
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireed19"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireed19"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9dDG4", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b641b1a272ca527$export$2e2bcd8739ae039);
let $6b641b1a272ca527$var$EventBus = function() {
    let me = {};
    let handlers = {};
    let active = true;
    let buffer = {};
    me.hold = function() {
        active = false;
    };
    me.release = function() {
        let keys = Object.keys(buffer);
        console.log("releasing " + keys.length + " event(s)");
        keys.forEach((key)=>{
            me.trigger(key, buffer[key]);
        });
        buffer = {};
        active = true;
    };
    me.trigger = function(action, context) {
        if (!active) {
            buffer[action] = context;
            return;
        }
        let actionHandler = handlers[action];
        if (actionHandler) actionHandler.forEach((handler)=>{
            handler(context);
        });
    };
    me.on = function(action, handler) {
        handlers[action] = handlers[action] || [];
        let actionHandler = handlers[action];
        actionHandler.push(handler);
    };
    return me;
}();
var $6b641b1a272ca527$export$2e2bcd8739ae039 = $6b641b1a272ca527$var$EventBus;

});

parcelRegister("k5ZAj", function(module, exports) {

$parcel$export(module.exports, "COMMAND", () => $ea140bafcf141cea$export$671af8f385981731);
$parcel$export(module.exports, "EVENT", () => $ea140bafcf141cea$export$e39a34cfd532e15);
let $ea140bafcf141cea$export$671af8f385981731 = {
    NEW: 1001,
    OPEN: 1002,
    LINE: 1003,
    SQUARE: 1004,
    ZOOMIN: 1005,
    ZOOMOUT: 1006,
    SELECT: 1007,
    DRAW: 1008,
    SPLITSCREEN: 1009,
    UNDO: 1010,
    REDO: 1011,
    STAMP: 1012,
    TOLAYER: 1013,
    CLEARSELECTION: 1014,
    ERASEELECTION: 1015,
    NEWLAYER: 1016,
    SAVE: 1017,
    PALETTEFROMIMAGE: 1018,
    PALETTEREDUCE: 1019,
    ROTATE: 1020,
    CLEAR: 1021,
    CROP: 1022,
    INFO: 1023,
    ERASE: 1024,
    DELETELAYER: 1025,
    CIRCLE: 1026,
    TRIM: 1027,
    TRANSFORMLAYER: 1028,
    ADDFRAME: 1029,
    DELETEFRAME: 1030,
    IMPORTFRAME: 1031,
    RESIZE: 1032,
    RESAMPLE: 1033,
    EFFECTS: 1034,
    GRADIENT: 1035,
    DUPLICATELAYER: 1036,
    COLORMASK: 1037,
    EDITPALETTE: 1038,
    MERGEDOWN: 1039,
    FLATTEN: 1040,
    LAYERUP: 1041,
    LAYERDOWN: 1042,
    SAVEPALETTE: 1043,
    LOADPALETTE: 1044,
    LAYERMASK: 1045,
    LAYERMASKHIDE: 1046,
    DELETELAYERMASK: 1047,
    APPLYLAYERMASK: 1048,
    POLYGONSELECT: 1049,
    ENDPOLYGONSELECT: 1050,
    TOSELECTION: 1051,
    CUTTOLAYER: 1052,
    SWAPCOLORS: 1053,
    ABOUT: 1054,
    FLOODSELECT: 1055,
    FLOOD: 1056,
    SELECTALL: 1057,
    COPY: 1058,
    PASTE: 1059,
    FULLSCREEN: 1060,
    PAN: 1061,
    COLORPICKER: 1062,
    TOGGLEPALETTES: 1063,
    ADF: 1064,
    DELUXE: 1065,
    SAVEDISK: 1066,
    SAVEGENERIC: 1067,
    SAVEFILETOADF: 1068,
    DUPLICATEFRAME: 1069,
    SMUDGE: 1070,
    CYCLEPALETTE: 1071,
    LOCKPALETTE: 1072,
    FLIPHORIZONTAL: 1073,
    FLIPVERTICAL: 1074,
    PRESENTATION: 1075,
    TOGGLEGRID: 1076,
    TOGGLEMASK: 1077,
    TOGGLEOVERRIDE: 1078,
    TOGGLEINVERT: 1079,
    ZOOMFIT: 1080,
    COLORSELECT: 1081,
    TOGGLESIDEPANEL: 1082,
    TOGGLEGALLERY: 1083,
    INITSELECTION: 1084
};
let $ea140bafcf141cea$export$e39a34cfd532e15 = {
    drawColorChanged: 1,
    backgroundColorChanged: 2,
    drawCanvasOverlay: 3,
    hideCanvasOverlay: 4,
    imageContentChanged: 5,
    imageSizeChanged: 6,
    layerContentChanged: 7,
    selectionChanged: 8,
    sizerChanged: 9,
    toolDeActivated: 10,
    layersChanged: 11,
    modifierKeyChanged: 12,
    toolChanged: 13,
    toolOptionsChanged: 14,
    brushOptionsChanged: 15,
    colorCount: 16,
    layerContentHistory: 17,
    imageHistory: 18,
    selectionHistory: 19,
    paletteHistory: 20,
    historyChanged: 21,
    endPolygonSelect: 22,
    framesChanged: 23,
    UIresize: 24,
    paletteChanged: 25,
    colorCycleChanged: 26,
    colorCycleToggled: 27,
    colorRangeChanged: 28,
    colorRangesChanged: 29,
    gridOptionsChanged: 30,
    layerPropertyHistory: 31,
    layerHistory: 32,
    sizerStartChange: 33,
    panelResized: 34
};

});

parcelRegister("eJ26Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab86e7844b98ec72$export$2e2bcd8739ae039);
$parcel$export(module.exports, "$div", () => $ab86e7844b98ec72$export$3718d30853d1be1);
$parcel$export(module.exports, "$link", () => $ab86e7844b98ec72$export$c453910a0b76012e);
$parcel$export(module.exports, "$title", () => $ab86e7844b98ec72$export$41720239e4ed5ea6);
$parcel$export(module.exports, "$elm", () => $ab86e7844b98ec72$export$716313d1f4d77324);
$parcel$export(module.exports, "$checkbox", () => $ab86e7844b98ec72$export$1e2124754ba10ea6);
$parcel$export(module.exports, "$input", () => $ab86e7844b98ec72$export$4159eb10f43487af);
$parcel$export(module.exports, "$setTarget", () => $ab86e7844b98ec72$export$e7f255b9482cfb38);
function $ab86e7844b98ec72$export$2e2bcd8739ae039(tagName, options) {
    let elm;
    let opt = {};
    let index = 1;
    let hasParent = false;
    if (typeof options === "object" && !Array.isArray(options) && !(options instanceof Element)) {
        opt = options;
        index++;
    }
    if (tagName instanceof Element) elm = tagName;
    else {
        // allow tag.class and tag#id constructors
        if (tagName.indexOf(".") >= 0) {
            let classNames = tagName.split(".");
            tagName = classNames.shift();
            opt.className = ((opt.className || "") + " " + classNames.join(" ")).trim();
        }
        if (tagName.indexOf("#") >= 0) {
            let p = tagName.split("#");
            tagName = p.shift();
            opt.id = p[0];
        }
        tagName = tagName || "div";
        elm = document.createElement(tagName);
    }
    for(let key in opt){
        if (key === "parent") {
            opt[key].appendChild(elm);
            hasParent = true;
            continue;
        }
        // custom dpaint.js stuff
        if (key === "onClick") $ab86e7844b98ec72$var$addClass(elm, opt, "handle");
        if (key === "info") $ab86e7844b98ec72$var$addClass(elm, opt, "info");
        // end custom dpaint.js stuff
        elm[key] = opt[key];
    }
    for(; index < arguments.length; index++)$ab86e7844b98ec72$var$append(elm, arguments[index]);
    if ($ab86e7844b98ec72$var$defaultParent && !hasParent) $ab86e7844b98ec72$var$defaultParent.appendChild(elm);
    return elm;
}
function $ab86e7844b98ec72$export$3718d30853d1be1(classname, innerHTML, parent, onClick) {
    let result = document.createElement("div");
    if (classname) result.className = classname;
    if (innerHTML) result.innerHTML = innerHTML;
    if (onClick) {
        result.onClick = onClick;
        result.classList.add("handle");
    }
    if (parent) parent.appendChild(result);
    return result;
}
function $ab86e7844b98ec72$export$c453910a0b76012e(classname, innerHTML, parent, onClick) {
    let result = document.createElement("a");
    if (classname) result.className = classname;
    if (innerHTML) result.innerHTML = innerHTML;
    if (onClick) result.onClick = onClick;
    if (parent) parent.appendChild(result);
    return result;
}
function $ab86e7844b98ec72$export$41720239e4ed5ea6(level, innerHTML, parent) {
    let result = document.createElement("h" + level);
    if (innerHTML) result.innerHTML = innerHTML;
    if (parent) parent.appendChild(result);
    return result;
}
function $ab86e7844b98ec72$export$716313d1f4d77324(type, innerHTML, parent, classname) {
    let result = document.createElement(type);
    if (innerHTML) result.innerHTML = innerHTML;
    if (classname) result.className = classname;
    if (parent) parent.appendChild(result);
    return result;
}
function $ab86e7844b98ec72$export$1e2124754ba10ea6(label, parent, classname, onToggle, checked) {
    let result = document.createElement("span");
    result.className = "checkbox";
    let labelElm = document.createElement("label");
    let checkbox = document.createElement("input");
    checkbox.type = "checkbox";
    checkbox.checked = !!checked;
    let textElm = document.createElement("span");
    labelElm.appendChild(checkbox);
    labelElm.appendChild(textElm);
    if (label) textElm.innerText = label;
    result.appendChild(labelElm);
    if (onToggle) checkbox.oninput = ()=>{
        onToggle(checkbox.checked);
    };
    if (classname) result.className += " " + classname;
    if (parent) parent.appendChild(result);
    result.setState = (state)=>{
        checkbox.checked = !!state;
    };
    return result;
}
function $ab86e7844b98ec72$export$4159eb10f43487af(type, value, parent, onInput) {
    let result = document.createElement("input");
    result.type = type || "text";
    if (typeof value !== "undefined") result.value = value;
    if (onInput) result.oninput = onInput;
    if (parent) parent.appendChild(result);
    return result;
}
let $ab86e7844b98ec72$var$append = (parent, child)=>{
    if (child) {
        if (Array.isArray(child)) child.map((sub)=>$ab86e7844b98ec72$var$append(parent, sub));
        else {
            if (typeof child === "string") child = document.createTextNode(child);
            parent.appendChild(child);
        }
    }
};
let $ab86e7844b98ec72$var$addClass = (elm, opt, className)=>{
    elm.classList.add(className);
    if (opt.className) opt.className += " " + className;
};
let $ab86e7844b98ec72$var$defaultParent;
function $ab86e7844b98ec72$export$e7f255b9482cfb38(parent) {
    $ab86e7844b98ec72$var$defaultParent = parent;
}

});

parcelRegister("jU8Uk", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7da281b50476907$export$2e2bcd8739ae039);

var $1zci6 = parcelRequire("1zci6");

var $9dDG4 = parcelRequire("9dDG4");

var $k5ZAj = parcelRequire("k5ZAj");

var $eZZbx = parcelRequire("eZZbx");

var $22JNL = parcelRequire("22JNL");

var $8FLxR = parcelRequire("8FLxR");

var $8ztM6 = parcelRequire("8ztM6");

var $9xub8 = parcelRequire("9xub8");

var $eTCYn = parcelRequire("eTCYn");

var $e0HvT = parcelRequire("e0HvT");

var $lPw7G = parcelRequire("lPw7G");
let $e7da281b50476907$var$ImageFile = function() {
    let me = {};
    let activeLayer;
    let activeLayerIndex = 0;
    let activeFrameIndex = 0;
    let cachedImage;
    let currentFile = {
        name: "Untitled",
        layers: []
    };
    me.getCurrentFile = function() {
        return currentFile;
    };
    me.getName = function() {
        return currentFile.name || "Untitled";
    };
    me.setName = function(name) {
        currentFile.name = name;
    };
    me.getOriginal = function() {
        if (!cachedImage) {
            console.error("caching image");
            cachedImage = document.createElement("canvas");
            let img = me.getCanvas();
            cachedImage.width = img.width;
            cachedImage.height = img.height;
            cachedImage.getContext("2d").drawImage(img, 0, 0);
        }
        return cachedImage;
    };
    me.restoreOriginal = function() {
        if (cachedImage) {
            let ctx = me.getActiveContext();
            ctx.clearRect(0, 0, currentFile.width, currentFile.height);
            ctx.drawImage(cachedImage, 0, 0);
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).imageContentChanged);
        }
    };
    me.getCanvas = function(frameIndex) {
        let frame = typeof frameIndex === "number" ? currentFile.frames[frameIndex] : currentFrame();
        if (!frame) return;
        if (frame.layers.length === 1) {
            if (typeof frameIndex === "number") return frame.layers[0].render();
            else {
                if (activeLayer && activeLayer.visible) return activeLayer.render();
            }
        } else {
            let canvas = document.createElement("canvas");
            let ctx = canvas.getContext("2d");
            canvas.width = currentFile.width;
            canvas.height = currentFile.height;
            frame.layers.forEach((layer)=>{
                if (layer.visible) {
                    ctx.globalAlpha = layer.opacity / 100;
                    let blendMode = layer.blendMode || "normal";
                    if (blendMode === "normal") blendMode = "source-over";
                    ctx.globalCompositeOperation = blendMode;
                    ctx.drawImage(layer.render(), 0, 0);
                    ctx.globalAlpha = 1;
                    ctx.globalCompositeOperation = "source-over";
                }
            });
            return canvas;
        }
    };
    me.getContext = function() {
        if (currentFrame().layers.length === 1 && activeLayer) return activeLayer.getContext();
        else return me.getCanvas().getContext("2d");
    };
    me.getActiveContext = function() {
        if (activeLayer) return activeLayer.getContext();
    };
    me.getActiveLayerIndex = function() {
        return activeLayerIndex;
    };
    me.getActiveLayer = function() {
        return activeLayer;
    };
    me.getLayer = function(index) {
        let frame = currentFile.frames[activeFrameIndex];
        return frame ? frame.layers[index] : undefined;
    };
    me.getLayerIndexesOfType = function(type) {
        let frame = currentFile.frames[activeFrameIndex];
        let result = [];
        if (frame) frame.layers.forEach((layer, index)=>{
            if (layer.type === type) result.push(index);
        });
        return result;
    };
    me.getActiveFrameIndex = function() {
        return activeFrameIndex;
    };
    me.getActiveFrame = function() {
        return currentFrame();
    };
    me.render = function() {
        currentFrame().layers.length;
    };
    me.openLocal = function() {
        var input = document.createElement("input");
        input.type = "file";
        input.onchange = function(e) {
            handleUpload(e.target.files, "file");
        };
        input.click();
    };
    me.openUrl = function(url, useProxy) {
        return new Promise((resolve, reject)=>{
            let fileName = url.substring(url.lastIndexOf("/") + 1);
            let extension = fileName.substring(fileName.lastIndexOf(".") + 1).toLowerCase();
            fetch(url).then((response)=>{
                if (extension === "json") response.json().then((json)=>{
                    me.handleJSON(json);
                    resolve();
                });
                else response.blob().then((blob)=>{
                    blob.arrayBuffer().then((buffer)=>{
                        me.handleBinary(buffer, fileName, "file", true);
                        resolve();
                    });
                });
            }).catch((err)=>{
                if (!useProxy) {
                    // probably a CORS error
                    url = "https://www.stef.be/bassoontracker/api/proxy/?" + encodeURIComponent(url);
                    me.openUrl(url, true).then(resolve).catch(reject);
                } else {
                    console.error(err);
                    reject(err);
                }
            });
        });
    };
    me.save = function() {
        (0, $8FLxR.default).show((0, $8FLxR.DIALOG).SAVE);
    };
    me.resize = function(properties) {
        if (!properties) (0, $8FLxR.default).show((0, $8FLxR.DIALOG).RESIZE);
        else {
            let w = properties.width;
            let h = properties.height;
            let anchor = properties.anchor || "topleft";
            let pW = currentFile.width;
            let pH = currentFile.height;
            currentFile.width = w;
            currentFile.height = h;
            let aX = Math.round((w - pW) / 2);
            let aY = Math.round((h - pH) / 2);
            if (anchor.indexOf("top") >= 0) aY = 0;
            if (anchor.indexOf("bottom") >= 0) aY = h - pH;
            if (anchor.indexOf("left") >= 0) aX = 0;
            if (anchor.indexOf("right") >= 0) aX = w - pW;
            console.log("Resizing image to " + w + "x" + h);
            currentFile.frames.forEach((frame)=>{
                frame.layers.forEach((layer)=>{
                    // TODO: what about mask canvas and dither canvas ?
                    let canvas = layer.getCanvas();
                    let ctx = layer.getContext();
                    let d = (0, $9xub8.duplicateCanvas)(canvas, true);
                    canvas.width = w;
                    canvas.height = h;
                    ctx.drawImage(d, aX, aY);
                    (0, $9xub8.releaseCanvas)(d);
                });
            });
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).imageSizeChanged);
        }
    };
    me.resample = function(properties) {
        if (!properties) (0, $8FLxR.default).show((0, $8FLxR.DIALOG).RESAMPLE);
        else {
            let w = properties.width;
            let h = properties.height;
            if (w === currentFile.width && h === currentFile.height) return;
            let quality = properties.quality || "pixelated";
            (0, $eZZbx.default).start((0, $k5ZAj.EVENT).imageHistory);
            currentFile.width = w;
            currentFile.height = h;
            let todo = 0;
            let done = 0;
            currentFile.frames.forEach((frame)=>{
                todo += frame.layers.length;
            });
            currentFile.frames.forEach((frame)=>{
                frame.layers.forEach((layer)=>{
                    let canvas = layer.getCanvas();
                    let ctx = layer.getContext();
                    if (quality === "pixelated") {
                        let d = (0, $9xub8.duplicateCanvas)(canvas, true);
                        canvas.width = w;
                        canvas.height = h;
                        ctx.webkitImageSmoothingEnabled = false;
                        ctx.mozImageSmoothingEnabled = false;
                        ctx.imageSmoothingEnabled = false;
                        ctx.drawImage(d, 0, 0, d.width, d.height, 0, 0, w, h);
                        (0, $9xub8.releaseCanvas)(d);
                        done++;
                        if (done >= todo) {
                            (0, $eZZbx.default).end();
                            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).imageSizeChanged);
                        }
                    } else {
                        let imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                        let result;
                        if (imageData.width > w && imageData.height > h) result = (0, $lPw7G.default).downScale(imageData, w, h);
                        else result = (0, $lPw7G.default).biCubic(imageData, w, h);
                        canvas.width = w;
                        canvas.height = h;
                        ctx.putImageData(result, 0, 0);
                        done++;
                        if (done >= todo) {
                            (0, $eZZbx.default).end();
                            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).imageSizeChanged);
                        }
                    }
                });
            });
        }
    };
    me.activateLayer = function(index) {
        activeLayerIndex = index;
        activeLayer = currentFrame().layers[activeLayerIndex];
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layersChanged);
    };
    me.toggleLayer = function(index) {
        currentFrame().layers[index].visible = !currentFrame().layers[index].visible;
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layersChanged);
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).imageContentChanged);
    };
    me.duplicateLayer = function(index) {
        if (typeof index !== "number") index = activeLayerIndex;
        let layer = currentFrame().layers[index];
        let newLayer = (0, $22JNL.default)(currentFile.width, currentFile.height, layer.name + " duplicate");
        newLayer.opacity = layer.opacity;
        newLayer.blendMode = layer.blendMode;
        newLayer.drawImage(layer.getCanvas());
        currentFrame().layers.splice(index + 1, 0, newLayer);
        me.activateLayer(index + 1);
    };
    me.flipLayer = function(index, horizontal) {
        if (typeof index !== "number") index = activeLayerIndex;
        let layer = currentFrame().layers[index];
        if (layer) {
            let canvas = (0, $9xub8.duplicateCanvas)(layer.getCanvas(), true);
            let ctx = layer.getContext();
            layer.clear();
            if (horizontal) {
                ctx.translate(canvas.width, 0);
                ctx.scale(-1, 1);
            } else {
                ctx.translate(0, canvas.height);
                ctx.scale(1, -1);
            }
            ctx.drawImage(canvas, 0, 0);
            ctx.setTransform(1, 0, 0, 1, 0, 0);
            (0, $9xub8.releaseCanvas)(canvas);
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layerContentChanged);
        }
    };
    me.setLayerOpacity = function(value) {
        if (activeLayer) {
            activeLayer.opacity = value;
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).imageContentChanged);
        }
    };
    me.setLayerBlendMode = function(value) {
        if (activeLayer) {
            activeLayer.blendMode = value;
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).imageContentChanged);
        }
    };
    me.getLayerBoundingRect = function(layerIndex) {
        let layer = activeLayer;
        if (typeof layerIndex === "number") layer = currentFrame().layers[layerIndex];
        let ctx = layer.getContext();
        let canvas = ctx.canvas;
        let w = canvas.width, h = canvas.height, pix = {
            x: [],
            y: []
        }, imageData = ctx.getImageData(0, 0, canvas.width, canvas.height), x, y, index;
        for(y = 0; y < h; y++)for(x = 0; x < w; x++){
            index = (y * w + x) * 4;
            if (imageData.data[index + 3] > 0) {
                pix.x.push(x);
                pix.y.push(y);
            }
        }
        pix.x.sort(function(a, b) {
            return a - b;
        });
        pix.y.sort(function(a, b) {
            return a - b;
        });
        let n = pix.x.length - 1;
        w = 1 + pix.x[n] - pix.x[0];
        h = 1 + pix.y[n] - pix.y[0];
        return {
            x: pix.x[0],
            y: pix.y[0],
            w: w,
            h: h
        };
    };
    me.activateFrame = function(index) {
        activeFrameIndex = index;
        activeLayerIndex = 0;
        cachedImage = undefined;
        activeLayer = currentFrame().layers[activeLayerIndex];
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layersChanged);
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).imageContentChanged);
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).framesChanged);
    };
    me.nextFrame = function(offset) {
        offset = offset || 1;
        let frame = activeFrameIndex + offset;
        if (frame < 0) frame = currentFile.frames.length - 1;
        if (frame >= currentFile.frames.length) frame = 0;
        me.activateFrame(frame);
    };
    me.clone = function(indexed) {
        let struct = {
            type: "dpaint",
            version: "1",
            image: {}
        };
        struct.image.name = currentFile.name;
        struct.image.width = currentFile.width;
        struct.image.height = currentFile.height;
        struct.image.activeLayerIndex = activeLayerIndex;
        struct.image.activeFrameIndex = activeFrameIndex;
        struct.image.frames = [];
        struct.errorCount = 0;
        currentFile.frames.forEach((frame)=>{
            let _frame = {
                layers: []
            };
            frame.layers.forEach((layer)=>{
                let _layer = layer.clone(true, indexed);
                struct.errorCount += _layer.conversionErrors || 0;
                _frame.layers.push(_layer);
            });
            struct.image.frames.push(_frame);
        });
        if (currentFile.colorRange) struct.image.colorRange = currentFile.colorRange;
        return struct;
    };
    me.restore = function(data) {
        let image = data.image;
        currentFile.width = image.width;
        currentFile.height = image.height;
        let mockImage = new Image(currentFile.width, currentFile.height);
        newFile(mockImage, currentFile.name, currentFile.type);
        currentFile.name = image.name || "Untitled";
        image.frames.forEach((_frame, frameIndex)=>{
            let frame = currentFile.frames[frameIndex];
            if (!frame) {
                addFrame();
                frame = currentFile.frames[frameIndex];
            }
            _frame.layers.forEach((_layer, layerIndex)=>{
                let layer = frame.layers[layerIndex];
                if (!layer) {
                    layer = (0, $22JNL.default)(currentFile.width, currentFile.height);
                    frame.layers.push(layer);
                }
                layer.restore(_layer).then(()=>{
                    if (image.activeLayerIndex === layerIndex && image.activeFrameIndex === frameIndex) {
                        me.activateFrame(frameIndex);
                        me.activateLayer(layerIndex);
                    }
                    (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layersChanged);
                    (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).imageSizeChanged);
                });
            });
        });
        if (image.colorRange) currentFile.colorRange = image.colorRange;
    };
    me.export = function(indexed) {
        let struct = me.clone(indexed);
        struct.palette = (0, $eTCYn.default).get();
        if (currentFile.colorRange) struct.colorRange = currentFile.colorRange;
        if (currentFile.indexedPixels) struct.indexedPixels = currentFile.indexedPixels;
        else if (indexed) struct.indexedPixels = me.generateIndexedPixels();
        console.log(struct);
        return struct;
    };
    me.addLayer = addLayer;
    me.removeLayer = removeLayer;
    me.moveLayer = moveLayer;
    function handleUpload(files, target) {
        if (files.length) {
            var file = files[0];
            var detectType;
            var isText;
            var fileName = file.name.split(".");
            var ext = fileName.pop().toLowerCase();
            fileName = fileName.join(".");
            if (ext === "info") detectType = true;
            if (ext === "gif") detectType = true;
            if (ext === "json") isText = true;
            var reader = new FileReader();
            reader.onload = function() {
                if (detectType) me.handleBinary(reader.result, file.name, target);
                else if (isText) {
                    let data = {};
                    if (ext === "json") try {
                        data = JSON.parse(reader.result);
                    } catch (e) {
                        console.error("Can't parse JSON");
                    }
                    if (data) me.handleJSON(data);
                } else {
                    // load as Image, fallback to detectType if it fails
                    var image = new Image();
                    image.onload = function() {
                        URL.revokeObjectURL(this.src);
                        if (target === "frame") drawFrame(image, fileName);
                        else newFile(image, fileName);
                    };
                    image.onerror = function() {
                        URL.revokeObjectURL(this.src);
                        detectType = true;
                        reader.readAsArrayBuffer(file);
                    };
                    image.setAttribute("crossOrigin", "");
                    image.src = reader.result;
                }
            };
            if (isText) reader.readAsText(file);
            else if (detectType) reader.readAsArrayBuffer(file);
            else reader.readAsDataURL(file);
            (0, $e0HvT.default).setFile();
        }
    }
    me.handleUpload = handleUpload;
    me.handleBinary = function(data, name, target, stillTryImage) {
        let now = performance.now();
        name = name || "";
        let fileName = name.split(".");
        fileName = fileName.join(".");
        console.log("Loading file: ", fileName);
        (0, $1zci6.default).detect(data, name).then((result)=>{
            console.log(" FileDetector: ", result);
            if (result) {
                currentFile.originalType = result.type;
                currentFile.originalData = result.data;
                if (result.data) {
                    if (result.data.xAspect && result.data.yAspect && result.data.xAspect !== result.data.yAspect) console.warn("Aspect ratio is not square! -> " + result.data.xAspect / result.data.yAspect);
                    if (result.data.palette) (0, $eTCYn.default).set(result.data.palette);
                    if (result.data.colourRange) console.log("Image has color cycling: ", result.data.colourRange);
                }
                let image = result.image;
                if (target === "frame") {
                    if (Array.isArray(image)) drawFrame(image[0], fileName);
                    else drawFrame(image, fileName);
                } else if (Array.isArray(image)) {
                    newFile(image[0], fileName, currentFile.originalType, currentFile.originalData);
                    (0, $9dDG4.default).hold();
                    for(let i = 1; i < image.length; i++)addFrame(image[i]);
                    (0, $9dDG4.default).release();
                    (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).framesChanged);
                } else newFile(image, fileName, currentFile.originalType, currentFile.originalData);
                let time = performance.now() - now;
                console.log("File loaded in " + time + "ms");
            } else if (stillTryImage) {
                // happens when the file is not coming from a file upload
                var image = new Image();
                image.onload = function() {
                    URL.revokeObjectURL(this.src);
                    if (target === "frame") drawFrame(image, fileName);
                    else newFile(image, fileName, currentFile.originalType, currentFile.originalData);
                };
                image.onerror = function() {
                    URL.revokeObjectURL(this.src);
                    console.error("File is not a default image type");
                };
                image.setAttribute("crossOrigin", "");
                var arrayBufferView = new Uint8Array(data);
                var blob = new Blob([
                    arrayBufferView
                ], {
                    type: "image/png"
                });
                image.src = URL.createObjectURL(blob);
            }
        });
    };
    me.handleJSON = function(data, next) {
        if (data.type === "dpaint") {
            if (data.palette) (0, $eTCYn.default).set(data.palette);
            if (data.colorRange) currentFile.colorRange = data.colorRange;
            me.restore(data);
        }
        if (data.type === "palette") (0, $eTCYn.default).set(data.palette);
        if (next) next();
    };
    function newFile(image, fileName, type, originalData) {
        (0, $eZZbx.default).clear();
        cachedImage = undefined;
        let w = 320;
        let h = 256;
        if (image) {
            w = image.width;
            h = image.height;
        }
        currentFile = {
            width: w,
            height: h,
            name: fileName || "Untitled",
            frames: [
                {
                    layers: []
                }
            ],
            colorRange: []
        };
        if (type) currentFile.originalType = type;
        if (originalData) {
            if (originalData.palette) currentFile.palette = originalData.palette;
            if (originalData.colourRange) currentFile.colorRange = originalData.colourRange;
            if (originalData.pixels) currentFile.indexedPixels = originalData.pixels;
            currentFile.originalData = originalData;
        }
        activeFrameIndex = 0;
        activeLayerIndex = 0;
        addLayer();
        activeLayer = currentFrame().layers[0];
        activeLayer.clear();
        if (image) activeLayer.getContext().drawImage(image, 0, 0);
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).imageSizeChanged);
    }
    function addLayer(index, name, options) {
        let newLayer = (0, $22JNL.default)(currentFile.width, currentFile.height, name || "Layer " + (currentFrame().layers.length + 1));
        let newIndex = currentFrame().layers.length;
        if (options) {
            if (options.locked) newLayer.locked = true;
            if (options.internal) newLayer.internal = true;
        }
        if (typeof index === "undefined") currentFrame().layers.push(newLayer);
        else {
            currentFrame().layers.splice(index, 0, newLayer);
            newIndex = index;
        }
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layersChanged);
        return newIndex;
    }
    function removeLayer(index) {
        if (typeof index === "undefined") index = activeLayerIndex;
        if (currentFrame().layers.length > 1) {
            currentFrame().layers.splice(index, 1);
            if (activeLayerIndex >= currentFrame().layers.length) activeLayerIndex--;
            me.activateLayer(activeLayerIndex);
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).imageContentChanged);
        }
    }
    function moveLayer(fromIndex, toIndex) {
        if (currentFrame().layers.length > 1) {
            if (toIndex >= currentFrame().layers.length) toIndex = currentFrame().layers.length - 1;
            if (toIndex < 0) toIndex = 0;
            if (toIndex !== fromIndex) {
                let layer = currentFrame().layers[fromIndex];
                currentFrame().layers.splice(fromIndex, 1);
                currentFrame().layers.splice(toIndex, 0, layer);
            }
            me.activateLayer(toIndex);
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).imageContentChanged);
        }
    }
    function addFrame(image) {
        let layer = (0, $22JNL.default)(currentFile.width, currentFile.height, "Layer 1");
        currentFile.frames.push({
            layers: [
                layer
            ]
        });
        if (image) {
            if (image.placeholder) layer.placeholder = true;
            else if (image.width) layer.getContext().drawImage(image, 0, 0);
        }
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).imageSizeChanged);
    }
    function removeFrame() {
        if (currentFile.frames.length > 1) {
            (0, $eZZbx.default).start((0, $k5ZAj.EVENT).imageHistory);
            currentFile.frames.splice(activeFrameIndex, 1);
            if (activeFrameIndex >= currentFile.frames.length) activeFrameIndex--;
            (0, $eZZbx.default).end();
            me.activateFrame(activeFrameIndex);
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).imageSizeChanged);
        }
    }
    function drawFrame(image, fileName) {
        let layerIndex = me.addLayer(0, fileName);
        let layer = me.getLayer(layerIndex);
        layer.clear();
        layer.drawImage(image);
        me.activateLayer(layerIndex);
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layerContentChanged);
    }
    function currentFrame() {
        return currentFile.frames[activeFrameIndex];
    }
    me.duplicateFrame = function(index) {
        (0, $eZZbx.default).start((0, $k5ZAj.EVENT).imageHistory);
        if (typeof index !== "number") index = activeFrameIndex;
        let layers = currentFrame().layers;
        let newFrame = {
            layers: []
        };
        layers.forEach((layer)=>{
            let newLayer = (0, $22JNL.default)(currentFile.width, currentFile.height, layer.name);
            newLayer.opacity = layer.opacity;
            newLayer.blendMode = layer.blendMode;
            newLayer.drawImage(layer.getCanvas());
            newFrame.layers.push(newLayer);
        });
        currentFile.frames.splice(index + 1, 0, newFrame);
        (0, $eZZbx.default).end();
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).imageSizeChanged);
    };
    me.moveFrame = (fromIndex, toIndex)=>{
        if (currentFile.frames.length > 1) {
            if (toIndex >= currentFile.frames.length) toIndex = currentFile.frames.length - 1;
            if (toIndex < 0) toIndex = 0;
            if (toIndex !== fromIndex) {
                let frame = currentFile.frames[fromIndex];
                currentFile.frames.splice(fromIndex, 1);
                currentFile.frames.splice(toIndex, 0, frame);
            }
            me.activateFrame(toIndex);
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).imageContentChanged);
        }
    };
    me.mergeDown = function(index, skipHistory) {
        if (typeof index !== "number") index = activeLayerIndex;
        let layer = currentFrame().layers[index];
        let belowLayer = currentFrame().layers[index - 1];
        if (layer && belowLayer) {
            if (!skipHistory) (0, $eZZbx.default).start((0, $k5ZAj.EVENT).imageHistory);
            if (layer.hasMask) layer.removeMask(true);
            let ctx = belowLayer.getContext();
            ctx.globalAlpha = layer.opacity;
            let blendMode = layer.blendMode || "normal";
            if (blendMode === "normal") blendMode = "source-over";
            ctx.globalCompositeOperation = blendMode;
            belowLayer.drawImage(layer.getCanvas(), 0, 0);
            ctx.globalAlpha = 1;
            ctx.globalCompositeOperation = "source-over";
            currentFrame().layers.splice(index, 1);
            if (!skipHistory) (0, $eZZbx.default).end();
            me.activateLayer(index - 1);
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layerContentChanged);
        }
    };
    me.paste = function(image) {
        let w = $e7da281b50476907$var$ImageFile.getCurrentFile().width;
        let h = $e7da281b50476907$var$ImageFile.getCurrentFile().height;
        function doPaste() {
            let index = me.addLayer();
            me.activateLayer(index);
            me.getActiveLayer().drawImage(image, 0, 0);
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layerContentChanged);
        }
        if (image && (image.width > w || image.height > h)) (0, $8FLxR.default).show((0, $8FLxR.DIALOG).OPTION, {
            title: "Paste Image",
            width: 320,
            text: "The image you are pasting is larger than the current canvas. What do you want to do?",
            buttons: [
                {
                    label: "Keep the canvas at " + w + "x" + h + " pixels",
                    onclick: doPaste
                },
                {
                    label: "Enlarge the canvas to " + image.width + "x" + image.height + " pixels",
                    onclick: ()=>{
                        me.resize({
                            width: image.width,
                            height: image.height
                        });
                        doPaste();
                    }
                },
                {
                    label: "Cancel"
                }
            ]
        });
        else doPaste();
    };
    me.addRange = function() {
        currentFile.colorRange = currentFile.colorRange || [];
        currentFile.colorRange.push({
            active: true,
            high: 1,
            low: 0,
            fps: 10
        });
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).colorRangesChanged);
    };
    me.generateIndexedPixels = function(frameIndex, oneDimensional) {
        console.log("generate indexed pixels");
        let now = performance.now();
        let ctx = me.getCanvas(frameIndex).getContext("2d");
        let colors = (0, $eTCYn.default).get();
        let indexed = (0, $9xub8.indexPixelsToPalette)(ctx, colors, oneDimensional);
        currentFile.indexedPixels = indexed.pixels;
        let time = performance.now() - now;
        console.log("Indexed pixels generated in " + time + "ms");
        if (indexed.notFoundCount) console.warn("Indexed pixels: " + indexed.notFoundCount + " colors not found in palette");
        return currentFile.indexedPixels;
    };
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).NEW, function() {
        newFile();
    });
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).SAVE, function() {
        me.save();
    });
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).RESIZE, function() {
        me.resize();
    });
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).RESAMPLE, function() {
        me.resample();
    });
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).INFO, function() {
        (0, $8ztM6.default).showInfo(currentFile);
    });
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).NEWLAYER, function() {
        (0, $8ztM6.default).show();
        let newIndex = addLayer(activeLayerIndex + 1);
        (0, $eZZbx.default).add((0, $k5ZAj.EVENT).layerPropertyHistory, {
            index: -1,
            currentIndex: activeLayerIndex
        }, {
            index: newIndex
        });
    });
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).DELETELAYER, function() {
        (0, $eZZbx.default).start((0, $k5ZAj.EVENT).imageHistory);
        removeLayer();
        (0, $eZZbx.default).end();
    });
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).DUPLICATELAYER, function() {
        (0, $eZZbx.default).start((0, $k5ZAj.EVENT).imageHistory);
        me.duplicateLayer();
        (0, $eZZbx.default).end();
    });
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).FLIPHORIZONTAL, function() {
        (0, $eZZbx.default).start((0, $k5ZAj.EVENT).layerContentHistory);
        me.flipLayer(undefined, true);
        (0, $eZZbx.default).end();
    });
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).FLIPVERTICAL, function() {
        (0, $eZZbx.default).start((0, $k5ZAj.EVENT).layerContentHistory);
        me.flipLayer(undefined, false);
        (0, $eZZbx.default).end();
    });
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).LAYERUP, function(index) {
        if (typeof index === "undefined") index = activeLayerIndex;
        let fromIndex = index;
        let toIndex = fromIndex + 1;
        moveLayer(fromIndex, toIndex);
    });
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).LAYERDOWN, function(index) {
        if (typeof index === "undefined") index = activeLayerIndex;
        let fromIndex = index;
        let toIndex = fromIndex - 1;
        moveLayer(fromIndex, toIndex);
    });
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).MERGEDOWN, function(index) {
        (0, $eZZbx.default).start((0, $k5ZAj.EVENT).imageHistory);
        me.mergeDown(index);
        (0, $eZZbx.default).end();
    });
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).FLATTEN, function() {
        (0, $eZZbx.default).start((0, $k5ZAj.EVENT).imageHistory);
        currentFrame().layers.forEach((layer)=>{
            if (layer.hasMask) {
                layer.removeMask(true);
                (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layersChanged);
            }
        });
        if (currentFrame().layers.length > 1) {
            let canvas = me.getCanvas();
            currentFrame().layers.splice(0, currentFrame().layers.length - 1);
            let layer = currentFrame().layers[0];
            if (layer) {
                layer.clear();
                layer.drawImage(canvas, 0, 0);
                layer.opacity = 100;
                layer.blendMode = "normal";
                layer.visible = true;
            }
            me.activateLayer(0);
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).imageContentChanged);
        }
        (0, $eZZbx.default).end();
    });
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).ADDFRAME, function() {
        (0, $eZZbx.default).start((0, $k5ZAj.EVENT).imageHistory);
        (0, $8ztM6.default).show();
        addFrame();
        (0, $eZZbx.default).end();
    });
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).DELETEFRAME, function() {
        (0, $eZZbx.default).start((0, $k5ZAj.EVENT).imageHistory);
        removeFrame();
        (0, $eZZbx.default).end();
    });
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).DUPLICATEFRAME, function() {
        (0, $eZZbx.default).start((0, $k5ZAj.EVENT).imageHistory);
        me.duplicateFrame();
        (0, $eZZbx.default).end();
    });
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).IMPORTFRAME, function() {
        var input = document.createElement("input");
        input.type = "file";
        input.onchange = function(e) {
            handleUpload(e.target.files, "frame");
        };
        input.click();
    });
    (0, $9dDG4.default).on((0, $k5ZAj.EVENT).layerContentChanged, function(options) {
        options = options || {};
        if (!options.keepImageCache) cachedImage = undefined;
        if (activeLayer) activeLayer.update();
        me.render();
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).imageContentChanged);
    });
    (0, $9dDG4.default).on((0, $k5ZAj.EVENT).imageSizeChanged, ()=>{
        cachedImage = undefined;
    });
    window.getCurrentFile = me.getCurrentFile;
    return me;
}();
var $e7da281b50476907$export$2e2bcd8739ae039 = $e7da281b50476907$var$ImageFile;

});
parcelRegister("1zci6", function(module, exports) {

$parcel$export(module.exports, "default", () => $1242981331755196$export$2e2bcd8739ae039);

var $3QDcZ = parcelRequire("3QDcZ");

var $fC5qu = parcelRequire("fC5qu");

var $aQoVS = parcelRequire("aQoVS");

var $bnYE1 = parcelRequire("bnYE1");
let $1242981331755196$var$FileDetector = function() {
    let me = {};
    me.detect = function(data, name) {
        return new Promise((next)=>{
            name = name || "";
            let ext = name.split(".").pop().toLowerCase();
            let file;
            if (ext === "info") {
                file = (0, $3QDcZ.default)(data.slice(0, data.byteLength), true);
                file.goto(0);
                // Note: this can be Async!
                (0, $fC5qu.default).parse(file, function(icon) {
                    if (icon) {
                        let canvas = (0, $fC5qu.default).getImage(icon);
                        let canvas2 = (0, $fC5qu.default).getImage(icon, 1);
                        next({
                            image: [
                                canvas,
                                canvas2
                            ],
                            type: (0, $fC5qu.default).getType(icon)
                        });
                    } else detectIFF();
                });
            } else if (ext === "gif") {
                file = (0, $3QDcZ.default)(data.slice(0, data.byteLength), false);
                file.goto(0);
                let result = (0, $bnYE1.default).detect(file);
                if (result) next((0, $bnYE1.default).toFrames(file));
                else next(false);
            } else {
                file = (0, $3QDcZ.default)(data.slice(0, data.byteLength), true);
                file.goto(0);
                detectIFF();
            }
            function detectIFF() {
                let fileType = (0, $aQoVS.default).detect(file);
                if (fileType) {
                    let data = (0, $aQoVS.default).parse(file, true, fileType);
                    let img;
                    if (data && data.frames && data.frames.length) img = data.frames.map((frame)=>{
                        //TODO: maybe defer rendering all frames until needed?
                        return (0, $aQoVS.default).toCanvas(frame);
                    });
                    else if (data && data.width) img = (0, $aQoVS.default).toCanvas(data);
                    if (img) next({
                        image: img,
                        type: "IFF",
                        data: data
                    });
                    else next(false);
                } else next(false);
            }
        });
    };
    return me;
}();
var $1242981331755196$export$2e2bcd8739ae039 = $1242981331755196$var$FileDetector;

});
parcelRegister("3QDcZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cd4a46bab427bce$export$2e2bcd8739ae039);
/*

	MIT License

	Copyright (c) 2019 Steffest - dev@stef.be

	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in all
	copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	SOFTWARE.
	
 */ function $2cd4a46bab427bce$var$BinaryStream(arrayBuffer, bigEndian) {
    var obj = {
        index: 0,
        litteEndian: !bigEndian
    };
    obj.goto = function(value) {
        setIndex(value);
    };
    obj.jump = function(value) {
        this.goto(this.index + value);
    };
    obj.readByte = function(position) {
        setIndex(position);
        var b = this.dataView.getInt8(this.index);
        this.index++;
        return b;
    };
    obj.writeByte = function(value, position) {
        setIndex(position);
        this.dataView.setInt8(this.index, value);
        this.index++;
    };
    obj.readUbyte = function(position) {
        setIndex(position);
        var b = this.dataView.getUint8(this.index);
        this.index++;
        return b;
    };
    obj.writeUbyte = function(value, position) {
        setIndex(position);
        this.dataView.setUint8(this.index, value);
        this.index++;
    };
    obj.readUint = function(position) {
        setIndex(position);
        var i = this.dataView.getUint32(this.index, this.litteEndian);
        this.index += 4;
        return i;
    };
    obj.writeUint = function(value, position) {
        setIndex(position);
        this.dataView.setUint32(this.index, value, this.litteEndian);
        this.index += 4;
    };
    obj.readBytes = function(len, position, buffer) {
        setIndex(position);
        var i = this.index;
        if ((len += i) > this.length) len = this.length;
        var offset = 0;
        for(; i < len; ++i)buffer.setUint8(offset++, this.dataView.getUint8(i));
        this.index += len;
        return buffer;
    };
    obj.readString = function(len, position) {
        setIndex(position);
        var i = this.index;
        var src = this.dataView;
        var text = "";
        if ((len += i) > this.length) len = this.length;
        for(; i < len; ++i){
            var c = src.getUint8(i);
            if (c == 0) break;
            text += String.fromCharCode(c);
        }
        this.index = len;
        return text;
    };
    obj.writeString = function(value, position) {
        setIndex(position);
        var src = this.dataView;
        var len = value.length;
        for(var i = 0; i < len; i++)src.setUint8(this.index + i, value.charCodeAt(i));
        this.index += len;
    };
    obj.writeStringSection = function(value, max, paddValue, position) {
        setIndex(position);
        max = max || 1;
        value = value || "";
        paddValue = paddValue || 0;
        var len = value.length;
        if (len > max) value = value.substr(0, max);
        obj.writeString(value);
        obj.fill(paddValue, max - len);
    };
    // same as readUshort
    obj.readWord = function(position) {
        setIndex(position);
        var w = this.dataView.getUint16(this.index, this.litteEndian);
        this.index += 2;
        return w;
    };
    obj.writeWord = function(value, position) {
        setIndex(position);
        this.dataView.setUint16(this.index, value, this.litteEndian);
        this.index += 2;
    };
    obj.readLong = obj.readDWord = obj.readUint;
    obj.writeLong = obj.writeDWord = obj.writeUint;
    obj.readShort = function(value, position) {
        setIndex(position);
        var w = this.dataView.getInt16(this.index, this.litteEndian);
        this.index += 2;
        return w;
    };
    obj.readBits = function(count, bitPosition, position) {
        // this reads $count bits, starting from byte $position and bit position $bitPosition
        // bitPosition can be > 8 , count should be <= 8;
        position = position === 0 ? position : position || obj.index;
        var bytePosition = position + (bitPosition >> 3);
        setIndex(bytePosition);
        bitPosition = bitPosition - (bitPosition >> 3 << 3);
        var bits = byte2Bits(this.dataView.getUint8(this.index));
        if (bitPosition + count > 8 && this.index < obj.length - 1) bits = bits.concat(byte2Bits(this.dataView.getUint8(this.index + 1)));
        return bits2Int(bits.slice(bitPosition, bitPosition + count));
    };
    obj.writeBits = function(bits, position) {
        setIndex(position);
        if (bits.length > 8) {
            var bts = [];
            var bindex = 0;
            var _this = this;
            function write() {
                if (bts.length) {
                    var b = bits2Int(bts);
                    _this.dataView.setUint8(_this.index, b);
                    _this.index++;
                    bts = [];
                }
            }
            while(bts.length < 8 && bindex < bits.length){
                bts.push(bits[bindex]);
                bindex++;
                if (bts.length >= 8) write();
            }
            write();
        } else {
            var b = bits2Int(bits);
            this.dataView.setUint8(this.index, b);
            this.index++;
        }
    };
    obj.writeByteArray = function(array, position) {
        setIndex(position);
        for(let i = 0; i < array.length; i++){
            this.dataView.setUint8(this.index, array[i]);
            this.index++;
        }
    };
    obj.clear = function(length) {
        obj.fill(0, length);
    };
    obj.fill = function(value, length) {
        value = value || 0;
        length = length || 0;
        for(var i = 0; i < length; i++)obj.writeByte(value);
    };
    obj.isEOF = function(margin) {
        margin = margin || 0;
        return this.index >= this.length - margin;
    };
    function setIndex(value) {
        value = value === 0 ? value : value || obj.index;
        if (value < 0) value = 0;
        if (value >= obj.length) value = obj.length - 1;
        obj.index = value;
    }
    obj.buffer = arrayBuffer;
    obj.dataView = new DataView(arrayBuffer);
    obj.length = arrayBuffer.byteLength;
    return obj;
    // todo
    /*

	check if copying typed arraybuffers is faster then reading dataview

	 var dstU8 = new Uint8Array(dst, dstOffset, byteLength);
  	 var srcU8 = new Uint8Array(src, srcOffset, byteLength);
  	 dstU8.set(srcU8);

	 */ function byte2Bits(b) {
        return [
            b >> 7 & 1,
            b >> 6 & 1,
            b >> 5 & 1,
            b >> 4 & 1,
            b >> 3 & 1,
            b >> 2 & 1,
            b >> 1 & 1,
            b & 1
        ];
    }
    function bits2Int(bits) {
        var v = 0;
        var len = bits.length - 1;
        for(var i = 0; i <= len; i++)v += bits[i] << len - i;
        return v;
    }
}
var //if (typeof module !== 'undefined' && module.exports) module.exports = BinaryStream;
$2cd4a46bab427bce$export$2e2bcd8739ae039 = $2cd4a46bab427bce$var$BinaryStream;

});

parcelRegister("fC5qu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b5de9d2c0fe2660b$export$2e2bcd8739ae039);
/*

	MIT License

	Copyright (c) 2019-2023 Steffest - dev@stef.be

	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:

	The above copyright notice and this permission notice shall be included in all
	copies or substantial portions of the Software.

	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	SOFTWARE.

 */ 
var $3QDcZ = parcelRequire("3QDcZ");

var $8XeSI = parcelRequire("8XeSI");
(0, $8XeSI.default).call(window); // meh ... is there a better way to import closure compiled code? they are designed to hook themselves as global var.

var $b5de9d2c0fe2660b$var$Icon = function() {
    // Detect and decode Amiga .info icon files
    // icon format info on
    // 		http://krashan.ppa.pl/articles/amigaicons/
    //		http://www.evillabs.net/index.php/Amiga_Icon_Formats
    // all Amiga icons formats are supported except newIcons
    var me = {};
    me.fileTypes = {
        ICON: {
            name: "Icon file",
            actions: [
                "show"
            ],
            inspect: true
        }
    };
    var WB13Palette = [
        [
            85,
            170,
            255
        ],
        [
            255,
            255,
            255
        ],
        [
            0,
            0,
            0
        ],
        [
            255,
            136,
            0
        ]
    ];
    var MUIPalette = [
        [
            149,
            149,
            149
        ],
        [
            0,
            0,
            0
        ],
        [
            255,
            255,
            255
        ],
        [
            59,
            103,
            162
        ],
        [
            123,
            123,
            123
        ],
        [
            175,
            175,
            175
        ],
        [
            170,
            144,
            124
        ],
        [
            255,
            169,
            151
        ]
    ];
    me.parse = function(file, next) {
        var icon = {};
        icon.info = {};
        var magicBytes = file.readDWord(0);
        var PNGID = 2303741511;
        if (magicBytes === PNGID) {
            //DualPNG
            console.log("DualPNG icon");
            icon.PNGIcon = {
                canvas: []
            };
            // look for second PNG
            file.goto(8);
            var found = false;
            var imageCount = 1;
            var buffer2;
            // read next chunk size
            var dw = file.readDWord();
            while(!file.isEOF(8)){
                // 4 byte Chunk Type ID and 4 byte CRC is not included
                dw += 8;
                file.jump(dw);
                // read next chunk size or next PNG ID
                dw = file.readDWord();
                if (dw === PNGID) {
                    found = true;
                    break;
                }
            }
            if (found) {
                imageCount = 2;
                buffer2 = file.buffer.slice(file.index - 4);
            }
            var done = function() {
                if (next) {
                    if (icon.PNGIcon.canvas.length > imageCount - 1) next(icon);
                }
            };
            function toCanvas(buffer, index) {
                var blob = new Blob([
                    buffer
                ], {
                    type: "image/png"
                });
                var urlCreator = window.URL || window.webkitURL;
                var imageUrl = urlCreator.createObjectURL(blob);
                var img = new Image();
                img.onload = function() {
                    icon.width = img.width;
                    icon.height = img.height;
                    var canvas = document.createElement("canvas");
                    canvas.width = img.width;
                    canvas.height = img.height;
                    canvas.getContext("2d").drawImage(img, 0, 0);
                    icon.PNGIcon.canvas[index] = canvas;
                    done();
                };
                img.src = imageUrl;
            }
            toCanvas(file.buffer, 0);
            if (imageCount > 1) toCanvas(buffer2, 1);
        } else {
            //Amiga Icon
            file.goto(2);
            icon.version = file.readWord();
            icon.nextGadget = file.readDWord();
            icon.leftEdge = file.readWord();
            icon.topEdge = file.readWord();
            icon.width = file.readWord();
            icon.height = file.readWord();
            icon.flags = file.readWord();
            icon.activation = file.readWord();
            icon.gadgetType = file.readWord();
            icon.gadgetRender = file.readDWord();
            icon.selectRender = file.readDWord();
            icon.gadgetText = file.readDWord(); //Unused. Usually 0.
            icon.mutualExclude = file.readDWord(); //Unused. Usually 0.
            icon.specialInfo = file.readDWord(); //Unused. Usually 0.
            icon.gadgetID = file.readWord(); //Unused. Usually 0.
            icon.userData = file.readDWord(); // Used for icon revision. 0 for OS 1.x icons. 1 for OS 2.x/3.x icons.
            icon.type = file.readUbyte(); /*
			A type of icon:
				1 – disk or volume.
				2 – drawer (folder).
				3 – tool (executable).
				4 – project (data file).
				5 – trashcan.
				6 – device.
				7 – Kickstart ROM image.
				8 – an appicon (placed on the desktop by application).
		*/ 
            icon.info.type = getIconType(icon.type);
            icon.padding = file.readUbyte();
            icon.hasDefaultTool = file.readDWord();
            icon.hasToolTypes = file.readDWord();
            icon.currentX = file.readDWord();
            icon.currentY = file.readDWord();
            icon.hasDrawerData = file.readDWord(); // unused
            icon.hasToolWindow = file.readDWord(); // I don't think this is used somewhere?
            icon.stackSize = file.readDWord();
            // total size 78 bytes
            var offset = 78;
            var drawerData = {};
            if (icon.hasDrawerData) // skip for now
            offset += 56;
            icon.drawerData = drawerData;
            icon.img = readIconImage(file, offset);
            if (icon.selectRender) icon.img2 = readIconImage(file);
            if (icon.hasDefaultTool) icon.defaultTool = readText(file);
            icon.toolTypes = [];
            let newIconFlags = 0;
            if (icon.hasToolTypes) {
                icon.toolTypeCount = file.readDWord();
                if (icon.toolTypeCount) {
                    icon.toolTypeCount = icon.toolTypeCount / 4 - 1; // seriously ... who invents this stuff? ...
                    for(var i = 0; i < icon.toolTypeCount; i++){
                        let toolType = readText(file);
                        if (toolType) {
                            let p = toolType.substr(0, 4);
                            if (p === "IM1=" || p === "IM2=") newIconFlags++;
                            icon.toolTypes.push(toolType);
                        }
                    }
                }
            }
            if (newIconFlags > 2) icon.newIcon = decodeNewIcon(icon.toolTypes);
            if (icon.hasToolWindow) icon.hasToolWindow = readText(file);
            if (icon.hasDrawerData && icon.userData) {
                // OS2.x+ drawers
                icon.drawerData2 = {};
                icon.drawerData2.flags = file.readDWord();
                icon.drawerData2.ViewModes = file.readWord();
            }
            if (file.index < file.length) {
                // we're not at the end of the file
                // check for FORM ICON file
                console.log("checking for IFF structure");
                var id = file.readString(4);
                if (id === "FORM") {
                    console.log("IFF file found");
                    var size = file.readDWord();
                    if (size + 8 <= file.length) {
                        // the size check isn't always exact for images?
                        var format = file.readString(4);
                        icon.colorIcon = readIFFICON(file);
                    }
                }
            }
            next(icon);
        }
        return icon;
    };
    me.detect = function(file) {
        var id = file.readWord(0);
        if (id === 0xE310) return typeof FILETYPE !== "undefined" ? FILETYPE.ICON : true;
    };
    me.inspect = function(file) {
        var result = "icon";
        var info = me.parse(file);
        return result;
    };
    me.getImage = function(icon, index) {
        index = index || 0;
        if (icon.colorIcon) return me.toCanvas(icon.colorIcon, index);
        else if (icon.newIcon) return me.toCanvas(icon.newIcon, index);
        else if (icon.PNGIcon) {
            index = Math.min(index, icon.PNGIcon.canvas.length - 1);
            return icon.PNGIcon.canvas[index];
        } else {
            var img = index ? icon.img2 : icon.img;
            if (img) {
                img.palette = icon.userData ? MUIPalette : WB13Palette;
                return me.toCanvas(img);
            }
        }
    };
    me.getType = function(icon) {
        if (icon.colorIcon || icon.newIcon) return "colorIcon";
        if (icon.PNGIcon) return "PNGIcon";
        return "classicIcon";
    };
    me.setPalette = function(icon, stateIndex) {
        var img = stateIndex ? icon.img2 : icon.img;
        if (img) img.palette = icon.userData ? MUIPalette : WB13Palette;
    };
    me.handle = function(file, action) {
        console.log(action);
        if (action === "show") {
            var icon = me.parse(file);
            var canvas = me.getImage(icon, 0);
            if (AdfViewer) AdfViewer.showImage(canvas);
        }
    };
    me.toCanvas = function(img, index) {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        var pixelWidth = 1;
        var ctx = canvas.getContext("2d");
        if (img.states) {
            // colorIcon, newIcon or ARGB
            var state = img.states[index || 0];
            if (state) {
                for(var y = 0; y < img.height; y++)for(var x = 0; x < img.width; x++){
                    var pixel = state.pixels[y * img.width + x];
                    if (state.rgba) var color = pixel;
                    else color = state.palette[pixel] || [
                        0,
                        0,
                        0,
                        0
                    ];
                    if (color.length < 4) color[3] = 1;
                    if (pixel === 0) color = [
                        0,
                        0,
                        0,
                        0
                    ];
                    ctx.fillStyle = "rgba(" + color.join(",") + ")";
                    ctx.fillRect(x * pixelWidth, y, pixelWidth, 1);
                }
            }
        } else {
            // WB Icon
            for(var y = 0; y < img.height; y++)for(var x = 0; x < img.width; x++){
                var pixel = img.pixels[y][x];
                var color = img.palette[pixel] || [
                    0,
                    0,
                    0,
                    0
                ];
                if (color.length < 4) color[3] = 1;
                if (pixel === 0) color = [
                    0,
                    0,
                    0,
                    0
                ];
                ctx.fillStyle = "rgba(" + color.join(",") + ")";
                ctx.fillRect(x * pixelWidth, y, pixelWidth, 1);
            }
        }
        return canvas;
    };
    me.create = function(width, height) {
        var icon = {};
        icon.version = 1;
        icon.nextGadget = 0;
        icon.leftEdge = 0;
        icon.topEdge = 0;
        icon.width = width;
        icon.height = height;
        // this is the width and height of the simple icon, NOT of the ColorIcon
        icon.width = 8;
        icon.height = 8;
        icon.flags = 6; // according docs this is usually 5? 6 seems to be more current.
        icon.activation = 3;
        icon.gadgetType = 1;
        icon.gadgetRender = 1;
        icon.selectRender = 1;
        icon.gadgetText = 0;
        icon.mutualExclude = 0;
        icon.specialInfo = 0;
        icon.gadgetID = 0;
        icon.userData = 1; // OS 2.x/3.x icon - use 0 for 1.X icons
        icon.type = 4; // project
        icon.padding = 0;
        icon.hasDefaultTool = 0;
        icon.hasToolTypes = 0;
        icon.currentX = 0;
        icon.currentY = 0;
        icon.hasDrawerData = 0;
        icon.hasToolWindow = 0;
        icon.stackSize = 8192;
        // default Classic Icon
        var classicWidth = 8;
        var classicHeight = 8;
        icon.img = {
            leftEdge: 0,
            topEdge: 0,
            width: classicWidth,
            height: classicHeight,
            depth: 1,
            hasimageData: 1,
            planePick: 1,
            // according to https://wiki.amigaos.net/wiki/Icon_Library this should be 3
            // my guess is that this is the number of colors-1
            planeOnOff: 0,
            nextImage: 0,
            pixels: []
        };
        icon.img2 = Object.assign({}, icon.img);
        icon.img2.pixels = [];
        for(var i = 0; i < classicHeight; i++)for(var j = 0; j < classicWidth; j++){
            var index = i * classicWidth + j;
            var value = 0;
            if (i === 0 || j === 0 || i === classicHeight - 1 || j === classicWidth - 1) value = 1;
            icon.img.pixels[index] = value;
            icon.img2.pixels[index] = 1;
        }
        icon.colorIcon = {
            width: width,
            height: height,
            flags: 0,
            aspectRatio: 17,
            MaxPaletteSize: 2,
            states: [
                {
                    transparentIndex: 0,
                    NumColors: 2,
                    flags: 3,
                    imageCompression: 0,
                    paletteCompression: 0,
                    depth: 8,
                    imageSize: width * height,
                    paletteSize: 6,
                    pixels: [],
                    palette: [
                        [
                            0,
                            0,
                            200
                        ],
                        [
                            0,
                            200,
                            0
                        ]
                    ]
                }
            ]
        };
        for(i = 0; i < height; i++)for(var j = 0; j < height; j++)icon.colorIcon.states[0].pixels.push(1);
        return icon;
    };
    // creates an ArrayBuffer with the binary data of the Icon;
    me.write = function(icon) {
        var fileSize = 78;
        var bitPlanes = icon.img.depth;
        var bitWidth = Math.ceil(icon.img.width / 16) * 16;
        var bitSize = icon.img.height * bitWidth * bitPlanes;
        fileSize += 20 + bitSize / 8;
        bitWidth = Math.ceil(icon.img2.width / 16) * 16;
        bitPlanes = icon.img2.depth;
        bitSize = icon.img2.height * bitWidth * bitPlanes;
        fileSize += 20 + bitSize / 8;
        //icon.colorIcon = 0;
        if (icon.colorIcon) {
            generateColorIconData(icon.colorIcon);
            fileSize += icon.colorIcon.byteSize + 8; // 8 = "FORM" + Size Dword;
        }
        0, module.exports;
        var file = (0, $3QDcZ.default)(new ArrayBuffer(fileSize), true);
        console.log("File is " + fileSize + " bytes");
        icon.currentX = -2147483648; // not sure but this seems to position the icon automatically in the window?
        icon.currentY = -2147483648;
        file.writeUbyte(227);
        file.writeUbyte(16);
        file.writeWord(icon.version);
        file.writeDWord(icon.nextGadget);
        file.writeWord(icon.leftEdge);
        file.writeWord(icon.topEdge);
        file.writeWord(icon.width);
        file.writeWord(icon.height);
        file.writeWord(icon.flags);
        file.writeWord(icon.activation);
        file.writeWord(icon.gadgetType);
        file.writeDWord(icon.gadgetRender);
        file.writeDWord(icon.selectRender);
        file.writeDWord(icon.gadgetText);
        file.writeDWord(icon.mutualExclude);
        file.writeDWord(icon.specialInfo);
        file.writeWord(icon.gadgetID);
        file.writeDWord(icon.userData);
        file.writeUbyte(icon.type);
        file.writeUbyte(icon.padding);
        file.writeDWord(icon.hasDefaultTool);
        file.writeDWord(icon.hasToolTypes);
        file.writeDWord(icon.currentX);
        file.writeDWord(icon.currentY);
        file.writeDWord(icon.hasDrawerData);
        file.writeDWord(icon.hasToolWindow);
        file.writeDWord(icon.stackSize);
        // 78
        // write first image
        writeImage(icon.img, 1);
        writeImage(icon.img2, 2);
        function writeImage(img, index) {
            file.writeWord(img.leftEdge);
            file.writeWord(img.topEdge);
            file.writeWord(img.width);
            file.writeWord(img.height);
            file.writeWord(img.depth);
            file.writeDWord(img.hasimageData);
            file.writeUbyte(img.planePick);
            file.writeUbyte(img.planeOnOff);
            file.writeDWord(img.nextImage);
            for(var bitPlane = 0; bitPlane < bitPlanes; bitPlane++){
                var pixelIndex = 0;
                for(var i = 0, max = img.height; i < max; i++){
                    var bits = [];
                    var bitWidth = Math.ceil(img.width / 16) * 16;
                    //for (var j = 0, maxj = bitWidth; j<maxj; j++){
                    for(var j = 0, maxj = img.width; j < maxj; j++){
                        var colorIndex = img.pixels[pixelIndex] || 0;
                        var pixel = 0;
                        if (bitPlane === 0) pixel = colorIndex % 2 === 1;
                        if (bitPlane === 1) pixel = colorIndex === 2 || colorIndex === 3 || colorIndex === 6 || colorIndex === 7;
                        if (bitPlane === 2) pixel = colorIndex === 4 || colorIndex === 5 || colorIndex === 6 || colorIndex === 7;
                        bits.push(pixel ? 1 : 0);
                        pixelIndex++;
                    }
                    for(j = 0, maxj = bitWidth - img.width; j < maxj; j++)bits.push(0);
                    file.writeBits(bits);
                }
            }
        }
        if (icon.colorIcon) {
            var writeIconState = function(state) {
                //console.log(state);
                file.writeString("IMAG");
                // aparently this should be even?
                file.writeDWord(state.size);
                file.writeUbyte(state.transparentIndex);
                file.writeUbyte(state.NumColors - 1);
                file.writeUbyte(state.flags);
                file.writeUbyte(state.imageCompression);
                file.writeUbyte(state.paletteCompression);
                file.writeUbyte(state.depth);
                file.writeWord(state.imageSize - 1);
                file.writeWord(state.paletteSize - 1);
                // then all pixels as UByte
                for(var i = 0; i < state.imageSize; i++)file.writeUbyte(state.pixels[i]);
                // then the palette
                if (state.palette) for(i = 0; i < state.paletteSize / 3; i++){
                    //console.log(i);
                    //console.log(state.palette[i]);
                    file.writeUbyte(state.palette[i][0]);
                    file.writeUbyte(state.palette[i][1]);
                    file.writeUbyte(state.palette[i][2]);
                }
                // padding byte if needed
                if (state.hasPaddingByte) file.writeByte(0);
            };
            file.writeString("FORM");
            file.writeDWord(icon.colorIcon.byteSize);
            file.writeString("ICON");
            file.writeString("FACE");
            file.writeDWord(6);
            file.writeUbyte(icon.colorIcon.width - 1);
            file.writeUbyte(icon.colorIcon.height - 1);
            file.writeUbyte(icon.colorIcon.flags);
            file.writeUbyte(icon.colorIcon.aspectRatio);
            file.writeWord(icon.colorIcon.MaxPaletteSize - 1);
            writeIconState(icon.colorIcon.states[0]);
            if (icon.colorIcon.states[1]) writeIconState(icon.colorIcon.states[1]);
        } else console.log("skipping Coloricon");
        return file.buffer;
    };
    function generateColorIconData(colorIcon) {
        var size = 18; // main header
        if (colorIcon.states[0]) {
            colorIcon.states[0].size = 10 + colorIcon.states[0].imageSize + colorIcon.states[0].paletteSize;
            // apparently this should be even?
            if (colorIcon.states[0].size % 2 === 1) {
                colorIcon.states[0].size++;
                colorIcon.states[0].hasPaddingByte = true;
            } else colorIcon.states[0].hasPaddingByte = false;
            size += colorIcon.states[0].size + 8; // 8 = "IMAG" + size Dword
        }
        if (colorIcon.states[1]) {
            colorIcon.states[1].size = 10 + colorIcon.states[1].imageSize;
            if (colorIcon.states[1].palette) colorIcon.states[1].size += colorIcon.states[1].paletteSize;
            if (colorIcon.states[1].size % 2 === 1) {
                colorIcon.states[1].size++;
                colorIcon.states[1].hasPaddingByte = true;
            } else colorIcon.states[1].hasPaddingByte = false;
            size += colorIcon.states[1].size + 8; // 8 = "IMAG" + size Dword
        }
        colorIcon.byteSize = size;
        console.log("state size = " + size);
    }
    function readIconImage(file, offset) {
        if (offset) file.goto(offset);
        var img = {};
        img.leftEdge = file.readWord();
        img.topEdge = file.readWord();
        img.width = file.readWord();
        img.height = file.readWord();
        img.depth = file.readWord();
        img.hasimageData = file.readDWord();
        img.planePick = file.readUbyte(); // not used
        img.planeOnOff = file.readUbyte(); // not used
        img.nextImage = file.readDWord(); // not used
        //img.depth = 1;
        if (img.hasimageData) {
            var lineWidth = img.width + 15 >> 4 << 1; // in bytes
            var pixels = [];
            if (img.depth < 9) {
                for(var plane = 0; plane < img.depth; plane++)for(var y = 0; y < img.height; y++){
                    pixels[y] = pixels[y] || [];
                    var line = [];
                    for(var x = 0; x < lineWidth; x++)line.push(file.readUbyte());
                    // add bitplane line to pixel values;
                    for(var b = 0; b < lineWidth; b++){
                        var val = line[b];
                        for(var i = 7; i >= 0; i--){
                            x = b * 8 + (7 - i);
                            var bit = val & 1 << i ? 1 : 0;
                            var p = pixels[y][x] || 0;
                            pixels[y][x] = p + (bit << plane);
                        }
                    }
                }
            } else {
                img.invalid = true;
                console.error("Error: This doesn't seem to be a valid icon file");
            }
            img.pixels = pixels;
        }
        return img;
    }
    function readText(file, offset) {
        if (offset) file.goto(offset);
        var length = file.readDWord();
        var s = file.readString(length - 1);
        file.readUbyte(); // zero byte;
        return s;
    }
    function decodeNewIcon(toolTypes) {
        let newIcon = {
            states: [
                {
                    pixels: [],
                    palette: []
                },
                {
                    pixels: [],
                    palette: []
                }
            ]
        };
        let decodeData = [
            {
                firstLine: false,
                paletteBits: "",
                imageBits: ""
            },
            {
                firstLine: false,
                paletteBits: "",
                imageBits: ""
            }
        ];
        let decodeBits = (data)=>{
            let bits = "";
            for(let i = 0; i < data.length; i++){
                let byte = data.charCodeAt(i);
                let _bits;
                if (byte < 160) _bits = (byte - 32).toString(2);
                else if (byte < 209) _bits = (byte - 81).toString(2);
                else {
                    // RLE - just used for filling with 0
                    _bits = "";
                    for(let j = 0; j < byte - 208; j++)_bits += "0000000";
                }
                if (_bits) {
                    while(_bits.length < 7)_bits = "0" + _bits;
                    bits += _bits;
                }
            }
            return bits;
        };
        toolTypes.forEach((toolType)=>{
            if (toolType.indexOf("IM1=") === 0 || toolType.indexOf("IM2=") === 0) {
                let data = toolType.substr(4);
                let imageIndex = toolType.indexOf("IM1=") === 0 ? 0 : 1;
                let decoded = decodeData[imageIndex];
                let state = newIcon.states[imageIndex];
                if (!decoded.firstLine) {
                    decoded.firstLine = true;
                    newIcon.transparency = data.charCodeAt(0) === 66 // B
                    ;
                    newIcon.width = data.charCodeAt(1) - 33;
                    newIcon.height = data.charCodeAt(2) - 33;
                    state.colorCount = (data.charCodeAt(3) - 33 << 6) + data.charCodeAt(4) - 33;
                    state.bitCount = 1;
                    while(1 << state.bitCount < state.colorCount)state.bitCount++;
                    data = data.substr(5);
                    decoded.paletteBits = decodeBits(data);
                    let bitCount = 8;
                    let max = Math.floor(decoded.paletteBits.length / bitCount / 3);
                    for(let i = 0; i < max; i++){
                        let index = i * bitCount * 3;
                        let r = parseInt(decoded.paletteBits.substr(index, bitCount), 2);
                        let g = parseInt(decoded.paletteBits.substr(index + bitCount, bitCount), 2);
                        let b = parseInt(decoded.paletteBits.substr(index + bitCount * 2, bitCount), 2);
                        newIcon.states[imageIndex].palette.push([
                            r,
                            g,
                            b
                        ]);
                    }
                } else {
                    // note: it's probably more efficient to put the pixel color in place directly, but yeah ... TODO for later
                    let bits = decodeBits(data);
                    let max = Math.floor(bits.length / state.bitCount);
                    for(let i = 0; i < max; i++){
                        let nr = parseInt(bits.substr(i * state.bitCount, state.bitCount), 2);
                        state.pixels.push(nr);
                    }
                }
            }
        });
        return newIcon;
    }
    function readIFFICON(file) {
        var index = file.index;
        var img = {
            states: []
        };
        function readChunk() {
            var chunk = {};
            chunk.name = file.readString(4);
            chunk.size = file.readDWord();
            return chunk;
        }
        while(index < file.length - 4){
            file.goto(index);
            var chunk = readChunk();
            index += chunk.size + 8;
            if (chunk.size % 2 === 1) index++;
            switch(chunk.name){
                case "FACE":
                    img.width = file.readUbyte() + 1;
                    img.height = file.readUbyte() + 1;
                    img.flags = file.readUbyte();
                    img.aspectRatio = file.readUbyte(); //upper 4 bits:x aspect, lower 4 bits: y aspect
                    img.MaxPaletteSize = file.readWord();
                    console.log("Icon is " + img.width + "x" + img.height);
                    break;
                case "IMAG":
                    var endIndex = file.index + chunk.size;
                    var state = {};
                    state.transparentIndex = file.readUbyte();
                    state.NumColors = file.readUbyte() + 1;
                    state.flags = file.readUbyte();
                    state.imageCompression = file.readUbyte();
                    state.paletteCompression = file.readUbyte();
                    state.depth = file.readUbyte();
                    state.imageSize = file.readWord() + 1;
                    state.paletteSize = file.readWord() + 1;
                    state.pixels = [];
                    state.palette = [];
                    var imageDataOffset = file.index;
                    var paletteDataOffset = imageDataOffset + state.imageSize;
                    if (state.imageCompression) {
                        // note: this is BIT aligned, not byte aligned ...
                        // -> RLE control chars are 8 bits, but the data elements are n bits, determined by state.depth
                        var max = (state.imageSize - 1) * 8;
                        var bitIndex = 0;
                        while(bitIndex < max){
                            var b = file.readBits(8, bitIndex, imageDataOffset);
                            bitIndex += 8;
                            if (b > 128) {
                                var b2 = file.readBits(state.depth, bitIndex, imageDataOffset);
                                bitIndex += state.depth;
                                for(var k = 0; k < 257 - b; k++)state.pixels.push(b2);
                            }
                            if (b < 128) for(k = 0; k <= b; k++){
                                state.pixels.push(file.readBits(state.depth, bitIndex, imageDataOffset));
                                bitIndex += state.depth;
                            }
                        }
                    } else // note: uncompressed data is BYTE aligned, even if state.depth < 8
                    for(var i = 0; i < state.imageSize; i++)state.pixels.push(file.readUbyte());
                    if (state.paletteSize) {
                        file.goto(paletteDataOffset);
                        var rgb = [];
                        var bitsPerColorByte = 8;
                        if (state.paletteCompression) {
                            var max = (state.paletteSize - 1) * 8;
                            var bitIndex = 0;
                            while(bitIndex < max){
                                var b = file.readBits(8, bitIndex, paletteDataOffset);
                                bitIndex += 8;
                                if (b > 128) {
                                    var b2 = file.readBits(bitsPerColorByte, bitIndex, paletteDataOffset);
                                    bitIndex += bitsPerColorByte;
                                    for(var k = 0; k < 257 - b; k++)rgb.push(b2);
                                }
                                if (b < 128) for(k = 0; k <= b; k++){
                                    rgb.push(file.readBits(bitsPerColorByte, bitIndex, paletteDataOffset));
                                    bitIndex += bitsPerColorByte;
                                }
                            }
                        } else for(i = 0; i < state.paletteSize; i++)rgb.push(file.readUbyte());
                        if (rgb.length > 2) for(i = 0, max = rgb.length; i < max; i += 3)state.palette.push([
                            rgb[i],
                            rgb[i + 1],
                            rgb[i + 2]
                        ]);
                    }
                    if (state.palette.length === 0 && state.flags < 3) // no palette, using the palette from the previous state if present;
                    {
                        if (img.states.length > 0) state.palette = img.states[img.states.length - 1].palette;
                    }
                    img.states.push(state);
                    break;
                case "ARGB":
                    // zlib compressed
                    // found some info/structure on https://amigaworld.net//modules/newbb/viewtopic.php?viewmode=flat&order=0&topic_id=34625&forum=15&post_id=639101#639062
                    console.log("decoding ARGB data");
                    var state = {};
                    state.rgba = true;
                    state.pixels = [];
                    state.palette = [];
                    for(var offset = 0; offset < 10; offset++)// no idea what this data structure is ...
                    // first DWORD always seem to be 1?
                    state.dummy = file.readUbyte();
                    var size = chunk.size - offset;
                    var data = new Uint8Array(size);
                    for(var i = 0; i < size; i++)data[i] = file.readUbyte();
                    try {
                        var a;
                        if (typeof Zlib !== "undefined") // running in browser
                        a = new Zlib.Inflate(data).decompress();
                        else {
                            // running in node
                            var zlib = (parcelRequire("gxZpm"));
                            a = zlib.inflateSync(data);
                        }
                        for(var y = 0; y < img.height; y++)for(var x = 0; x < img.width; x++){
                            var pixelIndex = (y * img.width + x) * 4;
                            var color = [
                                a[pixelIndex + 1] || 0,
                                a[pixelIndex + 2] || 0,
                                a[pixelIndex + 3] || 0,
                                (a[pixelIndex] || 0) / 255
                            ];
                            state.pixels.push(color);
                        }
                        img.states.push(state);
                    } catch (e) {
                        console.log("invalid zlib structure");
                    }
                    break;
                default:
                    console.log("unhandled IFF chunk: " + chunk.name);
                    break;
            }
        }
        return img;
    }
    function getIconType(type) {
        var iconTypes = {
            1: "disk",
            2: "drawer",
            3: "tool (executable)",
            4: "project (data file)",
            5: "trashcan",
            6: "device",
            7: "Kickstart ROM image",
            8: "Appicon (placed on the desktop by application)"
        };
        return iconTypes[type] || "unknown";
    }
    me.MUIPalette = MUIPalette;
    if (typeof FileType !== "undefined") FileType.register(me);
    return me;
}();
typeof module.exports;
var $b5de9d2c0fe2660b$export$2e2bcd8739ae039 = $b5de9d2c0fe2660b$var$Icon;

});
parcelRegister("8XeSI", function(module, exports) {

$parcel$export(module.exports, "default", () => $684f60967d3bbb2a$export$2e2bcd8739ae039);
/** @license zlib.js 2012 - imaya [ https://github.com/imaya/zlib.js ] The MIT License */ function $684f60967d3bbb2a$export$2e2bcd8739ae039() {
    "use strict";
    function m(d) {
        throw d;
    }
    var w = void 0, z = !0, aa = this;
    function A(d, a) {
        var c = d.split("."), e = aa;
        !(c[0] in e) && e.execScript && e.execScript("var " + c[0]);
        for(var b; c.length && (b = c.shift());)!c.length && a !== w ? e[b] = a : e = e[b] ? e[b] : e[b] = {};
    }
    var G = "undefined" !== typeof Uint8Array && "undefined" !== typeof Uint16Array && "undefined" !== typeof Uint32Array && "undefined" !== typeof DataView;
    function I(d, a) {
        this.index = "number" === typeof a ? a : 0;
        this.i = 0;
        this.buffer = d instanceof (G ? Uint8Array : Array) ? d : new (G ? Uint8Array : Array)(32768);
        2 * this.buffer.length <= this.index && m(Error("invalid index"));
        this.buffer.length <= this.index && this.f();
    }
    I.prototype.f = function() {
        var d = this.buffer, a, c = d.length, e = new (G ? Uint8Array : Array)(c << 1);
        if (G) e.set(d);
        else for(a = 0; a < c; ++a)e[a] = d[a];
        return this.buffer = e;
    };
    I.prototype.d = function(d, a, c) {
        var e = this.buffer, b = this.index, f = this.i, g = e[b], h;
        c && 1 < a && (d = 8 < a ? (Q[d & 255] << 24 | Q[d >>> 8 & 255] << 16 | Q[d >>> 16 & 255] << 8 | Q[d >>> 24 & 255]) >> 32 - a : Q[d] >> 8 - a);
        if (8 > a + f) g = g << a | d, f += a;
        else for(h = 0; h < a; ++h)g = g << 1 | d >> a - h - 1 & 1, 8 === ++f && (f = 0, e[b++] = Q[g], g = 0, b === e.length && (e = this.f()));
        e[b] = g;
        this.buffer = e;
        this.i = f;
        this.index = b;
    };
    I.prototype.finish = function() {
        var d = this.buffer, a = this.index, c;
        0 < this.i && (d[a] <<= 8 - this.i, d[a] = Q[d[a]], a++);
        G ? c = d.subarray(0, a) : (d.length = a, c = d);
        return c;
    };
    var ba = new (G ? Uint8Array : Array)(256), ca;
    for(ca = 0; 256 > ca; ++ca){
        for(var R = ca, ha = R, ia = 7, R = R >>> 1; R; R >>>= 1)ha <<= 1, ha |= R & 1, --ia;
        ba[ca] = (ha << ia & 255) >>> 0;
    }
    var Q = ba;
    function ja(d) {
        this.buffer = new (G ? Uint16Array : Array)(2 * d);
        this.length = 0;
    }
    ja.prototype.getParent = function(d) {
        return 2 * ((d - 2) / 4 | 0);
    };
    ja.prototype.push = function(d, a) {
        var c, e, b = this.buffer, f;
        c = this.length;
        b[this.length++] = a;
        for(b[this.length++] = d; 0 < c;)if (e = this.getParent(c), b[c] > b[e]) f = b[c], b[c] = b[e], b[e] = f, f = b[c + 1], b[c + 1] = b[e + 1], b[e + 1] = f, c = e;
        else break;
        return this.length;
    };
    ja.prototype.pop = function() {
        var d, a, c = this.buffer, e, b, f;
        a = c[0];
        d = c[1];
        this.length -= 2;
        c[0] = c[this.length];
        c[1] = c[this.length + 1];
        for(f = 0;;){
            b = 2 * f + 2;
            if (b >= this.length) break;
            b + 2 < this.length && c[b + 2] > c[b] && (b += 2);
            if (c[b] > c[f]) e = c[f], c[f] = c[b], c[b] = e, e = c[f + 1], c[f + 1] = c[b + 1], c[b + 1] = e;
            else break;
            f = b;
        }
        return {
            index: d,
            value: a,
            length: this.length
        };
    };
    function S(d) {
        var a = d.length, c = 0, e = Number.POSITIVE_INFINITY, b, f, g, h, k, p, q, r, n, l;
        for(r = 0; r < a; ++r)d[r] > c && (c = d[r]), d[r] < e && (e = d[r]);
        b = 1 << c;
        f = new (G ? Uint32Array : Array)(b);
        g = 1;
        h = 0;
        for(k = 2; g <= c;){
            for(r = 0; r < a; ++r)if (d[r] === g) {
                p = 0;
                q = h;
                for(n = 0; n < g; ++n)p = p << 1 | q & 1, q >>= 1;
                l = g << 16 | r;
                for(n = p; n < b; n += k)f[n] = l;
                ++h;
            }
            ++g;
            h <<= 1;
            k <<= 1;
        }
        return [
            f,
            c,
            e
        ];
    }
    function ka(d, a) {
        this.h = na;
        this.w = 0;
        this.input = G && d instanceof Array ? new Uint8Array(d) : d;
        this.b = 0;
        a && (a.lazy && (this.w = a.lazy), "number" === typeof a.compressionType && (this.h = a.compressionType), a.outputBuffer && (this.a = G && a.outputBuffer instanceof Array ? new Uint8Array(a.outputBuffer) : a.outputBuffer), "number" === typeof a.outputIndex && (this.b = a.outputIndex));
        this.a || (this.a = new (G ? Uint8Array : Array)(32768));
    }
    var na = 2, oa = {
        NONE: 0,
        r: 1,
        k: na,
        N: 3
    }, pa = [], T;
    for(T = 0; 288 > T; T++)switch(z){
        case 143 >= T:
            pa.push([
                T + 48,
                8
            ]);
            break;
        case 255 >= T:
            pa.push([
                T - 144 + 400,
                9
            ]);
            break;
        case 279 >= T:
            pa.push([
                T - 256 + 0,
                7
            ]);
            break;
        case 287 >= T:
            pa.push([
                T - 280 + 192,
                8
            ]);
            break;
        default:
            m("invalid literal: " + T);
    }
    ka.prototype.j = function() {
        var d, a, c, e, b = this.input;
        switch(this.h){
            case 0:
                c = 0;
                for(e = b.length; c < e;){
                    a = G ? b.subarray(c, c + 65535) : b.slice(c, c + 65535);
                    c += a.length;
                    var f = a, g = c === e, h = w, k = w, p = w, q = w, r = w, n = this.a, l = this.b;
                    if (G) {
                        for(n = new Uint8Array(this.a.buffer); n.length <= l + f.length + 5;)n = new Uint8Array(n.length << 1);
                        n.set(this.a);
                    }
                    h = g ? 1 : 0;
                    n[l++] = h | 0;
                    k = f.length;
                    p = ~k + 65536 & 65535;
                    n[l++] = k & 255;
                    n[l++] = k >>> 8 & 255;
                    n[l++] = p & 255;
                    n[l++] = p >>> 8 & 255;
                    if (G) n.set(f, l), l += f.length, n = n.subarray(0, l);
                    else {
                        q = 0;
                        for(r = f.length; q < r; ++q)n[l++] = f[q];
                        n.length = l;
                    }
                    this.b = l;
                    this.a = n;
                }
                break;
            case 1:
                var s = new I(G ? new Uint8Array(this.a.buffer) : this.a, this.b);
                s.d(1, 1, z);
                s.d(1, 2, z);
                var t = qa(this, b), x, E, B;
                x = 0;
                for(E = t.length; x < E; x++)if (B = t[x], I.prototype.d.apply(s, pa[B]), 256 < B) s.d(t[++x], t[++x], z), s.d(t[++x], 5), s.d(t[++x], t[++x], z);
                else if (256 === B) break;
                this.a = s.finish();
                this.b = this.a.length;
                break;
            case na:
                var C = new I(G ? new Uint8Array(this.a.buffer) : this.a, this.b), L, v, M, Y, Z, gb = [
                    16,
                    17,
                    18,
                    0,
                    8,
                    7,
                    9,
                    6,
                    10,
                    5,
                    11,
                    4,
                    12,
                    3,
                    13,
                    2,
                    14,
                    1,
                    15
                ], da, Fa, ea, Ga, la, sa = Array(19), Ha, $, ma, D, Ia;
                L = na;
                C.d(1, 1, z);
                C.d(L, 2, z);
                v = qa(this, b);
                da = ra(this.L, 15);
                Fa = ta(da);
                ea = ra(this.K, 7);
                Ga = ta(ea);
                for(M = 286; 257 < M && 0 === da[M - 1]; M--);
                for(Y = 30; 1 < Y && 0 === ea[Y - 1]; Y--);
                var Ja = M, Ka = Y, K = new (G ? Uint32Array : Array)(Ja + Ka), u, N, y, fa, J = new (G ? Uint32Array : Array)(316), H, F, O = new (G ? Uint8Array : Array)(19);
                for(u = N = 0; u < Ja; u++)K[N++] = da[u];
                for(u = 0; u < Ka; u++)K[N++] = ea[u];
                if (!G) {
                    u = 0;
                    for(fa = O.length; u < fa; ++u)O[u] = 0;
                }
                u = H = 0;
                for(fa = K.length; u < fa; u += N){
                    for(N = 1; u + N < fa && K[u + N] === K[u]; ++N);
                    y = N;
                    if (0 === K[u]) {
                        if (3 > y) for(; 0 < y--;)J[H++] = 0, O[0]++;
                        else for(; 0 < y;)F = 138 > y ? y : 138, F > y - 3 && F < y && (F = y - 3), 10 >= F ? (J[H++] = 17, J[H++] = F - 3, O[17]++) : (J[H++] = 18, J[H++] = F - 11, O[18]++), y -= F;
                    } else if (J[H++] = K[u], O[K[u]]++, y--, 3 > y) for(; 0 < y--;)J[H++] = K[u], O[K[u]]++;
                    else for(; 0 < y;)F = 6 > y ? y : 6, F > y - 3 && F < y && (F = y - 3), J[H++] = 16, J[H++] = F - 3, O[16]++, y -= F;
                }
                d = G ? J.subarray(0, H) : J.slice(0, H);
                la = ra(O, 7);
                for(D = 0; 19 > D; D++)sa[D] = la[gb[D]];
                for(Z = 19; 4 < Z && 0 === sa[Z - 1]; Z--);
                Ha = ta(la);
                C.d(M - 257, 5, z);
                C.d(Y - 1, 5, z);
                C.d(Z - 4, 4, z);
                for(D = 0; D < Z; D++)C.d(sa[D], 3, z);
                D = 0;
                for(Ia = d.length; D < Ia; D++)if ($ = d[D], C.d(Ha[$], la[$], z), 16 <= $) {
                    D++;
                    switch($){
                        case 16:
                            ma = 2;
                            break;
                        case 17:
                            ma = 3;
                            break;
                        case 18:
                            ma = 7;
                            break;
                        default:
                            m("invalid code: " + $);
                    }
                    C.d(d[D], ma, z);
                }
                var La = [
                    Fa,
                    da
                ], Ma = [
                    Ga,
                    ea
                ], P, Na, ga, va, Oa, Pa, Qa, Ra;
                Oa = La[0];
                Pa = La[1];
                Qa = Ma[0];
                Ra = Ma[1];
                P = 0;
                for(Na = v.length; P < Na; ++P)if (ga = v[P], C.d(Oa[ga], Pa[ga], z), 256 < ga) C.d(v[++P], v[++P], z), va = v[++P], C.d(Qa[va], Ra[va], z), C.d(v[++P], v[++P], z);
                else if (256 === ga) break;
                this.a = C.finish();
                this.b = this.a.length;
                break;
            default:
                m("invalid compression type");
        }
        return this.a;
    };
    function ua(d, a) {
        this.length = d;
        this.G = a;
    }
    var wa = function() {
        function d(b) {
            switch(z){
                case 3 === b:
                    return [
                        257,
                        b - 3,
                        0
                    ];
                case 4 === b:
                    return [
                        258,
                        b - 4,
                        0
                    ];
                case 5 === b:
                    return [
                        259,
                        b - 5,
                        0
                    ];
                case 6 === b:
                    return [
                        260,
                        b - 6,
                        0
                    ];
                case 7 === b:
                    return [
                        261,
                        b - 7,
                        0
                    ];
                case 8 === b:
                    return [
                        262,
                        b - 8,
                        0
                    ];
                case 9 === b:
                    return [
                        263,
                        b - 9,
                        0
                    ];
                case 10 === b:
                    return [
                        264,
                        b - 10,
                        0
                    ];
                case 12 >= b:
                    return [
                        265,
                        b - 11,
                        1
                    ];
                case 14 >= b:
                    return [
                        266,
                        b - 13,
                        1
                    ];
                case 16 >= b:
                    return [
                        267,
                        b - 15,
                        1
                    ];
                case 18 >= b:
                    return [
                        268,
                        b - 17,
                        1
                    ];
                case 22 >= b:
                    return [
                        269,
                        b - 19,
                        2
                    ];
                case 26 >= b:
                    return [
                        270,
                        b - 23,
                        2
                    ];
                case 30 >= b:
                    return [
                        271,
                        b - 27,
                        2
                    ];
                case 34 >= b:
                    return [
                        272,
                        b - 31,
                        2
                    ];
                case 42 >= b:
                    return [
                        273,
                        b - 35,
                        3
                    ];
                case 50 >= b:
                    return [
                        274,
                        b - 43,
                        3
                    ];
                case 58 >= b:
                    return [
                        275,
                        b - 51,
                        3
                    ];
                case 66 >= b:
                    return [
                        276,
                        b - 59,
                        3
                    ];
                case 82 >= b:
                    return [
                        277,
                        b - 67,
                        4
                    ];
                case 98 >= b:
                    return [
                        278,
                        b - 83,
                        4
                    ];
                case 114 >= b:
                    return [
                        279,
                        b - 99,
                        4
                    ];
                case 130 >= b:
                    return [
                        280,
                        b - 115,
                        4
                    ];
                case 162 >= b:
                    return [
                        281,
                        b - 131,
                        5
                    ];
                case 194 >= b:
                    return [
                        282,
                        b - 163,
                        5
                    ];
                case 226 >= b:
                    return [
                        283,
                        b - 195,
                        5
                    ];
                case 257 >= b:
                    return [
                        284,
                        b - 227,
                        5
                    ];
                case 258 === b:
                    return [
                        285,
                        b - 258,
                        0
                    ];
                default:
                    m("invalid length: " + b);
            }
        }
        var a = [], c, e;
        for(c = 3; 258 >= c; c++)e = d(c), a[c] = e[2] << 24 | e[1] << 16 | e[0];
        return a;
    }(), xa = G ? new Uint32Array(wa) : wa;
    function qa(d, a) {
        function c(b, c) {
            var a = b.G, d = [], e = 0, f;
            f = xa[b.length];
            d[e++] = f & 65535;
            d[e++] = f >> 16 & 255;
            d[e++] = f >> 24;
            var g;
            switch(z){
                case 1 === a:
                    g = [
                        0,
                        a - 1,
                        0
                    ];
                    break;
                case 2 === a:
                    g = [
                        1,
                        a - 2,
                        0
                    ];
                    break;
                case 3 === a:
                    g = [
                        2,
                        a - 3,
                        0
                    ];
                    break;
                case 4 === a:
                    g = [
                        3,
                        a - 4,
                        0
                    ];
                    break;
                case 6 >= a:
                    g = [
                        4,
                        a - 5,
                        1
                    ];
                    break;
                case 8 >= a:
                    g = [
                        5,
                        a - 7,
                        1
                    ];
                    break;
                case 12 >= a:
                    g = [
                        6,
                        a - 9,
                        2
                    ];
                    break;
                case 16 >= a:
                    g = [
                        7,
                        a - 13,
                        2
                    ];
                    break;
                case 24 >= a:
                    g = [
                        8,
                        a - 17,
                        3
                    ];
                    break;
                case 32 >= a:
                    g = [
                        9,
                        a - 25,
                        3
                    ];
                    break;
                case 48 >= a:
                    g = [
                        10,
                        a - 33,
                        4
                    ];
                    break;
                case 64 >= a:
                    g = [
                        11,
                        a - 49,
                        4
                    ];
                    break;
                case 96 >= a:
                    g = [
                        12,
                        a - 65,
                        5
                    ];
                    break;
                case 128 >= a:
                    g = [
                        13,
                        a - 97,
                        5
                    ];
                    break;
                case 192 >= a:
                    g = [
                        14,
                        a - 129,
                        6
                    ];
                    break;
                case 256 >= a:
                    g = [
                        15,
                        a - 193,
                        6
                    ];
                    break;
                case 384 >= a:
                    g = [
                        16,
                        a - 257,
                        7
                    ];
                    break;
                case 512 >= a:
                    g = [
                        17,
                        a - 385,
                        7
                    ];
                    break;
                case 768 >= a:
                    g = [
                        18,
                        a - 513,
                        8
                    ];
                    break;
                case 1024 >= a:
                    g = [
                        19,
                        a - 769,
                        8
                    ];
                    break;
                case 1536 >= a:
                    g = [
                        20,
                        a - 1025,
                        9
                    ];
                    break;
                case 2048 >= a:
                    g = [
                        21,
                        a - 1537,
                        9
                    ];
                    break;
                case 3072 >= a:
                    g = [
                        22,
                        a - 2049,
                        10
                    ];
                    break;
                case 4096 >= a:
                    g = [
                        23,
                        a - 3073,
                        10
                    ];
                    break;
                case 6144 >= a:
                    g = [
                        24,
                        a - 4097,
                        11
                    ];
                    break;
                case 8192 >= a:
                    g = [
                        25,
                        a - 6145,
                        11
                    ];
                    break;
                case 12288 >= a:
                    g = [
                        26,
                        a - 8193,
                        12
                    ];
                    break;
                case 16384 >= a:
                    g = [
                        27,
                        a - 12289,
                        12
                    ];
                    break;
                case 24576 >= a:
                    g = [
                        28,
                        a - 16385,
                        13
                    ];
                    break;
                case 32768 >= a:
                    g = [
                        29,
                        a - 24577,
                        13
                    ];
                    break;
                default:
                    m("invalid distance");
            }
            f = g;
            d[e++] = f[0];
            d[e++] = f[1];
            d[e++] = f[2];
            var h, k;
            h = 0;
            for(k = d.length; h < k; ++h)n[l++] = d[h];
            t[d[0]]++;
            x[d[3]]++;
            s = b.length + c - 1;
            r = null;
        }
        var e, b, f, g, h, k = {}, p, q, r, n = G ? new Uint16Array(2 * a.length) : [], l = 0, s = 0, t = new (G ? Uint32Array : Array)(286), x = new (G ? Uint32Array : Array)(30), E = d.w, B;
        if (!G) {
            for(f = 0; 285 >= f;)t[f++] = 0;
            for(f = 0; 29 >= f;)x[f++] = 0;
        }
        t[256] = 1;
        e = 0;
        for(b = a.length; e < b; ++e){
            f = h = 0;
            for(g = 3; f < g && e + f !== b; ++f)h = h << 8 | a[e + f];
            k[h] === w && (k[h] = []);
            p = k[h];
            if (!(0 < s--)) {
                for(; 0 < p.length && 32768 < e - p[0];)p.shift();
                if (e + 3 >= b) {
                    r && c(r, -1);
                    f = 0;
                    for(g = b - e; f < g; ++f)B = a[e + f], n[l++] = B, ++t[B];
                    break;
                }
                0 < p.length ? (q = ya(a, e, p), r ? r.length < q.length ? (B = a[e - 1], n[l++] = B, ++t[B], c(q, 0)) : c(r, -1) : q.length < E ? r = q : c(q, 0)) : r ? c(r, -1) : (B = a[e], n[l++] = B, ++t[B]);
            }
            p.push(e);
        }
        n[l++] = 256;
        t[256]++;
        d.L = t;
        d.K = x;
        return G ? n.subarray(0, l) : n;
    }
    function ya(d, a, c) {
        var e, b, f = 0, g, h, k, p, q = d.length;
        h = 0;
        p = c.length;
        a: for(; h < p; h++){
            e = c[p - h - 1];
            g = 3;
            if (3 < f) {
                for(k = f; 3 < k; k--)if (d[e + k - 1] !== d[a + k - 1]) continue a;
                g = f;
            }
            for(; 258 > g && a + g < q && d[e + g] === d[a + g];)++g;
            g > f && (b = e, f = g);
            if (258 === g) break;
        }
        return new ua(f, a - b);
    }
    function ra(d, a) {
        var c = d.length, e = new ja(572), b = new (G ? Uint8Array : Array)(c), f, g, h, k, p;
        if (!G) for(k = 0; k < c; k++)b[k] = 0;
        for(k = 0; k < c; ++k)0 < d[k] && e.push(k, d[k]);
        f = Array(e.length / 2);
        g = new (G ? Uint32Array : Array)(e.length / 2);
        if (1 === f.length) return b[e.pop().index] = 1, b;
        k = 0;
        for(p = e.length / 2; k < p; ++k)f[k] = e.pop(), g[k] = f[k].value;
        h = za(g, g.length, a);
        k = 0;
        for(p = f.length; k < p; ++k)b[f[k].index] = h[k];
        return b;
    }
    function za(d, a, c) {
        function e(b) {
            var c = k[b][p[b]];
            c === a ? (e(b + 1), e(b + 1)) : --g[c];
            ++p[b];
        }
        var b = new (G ? Uint16Array : Array)(c), f = new (G ? Uint8Array : Array)(c), g = new (G ? Uint8Array : Array)(a), h = Array(c), k = Array(c), p = Array(c), q = (1 << c) - a, r = 1 << c - 1, n, l, s, t, x;
        b[c - 1] = a;
        for(l = 0; l < c; ++l)q < r ? f[l] = 0 : (f[l] = 1, q -= r), q <<= 1, b[c - 2 - l] = (b[c - 1 - l] / 2 | 0) + a;
        b[0] = f[0];
        h[0] = Array(b[0]);
        k[0] = Array(b[0]);
        for(l = 1; l < c; ++l)b[l] > 2 * b[l - 1] + f[l] && (b[l] = 2 * b[l - 1] + f[l]), h[l] = Array(b[l]), k[l] = Array(b[l]);
        for(n = 0; n < a; ++n)g[n] = c;
        for(s = 0; s < b[c - 1]; ++s)h[c - 1][s] = d[s], k[c - 1][s] = s;
        for(n = 0; n < c; ++n)p[n] = 0;
        1 === f[c - 1] && (--g[0], ++p[c - 1]);
        for(l = c - 2; 0 <= l; --l){
            t = n = 0;
            x = p[l + 1];
            for(s = 0; s < b[l]; s++)t = h[l + 1][x] + h[l + 1][x + 1], t > d[n] ? (h[l][s] = t, k[l][s] = a, x += 2) : (h[l][s] = d[n], k[l][s] = n, ++n);
            p[l] = 0;
            1 === f[l] && e(l);
        }
        return g;
    }
    function ta(d) {
        var a = new (G ? Uint16Array : Array)(d.length), c = [], e = [], b = 0, f, g, h, k;
        f = 0;
        for(g = d.length; f < g; f++)c[d[f]] = (c[d[f]] | 0) + 1;
        f = 1;
        for(g = 16; f <= g; f++)e[f] = b, b += c[f] | 0, b <<= 1;
        f = 0;
        for(g = d.length; f < g; f++){
            b = e[d[f]];
            e[d[f]] += 1;
            h = a[f] = 0;
            for(k = d[f]; h < k; h++)a[f] = a[f] << 1 | b & 1, b >>>= 1;
        }
        return a;
    }
    function U(d, a) {
        this.l = [];
        this.m = 32768;
        this.e = this.g = this.c = this.q = 0;
        this.input = G ? new Uint8Array(d) : d;
        this.s = !1;
        this.n = Aa;
        this.B = !1;
        if (a || (a = {}, false)) a.index && (this.c = a.index), a.bufferSize && (this.m = a.bufferSize), a.bufferType && (this.n = a.bufferType), a.resize && (this.B = a.resize);
        switch(this.n){
            case Ba:
                this.b = 32768;
                this.a = new (G ? Uint8Array : Array)(32768 + this.m + 258);
                break;
            case Aa:
                this.b = 0;
                this.a = new (G ? Uint8Array : Array)(this.m);
                this.f = this.J;
                this.t = this.H;
                this.o = this.I;
                break;
            default:
                m(Error("invalid inflate mode"));
        }
    }
    var Ba = 0, Aa = 1, Ca = {
        D: Ba,
        C: Aa
    };
    U.prototype.p = function() {
        for(; !this.s;){
            var d = V(this, 3);
            d & 1 && (this.s = z);
            d >>>= 1;
            switch(d){
                case 0:
                    var a = this.input, c = this.c, e = this.a, b = this.b, f = a.length, g = w, h = w, k = e.length, p = w;
                    this.e = this.g = 0;
                    c + 1 >= f && m(Error("invalid uncompressed block header: LEN"));
                    g = a[c++] | a[c++] << 8;
                    c + 1 >= f && m(Error("invalid uncompressed block header: NLEN"));
                    h = a[c++] | a[c++] << 8;
                    g === ~h && m(Error("invalid uncompressed block header: length verify"));
                    c + g > a.length && m(Error("input buffer is broken"));
                    switch(this.n){
                        case Ba:
                            for(; b + g > e.length;){
                                p = k - b;
                                g -= p;
                                if (G) e.set(a.subarray(c, c + p), b), b += p, c += p;
                                else for(; p--;)e[b++] = a[c++];
                                this.b = b;
                                e = this.f();
                                b = this.b;
                            }
                            break;
                        case Aa:
                            for(; b + g > e.length;)e = this.f({
                                v: 2
                            });
                            break;
                        default:
                            m(Error("invalid inflate mode"));
                    }
                    if (G) e.set(a.subarray(c, c + g), b), b += g, c += g;
                    else for(; g--;)e[b++] = a[c++];
                    this.c = c;
                    this.b = b;
                    this.a = e;
                    break;
                case 1:
                    this.o(Da, Ea);
                    break;
                case 2:
                    for(var q = V(this, 5) + 257, r = V(this, 5) + 1, n = V(this, 4) + 4, l = new (G ? Uint8Array : Array)(Sa.length), s = w, t = w, x = w, E = w, B = w, C = w, L = w, v = w, M = w, v = 0; v < n; ++v)l[Sa[v]] = V(this, 3);
                    if (!G) {
                        v = n;
                        for(n = l.length; v < n; ++v)l[Sa[v]] = 0;
                    }
                    s = S(l);
                    E = new (G ? Uint8Array : Array)(q + r);
                    v = 0;
                    for(M = q + r; v < M;)switch(B = Ta(this, s), B){
                        case 16:
                            for(L = 3 + V(this, 2); L--;)E[v++] = C;
                            break;
                        case 17:
                            for(L = 3 + V(this, 3); L--;)E[v++] = 0;
                            C = 0;
                            break;
                        case 18:
                            for(L = 11 + V(this, 7); L--;)E[v++] = 0;
                            C = 0;
                            break;
                        default:
                            C = E[v++] = B;
                    }
                    t = G ? S(E.subarray(0, q)) : S(E.slice(0, q));
                    x = G ? S(E.subarray(q)) : S(E.slice(q));
                    this.o(t, x);
                    break;
                default:
                    m(Error("unknown BTYPE: " + d));
            }
        }
        return this.t();
    };
    var Ua = [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ], Sa = G ? new Uint16Array(Ua) : Ua, Va = [
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        13,
        15,
        17,
        19,
        23,
        27,
        31,
        35,
        43,
        51,
        59,
        67,
        83,
        99,
        115,
        131,
        163,
        195,
        227,
        258,
        258,
        258
    ], Wa = G ? new Uint16Array(Va) : Va, Xa = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        2,
        2,
        2,
        2,
        3,
        3,
        3,
        3,
        4,
        4,
        4,
        4,
        5,
        5,
        5,
        5,
        0,
        0,
        0
    ], Ya = G ? new Uint8Array(Xa) : Xa, Za = [
        1,
        2,
        3,
        4,
        5,
        7,
        9,
        13,
        17,
        25,
        33,
        49,
        65,
        97,
        129,
        193,
        257,
        385,
        513,
        769,
        1025,
        1537,
        2049,
        3073,
        4097,
        6145,
        8193,
        12289,
        16385,
        24577
    ], $a = G ? new Uint16Array(Za) : Za, ab = [
        0,
        0,
        0,
        0,
        1,
        1,
        2,
        2,
        3,
        3,
        4,
        4,
        5,
        5,
        6,
        6,
        7,
        7,
        8,
        8,
        9,
        9,
        10,
        10,
        11,
        11,
        12,
        12,
        13,
        13
    ], bb = G ? new Uint8Array(ab) : ab, cb = new (G ? Uint8Array : Array)(288), W, db;
    W = 0;
    for(db = cb.length; W < db; ++W)cb[W] = 143 >= W ? 8 : 255 >= W ? 9 : 279 >= W ? 7 : 8;
    var Da = S(cb), eb = new (G ? Uint8Array : Array)(30), fb, hb;
    fb = 0;
    for(hb = eb.length; fb < hb; ++fb)eb[fb] = 5;
    var Ea = S(eb);
    function V(d, a) {
        for(var c = d.g, e = d.e, b = d.input, f = d.c, g = b.length, h; e < a;)f >= g && m(Error("input buffer is broken")), c |= b[f++] << e, e += 8;
        h = c & (1 << a) - 1;
        d.g = c >>> a;
        d.e = e - a;
        d.c = f;
        return h;
    }
    function Ta(d, a) {
        for(var c = d.g, e = d.e, b = d.input, f = d.c, g = b.length, h = a[0], k = a[1], p, q; e < k && !(f >= g);)c |= b[f++] << e, e += 8;
        p = h[c & (1 << k) - 1];
        q = p >>> 16;
        q > e && m(Error("invalid code length: " + q));
        d.g = c >> q;
        d.e = e - q;
        d.c = f;
        return p & 65535;
    }
    U.prototype.o = function(d, a) {
        var c = this.a, e = this.b;
        this.u = d;
        for(var b = c.length - 258, f, g, h, k; 256 !== (f = Ta(this, d));)if (256 > f) e >= b && (this.b = e, c = this.f(), e = this.b), c[e++] = f;
        else {
            g = f - 257;
            k = Wa[g];
            0 < Ya[g] && (k += V(this, Ya[g]));
            f = Ta(this, a);
            h = $a[f];
            0 < bb[f] && (h += V(this, bb[f]));
            e >= b && (this.b = e, c = this.f(), e = this.b);
            for(; k--;)c[e] = c[e++ - h];
        }
        for(; 8 <= this.e;)this.e -= 8, this.c--;
        this.b = e;
    };
    U.prototype.I = function(d, a) {
        var c = this.a, e = this.b;
        this.u = d;
        for(var b = c.length, f, g, h, k; 256 !== (f = Ta(this, d));)if (256 > f) e >= b && (c = this.f(), b = c.length), c[e++] = f;
        else {
            g = f - 257;
            k = Wa[g];
            0 < Ya[g] && (k += V(this, Ya[g]));
            f = Ta(this, a);
            h = $a[f];
            0 < bb[f] && (h += V(this, bb[f]));
            e + k > b && (c = this.f(), b = c.length);
            for(; k--;)c[e] = c[e++ - h];
        }
        for(; 8 <= this.e;)this.e -= 8, this.c--;
        this.b = e;
    };
    U.prototype.f = function() {
        var d = new (G ? Uint8Array : Array)(this.b - 32768), a = this.b - 32768, c, e, b = this.a;
        if (G) d.set(b.subarray(32768, d.length));
        else {
            c = 0;
            for(e = d.length; c < e; ++c)d[c] = b[c + 32768];
        }
        this.l.push(d);
        this.q += d.length;
        if (G) b.set(b.subarray(a, a + 32768));
        else for(c = 0; 32768 > c; ++c)b[c] = b[a + c];
        this.b = 32768;
        return b;
    };
    U.prototype.J = function(d) {
        var a, c = this.input.length / this.c + 1 | 0, e, b, f, g = this.input, h = this.a;
        d && ("number" === typeof d.v && (c = d.v), "number" === typeof d.F && (c += d.F));
        2 > c ? (e = (g.length - this.c) / this.u[2], f = 258 * (e / 2) | 0, b = f < h.length ? h.length + f : h.length << 1) : b = h.length * c;
        G ? (a = new Uint8Array(b), a.set(h)) : a = h;
        return this.a = a;
    };
    U.prototype.t = function() {
        var d = 0, a = this.a, c = this.l, e, b = new (G ? Uint8Array : Array)(this.q + (this.b - 32768)), f, g, h, k;
        if (0 === c.length) return G ? this.a.subarray(32768, this.b) : this.a.slice(32768, this.b);
        f = 0;
        for(g = c.length; f < g; ++f){
            e = c[f];
            h = 0;
            for(k = e.length; h < k; ++h)b[d++] = e[h];
        }
        f = 32768;
        for(g = this.b; f < g; ++f)b[d++] = a[f];
        this.l = [];
        return this.buffer = b;
    };
    U.prototype.H = function() {
        var d, a = this.b;
        G ? this.B ? (d = new Uint8Array(a), d.set(this.a.subarray(0, a))) : d = this.a.subarray(0, a) : (this.a.length > a && (this.a.length = a), d = this.a);
        return this.buffer = d;
    };
    function ib(d) {
        if ("string" === typeof d) {
            var a = d.split(""), c, e;
            c = 0;
            for(e = a.length; c < e; c++)a[c] = (a[c].charCodeAt(0) & 255) >>> 0;
            d = a;
        }
        for(var b = 1, f = 0, g = d.length, h, k = 0; 0 < g;){
            h = 1024 < g ? 1024 : g;
            g -= h;
            do b += d[k++], f += b;
            while (--h);
            b %= 65521;
            f %= 65521;
        }
        return (f << 16 | b) >>> 0;
    }
    function jb(d, a) {
        var c, e;
        this.input = d;
        this.c = 0;
        if (a || (a = {}, false)) a.index && (this.c = a.index), a.verify && (this.M = a.verify);
        c = d[this.c++];
        e = d[this.c++];
        switch(c & 15){
            case kb:
                this.method = kb;
                break;
            default:
                m(Error("unsupported compression method"));
        }
        0 !== ((c << 8) + e) % 31 && m(Error("invalid fcheck flag:" + ((c << 8) + e) % 31));
        e & 32 && m(Error("fdict flag is not supported"));
        this.A = new U(d, {
            index: this.c,
            bufferSize: a.bufferSize,
            bufferType: a.bufferType,
            resize: a.resize
        });
    }
    jb.prototype.p = function() {
        var d = this.input, a, c;
        a = this.A.p();
        this.c = this.A.c;
        this.M && (c = (d[this.c++] << 24 | d[this.c++] << 16 | d[this.c++] << 8 | d[this.c++]) >>> 0, c !== ib(a) && m(Error("invalid adler-32 checksum")));
        return a;
    };
    var kb = 8;
    function lb(d, a) {
        this.input = d;
        this.a = new (G ? Uint8Array : Array)(32768);
        this.h = X.k;
        var c = {}, e;
        if ((a || (a = {}, false)) && "number" === typeof a.compressionType) this.h = a.compressionType;
        for(e in a)c[e] = a[e];
        c.outputBuffer = this.a;
        this.z = new ka(this.input, c);
    }
    var X = oa;
    lb.prototype.j = function() {
        var d, a, c, e, b, f, g, h = 0;
        g = this.a;
        d = kb;
        switch(d){
            case kb:
                a = Math.LOG2E * Math.log(32768) - 8;
                break;
            default:
                m(Error("invalid compression method"));
        }
        c = a << 4 | d;
        g[h++] = c;
        switch(d){
            case kb:
                switch(this.h){
                    case X.NONE:
                        b = 0;
                        break;
                    case X.r:
                        b = 1;
                        break;
                    case X.k:
                        b = 2;
                        break;
                    default:
                        m(Error("unsupported compression type"));
                }
                break;
            default:
                m(Error("invalid compression method"));
        }
        e = b << 6 | 0;
        g[h++] = e | 31 - (256 * c + e) % 31;
        f = ib(this.input);
        this.z.b = h;
        g = this.z.j();
        h = g.length;
        G && (g = new Uint8Array(g.buffer), g.length <= h + 4 && (this.a = new Uint8Array(g.length + 4), this.a.set(g), g = this.a), g = g.subarray(0, h + 4));
        g[h++] = f >> 24 & 255;
        g[h++] = f >> 16 & 255;
        g[h++] = f >> 8 & 255;
        g[h++] = f & 255;
        return g;
    };
    function mb(d, a) {
        var c, e, b, f;
        if (Object.keys) c = Object.keys(a);
        else for(e in c = [], b = 0, a)c[b++] = e;
        b = 0;
        for(f = c.length; b < f; ++b)e = c[b], A(d + "." + e, a[e]);
    }
    A("Zlib.Inflate", jb);
    A("Zlib.Inflate.prototype.decompress", jb.prototype.p);
    mb("Zlib.Inflate.BufferType", {
        ADAPTIVE: Ca.C,
        BLOCK: Ca.D
    });
    A("Zlib.Deflate", lb);
    A("Zlib.Deflate.compress", function(d, a) {
        return new lb(d, a).j();
    });
    A("Zlib.Deflate.prototype.compress", lb.prototype.j);
    mb("Zlib.Deflate.CompressionType", {
        NONE: X.NONE,
        FIXED: X.r,
        DYNAMIC: X.k
    });
}

});

parcelRegister("gxZpm", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";

var $6ZWSX = parcelRequire("6ZWSX");
var $c0bf5cc3997d5bb7$require$Buffer = $6ZWSX.Buffer;

var $ioRHp = parcelRequire("ioRHp");
var $c0bf5cc3997d5bb7$require$Transform = $ioRHp.Transform;

var $gymho = parcelRequire("gymho");

var $N7Lcz = parcelRequire("N7Lcz");

var $aLUwE = parcelRequire("aLUwE");
var $c0bf5cc3997d5bb7$require$assert = $aLUwE.ok;

var $6ZWSX = parcelRequire("6ZWSX");
var $c0bf5cc3997d5bb7$require$kMaxLength = $6ZWSX.kMaxLength;
var $c0bf5cc3997d5bb7$var$kRangeErrorMessage = "Cannot create final Buffer. It would be larger than 0x" + $c0bf5cc3997d5bb7$require$kMaxLength.toString(16) + " bytes";
// zlib doesn't provide these, so kludge them in following the same
// const naming scheme zlib uses.
$gymho.Z_MIN_WINDOWBITS = 8;
$gymho.Z_MAX_WINDOWBITS = 15;
$gymho.Z_DEFAULT_WINDOWBITS = 15;
// fewer than 64 bytes per chunk is stupid.
// technically it could work with as few as 8, but even 64 bytes
// is absurdly low.  Usually a MB or more is best.
$gymho.Z_MIN_CHUNK = 64;
$gymho.Z_MAX_CHUNK = Infinity;
$gymho.Z_DEFAULT_CHUNK = 16384;
$gymho.Z_MIN_MEMLEVEL = 1;
$gymho.Z_MAX_MEMLEVEL = 9;
$gymho.Z_DEFAULT_MEMLEVEL = 8;
$gymho.Z_MIN_LEVEL = -1;
$gymho.Z_MAX_LEVEL = 9;
$gymho.Z_DEFAULT_LEVEL = $gymho.Z_DEFAULT_COMPRESSION;
// expose all the zlib constants
var $c0bf5cc3997d5bb7$var$bkeys = Object.keys($gymho);
for(var $c0bf5cc3997d5bb7$var$bk = 0; $c0bf5cc3997d5bb7$var$bk < $c0bf5cc3997d5bb7$var$bkeys.length; $c0bf5cc3997d5bb7$var$bk++){
    var $c0bf5cc3997d5bb7$var$bkey = $c0bf5cc3997d5bb7$var$bkeys[$c0bf5cc3997d5bb7$var$bk];
    if ($c0bf5cc3997d5bb7$var$bkey.match(/^Z/)) Object.defineProperty(module.exports, $c0bf5cc3997d5bb7$var$bkey, {
        enumerable: true,
        value: $gymho[$c0bf5cc3997d5bb7$var$bkey],
        writable: false
    });
}
// translation table for return codes.
var $c0bf5cc3997d5bb7$var$codes = {
    Z_OK: $gymho.Z_OK,
    Z_STREAM_END: $gymho.Z_STREAM_END,
    Z_NEED_DICT: $gymho.Z_NEED_DICT,
    Z_ERRNO: $gymho.Z_ERRNO,
    Z_STREAM_ERROR: $gymho.Z_STREAM_ERROR,
    Z_DATA_ERROR: $gymho.Z_DATA_ERROR,
    Z_MEM_ERROR: $gymho.Z_MEM_ERROR,
    Z_BUF_ERROR: $gymho.Z_BUF_ERROR,
    Z_VERSION_ERROR: $gymho.Z_VERSION_ERROR
};
var $c0bf5cc3997d5bb7$var$ckeys = Object.keys($c0bf5cc3997d5bb7$var$codes);
for(var $c0bf5cc3997d5bb7$var$ck = 0; $c0bf5cc3997d5bb7$var$ck < $c0bf5cc3997d5bb7$var$ckeys.length; $c0bf5cc3997d5bb7$var$ck++){
    var $c0bf5cc3997d5bb7$var$ckey = $c0bf5cc3997d5bb7$var$ckeys[$c0bf5cc3997d5bb7$var$ck];
    $c0bf5cc3997d5bb7$var$codes[$c0bf5cc3997d5bb7$var$codes[$c0bf5cc3997d5bb7$var$ckey]] = $c0bf5cc3997d5bb7$var$ckey;
}
Object.defineProperty(module.exports, "codes", {
    enumerable: true,
    value: Object.freeze($c0bf5cc3997d5bb7$var$codes),
    writable: false
});
module.exports.Deflate = $c0bf5cc3997d5bb7$var$Deflate;
module.exports.Inflate = $c0bf5cc3997d5bb7$var$Inflate;
module.exports.Gzip = $c0bf5cc3997d5bb7$var$Gzip;
module.exports.Gunzip = $c0bf5cc3997d5bb7$var$Gunzip;
module.exports.DeflateRaw = $c0bf5cc3997d5bb7$var$DeflateRaw;
module.exports.InflateRaw = $c0bf5cc3997d5bb7$var$InflateRaw;
module.exports.Unzip = $c0bf5cc3997d5bb7$var$Unzip;
module.exports.createDeflate = function(o) {
    return new $c0bf5cc3997d5bb7$var$Deflate(o);
};
module.exports.createInflate = function(o) {
    return new $c0bf5cc3997d5bb7$var$Inflate(o);
};
module.exports.createDeflateRaw = function(o) {
    return new $c0bf5cc3997d5bb7$var$DeflateRaw(o);
};
module.exports.createInflateRaw = function(o) {
    return new $c0bf5cc3997d5bb7$var$InflateRaw(o);
};
module.exports.createGzip = function(o) {
    return new $c0bf5cc3997d5bb7$var$Gzip(o);
};
module.exports.createGunzip = function(o) {
    return new $c0bf5cc3997d5bb7$var$Gunzip(o);
};
module.exports.createUnzip = function(o) {
    return new $c0bf5cc3997d5bb7$var$Unzip(o);
};
// Convenience methods.
// compress/decompress a string or buffer in one step.
module.exports.deflate = function(buffer, opts, callback) {
    if (typeof opts === "function") {
        callback = opts;
        opts = {};
    }
    return $c0bf5cc3997d5bb7$var$zlibBuffer(new $c0bf5cc3997d5bb7$var$Deflate(opts), buffer, callback);
};
module.exports.deflateSync = function(buffer, opts) {
    return $c0bf5cc3997d5bb7$var$zlibBufferSync(new $c0bf5cc3997d5bb7$var$Deflate(opts), buffer);
};
module.exports.gzip = function(buffer, opts, callback) {
    if (typeof opts === "function") {
        callback = opts;
        opts = {};
    }
    return $c0bf5cc3997d5bb7$var$zlibBuffer(new $c0bf5cc3997d5bb7$var$Gzip(opts), buffer, callback);
};
module.exports.gzipSync = function(buffer, opts) {
    return $c0bf5cc3997d5bb7$var$zlibBufferSync(new $c0bf5cc3997d5bb7$var$Gzip(opts), buffer);
};
module.exports.deflateRaw = function(buffer, opts, callback) {
    if (typeof opts === "function") {
        callback = opts;
        opts = {};
    }
    return $c0bf5cc3997d5bb7$var$zlibBuffer(new $c0bf5cc3997d5bb7$var$DeflateRaw(opts), buffer, callback);
};
module.exports.deflateRawSync = function(buffer, opts) {
    return $c0bf5cc3997d5bb7$var$zlibBufferSync(new $c0bf5cc3997d5bb7$var$DeflateRaw(opts), buffer);
};
module.exports.unzip = function(buffer, opts, callback) {
    if (typeof opts === "function") {
        callback = opts;
        opts = {};
    }
    return $c0bf5cc3997d5bb7$var$zlibBuffer(new $c0bf5cc3997d5bb7$var$Unzip(opts), buffer, callback);
};
module.exports.unzipSync = function(buffer, opts) {
    return $c0bf5cc3997d5bb7$var$zlibBufferSync(new $c0bf5cc3997d5bb7$var$Unzip(opts), buffer);
};
module.exports.inflate = function(buffer, opts, callback) {
    if (typeof opts === "function") {
        callback = opts;
        opts = {};
    }
    return $c0bf5cc3997d5bb7$var$zlibBuffer(new $c0bf5cc3997d5bb7$var$Inflate(opts), buffer, callback);
};
module.exports.inflateSync = function(buffer, opts) {
    return $c0bf5cc3997d5bb7$var$zlibBufferSync(new $c0bf5cc3997d5bb7$var$Inflate(opts), buffer);
};
module.exports.gunzip = function(buffer, opts, callback) {
    if (typeof opts === "function") {
        callback = opts;
        opts = {};
    }
    return $c0bf5cc3997d5bb7$var$zlibBuffer(new $c0bf5cc3997d5bb7$var$Gunzip(opts), buffer, callback);
};
module.exports.gunzipSync = function(buffer, opts) {
    return $c0bf5cc3997d5bb7$var$zlibBufferSync(new $c0bf5cc3997d5bb7$var$Gunzip(opts), buffer);
};
module.exports.inflateRaw = function(buffer, opts, callback) {
    if (typeof opts === "function") {
        callback = opts;
        opts = {};
    }
    return $c0bf5cc3997d5bb7$var$zlibBuffer(new $c0bf5cc3997d5bb7$var$InflateRaw(opts), buffer, callback);
};
module.exports.inflateRawSync = function(buffer, opts) {
    return $c0bf5cc3997d5bb7$var$zlibBufferSync(new $c0bf5cc3997d5bb7$var$InflateRaw(opts), buffer);
};
function $c0bf5cc3997d5bb7$var$zlibBuffer(engine, buffer, callback) {
    var buffers = [];
    var nread = 0;
    engine.on("error", onError);
    engine.on("end", onEnd);
    engine.end(buffer);
    flow();
    function flow() {
        var chunk;
        while(null !== (chunk = engine.read())){
            buffers.push(chunk);
            nread += chunk.length;
        }
        engine.once("readable", flow);
    }
    function onError(err) {
        engine.removeListener("end", onEnd);
        engine.removeListener("readable", flow);
        callback(err);
    }
    function onEnd() {
        var buf;
        var err = null;
        if (nread >= $c0bf5cc3997d5bb7$require$kMaxLength) err = new RangeError($c0bf5cc3997d5bb7$var$kRangeErrorMessage);
        else buf = $c0bf5cc3997d5bb7$require$Buffer.concat(buffers, nread);
        buffers = [];
        engine.close();
        callback(err, buf);
    }
}
function $c0bf5cc3997d5bb7$var$zlibBufferSync(engine, buffer) {
    if (typeof buffer === "string") buffer = $c0bf5cc3997d5bb7$require$Buffer.from(buffer);
    if (!$c0bf5cc3997d5bb7$require$Buffer.isBuffer(buffer)) throw new TypeError("Not a string or buffer");
    var flushFlag = engine._finishFlushFlag;
    return engine._processChunk(buffer, flushFlag);
}
// generic zlib
// minimal 2-byte header
function $c0bf5cc3997d5bb7$var$Deflate(opts) {
    if (!(this instanceof $c0bf5cc3997d5bb7$var$Deflate)) return new $c0bf5cc3997d5bb7$var$Deflate(opts);
    $c0bf5cc3997d5bb7$var$Zlib.call(this, opts, $gymho.DEFLATE);
}
function $c0bf5cc3997d5bb7$var$Inflate(opts) {
    if (!(this instanceof $c0bf5cc3997d5bb7$var$Inflate)) return new $c0bf5cc3997d5bb7$var$Inflate(opts);
    $c0bf5cc3997d5bb7$var$Zlib.call(this, opts, $gymho.INFLATE);
}
// gzip - bigger header, same deflate compression
function $c0bf5cc3997d5bb7$var$Gzip(opts) {
    if (!(this instanceof $c0bf5cc3997d5bb7$var$Gzip)) return new $c0bf5cc3997d5bb7$var$Gzip(opts);
    $c0bf5cc3997d5bb7$var$Zlib.call(this, opts, $gymho.GZIP);
}
function $c0bf5cc3997d5bb7$var$Gunzip(opts) {
    if (!(this instanceof $c0bf5cc3997d5bb7$var$Gunzip)) return new $c0bf5cc3997d5bb7$var$Gunzip(opts);
    $c0bf5cc3997d5bb7$var$Zlib.call(this, opts, $gymho.GUNZIP);
}
// raw - no header
function $c0bf5cc3997d5bb7$var$DeflateRaw(opts) {
    if (!(this instanceof $c0bf5cc3997d5bb7$var$DeflateRaw)) return new $c0bf5cc3997d5bb7$var$DeflateRaw(opts);
    $c0bf5cc3997d5bb7$var$Zlib.call(this, opts, $gymho.DEFLATERAW);
}
function $c0bf5cc3997d5bb7$var$InflateRaw(opts) {
    if (!(this instanceof $c0bf5cc3997d5bb7$var$InflateRaw)) return new $c0bf5cc3997d5bb7$var$InflateRaw(opts);
    $c0bf5cc3997d5bb7$var$Zlib.call(this, opts, $gymho.INFLATERAW);
}
// auto-detect header.
function $c0bf5cc3997d5bb7$var$Unzip(opts) {
    if (!(this instanceof $c0bf5cc3997d5bb7$var$Unzip)) return new $c0bf5cc3997d5bb7$var$Unzip(opts);
    $c0bf5cc3997d5bb7$var$Zlib.call(this, opts, $gymho.UNZIP);
}
function $c0bf5cc3997d5bb7$var$isValidFlushFlag(flag) {
    return flag === $gymho.Z_NO_FLUSH || flag === $gymho.Z_PARTIAL_FLUSH || flag === $gymho.Z_SYNC_FLUSH || flag === $gymho.Z_FULL_FLUSH || flag === $gymho.Z_FINISH || flag === $gymho.Z_BLOCK;
}
// the Zlib class they all inherit from
// This thing manages the queue of requests, and returns
// true or false if there is anything in the queue when
// you call the .write() method.
function $c0bf5cc3997d5bb7$var$Zlib(opts, mode) {
    var _this = this;
    this._opts = opts = opts || {};
    this._chunkSize = opts.chunkSize || module.exports.Z_DEFAULT_CHUNK;
    $c0bf5cc3997d5bb7$require$Transform.call(this, opts);
    if (opts.flush && !$c0bf5cc3997d5bb7$var$isValidFlushFlag(opts.flush)) throw new Error("Invalid flush flag: " + opts.flush);
    if (opts.finishFlush && !$c0bf5cc3997d5bb7$var$isValidFlushFlag(opts.finishFlush)) throw new Error("Invalid flush flag: " + opts.finishFlush);
    this._flushFlag = opts.flush || $gymho.Z_NO_FLUSH;
    this._finishFlushFlag = typeof opts.finishFlush !== "undefined" ? opts.finishFlush : $gymho.Z_FINISH;
    if (opts.chunkSize) {
        if (opts.chunkSize < module.exports.Z_MIN_CHUNK || opts.chunkSize > module.exports.Z_MAX_CHUNK) throw new Error("Invalid chunk size: " + opts.chunkSize);
    }
    if (opts.windowBits) {
        if (opts.windowBits < module.exports.Z_MIN_WINDOWBITS || opts.windowBits > module.exports.Z_MAX_WINDOWBITS) throw new Error("Invalid windowBits: " + opts.windowBits);
    }
    if (opts.level) {
        if (opts.level < module.exports.Z_MIN_LEVEL || opts.level > module.exports.Z_MAX_LEVEL) throw new Error("Invalid compression level: " + opts.level);
    }
    if (opts.memLevel) {
        if (opts.memLevel < module.exports.Z_MIN_MEMLEVEL || opts.memLevel > module.exports.Z_MAX_MEMLEVEL) throw new Error("Invalid memLevel: " + opts.memLevel);
    }
    if (opts.strategy) {
        if (opts.strategy != module.exports.Z_FILTERED && opts.strategy != module.exports.Z_HUFFMAN_ONLY && opts.strategy != module.exports.Z_RLE && opts.strategy != module.exports.Z_FIXED && opts.strategy != module.exports.Z_DEFAULT_STRATEGY) throw new Error("Invalid strategy: " + opts.strategy);
    }
    if (opts.dictionary) {
        if (!$c0bf5cc3997d5bb7$require$Buffer.isBuffer(opts.dictionary)) throw new Error("Invalid dictionary: it should be a Buffer instance");
    }
    this._handle = new $gymho.Zlib(mode);
    var self = this;
    this._hadError = false;
    this._handle.onerror = function(message, errno) {
        // there is no way to cleanly recover.
        // continuing only obscures problems.
        $c0bf5cc3997d5bb7$var$_close(self);
        self._hadError = true;
        var error = new Error(message);
        error.errno = errno;
        error.code = module.exports.codes[errno];
        self.emit("error", error);
    };
    var level = module.exports.Z_DEFAULT_COMPRESSION;
    if (typeof opts.level === "number") level = opts.level;
    var strategy = module.exports.Z_DEFAULT_STRATEGY;
    if (typeof opts.strategy === "number") strategy = opts.strategy;
    this._handle.init(opts.windowBits || module.exports.Z_DEFAULT_WINDOWBITS, level, opts.memLevel || module.exports.Z_DEFAULT_MEMLEVEL, strategy, opts.dictionary);
    this._buffer = $c0bf5cc3997d5bb7$require$Buffer.allocUnsafe(this._chunkSize);
    this._offset = 0;
    this._level = level;
    this._strategy = strategy;
    this.once("end", this.close);
    Object.defineProperty(this, "_closed", {
        get: function() {
            return !_this._handle;
        },
        configurable: true,
        enumerable: true
    });
}
$N7Lcz.inherits($c0bf5cc3997d5bb7$var$Zlib, $c0bf5cc3997d5bb7$require$Transform);
$c0bf5cc3997d5bb7$var$Zlib.prototype.params = function(level, strategy, callback) {
    if (level < module.exports.Z_MIN_LEVEL || level > module.exports.Z_MAX_LEVEL) throw new RangeError("Invalid compression level: " + level);
    if (strategy != module.exports.Z_FILTERED && strategy != module.exports.Z_HUFFMAN_ONLY && strategy != module.exports.Z_RLE && strategy != module.exports.Z_FIXED && strategy != module.exports.Z_DEFAULT_STRATEGY) throw new TypeError("Invalid strategy: " + strategy);
    if (this._level !== level || this._strategy !== strategy) {
        var self = this;
        this.flush($gymho.Z_SYNC_FLUSH, function() {
            $c0bf5cc3997d5bb7$require$assert(self._handle, "zlib binding closed");
            self._handle.params(level, strategy);
            if (!self._hadError) {
                self._level = level;
                self._strategy = strategy;
                if (callback) callback();
            }
        });
    } else $hPtJY.nextTick(callback);
};
$c0bf5cc3997d5bb7$var$Zlib.prototype.reset = function() {
    $c0bf5cc3997d5bb7$require$assert(this._handle, "zlib binding closed");
    return this._handle.reset();
};
// This is the _flush function called by the transform class,
// internally, when the last chunk has been written.
$c0bf5cc3997d5bb7$var$Zlib.prototype._flush = function(callback) {
    this._transform($c0bf5cc3997d5bb7$require$Buffer.alloc(0), "", callback);
};
$c0bf5cc3997d5bb7$var$Zlib.prototype.flush = function(kind, callback) {
    var _this2 = this;
    var ws = this._writableState;
    if (typeof kind === "function" || kind === undefined && !callback) {
        callback = kind;
        kind = $gymho.Z_FULL_FLUSH;
    }
    if (ws.ended) {
        if (callback) $hPtJY.nextTick(callback);
    } else if (ws.ending) {
        if (callback) this.once("end", callback);
    } else if (ws.needDrain) {
        if (callback) this.once("drain", function() {
            return _this2.flush(kind, callback);
        });
    } else {
        this._flushFlag = kind;
        this.write($c0bf5cc3997d5bb7$require$Buffer.alloc(0), "", callback);
    }
};
$c0bf5cc3997d5bb7$var$Zlib.prototype.close = function(callback) {
    $c0bf5cc3997d5bb7$var$_close(this, callback);
    $hPtJY.nextTick($c0bf5cc3997d5bb7$var$emitCloseNT, this);
};
function $c0bf5cc3997d5bb7$var$_close(engine, callback) {
    if (callback) $hPtJY.nextTick(callback);
    // Caller may invoke .close after a zlib error (which will null _handle).
    if (!engine._handle) return;
    engine._handle.close();
    engine._handle = null;
}
function $c0bf5cc3997d5bb7$var$emitCloseNT(self) {
    self.emit("close");
}
$c0bf5cc3997d5bb7$var$Zlib.prototype._transform = function(chunk, encoding, cb) {
    var flushFlag;
    var ws = this._writableState;
    var ending = ws.ending || ws.ended;
    var last = ending && (!chunk || ws.length === chunk.length);
    if (chunk !== null && !$c0bf5cc3997d5bb7$require$Buffer.isBuffer(chunk)) return cb(new Error("invalid input"));
    if (!this._handle) return cb(new Error("zlib binding closed"));
    // If it's the last chunk, or a final flush, we use the Z_FINISH flush flag
    // (or whatever flag was provided using opts.finishFlush).
    // If it's explicitly flushing at some other time, then we use
    // Z_FULL_FLUSH. Otherwise, use Z_NO_FLUSH for maximum compression
    // goodness.
    if (last) flushFlag = this._finishFlushFlag;
    else {
        flushFlag = this._flushFlag;
        // once we've flushed the last of the queue, stop flushing and
        // go back to the normal behavior.
        if (chunk.length >= ws.length) this._flushFlag = this._opts.flush || $gymho.Z_NO_FLUSH;
    }
    this._processChunk(chunk, flushFlag, cb);
};
$c0bf5cc3997d5bb7$var$Zlib.prototype._processChunk = function(chunk, flushFlag, cb) {
    var availInBefore = chunk && chunk.length;
    var availOutBefore = this._chunkSize - this._offset;
    var inOff = 0;
    var self = this;
    var async = typeof cb === "function";
    if (!async) {
        var buffers = [];
        var nread = 0;
        var error;
        this.on("error", function(er) {
            error = er;
        });
        $c0bf5cc3997d5bb7$require$assert(this._handle, "zlib binding closed");
        do var res = this._handle.writeSync(flushFlag, chunk, inOff, availInBefore, this._buffer, this._offset, availOutBefore); // out_len
        while (!this._hadError && callback(res[0], res[1]));
        if (this._hadError) throw error;
        if (nread >= $c0bf5cc3997d5bb7$require$kMaxLength) {
            $c0bf5cc3997d5bb7$var$_close(this);
            throw new RangeError($c0bf5cc3997d5bb7$var$kRangeErrorMessage);
        }
        var buf = $c0bf5cc3997d5bb7$require$Buffer.concat(buffers, nread);
        $c0bf5cc3997d5bb7$var$_close(this);
        return buf;
    }
    $c0bf5cc3997d5bb7$require$assert(this._handle, "zlib binding closed");
    var req = this._handle.write(flushFlag, chunk, inOff, availInBefore, this._buffer, this._offset, availOutBefore); // out_len
    req.buffer = chunk;
    req.callback = callback;
    function callback(availInAfter, availOutAfter) {
        // When the callback is used in an async write, the callback's
        // context is the `req` object that was created. The req object
        // is === this._handle, and that's why it's important to null
        // out the values after they are done being used. `this._handle`
        // can stay in memory longer than the callback and buffer are needed.
        if (this) {
            this.buffer = null;
            this.callback = null;
        }
        if (self._hadError) return;
        var have = availOutBefore - availOutAfter;
        $c0bf5cc3997d5bb7$require$assert(have >= 0, "have should not go down");
        if (have > 0) {
            var out = self._buffer.slice(self._offset, self._offset + have);
            self._offset += have;
            // serve some output to the consumer.
            if (async) self.push(out);
            else {
                buffers.push(out);
                nread += out.length;
            }
        }
        // exhausted the output buffer, or used all the input create a new one.
        if (availOutAfter === 0 || self._offset >= self._chunkSize) {
            availOutBefore = self._chunkSize;
            self._offset = 0;
            self._buffer = $c0bf5cc3997d5bb7$require$Buffer.allocUnsafe(self._chunkSize);
        }
        if (availOutAfter === 0) {
            // Not actually done.  Need to reprocess.
            // Also, update the availInBefore to the availInAfter value,
            // so that if we have to hit it a third (fourth, etc.) time,
            // it'll have the correct byte counts.
            inOff += availInBefore - availInAfter;
            availInBefore = availInAfter;
            if (!async) return true;
            var newReq = self._handle.write(flushFlag, chunk, inOff, availInBefore, self._buffer, self._offset, self._chunkSize);
            newReq.callback = callback; // this same function
            newReq.buffer = chunk;
            return;
        }
        if (!async) return false;
        // finished with the chunk.
        cb();
    }
};
$N7Lcz.inherits($c0bf5cc3997d5bb7$var$Deflate, $c0bf5cc3997d5bb7$var$Zlib);
$N7Lcz.inherits($c0bf5cc3997d5bb7$var$Inflate, $c0bf5cc3997d5bb7$var$Zlib);
$N7Lcz.inherits($c0bf5cc3997d5bb7$var$Gzip, $c0bf5cc3997d5bb7$var$Zlib);
$N7Lcz.inherits($c0bf5cc3997d5bb7$var$Gunzip, $c0bf5cc3997d5bb7$var$Zlib);
$N7Lcz.inherits($c0bf5cc3997d5bb7$var$DeflateRaw, $c0bf5cc3997d5bb7$var$Zlib);
$N7Lcz.inherits($c0bf5cc3997d5bb7$var$InflateRaw, $c0bf5cc3997d5bb7$var$Zlib);
$N7Lcz.inherits($c0bf5cc3997d5bb7$var$Unzip, $c0bf5cc3997d5bb7$var$Zlib);

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a, (v) => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $51861dfc7ca9d588$export$599f31c3813fae4d, (v) => $51861dfc7ca9d588$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
var $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
var $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        var len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        var buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $51861dfc7ca9d588$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("ioRHp", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $d6541f691ffb0af6$var$Stream;

var $7etJZ = parcelRequire("7etJZ");
var $d6541f691ffb0af6$require$EE = $7etJZ.EventEmitter;

var $dlqwk = parcelRequire("dlqwk");
$dlqwk($d6541f691ffb0af6$var$Stream, $d6541f691ffb0af6$require$EE);

$d6541f691ffb0af6$var$Stream.Readable = (parcelRequire("d4xg3"));

$d6541f691ffb0af6$var$Stream.Writable = (parcelRequire("3LwY7"));

$d6541f691ffb0af6$var$Stream.Duplex = (parcelRequire("DwJuQ"));

$d6541f691ffb0af6$var$Stream.Transform = (parcelRequire("b7kl8"));

$d6541f691ffb0af6$var$Stream.PassThrough = (parcelRequire("4wWcs"));

$d6541f691ffb0af6$var$Stream.finished = (parcelRequire("fiCvv"));

$d6541f691ffb0af6$var$Stream.pipeline = (parcelRequire("aGSwO"));
// Backwards-compat with node 0.4.x
$d6541f691ffb0af6$var$Stream.Stream = $d6541f691ffb0af6$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $d6541f691ffb0af6$var$Stream() {
    $d6541f691ffb0af6$require$EE.call(this);
}
$d6541f691ffb0af6$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on("data", ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on("drain", ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on("end", onend);
        source.on("close", onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === "function") dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($d6541f691ffb0af6$require$EE.listenerCount(this, "error") === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on("error", onerror);
    dest.on("error", onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener("data", ondata);
        dest.removeListener("drain", ondrain);
        source.removeListener("end", onend);
        source.removeListener("close", onclose);
        source.removeListener("error", onerror);
        dest.removeListener("error", onerror);
        source.removeListener("end", cleanup);
        source.removeListener("close", cleanup);
        dest.removeListener("close", cleanup);
    }
    source.on("end", cleanup);
    source.on("close", cleanup);
    dest.on("close", cleanup);
    dest.emit("pipe", source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});
parcelRegister("7etJZ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $5440e9199a418654$var$R = typeof Reflect === "object" ? Reflect : null;
var $5440e9199a418654$var$ReflectApply = $5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.apply === "function" ? $5440e9199a418654$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5440e9199a418654$var$ReflectOwnKeys;
if ($5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.ownKeys === "function") $5440e9199a418654$var$ReflectOwnKeys = $5440e9199a418654$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5440e9199a418654$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5440e9199a418654$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5440e9199a418654$var$EventEmitter() {
    $5440e9199a418654$var$EventEmitter.init.call(this);
}
module.exports = $5440e9199a418654$var$EventEmitter;
module.exports.once = $5440e9199a418654$var$once;
// Backwards-compat with node 0.10.x
$5440e9199a418654$var$EventEmitter.EventEmitter = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$var$EventEmitter.prototype._events = undefined;
$5440e9199a418654$var$EventEmitter.prototype._eventsCount = 0;
$5440e9199a418654$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5440e9199a418654$var$defaultMaxListeners = 10;
function $5440e9199a418654$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5440e9199a418654$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $5440e9199a418654$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $5440e9199a418654$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $5440e9199a418654$var$defaultMaxListeners = arg;
    }
});
$5440e9199a418654$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5440e9199a418654$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $5440e9199a418654$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $5440e9199a418654$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5440e9199a418654$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5440e9199a418654$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5440e9199a418654$var$_getMaxListeners(this);
};
$5440e9199a418654$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $5440e9199a418654$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5440e9199a418654$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5440e9199a418654$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5440e9199a418654$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5440e9199a418654$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5440e9199a418654$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5440e9199a418654$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5440e9199a418654$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, false);
};
$5440e9199a418654$var$EventEmitter.prototype.on = $5440e9199a418654$var$EventEmitter.prototype.addListener;
$5440e9199a418654$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, true);
};
function $5440e9199a418654$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5440e9199a418654$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5440e9199a418654$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5440e9199a418654$var$EventEmitter.prototype.once = function once(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.on(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.prependListener(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5440e9199a418654$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5440e9199a418654$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5440e9199a418654$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.off = $5440e9199a418654$var$EventEmitter.prototype.removeListener;
$5440e9199a418654$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5440e9199a418654$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5440e9199a418654$var$unwrapListeners(evlistener) : $5440e9199a418654$var$arrayClone(evlistener, evlistener.length);
}
$5440e9199a418654$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, true);
};
$5440e9199a418654$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, false);
};
$5440e9199a418654$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $5440e9199a418654$var$listenerCount.call(emitter, type);
};
$5440e9199a418654$var$EventEmitter.prototype.listenerCount = $5440e9199a418654$var$listenerCount;
function $5440e9199a418654$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5440e9199a418654$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5440e9199a418654$var$ReflectOwnKeys(this._events) : [];
};
function $5440e9199a418654$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5440e9199a418654$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5440e9199a418654$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5440e9199a418654$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("dlqwk", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("d4xg3", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $9845726cca5dc7eb$var$Readable;
/*<replacement>*/ var $9845726cca5dc7eb$var$Duplex;
/*</replacement>*/ $9845726cca5dc7eb$var$Readable.ReadableState = $9845726cca5dc7eb$var$ReadableState;

var $7etJZ = parcelRequire("7etJZ");
var $9845726cca5dc7eb$require$EE = $7etJZ.EventEmitter;
var $9845726cca5dc7eb$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $jfAlf = parcelRequire("jfAlf");

var $6ZWSX = parcelRequire("6ZWSX");
var $9845726cca5dc7eb$require$Buffer = $6ZWSX.Buffer;
var $9845726cca5dc7eb$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $9845726cca5dc7eb$var$_uint8ArrayToBuffer(chunk) {
    return $9845726cca5dc7eb$require$Buffer.from(chunk);
}
function $9845726cca5dc7eb$var$_isUint8Array(obj) {
    return $9845726cca5dc7eb$require$Buffer.isBuffer(obj) || obj instanceof $9845726cca5dc7eb$var$OurUint8Array;
}

var $kl1gQ = parcelRequire("kl1gQ");
var $9845726cca5dc7eb$var$debug;
if ($kl1gQ && $kl1gQ.debuglog) $9845726cca5dc7eb$var$debug = $kl1gQ.debuglog("stream");
else $9845726cca5dc7eb$var$debug = function debug() {};

var $bF5dL = parcelRequire("bF5dL");

var $fMCbt = parcelRequire("fMCbt");

var $04a3B = parcelRequire("04a3B");
var $9845726cca5dc7eb$var$getHighWaterMark = $04a3B.getHighWaterMark;

var $6JySE = parcelRequire("6JySE");
var $9845726cca5dc7eb$require$_require$codes = $6JySE.codes;
var $9845726cca5dc7eb$var$ERR_INVALID_ARG_TYPE = $9845726cca5dc7eb$require$_require$codes.ERR_INVALID_ARG_TYPE, $9845726cca5dc7eb$var$ERR_STREAM_PUSH_AFTER_EOF = $9845726cca5dc7eb$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $9845726cca5dc7eb$var$ERR_METHOD_NOT_IMPLEMENTED = $9845726cca5dc7eb$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $9845726cca5dc7eb$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $9845726cca5dc7eb$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $9845726cca5dc7eb$var$StringDecoder;
var $9845726cca5dc7eb$var$createReadableStreamAsyncIterator;
var $9845726cca5dc7eb$var$from;

(parcelRequire("dlqwk"))($9845726cca5dc7eb$var$Readable, $jfAlf);
var $9845726cca5dc7eb$var$errorOrDestroy = $fMCbt.errorOrDestroy;
var $9845726cca5dc7eb$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $9845726cca5dc7eb$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $9845726cca5dc7eb$var$ReadableState(options, stream, isDuplex) {
    $9845726cca5dc7eb$var$Duplex = $9845726cca5dc7eb$var$Duplex || (parcelRequire("DwJuQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $9845726cca5dc7eb$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $9845726cca5dc7eb$var$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $bF5dL();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$9845726cca5dc7eb$var$StringDecoder) $9845726cca5dc7eb$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
        this.decoder = new $9845726cca5dc7eb$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $9845726cca5dc7eb$var$Readable(options) {
    $9845726cca5dc7eb$var$Duplex = $9845726cca5dc7eb$var$Duplex || (parcelRequire("DwJuQ"));
    if (!(this instanceof $9845726cca5dc7eb$var$Readable)) return new $9845726cca5dc7eb$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $9845726cca5dc7eb$var$Duplex;
    this._readableState = new $9845726cca5dc7eb$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $jfAlf.call(this);
}
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$9845726cca5dc7eb$var$Readable.prototype.destroy = $fMCbt.destroy;
$9845726cca5dc7eb$var$Readable.prototype._undestroy = $fMCbt.undestroy;
$9845726cca5dc7eb$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$9845726cca5dc7eb$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $9845726cca5dc7eb$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $9845726cca5dc7eb$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$9845726cca5dc7eb$var$Readable.prototype.unshift = function(chunk) {
    return $9845726cca5dc7eb$var$readableAddChunk(this, chunk, null, true, false);
};
function $9845726cca5dc7eb$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $9845726cca5dc7eb$var$debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $9845726cca5dc7eb$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $9845726cca5dc7eb$var$chunkInvalid(state, chunk);
        if (er) $9845726cca5dc7eb$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $9845726cca5dc7eb$require$Buffer.prototype) chunk = $9845726cca5dc7eb$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $9845726cca5dc7eb$var$errorOrDestroy(stream, new $9845726cca5dc7eb$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $9845726cca5dc7eb$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $9845726cca5dc7eb$var$errorOrDestroy(stream, new $9845726cca5dc7eb$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $9845726cca5dc7eb$var$addChunk(stream, state, chunk, false);
                    else $9845726cca5dc7eb$var$maybeReadMore(stream, state);
                } else $9845726cca5dc7eb$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $9845726cca5dc7eb$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $9845726cca5dc7eb$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $9845726cca5dc7eb$var$emitReadable(stream);
    }
    $9845726cca5dc7eb$var$maybeReadMore(stream, state);
}
function $9845726cca5dc7eb$var$chunkInvalid(state, chunk) {
    var er;
    if (!$9845726cca5dc7eb$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new $9845726cca5dc7eb$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
$9845726cca5dc7eb$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$9845726cca5dc7eb$var$Readable.prototype.setEncoding = function(enc) {
    if (!$9845726cca5dc7eb$var$StringDecoder) $9845726cca5dc7eb$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
    var decoder = new $9845726cca5dc7eb$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $9845726cca5dc7eb$var$MAX_HWM = 0x40000000;
function $9845726cca5dc7eb$var$computeNewHighWaterMark(n) {
    if (n >= $9845726cca5dc7eb$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $9845726cca5dc7eb$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $9845726cca5dc7eb$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$9845726cca5dc7eb$var$Readable.prototype.read = function(n) {
    $9845726cca5dc7eb$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $9845726cca5dc7eb$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $9845726cca5dc7eb$var$endReadable(this);
        else $9845726cca5dc7eb$var$emitReadable(this);
        return null;
    }
    n = $9845726cca5dc7eb$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $9845726cca5dc7eb$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $9845726cca5dc7eb$var$debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $9845726cca5dc7eb$var$debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $9845726cca5dc7eb$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $9845726cca5dc7eb$var$debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $9845726cca5dc7eb$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $9845726cca5dc7eb$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $9845726cca5dc7eb$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $9845726cca5dc7eb$var$onEofChunk(stream, state) {
    $9845726cca5dc7eb$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $9845726cca5dc7eb$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $9845726cca5dc7eb$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $9845726cca5dc7eb$var$emitReadable(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $9845726cca5dc7eb$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$emitReadable_, stream);
    }
}
function $9845726cca5dc7eb$var$emitReadable_(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $9845726cca5dc7eb$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $9845726cca5dc7eb$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$maybeReadMore_, stream, state);
    }
}
function $9845726cca5dc7eb$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $9845726cca5dc7eb$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$9845726cca5dc7eb$var$Readable.prototype._read = function(n) {
    $9845726cca5dc7eb$var$errorOrDestroy(this, new $9845726cca5dc7eb$var$ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
$9845726cca5dc7eb$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $9845726cca5dc7eb$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $hPtJY.stdout && dest !== $hPtJY.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $hPtJY.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $9845726cca5dc7eb$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $9845726cca5dc7eb$var$debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $9845726cca5dc7eb$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $9845726cca5dc7eb$var$debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $9845726cca5dc7eb$var$debug("ondata");
        var ret = dest.write(chunk);
        $9845726cca5dc7eb$var$debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $9845726cca5dc7eb$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $9845726cca5dc7eb$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $9845726cca5dc7eb$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($9845726cca5dc7eb$var$EElistenerCount(dest, "error") === 0) $9845726cca5dc7eb$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $9845726cca5dc7eb$var$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $9845726cca5dc7eb$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $9845726cca5dc7eb$var$debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $9845726cca5dc7eb$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $9845726cca5dc7eb$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $9845726cca5dc7eb$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $9845726cca5dc7eb$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $9845726cca5dc7eb$var$flow(src);
        }
    };
}
$9845726cca5dc7eb$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $9845726cca5dc7eb$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$9845726cca5dc7eb$var$Readable.prototype.on = function(ev, fn) {
    var res = $jfAlf.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $9845726cca5dc7eb$var$debug("on readable", state.length, state.reading);
            if (state.length) $9845726cca5dc7eb$var$emitReadable(this);
            else if (!state.reading) $hPtJY.nextTick($9845726cca5dc7eb$var$nReadingNextTick, this);
        }
    }
    return res;
};
$9845726cca5dc7eb$var$Readable.prototype.addListener = $9845726cca5dc7eb$var$Readable.prototype.on;
$9845726cca5dc7eb$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $jfAlf.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($9845726cca5dc7eb$var$updateReadableListening, this);
    return res;
};
$9845726cca5dc7eb$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $jfAlf.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($9845726cca5dc7eb$var$updateReadableListening, this);
    return res;
};
function $9845726cca5dc7eb$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount("data") > 0) self1.resume();
}
function $9845726cca5dc7eb$var$nReadingNextTick(self1) {
    $9845726cca5dc7eb$var$debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$9845726cca5dc7eb$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $9845726cca5dc7eb$var$debug("resume");
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $9845726cca5dc7eb$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $9845726cca5dc7eb$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$resume_, stream, state);
    }
}
function $9845726cca5dc7eb$var$resume_(stream, state) {
    $9845726cca5dc7eb$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $9845726cca5dc7eb$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$9845726cca5dc7eb$var$Readable.prototype.pause = function() {
    $9845726cca5dc7eb$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $9845726cca5dc7eb$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function $9845726cca5dc7eb$var$flow(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$9845726cca5dc7eb$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $9845726cca5dc7eb$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $9845726cca5dc7eb$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $9845726cca5dc7eb$var$kProxyEvents.length; n++)stream.on($9845726cca5dc7eb$var$kProxyEvents[n], this.emit.bind(this, $9845726cca5dc7eb$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $9845726cca5dc7eb$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === "function") $9845726cca5dc7eb$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($9845726cca5dc7eb$var$createReadableStreamAsyncIterator === undefined) $9845726cca5dc7eb$var$createReadableStreamAsyncIterator = (parcelRequire("2UdT6"));
    return $9845726cca5dc7eb$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$9845726cca5dc7eb$var$Readable._fromList = $9845726cca5dc7eb$var$fromList;
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $9845726cca5dc7eb$var$endReadable(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$endReadableNT, state, stream);
    }
}
function $9845726cca5dc7eb$var$endReadableNT(state, stream) {
    $9845726cca5dc7eb$var$debug("endReadableNT", state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === "function") $9845726cca5dc7eb$var$Readable.from = function(iterable, opts) {
    if ($9845726cca5dc7eb$var$from === undefined) $9845726cca5dc7eb$var$from = (parcelRequire("e6P81"));
    return $9845726cca5dc7eb$var$from($9845726cca5dc7eb$var$Readable, iterable, opts);
};
function $9845726cca5dc7eb$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("jfAlf", function(module, exports) {

module.exports = (parcelRequire("7etJZ")).EventEmitter;

});

parcelRegister("kl1gQ", function(module, exports) {
"use strict";

});

parcelRegister("bF5dL", function(module, exports) {
"use strict";
function $87d792cd1b95f90e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $87d792cd1b95f90e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $87d792cd1b95f90e$var$ownKeys(Object(source), !0).forEach(function(key) {
            $87d792cd1b95f90e$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $87d792cd1b95f90e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $87d792cd1b95f90e$var$_defineProperty(obj, key, value) {
    key = $87d792cd1b95f90e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $87d792cd1b95f90e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $87d792cd1b95f90e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $87d792cd1b95f90e$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $87d792cd1b95f90e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $87d792cd1b95f90e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $87d792cd1b95f90e$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $87d792cd1b95f90e$var$_toPropertyKey(arg) {
    var key = $87d792cd1b95f90e$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $87d792cd1b95f90e$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $6ZWSX = parcelRequire("6ZWSX");
var $87d792cd1b95f90e$var$Buffer = $6ZWSX.Buffer;

var $kl1gQ = parcelRequire("kl1gQ");
var $87d792cd1b95f90e$var$inspect = $kl1gQ.inspect;
var $87d792cd1b95f90e$var$custom = $87d792cd1b95f90e$var$inspect && $87d792cd1b95f90e$var$inspect.custom || "inspect";
function $87d792cd1b95f90e$var$copyBuffer(src, target, offset) {
    $87d792cd1b95f90e$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $87d792cd1b95f90e$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $87d792cd1b95f90e$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $87d792cd1b95f90e$var$Buffer.alloc(0);
                var ret = $87d792cd1b95f90e$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $87d792cd1b95f90e$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $87d792cd1b95f90e$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $87d792cd1b95f90e$var$custom,
            value: function value(_, options) {
                return $87d792cd1b95f90e$var$inspect(this, $87d792cd1b95f90e$var$_objectSpread($87d792cd1b95f90e$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("fMCbt", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
// undocumented cb() API, needed for core, not for public API
function $b7d8f541ca4a3ff5$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorAndCloseNT, _this, err);
            } else $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitCloseNT, _this);
        } else if (cb) {
            $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitCloseNT, _this);
            cb(err);
        } else $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitCloseNT, _this);
    });
    return this;
}
function $b7d8f541ca4a3ff5$var$emitErrorAndCloseNT(self, err) {
    $b7d8f541ca4a3ff5$var$emitErrorNT(self, err);
    $b7d8f541ca4a3ff5$var$emitCloseNT(self);
}
function $b7d8f541ca4a3ff5$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function $b7d8f541ca4a3ff5$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $b7d8f541ca4a3ff5$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
function $b7d8f541ca4a3ff5$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: $b7d8f541ca4a3ff5$var$destroy,
    undestroy: $b7d8f541ca4a3ff5$var$undestroy,
    errorOrDestroy: $b7d8f541ca4a3ff5$var$errorOrDestroy
};

});

parcelRegister("04a3B", function(module, exports) {
"use strict";

var $00c82cf8dac417cf$var$ERR_INVALID_OPT_VALUE = (parcelRequire("6JySE")).codes.ERR_INVALID_OPT_VALUE;
function $00c82cf8dac417cf$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $00c82cf8dac417cf$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $00c82cf8dac417cf$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new $00c82cf8dac417cf$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $00c82cf8dac417cf$var$getHighWaterMark
};

});
parcelRegister("6JySE", function(module, exports) {

$parcel$export(module.exports, "codes", () => $4e720097bc0bc9d8$export$e45cb6485273080e, (v) => $4e720097bc0bc9d8$export$e45cb6485273080e = v);
var $4e720097bc0bc9d8$export$e45cb6485273080e;
"use strict";
function $4e720097bc0bc9d8$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $4e720097bc0bc9d8$var$codes = {};
function $4e720097bc0bc9d8$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $4e720097bc0bc9d8$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $4e720097bc0bc9d8$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $4e720097bc0bc9d8$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $4e720097bc0bc9d8$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $4e720097bc0bc9d8$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $4e720097bc0bc9d8$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$4e720097bc0bc9d8$var$createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$4e720097bc0bc9d8$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $4e720097bc0bc9d8$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($4e720097bc0bc9d8$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($4e720097bc0bc9d8$var$oneOf(expected, "type"));
    else {
        var type = $4e720097bc0bc9d8$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($4e720097bc0bc9d8$var$oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
$4e720097bc0bc9d8$var$createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
$4e720097bc0bc9d8$var$createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$4e720097bc0bc9d8$var$createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
$4e720097bc0bc9d8$export$e45cb6485273080e = $4e720097bc0bc9d8$var$codes;

});


parcelRegister("DwJuQ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
/*<replacement>*/ var $076d08b0309449dc$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $076d08b0309449dc$var$Duplex;

var $d4xg3 = parcelRequire("d4xg3");

var $3LwY7 = parcelRequire("3LwY7");

(parcelRequire("dlqwk"))($076d08b0309449dc$var$Duplex, $d4xg3);
// Allow the keys array to be GC'ed.
var $076d08b0309449dc$var$keys = $076d08b0309449dc$var$objectKeys($3LwY7.prototype);
for(var $076d08b0309449dc$var$v = 0; $076d08b0309449dc$var$v < $076d08b0309449dc$var$keys.length; $076d08b0309449dc$var$v++){
    var $076d08b0309449dc$var$method = $076d08b0309449dc$var$keys[$076d08b0309449dc$var$v];
    if (!$076d08b0309449dc$var$Duplex.prototype[$076d08b0309449dc$var$method]) $076d08b0309449dc$var$Duplex.prototype[$076d08b0309449dc$var$method] = $3LwY7.prototype[$076d08b0309449dc$var$method];
}
function $076d08b0309449dc$var$Duplex(options) {
    if (!(this instanceof $076d08b0309449dc$var$Duplex)) return new $076d08b0309449dc$var$Duplex(options);
    $d4xg3.call(this, options);
    $3LwY7.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", $076d08b0309449dc$var$onend);
        }
    }
}
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $076d08b0309449dc$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $hPtJY.nextTick($076d08b0309449dc$var$onEndNT, this);
}
function $076d08b0309449dc$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("3LwY7", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $2bdf55c2c4f390d3$var$Writable;
/* <replacement> */ function $2bdf55c2c4f390d3$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $2bdf55c2c4f390d3$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $2bdf55c2c4f390d3$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $2bdf55c2c4f390d3$var$Duplex;
/*</replacement>*/ $2bdf55c2c4f390d3$var$Writable.WritableState = $2bdf55c2c4f390d3$var$WritableState;

/*<replacement>*/ var $2bdf55c2c4f390d3$var$internalUtil = {
    deprecate: (parcelRequire("39vsn"))
};

var $jfAlf = parcelRequire("jfAlf");

var $6ZWSX = parcelRequire("6ZWSX");
var $2bdf55c2c4f390d3$require$Buffer = $6ZWSX.Buffer;
var $2bdf55c2c4f390d3$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $2bdf55c2c4f390d3$var$_uint8ArrayToBuffer(chunk) {
    return $2bdf55c2c4f390d3$require$Buffer.from(chunk);
}
function $2bdf55c2c4f390d3$var$_isUint8Array(obj) {
    return $2bdf55c2c4f390d3$require$Buffer.isBuffer(obj) || obj instanceof $2bdf55c2c4f390d3$var$OurUint8Array;
}

var $fMCbt = parcelRequire("fMCbt");

var $04a3B = parcelRequire("04a3B");
var $2bdf55c2c4f390d3$var$getHighWaterMark = $04a3B.getHighWaterMark;

var $6JySE = parcelRequire("6JySE");
var $2bdf55c2c4f390d3$require$_require$codes = $6JySE.codes;
var $2bdf55c2c4f390d3$var$ERR_INVALID_ARG_TYPE = $2bdf55c2c4f390d3$require$_require$codes.ERR_INVALID_ARG_TYPE, $2bdf55c2c4f390d3$var$ERR_METHOD_NOT_IMPLEMENTED = $2bdf55c2c4f390d3$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $2bdf55c2c4f390d3$var$ERR_MULTIPLE_CALLBACK = $2bdf55c2c4f390d3$require$_require$codes.ERR_MULTIPLE_CALLBACK, $2bdf55c2c4f390d3$var$ERR_STREAM_CANNOT_PIPE = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $2bdf55c2c4f390d3$var$ERR_STREAM_DESTROYED = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_DESTROYED, $2bdf55c2c4f390d3$var$ERR_STREAM_NULL_VALUES = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_NULL_VALUES, $2bdf55c2c4f390d3$var$ERR_STREAM_WRITE_AFTER_END = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $2bdf55c2c4f390d3$var$ERR_UNKNOWN_ENCODING = $2bdf55c2c4f390d3$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $2bdf55c2c4f390d3$var$errorOrDestroy = $fMCbt.errorOrDestroy;

(parcelRequire("dlqwk"))($2bdf55c2c4f390d3$var$Writable, $jfAlf);
function $2bdf55c2c4f390d3$var$nop() {}

function $2bdf55c2c4f390d3$var$WritableState(options, stream, isDuplex) {
    $2bdf55c2c4f390d3$var$Duplex = $2bdf55c2c4f390d3$var$Duplex || (parcelRequire("DwJuQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $2bdf55c2c4f390d3$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $2bdf55c2c4f390d3$var$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $2bdf55c2c4f390d3$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $2bdf55c2c4f390d3$var$CorkedRequest(this);
}
$2bdf55c2c4f390d3$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($2bdf55c2c4f390d3$var$WritableState.prototype, "buffer", {
            get: $2bdf55c2c4f390d3$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $2bdf55c2c4f390d3$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $2bdf55c2c4f390d3$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($2bdf55c2c4f390d3$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($2bdf55c2c4f390d3$var$realHasInstance.call(this, object)) return true;
            if (this !== $2bdf55c2c4f390d3$var$Writable) return false;
            return object && object._writableState instanceof $2bdf55c2c4f390d3$var$WritableState;
        }
    });
} else $2bdf55c2c4f390d3$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $2bdf55c2c4f390d3$var$Writable(options) {
    $2bdf55c2c4f390d3$var$Duplex = $2bdf55c2c4f390d3$var$Duplex || (parcelRequire("DwJuQ"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $2bdf55c2c4f390d3$var$Duplex;
    if (!isDuplex && !$2bdf55c2c4f390d3$var$realHasInstance.call($2bdf55c2c4f390d3$var$Writable, this)) return new $2bdf55c2c4f390d3$var$Writable(options);
    this._writableState = new $2bdf55c2c4f390d3$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $jfAlf.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$2bdf55c2c4f390d3$var$Writable.prototype.pipe = function() {
    $2bdf55c2c4f390d3$var$errorOrDestroy(this, new $2bdf55c2c4f390d3$var$ERR_STREAM_CANNOT_PIPE());
};
function $2bdf55c2c4f390d3$var$writeAfterEnd(stream, cb) {
    var er = new $2bdf55c2c4f390d3$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
    $hPtJY.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $2bdf55c2c4f390d3$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $2bdf55c2c4f390d3$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new $2bdf55c2c4f390d3$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
        $hPtJY.nextTick(cb, er);
        return false;
    }
    return true;
}
$2bdf55c2c4f390d3$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $2bdf55c2c4f390d3$var$_isUint8Array(chunk);
    if (isBuf && !$2bdf55c2c4f390d3$require$Buffer.isBuffer(chunk)) chunk = $2bdf55c2c4f390d3$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $2bdf55c2c4f390d3$var$nop;
    if (state.ending) $2bdf55c2c4f390d3$var$writeAfterEnd(this, cb);
    else if (isBuf || $2bdf55c2c4f390d3$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $2bdf55c2c4f390d3$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$2bdf55c2c4f390d3$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$2bdf55c2c4f390d3$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2bdf55c2c4f390d3$var$clearBuffer(this, state);
    }
};
$2bdf55c2c4f390d3$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new $2bdf55c2c4f390d3$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $2bdf55c2c4f390d3$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $2bdf55c2c4f390d3$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $2bdf55c2c4f390d3$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $2bdf55c2c4f390d3$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $2bdf55c2c4f390d3$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $2bdf55c2c4f390d3$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $2bdf55c2c4f390d3$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $2bdf55c2c4f390d3$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $hPtJY.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $hPtJY.nextTick($2bdf55c2c4f390d3$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    }
}
function $2bdf55c2c4f390d3$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $2bdf55c2c4f390d3$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new $2bdf55c2c4f390d3$var$ERR_MULTIPLE_CALLBACK();
    $2bdf55c2c4f390d3$var$onwriteStateUpdate(state);
    if (er) $2bdf55c2c4f390d3$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $2bdf55c2c4f390d3$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2bdf55c2c4f390d3$var$clearBuffer(stream, state);
        if (sync) $hPtJY.nextTick($2bdf55c2c4f390d3$var$afterWrite, stream, state, finished, cb);
        else $2bdf55c2c4f390d3$var$afterWrite(stream, state, finished, cb);
    }
}
function $2bdf55c2c4f390d3$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $2bdf55c2c4f390d3$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $2bdf55c2c4f390d3$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function $2bdf55c2c4f390d3$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $2bdf55c2c4f390d3$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $2bdf55c2c4f390d3$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $2bdf55c2c4f390d3$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$2bdf55c2c4f390d3$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $2bdf55c2c4f390d3$var$ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
$2bdf55c2c4f390d3$var$Writable.prototype._writev = null;
$2bdf55c2c4f390d3$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $2bdf55c2c4f390d3$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $2bdf55c2c4f390d3$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $2bdf55c2c4f390d3$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $2bdf55c2c4f390d3$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    });
}
function $2bdf55c2c4f390d3$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $hPtJY.nextTick($2bdf55c2c4f390d3$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $2bdf55c2c4f390d3$var$finishMaybe(stream, state) {
    var need = $2bdf55c2c4f390d3$var$needFinish(state);
    if (need) {
        $2bdf55c2c4f390d3$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $2bdf55c2c4f390d3$var$endWritable(stream, state, cb) {
    state.ending = true;
    $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $hPtJY.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $2bdf55c2c4f390d3$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$2bdf55c2c4f390d3$var$Writable.prototype.destroy = $fMCbt.destroy;
$2bdf55c2c4f390d3$var$Writable.prototype._undestroy = $fMCbt.undestroy;
$2bdf55c2c4f390d3$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("39vsn", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $24ba9cfc39d77116$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $24ba9cfc39d77116$var$deprecate(fn, msg) {
    if ($24ba9cfc39d77116$var$config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($24ba9cfc39d77116$var$config("throwDeprecation")) throw new Error(msg);
            else if ($24ba9cfc39d77116$var$config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $24ba9cfc39d77116$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}

});



parcelRegister("eNRCS", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $ac6f3d51130904be$export$63a7aa211a91ed69, (v) => $ac6f3d51130904be$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $ac6f3d51130904be$export$63a7aa211a91ed69;
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $ac6f3d51130904be$require$Buffer = $1U9GM.Buffer;
/*</replacement>*/ var $ac6f3d51130904be$var$isEncoding = $ac6f3d51130904be$require$Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function $ac6f3d51130904be$var$_normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $ac6f3d51130904be$var$normalizeEncoding(enc) {
    var nenc = $ac6f3d51130904be$var$_normalizeEncoding(enc);
    if (typeof nenc !== "string" && ($ac6f3d51130904be$require$Buffer.isEncoding === $ac6f3d51130904be$var$isEncoding || !$ac6f3d51130904be$var$isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
$ac6f3d51130904be$export$63a7aa211a91ed69 = $ac6f3d51130904be$var$StringDecoder;
function $ac6f3d51130904be$var$StringDecoder(encoding) {
    this.encoding = $ac6f3d51130904be$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = $ac6f3d51130904be$var$utf16Text;
            this.end = $ac6f3d51130904be$var$utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = $ac6f3d51130904be$var$utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = $ac6f3d51130904be$var$base64Text;
            this.end = $ac6f3d51130904be$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $ac6f3d51130904be$var$simpleWrite;
            this.end = $ac6f3d51130904be$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $ac6f3d51130904be$require$Buffer.allocUnsafe(nb);
}
$ac6f3d51130904be$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
$ac6f3d51130904be$var$StringDecoder.prototype.end = $ac6f3d51130904be$var$utf8End;
// Returns only complete characters in a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.text = $ac6f3d51130904be$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $ac6f3d51130904be$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $ac6f3d51130904be$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $ac6f3d51130904be$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "\uFFFD";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "\uFFFD";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "\uFFFD";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $ac6f3d51130904be$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $ac6f3d51130904be$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $ac6f3d51130904be$var$utf8Text(buf, i) {
    var total = $ac6f3d51130904be$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $ac6f3d51130904be$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "\uFFFD";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $ac6f3d51130904be$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $ac6f3d51130904be$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function $ac6f3d51130904be$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function $ac6f3d51130904be$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $ac6f3d51130904be$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $ac6f3d51130904be$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

});
parcelRegister("1U9GM", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $1632896ed805433d$var$Buffer = $6ZWSX.Buffer;
// alternative to using Object.keys for old browsers
function $1632896ed805433d$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($1632896ed805433d$var$Buffer.from && $1632896ed805433d$var$Buffer.alloc && $1632896ed805433d$var$Buffer.allocUnsafe && $1632896ed805433d$var$Buffer.allocUnsafeSlow) module.exports = $6ZWSX;
else {
    // Copy properties from require('buffer')
    $1632896ed805433d$var$copyProps($6ZWSX, module.exports);
    module.exports.Buffer = $1632896ed805433d$var$SafeBuffer;
}
function $1632896ed805433d$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
}
$1632896ed805433d$var$SafeBuffer.prototype = Object.create($1632896ed805433d$var$Buffer.prototype);
// Copy static methods from Buffer
$1632896ed805433d$var$copyProps($1632896ed805433d$var$Buffer, $1632896ed805433d$var$SafeBuffer);
$1632896ed805433d$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
};
$1632896ed805433d$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $1632896ed805433d$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$1632896ed805433d$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $1632896ed805433d$var$Buffer(size);
};
$1632896ed805433d$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $6ZWSX.SlowBuffer(size);
};

});


parcelRegister("2UdT6", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
var $21db958e3a099d7d$var$_Object$setPrototypeO;
function $21db958e3a099d7d$var$_defineProperty(obj, key, value) {
    key = $21db958e3a099d7d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $21db958e3a099d7d$var$_toPropertyKey(arg) {
    var key = $21db958e3a099d7d$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $21db958e3a099d7d$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $fiCvv = parcelRequire("fiCvv");
var $21db958e3a099d7d$var$kLastResolve = Symbol("lastResolve");
var $21db958e3a099d7d$var$kLastReject = Symbol("lastReject");
var $21db958e3a099d7d$var$kError = Symbol("error");
var $21db958e3a099d7d$var$kEnded = Symbol("ended");
var $21db958e3a099d7d$var$kLastPromise = Symbol("lastPromise");
var $21db958e3a099d7d$var$kHandlePromise = Symbol("handlePromise");
var $21db958e3a099d7d$var$kStream = Symbol("stream");
function $21db958e3a099d7d$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $21db958e3a099d7d$var$readAndResolve(iter) {
    var resolve = iter[$21db958e3a099d7d$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$21db958e3a099d7d$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$21db958e3a099d7d$var$kLastPromise] = null;
            iter[$21db958e3a099d7d$var$kLastResolve] = null;
            iter[$21db958e3a099d7d$var$kLastReject] = null;
            resolve($21db958e3a099d7d$var$createIterResult(data, false));
        }
    }
}
function $21db958e3a099d7d$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $hPtJY.nextTick($21db958e3a099d7d$var$readAndResolve, iter);
}
function $21db958e3a099d7d$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$21db958e3a099d7d$var$kEnded]) {
                resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
                return;
            }
            iter[$21db958e3a099d7d$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $21db958e3a099d7d$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $21db958e3a099d7d$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($21db958e3a099d7d$var$_Object$setPrototypeO = {
    get stream () {
        return this[$21db958e3a099d7d$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$21db958e3a099d7d$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$21db958e3a099d7d$var$kEnded]) return Promise.resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
        if (this[$21db958e3a099d7d$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $hPtJY.nextTick(function() {
                if (_this[$21db958e3a099d7d$var$kError]) reject(_this[$21db958e3a099d7d$var$kError]);
                else resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$21db958e3a099d7d$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($21db958e3a099d7d$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$21db958e3a099d7d$var$kStream].read();
            if (data !== null) return Promise.resolve($21db958e3a099d7d$var$createIterResult(data, false));
            promise = new Promise(this[$21db958e3a099d7d$var$kHandlePromise]);
        }
        this[$21db958e3a099d7d$var$kLastPromise] = promise;
        return promise;
    }
}, $21db958e3a099d7d$var$_defineProperty($21db958e3a099d7d$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $21db958e3a099d7d$var$_defineProperty($21db958e3a099d7d$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$21db958e3a099d7d$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
        });
    });
}), $21db958e3a099d7d$var$_Object$setPrototypeO), $21db958e3a099d7d$var$AsyncIteratorPrototype);
var $21db958e3a099d7d$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($21db958e3a099d7d$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kStream, {
        value: stream,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kLastResolve, {
        value: null,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kLastReject, {
        value: null,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kError, {
        value: null,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$21db958e3a099d7d$var$kStream].read();
            if (data) {
                iterator[$21db958e3a099d7d$var$kLastPromise] = null;
                iterator[$21db958e3a099d7d$var$kLastResolve] = null;
                iterator[$21db958e3a099d7d$var$kLastReject] = null;
                resolve($21db958e3a099d7d$var$createIterResult(data, false));
            } else {
                iterator[$21db958e3a099d7d$var$kLastResolve] = resolve;
                iterator[$21db958e3a099d7d$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$21db958e3a099d7d$var$kLastPromise] = null;
    $fiCvv(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[$21db958e3a099d7d$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$21db958e3a099d7d$var$kLastPromise] = null;
                iterator[$21db958e3a099d7d$var$kLastResolve] = null;
                iterator[$21db958e3a099d7d$var$kLastReject] = null;
                reject(err);
            }
            iterator[$21db958e3a099d7d$var$kError] = err;
            return;
        }
        var resolve = iterator[$21db958e3a099d7d$var$kLastResolve];
        if (resolve !== null) {
            iterator[$21db958e3a099d7d$var$kLastPromise] = null;
            iterator[$21db958e3a099d7d$var$kLastResolve] = null;
            iterator[$21db958e3a099d7d$var$kLastReject] = null;
            resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
        }
        iterator[$21db958e3a099d7d$var$kEnded] = true;
    });
    stream.on("readable", $21db958e3a099d7d$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $21db958e3a099d7d$var$createReadableStreamAsyncIterator;

});
parcelRegister("fiCvv", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";

var $b236683171fcb6ee$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("6JySE")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $b236683171fcb6ee$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $b236683171fcb6ee$var$noop() {}
function $b236683171fcb6ee$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function $b236683171fcb6ee$var$eos(stream, opts, callback) {
    if (typeof opts === "function") return $b236683171fcb6ee$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $b236683171fcb6ee$var$once(callback || $b236683171fcb6ee$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $b236683171fcb6ee$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $b236683171fcb6ee$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if ($b236683171fcb6ee$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = $b236683171fcb6ee$var$eos;

});


parcelRegister("e6P81", function(module, exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

});


parcelRegister("b7kl8", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $8180203f7f0d3074$var$Transform;

var $6JySE = parcelRequire("6JySE");
var $8180203f7f0d3074$require$_require$codes = $6JySE.codes;
var $8180203f7f0d3074$var$ERR_METHOD_NOT_IMPLEMENTED = $8180203f7f0d3074$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $8180203f7f0d3074$var$ERR_MULTIPLE_CALLBACK = $8180203f7f0d3074$require$_require$codes.ERR_MULTIPLE_CALLBACK, $8180203f7f0d3074$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $8180203f7f0d3074$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $8180203f7f0d3074$var$ERR_TRANSFORM_WITH_LENGTH_0 = $8180203f7f0d3074$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $DwJuQ = parcelRequire("DwJuQ");

(parcelRequire("dlqwk"))($8180203f7f0d3074$var$Transform, $DwJuQ);
function $8180203f7f0d3074$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new $8180203f7f0d3074$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $8180203f7f0d3074$var$Transform(options) {
    if (!(this instanceof $8180203f7f0d3074$var$Transform)) return new $8180203f7f0d3074$var$Transform(options);
    $DwJuQ.call(this, options);
    this._transformState = {
        afterTransform: $8180203f7f0d3074$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $8180203f7f0d3074$var$prefinish);
}
function $8180203f7f0d3074$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        $8180203f7f0d3074$var$done(_this, er, data);
    });
    else $8180203f7f0d3074$var$done(this, null, null);
}
$8180203f7f0d3074$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $DwJuQ.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$8180203f7f0d3074$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $8180203f7f0d3074$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
$8180203f7f0d3074$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$8180203f7f0d3074$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$8180203f7f0d3074$var$Transform.prototype._destroy = function(err, cb) {
    $DwJuQ.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $8180203f7f0d3074$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $8180203f7f0d3074$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $8180203f7f0d3074$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("4wWcs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $34c74be520d619f2$var$PassThrough;

var $b7kl8 = parcelRequire("b7kl8");

(parcelRequire("dlqwk"))($34c74be520d619f2$var$PassThrough, $b7kl8);
function $34c74be520d619f2$var$PassThrough(options) {
    if (!(this instanceof $34c74be520d619f2$var$PassThrough)) return new $34c74be520d619f2$var$PassThrough(options);
    $b7kl8.call(this, options);
}
$34c74be520d619f2$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("aGSwO", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var $7c881fce7a4fadf1$var$eos;
function $7c881fce7a4fadf1$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $6JySE = parcelRequire("6JySE");
var $7c881fce7a4fadf1$require$_require$codes = $6JySE.codes;
var $7c881fce7a4fadf1$var$ERR_MISSING_ARGS = $7c881fce7a4fadf1$require$_require$codes.ERR_MISSING_ARGS, $7c881fce7a4fadf1$var$ERR_STREAM_DESTROYED = $7c881fce7a4fadf1$require$_require$codes.ERR_STREAM_DESTROYED;
function $7c881fce7a4fadf1$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $7c881fce7a4fadf1$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}

function $7c881fce7a4fadf1$var$destroyer(stream, reading, writing, callback) {
    callback = $7c881fce7a4fadf1$var$once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if ($7c881fce7a4fadf1$var$eos === undefined) $7c881fce7a4fadf1$var$eos = (parcelRequire("fiCvv"));
    $7c881fce7a4fadf1$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($7c881fce7a4fadf1$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new $7c881fce7a4fadf1$var$ERR_STREAM_DESTROYED("pipe"));
    };
}
function $7c881fce7a4fadf1$var$call(fn) {
    fn();
}
function $7c881fce7a4fadf1$var$pipe(from, to) {
    return from.pipe(to);
}
function $7c881fce7a4fadf1$var$popCallback(streams) {
    if (!streams.length) return $7c881fce7a4fadf1$var$noop;
    if (typeof streams[streams.length - 1] !== "function") return $7c881fce7a4fadf1$var$noop;
    return streams.pop();
}
function $7c881fce7a4fadf1$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $7c881fce7a4fadf1$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $7c881fce7a4fadf1$var$ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $7c881fce7a4fadf1$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($7c881fce7a4fadf1$var$call);
            if (reading) return;
            destroys.forEach($7c881fce7a4fadf1$var$call);
            callback(error);
        });
    });
    return streams.reduce($7c881fce7a4fadf1$var$pipe);
}
module.exports = $7c881fce7a4fadf1$var$pipeline;

});


parcelRegister("gymho", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $c0d11a8fc746efbd$require$Buffer = $6ZWSX.Buffer;

var $hPtJY = parcelRequire("hPtJY");
"use strict";

var $aLUwE = parcelRequire("aLUwE");

var $9WDto = parcelRequire("9WDto");

var $lGf86 = parcelRequire("lGf86");

var $fzvBq = parcelRequire("fzvBq");

var $hf4Xu = parcelRequire("hf4Xu");
for(var $c0d11a8fc746efbd$var$key in $hf4Xu)module.exports[$c0d11a8fc746efbd$var$key] = $hf4Xu[$c0d11a8fc746efbd$var$key];
// zlib modes
module.exports.NONE = 0;
module.exports.DEFLATE = 1;
module.exports.INFLATE = 2;
module.exports.GZIP = 3;
module.exports.GUNZIP = 4;
module.exports.DEFLATERAW = 5;
module.exports.INFLATERAW = 6;
module.exports.UNZIP = 7;
var $c0d11a8fc746efbd$var$GZIP_HEADER_ID1 = 0x1f;
var $c0d11a8fc746efbd$var$GZIP_HEADER_ID2 = 0x8b;
/**
 * Emulate Node's zlib C++ layer for use by the JS layer in index.js
 */ function $c0d11a8fc746efbd$var$Zlib(mode) {
    if (typeof mode !== "number" || mode < module.exports.DEFLATE || mode > module.exports.UNZIP) throw new TypeError("Bad argument");
    this.dictionary = null;
    this.err = 0;
    this.flush = 0;
    this.init_done = false;
    this.level = 0;
    this.memLevel = 0;
    this.mode = mode;
    this.strategy = 0;
    this.windowBits = 0;
    this.write_in_progress = false;
    this.pending_close = false;
    this.gzip_id_bytes_read = 0;
}
$c0d11a8fc746efbd$var$Zlib.prototype.close = function() {
    if (this.write_in_progress) {
        this.pending_close = true;
        return;
    }
    this.pending_close = false;
    $aLUwE(this.init_done, "close before init");
    $aLUwE(this.mode <= module.exports.UNZIP);
    if (this.mode === module.exports.DEFLATE || this.mode === module.exports.GZIP || this.mode === module.exports.DEFLATERAW) $lGf86.deflateEnd(this.strm);
    else if (this.mode === module.exports.INFLATE || this.mode === module.exports.GUNZIP || this.mode === module.exports.INFLATERAW || this.mode === module.exports.UNZIP) $fzvBq.inflateEnd(this.strm);
    this.mode = module.exports.NONE;
    this.dictionary = null;
};
$c0d11a8fc746efbd$var$Zlib.prototype.write = function(flush, input, in_off, in_len, out, out_off, out_len) {
    return this._write(true, flush, input, in_off, in_len, out, out_off, out_len);
};
$c0d11a8fc746efbd$var$Zlib.prototype.writeSync = function(flush, input, in_off, in_len, out, out_off, out_len) {
    return this._write(false, flush, input, in_off, in_len, out, out_off, out_len);
};
$c0d11a8fc746efbd$var$Zlib.prototype._write = function(async, flush, input, in_off, in_len, out, out_off, out_len) {
    $aLUwE.equal(arguments.length, 8);
    $aLUwE(this.init_done, "write before init");
    $aLUwE(this.mode !== module.exports.NONE, "already finalized");
    $aLUwE.equal(false, this.write_in_progress, "write already in progress");
    $aLUwE.equal(false, this.pending_close, "close is pending");
    this.write_in_progress = true;
    $aLUwE.equal(false, flush === undefined, "must provide flush value");
    this.write_in_progress = true;
    if (flush !== module.exports.Z_NO_FLUSH && flush !== module.exports.Z_PARTIAL_FLUSH && flush !== module.exports.Z_SYNC_FLUSH && flush !== module.exports.Z_FULL_FLUSH && flush !== module.exports.Z_FINISH && flush !== module.exports.Z_BLOCK) throw new Error("Invalid flush value");
    if (input == null) {
        input = $c0d11a8fc746efbd$require$Buffer.alloc(0);
        in_len = 0;
        in_off = 0;
    }
    this.strm.avail_in = in_len;
    this.strm.input = input;
    this.strm.next_in = in_off;
    this.strm.avail_out = out_len;
    this.strm.output = out;
    this.strm.next_out = out_off;
    this.flush = flush;
    if (!async) {
        // sync version
        this._process();
        if (this._checkError()) return this._afterSync();
        return;
    }
    // async version
    var self = this;
    $hPtJY.nextTick(function() {
        self._process();
        self._after();
    });
    return this;
};
$c0d11a8fc746efbd$var$Zlib.prototype._afterSync = function() {
    var avail_out = this.strm.avail_out;
    var avail_in = this.strm.avail_in;
    this.write_in_progress = false;
    return [
        avail_in,
        avail_out
    ];
};
$c0d11a8fc746efbd$var$Zlib.prototype._process = function() {
    var next_expected_header_byte = null;
    // If the avail_out is left at 0, then it means that it ran out
    // of room.  If there was avail_out left over, then it means
    // that all of the input was consumed.
    switch(this.mode){
        case module.exports.DEFLATE:
        case module.exports.GZIP:
        case module.exports.DEFLATERAW:
            this.err = $lGf86.deflate(this.strm, this.flush);
            break;
        case module.exports.UNZIP:
            if (this.strm.avail_in > 0) next_expected_header_byte = this.strm.next_in;
            switch(this.gzip_id_bytes_read){
                case 0:
                    if (next_expected_header_byte === null) break;
                    if (this.strm.input[next_expected_header_byte] === $c0d11a8fc746efbd$var$GZIP_HEADER_ID1) {
                        this.gzip_id_bytes_read = 1;
                        next_expected_header_byte++;
                        if (this.strm.avail_in === 1) break;
                    } else {
                        this.mode = module.exports.INFLATE;
                        break;
                    }
                // fallthrough
                case 1:
                    if (next_expected_header_byte === null) break;
                    if (this.strm.input[next_expected_header_byte] === $c0d11a8fc746efbd$var$GZIP_HEADER_ID2) {
                        this.gzip_id_bytes_read = 2;
                        this.mode = module.exports.GUNZIP;
                    } else // There is no actual difference between INFLATE and INFLATERAW
                    // (after initialization).
                    this.mode = module.exports.INFLATE;
                    break;
                default:
                    throw new Error("invalid number of gzip magic number bytes read");
            }
        // fallthrough
        case module.exports.INFLATE:
        case module.exports.GUNZIP:
        case module.exports.INFLATERAW:
            this.err = $fzvBq.inflate(this.strm, this.flush);
            if (this.err === module.exports.Z_NEED_DICT && this.dictionary) {
                // Load it
                this.err = $fzvBq.inflateSetDictionary(this.strm, this.dictionary);
                if (this.err === module.exports.Z_OK) // And try to decode again
                this.err = $fzvBq.inflate(this.strm, this.flush);
                else if (this.err === module.exports.Z_DATA_ERROR) // Both inflateSetDictionary() and inflate() return Z_DATA_ERROR.
                // Make it possible for After() to tell a bad dictionary from bad
                // input.
                this.err = module.exports.Z_NEED_DICT;
            }
            while(this.strm.avail_in > 0 && this.mode === module.exports.GUNZIP && this.err === module.exports.Z_STREAM_END && this.strm.next_in[0] !== 0x00){
                // Bytes remain in input buffer. Perhaps this is another compressed
                // member in the same archive, or just trailing garbage.
                // Trailing zero bytes are okay, though, since they are frequently
                // used for padding.
                this.reset();
                this.err = $fzvBq.inflate(this.strm, this.flush);
            }
            break;
        default:
            throw new Error("Unknown mode " + this.mode);
    }
};
$c0d11a8fc746efbd$var$Zlib.prototype._checkError = function() {
    // Acceptable error states depend on the type of zlib stream.
    switch(this.err){
        case module.exports.Z_OK:
        case module.exports.Z_BUF_ERROR:
            if (this.strm.avail_out !== 0 && this.flush === module.exports.Z_FINISH) {
                this._error("unexpected end of file");
                return false;
            }
            break;
        case module.exports.Z_STREAM_END:
            break;
        case module.exports.Z_NEED_DICT:
            if (this.dictionary == null) this._error("Missing dictionary");
            else this._error("Bad dictionary");
            return false;
        default:
            // something else.
            this._error("Zlib error");
            return false;
    }
    return true;
};
$c0d11a8fc746efbd$var$Zlib.prototype._after = function() {
    if (!this._checkError()) return;
    var avail_out = this.strm.avail_out;
    var avail_in = this.strm.avail_in;
    this.write_in_progress = false;
    // call the write() cb
    this.callback(avail_in, avail_out);
    if (this.pending_close) this.close();
};
$c0d11a8fc746efbd$var$Zlib.prototype._error = function(message) {
    if (this.strm.msg) message = this.strm.msg;
    this.onerror(message, this.err);
    this.write_in_progress = false;
    if (this.pending_close) this.close();
};
$c0d11a8fc746efbd$var$Zlib.prototype.init = function(windowBits, level, memLevel, strategy, dictionary) {
    $aLUwE(arguments.length === 4 || arguments.length === 5, "init(windowBits, level, memLevel, strategy, [dictionary])");
    $aLUwE(windowBits >= 8 && windowBits <= 15, "invalid windowBits");
    $aLUwE(level >= -1 && level <= 9, "invalid compression level");
    $aLUwE(memLevel >= 1 && memLevel <= 9, "invalid memlevel");
    $aLUwE(strategy === module.exports.Z_FILTERED || strategy === module.exports.Z_HUFFMAN_ONLY || strategy === module.exports.Z_RLE || strategy === module.exports.Z_FIXED || strategy === module.exports.Z_DEFAULT_STRATEGY, "invalid strategy");
    this._init(level, windowBits, memLevel, strategy, dictionary);
    this._setDictionary();
};
$c0d11a8fc746efbd$var$Zlib.prototype.params = function() {
    throw new Error("deflateParams Not supported");
};
$c0d11a8fc746efbd$var$Zlib.prototype.reset = function() {
    this._reset();
    this._setDictionary();
};
$c0d11a8fc746efbd$var$Zlib.prototype._init = function(level, windowBits, memLevel, strategy, dictionary) {
    this.level = level;
    this.windowBits = windowBits;
    this.memLevel = memLevel;
    this.strategy = strategy;
    this.flush = module.exports.Z_NO_FLUSH;
    this.err = module.exports.Z_OK;
    if (this.mode === module.exports.GZIP || this.mode === module.exports.GUNZIP) this.windowBits += 16;
    if (this.mode === module.exports.UNZIP) this.windowBits += 32;
    if (this.mode === module.exports.DEFLATERAW || this.mode === module.exports.INFLATERAW) this.windowBits = -1 * this.windowBits;
    this.strm = new $9WDto();
    switch(this.mode){
        case module.exports.DEFLATE:
        case module.exports.GZIP:
        case module.exports.DEFLATERAW:
            this.err = $lGf86.deflateInit2(this.strm, this.level, module.exports.Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
            break;
        case module.exports.INFLATE:
        case module.exports.GUNZIP:
        case module.exports.INFLATERAW:
        case module.exports.UNZIP:
            this.err = $fzvBq.inflateInit2(this.strm, this.windowBits);
            break;
        default:
            throw new Error("Unknown mode " + this.mode);
    }
    if (this.err !== module.exports.Z_OK) this._error("Init error");
    this.dictionary = dictionary;
    this.write_in_progress = false;
    this.init_done = true;
};
$c0d11a8fc746efbd$var$Zlib.prototype._setDictionary = function() {
    if (this.dictionary == null) return;
    this.err = module.exports.Z_OK;
    switch(this.mode){
        case module.exports.DEFLATE:
        case module.exports.DEFLATERAW:
            this.err = $lGf86.deflateSetDictionary(this.strm, this.dictionary);
            break;
        default:
            break;
    }
    if (this.err !== module.exports.Z_OK) this._error("Failed to set dictionary");
};
$c0d11a8fc746efbd$var$Zlib.prototype._reset = function() {
    this.err = module.exports.Z_OK;
    switch(this.mode){
        case module.exports.DEFLATE:
        case module.exports.DEFLATERAW:
        case module.exports.GZIP:
            this.err = $lGf86.deflateReset(this.strm);
            break;
        case module.exports.INFLATE:
        case module.exports.INFLATERAW:
        case module.exports.GUNZIP:
            this.err = $fzvBq.inflateReset(this.strm);
            break;
        default:
            break;
    }
    if (this.err !== module.exports.Z_OK) this._error("Failed to reset stream");
};
module.exports.Zlib = $c0d11a8fc746efbd$var$Zlib;

});
parcelRegister("aLUwE", function(module, exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
function $7d7a23f7babfddb7$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $7d7a23f7babfddb7$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $7d7a23f7babfddb7$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $7d7a23f7babfddb7$var$_typeof(obj);
}
function $7d7a23f7babfddb7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $cCihK = parcelRequire("cCihK");
var $7d7a23f7babfddb7$var$_require$codes = $cCihK.codes, $7d7a23f7babfddb7$var$ERR_AMBIGUOUS_ARGUMENT = $7d7a23f7babfddb7$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE = $7d7a23f7babfddb7$var$_require$codes.ERR_INVALID_ARG_TYPE, $7d7a23f7babfddb7$var$ERR_INVALID_ARG_VALUE = $7d7a23f7babfddb7$var$_require$codes.ERR_INVALID_ARG_VALUE, $7d7a23f7babfddb7$var$ERR_INVALID_RETURN_VALUE = $7d7a23f7babfddb7$var$_require$codes.ERR_INVALID_RETURN_VALUE, $7d7a23f7babfddb7$var$ERR_MISSING_ARGS = $7d7a23f7babfddb7$var$_require$codes.ERR_MISSING_ARGS;

var $8pS6q = parcelRequire("8pS6q");

var $N7Lcz = parcelRequire("N7Lcz");
var $7d7a23f7babfddb7$var$inspect = $N7Lcz.inspect;

var $N7Lcz = parcelRequire("N7Lcz");
var $7d7a23f7babfddb7$require$_require$types = $N7Lcz.types;
var $7d7a23f7babfddb7$var$isPromise = $7d7a23f7babfddb7$require$_require$types.isPromise, $7d7a23f7babfddb7$var$isRegExp = $7d7a23f7babfddb7$require$_require$types.isRegExp;

var $7d7a23f7babfddb7$var$objectAssign = Object.assign ? Object.assign : (parcelRequire("dYBnA")).assign;

var $7d7a23f7babfddb7$var$objectIs = Object.is ? Object.is : (parcelRequire("eT9RM"));
var $7d7a23f7babfddb7$var$errorCache = new Map();
var $7d7a23f7babfddb7$var$isDeepEqual;
var $7d7a23f7babfddb7$var$isDeepStrictEqual;
var $7d7a23f7babfddb7$var$parseExpressionAt;
var $7d7a23f7babfddb7$var$findNodeAround;
var $7d7a23f7babfddb7$var$decoder;

function $7d7a23f7babfddb7$var$lazyLoadComparison() {
    var comparison = (parcelRequire("3LKhK"));
    $7d7a23f7babfddb7$var$isDeepEqual = comparison.isDeepEqual;
    $7d7a23f7babfddb7$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
} // Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var $7d7a23f7babfddb7$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var $7d7a23f7babfddb7$var$meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    "\\b",
    "",
    "",
    "\\u000b",
    "\\f",
    "",
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var $7d7a23f7babfddb7$var$escapeFn = function escapeFn(str) {
    return $7d7a23f7babfddb7$var$meta[str.charCodeAt(0)];
};
var $7d7a23f7babfddb7$var$warned = false; // The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var $7d7a23f7babfddb7$var$assert = module.exports = $7d7a23f7babfddb7$var$ok;
var $7d7a23f7babfddb7$var$NO_EXCEPTION_SENTINEL = {}; // All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $7d7a23f7babfddb7$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $8pS6q(obj);
}
function $7d7a23f7babfddb7$var$fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = "Failed";
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if ($7d7a23f7babfddb7$var$warned === false) {
            $7d7a23f7babfddb7$var$warned = true;
            var warn = $hPtJY.emitWarning ? $hPtJY.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", "DeprecationWarning", "DEP0094");
        }
        if (argsLen === 2) operator = "!=";
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? "fail" : operator,
        stackStartFn: stackStartFn || $7d7a23f7babfddb7$var$fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new $8pS6q(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
$7d7a23f7babfddb7$var$assert.fail = $7d7a23f7babfddb7$var$fail; // The AssertionError is defined in internal/error.
$7d7a23f7babfddb7$var$assert.AssertionError = $8pS6q;
function $7d7a23f7babfddb7$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = "No value argument passed to `assert.ok()`";
        } else if (message instanceof Error) throw message;
        var err = new $8pS6q({
            actual: value,
            expected: true,
            message: message,
            operator: "==",
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
} // Pure assertion tests whether a value is truthy, as determined
// by !!value.
function $7d7a23f7babfddb7$var$ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $7d7a23f7babfddb7$var$innerOk.apply(void 0, [
        $7d7a23f7babfddb7$var$ok,
        args.length
    ].concat(args));
}
$7d7a23f7babfddb7$var$assert.ok = $7d7a23f7babfddb7$var$ok; // The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ $7d7a23f7babfddb7$var$assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS("actual", "expected");
     // eslint-disable-next-line eqeqeq
    if (actual != expected) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "==",
        stackStartFn: equal
    });
}; // The non-equality assertion tests for whether two objects are not
// equal with !=.
$7d7a23f7babfddb7$var$assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS("actual", "expected");
     // eslint-disable-next-line eqeqeq
    if (actual == expected) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "!=",
        stackStartFn: notEqual
    });
}; // The equivalence assertion tests a deep equality relation.
$7d7a23f7babfddb7$var$assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS("actual", "expected");
    if ($7d7a23f7babfddb7$var$isDeepEqual === undefined) $7d7a23f7babfddb7$var$lazyLoadComparison();
    if (!$7d7a23f7babfddb7$var$isDeepEqual(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "deepEqual",
        stackStartFn: deepEqual
    });
}; // The non-equivalence assertion tests for any deep inequality.
$7d7a23f7babfddb7$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS("actual", "expected");
    if ($7d7a23f7babfddb7$var$isDeepEqual === undefined) $7d7a23f7babfddb7$var$lazyLoadComparison();
    if ($7d7a23f7babfddb7$var$isDeepEqual(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notDeepEqual",
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ $7d7a23f7babfddb7$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS("actual", "expected");
    if ($7d7a23f7babfddb7$var$isDeepEqual === undefined) $7d7a23f7babfddb7$var$lazyLoadComparison();
    if (!$7d7a23f7babfddb7$var$isDeepStrictEqual(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "deepStrictEqual",
        stackStartFn: deepStrictEqual
    });
};
$7d7a23f7babfddb7$var$assert.notDeepStrictEqual = $7d7a23f7babfddb7$var$notDeepStrictEqual;
function $7d7a23f7babfddb7$var$notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS("actual", "expected");
    if ($7d7a23f7babfddb7$var$isDeepEqual === undefined) $7d7a23f7babfddb7$var$lazyLoadComparison();
    if ($7d7a23f7babfddb7$var$isDeepStrictEqual(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notDeepStrictEqual",
        stackStartFn: $7d7a23f7babfddb7$var$notDeepStrictEqual
    });
}
$7d7a23f7babfddb7$var$assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS("actual", "expected");
    if (!$7d7a23f7babfddb7$var$objectIs(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "strictEqual",
        stackStartFn: strictEqual
    });
};
$7d7a23f7babfddb7$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS("actual", "expected");
    if ($7d7a23f7babfddb7$var$objectIs(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notStrictEqual",
        stackStartFn: notStrictEqual
    });
};
var $7d7a23f7babfddb7$var$Comparison = function Comparison(obj, keys, actual) {
    var _this = this;
    $7d7a23f7babfddb7$var$_classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === "string" && $7d7a23f7babfddb7$var$isRegExp(obj[key]) && obj[key].test(actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
};
function $7d7a23f7babfddb7$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !$7d7a23f7babfddb7$var$isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new $7d7a23f7babfddb7$var$Comparison(actual, keys);
            var b = new $7d7a23f7babfddb7$var$Comparison(expected, keys, actual);
            var err = new $8pS6q({
                actual: a,
                expected: b,
                operator: "deepStrictEqual",
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        $7d7a23f7babfddb7$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function $7d7a23f7babfddb7$var$expectedException(actual, expected, msg, fn) {
    if (typeof expected !== "function") {
        if ($7d7a23f7babfddb7$var$isRegExp(expected)) return expected.test(actual); // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE("expected", [
            "Function",
            "RegExp"
        ], expected);
         // Handle primitives properly.
        if ($7d7a23f7babfddb7$var$_typeof(actual) !== "object" || actual === null) {
            var err = new $8pS6q({
                actual: actual,
                expected: expected,
                message: msg,
                operator: "deepStrictEqual",
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected); // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push("name", "message");
        else if (keys.length === 0) throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_VALUE("error", expected, "may not be an empty object");
        if ($7d7a23f7babfddb7$var$isDeepEqual === undefined) $7d7a23f7babfddb7$var$lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === "string" && $7d7a23f7babfddb7$var$isRegExp(expected[key]) && expected[key].test(actual[key])) return;
            $7d7a23f7babfddb7$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    } // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $7d7a23f7babfddb7$var$getActual(fn) {
    if (typeof fn !== "function") throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE("fn", "Function", fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return $7d7a23f7babfddb7$var$NO_EXCEPTION_SENTINEL;
}
function $7d7a23f7babfddb7$var$checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return $7d7a23f7babfddb7$var$isPromise(obj) || obj !== null && $7d7a23f7babfddb7$var$_typeof(obj) === "object" && typeof obj.then === "function" && typeof obj.catch === "function";
}
function $7d7a23f7babfddb7$var$waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === "function") {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn(); // Fail in case no promise is returned.
            if (!$7d7a23f7babfddb7$var$checkIsPromise(resultPromise)) throw new $7d7a23f7babfddb7$var$ERR_INVALID_RETURN_VALUE("instance of Promise", "promiseFn", resultPromise);
        } else if ($7d7a23f7babfddb7$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE("promiseFn", [
            "Function",
            "Promise"
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return $7d7a23f7babfddb7$var$NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function $7d7a23f7babfddb7$var$expectsError(stackStartFn, actual, error, message) {
    if (typeof error === "string") {
        if (arguments.length === 4) throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE("error", [
            "Object",
            "Error",
            "Function",
            "RegExp"
        ], error);
        if ($7d7a23f7babfddb7$var$_typeof(actual) === "object" && actual !== null) {
            if (actual.message === error) throw new $7d7a23f7babfddb7$var$ERR_AMBIGUOUS_ARGUMENT("error/message", 'The error message "'.concat(actual.message, '" is identical to the message.'));
        } else if (actual === error) throw new $7d7a23f7babfddb7$var$ERR_AMBIGUOUS_ARGUMENT("error/message", 'The error "'.concat(actual, '" is identical to the message.'));
        message = error;
        error = undefined;
    } else if (error != null && $7d7a23f7babfddb7$var$_typeof(error) !== "object" && typeof error !== "function") throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE("error", [
        "Object",
        "Error",
        "Function",
        "RegExp"
    ], error);
    if (actual === $7d7a23f7babfddb7$var$NO_EXCEPTION_SENTINEL) {
        var details = "";
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : ".";
        var fnType = stackStartFn.name === "rejects" ? "rejection" : "exception";
        $7d7a23f7babfddb7$var$innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !$7d7a23f7babfddb7$var$expectedException(actual, error, message, stackStartFn)) throw actual;
}
function $7d7a23f7babfddb7$var$expectsNoError(stackStartFn, actual, error, message) {
    if (actual === $7d7a23f7babfddb7$var$NO_EXCEPTION_SENTINEL) return;
    if (typeof error === "string") {
        message = error;
        error = undefined;
    }
    if (!error || $7d7a23f7babfddb7$var$expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : ".";
        var fnType = stackStartFn.name === "doesNotReject" ? "rejection" : "exception";
        $7d7a23f7babfddb7$var$innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + 'Actual message: "'.concat(actual && actual.message, '"'),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
$7d7a23f7babfddb7$var$assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    $7d7a23f7babfddb7$var$expectsError.apply(void 0, [
        throws,
        $7d7a23f7babfddb7$var$getActual(promiseFn)
    ].concat(args));
};
$7d7a23f7babfddb7$var$assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $7d7a23f7babfddb7$var$waitForActual(promiseFn).then(function(result) {
        return $7d7a23f7babfddb7$var$expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
$7d7a23f7babfddb7$var$assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    $7d7a23f7babfddb7$var$expectsNoError.apply(void 0, [
        doesNotThrow,
        $7d7a23f7babfddb7$var$getActual(fn)
    ].concat(args));
};
$7d7a23f7babfddb7$var$assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $7d7a23f7babfddb7$var$waitForActual(fn).then(function(result) {
        return $7d7a23f7babfddb7$var$expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
$7d7a23f7babfddb7$var$assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = "ifError got unwanted exception: ";
        if ($7d7a23f7babfddb7$var$_typeof(err) === "object" && typeof err.message === "string") {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += $7d7a23f7babfddb7$var$inspect(err);
        var newErr = new $8pS6q({
            actual: err,
            expected: null,
            operator: "ifError",
            message: message,
            stackStartFn: ifError
        }); // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === "string") {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split("\n");
            tmp2.shift(); // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split("\n");
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join("\n"), "\n").concat(tmp2.join("\n"));
        }
        throw newErr;
    }
}; // Expose a strict only variant of assert
function $7d7a23f7babfddb7$var$strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    $7d7a23f7babfddb7$var$innerOk.apply(void 0, [
        $7d7a23f7babfddb7$var$strict,
        args.length
    ].concat(args));
}
$7d7a23f7babfddb7$var$assert.strict = $7d7a23f7babfddb7$var$objectAssign($7d7a23f7babfddb7$var$strict, $7d7a23f7babfddb7$var$assert, {
    equal: $7d7a23f7babfddb7$var$assert.strictEqual,
    deepEqual: $7d7a23f7babfddb7$var$assert.deepStrictEqual,
    notEqual: $7d7a23f7babfddb7$var$assert.notStrictEqual,
    notDeepEqual: $7d7a23f7babfddb7$var$assert.notDeepStrictEqual
});
$7d7a23f7babfddb7$var$assert.strict.strict = $7d7a23f7babfddb7$var$assert.strict;

});
parcelRegister("cCihK", function(module, exports) {

$parcel$export(module.exports, "codes", () => $92f737b1c63f6b54$export$e45cb6485273080e, (v) => $92f737b1c63f6b54$export$e45cb6485273080e = v);
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ var $92f737b1c63f6b54$export$e45cb6485273080e;
"use strict"; // The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function $92f737b1c63f6b54$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $92f737b1c63f6b54$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $92f737b1c63f6b54$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $92f737b1c63f6b54$var$_typeof(obj);
}
function $92f737b1c63f6b54$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $92f737b1c63f6b54$var$_possibleConstructorReturn(self, call) {
    if (call && ($92f737b1c63f6b54$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $92f737b1c63f6b54$var$_assertThisInitialized(self);
}
function $92f737b1c63f6b54$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $92f737b1c63f6b54$var$_getPrototypeOf(o) {
    $92f737b1c63f6b54$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $92f737b1c63f6b54$var$_getPrototypeOf(o);
}
function $92f737b1c63f6b54$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $92f737b1c63f6b54$var$_setPrototypeOf(subClass, superClass);
}
function $92f737b1c63f6b54$var$_setPrototypeOf(o, p) {
    $92f737b1c63f6b54$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $92f737b1c63f6b54$var$_setPrototypeOf(o, p);
}
var $92f737b1c63f6b54$var$codes = {}; // Lazy loaded
var $92f737b1c63f6b54$var$assert;
var $92f737b1c63f6b54$var$util;
function $92f737b1c63f6b54$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $92f737b1c63f6b54$var$_inherits(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            $92f737b1c63f6b54$var$_classCallCheck(this, NodeError);
            _this = $92f737b1c63f6b54$var$_possibleConstructorReturn(this, $92f737b1c63f6b54$var$_getPrototypeOf(NodeError).call(this, getMessage(arg1, arg2, arg3)));
            _this.code = code;
            return _this;
        }
        return NodeError;
    }(Base);
    $92f737b1c63f6b54$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $92f737b1c63f6b54$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $92f737b1c63f6b54$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $92f737b1c63f6b54$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $92f737b1c63f6b54$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$92f737b1c63f6b54$var$createErrorType("ERR_AMBIGUOUS_ARGUMENT", 'The "%s" argument is ambiguous. %s', TypeError);

$92f737b1c63f6b54$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    if ($92f737b1c63f6b54$var$assert === undefined) $92f737b1c63f6b54$var$assert = (parcelRequire("aLUwE"));
    $92f737b1c63f6b54$var$assert(typeof name === "string", "'name' must be a string"); // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $92f737b1c63f6b54$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($92f737b1c63f6b54$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($92f737b1c63f6b54$var$oneOf(expected, "type"));
    else {
        var type = $92f737b1c63f6b54$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($92f737b1c63f6b54$var$oneOf(expected, "type"));
    } // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat($92f737b1c63f6b54$var$_typeof(actual));
    return msg;
}, TypeError);

$92f737b1c63f6b54$var$createErrorType("ERR_INVALID_ARG_VALUE", function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "is invalid";
    if ($92f737b1c63f6b54$var$util === undefined) $92f737b1c63f6b54$var$util = (parcelRequire("N7Lcz"));
    var inspected = $92f737b1c63f6b54$var$util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
$92f737b1c63f6b54$var$createErrorType("ERR_INVALID_RETURN_VALUE", function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat($92f737b1c63f6b54$var$_typeof(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);

$92f737b1c63f6b54$var$createErrorType("ERR_MISSING_ARGS", function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if ($92f737b1c63f6b54$var$assert === undefined) $92f737b1c63f6b54$var$assert = (parcelRequire("aLUwE"));
    $92f737b1c63f6b54$var$assert(args.length > 0, "At least one arg needs to be specified");
    var msg = "The ";
    var len = args.length;
    args = args.map(function(a) {
        return '"'.concat(a, '"');
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(", ");
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$92f737b1c63f6b54$export$e45cb6485273080e = $92f737b1c63f6b54$var$codes;

});
parcelRegister("N7Lcz", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
var $093a98c17cb6b6b8$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $093a98c17cb6b6b8$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$093a98c17cb6b6b8$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($093a98c17cb6b6b8$var$inspect(arguments[i]));
        return objects.join(" ");
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($093a98c17cb6b6b8$var$formatRegExp, function(x) {
        if (x === "%%") return "%";
        if (i >= len) return x;
        switch(x){
            case "%s":
                return String(args[i++]);
            case "%d":
                return Number(args[i++]);
            case "%j":
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return "[Circular]";
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($093a98c17cb6b6b8$var$isNull(x) || !$093a98c17cb6b6b8$var$isObject(x)) str += " " + x;
    else str += " " + $093a98c17cb6b6b8$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    if (typeof $hPtJY !== "undefined" && $hPtJY.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $hPtJY === "undefined") return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($hPtJY.throwDeprecation) throw new Error(msg);
            else if ($hPtJY.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var $093a98c17cb6b6b8$var$debugs = {};
var $093a98c17cb6b6b8$var$debugEnvRegex = /^$/;
var $093a98c17cb6b6b8$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$093a98c17cb6b6b8$var$debugs[set]) {
        if ($093a98c17cb6b6b8$var$debugEnvRegex.test(set)) {
            var pid = $hPtJY.pid;
            $093a98c17cb6b6b8$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error("%s %d: %s", set, pid, msg);
            };
        } else $093a98c17cb6b6b8$var$debugs[set] = function() {};
    }
    return $093a98c17cb6b6b8$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $093a98c17cb6b6b8$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $093a98c17cb6b6b8$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($093a98c17cb6b6b8$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $093a98c17cb6b6b8$var$stylizeWithColor;
    return $093a98c17cb6b6b8$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $093a98c17cb6b6b8$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$093a98c17cb6b6b8$var$inspect.colors = {
    "bold": [
        1,
        22
    ],
    "italic": [
        3,
        23
    ],
    "underline": [
        4,
        24
    ],
    "inverse": [
        7,
        27
    ],
    "white": [
        37,
        39
    ],
    "grey": [
        90,
        39
    ],
    "black": [
        30,
        39
    ],
    "blue": [
        34,
        39
    ],
    "cyan": [
        36,
        39
    ],
    "green": [
        32,
        39
    ],
    "magenta": [
        35,
        39
    ],
    "red": [
        31,
        39
    ],
    "yellow": [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$093a98c17cb6b6b8$var$inspect.styles = {
    "special": "cyan",
    "number": "yellow",
    "boolean": "yellow",
    "undefined": "grey",
    "null": "bold",
    "string": "green",
    "date": "magenta",
    // "name": intentionally not styling
    "regexp": "red"
};
function $093a98c17cb6b6b8$var$stylizeWithColor(str, styleType) {
    var style = $093a98c17cb6b6b8$var$inspect.styles[styleType];
    if (style) return "\x1b[" + $093a98c17cb6b6b8$var$inspect.colors[style][0] + "m" + str + "\x1b[" + $093a98c17cb6b6b8$var$inspect.colors[style][1] + "m";
    else return str;
}
function $093a98c17cb6b6b8$var$stylizeNoColor(str, styleType) {
    return str;
}
function $093a98c17cb6b6b8$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $093a98c17cb6b6b8$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $093a98c17cb6b6b8$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$093a98c17cb6b6b8$var$isString(ret)) ret = $093a98c17cb6b6b8$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $093a98c17cb6b6b8$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $093a98c17cb6b6b8$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($093a98c17cb6b6b8$var$isError(value) && (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)) return $093a98c17cb6b6b8$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($093a98c17cb6b6b8$var$isFunction(value)) {
            var name = value.name ? ": " + value.name : "";
            return ctx.stylize("[Function" + name + "]", "special");
        }
        if ($093a98c17cb6b6b8$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        if ($093a98c17cb6b6b8$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), "date");
        if ($093a98c17cb6b6b8$var$isError(value)) return $093a98c17cb6b6b8$var$formatError(value);
    }
    var base = "", array = false, braces = [
        "{",
        "}"
    ];
    // Make Array say that they are Array
    if ($093a98c17cb6b6b8$var$isArray(value)) {
        array = true;
        braces = [
            "[",
            "]"
        ];
    }
    // Make functions say that they are functions
    if ($093a98c17cb6b6b8$var$isFunction(value)) {
        var n = value.name ? ": " + value.name : "";
        base = " [Function" + n + "]";
    }
    // Make RegExps say that they are RegExps
    if ($093a98c17cb6b6b8$var$isRegExp(value)) base = " " + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($093a98c17cb6b6b8$var$isDate(value)) base = " " + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($093a98c17cb6b6b8$var$isError(value)) base = " " + $093a98c17cb6b6b8$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($093a98c17cb6b6b8$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        else return ctx.stylize("[Object]", "special");
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $093a98c17cb6b6b8$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $093a98c17cb6b6b8$var$reduceToSingleString(output, base, braces);
}
function $093a98c17cb6b6b8$var$formatPrimitive(ctx, value) {
    if ($093a98c17cb6b6b8$var$isUndefined(value)) return ctx.stylize("undefined", "undefined");
    if ($093a98c17cb6b6b8$var$isString(value)) {
        var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return ctx.stylize(simple, "string");
    }
    if ($093a98c17cb6b6b8$var$isNumber(value)) return ctx.stylize("" + value, "number");
    if ($093a98c17cb6b6b8$var$isBoolean(value)) return ctx.stylize("" + value, "boolean");
    // For some reason typeof null is "object", so special case here.
    if ($093a98c17cb6b6b8$var$isNull(value)) return ctx.stylize("null", "null");
}
function $093a98c17cb6b6b8$var$formatError(value) {
    return "[" + Error.prototype.toString.call(value) + "]";
}
function $093a98c17cb6b6b8$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($093a98c17cb6b6b8$var$hasOwnProperty(value, String(i))) output.push($093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push("");
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize("[Getter/Setter]", "special");
        else str = ctx.stylize("[Getter]", "special");
    } else if (desc.set) str = ctx.stylize("[Setter]", "special");
    if (!$093a98c17cb6b6b8$var$hasOwnProperty(visibleKeys, key)) name = "[" + key + "]";
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($093a98c17cb6b6b8$var$isNull(recurseTimes)) str = $093a98c17cb6b6b8$var$formatValue(ctx, desc.value, null);
            else str = $093a98c17cb6b6b8$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf("\n") > -1) {
                if (array) str = str.split("\n").map(function(line) {
                    return "  " + line;
                }).join("\n").slice(2);
                else str = "\n" + str.split("\n").map(function(line) {
                    return "   " + line;
                }).join("\n");
            }
        } else str = ctx.stylize("[Circular]", "special");
    }
    if ($093a98c17cb6b6b8$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify("" + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, "name");
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, "string");
        }
    }
    return name + ": " + str;
}
function $093a98c17cb6b6b8$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf("\n") >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
    return braces[0] + base + " " + output.join(", ") + " " + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("7He6T"));
function $093a98c17cb6b6b8$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $093a98c17cb6b6b8$var$isArray;
function $093a98c17cb6b6b8$var$isBoolean(arg) {
    return typeof arg === "boolean";
}
module.exports.isBoolean = $093a98c17cb6b6b8$var$isBoolean;
function $093a98c17cb6b6b8$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $093a98c17cb6b6b8$var$isNull;
function $093a98c17cb6b6b8$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $093a98c17cb6b6b8$var$isNullOrUndefined;
function $093a98c17cb6b6b8$var$isNumber(arg) {
    return typeof arg === "number";
}
module.exports.isNumber = $093a98c17cb6b6b8$var$isNumber;
function $093a98c17cb6b6b8$var$isString(arg) {
    return typeof arg === "string";
}
module.exports.isString = $093a98c17cb6b6b8$var$isString;
function $093a98c17cb6b6b8$var$isSymbol(arg) {
    return typeof arg === "symbol";
}
module.exports.isSymbol = $093a98c17cb6b6b8$var$isSymbol;
function $093a98c17cb6b6b8$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $093a98c17cb6b6b8$var$isUndefined;
function $093a98c17cb6b6b8$var$isRegExp(re) {
    return $093a98c17cb6b6b8$var$isObject(re) && $093a98c17cb6b6b8$var$objectToString(re) === "[object RegExp]";
}
module.exports.isRegExp = $093a98c17cb6b6b8$var$isRegExp;
module.exports.types.isRegExp = $093a98c17cb6b6b8$var$isRegExp;
function $093a98c17cb6b6b8$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
module.exports.isObject = $093a98c17cb6b6b8$var$isObject;
function $093a98c17cb6b6b8$var$isDate(d) {
    return $093a98c17cb6b6b8$var$isObject(d) && $093a98c17cb6b6b8$var$objectToString(d) === "[object Date]";
}
module.exports.isDate = $093a98c17cb6b6b8$var$isDate;
module.exports.types.isDate = $093a98c17cb6b6b8$var$isDate;
function $093a98c17cb6b6b8$var$isError(e) {
    return $093a98c17cb6b6b8$var$isObject(e) && ($093a98c17cb6b6b8$var$objectToString(e) === "[object Error]" || e instanceof Error);
}
module.exports.isError = $093a98c17cb6b6b8$var$isError;
module.exports.types.isNativeError = $093a98c17cb6b6b8$var$isError;
function $093a98c17cb6b6b8$var$isFunction(arg) {
    return typeof arg === "function";
}
module.exports.isFunction = $093a98c17cb6b6b8$var$isFunction;
function $093a98c17cb6b6b8$var$isPrimitive(arg) {
    return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
    typeof arg === "undefined";
}
module.exports.isPrimitive = $093a98c17cb6b6b8$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("kotBY"));
function $093a98c17cb6b6b8$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $093a98c17cb6b6b8$var$pad(n) {
    return n < 10 ? "0" + n.toString(10) : n.toString(10);
}
var $093a98c17cb6b6b8$var$months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
// 26 Feb 16:19:34
function $093a98c17cb6b6b8$var$timestamp() {
    var d = new Date();
    var time = [
        $093a98c17cb6b6b8$var$pad(d.getHours()),
        $093a98c17cb6b6b8$var$pad(d.getMinutes()),
        $093a98c17cb6b6b8$var$pad(d.getSeconds())
    ].join(":");
    return [
        d.getDate(),
        $093a98c17cb6b6b8$var$months[d.getMonth()],
        time
    ].join(" ");
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log("%s - %s", $093a98c17cb6b6b8$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("dlqwk"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$093a98c17cb6b6b8$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $093a98c17cb6b6b8$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol = typeof Symbol !== "undefined" ? Symbol("util.promisify.custom") : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    if ($093a98c17cb6b6b8$var$kCustomPromisifiedSymbol && original[$093a98c17cb6b6b8$var$kCustomPromisifiedSymbol]) {
        var fn = original[$093a98c17cb6b6b8$var$kCustomPromisifiedSymbol];
        if (typeof fn !== "function") throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($093a98c17cb6b6b8$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $093a98c17cb6b6b8$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol;
function $093a98c17cb6b6b8$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error("Promise was rejected with a falsy value");
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $093a98c17cb6b6b8$var$callbackify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== "function") throw new TypeError("The last argument must be of type Function");
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $hPtJY.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $hPtJY.nextTick($093a98c17cb6b6b8$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $093a98c17cb6b6b8$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $093a98c17cb6b6b8$var$callbackify;

});
parcelRegister("7He6T", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
"use strict";

var $f4HGZ = parcelRequire("f4HGZ");

var $5WnCa = parcelRequire("5WnCa");

var $gJrpv = parcelRequire("gJrpv");

var $hN833 = parcelRequire("hN833");
function $59a77e8886024a57$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $59a77e8886024a57$var$BigIntSupported = typeof BigInt !== "undefined";
var $59a77e8886024a57$var$SymbolSupported = typeof Symbol !== "undefined";
var $59a77e8886024a57$var$ObjectToString = $59a77e8886024a57$var$uncurryThis(Object.prototype.toString);
var $59a77e8886024a57$var$numberValue = $59a77e8886024a57$var$uncurryThis(Number.prototype.valueOf);
var $59a77e8886024a57$var$stringValue = $59a77e8886024a57$var$uncurryThis(String.prototype.valueOf);
var $59a77e8886024a57$var$booleanValue = $59a77e8886024a57$var$uncurryThis(Boolean.prototype.valueOf);
if ($59a77e8886024a57$var$BigIntSupported) var $59a77e8886024a57$var$bigIntValue = $59a77e8886024a57$var$uncurryThis(BigInt.prototype.valueOf);
if ($59a77e8886024a57$var$SymbolSupported) var $59a77e8886024a57$var$symbolValue = $59a77e8886024a57$var$uncurryThis(Symbol.prototype.valueOf);
function $59a77e8886024a57$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== "object") return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $f4HGZ;
module.exports.isGeneratorFunction = $5WnCa;
module.exports.isTypedArray = $hN833;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $59a77e8886024a57$var$isPromise(input) {
    return typeof Promise !== "undefined" && input instanceof Promise || input !== null && typeof input === "object" && typeof input.then === "function" && typeof input.catch === "function";
}
module.exports.isPromise = $59a77e8886024a57$var$isPromise;
function $59a77e8886024a57$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $hN833(value) || $59a77e8886024a57$var$isDataView(value);
}
module.exports.isArrayBufferView = $59a77e8886024a57$var$isArrayBufferView;
function $59a77e8886024a57$var$isUint8Array(value) {
    return $gJrpv(value) === "Uint8Array";
}
module.exports.isUint8Array = $59a77e8886024a57$var$isUint8Array;
function $59a77e8886024a57$var$isUint8ClampedArray(value) {
    return $gJrpv(value) === "Uint8ClampedArray";
}
module.exports.isUint8ClampedArray = $59a77e8886024a57$var$isUint8ClampedArray;
function $59a77e8886024a57$var$isUint16Array(value) {
    return $gJrpv(value) === "Uint16Array";
}
module.exports.isUint16Array = $59a77e8886024a57$var$isUint16Array;
function $59a77e8886024a57$var$isUint32Array(value) {
    return $gJrpv(value) === "Uint32Array";
}
module.exports.isUint32Array = $59a77e8886024a57$var$isUint32Array;
function $59a77e8886024a57$var$isInt8Array(value) {
    return $gJrpv(value) === "Int8Array";
}
module.exports.isInt8Array = $59a77e8886024a57$var$isInt8Array;
function $59a77e8886024a57$var$isInt16Array(value) {
    return $gJrpv(value) === "Int16Array";
}
module.exports.isInt16Array = $59a77e8886024a57$var$isInt16Array;
function $59a77e8886024a57$var$isInt32Array(value) {
    return $gJrpv(value) === "Int32Array";
}
module.exports.isInt32Array = $59a77e8886024a57$var$isInt32Array;
function $59a77e8886024a57$var$isFloat32Array(value) {
    return $gJrpv(value) === "Float32Array";
}
module.exports.isFloat32Array = $59a77e8886024a57$var$isFloat32Array;
function $59a77e8886024a57$var$isFloat64Array(value) {
    return $gJrpv(value) === "Float64Array";
}
module.exports.isFloat64Array = $59a77e8886024a57$var$isFloat64Array;
function $59a77e8886024a57$var$isBigInt64Array(value) {
    return $gJrpv(value) === "BigInt64Array";
}
module.exports.isBigInt64Array = $59a77e8886024a57$var$isBigInt64Array;
function $59a77e8886024a57$var$isBigUint64Array(value) {
    return $gJrpv(value) === "BigUint64Array";
}
module.exports.isBigUint64Array = $59a77e8886024a57$var$isBigUint64Array;
function $59a77e8886024a57$var$isMapToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object Map]";
}
$59a77e8886024a57$var$isMapToString.working = typeof Map !== "undefined" && $59a77e8886024a57$var$isMapToString(new Map());
function $59a77e8886024a57$var$isMap(value) {
    if (typeof Map === "undefined") return false;
    return $59a77e8886024a57$var$isMapToString.working ? $59a77e8886024a57$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $59a77e8886024a57$var$isMap;
function $59a77e8886024a57$var$isSetToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object Set]";
}
$59a77e8886024a57$var$isSetToString.working = typeof Set !== "undefined" && $59a77e8886024a57$var$isSetToString(new Set());
function $59a77e8886024a57$var$isSet(value) {
    if (typeof Set === "undefined") return false;
    return $59a77e8886024a57$var$isSetToString.working ? $59a77e8886024a57$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $59a77e8886024a57$var$isSet;
function $59a77e8886024a57$var$isWeakMapToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object WeakMap]";
}
$59a77e8886024a57$var$isWeakMapToString.working = typeof WeakMap !== "undefined" && $59a77e8886024a57$var$isWeakMapToString(new WeakMap());
function $59a77e8886024a57$var$isWeakMap(value) {
    if (typeof WeakMap === "undefined") return false;
    return $59a77e8886024a57$var$isWeakMapToString.working ? $59a77e8886024a57$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $59a77e8886024a57$var$isWeakMap;
function $59a77e8886024a57$var$isWeakSetToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object WeakSet]";
}
$59a77e8886024a57$var$isWeakSetToString.working = typeof WeakSet !== "undefined" && $59a77e8886024a57$var$isWeakSetToString(new WeakSet());
function $59a77e8886024a57$var$isWeakSet(value) {
    return $59a77e8886024a57$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $59a77e8886024a57$var$isWeakSet;
function $59a77e8886024a57$var$isArrayBufferToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object ArrayBuffer]";
}
$59a77e8886024a57$var$isArrayBufferToString.working = typeof ArrayBuffer !== "undefined" && $59a77e8886024a57$var$isArrayBufferToString(new ArrayBuffer());
function $59a77e8886024a57$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === "undefined") return false;
    return $59a77e8886024a57$var$isArrayBufferToString.working ? $59a77e8886024a57$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $59a77e8886024a57$var$isArrayBuffer;
function $59a77e8886024a57$var$isDataViewToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object DataView]";
}
$59a77e8886024a57$var$isDataViewToString.working = typeof ArrayBuffer !== "undefined" && typeof DataView !== "undefined" && $59a77e8886024a57$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $59a77e8886024a57$var$isDataView(value) {
    if (typeof DataView === "undefined") return false;
    return $59a77e8886024a57$var$isDataViewToString.working ? $59a77e8886024a57$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $59a77e8886024a57$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $59a77e8886024a57$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== "undefined" ? SharedArrayBuffer : undefined;
function $59a77e8886024a57$var$isSharedArrayBufferToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object SharedArrayBuffer]";
}
function $59a77e8886024a57$var$isSharedArrayBuffer(value) {
    if (typeof $59a77e8886024a57$var$SharedArrayBufferCopy === "undefined") return false;
    if (typeof $59a77e8886024a57$var$isSharedArrayBufferToString.working === "undefined") $59a77e8886024a57$var$isSharedArrayBufferToString.working = $59a77e8886024a57$var$isSharedArrayBufferToString(new $59a77e8886024a57$var$SharedArrayBufferCopy());
    return $59a77e8886024a57$var$isSharedArrayBufferToString.working ? $59a77e8886024a57$var$isSharedArrayBufferToString(value) : value instanceof $59a77e8886024a57$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $59a77e8886024a57$var$isSharedArrayBuffer;
function $59a77e8886024a57$var$isAsyncFunction(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object AsyncFunction]";
}
module.exports.isAsyncFunction = $59a77e8886024a57$var$isAsyncFunction;
function $59a77e8886024a57$var$isMapIterator(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object Map Iterator]";
}
module.exports.isMapIterator = $59a77e8886024a57$var$isMapIterator;
function $59a77e8886024a57$var$isSetIterator(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object Set Iterator]";
}
module.exports.isSetIterator = $59a77e8886024a57$var$isSetIterator;
function $59a77e8886024a57$var$isGeneratorObject(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object Generator]";
}
module.exports.isGeneratorObject = $59a77e8886024a57$var$isGeneratorObject;
function $59a77e8886024a57$var$isWebAssemblyCompiledModule(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object WebAssembly.Module]";
}
module.exports.isWebAssemblyCompiledModule = $59a77e8886024a57$var$isWebAssemblyCompiledModule;
function $59a77e8886024a57$var$isNumberObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$numberValue);
}
module.exports.isNumberObject = $59a77e8886024a57$var$isNumberObject;
function $59a77e8886024a57$var$isStringObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$stringValue);
}
module.exports.isStringObject = $59a77e8886024a57$var$isStringObject;
function $59a77e8886024a57$var$isBooleanObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$booleanValue);
}
module.exports.isBooleanObject = $59a77e8886024a57$var$isBooleanObject;
function $59a77e8886024a57$var$isBigIntObject(value) {
    return $59a77e8886024a57$var$BigIntSupported && $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$bigIntValue);
}
module.exports.isBigIntObject = $59a77e8886024a57$var$isBigIntObject;
function $59a77e8886024a57$var$isSymbolObject(value) {
    return $59a77e8886024a57$var$SymbolSupported && $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$symbolValue);
}
module.exports.isSymbolObject = $59a77e8886024a57$var$isSymbolObject;
function $59a77e8886024a57$var$isBoxedPrimitive(value) {
    return $59a77e8886024a57$var$isNumberObject(value) || $59a77e8886024a57$var$isStringObject(value) || $59a77e8886024a57$var$isBooleanObject(value) || $59a77e8886024a57$var$isBigIntObject(value) || $59a77e8886024a57$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $59a77e8886024a57$var$isBoxedPrimitive;
function $59a77e8886024a57$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== "undefined" && ($59a77e8886024a57$var$isArrayBuffer(value) || $59a77e8886024a57$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $59a77e8886024a57$var$isAnyArrayBuffer;
[
    "isProxy",
    "isExternal",
    "isModuleNamespaceObject"
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + " is not supported in userland");
        }
    });
});

});
parcelRegister("f4HGZ", function(module, exports) {
"use strict";

var $af991f1d6c80f097$var$hasToStringTag = (parcelRequire("3KyxH"))();

var $hXu6F = parcelRequire("hXu6F");
var $af991f1d6c80f097$var$$toString = $hXu6F("Object.prototype.toString");
var $af991f1d6c80f097$var$isStandardArguments = function isArguments(value) {
    if ($af991f1d6c80f097$var$hasToStringTag && value && typeof value === "object" && Symbol.toStringTag in value) return false;
    return $af991f1d6c80f097$var$$toString(value) === "[object Arguments]";
};
var $af991f1d6c80f097$var$isLegacyArguments = function isArguments(value) {
    if ($af991f1d6c80f097$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $af991f1d6c80f097$var$$toString(value) !== "[object Array]" && $af991f1d6c80f097$var$$toString(value.callee) === "[object Function]";
};
var $af991f1d6c80f097$var$supportsStandardArguments = function() {
    return $af991f1d6c80f097$var$isStandardArguments(arguments);
}();
$af991f1d6c80f097$var$isStandardArguments.isLegacyArguments = $af991f1d6c80f097$var$isLegacyArguments; // for tests
module.exports = $af991f1d6c80f097$var$supportsStandardArguments ? $af991f1d6c80f097$var$isStandardArguments : $af991f1d6c80f097$var$isLegacyArguments;

});
parcelRegister("3KyxH", function(module, exports) {
"use strict";

var $7YWkK = parcelRequire("7YWkK");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $7YWkK() && !!Symbol.toStringTag;
};

});
parcelRegister("7YWkK", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("hXu6F", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");

var $cOB0F = parcelRequire("cOB0F");
var $d12f4cdcd6b10506$var$$indexOf = $cOB0F($1zENl("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $1zENl(name, !!allowMissing);
    if (typeof intrinsic === "function" && $d12f4cdcd6b10506$var$$indexOf(name, ".prototype.") > -1) return $cOB0F(intrinsic);
    return intrinsic;
};

});
parcelRegister("1zENl", function(module, exports) {
"use strict";
var $1258b452ecf218a1$var$undefined1;

var $5A49f = parcelRequire("5A49f");

var $hDtVy = parcelRequire("hDtVy");

var $9RC8m = parcelRequire("9RC8m");

var $2BaZq = parcelRequire("2BaZq");

var $5Ox6r = parcelRequire("5Ox6r");

var $eEkyn = parcelRequire("eEkyn");

var $hFSMY = parcelRequire("hFSMY");
var $1258b452ecf218a1$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $1258b452ecf218a1$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $1258b452ecf218a1$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $1258b452ecf218a1$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($1258b452ecf218a1$var$$gOPD) try {
    $1258b452ecf218a1$var$$gOPD({}, "");
} catch (e) {
    $1258b452ecf218a1$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $1258b452ecf218a1$var$throwTypeError = function() {
    throw new $eEkyn();
};
var $1258b452ecf218a1$var$ThrowTypeError = $1258b452ecf218a1$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $1258b452ecf218a1$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $1258b452ecf218a1$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $1258b452ecf218a1$var$throwTypeError;
        }
    }
}() : $1258b452ecf218a1$var$throwTypeError;

var $1258b452ecf218a1$var$hasSymbols = (parcelRequire("24qIq"))();

var $1258b452ecf218a1$var$hasProto = (parcelRequire("dSRh6"))();
var $1258b452ecf218a1$var$getProto = Object.getPrototypeOf || ($1258b452ecf218a1$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $1258b452ecf218a1$var$needsEval = {};
var $1258b452ecf218a1$var$TypedArray = typeof Uint8Array === "undefined" || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(Uint8Array);
var $1258b452ecf218a1$var$INTRINSICS = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $1258b452ecf218a1$var$needsEval,
    "%AsyncGenerator%": $1258b452ecf218a1$var$needsEval,
    "%AsyncGeneratorFunction%": $1258b452ecf218a1$var$needsEval,
    "%AsyncIteratorPrototype%": $1258b452ecf218a1$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": $5A49f,
    "%eval%": eval,
    "%EvalError%": $hDtVy,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $1258b452ecf218a1$var$$Function,
    "%GeneratorFunction%": $1258b452ecf218a1$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto($1258b452ecf218a1$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$1258b452ecf218a1$var$hasSymbols || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": $9RC8m,
    "%ReferenceError%": $2BaZq,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$1258b452ecf218a1$var$hasSymbols || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $1258b452ecf218a1$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $5Ox6r,
    "%ThrowTypeError%": $1258b452ecf218a1$var$ThrowTypeError,
    "%TypedArray%": $1258b452ecf218a1$var$TypedArray,
    "%TypeError%": $eEkyn,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": $hFSMY,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($1258b452ecf218a1$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $1258b452ecf218a1$var$errorProto = $1258b452ecf218a1$var$getProto($1258b452ecf218a1$var$getProto(e));
    $1258b452ecf218a1$var$INTRINSICS["%Error.prototype%"] = $1258b452ecf218a1$var$errorProto;
}
var $1258b452ecf218a1$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $1258b452ecf218a1$var$getProto) value = $1258b452ecf218a1$var$getProto(gen.prototype);
    }
    $1258b452ecf218a1$var$INTRINSICS[name] = value;
    return value;
};
var $1258b452ecf218a1$var$LEGACY_ALIASES = {
    __proto__: null,
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $gvair = parcelRequire("gvair");

var $4c4Ky = parcelRequire("4c4Ky");
var $1258b452ecf218a1$var$$concat = $gvair.call(Function.call, Array.prototype.concat);
var $1258b452ecf218a1$var$$spliceApply = $gvair.call(Function.apply, Array.prototype.splice);
var $1258b452ecf218a1$var$$replace = $gvair.call(Function.call, String.prototype.replace);
var $1258b452ecf218a1$var$$strSlice = $gvair.call(Function.call, String.prototype.slice);
var $1258b452ecf218a1$var$$exec = $gvair.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $1258b452ecf218a1$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $1258b452ecf218a1$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $1258b452ecf218a1$var$stringToPath = function stringToPath(string) {
    var first = $1258b452ecf218a1$var$$strSlice(string, 0, 1);
    var last = $1258b452ecf218a1$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $5Ox6r("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $5Ox6r("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $1258b452ecf218a1$var$$replace(string, $1258b452ecf218a1$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $1258b452ecf218a1$var$$replace(subString, $1258b452ecf218a1$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $1258b452ecf218a1$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($4c4Ky($1258b452ecf218a1$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $1258b452ecf218a1$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($4c4Ky($1258b452ecf218a1$var$INTRINSICS, intrinsicName)) {
        var value = $1258b452ecf218a1$var$INTRINSICS[intrinsicName];
        if (value === $1258b452ecf218a1$var$needsEval) value = $1258b452ecf218a1$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $eEkyn("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $5Ox6r("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $eEkyn("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $eEkyn('"allowMissing" argument must be a boolean');
    if ($1258b452ecf218a1$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $5Ox6r("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $1258b452ecf218a1$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $1258b452ecf218a1$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $1258b452ecf218a1$var$$spliceApply(parts, $1258b452ecf218a1$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $1258b452ecf218a1$var$$strSlice(part, 0, 1);
        var last = $1258b452ecf218a1$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $5Ox6r("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($4c4Ky($1258b452ecf218a1$var$INTRINSICS, intrinsicRealName)) value = $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $eEkyn("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($1258b452ecf218a1$var$$gOPD && i + 1 >= parts.length) {
                var desc = $1258b452ecf218a1$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $4c4Ky(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("5A49f", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("hDtVy", function(module, exports) {
"use strict";
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("9RC8m", function(module, exports) {
"use strict";
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("2BaZq", function(module, exports) {
"use strict";
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("5Ox6r", function(module, exports) {
"use strict";
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("eEkyn", function(module, exports) {
"use strict";
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("hFSMY", function(module, exports) {
"use strict";
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("24qIq", function(module, exports) {
"use strict";
var $1820ada193f67aeb$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $7YWkK = parcelRequire("7YWkK");
module.exports = function hasNativeSymbols() {
    if (typeof $1820ada193f67aeb$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $1820ada193f67aeb$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $7YWkK();
};

});

parcelRegister("dSRh6", function(module, exports) {
"use strict";
var $a1b9a4c94d7d9147$var$test = {
    __proto__: null,
    foo: {}
};
var $a1b9a4c94d7d9147$var$$Object = Object;
/** @type {import('.')} */ module.exports = function hasProto() {
    // @ts-expect-error: TS errors on an inherited property for some reason
    return ({
        __proto__: $a1b9a4c94d7d9147$var$test
    }).foo === $a1b9a4c94d7d9147$var$test.foo && !($a1b9a4c94d7d9147$var$test instanceof $a1b9a4c94d7d9147$var$$Object);
};

});

parcelRegister("gvair", function(module, exports) {
"use strict";

var $kAGnA = parcelRequire("kAGnA");
module.exports = Function.prototype.bind || $kAGnA;

});
parcelRegister("kAGnA", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $efd80b1d7fbb2850$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $efd80b1d7fbb2850$var$toStr = Object.prototype.toString;
var $efd80b1d7fbb2850$var$max = Math.max;
var $efd80b1d7fbb2850$var$funcType = "[object Function]";
var $efd80b1d7fbb2850$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $efd80b1d7fbb2850$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $efd80b1d7fbb2850$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $efd80b1d7fbb2850$var$toStr.apply(target) !== $efd80b1d7fbb2850$var$funcType) throw new TypeError($efd80b1d7fbb2850$var$ERROR_MESSAGE + target);
    var args = $efd80b1d7fbb2850$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $efd80b1d7fbb2850$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $efd80b1d7fbb2850$var$concatty(args, arguments));
    };
    var boundLength = $efd80b1d7fbb2850$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $efd80b1d7fbb2850$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("4c4Ky", function(module, exports) {
"use strict";
var $30dbf79dbae6c725$var$call = Function.prototype.call;
var $30dbf79dbae6c725$var$$hasOwn = Object.prototype.hasOwnProperty;

var $gvair = parcelRequire("gvair");
/** @type {import('.')} */ module.exports = $gvair.call($30dbf79dbae6c725$var$call, $30dbf79dbae6c725$var$$hasOwn);

});


parcelRegister("cOB0F", function(module, exports) {
"use strict";

var $gvair = parcelRequire("gvair");

var $1zENl = parcelRequire("1zENl");

var $BPe9e = parcelRequire("BPe9e");

var $eEkyn = parcelRequire("eEkyn");
var $9546dce5bd4976bd$var$$apply = $1zENl("%Function.prototype.apply%");
var $9546dce5bd4976bd$var$$call = $1zENl("%Function.prototype.call%");
var $9546dce5bd4976bd$var$$reflectApply = $1zENl("%Reflect.apply%", true) || $gvair.call($9546dce5bd4976bd$var$$call, $9546dce5bd4976bd$var$$apply);

var $jAy3M = parcelRequire("jAy3M");
var $9546dce5bd4976bd$var$$max = $1zENl("%Math.max%");
module.exports = function callBind(originalFunction) {
    if (typeof originalFunction !== "function") throw new $eEkyn("a function is required");
    var func = $9546dce5bd4976bd$var$$reflectApply($gvair, $9546dce5bd4976bd$var$$call, arguments);
    return $BPe9e(func, 1 + $9546dce5bd4976bd$var$$max(0, originalFunction.length - (arguments.length - 1)), true);
};
var $9546dce5bd4976bd$var$applyBind = function applyBind() {
    return $9546dce5bd4976bd$var$$reflectApply($gvair, $9546dce5bd4976bd$var$$apply, arguments);
};
if ($jAy3M) $jAy3M(module.exports, "apply", {
    value: $9546dce5bd4976bd$var$applyBind
});
else module.exports.apply = $9546dce5bd4976bd$var$applyBind;

});
parcelRegister("BPe9e", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");

var $5FEEt = parcelRequire("5FEEt");

var $071b317808876eb5$var$hasDescriptors = (parcelRequire("i16wS"))();

var $dYOee = parcelRequire("dYOee");

var $eEkyn = parcelRequire("eEkyn");
var $071b317808876eb5$var$$floor = $1zENl("%Math.floor%");
/** @typedef {(...args: unknown[]) => unknown} Func */ /** @type {<T extends Func = Func>(fn: T, length: number, loose?: boolean) => T} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== "function") throw new $eEkyn("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $071b317808876eb5$var$$floor(length) !== length) throw new $eEkyn("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && $dYOee) {
        var desc = $dYOee(fn, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($071b317808876eb5$var$hasDescriptors) $5FEEt(/** @type {Parameters<define>[0]} */ fn, "length", length, true, true);
        else $5FEEt(/** @type {Parameters<define>[0]} */ fn, "length", length);
    }
    return fn;
};

});
parcelRegister("5FEEt", function(module, exports) {
"use strict";

var $jAy3M = parcelRequire("jAy3M");

var $5Ox6r = parcelRequire("5Ox6r");

var $eEkyn = parcelRequire("eEkyn");

var $dYOee = parcelRequire("dYOee");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $eEkyn("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $eEkyn("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $eEkyn("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $eEkyn("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $eEkyn("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $eEkyn("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$dYOee && $dYOee(obj, property);
    if ($jAy3M) $jAy3M(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $5Ox6r("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};

});
parcelRegister("jAy3M", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");
/** @type {import('.')} */ var $e42bccb64e3fb3fd$var$$defineProperty = $1zENl("%Object.defineProperty%", true) || false;
if ($e42bccb64e3fb3fd$var$$defineProperty) try {
    $e42bccb64e3fb3fd$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $e42bccb64e3fb3fd$var$$defineProperty = false;
}
module.exports = $e42bccb64e3fb3fd$var$$defineProperty;

});

parcelRegister("dYOee", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");
var $a2d7d74e83f6c3ed$var$$gOPD = $1zENl("%Object.getOwnPropertyDescriptor%", true);
if ($a2d7d74e83f6c3ed$var$$gOPD) try {
    $a2d7d74e83f6c3ed$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $a2d7d74e83f6c3ed$var$$gOPD = null;
}
module.exports = $a2d7d74e83f6c3ed$var$$gOPD;

});


parcelRegister("i16wS", function(module, exports) {
"use strict";

var $jAy3M = parcelRequire("jAy3M");
var $d1dd62937e17e68d$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$jAy3M;
};
$d1dd62937e17e68d$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$jAy3M) return null;
    try {
        return $jAy3M([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $d1dd62937e17e68d$var$hasPropertyDescriptors;

});





parcelRegister("5WnCa", function(module, exports) {
"use strict";
var $4534afe844d627e4$var$toStr = Object.prototype.toString;
var $4534afe844d627e4$var$fnToStr = Function.prototype.toString;
var $4534afe844d627e4$var$isFnRegex = /^\s*(?:function)?\*/;

var $4534afe844d627e4$var$hasToStringTag = (parcelRequire("3KyxH"))();
var $4534afe844d627e4$var$getProto = Object.getPrototypeOf;
var $4534afe844d627e4$var$getGeneratorFunc = function() {
    if (!$4534afe844d627e4$var$hasToStringTag) return false;
    try {
        return Function("return function*() {}")();
    } catch (e) {}
};
var $4534afe844d627e4$var$GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== "function") return false;
    if ($4534afe844d627e4$var$isFnRegex.test($4534afe844d627e4$var$fnToStr.call(fn))) return true;
    if (!$4534afe844d627e4$var$hasToStringTag) {
        var str = $4534afe844d627e4$var$toStr.call(fn);
        return str === "[object GeneratorFunction]";
    }
    if (!$4534afe844d627e4$var$getProto) return false;
    if (typeof $4534afe844d627e4$var$GeneratorFunction === "undefined") {
        var generatorFunc = $4534afe844d627e4$var$getGeneratorFunc();
        $4534afe844d627e4$var$GeneratorFunction = generatorFunc ? $4534afe844d627e4$var$getProto(generatorFunc) : false;
    }
    return $4534afe844d627e4$var$getProto(fn) === $4534afe844d627e4$var$GeneratorFunction;
};

});

parcelRegister("gJrpv", function(module, exports) {
"use strict";

var $gFhA7 = parcelRequire("gFhA7");

var $8yXCr = parcelRequire("8yXCr");

var $cOB0F = parcelRequire("cOB0F");

var $hXu6F = parcelRequire("hXu6F");

var $dYOee = parcelRequire("dYOee");
var $c2e61c703a2c9ae0$var$$toString = $hXu6F("Object.prototype.toString");

var $c2e61c703a2c9ae0$var$hasToStringTag = (parcelRequire("3KyxH"))();
var $c2e61c703a2c9ae0$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
var $c2e61c703a2c9ae0$var$typedArrays = $8yXCr();
var $c2e61c703a2c9ae0$var$$slice = $hXu6F("String.prototype.slice");
var $c2e61c703a2c9ae0$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
var $c2e61c703a2c9ae0$var$$indexOf = $hXu6F("Array.prototype.indexOf", true) || /** @type {(array: readonly unknown[], value: unknown) => keyof array} */ function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {Int8Array | Uint8Array | Uint8ClampedArray | Int16Array | Uint16Array | Int32Array | Uint32Array | Float32Array | Float64Array | BigInt64Array | BigUint64Array} TypedArray */ /** @typedef {'Int8Array' | 'Uint8Array' | 'Uint8ClampedArray' | 'Int16Array' | 'Uint16Array' | 'Int32Array' | 'Uint32Array' | 'Float32Array' | 'Float64Array' | 'BigInt64Array' | 'BigUint64Array'} TypedArrayName */ /** @type {{ [k in `\$${TypedArrayName}`]?: (receiver: TypedArray) => string | typeof Uint8Array.prototype.slice.call | typeof Uint8Array.prototype.set.call } & { __proto__: null }} */ var $c2e61c703a2c9ae0$var$cache = {
    __proto__: null
};
if ($c2e61c703a2c9ae0$var$hasToStringTag && $dYOee && $c2e61c703a2c9ae0$var$getPrototypeOf) $gFhA7($c2e61c703a2c9ae0$var$typedArrays, function(typedArray) {
    var arr = new $c2e61c703a2c9ae0$var$g[typedArray]();
    if (Symbol.toStringTag in arr) {
        var proto = $c2e61c703a2c9ae0$var$getPrototypeOf(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $dYOee(proto, Symbol.toStringTag);
        if (!descriptor) {
            var superProto = $c2e61c703a2c9ae0$var$getPrototypeOf(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $dYOee(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        $c2e61c703a2c9ae0$var$cache["$" + typedArray] = $cOB0F(descriptor.get);
    }
});
else $gFhA7($c2e61c703a2c9ae0$var$typedArrays, function(typedArray) {
    var arr = new $c2e61c703a2c9ae0$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) // @ts-expect-error TODO: fix
    $c2e61c703a2c9ae0$var$cache["$" + typedArray] = $cOB0F(fn);
});
/** @type {import('.')} */ var $c2e61c703a2c9ae0$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<tryAllTypedArrays>} */ var found = false;
    $gFhA7(// eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, typeof cache>} */ /** @type {any} */ $c2e61c703a2c9ae0$var$cache, /** @type {(getter: typeof cache, name: `\$${TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error TODO: fix
            if ("$" + getter(value) === typedArray) found = $c2e61c703a2c9ae0$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ var $c2e61c703a2c9ae0$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<tryAllSlices>} */ var found = false;
    $gFhA7(// eslint-disable-next-line no-extra-parens
    /** @type {any} */ $c2e61c703a2c9ae0$var$cache, /** @type {(getter: typeof cache, name: `\$${TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error TODO: fix
            getter(value);
            found = $c2e61c703a2c9ae0$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== "object") return false;
    if (!$c2e61c703a2c9ae0$var$hasToStringTag) {
        var tag = $c2e61c703a2c9ae0$var$$slice($c2e61c703a2c9ae0$var$$toString(value), 8, -1);
        if ($c2e61c703a2c9ae0$var$$indexOf($c2e61c703a2c9ae0$var$typedArrays, tag) > -1) return tag;
        if (tag !== "Object") return false;
        // node < 0.6 hits here on real Typed Arrays
        return $c2e61c703a2c9ae0$var$trySlices(value);
    }
    if (!$dYOee) return null;
     // unknown engine
    return $c2e61c703a2c9ae0$var$tryTypedArrays(value);
};

});
parcelRegister("gFhA7", function(module, exports) {
"use strict";

var $63RD0 = parcelRequire("63RD0");
var $c21e1d005400ef2a$var$toStr = Object.prototype.toString;
var $c21e1d005400ef2a$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $c21e1d005400ef2a$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($c21e1d005400ef2a$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
var $c21e1d005400ef2a$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
var $c21e1d005400ef2a$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($c21e1d005400ef2a$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
var $c21e1d005400ef2a$var$forEach = function forEach(list, iterator, thisArg) {
    if (!$63RD0(iterator)) throw new TypeError("iterator must be a function");
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($c21e1d005400ef2a$var$toStr.call(list) === "[object Array]") $c21e1d005400ef2a$var$forEachArray(list, iterator, receiver);
    else if (typeof list === "string") $c21e1d005400ef2a$var$forEachString(list, iterator, receiver);
    else $c21e1d005400ef2a$var$forEachObject(list, iterator, receiver);
};
module.exports = $c21e1d005400ef2a$var$forEach;

});
parcelRegister("63RD0", function(module, exports) {
"use strict";
var $469c9f4bd3a650de$var$fnToStr = Function.prototype.toString;
var $469c9f4bd3a650de$var$reflectApply = typeof Reflect === "object" && Reflect !== null && Reflect.apply;
var $469c9f4bd3a650de$var$badArrayLike;
var $469c9f4bd3a650de$var$isCallableMarker;
if (typeof $469c9f4bd3a650de$var$reflectApply === "function" && typeof Object.defineProperty === "function") try {
    $469c9f4bd3a650de$var$badArrayLike = Object.defineProperty({}, "length", {
        get: function() {
            throw $469c9f4bd3a650de$var$isCallableMarker;
        }
    });
    $469c9f4bd3a650de$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $469c9f4bd3a650de$var$reflectApply(function() {
        throw 42;
    }, null, $469c9f4bd3a650de$var$badArrayLike);
} catch (_) {
    if (_ !== $469c9f4bd3a650de$var$isCallableMarker) $469c9f4bd3a650de$var$reflectApply = null;
}
else $469c9f4bd3a650de$var$reflectApply = null;
var $469c9f4bd3a650de$var$constructorRegex = /^\s*class\b/;
var $469c9f4bd3a650de$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $469c9f4bd3a650de$var$fnToStr.call(value);
        return $469c9f4bd3a650de$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $469c9f4bd3a650de$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($469c9f4bd3a650de$var$isES6ClassFn(value)) return false;
        $469c9f4bd3a650de$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $469c9f4bd3a650de$var$toStr = Object.prototype.toString;
var $469c9f4bd3a650de$var$objectClass = "[object Object]";
var $469c9f4bd3a650de$var$fnClass = "[object Function]";
var $469c9f4bd3a650de$var$genClass = "[object GeneratorFunction]";
var $469c9f4bd3a650de$var$ddaClass = "[object HTMLAllCollection]"; // IE 11
var $469c9f4bd3a650de$var$ddaClass2 = "[object HTML document.all class]";
var $469c9f4bd3a650de$var$ddaClass3 = "[object HTMLCollection]"; // IE 9-10
var $469c9f4bd3a650de$var$hasToStringTag = typeof Symbol === "function" && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $469c9f4bd3a650de$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $469c9f4bd3a650de$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === "object") {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $469c9f4bd3a650de$var$all = document.all;
    if ($469c9f4bd3a650de$var$toStr.call($469c9f4bd3a650de$var$all) === $469c9f4bd3a650de$var$toStr.call(document.all)) $469c9f4bd3a650de$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($469c9f4bd3a650de$var$isIE68 || !value) && (typeof value === "undefined" || typeof value === "object")) try {
            var str = $469c9f4bd3a650de$var$toStr.call(value);
            return (str === $469c9f4bd3a650de$var$ddaClass || str === $469c9f4bd3a650de$var$ddaClass2 || str === $469c9f4bd3a650de$var$ddaClass3 // opera 12.16
             || str === $469c9f4bd3a650de$var$objectClass // IE 6-8
            ) && value("") == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $469c9f4bd3a650de$var$reflectApply ? function isCallable(value) {
    if ($469c9f4bd3a650de$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    try {
        $469c9f4bd3a650de$var$reflectApply(value, null, $469c9f4bd3a650de$var$badArrayLike);
    } catch (e) {
        if (e !== $469c9f4bd3a650de$var$isCallableMarker) return false;
    }
    return !$469c9f4bd3a650de$var$isES6ClassFn(value) && $469c9f4bd3a650de$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($469c9f4bd3a650de$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    if ($469c9f4bd3a650de$var$hasToStringTag) return $469c9f4bd3a650de$var$tryFunctionObject(value);
    if ($469c9f4bd3a650de$var$isES6ClassFn(value)) return false;
    var strClass = $469c9f4bd3a650de$var$toStr.call(value);
    if (strClass !== $469c9f4bd3a650de$var$fnClass && strClass !== $469c9f4bd3a650de$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $469c9f4bd3a650de$var$tryFunctionObject(value);
};

});


parcelRegister("8yXCr", function(module, exports) {
"use strict";

var $epJrh = parcelRequire("epJrh");
var $63bfbecf41903c8f$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $epJrh.length; i++)if (typeof $63bfbecf41903c8f$var$g[$epJrh[i]] === "function") // @ts-expect-error
    out[out.length] = $epJrh[i];
    return out;
};

});
parcelRegister("epJrh", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = [
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Int16Array",
    "Int32Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array"
];

});



parcelRegister("hN833", function(module, exports) {
"use strict";

var $gJrpv = parcelRequire("gJrpv");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$gJrpv(value);
};

});


parcelRegister("kotBY", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === "object" && typeof arg.copy === "function" && typeof arg.fill === "function" && typeof arg.readUInt8 === "function";
};

});



parcelRegister("8pS6q", function(module, exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c

var $hPtJY = parcelRequire("hPtJY");
"use strict";
function $620aa032cca82da4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $620aa032cca82da4$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $620aa032cca82da4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $620aa032cca82da4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $620aa032cca82da4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $620aa032cca82da4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $620aa032cca82da4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $620aa032cca82da4$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $620aa032cca82da4$var$_possibleConstructorReturn(self, call) {
    if (call && ($620aa032cca82da4$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $620aa032cca82da4$var$_assertThisInitialized(self);
}
function $620aa032cca82da4$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $620aa032cca82da4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $620aa032cca82da4$var$_setPrototypeOf(subClass, superClass);
}
function $620aa032cca82da4$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $620aa032cca82da4$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$620aa032cca82da4$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $620aa032cca82da4$var$_construct(Class, arguments, $620aa032cca82da4$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $620aa032cca82da4$var$_setPrototypeOf(Wrapper, Class);
    };
    return $620aa032cca82da4$var$_wrapNativeSuper(Class);
}
function $620aa032cca82da4$var$isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $620aa032cca82da4$var$_construct(Parent, args, Class) {
    if ($620aa032cca82da4$var$isNativeReflectConstruct()) $620aa032cca82da4$var$_construct = Reflect.construct;
    else $620aa032cca82da4$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $620aa032cca82da4$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $620aa032cca82da4$var$_construct.apply(null, arguments);
}
function $620aa032cca82da4$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $620aa032cca82da4$var$_setPrototypeOf(o, p) {
    $620aa032cca82da4$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $620aa032cca82da4$var$_setPrototypeOf(o, p);
}
function $620aa032cca82da4$var$_getPrototypeOf(o) {
    $620aa032cca82da4$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $620aa032cca82da4$var$_getPrototypeOf(o);
}
function $620aa032cca82da4$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $620aa032cca82da4$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $620aa032cca82da4$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $620aa032cca82da4$var$_typeof(obj);
}

var $N7Lcz = parcelRequire("N7Lcz");
var $620aa032cca82da4$var$inspect = $N7Lcz.inspect;

var $cCihK = parcelRequire("cCihK");
var $620aa032cca82da4$var$ERR_INVALID_ARG_TYPE = $cCihK.codes.ERR_INVALID_ARG_TYPE; // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $620aa032cca82da4$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function $620aa032cca82da4$var$repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return "";
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var $620aa032cca82da4$var$blue = "";
var $620aa032cca82da4$var$green = "";
var $620aa032cca82da4$var$red = "";
var $620aa032cca82da4$var$white = "";
var $620aa032cca82da4$var$kReadableOperator = {
    deepStrictEqual: "Expected values to be strictly deep-equal:",
    strictEqual: "Expected values to be strictly equal:",
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: "Expected values to be loosely deep-equal:",
    equal: "Expected values to be loosely equal:",
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: "Values identical but not reference-equal:"
}; // Comparing short primitives should just show === / !== instead of using the
// diff.
var $620aa032cca82da4$var$kMaxShortLength = 10;
function $620aa032cca82da4$var$copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, "message", {
        value: source.message
    });
    return target;
}
function $620aa032cca82da4$var$inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return $620aa032cca82da4$var$inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function $620aa032cca82da4$var$createErrDiff(actual, expected, operator) {
    var other = "";
    var res = "";
    var lastPos = 0;
    var end = "";
    var skipped = false;
    var actualInspected = $620aa032cca82da4$var$inspectValue(actual);
    var actualLines = actualInspected.split("\n");
    var expectedLines = $620aa032cca82da4$var$inspectValue(expected).split("\n");
    var i = 0;
    var indicator = ""; // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === "strictEqual" && $620aa032cca82da4$var$_typeof(actual) === "object" && $620aa032cca82da4$var$_typeof(expected) === "object" && actual !== null && expected !== null) operator = "strictEqualObject";
     // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length; // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= $620aa032cca82da4$var$kMaxShortLength) {
            if (($620aa032cca82da4$var$_typeof(actual) !== "object" || actual === null) && ($620aa032cca82da4$var$_typeof(expected) !== "object" || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat($620aa032cca82da4$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== "strictEqualObject") {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = $hPtJY.stderr && $hPtJY.stderr.isTTY ? $hPtJY.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                 // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat($620aa032cca82da4$var$repeat(" ", i), "^");
                    i = 0;
                }
            }
        }
    } // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length); // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split("\n"); // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat($620aa032cca82da4$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join("\n"), "\n");
    }
    if (i > 3) {
        end = "\n".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white).concat(end);
        skipped = true;
    }
    if (other !== "") {
        end = "\n  ".concat(other).concat(end);
        other = "";
    }
    var printedLines = 0;
    var msg = $620aa032cca82da4$var$kReadableOperator[operator] + "\n".concat($620aa032cca82da4$var$green, "+ actual").concat($620aa032cca82da4$var$white, " ").concat($620aa032cca82da4$var$red, "- expected").concat($620aa032cca82da4$var$white);
    var skippedMsg = " ".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            } // Mark the current line as the last diverging one.
            lastPos = i; // Add the expected line to the cache.
            other += "\n".concat($620aa032cca82da4$var$red, "-").concat($620aa032cca82da4$var$white, " ").concat(expectedLines[i]);
            printedLines++; // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            } // Mark the current line as the last diverging one.
            lastPos = i; // Add the actual line to the result.
            res += "\n".concat($620aa032cca82da4$var$green, "+").concat($620aa032cca82da4$var$white, " ").concat(actualLines[i]);
            printedLines++; // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i]; // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!$620aa032cca82da4$var$endsWith(actualLine, ",") || actualLine.slice(0, -1) !== expectedLine); // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && $620aa032cca82da4$var$endsWith(expectedLine, ",") && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ",";
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                } // Mark the current line as the last diverging one.
                lastPos = i; // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat($620aa032cca82da4$var$green, "+").concat($620aa032cca82da4$var$white, " ").concat(actualLine);
                other += "\n".concat($620aa032cca82da4$var$red, "-").concat($620aa032cca82da4$var$white, " ").concat(expectedLine);
                printedLines += 2; // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = ""; // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        } // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white).concat(other, "\n") + "".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : "", "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var $620aa032cca82da4$var$AssertionError = /*#__PURE__*/ function(_Error) {
    $620aa032cca82da4$var$_inherits(AssertionError, _Error);
    function AssertionError(options) {
        var _this;
        $620aa032cca82da4$var$_classCallCheck(this, AssertionError);
        if ($620aa032cca82da4$var$_typeof(options) !== "object" || options === null) throw new $620aa032cca82da4$var$ERR_INVALID_ARG_TYPE("options", "Object", options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = $620aa032cca82da4$var$_possibleConstructorReturn(this, $620aa032cca82da4$var$_getPrototypeOf(AssertionError).call(this, String(message)));
        else {
            if ($hPtJY.stderr && $hPtJY.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if ($hPtJY.stderr && $hPtJY.stderr.getColorDepth && $hPtJY.stderr.getColorDepth() !== 1) {
                    $620aa032cca82da4$var$blue = "\x1b[34m";
                    $620aa032cca82da4$var$green = "\x1b[32m";
                    $620aa032cca82da4$var$white = "\x1b[39m";
                    $620aa032cca82da4$var$red = "\x1b[31m";
                } else {
                    $620aa032cca82da4$var$blue = "";
                    $620aa032cca82da4$var$green = "";
                    $620aa032cca82da4$var$white = "";
                    $620aa032cca82da4$var$red = "";
                }
            } // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if ($620aa032cca82da4$var$_typeof(actual) === "object" && actual !== null && $620aa032cca82da4$var$_typeof(expected) === "object" && expected !== null && "stack" in actual && actual instanceof Error && "stack" in expected && expected instanceof Error) {
                actual = $620aa032cca82da4$var$copyError(actual);
                expected = $620aa032cca82da4$var$copyError(expected);
            }
            if (operator === "deepStrictEqual" || operator === "strictEqual") _this = $620aa032cca82da4$var$_possibleConstructorReturn(this, $620aa032cca82da4$var$_getPrototypeOf(AssertionError).call(this, $620aa032cca82da4$var$createErrDiff(actual, expected, operator)));
            else if (operator === "notDeepStrictEqual" || operator === "notStrictEqual") {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = $620aa032cca82da4$var$kReadableOperator[operator];
                var res = $620aa032cca82da4$var$inspectValue(actual).split("\n"); // In case "actual" is an object, it should not be reference equal.
                if (operator === "notStrictEqual" && $620aa032cca82da4$var$_typeof(actual) === "object" && actual !== null) base = $620aa032cca82da4$var$kReadableOperator.notStrictEqualObject;
                 // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
                    while(res.length > 27)res.pop();
                } // Only print a single input.
                if (res.length === 1) _this = $620aa032cca82da4$var$_possibleConstructorReturn(this, $620aa032cca82da4$var$_getPrototypeOf(AssertionError).call(this, "".concat(base, " ").concat(res[0])));
                else _this = $620aa032cca82da4$var$_possibleConstructorReturn(this, $620aa032cca82da4$var$_getPrototypeOf(AssertionError).call(this, "".concat(base, "\n\n").concat(res.join("\n"), "\n")));
            } else {
                var _res = $620aa032cca82da4$var$inspectValue(actual);
                var other = "";
                var knownOperators = $620aa032cca82da4$var$kReadableOperator[operator];
                if (operator === "notDeepEqual" || operator === "notEqual") {
                    _res = "".concat($620aa032cca82da4$var$kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat($620aa032cca82da4$var$inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === "deepEqual" || operator === "equal") _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = $620aa032cca82da4$var$_possibleConstructorReturn(this, $620aa032cca82da4$var$_getPrototypeOf(AssertionError).call(this, "".concat(_res).concat(other)));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty($620aa032cca82da4$var$_assertThisInitialized(_this), "name", {
            value: "AssertionError [ERR_ASSERTION]",
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = "ERR_ASSERTION";
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace($620aa032cca82da4$var$_assertThisInitialized(_this), stackStartFn);
         // Create error message including the error code in the name.
        _this.stack; // Reset the name.
        _this.name = "AssertionError";
        return $620aa032cca82da4$var$_possibleConstructorReturn(_this);
    }
    $620aa032cca82da4$var$_createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: $620aa032cca82da4$var$inspect.custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return $620aa032cca82da4$var$inspect(this, $620aa032cca82da4$var$_objectSpread({}, ctx, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}($620aa032cca82da4$var$_wrapNativeSuper(Error));
module.exports = $620aa032cca82da4$var$AssertionError;

});

parcelRegister("dYBnA", function(module, exports) {
/**
 * Code refactored from Mozilla Developer Network:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 */ "use strict";
function $a2cddfb99e0a6135$var$assign(target, firstSource) {
    if (target === undefined || target === null) throw new TypeError("Cannot convert first argument to object");
    var to = Object(target);
    for(var i = 1; i < arguments.length; i++){
        var nextSource = arguments[i];
        if (nextSource === undefined || nextSource === null) continue;
        var keysArray = Object.keys(Object(nextSource));
        for(var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++){
            var nextKey = keysArray[nextIndex];
            var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
            if (desc !== undefined && desc.enumerable) to[nextKey] = nextSource[nextKey];
        }
    }
    return to;
}
function $a2cddfb99e0a6135$var$polyfill() {
    if (!Object.assign) Object.defineProperty(Object, "assign", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: $a2cddfb99e0a6135$var$assign
    });
}
module.exports = {
    assign: $a2cddfb99e0a6135$var$assign,
    polyfill: $a2cddfb99e0a6135$var$polyfill
};

});

parcelRegister("eT9RM", function(module, exports) {
"use strict";

var $1UbTr = parcelRequire("1UbTr");

var $cOB0F = parcelRequire("cOB0F");

var $6wuPW = parcelRequire("6wuPW");

var $5SxoI = parcelRequire("5SxoI");

var $bNbuK = parcelRequire("bNbuK");
var $ad6ddb07ef0cb149$var$polyfill = $cOB0F($5SxoI(), Object);
$1UbTr($ad6ddb07ef0cb149$var$polyfill, {
    getPolyfill: $5SxoI,
    implementation: $6wuPW,
    shim: $bNbuK
});
module.exports = $ad6ddb07ef0cb149$var$polyfill;

});
parcelRegister("1UbTr", function(module, exports) {
"use strict";

var $81enX = parcelRequire("81enX");
var $16343f2546a69e4c$var$hasSymbols = typeof Symbol === "function" && typeof Symbol("foo") === "symbol";
var $16343f2546a69e4c$var$toStr = Object.prototype.toString;
var $16343f2546a69e4c$var$concat = Array.prototype.concat;

var $5FEEt = parcelRequire("5FEEt");
var $16343f2546a69e4c$var$isFunction = function(fn) {
    return typeof fn === "function" && $16343f2546a69e4c$var$toStr.call(fn) === "[object Function]";
};

var $16343f2546a69e4c$var$supportsDescriptors = (parcelRequire("i16wS"))();
var $16343f2546a69e4c$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$16343f2546a69e4c$var$isFunction(predicate) || !predicate()) return;
    }
    if ($16343f2546a69e4c$var$supportsDescriptors) $5FEEt(object, name, value, true);
    else $5FEEt(object, name, value);
};
var $16343f2546a69e4c$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $81enX(map);
    if ($16343f2546a69e4c$var$hasSymbols) props = $16343f2546a69e4c$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$16343f2546a69e4c$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$16343f2546a69e4c$var$defineProperties.supportsDescriptors = !!$16343f2546a69e4c$var$supportsDescriptors;
module.exports = $16343f2546a69e4c$var$defineProperties;

});
parcelRegister("81enX", function(module, exports) {
"use strict";
var $5d69935f2747da8d$var$slice = Array.prototype.slice;

var $z1gio = parcelRequire("z1gio");
var $5d69935f2747da8d$var$origKeys = Object.keys;

var $5d69935f2747da8d$var$keysShim = $5d69935f2747da8d$var$origKeys ? function keys(o) {
    return $5d69935f2747da8d$var$origKeys(o);
} : (parcelRequire("4nFCC"));
var $5d69935f2747da8d$var$originalKeys = Object.keys;
$5d69935f2747da8d$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($z1gio(object)) return $5d69935f2747da8d$var$originalKeys($5d69935f2747da8d$var$slice.call(object));
            return $5d69935f2747da8d$var$originalKeys(object);
        };
    } else Object.keys = $5d69935f2747da8d$var$keysShim;
    return Object.keys || $5d69935f2747da8d$var$keysShim;
};
module.exports = $5d69935f2747da8d$var$keysShim;

});
parcelRegister("z1gio", function(module, exports) {
"use strict";
var $06943f92b55ad7fa$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $06943f92b55ad7fa$var$toStr.call(value);
    var isArgs = str === "[object Arguments]";
    if (!isArgs) isArgs = str !== "[object Array]" && value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $06943f92b55ad7fa$var$toStr.call(value.callee) === "[object Function]";
    return isArgs;
};

});

parcelRegister("4nFCC", function(module, exports) {
"use strict";
var $330998a67e44345d$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $330998a67e44345d$var$has = Object.prototype.hasOwnProperty;
    var $330998a67e44345d$var$toStr = Object.prototype.toString;
    var $330998a67e44345d$var$isArgs = (parcelRequire("z1gio")); // eslint-disable-line global-require
    var $330998a67e44345d$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $330998a67e44345d$var$hasDontEnumBug = !$330998a67e44345d$var$isEnumerable.call({
        toString: null
    }, "toString");
    var $330998a67e44345d$var$hasProtoEnumBug = $330998a67e44345d$var$isEnumerable.call(function() {}, "prototype");
    var $330998a67e44345d$var$dontEnums = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor"
    ];
    var $330998a67e44345d$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $330998a67e44345d$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $330998a67e44345d$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === "undefined") return false;
        for(var k in window)try {
            if (!$330998a67e44345d$var$excludedKeys["$" + k] && $330998a67e44345d$var$has.call(window, k) && window[k] !== null && typeof window[k] === "object") try {
                $330998a67e44345d$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $330998a67e44345d$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === "undefined" || !$330998a67e44345d$var$hasAutomationEqualityBug) return $330998a67e44345d$var$equalsConstructorPrototype(o);
        try {
            return $330998a67e44345d$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $330998a67e44345d$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === "object";
        var isFunction = $330998a67e44345d$var$toStr.call(object) === "[object Function]";
        var isArguments = $330998a67e44345d$var$isArgs(object);
        var isString = isObject && $330998a67e44345d$var$toStr.call(object) === "[object String]";
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError("Object.keys called on a non-object");
        var skipProto = $330998a67e44345d$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$330998a67e44345d$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === "prototype") && $330998a67e44345d$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($330998a67e44345d$var$hasDontEnumBug) {
            var skipConstructor = $330998a67e44345d$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $330998a67e44345d$var$dontEnums.length; ++k)if (!(skipConstructor && $330998a67e44345d$var$dontEnums[k] === "constructor") && $330998a67e44345d$var$has.call(object, $330998a67e44345d$var$dontEnums[k])) theKeys.push($330998a67e44345d$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $330998a67e44345d$var$keysShim;

});



parcelRegister("6wuPW", function(module, exports) {
"use strict";
var $4bfda6cb765ad269$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($4bfda6cb765ad269$var$numberIsNaN(a) && $4bfda6cb765ad269$var$numberIsNaN(b)) return true;
    return false;
};

});

parcelRegister("5SxoI", function(module, exports) {
"use strict";

var $6wuPW = parcelRequire("6wuPW");
module.exports = function getPolyfill() {
    return typeof Object.is === "function" ? Object.is : $6wuPW;
};

});

parcelRegister("bNbuK", function(module, exports) {
"use strict";

var $5SxoI = parcelRequire("5SxoI");

var $1UbTr = parcelRequire("1UbTr");
module.exports = function shimObjectIs() {
    var polyfill = $5SxoI();
    $1UbTr(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRegister("3LKhK", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
"use strict";
function $2be9aa30bff457b9$var$_slicedToArray(arr, i) {
    return $2be9aa30bff457b9$var$_arrayWithHoles(arr) || $2be9aa30bff457b9$var$_iterableToArrayLimit(arr, i) || $2be9aa30bff457b9$var$_nonIterableRest();
}
function $2be9aa30bff457b9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function $2be9aa30bff457b9$var$_iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $2be9aa30bff457b9$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $2be9aa30bff457b9$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $2be9aa30bff457b9$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $2be9aa30bff457b9$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $2be9aa30bff457b9$var$_typeof(obj);
}
var $2be9aa30bff457b9$var$regexFlagsSupported = /a/g.flags !== undefined;
var $2be9aa30bff457b9$var$arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var $2be9aa30bff457b9$var$arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};

var $2be9aa30bff457b9$var$objectIs = Object.is ? Object.is : (parcelRequire("eT9RM"));
var $2be9aa30bff457b9$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};

var $2be9aa30bff457b9$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("c8Cyq"));
function $2be9aa30bff457b9$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $2be9aa30bff457b9$var$hasOwnProperty = $2be9aa30bff457b9$var$uncurryThis(Object.prototype.hasOwnProperty);
var $2be9aa30bff457b9$var$propertyIsEnumerable = $2be9aa30bff457b9$var$uncurryThis(Object.prototype.propertyIsEnumerable);
var $2be9aa30bff457b9$var$objectToString = $2be9aa30bff457b9$var$uncurryThis(Object.prototype.toString);

var $N7Lcz = parcelRequire("N7Lcz");
var $2be9aa30bff457b9$require$_require$types = $N7Lcz.types;
var $2be9aa30bff457b9$var$isAnyArrayBuffer = $2be9aa30bff457b9$require$_require$types.isAnyArrayBuffer, $2be9aa30bff457b9$var$isArrayBufferView = $2be9aa30bff457b9$require$_require$types.isArrayBufferView, $2be9aa30bff457b9$var$isDate = $2be9aa30bff457b9$require$_require$types.isDate, $2be9aa30bff457b9$var$isMap = $2be9aa30bff457b9$require$_require$types.isMap, $2be9aa30bff457b9$var$isRegExp = $2be9aa30bff457b9$require$_require$types.isRegExp, $2be9aa30bff457b9$var$isSet = $2be9aa30bff457b9$require$_require$types.isSet, $2be9aa30bff457b9$var$isNativeError = $2be9aa30bff457b9$require$_require$types.isNativeError, $2be9aa30bff457b9$var$isBoxedPrimitive = $2be9aa30bff457b9$require$_require$types.isBoxedPrimitive, $2be9aa30bff457b9$var$isNumberObject = $2be9aa30bff457b9$require$_require$types.isNumberObject, $2be9aa30bff457b9$var$isStringObject = $2be9aa30bff457b9$require$_require$types.isStringObject, $2be9aa30bff457b9$var$isBooleanObject = $2be9aa30bff457b9$require$_require$types.isBooleanObject, $2be9aa30bff457b9$var$isBigIntObject = $2be9aa30bff457b9$require$_require$types.isBigIntObject, $2be9aa30bff457b9$var$isSymbolObject = $2be9aa30bff457b9$require$_require$types.isSymbolObject, $2be9aa30bff457b9$var$isFloat32Array = $2be9aa30bff457b9$require$_require$types.isFloat32Array, $2be9aa30bff457b9$var$isFloat64Array = $2be9aa30bff457b9$require$_require$types.isFloat64Array;
function $2be9aa30bff457b9$var$isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    } // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function $2be9aa30bff457b9$var$getOwnNonIndexProperties(value) {
    return Object.keys(value).filter($2be9aa30bff457b9$var$isNonIndex).concat($2be9aa30bff457b9$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
} // Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function $2be9aa30bff457b9$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $2be9aa30bff457b9$var$ONLY_ENUMERABLE = undefined;
var $2be9aa30bff457b9$var$kStrict = true;
var $2be9aa30bff457b9$var$kLoose = false;
var $2be9aa30bff457b9$var$kNoIterator = 0;
var $2be9aa30bff457b9$var$kIsArray = 1;
var $2be9aa30bff457b9$var$kIsSet = 2;
var $2be9aa30bff457b9$var$kIsMap = 3; // Check if they have the same source and flags
function $2be9aa30bff457b9$var$areSimilarRegExps(a, b) {
    return $2be9aa30bff457b9$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function $2be9aa30bff457b9$var$areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function $2be9aa30bff457b9$var$areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $2be9aa30bff457b9$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function $2be9aa30bff457b9$var$areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && $2be9aa30bff457b9$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function $2be9aa30bff457b9$var$isEqualBoxedPrimitive(val1, val2) {
    if ($2be9aa30bff457b9$var$isNumberObject(val1)) return $2be9aa30bff457b9$var$isNumberObject(val2) && $2be9aa30bff457b9$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if ($2be9aa30bff457b9$var$isStringObject(val1)) return $2be9aa30bff457b9$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if ($2be9aa30bff457b9$var$isBooleanObject(val1)) return $2be9aa30bff457b9$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if ($2be9aa30bff457b9$var$isBigIntObject(val1)) return $2be9aa30bff457b9$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return $2be9aa30bff457b9$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
} // Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function $2be9aa30bff457b9$var$innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? $2be9aa30bff457b9$var$objectIs(val1, val2) : true;
    } // Check more closely if val1 and val2 are equal.
    if (strict) {
        if ($2be9aa30bff457b9$var$_typeof(val1) !== "object") return typeof val1 === "number" && $2be9aa30bff457b9$var$numberIsNaN(val1) && $2be9aa30bff457b9$var$numberIsNaN(val2);
        if ($2be9aa30bff457b9$var$_typeof(val2) !== "object" || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || $2be9aa30bff457b9$var$_typeof(val1) !== "object") {
            if (val2 === null || $2be9aa30bff457b9$var$_typeof(val2) !== "object") // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || $2be9aa30bff457b9$var$_typeof(val2) !== "object") return false;
    }
    var val1Tag = $2be9aa30bff457b9$var$objectToString(val1);
    var val2Tag = $2be9aa30bff457b9$var$objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = $2be9aa30bff457b9$var$getOwnNonIndexProperties(val1, $2be9aa30bff457b9$var$ONLY_ENUMERABLE);
        var keys2 = $2be9aa30bff457b9$var$getOwnNonIndexProperties(val2, $2be9aa30bff457b9$var$ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, $2be9aa30bff457b9$var$kIsArray, keys1);
    } // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === "[object Object]") {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!$2be9aa30bff457b9$var$isMap(val1) && $2be9aa30bff457b9$var$isMap(val2) || !$2be9aa30bff457b9$var$isSet(val1) && $2be9aa30bff457b9$var$isSet(val2)) return false;
    }
    if ($2be9aa30bff457b9$var$isDate(val1)) {
        if (!$2be9aa30bff457b9$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if ($2be9aa30bff457b9$var$isRegExp(val1)) {
        if (!$2be9aa30bff457b9$var$isRegExp(val2) || !$2be9aa30bff457b9$var$areSimilarRegExps(val1, val2)) return false;
    } else if ($2be9aa30bff457b9$var$isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if ($2be9aa30bff457b9$var$isArrayBufferView(val1)) {
        if (!strict && ($2be9aa30bff457b9$var$isFloat32Array(val1) || $2be9aa30bff457b9$var$isFloat64Array(val1))) {
            if (!$2be9aa30bff457b9$var$areSimilarFloatArrays(val1, val2)) return false;
        } else if (!$2be9aa30bff457b9$var$areSimilarTypedArrays(val1, val2)) return false;
         // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = $2be9aa30bff457b9$var$getOwnNonIndexProperties(val1, $2be9aa30bff457b9$var$ONLY_ENUMERABLE);
        var _keys2 = $2be9aa30bff457b9$var$getOwnNonIndexProperties(val2, $2be9aa30bff457b9$var$ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, $2be9aa30bff457b9$var$kNoIterator, _keys);
    } else if ($2be9aa30bff457b9$var$isSet(val1)) {
        if (!$2be9aa30bff457b9$var$isSet(val2) || val1.size !== val2.size) return false;
        return $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, $2be9aa30bff457b9$var$kIsSet);
    } else if ($2be9aa30bff457b9$var$isMap(val1)) {
        if (!$2be9aa30bff457b9$var$isMap(val2) || val1.size !== val2.size) return false;
        return $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, $2be9aa30bff457b9$var$kIsMap);
    } else if ($2be9aa30bff457b9$var$isAnyArrayBuffer(val1)) {
        if (!$2be9aa30bff457b9$var$areEqualArrayBuffers(val1, val2)) return false;
    } else if ($2be9aa30bff457b9$var$isBoxedPrimitive(val1) && !$2be9aa30bff457b9$var$isEqualBoxedPrimitive(val1, val2)) return false;
    return $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, $2be9aa30bff457b9$var$kNoIterator);
}
function $2be9aa30bff457b9$var$getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return $2be9aa30bff457b9$var$propertyIsEnumerable(val, k);
    });
}
function $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2); // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    } // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!$2be9aa30bff457b9$var$hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = $2be9aa30bff457b9$var$objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if ($2be9aa30bff457b9$var$propertyIsEnumerable(val1, key)) {
                    if (!$2be9aa30bff457b9$var$propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if ($2be9aa30bff457b9$var$propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = $2be9aa30bff457b9$var$objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && $2be9aa30bff457b9$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = $2be9aa30bff457b9$var$objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && $2be9aa30bff457b9$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === $2be9aa30bff457b9$var$kNoIterator || iterationType === $2be9aa30bff457b9$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
     // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = $2be9aa30bff457b9$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function $2be9aa30bff457b9$var$setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = $2be9aa30bff457b9$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if ($2be9aa30bff457b9$var$innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
} // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function $2be9aa30bff457b9$var$findLooseMatchingPrimitives(prim) {
    switch($2be9aa30bff457b9$var$_typeof(prim)){
        case "undefined":
            return null;
        case "object":
            // Only pass in null as object!
            return undefined;
        case "symbol":
            return false;
        case "string":
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case "number":
            if ($2be9aa30bff457b9$var$numberIsNaN(prim)) return false;
    }
    return true;
}
function $2be9aa30bff457b9$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $2be9aa30bff457b9$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function $2be9aa30bff457b9$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = $2be9aa30bff457b9$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !$2be9aa30bff457b9$var$innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && $2be9aa30bff457b9$var$innerDeepEqual(item, curB, false, memo);
}
function $2be9aa30bff457b9$var$setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = $2be9aa30bff457b9$var$arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i]; // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if ($2be9aa30bff457b9$var$_typeof(val) === "object" && val !== null) {
            if (set === null) set = new Set();
             // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false; // Fast path to detect missing string, symbol, undefined and null values.
            if (!$2be9aa30bff457b9$var$setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = $2be9aa30bff457b9$var$arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i]; // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if ($2be9aa30bff457b9$var$_typeof(_val) === "object" && _val !== null) {
                if (!$2be9aa30bff457b9$var$setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !$2be9aa30bff457b9$var$setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $2be9aa30bff457b9$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = $2be9aa30bff457b9$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if ($2be9aa30bff457b9$var$innerDeepEqual(key1, key2, strict, memo) && $2be9aa30bff457b9$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function $2be9aa30bff457b9$var$mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = $2be9aa30bff457b9$var$arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = $2be9aa30bff457b9$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if ($2be9aa30bff457b9$var$_typeof(key) === "object" && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !$2be9aa30bff457b9$var$innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false; // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!$2be9aa30bff457b9$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = $2be9aa30bff457b9$var$arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = $2be9aa30bff457b9$var$_slicedToArray(bEntries[_i2], 2), key = _bEntries$_i[0], item = _bEntries$_i[1];
            if ($2be9aa30bff457b9$var$_typeof(key) === "object" && key !== null) {
                if (!$2be9aa30bff457b9$var$mapHasEqualEntry(set, a, key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(key) || !$2be9aa30bff457b9$var$innerDeepEqual(a.get(key), item, false, memo)) && !$2be9aa30bff457b9$var$mapHasEqualEntry(set, a, key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $2be9aa30bff457b9$var$objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === $2be9aa30bff457b9$var$kIsSet) {
        if (!$2be9aa30bff457b9$var$setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $2be9aa30bff457b9$var$kIsMap) {
        if (!$2be9aa30bff457b9$var$mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $2be9aa30bff457b9$var$kIsArray) for(; i < a.length; i++){
        if ($2be9aa30bff457b9$var$hasOwnProperty(a, i)) {
            if (!$2be9aa30bff457b9$var$hasOwnProperty(b, i) || !$2be9aa30bff457b9$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if ($2be9aa30bff457b9$var$hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!$2be9aa30bff457b9$var$hasOwnProperty(b, key) || !$2be9aa30bff457b9$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
     // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key = keys[i];
        if (!$2be9aa30bff457b9$var$innerDeepEqual(a[_key], b[_key], strict, memos)) return false;
    }
    return true;
}
function $2be9aa30bff457b9$var$isDeepEqual(val1, val2) {
    return $2be9aa30bff457b9$var$innerDeepEqual(val1, val2, $2be9aa30bff457b9$var$kLoose);
}
function $2be9aa30bff457b9$var$isDeepStrictEqual(val1, val2) {
    return $2be9aa30bff457b9$var$innerDeepEqual(val1, val2, $2be9aa30bff457b9$var$kStrict);
}
module.exports = {
    isDeepEqual: $2be9aa30bff457b9$var$isDeepEqual,
    isDeepStrictEqual: $2be9aa30bff457b9$var$isDeepStrictEqual
};

});
parcelRegister("c8Cyq", function(module, exports) {
"use strict";

var $cOB0F = parcelRequire("cOB0F");

var $1UbTr = parcelRequire("1UbTr");

var $8sYH2 = parcelRequire("8sYH2");

var $91M8b = parcelRequire("91M8b");

var $hCf9I = parcelRequire("hCf9I");
var $8d642377f5822430$var$polyfill = $cOB0F($91M8b(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ $1UbTr($8d642377f5822430$var$polyfill, {
    getPolyfill: $91M8b,
    implementation: $8sYH2,
    shim: $hCf9I
});
module.exports = $8d642377f5822430$var$polyfill;

});
parcelRegister("8sYH2", function(module, exports) {
"use strict";
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

});

parcelRegister("91M8b", function(module, exports) {
"use strict";

var $8sYH2 = parcelRequire("8sYH2");
module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN("a")) return Number.isNaN;
    return $8sYH2;
};

});

parcelRegister("hCf9I", function(module, exports) {
"use strict";

var $1UbTr = parcelRequire("1UbTr");

var $91M8b = parcelRequire("91M8b");
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = $91M8b();
    $1UbTr(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

});




parcelRegister("9WDto", function(module, exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $73d8265e2c50d00b$var$ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = "" /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
module.exports = $73d8265e2c50d00b$var$ZStream;

});

parcelRegister("lGf86", function(module, exports) {

$parcel$export(module.exports, "deflateInit2", () => $fc8941aa2060205a$export$a65c7b2bde87cb70, (v) => $fc8941aa2060205a$export$a65c7b2bde87cb70 = v);
$parcel$export(module.exports, "deflateReset", () => $fc8941aa2060205a$export$8f99f0e30bc7dd53, (v) => $fc8941aa2060205a$export$8f99f0e30bc7dd53 = v);
$parcel$export(module.exports, "deflate", () => $fc8941aa2060205a$export$2316623ecd1285ab, (v) => $fc8941aa2060205a$export$2316623ecd1285ab = v);
$parcel$export(module.exports, "deflateEnd", () => $fc8941aa2060205a$export$599854fa319a815f, (v) => $fc8941aa2060205a$export$599854fa319a815f = v);
$parcel$export(module.exports, "deflateSetDictionary", () => $fc8941aa2060205a$export$f55e0b3ab66b5d46, (v) => $fc8941aa2060205a$export$f55e0b3ab66b5d46 = v);
var $fc8941aa2060205a$export$72b35d618fb8ad9b;
var $fc8941aa2060205a$export$a65c7b2bde87cb70;
var $fc8941aa2060205a$export$8f99f0e30bc7dd53;
var $fc8941aa2060205a$export$e78fab288549509;
var $fc8941aa2060205a$export$1cd50f7b2515ba19;
var $fc8941aa2060205a$export$2316623ecd1285ab;
var $fc8941aa2060205a$export$599854fa319a815f;
var $fc8941aa2060205a$export$f55e0b3ab66b5d46;
var $fc8941aa2060205a$export$12b6e1fcadea22f9;
"use strict";

var $9CLQF = parcelRequire("9CLQF");

var $hx6dX = parcelRequire("hx6dX");

var $gJUj4 = parcelRequire("gJUj4");

var $5UMyJ = parcelRequire("5UMyJ");

var $7gAmB = parcelRequire("7gAmB");
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ var $fc8941aa2060205a$var$Z_NO_FLUSH = 0;
var $fc8941aa2060205a$var$Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var $fc8941aa2060205a$var$Z_FULL_FLUSH = 3;
var $fc8941aa2060205a$var$Z_FINISH = 4;
var $fc8941aa2060205a$var$Z_BLOCK = 5;
//var Z_TREES         = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var $fc8941aa2060205a$var$Z_OK = 0;
var $fc8941aa2060205a$var$Z_STREAM_END = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var $fc8941aa2060205a$var$Z_STREAM_ERROR = -2;
var $fc8941aa2060205a$var$Z_DATA_ERROR = -3;
//var Z_MEM_ERROR     = -4;
var $fc8941aa2060205a$var$Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* compression levels */ //var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var $fc8941aa2060205a$var$Z_DEFAULT_COMPRESSION = -1;
var $fc8941aa2060205a$var$Z_FILTERED = 1;
var $fc8941aa2060205a$var$Z_HUFFMAN_ONLY = 2;
var $fc8941aa2060205a$var$Z_RLE = 3;
var $fc8941aa2060205a$var$Z_FIXED = 4;
var $fc8941aa2060205a$var$Z_DEFAULT_STRATEGY = 0;
/* Possible values of the data_type field (though see inflate()) */ //var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var $fc8941aa2060205a$var$Z_UNKNOWN = 2;
/* The deflate compression method */ var $fc8941aa2060205a$var$Z_DEFLATED = 8;
/*============================================================================*/ var $fc8941aa2060205a$var$MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ var $fc8941aa2060205a$var$MAX_WBITS = 15;
/* 32K LZ77 window */ var $fc8941aa2060205a$var$DEF_MEM_LEVEL = 8;
var $fc8941aa2060205a$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $fc8941aa2060205a$var$LITERALS = 256;
/* number of literal bytes 0..255 */ var $fc8941aa2060205a$var$L_CODES = $fc8941aa2060205a$var$LITERALS + 1 + $fc8941aa2060205a$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var $fc8941aa2060205a$var$D_CODES = 30;
/* number of distance codes */ var $fc8941aa2060205a$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var $fc8941aa2060205a$var$HEAP_SIZE = 2 * $fc8941aa2060205a$var$L_CODES + 1;
/* maximum heap size */ var $fc8941aa2060205a$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var $fc8941aa2060205a$var$MIN_MATCH = 3;
var $fc8941aa2060205a$var$MAX_MATCH = 258;
var $fc8941aa2060205a$var$MIN_LOOKAHEAD = $fc8941aa2060205a$var$MAX_MATCH + $fc8941aa2060205a$var$MIN_MATCH + 1;
var $fc8941aa2060205a$var$PRESET_DICT = 0x20;
var $fc8941aa2060205a$var$INIT_STATE = 42;
var $fc8941aa2060205a$var$EXTRA_STATE = 69;
var $fc8941aa2060205a$var$NAME_STATE = 73;
var $fc8941aa2060205a$var$COMMENT_STATE = 91;
var $fc8941aa2060205a$var$HCRC_STATE = 103;
var $fc8941aa2060205a$var$BUSY_STATE = 113;
var $fc8941aa2060205a$var$FINISH_STATE = 666;
var $fc8941aa2060205a$var$BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
var $fc8941aa2060205a$var$BS_BLOCK_DONE = 2; /* block flush performed */ 
var $fc8941aa2060205a$var$BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
var $fc8941aa2060205a$var$BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
var $fc8941aa2060205a$var$OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
function $fc8941aa2060205a$var$err(strm, errorCode) {
    strm.msg = $7gAmB[errorCode];
    return errorCode;
}
function $fc8941aa2060205a$var$rank(f) {
    return (f << 1) - (f > 4 ? 9 : 0);
}
function $fc8941aa2060205a$var$zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */ function $fc8941aa2060205a$var$flush_pending(strm) {
    var s = strm.state;
    //_tr_flush_bits(s);
    var len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    $9CLQF.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
}
function $fc8941aa2060205a$var$flush_block_only(s, last) {
    $hx6dX._tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    $fc8941aa2060205a$var$flush_pending(s.strm);
}
function $fc8941aa2060205a$var$put_byte(s, b) {
    s.pending_buf[s.pending++] = b;
}
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ function $fc8941aa2060205a$var$putShortMSB(s, b) {
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
}
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ function $fc8941aa2060205a$var$read_buf(strm, buf, start, size) {
    var len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    $9CLQF.arraySet(buf, strm.input, strm.next_in, len, start);
    if (strm.state.wrap === 1) strm.adler = $gJUj4(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = $5UMyJ(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
}
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ function $fc8941aa2060205a$var$longest_match(s, cur_match) {
    var chain_length = s.max_chain_length; /* max hash chain length */ 
    var scan = s.strstart; /* current string */ 
    var match; /* matched string */ 
    var len; /* length of current match */ 
    var best_len = s.prev_length; /* best match length so far */ 
    var nice_match = s.nice_match; /* stop if match long enough */ 
    var limit = s.strstart > s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD ? s.strstart - (s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    var _win = s.window; // shortcut
    var wmask = s.w_mask;
    var prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ var strend = s.strstart + $fc8941aa2060205a$var$MAX_MATCH;
    var scan_end1 = _win[scan + best_len - 1];
    var scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = $fc8941aa2060205a$var$MAX_MATCH - (strend - scan);
        scan = strend - $fc8941aa2060205a$var$MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
}
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ function $fc8941aa2060205a$var$fill_window(s) {
    var _w_size = s.w_size;
    var p, n, m, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD)) {
            $9CLQF.arraySet(s.window, s.window, _w_size, _w_size, 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */ n = s.hash_size;
            p = n;
            do {
                m = s.head[--p];
                s.head[p] = m >= _w_size ? m - _w_size : 0;
            }while (--n);
            n = _w_size;
            p = n;
            do {
                m = s.prev[--p];
                s.prev[p] = m >= _w_size ? m - _w_size : 0;
            /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */ }while (--n);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = $fc8941aa2060205a$var$read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= $fc8941aa2060205a$var$MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < $fc8941aa2060205a$var$MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */ function $fc8941aa2060205a$var$deflate_stored(s, flush) {
    /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */ var max_block_size = 0xffff;
    if (max_block_size > s.pending_buf_size - 5) max_block_size = s.pending_buf_size - 5;
    /* Copy as much as possible from input to output: */ for(;;){
        /* Fill the window as much as possible: */ if (s.lookahead <= 1) {
            //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
            //  s->block_start >= (long)s->w_size, "slide too late");
            //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
            //        s.block_start >= s.w_size)) {
            //        throw  new Error("slide too late");
            //      }
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead === 0 && flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
        /* flush the current block */ }
        //Assert(s->block_start >= 0L, "block gone");
        //    if (s.block_start < 0) throw new Error("block gone");
        s.strstart += s.lookahead;
        s.lookahead = 0;
        /* Emit a stored block if pending_buf will be full: */ var max_start = s.block_start + max_block_size;
        if (s.strstart === 0 || s.strstart >= max_start) {
            /* strstart == 0 is possible when wraparound on 16-bit machine */ s.lookahead = s.strstart - max_start;
            s.strstart = max_start;
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
        /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */ if (s.strstart - s.block_start >= s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD) {
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.strstart > s.block_start) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_NEED_MORE;
}
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ function $fc8941aa2060205a$var$deflate_fast(s, flush) {
    var hash_head; /* head of the hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD) {
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD && flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $fc8941aa2060205a$var$longest_match(s, hash_head);
        if (s.match_length >= $fc8941aa2060205a$var$MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = $hx6dX._tr_tally(s, s.strstart - s.match_start, s.match_length - $fc8941aa2060205a$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $hx6dX._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < $fc8941aa2060205a$var$MIN_MATCH - 1 ? s.strstart : $fc8941aa2060205a$var$MIN_MATCH - 1;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ function $fc8941aa2060205a$var$deflate_slow(s, flush) {
    var hash_head; /* head of hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    var max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD) {
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD && flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $fc8941aa2060205a$var$longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === $fc8941aa2060205a$var$Z_FILTERED || s.match_length === $fc8941aa2060205a$var$MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= $fc8941aa2060205a$var$MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - $fc8941aa2060205a$var$MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = $hx6dX._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - $fc8941aa2060205a$var$MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
                if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $hx6dX._tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $hx6dX._tr_tally(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < $fc8941aa2060205a$var$MIN_MATCH - 1 ? s.strstart : $fc8941aa2060205a$var$MIN_MATCH - 1;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ function $fc8941aa2060205a$var$deflate_rle(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    var prev; /* byte at distance one to match */ 
    var scan, strend; /* scan goes up to strend for length of run */ 
    var _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= $fc8941aa2060205a$var$MAX_MATCH) {
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead <= $fc8941aa2060205a$var$MAX_MATCH && flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + $fc8941aa2060205a$var$MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = $fc8941aa2060205a$var$MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= $fc8941aa2060205a$var$MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = $hx6dX._tr_tally(s, 1, s.match_length - $fc8941aa2060205a$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $hx6dX._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ function $fc8941aa2060205a$var$deflate_huff(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead === 0) {
                if (flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $hx6dX._tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_BLOCK_DONE;
}
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function $fc8941aa2060205a$var$Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
var $fc8941aa2060205a$var$configuration_table;
$fc8941aa2060205a$var$configuration_table = [
    /*      good lazy nice chain */ new $fc8941aa2060205a$var$Config(0, 0, 0, 0, $fc8941aa2060205a$var$deflate_stored),
    /* 0 store only */ new $fc8941aa2060205a$var$Config(4, 4, 8, 4, $fc8941aa2060205a$var$deflate_fast),
    /* 1 max speed, no lazy matches */ new $fc8941aa2060205a$var$Config(4, 5, 16, 8, $fc8941aa2060205a$var$deflate_fast),
    /* 2 */ new $fc8941aa2060205a$var$Config(4, 6, 32, 32, $fc8941aa2060205a$var$deflate_fast),
    /* 3 */ new $fc8941aa2060205a$var$Config(4, 4, 16, 16, $fc8941aa2060205a$var$deflate_slow),
    /* 4 lazy matches */ new $fc8941aa2060205a$var$Config(8, 16, 32, 32, $fc8941aa2060205a$var$deflate_slow),
    /* 5 */ new $fc8941aa2060205a$var$Config(8, 16, 128, 128, $fc8941aa2060205a$var$deflate_slow),
    /* 6 */ new $fc8941aa2060205a$var$Config(8, 32, 128, 256, $fc8941aa2060205a$var$deflate_slow),
    /* 7 */ new $fc8941aa2060205a$var$Config(32, 128, 258, 1024, $fc8941aa2060205a$var$deflate_slow),
    /* 8 */ new $fc8941aa2060205a$var$Config(32, 258, 258, 4096, $fc8941aa2060205a$var$deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ function $fc8941aa2060205a$var$lm_init(s) {
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ $fc8941aa2060205a$var$zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = $fc8941aa2060205a$var$configuration_table[s.level].max_lazy;
    s.good_match = $fc8941aa2060205a$var$configuration_table[s.level].good_length;
    s.nice_match = $fc8941aa2060205a$var$configuration_table[s.level].nice_length;
    s.max_chain_length = $fc8941aa2060205a$var$configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
}
function $fc8941aa2060205a$var$DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = $fc8941aa2060205a$var$Z_DEFLATED; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new $9CLQF.Buf16($fc8941aa2060205a$var$HEAP_SIZE * 2);
    this.dyn_dtree = new $9CLQF.Buf16((2 * $fc8941aa2060205a$var$D_CODES + 1) * 2);
    this.bl_tree = new $9CLQF.Buf16((2 * $fc8941aa2060205a$var$BL_CODES + 1) * 2);
    $fc8941aa2060205a$var$zero(this.dyn_ltree);
    $fc8941aa2060205a$var$zero(this.dyn_dtree);
    $fc8941aa2060205a$var$zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new $9CLQF.Buf16($fc8941aa2060205a$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new $9CLQF.Buf16(2 * $fc8941aa2060205a$var$L_CODES + 1); /* heap used to build the Huffman trees */ 
    $fc8941aa2060205a$var$zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new $9CLQF.Buf16(2 * $fc8941aa2060205a$var$L_CODES + 1); //uch depth[2*L_CODES+1];
    $fc8941aa2060205a$var$zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.l_buf = 0; /* buffer index for literals or lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.last_lit = 0; /* running index in l_buf */ 
    this.d_buf = 0;
    /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */ this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
function $fc8941aa2060205a$var$deflateResetKeep(strm) {
    var s;
    if (!strm || !strm.state) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_STREAM_ERROR);
    strm.total_in = strm.total_out = 0;
    strm.data_type = $fc8941aa2060205a$var$Z_UNKNOWN;
    s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = s.wrap ? $fc8941aa2060205a$var$INIT_STATE : $fc8941aa2060205a$var$BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = $fc8941aa2060205a$var$Z_NO_FLUSH;
    $hx6dX._tr_init(s);
    return $fc8941aa2060205a$var$Z_OK;
}
function $fc8941aa2060205a$var$deflateReset(strm) {
    var ret = $fc8941aa2060205a$var$deflateResetKeep(strm);
    if (ret === $fc8941aa2060205a$var$Z_OK) $fc8941aa2060205a$var$lm_init(strm.state);
    return ret;
}
function $fc8941aa2060205a$var$deflateSetHeader(strm, head) {
    if (!strm || !strm.state) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    if (strm.state.wrap !== 2) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    strm.state.gzhead = head;
    return $fc8941aa2060205a$var$Z_OK;
}
function $fc8941aa2060205a$var$deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
    if (!strm) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    var wrap = 1;
    if (level === $fc8941aa2060205a$var$Z_DEFAULT_COMPRESSION) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > $fc8941aa2060205a$var$MAX_MEM_LEVEL || method !== $fc8941aa2060205a$var$Z_DEFLATED || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > $fc8941aa2060205a$var$Z_FIXED) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_STREAM_ERROR);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ var s = new $fc8941aa2060205a$var$DeflateState();
    strm.state = s;
    s.strm = strm;
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + $fc8941aa2060205a$var$MIN_MATCH - 1) / $fc8941aa2060205a$var$MIN_MATCH);
    s.window = new $9CLQF.Buf8(s.w_size * 2);
    s.head = new $9CLQF.Buf16(s.hash_size);
    s.prev = new $9CLQF.Buf16(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    s.pending_buf_size = s.lit_bufsize * 4;
    //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
    //s->pending_buf = (uchf *) overlay;
    s.pending_buf = new $9CLQF.Buf8(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
    s.d_buf = 1 * s.lit_bufsize;
    //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
    s.l_buf = 3 * s.lit_bufsize;
    s.level = level;
    s.strategy = strategy;
    s.method = method;
    return $fc8941aa2060205a$var$deflateReset(strm);
}
function $fc8941aa2060205a$var$deflateInit(strm, level) {
    return $fc8941aa2060205a$var$deflateInit2(strm, level, $fc8941aa2060205a$var$Z_DEFLATED, $fc8941aa2060205a$var$MAX_WBITS, $fc8941aa2060205a$var$DEF_MEM_LEVEL, $fc8941aa2060205a$var$Z_DEFAULT_STRATEGY);
}
function $fc8941aa2060205a$var$deflate(strm, flush) {
    var old_flush, s;
    var beg, val; // for gzip header write only
    if (!strm || !strm.state || flush > $fc8941aa2060205a$var$Z_BLOCK || flush < 0) return strm ? $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_STREAM_ERROR) : $fc8941aa2060205a$var$Z_STREAM_ERROR;
    s = strm.state;
    if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === $fc8941aa2060205a$var$FINISH_STATE && flush !== $fc8941aa2060205a$var$Z_FINISH) return $fc8941aa2060205a$var$err(strm, strm.avail_out === 0 ? $fc8941aa2060205a$var$Z_BUF_ERROR : $fc8941aa2060205a$var$Z_STREAM_ERROR);
    s.strm = strm; /* just in case */ 
    old_flush = s.last_flush;
    s.last_flush = flush;
    /* Write the header */ if (s.status === $fc8941aa2060205a$var$INIT_STATE) {
        if (s.wrap === 2) {
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
            $fc8941aa2060205a$var$put_byte(s, 31);
            $fc8941aa2060205a$var$put_byte(s, 139);
            $fc8941aa2060205a$var$put_byte(s, 8);
            if (!s.gzhead) {
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $fc8941aa2060205a$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                $fc8941aa2060205a$var$put_byte(s, $fc8941aa2060205a$var$OS_CODE);
                s.status = $fc8941aa2060205a$var$BUSY_STATE;
            } else {
                $fc8941aa2060205a$var$put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.time & 0xff);
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.time >> 8 & 0xff);
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.time >> 16 & 0xff);
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.time >> 24 & 0xff);
                $fc8941aa2060205a$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $fc8941aa2060205a$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.os & 0xff);
                if (s.gzhead.extra && s.gzhead.extra.length) {
                    $fc8941aa2060205a$var$put_byte(s, s.gzhead.extra.length & 0xff);
                    $fc8941aa2060205a$var$put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
                }
                if (s.gzhead.hcrc) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending, 0);
                s.gzindex = 0;
                s.status = $fc8941aa2060205a$var$EXTRA_STATE;
            }
        } else {
            var header = $fc8941aa2060205a$var$Z_DEFLATED + (s.w_bits - 8 << 4) << 8;
            var level_flags = -1;
            if (s.strategy >= $fc8941aa2060205a$var$Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
            else if (s.level < 6) level_flags = 1;
            else if (s.level === 6) level_flags = 2;
            else level_flags = 3;
            header |= level_flags << 6;
            if (s.strstart !== 0) header |= $fc8941aa2060205a$var$PRESET_DICT;
            header += 31 - header % 31;
            s.status = $fc8941aa2060205a$var$BUSY_STATE;
            $fc8941aa2060205a$var$putShortMSB(s, header);
            /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
                $fc8941aa2060205a$var$putShortMSB(s, strm.adler >>> 16);
                $fc8941aa2060205a$var$putShortMSB(s, strm.adler & 0xffff);
            }
            strm.adler = 1; // adler32(0L, Z_NULL, 0);
        }
    }
    //#ifdef GZIP
    if (s.status === $fc8941aa2060205a$var$EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            while(s.gzindex < (s.gzhead.extra.length & 0xffff)){
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $fc8941aa2060205a$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) break;
                }
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                s.gzindex++;
            }
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (s.gzindex === s.gzhead.extra.length) {
                s.gzindex = 0;
                s.status = $fc8941aa2060205a$var$NAME_STATE;
            }
        } else s.status = $fc8941aa2060205a$var$NAME_STATE;
    }
    if (s.status === $fc8941aa2060205a$var$NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $fc8941aa2060205a$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $fc8941aa2060205a$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) {
                s.gzindex = 0;
                s.status = $fc8941aa2060205a$var$COMMENT_STATE;
            }
        } else s.status = $fc8941aa2060205a$var$COMMENT_STATE;
    }
    if (s.status === $fc8941aa2060205a$var$COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $fc8941aa2060205a$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $fc8941aa2060205a$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) s.status = $fc8941aa2060205a$var$HCRC_STATE;
        } else s.status = $fc8941aa2060205a$var$HCRC_STATE;
    }
    if (s.status === $fc8941aa2060205a$var$HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) $fc8941aa2060205a$var$flush_pending(strm);
            if (s.pending + 2 <= s.pending_buf_size) {
                $fc8941aa2060205a$var$put_byte(s, strm.adler & 0xff);
                $fc8941aa2060205a$var$put_byte(s, strm.adler >> 8 & 0xff);
                strm.adler = 0; //crc32(0L, Z_NULL, 0);
                s.status = $fc8941aa2060205a$var$BUSY_STATE;
            }
        } else s.status = $fc8941aa2060205a$var$BUSY_STATE;
    }
    //#endif
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        $fc8941aa2060205a$var$flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return $fc8941aa2060205a$var$Z_OK;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && $fc8941aa2060205a$var$rank(flush) <= $fc8941aa2060205a$var$rank(old_flush) && flush !== $fc8941aa2060205a$var$Z_FINISH) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_BUF_ERROR);
    /* User must not provide more input after the first FINISH: */ if (s.status === $fc8941aa2060205a$var$FINISH_STATE && strm.avail_in !== 0) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_BUF_ERROR);
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== $fc8941aa2060205a$var$Z_NO_FLUSH && s.status !== $fc8941aa2060205a$var$FINISH_STATE) {
        var bstate = s.strategy === $fc8941aa2060205a$var$Z_HUFFMAN_ONLY ? $fc8941aa2060205a$var$deflate_huff(s, flush) : s.strategy === $fc8941aa2060205a$var$Z_RLE ? $fc8941aa2060205a$var$deflate_rle(s, flush) : $fc8941aa2060205a$var$configuration_table[s.level].func(s, flush);
        if (bstate === $fc8941aa2060205a$var$BS_FINISH_STARTED || bstate === $fc8941aa2060205a$var$BS_FINISH_DONE) s.status = $fc8941aa2060205a$var$FINISH_STATE;
        if (bstate === $fc8941aa2060205a$var$BS_NEED_MORE || bstate === $fc8941aa2060205a$var$BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return $fc8941aa2060205a$var$Z_OK;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === $fc8941aa2060205a$var$BS_BLOCK_DONE) {
            if (flush === $fc8941aa2060205a$var$Z_PARTIAL_FLUSH) $hx6dX._tr_align(s);
            else if (flush !== $fc8941aa2060205a$var$Z_BLOCK) {
                $hx6dX._tr_stored_block(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === $fc8941aa2060205a$var$Z_FULL_FLUSH) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ $fc8941aa2060205a$var$zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            $fc8941aa2060205a$var$flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return $fc8941aa2060205a$var$Z_OK;
            }
        }
    }
    //Assert(strm->avail_out > 0, "bug2");
    //if (strm.avail_out <= 0) { throw new Error("bug2");}
    if (flush !== $fc8941aa2060205a$var$Z_FINISH) return $fc8941aa2060205a$var$Z_OK;
    if (s.wrap <= 0) return $fc8941aa2060205a$var$Z_STREAM_END;
    /* Write the trailer */ if (s.wrap === 2) {
        $fc8941aa2060205a$var$put_byte(s, strm.adler & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.adler >> 8 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.adler >> 16 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.adler >> 24 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.total_in & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.total_in >> 8 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.total_in >> 16 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        $fc8941aa2060205a$var$putShortMSB(s, strm.adler >>> 16);
        $fc8941aa2060205a$var$putShortMSB(s, strm.adler & 0xffff);
    }
    $fc8941aa2060205a$var$flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? $fc8941aa2060205a$var$Z_OK : $fc8941aa2060205a$var$Z_STREAM_END;
}
function $fc8941aa2060205a$var$deflateEnd(strm) {
    var status;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    status = strm.state.status;
    if (status !== $fc8941aa2060205a$var$INIT_STATE && status !== $fc8941aa2060205a$var$EXTRA_STATE && status !== $fc8941aa2060205a$var$NAME_STATE && status !== $fc8941aa2060205a$var$COMMENT_STATE && status !== $fc8941aa2060205a$var$HCRC_STATE && status !== $fc8941aa2060205a$var$BUSY_STATE && status !== $fc8941aa2060205a$var$FINISH_STATE) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_STREAM_ERROR);
    strm.state = null;
    return status === $fc8941aa2060205a$var$BUSY_STATE ? $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_DATA_ERROR) : $fc8941aa2060205a$var$Z_OK;
}
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ function $fc8941aa2060205a$var$deflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var s;
    var str, n;
    var wrap;
    var avail;
    var next;
    var input;
    var tmpDict;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    s = strm.state;
    wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== $fc8941aa2060205a$var$INIT_STATE || s.lookahead) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = $gJUj4(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ $fc8941aa2060205a$var$zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        tmpDict = new $9CLQF.Buf8(s.w_size);
        $9CLQF.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ avail = strm.avail_in;
    next = strm.next_in;
    input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    $fc8941aa2060205a$var$fill_window(s);
    while(s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH){
        str = s.strstart;
        n = s.lookahead - ($fc8941aa2060205a$var$MIN_MATCH - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = $fc8941aa2060205a$var$MIN_MATCH - 1;
        $fc8941aa2060205a$var$fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return $fc8941aa2060205a$var$Z_OK;
}
$fc8941aa2060205a$export$72b35d618fb8ad9b = $fc8941aa2060205a$var$deflateInit;
$fc8941aa2060205a$export$a65c7b2bde87cb70 = $fc8941aa2060205a$var$deflateInit2;
$fc8941aa2060205a$export$8f99f0e30bc7dd53 = $fc8941aa2060205a$var$deflateReset;
$fc8941aa2060205a$export$e78fab288549509 = $fc8941aa2060205a$var$deflateResetKeep;
$fc8941aa2060205a$export$1cd50f7b2515ba19 = $fc8941aa2060205a$var$deflateSetHeader;
$fc8941aa2060205a$export$2316623ecd1285ab = $fc8941aa2060205a$var$deflate;
$fc8941aa2060205a$export$599854fa319a815f = $fc8941aa2060205a$var$deflateEnd;
$fc8941aa2060205a$export$f55e0b3ab66b5d46 = $fc8941aa2060205a$var$deflateSetDictionary;
$fc8941aa2060205a$export$12b6e1fcadea22f9 = "pako deflate (from Nodeca project)"; /* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/ 

});
parcelRegister("9CLQF", function(module, exports) {
"use strict";
var $701cc75d47025217$var$TYPED_OK = typeof Uint8Array !== "undefined" && typeof Uint16Array !== "undefined" && typeof Int32Array !== "undefined";
function $701cc75d47025217$var$_has(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
module.exports.assign = function(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    while(sources.length){
        var source = sources.shift();
        if (!source) continue;
        if (typeof source !== "object") throw new TypeError(source + "must be non-object");
        for(var p in source)if ($701cc75d47025217$var$_has(source, p)) obj[p] = source[p];
    }
    return obj;
};
// reduce buffer size, avoiding mem copy
module.exports.shrinkBuf = function(buf, size) {
    if (buf.length === size) return buf;
    if (buf.subarray) return buf.subarray(0, size);
    buf.length = size;
    return buf;
};
var $701cc75d47025217$var$fnTyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        if (src.subarray && dest.subarray) {
            dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
            return;
        }
        // Fallback to ordinary array
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        var i, l, len, pos, chunk, result;
        // calculate data length
        len = 0;
        for(i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
        // join chunks
        result = new Uint8Array(len);
        pos = 0;
        for(i = 0, l = chunks.length; i < l; i++){
            chunk = chunks[i];
            result.set(chunk, pos);
            pos += chunk.length;
        }
        return result;
    }
};
var $701cc75d47025217$var$fnUntyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        return [].concat.apply([], chunks);
    }
};
// Enable/Disable typed arrays use, for testing
//
module.exports.setTyped = function(on) {
    if (on) {
        module.exports.Buf8 = Uint8Array;
        module.exports.Buf16 = Uint16Array;
        module.exports.Buf32 = Int32Array;
        module.exports.assign(module.exports, $701cc75d47025217$var$fnTyped);
    } else {
        module.exports.Buf8 = Array;
        module.exports.Buf16 = Array;
        module.exports.Buf32 = Array;
        module.exports.assign(module.exports, $701cc75d47025217$var$fnUntyped);
    }
};
module.exports.setTyped($701cc75d47025217$var$TYPED_OK);

});

parcelRegister("hx6dX", function(module, exports) {

$parcel$export(module.exports, "_tr_init", () => $cc3a58b664fcb155$export$4e4fc0157c3cd14d, (v) => $cc3a58b664fcb155$export$4e4fc0157c3cd14d = v);
$parcel$export(module.exports, "_tr_stored_block", () => $cc3a58b664fcb155$export$8959e34c5e020172, (v) => $cc3a58b664fcb155$export$8959e34c5e020172 = v);
$parcel$export(module.exports, "_tr_flush_block", () => $cc3a58b664fcb155$export$44f15b52eef0cf41, (v) => $cc3a58b664fcb155$export$44f15b52eef0cf41 = v);
$parcel$export(module.exports, "_tr_tally", () => $cc3a58b664fcb155$export$b3cbce147289408f, (v) => $cc3a58b664fcb155$export$b3cbce147289408f = v);
$parcel$export(module.exports, "_tr_align", () => $cc3a58b664fcb155$export$bfb360e02ee9b403, (v) => $cc3a58b664fcb155$export$bfb360e02ee9b403 = v);
var $cc3a58b664fcb155$export$4e4fc0157c3cd14d;
var $cc3a58b664fcb155$export$8959e34c5e020172;
var $cc3a58b664fcb155$export$44f15b52eef0cf41;
var $cc3a58b664fcb155$export$b3cbce147289408f;
var $cc3a58b664fcb155$export$bfb360e02ee9b403;
"use strict";

var $9CLQF = parcelRequire("9CLQF");
/* Public constants ==========================================================*/ /* ===========================================================================*/ //var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var $cc3a58b664fcb155$var$Z_FIXED = 4;
//var Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ var $cc3a58b664fcb155$var$Z_BINARY = 0;
var $cc3a58b664fcb155$var$Z_TEXT = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var $cc3a58b664fcb155$var$Z_UNKNOWN = 2;
/*============================================================================*/ function $cc3a58b664fcb155$var$zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
var $cc3a58b664fcb155$var$STORED_BLOCK = 0;
var $cc3a58b664fcb155$var$STATIC_TREES = 1;
var $cc3a58b664fcb155$var$DYN_TREES = 2;
/* The three kinds of block type */ var $cc3a58b664fcb155$var$MIN_MATCH = 3;
var $cc3a58b664fcb155$var$MAX_MATCH = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ var $cc3a58b664fcb155$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $cc3a58b664fcb155$var$LITERALS = 256;
/* number of literal bytes 0..255 */ var $cc3a58b664fcb155$var$L_CODES = $cc3a58b664fcb155$var$LITERALS + 1 + $cc3a58b664fcb155$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var $cc3a58b664fcb155$var$D_CODES = 30;
/* number of distance codes */ var $cc3a58b664fcb155$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var $cc3a58b664fcb155$var$HEAP_SIZE = 2 * $cc3a58b664fcb155$var$L_CODES + 1;
/* maximum heap size */ var $cc3a58b664fcb155$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var $cc3a58b664fcb155$var$Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ var $cc3a58b664fcb155$var$MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ var $cc3a58b664fcb155$var$END_BLOCK = 256;
/* end of block literal code */ var $cc3a58b664fcb155$var$REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ var $cc3a58b664fcb155$var$REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ var $cc3a58b664fcb155$var$REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ var $cc3a58b664fcb155$var$extra_lbits = /* extra bits for each length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
];
var $cc3a58b664fcb155$var$extra_dbits = /* extra bits for each distance code */ [
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
];
var $cc3a58b664fcb155$var$extra_blbits = /* extra bits for each bit length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
];
var $cc3a58b664fcb155$var$bl_order = [
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
];
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
var $cc3a58b664fcb155$var$DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
var $cc3a58b664fcb155$var$static_ltree = new Array(($cc3a58b664fcb155$var$L_CODES + 2) * 2);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ var $cc3a58b664fcb155$var$static_dtree = new Array($cc3a58b664fcb155$var$D_CODES * 2);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ var $cc3a58b664fcb155$var$_dist_code = new Array($cc3a58b664fcb155$var$DIST_CODE_LEN);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ var $cc3a58b664fcb155$var$_length_code = new Array($cc3a58b664fcb155$var$MAX_MATCH - $cc3a58b664fcb155$var$MIN_MATCH + 1);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ var $cc3a58b664fcb155$var$base_length = new Array($cc3a58b664fcb155$var$LENGTH_CODES);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ var $cc3a58b664fcb155$var$base_dist = new Array($cc3a58b664fcb155$var$D_CODES);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function $cc3a58b664fcb155$var$StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
var $cc3a58b664fcb155$var$static_l_desc;
var $cc3a58b664fcb155$var$static_d_desc;
var $cc3a58b664fcb155$var$static_bl_desc;
function $cc3a58b664fcb155$var$TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
function $cc3a58b664fcb155$var$d_code(dist) {
    return dist < 256 ? $cc3a58b664fcb155$var$_dist_code[dist] : $cc3a58b664fcb155$var$_dist_code[256 + (dist >>> 7)];
}
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ function $cc3a58b664fcb155$var$put_short(s, w) {
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
}
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ function $cc3a58b664fcb155$var$send_bits(s, value, length) {
    if (s.bi_valid > $cc3a58b664fcb155$var$Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        $cc3a58b664fcb155$var$put_short(s, s.bi_buf);
        s.bi_buf = value >> $cc3a58b664fcb155$var$Buf_size - s.bi_valid;
        s.bi_valid += length - $cc3a58b664fcb155$var$Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
}
function $cc3a58b664fcb155$var$send_code(s, c, tree) {
    $cc3a58b664fcb155$var$send_bits(s, tree[c * 2], tree[c * 2 + 1]);
}
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ function $cc3a58b664fcb155$var$bi_reverse(code, len) {
    var res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
}
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ function $cc3a58b664fcb155$var$bi_flush(s) {
    if (s.bi_valid === 16) {
        $cc3a58b664fcb155$var$put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
}
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ function $cc3a58b664fcb155$var$gen_bitlen(s, desc) //    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var max_code = desc.max_code;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var extra = desc.stat_desc.extra_bits;
    var base = desc.stat_desc.extra_base;
    var max_length = desc.stat_desc.max_length;
    var h; /* heap index */ 
    var n, m; /* iterate over the tree elements */ 
    var bits; /* bit length */ 
    var xbits; /* extra bits */ 
    var f; /* frequency */ 
    var overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= $cc3a58b664fcb155$var$MAX_BITS; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < $cc3a58b664fcb155$var$HEAP_SIZE; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Trace((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
}
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ function $cc3a58b664fcb155$var$gen_codes(tree, max_code, bl_count) //    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
    var next_code = new Array($cc3a58b664fcb155$var$MAX_BITS + 1); /* next code value for each bit length */ 
    var code = 0; /* running code value */ 
    var bits; /* bit index */ 
    var n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= $cc3a58b664fcb155$var$MAX_BITS; bits++)next_code[bits] = code = code + bl_count[bits - 1] << 1;
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        var len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = $cc3a58b664fcb155$var$bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
}
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ function $cc3a58b664fcb155$var$tr_static_init() {
    var n; /* iterates over tree elements */ 
    var bits; /* bit counter */ 
    var length; /* length value */ 
    var code; /* code value */ 
    var dist; /* distance index */ 
    var bl_count = new Array($cc3a58b664fcb155$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < $cc3a58b664fcb155$var$LENGTH_CODES - 1; code++){
        $cc3a58b664fcb155$var$base_length[code] = length;
        for(n = 0; n < 1 << $cc3a58b664fcb155$var$extra_lbits[code]; n++)$cc3a58b664fcb155$var$_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ $cc3a58b664fcb155$var$_length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        $cc3a58b664fcb155$var$base_dist[code] = dist;
        for(n = 0; n < 1 << $cc3a58b664fcb155$var$extra_dbits[code]; n++)$cc3a58b664fcb155$var$_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < $cc3a58b664fcb155$var$D_CODES; code++){
        $cc3a58b664fcb155$var$base_dist[code] = dist << 7;
        for(n = 0; n < 1 << $cc3a58b664fcb155$var$extra_dbits[code] - 7; n++)$cc3a58b664fcb155$var$_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= $cc3a58b664fcb155$var$MAX_BITS; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        $cc3a58b664fcb155$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        $cc3a58b664fcb155$var$static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        $cc3a58b664fcb155$var$static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        $cc3a58b664fcb155$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ $cc3a58b664fcb155$var$gen_codes($cc3a58b664fcb155$var$static_ltree, $cc3a58b664fcb155$var$L_CODES + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < $cc3a58b664fcb155$var$D_CODES; n++){
        $cc3a58b664fcb155$var$static_dtree[n * 2 + 1] = 5;
        $cc3a58b664fcb155$var$static_dtree[n * 2] = $cc3a58b664fcb155$var$bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    $cc3a58b664fcb155$var$static_l_desc = new $cc3a58b664fcb155$var$StaticTreeDesc($cc3a58b664fcb155$var$static_ltree, $cc3a58b664fcb155$var$extra_lbits, $cc3a58b664fcb155$var$LITERALS + 1, $cc3a58b664fcb155$var$L_CODES, $cc3a58b664fcb155$var$MAX_BITS);
    $cc3a58b664fcb155$var$static_d_desc = new $cc3a58b664fcb155$var$StaticTreeDesc($cc3a58b664fcb155$var$static_dtree, $cc3a58b664fcb155$var$extra_dbits, 0, $cc3a58b664fcb155$var$D_CODES, $cc3a58b664fcb155$var$MAX_BITS);
    $cc3a58b664fcb155$var$static_bl_desc = new $cc3a58b664fcb155$var$StaticTreeDesc(new Array(0), $cc3a58b664fcb155$var$extra_blbits, 0, $cc3a58b664fcb155$var$BL_CODES, $cc3a58b664fcb155$var$MAX_BL_BITS);
//static_init_done = true;
}
/* ===========================================================================
 * Initialize a new block.
 */ function $cc3a58b664fcb155$var$init_block(s) {
    var n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < $cc3a58b664fcb155$var$L_CODES; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < $cc3a58b664fcb155$var$D_CODES; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < $cc3a58b664fcb155$var$BL_CODES; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[$cc3a58b664fcb155$var$END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.last_lit = s.matches = 0;
}
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ function $cc3a58b664fcb155$var$bi_windup(s) {
    if (s.bi_valid > 8) $cc3a58b664fcb155$var$put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
}
/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */ function $cc3a58b664fcb155$var$copy_block(s, buf, len, header) //DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
    $cc3a58b664fcb155$var$bi_windup(s); /* align on byte boundary */ 
    if (header) {
        $cc3a58b664fcb155$var$put_short(s, len);
        $cc3a58b664fcb155$var$put_short(s, ~len);
    }
    //  while (len--) {
    //    put_byte(s, *buf++);
    //  }
    $9CLQF.arraySet(s.pending_buf, s.window, buf, len, s.pending);
    s.pending += len;
}
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ function $cc3a58b664fcb155$var$smaller(tree, n, m, depth) {
    var _n2 = n * 2;
    var _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
}
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ function $cc3a58b664fcb155$var$pqdownheap(s, tree, k) //    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
    var v = s.heap[k];
    var j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && $cc3a58b664fcb155$var$smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if ($cc3a58b664fcb155$var$smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
}
// inlined manually
// var SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ function $cc3a58b664fcb155$var$compress_block(s, ltree, dtree) //    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
    var dist; /* distance of matched string */ 
    var lc; /* match length or unmatched char (if dist == 0) */ 
    var lx = 0; /* running index in l_buf */ 
    var code; /* the code to send */ 
    var extra; /* number of extra bits to send */ 
    if (s.last_lit !== 0) do {
        dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
        lc = s.pending_buf[s.l_buf + lx];
        lx++;
        if (dist === 0) $cc3a58b664fcb155$var$send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = $cc3a58b664fcb155$var$_length_code[lc];
            $cc3a58b664fcb155$var$send_code(s, code + $cc3a58b664fcb155$var$LITERALS + 1, ltree); /* send the length code */ 
            extra = $cc3a58b664fcb155$var$extra_lbits[code];
            if (extra !== 0) {
                lc -= $cc3a58b664fcb155$var$base_length[code];
                $cc3a58b664fcb155$var$send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = $cc3a58b664fcb155$var$d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            $cc3a58b664fcb155$var$send_code(s, code, dtree); /* send the distance code */ 
            extra = $cc3a58b664fcb155$var$extra_dbits[code];
            if (extra !== 0) {
                dist -= $cc3a58b664fcb155$var$base_dist[code];
                $cc3a58b664fcb155$var$send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */ //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
    //       "pendingBuf overflow");
    }while (lx < s.last_lit);
    $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$END_BLOCK, ltree);
}
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ function $cc3a58b664fcb155$var$build_tree(s, desc) //    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var elems = desc.stat_desc.elems;
    var n, m; /* iterate over heap elements */ 
    var max_code = -1; /* largest code with non zero frequency */ 
    var node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = $cc3a58b664fcb155$var$HEAP_SIZE;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)$cc3a58b664fcb155$var$pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        $cc3a58b664fcb155$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        $cc3a58b664fcb155$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ $cc3a58b664fcb155$var$gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ $cc3a58b664fcb155$var$gen_codes(tree, max_code, s.bl_count);
}
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ function $cc3a58b664fcb155$var$scan_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[$cc3a58b664fcb155$var$REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[$cc3a58b664fcb155$var$REPZ_3_10 * 2]++;
        else s.bl_tree[$cc3a58b664fcb155$var$REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ function $cc3a58b664fcb155$var$send_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do $cc3a58b664fcb155$var$send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                $cc3a58b664fcb155$var$send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$REP_3_6, s.bl_tree);
            $cc3a58b664fcb155$var$send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$REPZ_3_10, s.bl_tree);
            $cc3a58b664fcb155$var$send_bits(s, count - 3, 3);
        } else {
            $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$REPZ_11_138, s.bl_tree);
            $cc3a58b664fcb155$var$send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ function $cc3a58b664fcb155$var$build_bl_tree(s) {
    var max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ $cc3a58b664fcb155$var$scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    $cc3a58b664fcb155$var$scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ $cc3a58b664fcb155$var$build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = $cc3a58b664fcb155$var$BL_CODES - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[$cc3a58b664fcb155$var$bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
}
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ function $cc3a58b664fcb155$var$send_all_trees(s, lcodes, dcodes, blcodes) //    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
    var rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    $cc3a58b664fcb155$var$send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    $cc3a58b664fcb155$var$send_bits(s, dcodes - 1, 5);
    $cc3a58b664fcb155$var$send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    $cc3a58b664fcb155$var$send_bits(s, s.bl_tree[$cc3a58b664fcb155$var$bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    $cc3a58b664fcb155$var$send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    $cc3a58b664fcb155$var$send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ function $cc3a58b664fcb155$var$detect_data_type(s) {
    /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ var black_mask = 0xf3ffc07f;
    var n;
    /* Check for non-textual ("black-listed") bytes. */ for(n = 0; n <= 31; n++, black_mask >>>= 1){
        if (black_mask & 1 && s.dyn_ltree[n * 2] !== 0) return $cc3a58b664fcb155$var$Z_BINARY;
    }
    /* Check for textual ("white-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return $cc3a58b664fcb155$var$Z_TEXT;
    for(n = 32; n < $cc3a58b664fcb155$var$LITERALS; n++){
        if (s.dyn_ltree[n * 2] !== 0) return $cc3a58b664fcb155$var$Z_TEXT;
    }
    /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return $cc3a58b664fcb155$var$Z_BINARY;
}
var $cc3a58b664fcb155$var$static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ function $cc3a58b664fcb155$var$_tr_init(s) {
    if (!$cc3a58b664fcb155$var$static_init_done) {
        $cc3a58b664fcb155$var$tr_static_init();
        $cc3a58b664fcb155$var$static_init_done = true;
    }
    s.l_desc = new $cc3a58b664fcb155$var$TreeDesc(s.dyn_ltree, $cc3a58b664fcb155$var$static_l_desc);
    s.d_desc = new $cc3a58b664fcb155$var$TreeDesc(s.dyn_dtree, $cc3a58b664fcb155$var$static_d_desc);
    s.bl_desc = new $cc3a58b664fcb155$var$TreeDesc(s.bl_tree, $cc3a58b664fcb155$var$static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ $cc3a58b664fcb155$var$init_block(s);
}
/* ===========================================================================
 * Send a stored block
 */ function $cc3a58b664fcb155$var$_tr_stored_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    $cc3a58b664fcb155$var$send_bits(s, ($cc3a58b664fcb155$var$STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    $cc3a58b664fcb155$var$copy_block(s, buf, stored_len, true); /* with header */ 
}
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ function $cc3a58b664fcb155$var$_tr_align(s) {
    $cc3a58b664fcb155$var$send_bits(s, $cc3a58b664fcb155$var$STATIC_TREES << 1, 3);
    $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$END_BLOCK, $cc3a58b664fcb155$var$static_ltree);
    $cc3a58b664fcb155$var$bi_flush(s);
}
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */ function $cc3a58b664fcb155$var$_tr_flush_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    var opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    var max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === $cc3a58b664fcb155$var$Z_UNKNOWN) s.strm.data_type = $cc3a58b664fcb155$var$detect_data_type(s);
        /* Construct the literal and distance trees */ $cc3a58b664fcb155$var$build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        $cc3a58b664fcb155$var$build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = $cc3a58b664fcb155$var$build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->last_lit));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ $cc3a58b664fcb155$var$_tr_stored_block(s, buf, stored_len, last);
    else if (s.strategy === $cc3a58b664fcb155$var$Z_FIXED || static_lenb === opt_lenb) {
        $cc3a58b664fcb155$var$send_bits(s, ($cc3a58b664fcb155$var$STATIC_TREES << 1) + (last ? 1 : 0), 3);
        $cc3a58b664fcb155$var$compress_block(s, $cc3a58b664fcb155$var$static_ltree, $cc3a58b664fcb155$var$static_dtree);
    } else {
        $cc3a58b664fcb155$var$send_bits(s, ($cc3a58b664fcb155$var$DYN_TREES << 1) + (last ? 1 : 0), 3);
        $cc3a58b664fcb155$var$send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        $cc3a58b664fcb155$var$compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ $cc3a58b664fcb155$var$init_block(s);
    if (last) $cc3a58b664fcb155$var$bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
}
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ function $cc3a58b664fcb155$var$_tr_tally(s, dist, lc) //    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
    //var out_length, in_length, dcode;
    s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 0xff;
    s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
    s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
    s.last_lit++;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[($cc3a58b664fcb155$var$_length_code[lc] + $cc3a58b664fcb155$var$LITERALS + 1) * 2]++;
        s.dyn_dtree[$cc3a58b664fcb155$var$d_code(dist) * 2]++;
    }
    // (!) This block is disabled in zlib defaults,
    // don't enable it for binary compatibility
    //#ifdef TRUNCATE_BLOCK
    //  /* Try to guess if it is profitable to stop the current block here */
    //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
    //    /* Compute an upper bound for the compressed length */
    //    out_length = s.last_lit*8;
    //    in_length = s.strstart - s.block_start;
    //
    //    for (dcode = 0; dcode < D_CODES; dcode++) {
    //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
    //    }
    //    out_length >>>= 3;
    //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
    //    //       s->last_lit, in_length, out_length,
    //    //       100L - out_length*100L/in_length));
    //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
    //      return true;
    //    }
    //  }
    //#endif
    return s.last_lit === s.lit_bufsize - 1;
/* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ }
$cc3a58b664fcb155$export$4e4fc0157c3cd14d = $cc3a58b664fcb155$var$_tr_init;
$cc3a58b664fcb155$export$8959e34c5e020172 = $cc3a58b664fcb155$var$_tr_stored_block;
$cc3a58b664fcb155$export$44f15b52eef0cf41 = $cc3a58b664fcb155$var$_tr_flush_block;
$cc3a58b664fcb155$export$b3cbce147289408f = $cc3a58b664fcb155$var$_tr_tally;
$cc3a58b664fcb155$export$bfb360e02ee9b403 = $cc3a58b664fcb155$var$_tr_align;

});

parcelRegister("gJUj4", function(module, exports) {
"use strict";
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $c2fc869ba2d0859c$var$adler32(adler, buf, len, pos) {
    var s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
}
module.exports = $c2fc869ba2d0859c$var$adler32;

});

parcelRegister("5UMyJ", function(module, exports) {
"use strict";
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
function $44e7d98dd6723a9a$var$makeTable() {
    var c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
}
// Create table on load. Just 255 signed longs. Not a problem.
var $44e7d98dd6723a9a$var$crcTable = $44e7d98dd6723a9a$var$makeTable();
function $44e7d98dd6723a9a$var$crc32(crc, buf, len, pos) {
    var t = $44e7d98dd6723a9a$var$crcTable, end = pos + len;
    crc ^= -1;
    for(var i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
}
module.exports = $44e7d98dd6723a9a$var$crc32;

});

parcelRegister("7gAmB", function(module, exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
module.exports = {
    2: "need dictionary",
    /* Z_NEED_DICT       2  */ 1: "stream end",
    /* Z_STREAM_END      1  */ 0: "",
    /* Z_OK              0  */ "-1": "file error",
    /* Z_ERRNO         (-1) */ "-2": "stream error",
    /* Z_STREAM_ERROR  (-2) */ "-3": "data error",
    /* Z_DATA_ERROR    (-3) */ "-4": "insufficient memory",
    /* Z_MEM_ERROR     (-4) */ "-5": "buffer error",
    /* Z_BUF_ERROR     (-5) */ "-6": "incompatible version" /* Z_VERSION_ERROR (-6) */ 
};

});


parcelRegister("fzvBq", function(module, exports) {

$parcel$export(module.exports, "inflateReset", () => $b562a383a327bea1$export$42de45683a92ba94, (v) => $b562a383a327bea1$export$42de45683a92ba94 = v);
$parcel$export(module.exports, "inflateInit2", () => $b562a383a327bea1$export$6792d92addc5c8a0, (v) => $b562a383a327bea1$export$6792d92addc5c8a0 = v);
$parcel$export(module.exports, "inflate", () => $b562a383a327bea1$export$cae1ce83fe4a1782, (v) => $b562a383a327bea1$export$cae1ce83fe4a1782 = v);
$parcel$export(module.exports, "inflateEnd", () => $b562a383a327bea1$export$224e1a443c3fba76, (v) => $b562a383a327bea1$export$224e1a443c3fba76 = v);
$parcel$export(module.exports, "inflateSetDictionary", () => $b562a383a327bea1$export$60da749bed98ccf8, (v) => $b562a383a327bea1$export$60da749bed98ccf8 = v);
var $b562a383a327bea1$export$42de45683a92ba94;
var $b562a383a327bea1$export$7633ac2cd30f9650;
var $b562a383a327bea1$export$6710ea52c4ec9d6a;
var $b562a383a327bea1$export$9c140b25e26874f9;
var $b562a383a327bea1$export$6792d92addc5c8a0;
var $b562a383a327bea1$export$cae1ce83fe4a1782;
var $b562a383a327bea1$export$224e1a443c3fba76;
var $b562a383a327bea1$export$6d4647cb9e1c75fc;
var $b562a383a327bea1$export$60da749bed98ccf8;
var $b562a383a327bea1$export$220f6291ca35fd71;
"use strict";

var $9CLQF = parcelRequire("9CLQF");

var $gJUj4 = parcelRequire("gJUj4");

var $5UMyJ = parcelRequire("5UMyJ");

var $6OFFF = parcelRequire("6OFFF");

var $bxjQM = parcelRequire("bxjQM");
var $b562a383a327bea1$var$CODES = 0;
var $b562a383a327bea1$var$LENS = 1;
var $b562a383a327bea1$var$DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ //var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var $b562a383a327bea1$var$Z_FINISH = 4;
var $b562a383a327bea1$var$Z_BLOCK = 5;
var $b562a383a327bea1$var$Z_TREES = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var $b562a383a327bea1$var$Z_OK = 0;
var $b562a383a327bea1$var$Z_STREAM_END = 1;
var $b562a383a327bea1$var$Z_NEED_DICT = 2;
//var Z_ERRNO         = -1;
var $b562a383a327bea1$var$Z_STREAM_ERROR = -2;
var $b562a383a327bea1$var$Z_DATA_ERROR = -3;
var $b562a383a327bea1$var$Z_MEM_ERROR = -4;
var $b562a383a327bea1$var$Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* The deflate compression method */ var $b562a383a327bea1$var$Z_DEFLATED = 8;
/* STATES ====================================================================*/ /* ===========================================================================*/ var $b562a383a327bea1$var$HEAD = 1; /* i: waiting for magic header */ 
var $b562a383a327bea1$var$FLAGS = 2; /* i: waiting for method and flags (gzip) */ 
var $b562a383a327bea1$var$TIME = 3; /* i: waiting for modification time (gzip) */ 
var $b562a383a327bea1$var$OS = 4; /* i: waiting for extra flags and operating system (gzip) */ 
var $b562a383a327bea1$var$EXLEN = 5; /* i: waiting for extra length (gzip) */ 
var $b562a383a327bea1$var$EXTRA = 6; /* i: waiting for extra bytes (gzip) */ 
var $b562a383a327bea1$var$NAME = 7; /* i: waiting for end of file name (gzip) */ 
var $b562a383a327bea1$var$COMMENT = 8; /* i: waiting for end of comment (gzip) */ 
var $b562a383a327bea1$var$HCRC = 9; /* i: waiting for header crc (gzip) */ 
var $b562a383a327bea1$var$DICTID = 10; /* i: waiting for dictionary check value */ 
var $b562a383a327bea1$var$DICT = 11; /* waiting for inflateSetDictionary() call */ 
var $b562a383a327bea1$var$TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
var $b562a383a327bea1$var$TYPEDO = 13; /* i: same, but skip check to exit inflate on new block */ 
var $b562a383a327bea1$var$STORED = 14; /* i: waiting for stored size (length and complement) */ 
var $b562a383a327bea1$var$COPY_ = 15; /* i/o: same as COPY below, but only first time in */ 
var $b562a383a327bea1$var$COPY = 16; /* i/o: waiting for input or output to copy stored block */ 
var $b562a383a327bea1$var$TABLE = 17; /* i: waiting for dynamic block table lengths */ 
var $b562a383a327bea1$var$LENLENS = 18; /* i: waiting for code length code lengths */ 
var $b562a383a327bea1$var$CODELENS = 19; /* i: waiting for length/lit and distance code lengths */ 
var $b562a383a327bea1$var$LEN_ = 20; /* i: same as LEN below, but only first time in */ 
var $b562a383a327bea1$var$LEN = 21; /* i: waiting for length/lit/eob code */ 
var $b562a383a327bea1$var$LENEXT = 22; /* i: waiting for length extra bits */ 
var $b562a383a327bea1$var$DIST = 23; /* i: waiting for distance code */ 
var $b562a383a327bea1$var$DISTEXT = 24; /* i: waiting for distance extra bits */ 
var $b562a383a327bea1$var$MATCH = 25; /* o: waiting for output space to copy string */ 
var $b562a383a327bea1$var$LIT = 26; /* o: waiting for output space to write literal */ 
var $b562a383a327bea1$var$CHECK = 27; /* i: waiting for 32-bit check value */ 
var $b562a383a327bea1$var$LENGTH = 28; /* i: waiting for 32-bit length (gzip) */ 
var $b562a383a327bea1$var$DONE = 29; /* finished check, done -- remain here until reset */ 
var $b562a383a327bea1$var$BAD = 30; /* got a data error -- remain here until reset */ 
var $b562a383a327bea1$var$MEM = 31; /* got an inflate() memory error -- remain here until reset */ 
var $b562a383a327bea1$var$SYNC = 32; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ var $b562a383a327bea1$var$ENOUGH_LENS = 852;
var $b562a383a327bea1$var$ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
var $b562a383a327bea1$var$MAX_WBITS = 15;
/* 32K LZ77 window */ var $b562a383a327bea1$var$DEF_WBITS = $b562a383a327bea1$var$MAX_WBITS;
function $b562a383a327bea1$var$zswap32(q) {
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
}
function $b562a383a327bea1$var$InflateState() {
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib) */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new $9CLQF.Buf16(320); /* temporary storage for code lengths */ 
    this.work = new $9CLQF.Buf16(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
function $b562a383a327bea1$var$inflateResetKeep(strm) {
    var state;
    if (!strm || !strm.state) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ""; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = $b562a383a327bea1$var$HEAD;
    state.last = 0;
    state.havedict = 0;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new $9CLQF.Buf32($b562a383a327bea1$var$ENOUGH_LENS);
    state.distcode = state.distdyn = new $9CLQF.Buf32($b562a383a327bea1$var$ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return $b562a383a327bea1$var$Z_OK;
}
function $b562a383a327bea1$var$inflateReset(strm) {
    var state;
    if (!strm || !strm.state) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return $b562a383a327bea1$var$inflateResetKeep(strm);
}
function $b562a383a327bea1$var$inflateReset2(strm, windowBits) {
    var wrap;
    var state;
    /* get the state */ if (!strm || !strm.state) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 1;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return $b562a383a327bea1$var$inflateReset(strm);
}
function $b562a383a327bea1$var$inflateInit2(strm, windowBits) {
    var ret;
    var state;
    if (!strm) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    state = new $b562a383a327bea1$var$InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.window = null /*Z_NULL*/ ;
    ret = $b562a383a327bea1$var$inflateReset2(strm, windowBits);
    if (ret !== $b562a383a327bea1$var$Z_OK) strm.state = null /*Z_NULL*/ ;
    return ret;
}
function $b562a383a327bea1$var$inflateInit(strm) {
    return $b562a383a327bea1$var$inflateInit2(strm, $b562a383a327bea1$var$DEF_WBITS);
}
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ var $b562a383a327bea1$var$virgin = true;
var $b562a383a327bea1$var$lenfix, $b562a383a327bea1$var$distfix; // We have no pointers in JS, so keep tables separate
function $b562a383a327bea1$var$fixedtables(state) {
    /* build fixed huffman tables if first call (may not be thread safe) */ if ($b562a383a327bea1$var$virgin) {
        var sym;
        $b562a383a327bea1$var$lenfix = new $9CLQF.Buf32(512);
        $b562a383a327bea1$var$distfix = new $9CLQF.Buf32(32);
        /* literal/length table */ sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        $bxjQM($b562a383a327bea1$var$LENS, state.lens, 0, 288, $b562a383a327bea1$var$lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        $bxjQM($b562a383a327bea1$var$DISTS, state.lens, 0, 32, $b562a383a327bea1$var$distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ $b562a383a327bea1$var$virgin = false;
    }
    state.lencode = $b562a383a327bea1$var$lenfix;
    state.lenbits = 9;
    state.distcode = $b562a383a327bea1$var$distfix;
    state.distbits = 5;
}
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ function $b562a383a327bea1$var$updatewindow(strm, src, end, copy) {
    var dist;
    var state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new $9CLQF.Buf8(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        $9CLQF.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        $9CLQF.arraySet(state.window, src, end - copy, dist, state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            $9CLQF.arraySet(state.window, src, end - copy, copy, 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
}
function $b562a383a327bea1$var$inflate(strm, flush) {
    var state;
    var input, output; // input/output buffers
    var next; /* next input INDEX */ 
    var put; /* next output INDEX */ 
    var have, left; /* available input and output */ 
    var hold; /* bit buffer */ 
    var bits; /* bits in bit buffer */ 
    var _in, _out; /* save starting available input and output */ 
    var copy; /* number of stored or match bytes to copy */ 
    var from; /* where to copy match bytes from */ 
    var from_source;
    var here = 0; /* current decoding table entry */ 
    var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //var last;                   /* parent table entry */
    var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    var len; /* length to copy for repeats, bits to drop */ 
    var ret; /* return code */ 
    var hbuf = new $9CLQF.Buf8(4); /* buffer for gzip header crc calculation */ 
    var opts;
    var n; // temporary var for NEED_BITS
    var order = /* permutation of code lengths */ [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    if (state.mode === $b562a383a327bea1$var$TYPE) state.mode = $b562a383a327bea1$var$TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = $b562a383a327bea1$var$Z_OK;
    inf_leave: for(;;)switch(state.mode){
        case $b562a383a327bea1$var$HEAD:
            if (state.wrap === 0) {
                state.mode = $b562a383a327bea1$var$TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $5UMyJ(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = $b562a383a327bea1$var$FLAGS;
                break;
            }
            state.flags = 0; /* expect zlib header */ 
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = "incorrect header check";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            if ((hold & 0x0f) !== $b562a383a327bea1$var$Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            else if (len > state.wbits) {
                strm.msg = "invalid window size";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.dmax = 1 << len;
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? $b562a383a327bea1$var$DICTID : $b562a383a327bea1$var$TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case $b562a383a327bea1$var$FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== $b562a383a327bea1$var$Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = "unknown header flags set";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $5UMyJ(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$TIME;
        /* falls through */ case $b562a383a327bea1$var$TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = $5UMyJ(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$OS;
        /* falls through */ case $b562a383a327bea1$var$OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $5UMyJ(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$EXLEN;
        /* falls through */ case $b562a383a327bea1$var$EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = $5UMyJ(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = $b562a383a327bea1$var$EXTRA;
        /* falls through */ case $b562a383a327bea1$var$EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Array(state.head.extra_len);
                        $9CLQF.arraySet(state.head.extra, input, next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        copy, /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200) state.check = $5UMyJ(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = $b562a383a327bea1$var$NAME;
        /* falls through */ case $b562a383a327bea1$var$NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $5UMyJ(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = $b562a383a327bea1$var$COMMENT;
        /* falls through */ case $b562a383a327bea1$var$COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $5UMyJ(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = $b562a383a327bea1$var$HCRC;
        /* falls through */ case $b562a383a327bea1$var$HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.check & 0xffff)) {
                    strm.msg = "header crc mismatch";
                    state.mode = $b562a383a327bea1$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = $b562a383a327bea1$var$TYPE;
            break;
        case $b562a383a327bea1$var$DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = $b562a383a327bea1$var$zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$DICT;
        /* falls through */ case $b562a383a327bea1$var$DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return $b562a383a327bea1$var$Z_NEED_DICT;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = $b562a383a327bea1$var$TYPE;
        /* falls through */ case $b562a383a327bea1$var$TYPE:
            if (flush === $b562a383a327bea1$var$Z_BLOCK || flush === $b562a383a327bea1$var$Z_TREES) break inf_leave;
        /* falls through */ case $b562a383a327bea1$var$TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = $b562a383a327bea1$var$CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $b562a383a327bea1$var$STORED;
                    break;
                case 1:
                    /* fixed block */ $b562a383a327bea1$var$fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $b562a383a327bea1$var$LEN_; /* decode codes */ 
                    if (flush === $b562a383a327bea1$var$Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $b562a383a327bea1$var$TABLE;
                    break;
                case 3:
                    strm.msg = "invalid block type";
                    state.mode = $b562a383a327bea1$var$BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case $b562a383a327bea1$var$STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = "invalid stored block lengths";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$COPY_;
            if (flush === $b562a383a327bea1$var$Z_TREES) break inf_leave;
        /* falls through */ case $b562a383a327bea1$var$COPY_:
            state.mode = $b562a383a327bea1$var$COPY;
        /* falls through */ case $b562a383a327bea1$var$COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                $9CLQF.arraySet(output, input, next, copy, put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = $b562a383a327bea1$var$TYPE;
            break;
        case $b562a383a327bea1$var$TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = "too many length or distance symbols";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = $b562a383a327bea1$var$LENLENS;
        /* falls through */ case $b562a383a327bea1$var$LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = $bxjQM($b562a383a327bea1$var$CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = "invalid code lengths set";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = $b562a383a327bea1$var$CODELENS;
        /* falls through */ case $b562a383a327bea1$var$CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = "invalid bit length repeat";
                            state.mode = $b562a383a327bea1$var$BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = "invalid bit length repeat";
                        state.mode = $b562a383a327bea1$var$BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === $b562a383a327bea1$var$BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = "invalid code -- missing end-of-block";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = $bxjQM($b562a383a327bea1$var$LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = "invalid literal/lengths set";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = $bxjQM($b562a383a327bea1$var$DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = "invalid distances set";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = $b562a383a327bea1$var$LEN_;
            if (flush === $b562a383a327bea1$var$Z_TREES) break inf_leave;
        /* falls through */ case $b562a383a327bea1$var$LEN_:
            state.mode = $b562a383a327bea1$var$LEN;
        /* falls through */ case $b562a383a327bea1$var$LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                $6OFFF(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === $b562a383a327bea1$var$TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = $b562a383a327bea1$var$LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = $b562a383a327bea1$var$TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = "invalid literal/length code";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = $b562a383a327bea1$var$LENEXT;
        /* falls through */ case $b562a383a327bea1$var$LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = $b562a383a327bea1$var$DIST;
        /* falls through */ case $b562a383a327bea1$var$DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = "invalid distance code";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = $b562a383a327bea1$var$DISTEXT;
        /* falls through */ case $b562a383a327bea1$var$DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = "invalid distance too far back";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = $b562a383a327bea1$var$MATCH;
        /* falls through */ case $b562a383a327bea1$var$MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = "invalid distance too far back";
                        state.mode = $b562a383a327bea1$var$BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = $b562a383a327bea1$var$LEN;
            break;
        case $b562a383a327bea1$var$LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = $b562a383a327bea1$var$LEN;
            break;
        case $b562a383a327bea1$var$CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (_out) strm.adler = state.check = /*UPDATE(state.check, put - _out, _out);*/ state.flags ? $5UMyJ(state.check, output, _out, put - _out) : $gJUj4(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if ((state.flags ? hold : $b562a383a327bea1$var$zswap32(hold)) !== state.check) {
                    strm.msg = "incorrect data check";
                    state.mode = $b562a383a327bea1$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = $b562a383a327bea1$var$LENGTH;
        /* falls through */ case $b562a383a327bea1$var$LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.total & 0xffffffff)) {
                    strm.msg = "incorrect length check";
                    state.mode = $b562a383a327bea1$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = $b562a383a327bea1$var$DONE;
        /* falls through */ case $b562a383a327bea1$var$DONE:
            ret = $b562a383a327bea1$var$Z_STREAM_END;
            break inf_leave;
        case $b562a383a327bea1$var$BAD:
            ret = $b562a383a327bea1$var$Z_DATA_ERROR;
            break inf_leave;
        case $b562a383a327bea1$var$MEM:
            return $b562a383a327bea1$var$Z_MEM_ERROR;
        case $b562a383a327bea1$var$SYNC:
        /* falls through */ default:
            return $b562a383a327bea1$var$Z_STREAM_ERROR;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < $b562a383a327bea1$var$BAD && (state.mode < $b562a383a327bea1$var$CHECK || flush !== $b562a383a327bea1$var$Z_FINISH)) {
        if ($b562a383a327bea1$var$updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
            state.mode = $b562a383a327bea1$var$MEM;
            return $b562a383a327bea1$var$Z_MEM_ERROR;
        }
    }
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap && _out) strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/ state.flags ? $5UMyJ(state.check, output, _out, strm.next_out - _out) : $gJUj4(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === $b562a383a327bea1$var$TYPE ? 128 : 0) + (state.mode === $b562a383a327bea1$var$LEN_ || state.mode === $b562a383a327bea1$var$COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === $b562a383a327bea1$var$Z_FINISH) && ret === $b562a383a327bea1$var$Z_OK) ret = $b562a383a327bea1$var$Z_BUF_ERROR;
    return ret;
}
function $b562a383a327bea1$var$inflateEnd(strm) {
    if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/ ) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    var state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return $b562a383a327bea1$var$Z_OK;
}
function $b562a383a327bea1$var$inflateGetHeader(strm, head) {
    var state;
    /* check state */ if (!strm || !strm.state) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    if ((state.wrap & 2) === 0) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    /* save header structure */ state.head = head;
    head.done = false;
    return $b562a383a327bea1$var$Z_OK;
}
function $b562a383a327bea1$var$inflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var state;
    var dictid;
    var ret;
    /* check state */ if (!strm /* == Z_NULL */  || !strm.state /* == Z_NULL */ ) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== $b562a383a327bea1$var$DICT) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    /* check for correct dictionary identifier */ if (state.mode === $b562a383a327bea1$var$DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = $gJUj4(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return $b562a383a327bea1$var$Z_DATA_ERROR;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = $b562a383a327bea1$var$updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = $b562a383a327bea1$var$MEM;
        return $b562a383a327bea1$var$Z_MEM_ERROR;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return $b562a383a327bea1$var$Z_OK;
}
$b562a383a327bea1$export$42de45683a92ba94 = $b562a383a327bea1$var$inflateReset;
$b562a383a327bea1$export$7633ac2cd30f9650 = $b562a383a327bea1$var$inflateReset2;
$b562a383a327bea1$export$6710ea52c4ec9d6a = $b562a383a327bea1$var$inflateResetKeep;
$b562a383a327bea1$export$9c140b25e26874f9 = $b562a383a327bea1$var$inflateInit;
$b562a383a327bea1$export$6792d92addc5c8a0 = $b562a383a327bea1$var$inflateInit2;
$b562a383a327bea1$export$cae1ce83fe4a1782 = $b562a383a327bea1$var$inflate;
$b562a383a327bea1$export$224e1a443c3fba76 = $b562a383a327bea1$var$inflateEnd;
$b562a383a327bea1$export$6d4647cb9e1c75fc = $b562a383a327bea1$var$inflateGetHeader;
$b562a383a327bea1$export$60da749bed98ccf8 = $b562a383a327bea1$var$inflateSetDictionary;
$b562a383a327bea1$export$220f6291ca35fd71 = "pako inflate (from Nodeca project)"; /* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/ 

});
parcelRegister("6OFFF", function(module, exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
var $4f67bc996330e695$var$BAD = 30; /* got a data error -- remain here until reset */ 
var $4f67bc996330e695$var$TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ module.exports = function inflate_fast(strm, start) {
    var state;
    var _in; /* local strm.input */ 
    var last; /* have enough input while in < last */ 
    var _out; /* local strm.output */ 
    var beg; /* inflate()'s initial strm.output */ 
    var end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    var dmax; /* maximum distance from zlib header */ 
    //#endif
    var wsize; /* window size or zero if not using window */ 
    var whave; /* valid bytes in the window */ 
    var wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    var s_window; /* allocated sliding window, if wsize != 0 */ 
    var hold; /* local strm.hold */ 
    var bits; /* local strm.bits */ 
    var lcode; /* local strm.lencode */ 
    var dcode; /* local strm.distcode */ 
    var lmask; /* mask for first level of length codes */ 
    var dmask; /* mask for first level of distance codes */ 
    var here; /* retrieved table entry */ 
    var op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ var len; /* match length, unused bytes */ 
    var dist; /* match distance */ 
    var from; /* where to copy match from */ 
    var from_source;
    var input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = "invalid distance too far back";
                            state.mode = $4f67bc996330e695$var$BAD;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = "invalid distance too far back";
                                    state.mode = $4f67bc996330e695$var$BAD;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = "invalid distance code";
                        state.mode = $4f67bc996330e695$var$BAD;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = $4f67bc996330e695$var$TYPE;
                break top;
            } else {
                strm.msg = "invalid literal/length code";
                state.mode = $4f67bc996330e695$var$BAD;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};

});

parcelRegister("bxjQM", function(module, exports) {
"use strict";

var $9CLQF = parcelRequire("9CLQF");
var $86622ca50c32b2ec$var$MAXBITS = 15;
var $86622ca50c32b2ec$var$ENOUGH_LENS = 852;
var $86622ca50c32b2ec$var$ENOUGH_DISTS = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
var $86622ca50c32b2ec$var$CODES = 0;
var $86622ca50c32b2ec$var$LENS = 1;
var $86622ca50c32b2ec$var$DISTS = 2;
var $86622ca50c32b2ec$var$lbase = [
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
];
var $86622ca50c32b2ec$var$lext = [
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
];
var $86622ca50c32b2ec$var$dbase = [
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
];
var $86622ca50c32b2ec$var$dext = [
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
];
module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts) {
    var bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    var len = 0; /* a code's length in bits */ 
    var sym = 0; /* index of code symbols */ 
    var min = 0, max = 0; /* minimum and maximum code lengths */ 
    var root = 0; /* number of index bits for root table */ 
    var curr = 0; /* number of index bits for current table */ 
    var drop = 0; /* code bits to drop for sub-table */ 
    var left = 0; /* number of prefix codes available */ 
    var used = 0; /* code entries in table used */ 
    var huff = 0; /* Huffman code */ 
    var incr; /* for incrementing code, index */ 
    var fill; /* index for replicating entries */ 
    var low; /* low bits for current root entry */ 
    var mask; /* mask for low root bits */ 
    var next; /* next available space in table */ 
    var base = null; /* base value table to use */ 
    var base_index = 0;
    //  var shoextra;    /* extra bits table to use */
    var end; /* use base and extra for symbol > end */ 
    var count = new $9CLQF.Buf16($86622ca50c32b2ec$var$MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    var offs = new $9CLQF.Buf16($86622ca50c32b2ec$var$MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    var extra = null;
    var extra_index = 0;
    var here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= $86622ca50c32b2ec$var$MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = $86622ca50c32b2ec$var$MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= $86622ca50c32b2ec$var$MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === $86622ca50c32b2ec$var$CODES || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < $86622ca50c32b2ec$var$MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === $86622ca50c32b2ec$var$CODES) {
        base = extra = work; /* dummy value--not used */ 
        end = 19;
    } else if (type === $86622ca50c32b2ec$var$LENS) {
        base = $86622ca50c32b2ec$var$lbase;
        base_index -= 257;
        extra = $86622ca50c32b2ec$var$lext;
        extra_index -= 257;
        end = 256;
    } else {
        base = $86622ca50c32b2ec$var$dbase;
        extra = $86622ca50c32b2ec$var$dext;
        end = -1;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === $86622ca50c32b2ec$var$LENS && used > $86622ca50c32b2ec$var$ENOUGH_LENS || type === $86622ca50c32b2ec$var$DISTS && used > $86622ca50c32b2ec$var$ENOUGH_DISTS) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] < end) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] > end) {
            here_op = extra[extra_index + work[sym]];
            here_val = base[base_index + work[sym]];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === $86622ca50c32b2ec$var$LENS && used > $86622ca50c32b2ec$var$ENOUGH_LENS || type === $86622ca50c32b2ec$var$DISTS && used > $86622ca50c32b2ec$var$ENOUGH_DISTS) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};

});


parcelRegister("hf4Xu", function(module, exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
module.exports = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    //Z_MEM_ERROR:     -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};

});




parcelRegister("aQoVS", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e5219ca972f072b$export$2e2bcd8739ae039);
/*

    MIT License

    Copyright (c) 2019-2023 Steffest - dev@stef.be

    Permission is hereby granted, free of charge, to any person obtaining a copy
    of this software and associated documentation files (the "Software"), to deal
    in the Software without restriction, including without limitation the rights
    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
    copies of the Software, and to permit persons to whom the Software is
    furnished to do so, subject to the following conditions:

    The above copyright notice and this permission notice shall be included in all
    copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
    SOFTWARE.

 */ 
var $3QDcZ = parcelRequire("3QDcZ");

var $lPw7G = parcelRequire("lPw7G");

var $eTCYn = parcelRequire("eTCYn");

var $bfgOg = parcelRequire("bfgOg");
const $7e5219ca972f072b$var$FILETYPE = {
    IFF: {
        name: "IFF file"
    },
    PBM: {
        name: "PBM Image"
    },
    ILBM: {
        name: "ILBM Image",
        actions: [
            "show"
        ],
        inspect: true
    },
    ANIM: {
        name: "IFF ILBM Animation"
    }
};
const $7e5219ca972f072b$var$IFF = function() {
    // Detect and Decode IFF Files
    // handles ILBM images, including EHB (Extra Half-Bright) and HAM (Hold and Modify)
    // and ANIM animations
    // TODO: Brushes and other masked images
    // image format info on https://en.wikipedia.org/wiki/ILBM
    const me = {};
    me.fileTypes = {
        IFF: {
            name: "IFF file"
        },
        ILBM: {
            name: "ILBM Image",
            actions: [
                "show"
            ],
            inspect: true
        },
        ANIM: {
            name: "IFF ILBM Animation"
        }
    };
    me.parse = function(file, decodeBody, fileType, parent) {
        let img = {
            palette: []
        };
        let index = 12;
        function readChunk() {
            const chunk = {};
            chunk.name = file.readString(4);
            chunk.size = file.readDWord();
            return chunk;
        }
        while(index < file.length - 4){
            file.goto(index);
            const chunk = readChunk();
            index += chunk.size + 8;
            if (chunk.size % 2 === 1) index++;
            switch(chunk.name){
                case "BMHD":
                    img.width = file.readWord();
                    img.height = file.readWord();
                    img.x = file.readShort();
                    img.y = file.readShort();
                    img.numPlanes = file.readUbyte();
                    img.mask = file.readUbyte();
                    img.compression = file.readUbyte();
                    img.pad = file.readUbyte();
                    img.transparentColor = file.readWord();
                    img.xAspect = file.readUbyte();
                    img.yAspect = file.readUbyte();
                    img.pageWidth = file.readWord();
                    img.pageHeight = file.readWord();
                    if (img.numPlanes && img.numPlanes < 9) img.colors = 1 << img.numPlanes;
                    if (img.numPlanes == 24) img.trueColor = true;
                    break;
                case "CMAP":
                    for(var i = 0, max = chunk.size / 3; i < max; i++)img.palette.push([
                        file.readUbyte(),
                        file.readUbyte(),
                        file.readUbyte()
                    ]);
                    break;
                case "CRNG":
                    img.colourRange = img.colourRange || [];
                    file.readShort(); // padding
                    let CRNGrange = {
                        rate: file.readShort(),
                        flags: file.readShort(),
                        low: file.readUbyte(),
                        high: file.readUbyte()
                    };
                    CRNGrange.fps = CRNGrange.rate / 16384 * 60;
                    CRNGrange.active = CRNGrange.flags & 1;
                    CRNGrange.reverse = CRNGrange.flags & 2;
                    img.colourRange.push(CRNGrange);
                    break;
                case "DRNG":
                    {
                        // Dpaint IV enhanced color cycle chunk.
                        // https://wiki.amigaos.net/wiki/ILBM_IFF_Interleaved_Bitmap#ILBM.DRNG
                        img.colourRange = img.colourRange || [];
                        const range = {
                            min: file.readUbyte(),
                            max: file.readUbyte(),
                            rate: file.readShort(),
                            flags: file.readShort(),
                            numberOfDColors: file.readUbyte(),
                            colors: [],
                            numberOfDIndexes: file.readUbyte(),
                            indexes: []
                        };
                        for(let i = 0; i < range.numberOfDColors; i++)// true color RGB values. (Is this used? I've never seen it in the wild)
                        range.colors.push({
                            index: file.readUbyte(),
                            red: file.readUbyte(),
                            green: file.readUbyte(),
                            blue: file.readUbyte()
                        });
                        for(let i = 0; i < range.numberOfDIndexes; i++)// index values
                        range.indexes.push({
                            index: file.readUbyte(),
                            colorIndex: file.readUbyte()
                        });
                        img.colourRange.push(range);
                        break;
                    }
                case "CCRT":
                    // Graphicraft Color Cycle chunk
                    // https://wiki.amigaos.net/wiki/ILBM_IFF_Interleaved_Bitmap#ILBM.CCRT
                    // examples: https://amiga.lychesis.net/applications/Graphicraft.html
                    img.colourRange = img.colourRange || [];
                    let CCRTRange = {
                        direction: file.readWord(),
                        low: file.readUbyte(),
                        high: file.readUbyte(),
                        seconds: file.readLong(),
                        microseconds: file.readLong(),
                        padding: file.readWord()
                    };
                    CCRTRange.active = CCRTRange.direction !== 0;
                    CCRTRange.fps = 1 / (CCRTRange.seconds + CCRTRange.microseconds / 1000000);
                    img.colourRange.push(CCRTRange);
                    break;
                case "CAMG":
                    var v = file.readLong();
                    img.interlaced = v & 0x4;
                    img.ehb = v & 0x80;
                    img.ham = v & 0x800;
                    img.hires = v & 0x8000;
                    break;
                case "BODY":
                    img.body = [];
                    // adjust EHB and HAM palette here as the order of CMAP and CAMG is not defined;
                    if (img.ehb) for(i = 0; i < 32; i++){
                        const c = img.palette[i];
                        img.palette[i + 32] = [
                            c[0] >> 1,
                            c[1] >> 1,
                            c[2] >> 1
                        ];
                    }
                    img.colorPlanes = img.numPlanes;
                    if (img.ham) {
                        img.hamPixels = [];
                        img.colorPlanes = 6; // HAM8
                        if (img.numPlanes < 7) img.colorPlanes = 4; // HAM6
                    }
                    // some images have bad CAMG blocks?
                    if (!img.hires && img.width >= 640) img.hires = true;
                    if (img.hires && !img.interlaced && img.height >= 400) img.interlaced = true;
                    if (decodeBody) {
                        if (fileType === $7e5219ca972f072b$var$FILETYPE.PBM) {
                            let pixelData = [];
                            if (img.compression) // Decompress the data
                            for(let i = 0; i < chunk.size; i++){
                                const byte = file.readUbyte();
                                if (byte > 128) {
                                    const nextByte = file.readUbyte();
                                    for(let i = 0; i < 257 - byte; i++)pixelData.push(nextByte);
                                } else if (byte < 128) for(let i = 0; i < byte + 1; i++)pixelData.push(file.readUbyte());
                                else break;
                            }
                            else // Just copy the data
                            // FIXME: Use BinaryStream.readBytes() ?
                            for(let i = 0; i < chunk.size; i++)pixelData.push(file.readUbyte());
                            // Rearrange pixel data in the right format for rendering?
                            // FIXME: Figure out why this needs to happen
                            let pixels = [];
                            for(let y = 0; y < img.height; y++){
                                pixels[y] = [];
                                for(let x = 0; x < img.width; x++)pixels[y][x] = pixelData[y * img.width + x];
                            }
                            img.pixels = pixels;
                        } else {
                            const pixels = [];
                            const planes = [];
                            let lineWidth = img.width + 15 >> 4; // in words
                            lineWidth *= 2; // in bytes
                            for(let y = 0; y < img.height; y++){
                                pixels[y] = [];
                                if (img.ham) img.hamPixels[y] = [];
                                for(let plane = 0; plane < img.numPlanes; plane++){
                                    planes[plane] = planes[plane] || [];
                                    planes[plane][y] = planes[plane][y] || [];
                                    const line = [];
                                    if (img.compression) {
                                        // RLE compression
                                        let pCount = 0;
                                        while(pCount < lineWidth){
                                            var b = file.readUbyte();
                                            if (b === 128) break;
                                            if (b > 128) {
                                                let b2 = file.readUbyte();
                                                for(var k = 0; k < 257 - b; k++){
                                                    line.push(b2);
                                                    pCount++;
                                                }
                                            } else {
                                                for(k = 0; k <= b; k++)line.push(file.readUbyte());
                                                pCount += b + 1;
                                            }
                                        }
                                    } else for(let x = 0; x < lineWidth; x++)line.push(file.readUbyte());
                                    // add bitplane line to pixel values;
                                    for(b = 0; b < lineWidth; b++){
                                        const val = line[b];
                                        for(i = 7; i >= 0; i--){
                                            let x = b * 8 + (7 - i);
                                            const bit = val & 1 << i ? 1 : 0;
                                            if (plane < img.colorPlanes) {
                                                var p = pixels[y][x] || 0;
                                                pixels[y][x] = p + (bit << plane);
                                                planes[plane][y][x] = bit;
                                            } else {
                                                p = img.hamPixels[y][x] || 0;
                                                img.hamPixels[y][x] = p + (bit << plane - img.colorPlanes);
                                            }
                                        }
                                    }
                                }
                            }
                            img.pixels = pixels;
                            img.planes = planes;
                        }
                    }
                    break;
                case "FORM":
                    img.frames = img.frames || [];
                    if (img.animFrameCount && img.frames.length >= img.animFrameCount) {
                        console.log("ANIM: frame count exceeded, skipping frame");
                        break;
                    }
                    let buffer = new ArrayBuffer(chunk.size + 8);
                    const view = new DataView(buffer);
                    file.readBytes(chunk.size + 8, file.index - 8, view);
                    let subFile = new (0, $3QDcZ.default)(buffer, true);
                    let subImg = me.parse(subFile, true, fileType, img);
                    if (subImg) {
                        img.frames.push(subImg);
                        if (img.frames.length === 1) {
                            img.width = subImg.width;
                            img.height = subImg.height;
                            img.numPlanes = subImg.numPlanes;
                            img.palette = subImg.palette;
                            img.animFrameCount = subImg.animFrameCount;
                        }
                    }
                    break;
                case "ANHD":
                    img.animHeader = {
                        compression: file.readUbyte(),
                        mask: file.readUbyte(),
                        width: file.readWord(),
                        height: file.readWord(),
                        x: file.readWord(),
                        y: file.readWord(),
                        absTime: file.readDWord(),
                        relTime: file.readDWord(),
                        interleave: file.readUbyte(),
                        pad: file.readUbyte(),
                        bits: file.readUbyte(),
                        future: file.readUbyte()
                    };
                    break;
                case "DPAN":
                    img.animVersion = file.readWord();
                    img.animFrameCount = file.readWord();
                    break;
                case "DLTA":
                    if (!parent) {
                        console.error("Error: DLTA chunk without parent structure");
                        return;
                    }
                    img.animHeader = img.animHeader || {};
                    let sourceFrameIndex = Math.max(parent.frames.length - 2, 0);
                    let frame = parent.frames[sourceFrameIndex];
                    if (!frame) {
                        console.error("Error: No frame to apply DLTA chunk to");
                        return;
                    }
                    // copy reference frame;
                    img.width = frame.width;
                    img.height = frame.height;
                    img.palette = frame.palette;
                    img.planes = [];
                    // TODO: this is slow...
                    frame.planes.forEach((plane)=>{
                        let newPlane = [];
                        plane.forEach((line)=>newPlane.push(line.slice()));
                        img.planes.push(newPlane);
                    });
                    sourceFrameIndex;
                    switch(img.animHeader.compression){
                        case 0:
                            break;
                        case 1:
                            console.warn("unhandled ANIM compression: XOR");
                            break;
                        case 2:
                            console.warn("unhandled ANIM compression: long Delta");
                            break;
                        case 3:
                            console.warn("unhandled ANIM compression: short Delta");
                            break;
                        case 4:
                            console.warn("unhandled ANIM compression: Generalized Delta");
                            break;
                        case 5:
                            // This is the default compression method for Deluxe Paint Animations.
                            let startIndex = file.index;
                            let pointers = [];
                            for(let i = 0; i < 8; i++)pointers.push(file.readDWord());
                            let colCount = parent.width + 15 >>> 4 << 1;
                            let bitPlaneCount = Math.min(parent.numPlanes, 8);
                            for(let bitPlaneIndex = 0; bitPlaneIndex < bitPlaneCount; bitPlaneIndex++){
                                let pointer = pointers[bitPlaneIndex];
                                if (pointer) {
                                    //console.log('handling bitPlaneIndex ' + bitPlaneIndex + ' at ' + pointer);
                                    file.goto(startIndex + pointer);
                                    for(let colIndex = 0; colIndex < colCount; colIndex++){
                                        let opCount = file.readUbyte();
                                        if (opCount === 0) continue;
                                        //console.warn(opCount + " opCounts in column " + colIndex);
                                        let destinationIndex = 0;
                                        for(let opIndex = 0; opIndex < opCount; opIndex++){
                                            let opCode = file.readUbyte();
                                            //console.warn("opCode", opCode);
                                            if (opCode === 0) {
                                                //Same ops
                                                let copyCount = file.readUbyte();
                                                let byteToCopy = file.readUbyte();
                                                //console.warn("copy",byteToCopy,copyCount);
                                                for(let i = 0; i < copyCount; i++){
                                                    let y = destinationIndex;
                                                    //data[(destinationIndex * bitPlaneCount + bitPlaneIndex) * colCount + colIndex] = byteToCopy;
                                                    for(let bi = 7; bi >= 0; bi--){
                                                        let x = colIndex * 8 + 7 - bi;
                                                        const bit = byteToCopy & 1 << bi ? 1 : 0;
                                                        img.planes[bitPlaneIndex][y][x] = bit;
                                                    }
                                                    destinationIndex++;
                                                }
                                            } else if (opCode < 128) // Skip ops: jump over opCode pixels
                                            destinationIndex += opCode;
                                            else {
                                                // Uniq ops: read opCode pixels
                                                opCode -= 128;
                                                for(let i = 0; i < opCode; i++){
                                                    let b = file.readUbyte();
                                                    let y = destinationIndex;
                                                    let bits = [];
                                                    if (destinationIndex < img.height) {
                                                        for(let bi = 7; bi >= 0; bi--){
                                                            let x = colIndex * 8 + 7 - bi;
                                                            const bit = b & 1 << bi ? 1 : 0;
                                                            img.planes[bitPlaneIndex][y][x] = bit;
                                                            bits.push(bit);
                                                        }
                                                        destinationIndex++;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            break;
                        case 6:
                            console.warn("unhandled ANIM compression: Stereo op 5");
                            break;
                        case 7:
                            console.warn("unhandled ANIM compression: short/long Vertical Delta");
                            break;
                        default:
                            console.error(`unhandled ANIM compression: ${img.animHeader.compression}`);
                    }
                    let now = performance.now();
                    // planes to pixels
                    img.pixels = [];
                    for(let y = 0; y < img.height; y++){
                        let line = [];
                        for(let x = 0; x < img.width; x++){
                            let pixel = 0;
                            for(let bitPlaneIndex = 0; bitPlaneIndex < parent.numPlanes; bitPlaneIndex++){
                                let bit = img.planes[bitPlaneIndex][y][x];
                                pixel += bit << bitPlaneIndex;
                            }
                            line.push(pixel);
                        }
                        img.pixels.push(line);
                    }
                    break;
                default:
                    console.warn(`unhandled IFF chunk: ${chunk.name}`);
                    break;
            }
        }
        return img;
    };
    me.detect = function(file) {
        const id = file.readString(4, 0);
        if (id === "FORM") {
            const size = file.readDWord();
            if (size + 8 <= file.length) {
                // the size check isn't always exact for images?
                const format = file.readString(4);
                if (format === "ILBM") return $7e5219ca972f072b$var$FILETYPE.ILBM;
                if (format === "PBM ") return $7e5219ca972f072b$var$FILETYPE.PBM;
                if (format === "ANIM") return $7e5219ca972f072b$var$FILETYPE.ANIM;
                return $7e5219ca972f072b$var$FILETYPE.IFF;
            }
        }
    };
    me.inspect = function(file) {
        let result = "";
        const info = me.parse(file, false);
        if (info.width && info.height) result = `${info.width}x${info.height}`;
        if (info.ham) result += ` HAM${info.numPlanes < 7 ? "6" : "8"}`;
        if (info.trueColor) result += " 24-bit";
        else if (info.colors) result += ` ${info.colors} colours`;
        else if (info.palette) result += `palette with ${info.palette.length} colours`;
        return result;
    };
    me.handle = function(file, action) {
        if (action === "show") {
            const img = me.parse(file, true);
        //if (AdfViewer) AdfViewer.showImage(me.toCanvas(img));
        }
    };
    me.toCanvas = function(img) {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        let pixelWidth = 1;
        if (img.interlaced && !img.hires) {
            canvas.width *= 2;
            pixelWidth = 2;
        }
        //const ctx = canvas.getContext("2d");
        //let imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        if (!img.ham && !img.trueColor && img.colourRange && img.colourRange.length > 0) // Executive decision right here:
        // we're checking for duplicate colors in the palette that are inside the color range
        // if we find any, we're going to slighty alter them to make them unique
        // this is definitely a hack, but otherwise we have to implement full color index tracking through ALL image operations in ALL layers, which is definitely not worth it
        img.palette.forEach((color, index)=>{
            if (img.colourRange.some((range)=>range.low <= index && index <= range.high)) {
                let colorIndex = img.palette.findIndex((c, i)=>i !== index && (0, $bfgOg.default).equals(c, color));
                let offsetIndex = 0;
                let direction = [
                    1,
                    1,
                    1
                ];
                if (color[0] > 128) direction[0] = -1;
                if (color[1] > 128) direction[1] = -1;
                if (color[2] > 128) direction[2] = -1;
                let count = 0;
                while(colorIndex !== -1 && count < 60){
                    color[offsetIndex] += direction[offsetIndex];
                    if (color[offsetIndex] < 0) color[offsetIndex] = 0;
                    if (color[offsetIndex] > 255) color[offsetIndex] = 255;
                    offsetIndex = (offsetIndex + 1) % 3;
                    colorIndex = img.palette.findIndex((c, i)=>i !== index && (0, $bfgOg.default).equals(c, color));
                    count++;
                }
                img.palette[index] = color;
            }
        });
        let imageData = new ImageData(img.width, img.height);
        for(let y = 0; y < img.height; y++){
            let prevColor = [
                0,
                0,
                0
            ];
            for(let x = 0; x < img.width; x++){
                let pixel = img.pixels[y][x];
                let color = img.palette[pixel] || [
                    0,
                    0,
                    0
                ];
                if (img.ham) {
                    const modifier = img.hamPixels[y][x];
                    if (modifier) {
                        pixel <<= 8 - img.colorPlanes; // should the remaining (lower) bits also be filled?
                        color = prevColor.slice();
                        if (modifier === 1) color[3] = pixel;
                        if (modifier === 2) color[0] = pixel;
                        if (modifier === 3) color[1] = pixel;
                    }
                }
                if (img.trueColor) // bits are stored like R0-R7,G0-B7,B0-B7
                // when reading out we just stack them on top, that's why the BlUE values are in 0xff0000 and the RED values are in 0x0000ff
                color = [
                    pixel & 0x0000ff,
                    (pixel & 0x00ff00) >> 8,
                    (pixel & 0xff0000) >> 16
                ];
                prevColor = color;
                for(let i = 0; i < pixelWidth; i++){
                    const index = (y * canvas.width + x * pixelWidth + i) * 4;
                    imageData.data[index] = color[0];
                    imageData.data[index + 1] = color[1];
                    imageData.data[index + 2] = color[2];
                    imageData.data[index + 3] = 255;
                }
            }
        }
        ctx.putImageData(imageData, 0, 0);
        return canvas;
    };
    // creates an ArrayBuffer with the binary data of the image;
    me.write = function(canvas) {
        let colors = (0, $eTCYn.default).isLocked() ? (0, $eTCYn.default).get() : (0, $lPw7G.default).getColors(canvas, 256);
        let bitplaneCount = 1;
        while(1 << bitplaneCount < colors.length)bitplaneCount++;
        while(colors.length < 1 << bitplaneCount)colors.push([
            0,
            0,
            0
        ]);
        const w = canvas.width;
        const h = canvas.height;
        const pixels = canvas.getContext("2d").getImageData(0, 0, w, h).data;
        const bytesPerLine = Math.ceil(w / 16) * 2;
        const bodySize = bytesPerLine * bitplaneCount * h;
        let fileSize = 56;
        fileSize += colors.length * 3;
        fileSize += bodySize;
        if (fileSize & 1) fileSize++;
        const file = (0, $3QDcZ.default)(new ArrayBuffer(fileSize), true);
        file.goto(0);
        file.writeString("FORM");
        file.writeDWord(fileSize - 8);
        file.writeString("ILBM");
        file.writeString("BMHD");
        file.writeDWord(20);
        file.writeWord(w);
        file.writeWord(h);
        file.writeWord(0);
        file.writeWord(0);
        file.writeUbyte(bitplaneCount);
        file.writeUbyte(0);
        file.writeUbyte(0);
        file.writeUbyte(0);
        file.writeWord(0);
        file.writeUbyte(1);
        file.writeUbyte(1);
        file.writeWord(w);
        file.writeWord(h);
        // palette
        file.writeString("CMAP");
        file.writeDWord(colors.length * 3);
        colors.forEach((color)=>{
            file.writeUbyte(color[0]);
            file.writeUbyte(color[1]);
            file.writeUbyte(color[2]);
        });
        // body
        file.writeString("BODY");
        file.writeDWord(bodySize);
        const bitplaneLines = [];
        function getIndex(color) {
            let index = colors.findIndex((c)=>c[0] === color[0] && c[1] === color[1] && c[2] === color[2]);
            if (index < 0) {
                index = 0;
                console.error("color not found in palette", color);
            }
            return index;
        }
        for(let y = 0; y < h; y++){
            for(var i = 0; i < bitplaneCount; i++)bitplaneLines[i] = new Uint8Array(bytesPerLine);
            for(let x = 0; x < w; x++){
                let colorIndex = 0;
                const pixel = (x + y * w) * 4;
                const color = [
                    pixels[pixel],
                    pixels[pixel + 1],
                    pixels[pixel + 2]
                ];
                // should we use an alpha threshold?
                // const a = pixels[pixel + 3];
                colorIndex = getIndex(color);
                for(i = 0; i < bitplaneCount; i++)if (colorIndex & 1 << i) bitplaneLines[i][x >> 3] |= 0x80 >> (x & 7);
            }
            for(i = 0; i < bitplaneCount; i++)for(let bi = 0; bi < bytesPerLine; bi++)file.writeUbyte(bitplaneLines[i][bi]);
        }
        return file.buffer;
    };
    me.toBitPlanes = function(canvas) {
        let addExtraPlane = false;
        let colors = (0, $eTCYn.default).isLocked() ? (0, $eTCYn.default).get() : (0, $lPw7G.default).getColors(canvas, 256);
        let bitplaneCount = 1;
        while(1 << bitplaneCount < colors.length)bitplaneCount++;
        while(colors.length < 1 << bitplaneCount)colors.push([
            0,
            0,
            0
        ]);
        const w = canvas.width;
        const h = canvas.height;
        const pixels = canvas.getContext("2d").getImageData(0, 0, w, h).data;
        const bytesPerLine = Math.ceil(w / 16) * 2;
        const bitPlaneSize = bytesPerLine * h;
        let fileSize = bitPlaneSize * bitplaneCount;
        if (addExtraPlane) fileSize += bitPlaneSize;
        const file = (0, $3QDcZ.default)(new ArrayBuffer(fileSize), true);
        file.goto(0);
        const bitplanes = [];
        function getIndex(color) {
            let index = colors.findIndex((c)=>c[0] === color[0] && c[1] === color[1] && c[2] === color[2]);
            if (index < 0) {
                index = 0;
                console.error("color not found in palette", color);
            }
            return index;
        }
        for(var i = 0; i < bitplaneCount; i++)bitplanes[i] = new Uint8Array(bitPlaneSize);
        for(let y = 0; y < h; y++)for(let x = 0; x < w; x++){
            let colorIndex = 0;
            const pixel = (x + y * w) * 4;
            const color = [
                pixels[pixel],
                pixels[pixel + 1],
                pixels[pixel + 2]
            ];
            colorIndex = getIndex(color);
            for(i = 0; i < bitplaneCount; i++)if (colorIndex & 1 << i) {
                let index = y * bytesPerLine + (x >> 3);
                bitplanes[i][index] |= 0x80 >> (x & 7);
            }
        }
        for(i = 0; i < bitplaneCount; i++)for(let bi = 0; bi < bitPlaneSize; bi++)file.writeUbyte(bitplanes[i][bi]);
        if (addExtraPlane) for(let bi = 0; bi < bitPlaneSize; bi++)file.writeUbyte(255);
        return {
            width: w,
            height: h,
            palette: colors,
            planes: file.buffer
        };
    };
    me.toBitMask = function(canvas) {
        let bitplaneCount = 1;
        const w = canvas.width;
        const h = canvas.height;
        const pixels = canvas.getContext("2d").getImageData(0, 0, w, h).data;
        const bytesPerLine = Math.ceil(w / 16) * 2;
        const bitPlaneSize = bytesPerLine * h;
        let fileSize = bitPlaneSize * bitplaneCount;
        const file = (0, $3QDcZ.default)(new ArrayBuffer(fileSize), true);
        file.goto(0);
        const bitplanes = [
            new Uint8Array(bitPlaneSize)
        ];
        for(let y = 0; y < h; y++)for(let x = 0; x < w; x++){
            let colorIndex = 0;
            const pixel = (x + y * w) * 4;
            let alpha = pixels[pixel + 3];
            if (alpha > 128) colorIndex = 1;
            if (colorIndex) {
                let index = y * bytesPerLine + (x >> 3);
                bitplanes[0][index] |= 0x80 >> (x & 7);
            }
        }
        for(let bi = 0; bi < bitPlaneSize; bi++)file.writeUbyte(bitplanes[0][bi]);
        return {
            planes: file.buffer
        };
    };
    return me;
}();
var $7e5219ca972f072b$export$2e2bcd8739ae039 = $7e5219ca972f072b$var$IFF;

});
parcelRegister("lPw7G", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe4747501471ebdd$export$2e2bcd8739ae039);

var $9dDG4 = parcelRequire("9dDG4");

var $k5ZAj = parcelRequire("k5ZAj");

var $eTCYn = parcelRequire("eTCYn");

var $jU8Uk = parcelRequire("jU8Uk");

var $bfgOg = parcelRequire("bfgOg");

var $fe4747501471ebdd$var$ImageProcessing = function() {
    var me = {};
    var imageInfos = {};
    // good explanation on dithering: https://tannerhelland.com/2012/12/28/dithering-eleven-algorithms-source-code.html
    // also: implement  https://twitter.com/lorenschmidt/status/1468671174821486594?s=20 ?
    // I kind of forgot where the original code came from.
    // maybe http://tool.anides.de/ ?
    // if so: credits to the original author. Sorry, I forgot your name.
    var dithering = [
        {
            Name: "none",
            label: "None",
            pattern: null
        },
        {
            Name: "checks1",
            label: "Checks (very low)",
            pattern: [
                8,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        {
            Name: "checks2",
            label: "Checks (low)",
            pattern: [
                16,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        {
            Name: "checks3",
            label: "Checks (medium)",
            pattern: [
                32,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        {
            Name: "checks4",
            label: "Checks (high)",
            pattern: [
                64,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        {
            Name: "checks5",
            label: "Checks (very high)",
            pattern: [
                128,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        {
            Name: "checks6",
            label: "Checks (very high 2)",
            pattern: [
                256,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        {
            Name: "fs",
            label: "Floyd-Steinberg",
            pattern: [
                0,
                0,
                0,
                0.4375,
                0,
                0,
                0.1875,
                0.3125,
                0.0625,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        {
            Name: "fs85",
            label: "Floyd-Steinberg (85%)",
            pattern: [
                0,
                0,
                0,
                0.371875,
                0,
                0,
                0.159375,
                0.265625,
                0.053125,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        {
            Name: "fs75",
            label: "Floyd-Steinberg (75%)",
            pattern: [
                0,
                0,
                0,
                0.328125,
                0,
                0,
                0.140625,
                0.234375,
                0.046875,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        {
            Name: "fs50",
            label: "Floyd-Steinberg (50%)",
            pattern: [
                0,
                0,
                0,
                0.21875,
                0,
                0,
                0.09375,
                0.15625,
                0.03125,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        {
            Name: "jjn",
            label: "Jarvis, Judice, and Ninke",
            pattern: [
                0,
                0,
                0,
                7.0 / 48.0,
                5.0 / 48.0,
                0.0625,
                5.0 / 48.0,
                7.0 / 48.0,
                5.0 / 48.0,
                0.0625,
                1.0 / 48.0,
                0.0625,
                5.0 / 48.0,
                0.0625,
                1.0 / 48.0
            ]
        },
        {
            Name: "s",
            label: "Stucki",
            pattern: [
                0,
                0,
                0,
                8.0 / 42.0,
                4.0 / 42.0,
                2.0 / 42.0,
                4.0 / 42.0,
                8.0 / 42.0,
                4.0 / 42.0,
                2.0 / 42.0,
                1.0 / 42.0,
                2.0 / 42.0,
                4.0 / 42.0,
                2.0 / 42.0,
                1.0 / 42.0
            ]
        },
        {
            Name: "a",
            label: "Atkinson",
            pattern: [
                0,
                0,
                0,
                0.125,
                0.125,
                0,
                0.125,
                0.125,
                0.125,
                0,
                0,
                0,
                0.125,
                0,
                0
            ]
        },
        {
            Name: "b",
            label: "Burkes",
            pattern: [
                0,
                0,
                0,
                0.25,
                0.125,
                0.0625,
                0.125,
                0.25,
                0.125,
                0.0625,
                0,
                0,
                0,
                0,
                0
            ]
        },
        {
            Name: "s",
            label: "Sierra",
            pattern: [
                0,
                0,
                0,
                0.15625,
                0.09375,
                0.0625,
                0.125,
                0.15625,
                0.125,
                0.0625,
                0,
                0.0625,
                0.09375,
                0.0625,
                0
            ]
        },
        {
            Name: "trs",
            label: "Two-Row Sierra",
            pattern: [
                0,
                0,
                0,
                0.25,
                0.1875,
                0.0625,
                0.125,
                0.1875,
                0.125,
                0.0625,
                0,
                0,
                0,
                0,
                0
            ]
        },
        {
            Name: "sl",
            label: "Sierra Lite",
            pattern: [
                0,
                0,
                0,
                0.5,
                0,
                0,
                0.25,
                0.25,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        }
    ];
    var ditherPattern = null;
    var alphaThreshold = 44;
    var mattingColor = "rgb(149,149,149)";
    mattingColor = "rgb(192,192,192)";
    me.getDithering = function() {
        return dithering;
    };
    me.matting = function() {
        if (imageInfos.canvas) {
            var opaqueCanvas = document.createElement("canvas");
            opaqueCanvas.width = imageInfos.canvas.width;
            opaqueCanvas.height = imageInfos.canvas.height;
            var opaqueCtx = opaqueCanvas.getContext("2d");
            opaqueCtx.fillStyle = mattingColor;
            opaqueCtx.fillRect(0, 0, opaqueCanvas.width, opaqueCanvas.height);
            opaqueCtx.drawImage(imageInfos.canvas, 0, 0);
            var ctx = imageInfos.canvas.getContext("2d");
            var data = ctx.getImageData(0, 0, imageInfos.canvas.width, imageInfos.canvas.height);
            var opaqueData = opaqueCtx.getImageData(0, 0, imageInfos.canvas.width, imageInfos.canvas.height);
            for(var y = 0; y < imageInfos.canvas.height; y++)for(var x = 0; x < imageInfos.canvas.width; x++){
                var index = (x + y * imageInfos.canvas.width) * 4;
                var red = opaqueData.data[index];
                var green = opaqueData.data[index + 1];
                var blue = opaqueData.data[index + 2];
                var alpha = data.data[index + 3];
                if (alpha < 255) {
                    if (alpha >= alphaThreshold) {
                        ctx.fillStyle = "rgb(" + red + "," + green + "," + blue + ")";
                        ctx.fillRect(x, y, 1, 1);
                    } else ctx.clearRect(x, y, 1, 1);
                }
            }
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).imageContentChanged);
        }
    };
    me.getColors = function(canvas, stopAtMax) {
        imageInfos.canvas = canvas;
        let ctx = canvas.getContext("2d");
        let data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
        let colorCube = new Uint32Array(16777216);
        let colors = [];
        for(var Y = 0; Y < canvas.height; Y++)for(var X = 0; X < canvas.width; X++){
            var pixelIndex = (X + Y * canvas.width) * 4;
            var red = data[pixelIndex];
            var green = data[pixelIndex + 1];
            var blue = data[pixelIndex + 2];
            var alpha = data[pixelIndex + 3];
            if (alpha >= alphaThreshold) {
                if (colorCube[red * 65536 + green * 256 + blue] == 0) colors.push([
                    red,
                    green,
                    blue
                ]);
                colorCube[red * 65536 + green * 256 + blue]++;
                if (stopAtMax && colors.length > stopAtMax) return colors;
            }
        }
        colors.sort(function(c1, c2) {
            return SrgbToRgb(c1[0]) * 0.21 + SrgbToRgb(c1[1]) * 0.72 + SrgbToRgb(c1[2]) * 0.07 - (SrgbToRgb(c2[0]) * 0.21 + SrgbToRgb(c2[1]) * 0.72 + SrgbToRgb(c2[2]) * 0.07);
        });
        return colors;
    };
    me.reduce = function(canvas, colors, _alphaThreshold, ditherIndex) {
        alphaThreshold = _alphaThreshold || 0;
        ditherPattern = dithering[ditherIndex || 0].pattern;
        var bitsPerColor = 8;
        var mode = "Palette";
        if (!isNaN(colors)) mode = colors;
        else imageInfos.palette = colors;
        imageInfos.canvas = canvas;
        imageInfos.colorCount = colors;
        me.matting();
        processImage(mode, bitsPerColor, ditherPattern, "id");
    };
    function RgbToSrgb(ColorChannel) {
        return Math.pow(ColorChannel / 255, 1 / 2.2) * 255;
    }
    function SrgbToRgb(ColorChannel) {
        return Math.pow(ColorChannel / 255, 2.2) * 255;
    }
    function colorDistance(RedDelta, GreenDelta, BlueDelta, LuminanceDelta) {
        return RedDelta * RedDelta + GreenDelta * GreenDelta + BlueDelta * BlueDelta + LuminanceDelta * LuminanceDelta * 6;
    }
    function remapImage(canvas, Colors, ditherPattern) {
        var Context = canvas.getContext("2d");
        var Data = Context.getImageData(0, 0, canvas.width, canvas.height);
        var MixedColors = [];
        for(var Index = 0; Index < Colors.length; Index++)MixedColors.push({
            Red: Colors[Index].Red,
            Green: Colors[Index].Green,
            Blue: Colors[Index].Blue,
            TrueRed: SrgbToRgb(Colors[Index].Red),
            TrueGreen: SrgbToRgb(Colors[Index].Green),
            TrueBlue: SrgbToRgb(Colors[Index].Blue)
        });
        if (ditherPattern && ditherPattern[0] > 0 && Colors.length <= 64) {
            for(var Index1 = 0; Index1 < Colors.length; Index1++)for(var Index2 = Index1 + 1; Index2 < Colors.length; Index2++){
                var Luminance1 = SrgbToRgb(Colors[Index1].Red) * 0.21 + SrgbToRgb(Colors[Index1].Green) * 0.72 + SrgbToRgb(Colors[Index1].Blue) * 0.07;
                var Luminance2 = SrgbToRgb(Colors[Index2].Red) * 0.21 + SrgbToRgb(Colors[Index2].Green) * 0.72 + SrgbToRgb(Colors[Index2].Blue) * 0.07;
                var LuminanceDeltaSquare = (Luminance1 - Luminance2) * (Luminance1 - Luminance2);
                if (LuminanceDeltaSquare < ditherPattern[0] * ditherPattern[0]) {
                    var Red = RgbToSrgb((SrgbToRgb(Colors[Index1].Red) + SrgbToRgb(Colors[Index2].Red)) / 2.0);
                    var Green = RgbToSrgb((SrgbToRgb(Colors[Index1].Green) + SrgbToRgb(Colors[Index2].Green)) / 2.0);
                    var Blue = RgbToSrgb((SrgbToRgb(Colors[Index1].Blue) + SrgbToRgb(Colors[Index2].Blue)) / 2.0);
                    MixedColors.push({
                        Index1: Index1,
                        Index2: Index2,
                        Red: Red,
                        Green: Green,
                        Blue: Blue,
                        TrueRed: SrgbToRgb(Red),
                        TrueGreen: SrgbToRgb(Green),
                        TrueBlue: SrgbToRgb(Blue)
                    });
                }
            }
        }
        Colors = MixedColors;
        for(var Y = 0; Y < canvas.height; Y++)for(var X = 0; X < canvas.width; X++){
            var pixelIndex = (X + Y * canvas.width) * 4;
            var SrgbIndex = X + Y * canvas.width;
            var Red = Data.data[pixelIndex];
            var Green = Data.data[pixelIndex + 1];
            var Blue = Data.data[pixelIndex + 2];
            var alpha = Data.data[pixelIndex + 3];
            var TrueRed = SrgbToRgb(Red);
            var TrueGreen = SrgbToRgb(Green);
            var TrueBlue = SrgbToRgb(Blue);
            var Luminance = TrueRed * 0.21 + TrueGreen * 0.72 + TrueBlue * 0.07;
            if (alpha >= alphaThreshold) {
                // Find the matching color index.
                var LastDistance = Number.MAX_VALUE;
                var RemappedColorIndex = 0;
                for(var ColorIndex = 0; ColorIndex < Colors.length; ColorIndex++){
                    var RedDelta = Colors[ColorIndex].TrueRed - TrueRed;
                    var GreenDelta = Colors[ColorIndex].TrueGreen - TrueGreen;
                    var BlueDelta = Colors[ColorIndex].TrueBlue - TrueBlue;
                    var LuminanceDelta = Colors[ColorIndex].TrueRed * 0.21 + Colors[ColorIndex].TrueGreen * 0.72 + Colors[ColorIndex].TrueBlue * 0.07 - Luminance;
                    var Distance = 0;
                    if (Colors[ColorIndex].Index1 !== undefined) {
                        var RedDelta1 = Colors[Colors[ColorIndex].Index1].TrueRed - TrueRed;
                        var GreenDelta1 = Colors[Colors[ColorIndex].Index1].TrueGreen - TrueGreen;
                        var BlueDelta1 = Colors[Colors[ColorIndex].Index1].TrueBlue - TrueBlue;
                        var LuminanceDelta1 = Colors[Colors[ColorIndex].Index1].TrueRed * 0.21 + Colors[Colors[ColorIndex].Index1].TrueGreen * 0.72 + Colors[Colors[ColorIndex].Index1].TrueBlue * 0.07 - Luminance;
                        var RedDelta2 = Colors[Colors[ColorIndex].Index2].TrueRed - TrueRed;
                        var GreenDelta2 = Colors[Colors[ColorIndex].Index2].TrueGreen - TrueGreen;
                        var BlueDelta2 = Colors[Colors[ColorIndex].Index2].TrueBlue - TrueBlue;
                        var LuminanceDelta2 = Colors[Colors[ColorIndex].Index2].TrueRed * 0.21 + Colors[Colors[ColorIndex].Index2].TrueGreen * 0.72 + Colors[Colors[ColorIndex].Index2].TrueBlue * 0.07 - Luminance;
                        Distance = colorDistance(RedDelta, GreenDelta, BlueDelta, LuminanceDelta) * 4;
                        Distance += colorDistance(RedDelta1, GreenDelta1, BlueDelta1, LuminanceDelta1);
                        Distance += colorDistance(RedDelta2, GreenDelta2, BlueDelta2, LuminanceDelta2);
                        Distance /= 6;
                    } else Distance = colorDistance(RedDelta, GreenDelta, BlueDelta, LuminanceDelta);
                    if (Distance < LastDistance) {
                        RemappedColorIndex = ColorIndex;
                        LastDistance = Distance;
                    }
                }
                if (ditherPattern) {
                    if (ditherPattern[0] > 0) {
                        if (Colors[RemappedColorIndex].Index1 !== undefined) {
                            if ((X ^ Y) & 1) RemappedColorIndex = Colors[RemappedColorIndex].Index1;
                            else RemappedColorIndex = Colors[RemappedColorIndex].Index2;
                        }
                        Data.data[pixelIndex] = Colors[RemappedColorIndex].Red;
                        Data.data[pixelIndex + 1] = Colors[RemappedColorIndex].Green;
                        Data.data[pixelIndex + 2] = Colors[RemappedColorIndex].Blue;
                        Data.data[pixelIndex + 3] = alpha;
                    } else {
                        var RedDelta = Colors[RemappedColorIndex].Red - Red;
                        var GreenDelta = Colors[RemappedColorIndex].Green - Green;
                        var BlueDelta = Colors[RemappedColorIndex].Blue - Blue;
                        if (X < canvas.width - 2) {
                            if (ditherPattern[4]) {
                                Data.data[pixelIndex + 8] = Math.round(Math.min(255, Math.max(0, Data.data[pixelIndex + 8] - RedDelta * ditherPattern[4])));
                                Data.data[pixelIndex + 8 + 1] = Math.round(Math.min(255, Math.max(0, Data.data[pixelIndex + 8 + 1] - GreenDelta * ditherPattern[4])));
                                Data.data[pixelIndex + 8 + 2] = Math.round(Math.min(255, Math.max(0, Data.data[pixelIndex + 8 + 2] - BlueDelta * ditherPattern[4])));
                            }
                            if (Y < canvas.height - 1 && ditherPattern[9]) {
                                Data.data[pixelIndex + canvas.width * 4 + 8] = Math.round(Math.min(255, Math.max(0, Data.data[pixelIndex + canvas.width * 4 + 8] - RedDelta * ditherPattern[9])));
                                Data.data[pixelIndex + canvas.width * 4 + 8 + 1] = Math.round(Math.min(255, Math.max(0, Data.data[pixelIndex + canvas.width * 4 + 8 + 1] - GreenDelta * ditherPattern[9])));
                                Data.data[pixelIndex + canvas.width * 4 + 8 + 2] = Math.round(Math.min(255, Math.max(0, Data.data[pixelIndex + canvas.width * 4 + 8 + 2] - BlueDelta * ditherPattern[9])));
                            }
                            if (Y < canvas.height - 2 && ditherPattern[14]) {
                                Data.data[pixelIndex + canvas.width * 8 + 8] = Math.round(Math.min(255, Math.max(0, Data.data[pixelIndex + canvas.width * 8 + 8] - RedDelta * ditherPattern[14])));
                                Data.data[pixelIndex + canvas.width * 8 + 8 + 1] = Math.round(Math.min(255, Math.max(0, Data.data[pixelIndex + canvas.width * 8 + 8 + 1] - GreenDelta * ditherPattern[14])));
                                Data.data[pixelIndex + canvas.width * 8 + 8 + 2] = Math.round(Math.min(255, Math.max(0, Data.data[pixelIndex + canvas.width * 8 + 8 + 2] - BlueDelta * ditherPattern[14])));
                            }
                        }
                        if (X < canvas.width - 1) {
                            if (ditherPattern[3]) {
                                Data.data[pixelIndex + 4] = Math.round(Math.min(255, Math.max(0, Data.data[pixelIndex + 4] - RedDelta * ditherPattern[3])));
                                Data.data[pixelIndex + 4 + 1] = Math.round(Math.min(255, Math.max(0, Data.data[pixelIndex + 4 + 1] - GreenDelta * ditherPattern[3])));
                                Data.data[pixelIndex + 4 + 2] = Math.round(Math.min(255, Math.max(0, Data.data[pixelIndex + 4 + 2] - BlueDelta * ditherPattern[3])));
                            }
                            if (Y < canvas.height - 1 && ditherPattern[8]) {
                                Data.data[pixelIndex + canvas.width * 4 + 4] = Math.round(Math.min(255, Math.max(0, Data.data[pixelIndex + canvas.width * 4 + 4] - RedDelta * ditherPattern[8])));
                                Data.data[pixelIndex + canvas.width * 4 + 4 + 1] = Math.round(Math.min(255, Math.max(0, Data.data[pixelIndex + canvas.width * 4 + 4 + 1] - GreenDelta * ditherPattern[8])));
                                Data.data[pixelIndex + canvas.width * 4 + 4 + 2] = Math.round(Math.min(255, Math.max(0, Data.data[pixelIndex + canvas.width * 4 + 4 + 2] - BlueDelta * ditherPattern[8])));
                            }
                            if (Y < canvas.height - 2 && ditherPattern[13]) {
                                Data.data[pixelIndex + canvas.width * 8 + 4] = Math.round(Math.min(255, Math.max(0, Data.data[pixelIndex + canvas.width * 8 + 4] - RedDelta * ditherPattern[13])));
                                Data.data[pixelIndex + canvas.width * 8 + 4 + 1] = Math.round(Math.min(255, Math.max(0, Data.data[pixelIndex + canvas.width * 8 + 4 + 1] - GreenDelta * ditherPattern[13])));
                                Data.data[pixelIndex + canvas.width * 8 + 4 + 2] = Math.round(Math.min(255, Math.max(0, Data.data[pixelIndex + canvas.width * 8 + 4 + 2] - BlueDelta * ditherPattern[13])));
                            }
                        }
                        if (Y < canvas.height - 1 && ditherPattern[7]) {
                            Data.data[pixelIndex + canvas.width * 4] = Math.round(Math.min(255, Math.max(0, Data.data[pixelIndex + canvas.width * 4] - RedDelta * ditherPattern[7])));
                            Data.data[pixelIndex + canvas.width * 4 + 1] = Math.round(Math.min(255, Math.max(0, Data.data[pixelIndex + canvas.width * 4 + 1] - GreenDelta * ditherPattern[7])));
                            Data.data[pixelIndex + canvas.width * 4 + 2] = Math.round(Math.min(255, Math.max(0, Data.data[pixelIndex + canvas.width * 4 + 2] - BlueDelta * ditherPattern[7])));
                        }
                        if (Y < canvas.height - 2 && ditherPattern[12]) {
                            Data.data[pixelIndex + canvas.width * 8] = Math.round(Math.min(255, Math.max(0, Data.data[pixelIndex + canvas.width * 8] - RedDelta * ditherPattern[12])));
                            Data.data[pixelIndex + canvas.width * 8 + 1] = Math.round(Math.min(255, Math.max(0, Data.data[pixelIndex + canvas.width * 8 + 1] - GreenDelta * ditherPattern[12])));
                            Data.data[pixelIndex + canvas.width * 8 + 2] = Math.round(Math.min(255, Math.max(0, Data.data[pixelIndex + canvas.width * 8 + 2] - BlueDelta * ditherPattern[12])));
                        }
                        if (X > 0) {
                            if (Y < canvas.height - 1 && ditherPattern[6]) {
                                Data.data[pixelIndex + canvas.width * 4 - 4] = Math.round(Math.min(255, Math.max(0, Data.data[pixelIndex + canvas.width * 4 - 4] - RedDelta * ditherPattern[6])));
                                Data.data[pixelIndex + canvas.width * 4 - 4 + 1] = Math.round(Math.min(255, Math.max(0, Data.data[pixelIndex + canvas.width * 4 - 4 + 1] - GreenDelta * ditherPattern[6])));
                                Data.data[pixelIndex + canvas.width * 4 - 4 + 2] = Math.round(Math.min(255, Math.max(0, Data.data[pixelIndex + canvas.width * 4 - 4 + 2] - BlueDelta * ditherPattern[6])));
                            }
                            if (Y < canvas.height - 2 && ditherPattern[11]) {
                                Data.data[pixelIndex + canvas.width * 8 - 4] = Math.round(Math.min(255, Math.max(0, Data.data[pixelIndex + canvas.width * 8 - 4] - RedDelta * ditherPattern[11])));
                                Data.data[pixelIndex + canvas.width * 8 - 4 + 1] = Math.round(Math.min(255, Math.max(0, Data.data[pixelIndex + canvas.width * 8 - 4 + 1] - GreenDelta * ditherPattern[11])));
                                Data.data[pixelIndex + canvas.width * 8 - 4 + 2] = Math.round(Math.min(255, Math.max(0, Data.data[pixelIndex + canvas.width * 8 - 4 + 2] - BlueDelta * ditherPattern[11])));
                            }
                        }
                        if (X > 1) {
                            if (Y < canvas.height - 1 && ditherPattern[5]) {
                                Data.data[pixelIndex + canvas.width * 4 - 8] = Math.round(Math.min(255, Math.max(0, Data.data[pixelIndex + canvas.width * 4 - 8] - RedDelta * ditherPattern[5])));
                                Data.data[pixelIndex + canvas.width * 4 - 8 + 1] = Math.round(Math.min(255, Math.max(0, Data.data[pixelIndex + canvas.width * 4 - 8 + 1] - GreenDelta * ditherPattern[5])));
                                Data.data[pixelIndex + canvas.width * 4 - 8 + 2] = Math.round(Math.min(255, Math.max(0, Data.data[pixelIndex + canvas.width * 4 - 8 + 2] - BlueDelta * ditherPattern[5])));
                            }
                            if (Y < canvas.height - 2 && ditherPattern[10]) {
                                Data.data[pixelIndex + canvas.width * 8 - 8] = Math.round(Math.min(255, Math.max(0, Data.data[pixelIndex + canvas.width * 8 - 8] - RedDelta * ditherPattern[10])));
                                Data.data[pixelIndex + canvas.width * 8 - 8 + 1] = Math.round(Math.min(255, Math.max(0, Data.data[pixelIndex + canvas.width * 8 - 8 + 1] - GreenDelta * ditherPattern[10])));
                                Data.data[pixelIndex + canvas.width * 8 - 8 + 2] = Math.round(Math.min(255, Math.max(0, Data.data[pixelIndex + canvas.width * 8 - 8 + 2] - BlueDelta * ditherPattern[10])));
                            }
                        }
                        Data.data[pixelIndex] = Colors[RemappedColorIndex].Red;
                        Data.data[pixelIndex + 1] = Colors[RemappedColorIndex].Green;
                        Data.data[pixelIndex + 2] = Colors[RemappedColorIndex].Blue;
                        Data.data[pixelIndex + 3] = alpha;
                    }
                } else {
                    var c = Colors[RemappedColorIndex];
                    Data.data[pixelIndex] = c.Red;
                    Data.data[pixelIndex + 1] = c.Green;
                    Data.data[pixelIndex + 2] = c.Blue;
                    Data.data[pixelIndex + 3] = alpha;
                }
            }
        }
        Context.putImageData(Data, 0, 0);
    }
    function remapFullPaletteImage(Canvas, BitsPerColor, DitherPattern) {
        var Context = Canvas.getContext("2d");
        var Data = Context.getImageData(0, 0, Canvas.width, Canvas.height);
        var ShadesPerColor = 1 << BitsPerColor;
        for(var Y = 0; Y < Canvas.height; Y++)for(var X = 0; X < Canvas.width; X++){
            var PixelIndex = (X + Y * Canvas.width) * 4;
            var Red = Data.data[PixelIndex];
            var Green = Data.data[PixelIndex + 1];
            var Blue = Data.data[PixelIndex + 2];
            var Alpha = Data.data[PixelIndex + 3];
            var Luminance = Red * 0.21 + Green * 0.72 + Blue * 0.07;
            var MatchingRed = Red;
            var MatchingGreen = Green;
            var MatchingBlue = Blue;
            if (Alpha >= alphaThreshold) {
                if (DitherPattern) {
                    if (DitherPattern[0] == 1) ;
                    else {
                        // Error diffusion.
                        var ShadesScale = (ShadesPerColor - 1) / 255;
                        var InverseShadesScale = 1 / ShadesScale;
                        MatchingRed = Math.round(Math.round(Red * ShadesScale) * InverseShadesScale);
                        MatchingGreen = Math.round(Math.round(Green * ShadesScale) * InverseShadesScale);
                        MatchingBlue = Math.round(Math.round(Blue * ShadesScale) * InverseShadesScale);
                        var RedDelta = MatchingRed - Red;
                        var GreenDelta = MatchingGreen - Green;
                        var BlueDelta = MatchingBlue - Blue;
                        if (X < Canvas.width - 2) {
                            if (DitherPattern[4]) {
                                Data.data[PixelIndex + 8] = Math.round(Math.min(255, Math.max(0, Data.data[PixelIndex + 8] - RedDelta * DitherPattern[4])));
                                Data.data[PixelIndex + 8 + 1] = Math.round(Math.min(255, Math.max(0, Data.data[PixelIndex + 8 + 1] - GreenDelta * DitherPattern[4])));
                                Data.data[PixelIndex + 8 + 2] = Math.round(Math.min(255, Math.max(0, Data.data[PixelIndex + 8 + 2] - BlueDelta * DitherPattern[4])));
                            }
                            if (Y < Canvas.height - 1 && DitherPattern[9]) {
                                Data.data[PixelIndex + Canvas.width * 4 + 8] = Math.round(Math.min(255, Math.max(0, Data.data[PixelIndex + Canvas.width * 4 + 8] - RedDelta * DitherPattern[9])));
                                Data.data[PixelIndex + Canvas.width * 4 + 8 + 1] = Math.round(Math.min(255, Math.max(0, Data.data[PixelIndex + Canvas.width * 4 + 8 + 1] - GreenDelta * DitherPattern[9])));
                                Data.data[PixelIndex + Canvas.width * 4 + 8 + 2] = Math.round(Math.min(255, Math.max(0, Data.data[PixelIndex + Canvas.width * 4 + 8 + 2] - BlueDelta * DitherPattern[9])));
                            }
                            if (Y < Canvas.height - 2 && DitherPattern[14]) {
                                Data.data[PixelIndex + Canvas.width * 8 + 8] = Math.round(Math.min(255, Math.max(0, Data.data[PixelIndex + Canvas.width * 8 + 8] - RedDelta * DitherPattern[14])));
                                Data.data[PixelIndex + Canvas.width * 8 + 8 + 1] = Math.round(Math.min(255, Math.max(0, Data.data[PixelIndex + Canvas.width * 8 + 8 + 1] - GreenDelta * DitherPattern[14])));
                                Data.data[PixelIndex + Canvas.width * 8 + 8 + 2] = Math.round(Math.min(255, Math.max(0, Data.data[PixelIndex + Canvas.width * 8 + 8 + 2] - BlueDelta * DitherPattern[14])));
                            }
                        }
                        if (X < Canvas.width - 1) {
                            if (DitherPattern[3]) {
                                Data.data[PixelIndex + 4] = Math.round(Math.min(255, Math.max(0, Data.data[PixelIndex + 4] - RedDelta * DitherPattern[3])));
                                Data.data[PixelIndex + 4 + 1] = Math.round(Math.min(255, Math.max(0, Data.data[PixelIndex + 4 + 1] - GreenDelta * DitherPattern[3])));
                                Data.data[PixelIndex + 4 + 2] = Math.round(Math.min(255, Math.max(0, Data.data[PixelIndex + 4 + 2] - BlueDelta * DitherPattern[3])));
                            }
                            if (Y < Canvas.height - 1 && DitherPattern[8]) {
                                Data.data[PixelIndex + Canvas.width * 4 + 4] = Math.round(Math.min(255, Math.max(0, Data.data[PixelIndex + Canvas.width * 4 + 4] - RedDelta * DitherPattern[8])));
                                Data.data[PixelIndex + Canvas.width * 4 + 4 + 1] = Math.round(Math.min(255, Math.max(0, Data.data[PixelIndex + Canvas.width * 4 + 4 + 1] - GreenDelta * DitherPattern[8])));
                                Data.data[PixelIndex + Canvas.width * 4 + 4 + 2] = Math.round(Math.min(255, Math.max(0, Data.data[PixelIndex + Canvas.width * 4 + 4 + 2] - BlueDelta * DitherPattern[8])));
                            }
                            if (Y < Canvas.height - 2 && DitherPattern[13]) {
                                Data.data[PixelIndex + Canvas.width * 8 + 4] = Math.round(Math.min(255, Math.max(0, Data.data[PixelIndex + Canvas.width * 8 + 4] - RedDelta * DitherPattern[13])));
                                Data.data[PixelIndex + Canvas.width * 8 + 4 + 1] = Math.round(Math.min(255, Math.max(0, Data.data[PixelIndex + Canvas.width * 8 + 4 + 1] - GreenDelta * DitherPattern[13])));
                                Data.data[PixelIndex + Canvas.width * 8 + 4 + 2] = Math.round(Math.min(255, Math.max(0, Data.data[PixelIndex + Canvas.width * 8 + 4 + 2] - BlueDelta * DitherPattern[13])));
                            }
                        }
                        if (Y < Canvas.height - 1 && DitherPattern[7]) {
                            Data.data[PixelIndex + Canvas.width * 4] = Math.round(Math.min(255, Math.max(0, Data.data[PixelIndex + Canvas.width * 4] - RedDelta * DitherPattern[7])));
                            Data.data[PixelIndex + Canvas.width * 4 + 1] = Math.round(Math.min(255, Math.max(0, Data.data[PixelIndex + Canvas.width * 4 + 1] - GreenDelta * DitherPattern[7])));
                            Data.data[PixelIndex + Canvas.width * 4 + 2] = Math.round(Math.min(255, Math.max(0, Data.data[PixelIndex + Canvas.width * 4 + 2] - BlueDelta * DitherPattern[7])));
                        }
                        if (Y < Canvas.height - 2 && DitherPattern[12]) {
                            Data.data[PixelIndex + Canvas.width * 8] = Math.round(Math.min(255, Math.max(0, Data.data[PixelIndex + Canvas.width * 8] - RedDelta * DitherPattern[12])));
                            Data.data[PixelIndex + Canvas.width * 8 + 1] = Math.round(Math.min(255, Math.max(0, Data.data[PixelIndex + Canvas.width * 8 + 1] - GreenDelta * DitherPattern[12])));
                            Data.data[PixelIndex + Canvas.width * 8 + 2] = Math.round(Math.min(255, Math.max(0, Data.data[PixelIndex + Canvas.width * 8 + 2] - BlueDelta * DitherPattern[12])));
                        }
                        if (X > 0) {
                            if (Y < Canvas.height - 1 && DitherPattern[6]) {
                                Data.data[PixelIndex + Canvas.width * 4 - 4] = Math.round(Math.min(255, Math.max(0, Data.data[PixelIndex + Canvas.width * 4 - 4] - RedDelta * DitherPattern[6])));
                                Data.data[PixelIndex + Canvas.width * 4 - 4 + 1] = Math.round(Math.min(255, Math.max(0, Data.data[PixelIndex + Canvas.width * 4 - 4 + 1] - GreenDelta * DitherPattern[6])));
                                Data.data[PixelIndex + Canvas.width * 4 - 4 + 2] = Math.round(Math.min(255, Math.max(0, Data.data[PixelIndex + Canvas.width * 4 - 4 + 2] - BlueDelta * DitherPattern[6])));
                            }
                            if (Y < Canvas.height - 2 && DitherPattern[11]) {
                                Data.data[PixelIndex + Canvas.width * 8 - 4] = Math.round(Math.min(255, Math.max(0, Data.data[PixelIndex + Canvas.width * 8 - 4] - RedDelta * DitherPattern[11])));
                                Data.data[PixelIndex + Canvas.width * 8 - 4 + 1] = Math.round(Math.min(255, Math.max(0, Data.data[PixelIndex + Canvas.width * 8 - 4 + 1] - GreenDelta * DitherPattern[11])));
                                Data.data[PixelIndex + Canvas.width * 8 - 4 + 2] = Math.round(Math.min(255, Math.max(0, Data.data[PixelIndex + Canvas.width * 8 - 4 + 2] - BlueDelta * DitherPattern[11])));
                            }
                        }
                        if (X > 1) {
                            if (Y < Canvas.height - 1 && DitherPattern[5]) {
                                Data.data[PixelIndex + Canvas.width * 4 - 8] = Math.round(Math.min(255, Math.max(0, Data.data[PixelIndex + Canvas.width * 4 - 8] - RedDelta * DitherPattern[5])));
                                Data.data[PixelIndex + Canvas.width * 4 - 8 + 1] = Math.round(Math.min(255, Math.max(0, Data.data[PixelIndex + Canvas.width * 4 - 8 + 1] - GreenDelta * DitherPattern[5])));
                                Data.data[PixelIndex + Canvas.width * 4 - 8 + 2] = Math.round(Math.min(255, Math.max(0, Data.data[PixelIndex + Canvas.width * 4 - 8 + 2] - BlueDelta * DitherPattern[5])));
                            }
                            if (Y < Canvas.height - 2 && DitherPattern[10]) {
                                Data.data[PixelIndex + Canvas.width * 8 - 8] = Math.round(Math.min(255, Math.max(0, Data.data[PixelIndex + Canvas.width * 8 - 8] - RedDelta * DitherPattern[10])));
                                Data.data[PixelIndex + Canvas.width * 8 - 8 + 1] = Math.round(Math.min(255, Math.max(0, Data.data[PixelIndex + Canvas.width * 8 - 8 + 1] - GreenDelta * DitherPattern[10])));
                                Data.data[PixelIndex + Canvas.width * 8 - 8 + 2] = Math.round(Math.min(255, Math.max(0, Data.data[PixelIndex + Canvas.width * 8 - 8 + 2] - BlueDelta * DitherPattern[10])));
                            }
                        }
                    }
                }
                //console.error(MatchingRed);
                Data.data[PixelIndex] = MatchingRed;
                Data.data[PixelIndex + 1] = MatchingGreen;
                Data.data[PixelIndex + 2] = MatchingBlue;
                Data.data[PixelIndex + 3] = Alpha;
            }
        }
        Context.putImageData(Data, 0, 0);
    }
    function processImage(colorCount, bitsPerColor, ditherPattern, Id) {
        var colors = [];
        var useTransparentColor = true;
        var transparentColor = useTransparentColor ? (0, $eTCYn.default).getBackgroundColor() : undefined;
        if (colorCount === "Palette") {
            for(var i = 0; i < imageInfos.palette.length; i++){
                var color = (0, $bfgOg.default).fromString(imageInfos.palette[i]);
                colors.push({
                    Red: color[0],
                    Green: color[1],
                    Blue: color[2],
                    Alpha: 255
                });
            }
            imageInfos.QuantizedColors = colors;
            remapImage(imageInfos.canvas, colors, ditherPattern);
        } else {
            if (!imageInfos.Colors || imageInfos.Colors.length > colorCount) {
                if (colorCount === 2) {
                    if (useTransparentColor) colors.push({
                        Red: transparentColor[0],
                        Green: transparentColor[1],
                        Blue: transparentColor[2]
                    });
                    else colors.push({
                        Red: 255,
                        Green: 255,
                        Blue: 255
                    });
                    colors.push({
                        Red: 0,
                        Green: 0,
                        Blue: 0
                    });
                    imageInfos.QuantizedColors = colors;
                    remapImage(imageInfos.canvas, colors, ditherPattern);
                    updateImageWindow(Id);
                } else {
                    if (useTransparentColor) colorCount--;
                    var MaxRecursionDepth = 1;
                    while(Math.pow(2, MaxRecursionDepth) < colorCount)MaxRecursionDepth++;
                    var QuantizeWorker = new Worker((parcelRequire("a8IsR")));
                    var QuantizeData = {
                        LineIndex: 0,
                        CanvasData: imageInfos.canvas.getContext("2d").getImageData(0, 0, imageInfos.canvas.width, imageInfos.canvas.height),
                        MaxRecursionDepth: MaxRecursionDepth,
                        BitsPerColor: bitsPerColor,
                        ColorCount: colorCount,
                        transparentColor: transparentColor
                    };
                    QuantizeWorker.addEventListener("message", function(e) {
                        imageInfos.QuantizedColors = e.data.Colors;
                        remapImage(imageInfos.canvas, imageInfos.QuantizedColors, ditherPattern);
                        if (useTransparentColor && colorCount > 4) imageInfos.QuantizedColors.unshift({
                            Red: transparentColor[0],
                            Green: transparentColor[1],
                            Blue: transparentColor[2]
                        });
                        updateImageWindow(Id);
                    }, false);
                    QuantizeWorker.postMessage(QuantizeData);
                }
                return;
            } else for(var Index = 0; Index < imageInfos.Colors.length; Index++)colors.push({
                Red: imageInfos.Colors[Index].Red,
                Green: imageInfos.Colors[Index].Green,
                Blue: imageInfos.Colors[Index].Blue
            });
            var ShadesPerColor = 1 << bitsPerColor;
            for(var Index = 0; Index < colors.length; Index++){
                var ShadesScale = (ShadesPerColor - 1) / 255;
                var InverseShadesScale = 1 / ShadesScale;
                colors[Index].Red = Math.round(Math.round(colors[Index].Red * ShadesScale) * InverseShadesScale);
                colors[Index].Green = Math.round(Math.round(colors[Index].Green * ShadesScale) * InverseShadesScale);
                colors[Index].Blue = Math.round(Math.round(colors[Index].Blue * ShadesScale) * InverseShadesScale);
            }
        }
        // Remap image.
        if (colorCount === "Palette") remapFullPaletteImage(imageInfos.canvas, bitsPerColor, ditherPattern);
        imageInfos.QuantizedColors = colors;
        updateImageWindow(Id);
    }
    function updateImageWindow() {
        //console.error(imageInfos);
        if (imageInfos.QuantizedColors) {
            var palette = [];
            imageInfos.QuantizedColors.forEach(function(c) {
                palette.push([
                    c.Red,
                    c.Green,
                    c.Blue
                ]);
            });
            //console.error(palette);
            let f = (0, $jU8Uk.default).getCurrentFile();
            let ctx = (0, $jU8Uk.default).getActiveContext();
            ctx.clearRect(0, 0, f.width, f.height);
            ctx.drawImage(imageInfos.canvas, 0, 0);
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layerContentChanged, {
                keepImageCache: true
            });
            (0, $eTCYn.default).set(palette);
            (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).INFO);
        //IconEditor.setPalette(palette);
        //IconEditor.updateIcon();
        }
    }
    me.rotate = function(canvas) {
        let ctx = canvas.getContext("2d");
        let newCanvas = document.createElement("canvas");
        let w = canvas.height;
        let h = canvas.width;
        newCanvas.width = w;
        newCanvas.height = h;
        let newCtx = newCanvas.getContext("2d");
        newCtx.save();
        newCtx.translate(w / 2, h / 2);
        newCtx.rotate(90 * Math.PI / 180);
        newCtx.drawImage(canvas, -h / 2, -w / 2);
        newCtx.restore();
        canvas.height = h;
        canvas.width = w;
        ctx.clearRect(0, 0, w, h);
        ctx.drawImage(newCanvas, 0, 0);
        newCanvas = null;
    };
    me.bayer = function(ctx, threshold, whiteTransparent) {
        let image = ctx.getImageData(0, 0, ctx.canvas.width, ctx.canvas.height);
        const thresholdMap = [
            [
                15,
                135,
                45,
                165
            ],
            [
                195,
                75,
                225,
                105
            ],
            [
                60,
                180,
                30,
                150
            ],
            [
                240,
                120,
                210,
                90
            ]
        ];
        for(let i = 0; i < image.data.length; i += 4){
            const luminance = image.data[i] * 0.299 + image.data[i + 1] * 0.587 + image.data[i + 2] * 0.114;
            const x = i / 4 % image.width;
            const y = Math.floor(i / 4 / image.width);
            const map = Math.floor((luminance + thresholdMap[x % 4][y % 4]) / 2);
            //console.error(map);
            let value = map < threshold ? 0 : 255;
            image.data.fill(value, i, i + 3);
            if (whiteTransparent && value === 255) image.data[i + 3] = 0;
        }
        ctx.putImageData(image, 0, 0);
    };
    // https://github.com/ytiurin/downscale/blob/master/src/downsample.js
    // MIT License - Copyright (c) 2017 Eugene Tiurin
    // seems "good enough" for our purpose and reasonable fast
    // TODO: implement in webworker
    // good article: https://stackoverflow.com/questions/18922880/html5-canvas-resize-downscale-image-high-quality
    // also checkout https://github.com/nodeca/pica
    me.downScale = function(sourceImageData, destWidth, destHeight) {
        function round(val) {
            return val + 0.49 << 0;
        }
        function downsample(sourceImageData, destWidth, destHeight, sourceX, sourceY, sourceWidth, sourceHeight) {
            var dest = new ImageData(destWidth, destHeight);
            var SOURCE_DATA = new Int32Array(sourceImageData.data.buffer);
            var SOURCE_WIDTH = sourceImageData.width;
            var DEST_DATA = new Int32Array(dest.data.buffer);
            var DEST_WIDTH = dest.width;
            var SCALE_FACTOR_X = destWidth / sourceWidth;
            var SCALE_FACTOR_Y = destHeight / sourceHeight;
            var SCALE_RANGE_X = round(1 / SCALE_FACTOR_X);
            var SCALE_RANGE_Y = round(1 / SCALE_FACTOR_Y);
            var SCALE_RANGE_SQR = SCALE_RANGE_X * SCALE_RANGE_Y;
            for(var destRow = 0; destRow < dest.height; destRow++)for(var destCol = 0; destCol < DEST_WIDTH; destCol++){
                var sourceInd = sourceX + round(destCol / SCALE_FACTOR_X) + (sourceY + round(destRow / SCALE_FACTOR_Y)) * SOURCE_WIDTH;
                var destRed = 0;
                var destGreen = 0;
                var destBlue = 0;
                var destAlpha = 0;
                for(var sourceRow = 0; sourceRow < SCALE_RANGE_Y; sourceRow++)for(var sourceCol = 0; sourceCol < SCALE_RANGE_X; sourceCol++){
                    var sourcePx = SOURCE_DATA[sourceInd + sourceCol + sourceRow * SOURCE_WIDTH];
                    destRed += sourcePx << 24 >>> 24;
                    destGreen += sourcePx << 16 >>> 24;
                    destBlue += sourcePx << 8 >>> 24;
                    destAlpha += sourcePx >>> 24;
                }
                destRed = round(destRed / SCALE_RANGE_SQR);
                destGreen = round(destGreen / SCALE_RANGE_SQR);
                destBlue = round(destBlue / SCALE_RANGE_SQR);
                destAlpha = round(destAlpha / SCALE_RANGE_SQR);
                DEST_DATA[destCol + destRow * DEST_WIDTH] = destAlpha << 24 | destBlue << 16 | destGreen << 8 | destRed;
            }
            return dest;
        }
        return downsample(sourceImageData, destWidth, destHeight, 0, 0, sourceImageData.width, sourceImageData.height);
    };
    // http://jsfiddle.net/HZewg/1/
    me.biCubic = function(sourceImageData, destWidth, destHeight) {
        function TERP(t, a, b, c, d) {
            return 0.5 * (c - a + (2.0 * a - 5.0 * b + 4.0 * c - d + (3.0 * (b - c) + d - a) * t) * t) * t + b;
        }
        function ivect(ix, iy, w) {
            // byte array, r,g,b,a
            return (ix + w * iy) * 4;
        }
        function BicubicInterpolation(x, y, values) {
            var i0, i1, i2, i3;
            i0 = TERP(x, values[0][0], values[1][0], values[2][0], values[3][0]);
            i1 = TERP(x, values[0][1], values[1][1], values[2][1], values[3][1]);
            i2 = TERP(x, values[0][2], values[1][2], values[2][2], values[3][2]);
            i3 = TERP(x, values[0][3], values[1][3], values[2][3], values[3][3]);
            return TERP(y, i0, i1, i2, i3);
        }
        var dest = new ImageData(destWidth, destHeight);
        bicubic(sourceImageData, dest);
        return dest;
        function bicubic(srcImg, destImg) {
            let scaleX = destWidth / sourceImageData.width;
            let scaleY = destHeight / sourceImageData.height;
            var i, j;
            var dx, dy;
            var repeatX, repeatY;
            var offset_row0, offset_row1, offset_row2, offset_row3;
            var offset_col0, offset_col1, offset_col2, offset_col3;
            var red_pixels, green_pixels, blue_pixels, alpha_pixels;
            for(i = 0; i < destImg.height; ++i){
                let iyv = i / scaleY;
                let iy0 = Math.floor(iyv);
                // We have to special-case the pixels along the border and repeat their values if necessary
                repeatY = 0;
                if (iy0 < 1) repeatY = -1;
                else if (iy0 > srcImg.height - 3) repeatY = iy0 - (srcImg.height - 3);
                for(j = 0; j < destImg.width; ++j){
                    let ixv = j / scaleX;
                    let ix0 = Math.floor(ixv);
                    // We have to special-case the pixels along the border and repeat their values if necessary
                    repeatX = 0;
                    if (ix0 < 1) repeatX = -1;
                    else if (ix0 > srcImg.width - 3) repeatX = ix0 - (srcImg.width - 3);
                    offset_row1 = (iy0 * srcImg.width + ix0) * 4;
                    offset_row0 = repeatY < 0 ? offset_row1 : ((iy0 - 1) * srcImg.width + ix0) * 4;
                    offset_row2 = repeatY > 1 ? offset_row1 : ((iy0 + 1) * srcImg.width + ix0) * 4;
                    offset_row3 = repeatY > 0 ? offset_row2 : ((iy0 + 2) * srcImg.width + ix0) * 4;
                    offset_col1 = 0;
                    offset_col0 = repeatX < 0 ? offset_col1 : -4;
                    offset_col2 = repeatX > 1 ? offset_col1 : 4;
                    offset_col3 = repeatX > 0 ? offset_col2 : 8;
                    //Each offset is for the start of a row's red pixels
                    red_pixels = [
                        [
                            srcImg.data[offset_row0 + offset_col0],
                            srcImg.data[offset_row1 + offset_col0],
                            srcImg.data[offset_row2 + offset_col0],
                            srcImg.data[offset_row3 + offset_col0]
                        ],
                        [
                            srcImg.data[offset_row0 + offset_col1],
                            srcImg.data[offset_row1 + offset_col1],
                            srcImg.data[offset_row2 + offset_col1],
                            srcImg.data[offset_row3 + offset_col1]
                        ],
                        [
                            srcImg.data[offset_row0 + offset_col2],
                            srcImg.data[offset_row1 + offset_col2],
                            srcImg.data[offset_row2 + offset_col2],
                            srcImg.data[offset_row3 + offset_col2]
                        ],
                        [
                            srcImg.data[offset_row0 + offset_col3],
                            srcImg.data[offset_row1 + offset_col3],
                            srcImg.data[offset_row2 + offset_col3],
                            srcImg.data[offset_row3 + offset_col3]
                        ]
                    ];
                    offset_row0++;
                    offset_row1++;
                    offset_row2++;
                    offset_row3++;
                    //Each offset is for the start of a row's green pixels
                    green_pixels = [
                        [
                            srcImg.data[offset_row0 + offset_col0],
                            srcImg.data[offset_row1 + offset_col0],
                            srcImg.data[offset_row2 + offset_col0],
                            srcImg.data[offset_row3 + offset_col0]
                        ],
                        [
                            srcImg.data[offset_row0 + offset_col1],
                            srcImg.data[offset_row1 + offset_col1],
                            srcImg.data[offset_row2 + offset_col1],
                            srcImg.data[offset_row3 + offset_col1]
                        ],
                        [
                            srcImg.data[offset_row0 + offset_col2],
                            srcImg.data[offset_row1 + offset_col2],
                            srcImg.data[offset_row2 + offset_col2],
                            srcImg.data[offset_row3 + offset_col2]
                        ],
                        [
                            srcImg.data[offset_row0 + offset_col3],
                            srcImg.data[offset_row1 + offset_col3],
                            srcImg.data[offset_row2 + offset_col3],
                            srcImg.data[offset_row3 + offset_col3]
                        ]
                    ];
                    offset_row0++;
                    offset_row1++;
                    offset_row2++;
                    offset_row3++;
                    //Each offset is for the start of a row's blue pixels
                    blue_pixels = [
                        [
                            srcImg.data[offset_row0 + offset_col0],
                            srcImg.data[offset_row1 + offset_col0],
                            srcImg.data[offset_row2 + offset_col0],
                            srcImg.data[offset_row3 + offset_col0]
                        ],
                        [
                            srcImg.data[offset_row0 + offset_col1],
                            srcImg.data[offset_row1 + offset_col1],
                            srcImg.data[offset_row2 + offset_col1],
                            srcImg.data[offset_row3 + offset_col1]
                        ],
                        [
                            srcImg.data[offset_row0 + offset_col2],
                            srcImg.data[offset_row1 + offset_col2],
                            srcImg.data[offset_row2 + offset_col2],
                            srcImg.data[offset_row3 + offset_col2]
                        ],
                        [
                            srcImg.data[offset_row0 + offset_col3],
                            srcImg.data[offset_row1 + offset_col3],
                            srcImg.data[offset_row2 + offset_col3],
                            srcImg.data[offset_row3 + offset_col3]
                        ]
                    ];
                    offset_row0++;
                    offset_row1++;
                    offset_row2++;
                    offset_row3++;
                    //Each offset is for the start of a row's alpha pixels
                    alpha_pixels = [
                        [
                            srcImg.data[offset_row0 + offset_col0],
                            srcImg.data[offset_row1 + offset_col0],
                            srcImg.data[offset_row2 + offset_col0],
                            srcImg.data[offset_row3 + offset_col0]
                        ],
                        [
                            srcImg.data[offset_row0 + offset_col1],
                            srcImg.data[offset_row1 + offset_col1],
                            srcImg.data[offset_row2 + offset_col1],
                            srcImg.data[offset_row3 + offset_col1]
                        ],
                        [
                            srcImg.data[offset_row0 + offset_col2],
                            srcImg.data[offset_row1 + offset_col2],
                            srcImg.data[offset_row2 + offset_col2],
                            srcImg.data[offset_row3 + offset_col2]
                        ],
                        [
                            srcImg.data[offset_row0 + offset_col3],
                            srcImg.data[offset_row1 + offset_col3],
                            srcImg.data[offset_row2 + offset_col3],
                            srcImg.data[offset_row3 + offset_col3]
                        ]
                    ];
                    // overall coordinates to unit square
                    dx = ixv - ix0;
                    dy = iyv - iy0;
                    let idxD = ivect(j, i, destImg.width);
                    destImg.data[idxD] = BicubicInterpolation(dx, dy, red_pixels);
                    destImg.data[idxD + 1] = BicubicInterpolation(dx, dy, green_pixels);
                    destImg.data[idxD + 2] = BicubicInterpolation(dx, dy, blue_pixels);
                    destImg.data[idxD + 3] = BicubicInterpolation(dx, dy, alpha_pixels);
                }
            }
        }
    };
    return me;
}();
var $fe4747501471ebdd$export$2e2bcd8739ae039 = $fe4747501471ebdd$var$ImageProcessing;

});
parcelRegister("eTCYn", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad846eee7cfb94e2$export$2e2bcd8739ae039);

var $eJ26Q = parcelRequire("eJ26Q");

var $9dDG4 = parcelRequire("9dDG4");

var $k5ZAj = parcelRequire("k5ZAj");

var $bfgOg = parcelRequire("bfgOg");

var $lPw7G = parcelRequire("lPw7G");

var $jU8Uk = parcelRequire("jU8Uk");

var $8ztM6 = parcelRequire("8ztM6");

var $9xub8 = parcelRequire("9xub8");

var $bqUff = parcelRequire("bqUff");

var $ex1EM = parcelRequire("ex1EM");

var $8FLxR = parcelRequire("8FLxR");
let $ad846eee7cfb94e2$var$Palette = function() {
    let me = {};
    var container;
    var paletteCanvas;
    var paletteCtx;
    var paletteNav;
    var size = 14;
    var currentPalette;
    var alphaThreshold = 44;
    var ditherIndex = 0;
    var targetColorCount = 32;
    let palettePageIndex = 0;
    let palettePageCount = 1;
    let currentHeight;
    let colorLayers = {};
    let cycleButton;
    let lockButton;
    let isLocked = false;
    let hasDuplicates = false;
    var drawColor = "black";
    var backgroundColor = "white";
    var drawColorIndex = 1;
    var backColorIndex = 0;
    var colors = [
        [
            149,
            149,
            149
        ],
        [
            0,
            0,
            0
        ],
        [
            255,
            255,
            255
        ],
        [
            59,
            103,
            162
        ],
        [
            123,
            123,
            123
        ],
        [
            175,
            175,
            175
        ],
        [
            170,
            144,
            124
        ],
        [
            255,
            169,
            151
        ]
    ];
    var muiPalette = [
        [
            149,
            149,
            149
        ],
        [
            0,
            0,
            0
        ],
        [
            255,
            255,
            255
        ],
        [
            59,
            103,
            162
        ],
        [
            123,
            123,
            123
        ],
        [
            175,
            175,
            175
        ],
        [
            170,
            144,
            124
        ],
        [
            255,
            169,
            151
        ]
    ];
    // https://pixeljoint.com/forum/forum_posts.asp?TID=12795
    var db16Palette = [
        [
            20,
            12,
            28
        ],
        [
            68,
            36,
            52
        ],
        [
            48,
            52,
            109
        ],
        [
            78,
            74,
            78
        ],
        [
            133,
            76,
            48
        ],
        [
            52,
            101,
            36
        ],
        [
            208,
            70,
            72
        ],
        [
            117,
            113,
            97
        ],
        [
            89,
            125,
            206
        ],
        [
            210,
            125,
            44
        ],
        [
            133,
            149,
            161
        ],
        [
            109,
            170,
            44
        ],
        [
            210,
            170,
            153
        ],
        [
            109,
            194,
            202
        ],
        [
            218,
            212,
            94
        ],
        [
            222,
            238,
            214
        ]
    ];
    // DawnBringer's 32 Col Palette
    //http://pixeljoint.com/forum/forum_posts.asp?TID=16247
    var db32Palette = [
        [
            0,
            0,
            0
        ],
        [
            34,
            32,
            52
        ],
        [
            69,
            40,
            60
        ],
        [
            102,
            57,
            49
        ],
        [
            143,
            86,
            59
        ],
        [
            223,
            113,
            38
        ],
        [
            217,
            160,
            102
        ],
        [
            238,
            195,
            154
        ],
        [
            251,
            242,
            54
        ],
        [
            153,
            229,
            80
        ],
        [
            106,
            190,
            48
        ],
        [
            55,
            148,
            110
        ],
        [
            75,
            105,
            47
        ],
        [
            82,
            75,
            36
        ],
        [
            50,
            60,
            57
        ],
        [
            63,
            63,
            116
        ],
        [
            48,
            96,
            130
        ],
        [
            91,
            110,
            225
        ],
        [
            99,
            155,
            255
        ],
        [
            95,
            205,
            228
        ],
        [
            203,
            219,
            252
        ],
        [
            255,
            255,
            255
        ],
        [
            155,
            173,
            183
        ],
        [
            132,
            126,
            135
        ],
        [
            105,
            106,
            106
        ],
        [
            89,
            86,
            82
        ],
        [
            118,
            66,
            138
        ],
        [
            172,
            50,
            50
        ],
        [
            217,
            87,
            99
        ],
        [
            215,
            123,
            186
        ],
        [
            143,
            151,
            74
        ],
        [
            138,
            111,
            48
        ]
    ];
    // https://fulifuli.tumblr.com/post/141892525920/grafxkids-today-land-palette-release
    var gfxkPalette = [
        [
            17,
            10,
            3
        ],
        [
            17,
            10,
            3
        ],
        [
            99,
            13,
            38
        ],
        [
            71,
            18,
            92
        ],
        [
            37,
            30,
            106
        ],
        [
            62,
            40,
            40
        ],
        [
            14,
            53,
            62
        ],
        [
            40,
            53,
            74
        ],
        [
            152,
            30,
            130
        ],
        [
            33,
            74,
            167
        ],
        [
            181,
            45,
            27
        ],
        [
            133,
            62,
            51
        ],
        [
            21,
            105,
            72
        ],
        [
            28,
            100,
            112
        ],
        [
            109,
            93,
            91
        ],
        [
            69,
            105,
            117
        ],
        [
            10,
            152,
            216
        ],
        [
            238,
            98,
            131
        ],
        [
            202,
            117,
            56
        ],
        [
            219,
            110,
            83
        ],
        [
            240,
            117,
            8
        ],
        [
            30,
            182,
            120
        ],
        [
            89,
            179,
            45
        ],
        [
            126,
            174,
            163
        ],
        [
            176,
            162,
            141
        ],
        [
            249,
            178,
            167
        ],
        [
            245,
            185,
            125
        ],
        [
            73,
            227,
            218
        ],
        [
            251,
            197,
            49
        ],
        [
            211,
            229,
            73
        ],
        [
            239,
            239,
            233
        ],
        [
            255,
            255,
            255
        ]
    ];
    var paletteMap = {
        optimized: {
            label: "Optimized",
            palette: null
        },
        current: {
            label: "Current",
            palette: null
        },
        mui: {
            label: "MUI",
            palette: muiPalette
        },
        db8: {
            label: "DawnBringer 8",
            palette: [
                [
                    20,
                    12,
                    28
                ],
                [
                    85,
                    65,
                    95
                ],
                [
                    100,
                    105,
                    100
                ],
                [
                    215,
                    115,
                    85
                ],
                [
                    80,
                    140,
                    215
                ],
                [
                    100,
                    185,
                    100
                ],
                [
                    230,
                    200,
                    110
                ],
                [
                    220,
                    245,
                    255
                ]
            ]
        },
        db16: {
            label: "DawnBringer 16",
            palette: db16Palette
        },
        db32: {
            label: "DawnBringer 32",
            palette: db32Palette
        },
        gfxk16: {
            label: "Grafxkid 16",
            palette: [
                [
                    26,
                    28,
                    44
                ],
                [
                    93,
                    39,
                    93
                ],
                [
                    177,
                    62,
                    83
                ],
                [
                    239,
                    125,
                    87
                ],
                [
                    255,
                    205,
                    117
                ],
                [
                    167,
                    240,
                    112
                ],
                [
                    56,
                    183,
                    100
                ],
                [
                    37,
                    113,
                    121
                ],
                [
                    41,
                    54,
                    111
                ],
                [
                    59,
                    93,
                    201
                ],
                [
                    65,
                    166,
                    246
                ],
                [
                    115,
                    239,
                    247
                ],
                [
                    244,
                    244,
                    244
                ],
                [
                    148,
                    176,
                    194
                ],
                [
                    86,
                    108,
                    134
                ],
                [
                    51,
                    60,
                    87
                ]
            ]
        },
        gfxk: {
            label: "Grafxkid 32",
            palette: gfxkPalette
        },
        pico8: {
            label: "PICO-8",
            palette: [
                [
                    0,
                    0,
                    0
                ],
                [
                    29,
                    43,
                    83
                ],
                [
                    126,
                    37,
                    83
                ],
                [
                    0,
                    135,
                    81
                ],
                [
                    171,
                    82,
                    54
                ],
                [
                    95,
                    87,
                    79
                ],
                [
                    194,
                    195,
                    199
                ],
                [
                    255,
                    241,
                    232
                ],
                [
                    255,
                    0,
                    77
                ],
                [
                    255,
                    163,
                    0
                ],
                [
                    255,
                    236,
                    39
                ],
                [
                    0,
                    228,
                    54
                ],
                [
                    41,
                    173,
                    255
                ],
                [
                    131,
                    118,
                    156
                ],
                [
                    255,
                    119,
                    168
                ],
                [
                    255,
                    204,
                    170
                ]
            ]
        },
        dga: {
            label: "DGA-16",
            palette: [
                "#010101",
                "#031b75",
                "#108c00",
                "#17bbd3",
                "#720c0a",
                "#6c1c9e",
                "#b25116",
                "#b8b0a8",
                "#4a4842",
                "#0b63c4",
                "#9bce00",
                "#73f5d5",
                "#e89e00",
                "#ff7bdb",
                "#fef255",
                "#fffffe"
            ]
        },
        micro: {
            label: "BBC Micro",
            platform: true,
            palette: [
                [
                    0,
                    0,
                    0
                ],
                [
                    255,
                    0,
                    0
                ],
                [
                    0,
                    255,
                    0
                ],
                [
                    255,
                    255,
                    0
                ],
                [
                    0,
                    0,
                    255
                ],
                [
                    255,
                    0,
                    255
                ],
                [
                    0,
                    255,
                    255
                ],
                [
                    255,
                    255,
                    255
                ]
            ]
        },
        pepto: {
            label: "Pepto (C64)",
            platform: true,
            palette: [
                [
                    0,
                    0,
                    0
                ],
                [
                    255,
                    255,
                    255
                ],
                [
                    104,
                    55,
                    43
                ],
                [
                    112,
                    164,
                    178
                ],
                [
                    111,
                    61,
                    134
                ],
                [
                    88,
                    141,
                    67
                ],
                [
                    53,
                    40,
                    121
                ],
                [
                    184,
                    199,
                    111
                ],
                [
                    111,
                    79,
                    37
                ],
                [
                    67,
                    57,
                    0
                ],
                [
                    154,
                    103,
                    89
                ],
                [
                    68,
                    68,
                    68
                ],
                [
                    108,
                    108,
                    108
                ],
                [
                    154,
                    210,
                    132
                ],
                [
                    108,
                    94,
                    181
                ],
                [
                    149,
                    149,
                    149
                ]
            ]
        },
        spectrum: {
            label: "ZX Spectrum",
            platform: true,
            palette: [
                [
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    128
                ],
                [
                    0,
                    0,
                    255
                ],
                [
                    128,
                    0,
                    0
                ],
                [
                    255,
                    0,
                    0
                ],
                [
                    128,
                    0,
                    128
                ],
                [
                    255,
                    0,
                    255
                ],
                [
                    0,
                    128,
                    0
                ],
                [
                    0,
                    255,
                    0
                ],
                [
                    0,
                    128,
                    128
                ],
                [
                    0,
                    255,
                    255
                ],
                [
                    128,
                    128,
                    0
                ],
                [
                    255,
                    255,
                    0
                ],
                [
                    128,
                    128,
                    128
                ],
                [
                    255,
                    255,
                    255
                ]
            ]
        },
        msx: {
            label: "MSX",
            platform: true,
            palette: "MSX.json"
        },
        cga: {
            label: "CGA (IBM PC)",
            platform: true,
            palette: "CGA.json"
        },
        amstrad: {
            label: "Amstrad CPC",
            platform: true,
            palette: "Amstrad-CPC.json"
        },
        ted: {
            label: "C= TED/+4/16",
            platform: true,
            palette: "TED-Plus4-C16.json"
        },
        atari2600pal: {
            label: "Atari 2600 PAL",
            platform: true,
            palette: "Atari-2600-PAL.json"
        },
        atari2600ntsc: {
            label: "Atari 2600 NTSC",
            platform: true,
            palette: "Atari-2600-NTSC.json"
        },
        atari: {
            label: "Atari GTIA",
            platform: true,
            palette: "Atari-GTIA.json"
        }
    };
    var targetPalette = null;
    me.init = function(parent, paletteParent) {
        container = (0, $eJ26Q.$div)("palette", "", parent);
        let display = (0, $eJ26Q.$div)("display", "", container);
        let colorPicker = (0, $eJ26Q.$input)("color", "", display, ()=>{
            me.setColor(colorPicker.value, colorPicker.isBack, true);
        });
        let front = (0, $eJ26Q.$div)("front info", "", display, ()=>{
            colorPicker.value = (0, $bfgOg.default).toHex(me.getDrawColor());
            colorPicker.isBack = false;
            colorPicker.click();
        });
        front.info = "Left click drawing color - click to pick color";
        let back = (0, $eJ26Q.$div)("back info", "", display, ()=>{
            colorPicker.value = (0, $bfgOg.default).toHex(me.getBackgroundColor());
            colorPicker.isBack = true;
            colorPicker.click();
        });
        back.info = "Right click drawing color - click to pick color";
        let swapColors = (0, $eJ26Q.$div)("button swapcolors info", "", display, ()=>{
            (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).SWAPCOLORS);
        });
        swapColors.info = "<b>X</b> Swap foreground and background color";
        let noColor = (0, $eJ26Q.$div)("button transparentcolors info", "", display, (e)=>{
            me.setColor("transparent", e.button, true);
        });
        noColor.info = "Select transparent color, left click to select front, right click to select back";
        (0, $eJ26Q.default)(".togglepanel.showpalettelist", {
            parent: container,
            onClick: ()=>{
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).TOGGLEPALETTES);
            },
            info: "Show palettes"
        }, "Palette");
        (0, $eJ26Q.default)(".palettebuttons", {
            parent: paletteParent
        }, (0, $eJ26Q.default)(".edit", {
            onClick: ()=>{
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).EDITPALETTE);
            },
            info: "Edit palette"
        }, (0, $eJ26Q.default)(".icon")), cycleButton = (0, $eJ26Q.default)(".cycle", {
            onClick: ()=>{
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).CYCLEPALETTE);
            },
            info: "<b>tab</b> Toggle Color Cycle"
        }, (0, $eJ26Q.default)(".icon")), lockButton = (0, $eJ26Q.default)(".lock", {
            onClick: ()=>{
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).LOCKPALETTE);
            },
            info: "Lock Palette"
        }, (0, $eJ26Q.default)(".icon")));
        paletteCanvas = (0, $eJ26Q.default)("canvas.info.palettecanvas", {
            parent: paletteParent,
            info: "Color palette, left click to select front, right click to select back",
            infoOnMove: (e)=>{
                const rect = paletteCanvas.getBoundingClientRect();
                const x = Math.floor(e.clientX - rect.left);
                const y = Math.floor(e.clientY - rect.top);
                let p = paletteCtx.getImageData(x, y, 1, 1).data;
                let color = "r: " + p[0] + " g: " + p[1] + " b: " + p[2] + " ";
                return color;
            },
            onClick: function(e) {
                const rect = paletteCanvas.getBoundingClientRect();
                const x = Math.floor(e.clientX - rect.left);
                const y = Math.floor(e.clientY - rect.top);
                let p = paletteCtx.getImageData(x, y, 1, 1).data;
                let index = Math.floor(x / size) + Math.floor(y / size) * 4 + palettePageIndex * 4 * Math.floor(currentHeight / size);
                if (e.button) backColorIndex = index;
                else drawColorIndex = index;
                me.setColor([
                    p[0],
                    p[1],
                    p[2]
                ], e.button, false);
            }
        });
        paletteNav = (0, $eJ26Q.$div)("palettenav", "", paletteParent);
        paletteCtx = paletteCanvas.getContext("2d");
        me.set(colors);
        (0, $9dDG4.default).on((0, $k5ZAj.EVENT).drawColorChanged, (color)=>{
            color = (0, $bfgOg.default).fromString(color);
            if (color.length > 3 && color[3] === 0) color = "transparent";
            if (color === "transparent") {
                front.style.backgroundColor = color;
                front.classList.add("nofill");
            } else {
                front.style.backgroundColor = "rgb(" + color[0] + "," + color[1] + "," + color[2] + ")";
                front.classList.remove("nofill");
            }
        });
        (0, $9dDG4.default).on((0, $k5ZAj.EVENT).backgroundColorChanged, (color)=>{
            color = (0, $bfgOg.default).fromString(color);
            if (color.length > 3 && color[3] === 0) color = "transparent";
            if (color === "transparent") {
                back.style.backgroundColor = color;
                back.classList.add("nofill");
            } else {
                back.style.backgroundColor = "rgb(" + color[0] + "," + color[1] + "," + color[2] + ")";
                back.classList.remove("nofill");
            }
        });
        me.setColor(colors[1], false, true);
        me.setColor(colors[2], true, true);
    };
    me.setColor = function(color, back, matchIndex) {
        if (back) {
            backgroundColor = (0, $bfgOg.default).toString(color);
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).backgroundColorChanged, color);
            if (matchIndex) backColorIndex = me.getColorIndex(color, false);
        } else {
            drawColor = (0, $bfgOg.default).toString(color);
            if (matchIndex) drawColorIndex = me.getColorIndex(color, false);
            drawPalette();
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).drawColorChanged, color);
        }
    };
    me.getDrawColor = function() {
        return drawColor;
    };
    me.getBackgroundColor = function() {
        return backgroundColor;
    };
    me.next = function() {
        me.setColorIndex(drawColorIndex + 1);
    };
    me.prev = function() {
        me.setColorIndex(drawColorIndex - 1);
    };
    me.setColorIndex = function(index) {
        if (currentPalette) {
            drawColorIndex = index;
            let rangeIndex = (0, $ex1EM.default).getActiveRange();
            if (rangeIndex !== undefined) {
                let range = (0, $jU8Uk.default).getCurrentFile().colorRange[rangeIndex];
                if (range) {
                    if (drawColorIndex < range.low) drawColorIndex = range.high;
                    if (drawColorIndex > range.high) drawColorIndex = range.low;
                }
            }
            if (drawColorIndex < 0) drawColorIndex = currentPalette.length - 1;
            if (drawColorIndex >= currentPalette.length) drawColorIndex = 0;
            me.setColor(currentPalette[drawColorIndex], false, false);
        }
    };
    me.getDrawColorIndex = function() {
        return drawColorIndex;
    };
    me.getBackColorIndex = function() {
        return backColorIndex;
    };
    me.isLocked = function() {
        return isLocked;
    };
    me.set = function(palette) {
        let cols = 4;
        let rows = Math.ceil(palette.length / cols);
        paletteCanvas.width = cols * size;
        paletteCanvas.height = rows * size;
        palettePageIndex = 0;
        palettePageCount = 1;
        paletteNav.innerHTML = "";
        let pageNumber, pageNext, pagePrev;
        let box = paletteCanvas.getBoundingClientRect();
        let parentBox = paletteCanvas.parentElement.getBoundingClientRect();
        let availableHeight = parentBox.height + parentBox.top - box.top - 2;
        currentHeight = availableHeight;
        if (availableHeight < paletteCanvas.height) {
            let rows = Math.floor((availableHeight - 22) / size);
            paletteCanvas.height = rows * size;
            palettePageCount = Math.ceil(palette.length / (cols * rows));
            paletteNav.appendChild((0, $eJ26Q.default)(".nav", pagePrev = (0, $eJ26Q.default)(".prev", {
                onClick: ()=>{
                    setPage(-1);
                }
            }), pageNumber = (0, $eJ26Q.default)(".page", "1"), pageNext = (0, $eJ26Q.default)(".next.active", {
                onClick: ()=>{
                    setPage(1);
                }
            })));
        }
        currentPalette = palette;
        scanDuplicates();
        drawPalette();
        function setPage(index) {
            palettePageIndex += index;
            if (palettePageIndex < 0) palettePageIndex = 0;
            if (palettePageIndex >= palettePageCount) palettePageIndex = palettePageCount - 1;
            pageNumber.innerHTML = palettePageIndex + 1;
            pagePrev.classList.toggle("active", palettePageIndex > 0);
            pageNext.classList.toggle("active", palettePageIndex < palettePageCount - 1);
            drawPalette();
        }
    };
    function drawPalette() {
        let cols = 4;
        let rows = Math.floor(paletteCanvas.height / size);
        let start = palettePageIndex * cols * rows;
        let end = start + cols * rows;
        if (end > currentPalette.length) end = currentPalette.length;
        paletteCtx.clearRect(0, 0, paletteCanvas.width, paletteCanvas.height);
        for(let i = start; i < end; i++){
            let color = currentPalette[i];
            if (typeof color === "string") {
                color = (0, $bfgOg.default).fromString(color);
                currentPalette[i] = color;
            }
            let x = (i - start) % cols * size;
            let y = Math.floor((i - start) / cols) * size;
            paletteCtx.fillStyle = "rgb(" + color[0] + "," + color[1] + "," + color[2] + ")";
            paletteCtx.fillRect(x, y, size, size);
            if (i === drawColorIndex) {
                paletteCtx.fillStyle = "black";
                paletteCtx.fillRect(x + 2, y + 2, 4, 4);
                paletteCtx.fillStyle = "white";
                paletteCtx.fillRect(x + 3, y + 3, 2, 2);
                drawColorIndex = i;
            }
        }
    }
    me.get = function() {
        return currentPalette;
    };
    me.fromImage = function() {
        var colors = (0, $lPw7G.default).getColors((0, $jU8Uk.default).getCanvas());
        var palette = [];
        var max = Math.min(colors.length, 256);
        for(var i = 0; i < max; i++){
            var c = colors[i];
            palette.push(c);
        }
        $ad846eee7cfb94e2$var$Palette.set(palette);
    };
    me.reduce = function() {
        if (targetColorCount > 256 && !targetPalette) (0, $jU8Uk.default).restoreOriginal();
        else {
            let base = (0, $jU8Uk.default).getOriginal();
            let c = (0, $9xub8.duplicateCanvas)(base, true);
            if (targetColorCount === 2 && ditherIndex) {
                (0, $lPw7G.default).bayer(c.getContext("2d"), Math.floor(alphaThreshold * 2.56), false);
                let layer = (0, $jU8Uk.default).getActiveLayer();
                layer.clear();
                layer.drawImage(c, 0, 0);
                (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layerContentChanged, {
                    keepImageCache: true
                });
            } else (0, $lPw7G.default).reduce(c, targetPalette || targetColorCount, alphaThreshold, ditherIndex);
            (0, $8ztM6.default).show("reduce");
        }
    };
    me.apply = function() {
        let base = (0, $jU8Uk.default).getOriginal();
        let c = (0, $9xub8.duplicateCanvas)(base, true);
        (0, $lPw7G.default).reduce(c, currentPalette, alphaThreshold, 0);
    };
    me.getColorIndex = function(color, forceMatch) {
        var index = currentPalette.findIndex((c)=>{
            return c[0] === color[0] && c[1] === color[1] && c[2] === color[2];
        });
        if (index < 0 && forceMatch) index = 0;
        return index;
    };
    me.getColor = (index)=>currentPalette[index];
    me.matchColor = function(color) {
        // find the closest color in the palette
        var index = currentPalette.findIndex((c)=>{
            return c[0] === color[0] && c[1] === color[1] && c[2] === color[2];
        });
        if (index < 0) {
            var min = 100000;
            var match = 0;
            for(var i = 0; i < currentPalette.length; i++){
                var c = currentPalette[i];
                // simple distance
                //let dist = Color.distance(c,color);
                // LAB distance - should be fast enough
                let dist = (0, $bfgOg.default).distanceLAB(c, color);
                if (dist < min) {
                    min = dist;
                    match = i;
                }
            }
            index = match;
        }
        return currentPalette[index];
    };
    me.updateColor = function(index, color) {
        currentPalette[index] = color;
        me.set(currentPalette);
    };
    me.swapColors = function(index1, index2) {
        let c = currentPalette[index1];
        currentPalette[index1] = currentPalette[index2];
        currentPalette[index2] = c;
        me.set(currentPalette);
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).paletteChanged);
    };
    me.spreadColors = function(index1, index2) {
        if (index1 === index2) return;
        if (index1 > index2) {
            let t = index1;
            index1 = index2;
            index2 = t;
        }
        if (index2 - index1 === 1) return;
        let steps = index2 - index1 - 1;
        let c1 = currentPalette[index1];
        let c2 = currentPalette[index2];
        let delta = [
            c2[0] - c1[0],
            c2[1] - c1[1],
            c2[2] - c1[2]
        ];
        for(let i = 1; i <= steps; i++){
            let color = [
                c1[0] + Math.floor(delta[0] * i / (steps + 1)),
                c1[1] + Math.floor(delta[1] * i / (steps + 1)),
                c1[2] + Math.floor(delta[2] * i / (steps + 1))
            ];
            currentPalette[index1 + i] = color;
        }
        me.set(currentPalette);
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).paletteChanged);
    };
    me.removeColor = function(index) {
        currentPalette.splice(index, 1);
        me.set(currentPalette);
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).paletteChanged);
    };
    me.addColor = function(color) {
        currentPalette.push(color);
        me.set(currentPalette);
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).paletteChanged);
    };
    me.sortByHue = function() {
        currentPalette.sort((a, b)=>{
            let h1 = (0, $bfgOg.default).hue(a);
            let h2 = (0, $bfgOg.default).hue(b);
            if (h1 < h2) return 1;
            if (h1 > h2) return -1;
            let l1 = (0, $bfgOg.default).lightness(a);
            let l2 = (0, $bfgOg.default).lightness(b);
            return l1 < l2 ? 1 : l1 > l2 ? -1 : 0;
        });
        me.set(currentPalette);
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).paletteChanged);
    };
    me.sortByLightness = function() {
        currentPalette.sort((a, b)=>{
            let l1 = (0, $bfgOg.default).lightness(a);
            let l2 = (0, $bfgOg.default).lightness(b);
            return l1 < l2 ? 1 : l1 > l2 ? -1 : 0;
        });
        me.set(currentPalette);
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).paletteChanged);
    };
    me.sortBySaturation = function() {
        currentPalette.sort((a, b)=>{
            let s1 = (0, $bfgOg.default).saturation(a);
            let s2 = (0, $bfgOg.default).saturation(b);
            return s1 < s2 ? 1 : s1 > s2 ? -1 : 0;
        });
        me.set(currentPalette);
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).paletteChanged);
    };
    me.sortByUseCount = function(andTest) {
        (0, $jU8Uk.default).generateIndexedPixels();
        let image = (0, $jU8Uk.default).getCurrentFile();
        let pixels = image.indexedPixels || [];
        let counts = {};
        pixels.forEach((line)=>{
            line.forEach((pixel)=>{
                counts[pixel] = counts[pixel] || 0;
                counts[pixel]++;
            });
        });
        let sorted = Object.keys(counts).sort((a, b)=>counts[b] - counts[a]);
        let palette = [];
        sorted.forEach((pixel)=>{
            palette.push(currentPalette[pixel]);
        });
        me.set(palette);
    };
    me.reverse = function() {
        currentPalette.reverse();
        me.set(currentPalette);
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).paletteChanged);
    };
    me.generateControlPanel = function(parent) {
        let palettePanel = (0, $eJ26Q.$div)("subpanel", "", parent);
        (0, $eJ26Q.$div)("label", "Palette", palettePanel);
        let pselect = document.createElement("select");
        Object.keys(paletteMap).forEach((key, index)=>{
            let option = document.createElement("option");
            option.value = key;
            option.innerHTML = paletteMap[key].label;
            pselect.appendChild(option);
        });
        pselect.onchange = function() {
            targetPalette = paletteMap[pselect.value].palette;
            if (pselect.value === "current") targetPalette = currentPalette;
            if (typeof targetPalette === "string") me.loadPreset(paletteMap[pselect.value]).then((palette)=>{
                paletteMap[pselect.value].palette = palette;
                targetPalette = palette;
                me.reduce();
            });
            else me.reduce();
        };
        palettePanel.appendChild(pselect);
        let fixed = (0, $eJ26Q.$div)("subpanel", "", parent);
        (0, $eJ26Q.$div)("label", "Optimize colors", fixed);
        let value = (0, $eJ26Q.$div)("value", "32", fixed);
        let range = document.createElement("input");
        range.type = "range";
        range.value = 5;
        range.min = 1;
        range.max = 9;
        range.oninput = function() {
            targetColorCount = Math.pow(2, range.value);
            value.innerHTML = range.value < 9 ? targetColorCount : "Full";
        };
        range.onchange = function() {
            targetColorCount = Math.pow(2, range.value);
            pselect.value = "optimized";
            targetPalette = null;
            me.reduce();
        };
        fixed.appendChild(range);
        let dithering = (0, $eJ26Q.$div)("subpanel", "", parent);
        (0, $eJ26Q.$div)("label", "Dithering", dithering);
        let select = document.createElement("select");
        select.value = 0;
        let options = (0, $lPw7G.default).getDithering();
        options.forEach((o, index)=>{
            let option = document.createElement("option");
            option.value = index;
            option.innerHTML = o.label;
            select.appendChild(option);
        });
        select.onchange = function() {
            ditherIndex = select.value;
            me.reduce();
        };
        (0, $eJ26Q.$div)("button square prev", "<", dithering, ()=>{
            let v = parseInt(select.value) - 1;
            if (v < 0) v = options.length - 1;
            select.value = v;
            select.onchange();
        });
        (0, $eJ26Q.$div)("button square next", ">", dithering, ()=>{
            let v = parseInt(select.value) + 1;
            if (v >= options.length) v = 0;
            select.value = v;
            select.onchange();
        });
        dithering.appendChild(select);
        let alpha = (0, $eJ26Q.$div)("subpanel", "", parent);
        (0, $eJ26Q.$div)("label", "Alpha Threshold", alpha);
        let avalue = (0, $eJ26Q.$div)("value", alphaThreshold + "%", alpha);
        let arange = document.createElement("input");
        arange.type = "range";
        arange.value = alphaThreshold;
        arange.min = 0;
        arange.max = 100;
        arange.oninput = function() {
            avalue.innerHTML = arange.value + "%";
        };
        arange.onchange = function() {
            alphaThreshold = arange.value;
            me.reduce();
        };
        alpha.appendChild(arange);
    };
    me.openLocal = function() {
        var input = document.createElement("input");
        input.type = "file";
        input.onchange = function(e) {
            let files = e.target.files;
            if (files.length) {
                var file = files[0];
                var ext = file.name.split(".").pop().toLowerCase();
                if (ext === "json") {
                    var reader = new FileReader();
                    reader.onload = function() {
                        let data = {};
                        try {
                            data = JSON.parse(reader.result);
                        } catch (error) {
                            console.error("Error parsing Palette");
                        }
                        if (data && data.type === "palette" && data.palette) {
                            me.set(data.palette);
                            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).paletteChanged);
                        }
                    };
                    reader.readAsText(file);
                }
            }
        };
        input.click();
    };
    me.getPaletteMap = function() {
        return paletteMap;
    };
    me.hasDuplicates = function() {
        return hasDuplicates;
    };
    me.loadPreset = function(preset) {
        return new Promise((resolve)=>{
            if (preset && preset.palette) {
                if (typeof preset.palette === "object") {
                    resolve(preset.palette);
                    return;
                }
                if (typeof preset.palette === "string") {
                    console.log("loading palette", preset.palette);
                    fetch("_data/palettes/" + preset.palette).then((r)=>r.json()).then((data)=>{
                        if (data && data.palette) {
                            preset.palette = data.palette;
                            resolve(data.palette);
                        } else {
                            console.error("Error loading palette", preset.palette);
                            resolve([]);
                        }
                    });
                    return;
                }
            }
            resolve([]);
        });
    };
    me.cycle = function() {
        let image = (0, $jU8Uk.default).getCurrentFile();
        if (image && image.colorRange && image.colorRange.length) {
            // check for active color ranges
            let active = image.colorRange.find((range)=>range.active);
            if (!active) {
                (0, $8FLxR.default).softAlert("There are no active color ranges.", "Can't Start Color Cycle");
                return;
            }
            let imageData = (0, $jU8Uk.default).getContext().getImageData(0, 0, image.width, image.height);
            let data = imageData.data;
            let hasLayers = (0, $jU8Uk.default).getActiveFrame().layers && (0, $jU8Uk.default).getActiveFrame().layers.length > 1;
            // probably a good idea to move the color cycling to a separate layer anyway
            hasLayers = true;
            if ((0, $bqUff.default).isRunning()) {
                (0, $bqUff.default).stop();
                if (hasLayers) {
                    let cycleLayer = (0, $jU8Uk.default).getActiveFrame().layers.findIndex((l)=>l.name === "Colour Cycling" && l.locked);
                    if (cycleLayer >= 0) (0, $jU8Uk.default).removeLayer(cycleLayer);
                }
                image.colorRange.forEach((range, index)=>{
                    if (range.active) {
                        range.index = 0;
                        updateRangeColors(range, data);
                        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).colorCycleChanged, index);
                        if (!hasLayers) (0, $jU8Uk.default).getContext().putImageData(imageData, 0, 0);
                        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).imageContentChanged);
                    }
                });
                drawPalette();
            } else {
                if (hasLayers) // add temporary layer to combine all layers and use for color cycling
                (0, $jU8Uk.default).addLayer(undefined, "Colour Cycling", {
                    locked: true,
                    internal: true
                });
                let renderContext = (0, $jU8Uk.default).getLayer((0, $jU8Uk.default).getActiveFrame().layers.length - 1).getContext();
                generateColorLayers();
                image.colorRange.forEach((range, index)=>{
                    let fps = Math.abs(range.fps || 10);
                    if (range.active) (0, $bqUff.default).start(()=>{
                        if (range.reverse) {
                            range.index--;
                            if (range.index < 0) range.index = range.max - 1;
                        } else {
                            range.index++;
                            if (range.index >= range.max) range.index = 0;
                        }
                        updateRangeColors(range, data);
                        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).colorCycleChanged, index);
                        renderContext.putImageData(imageData, 0, 0);
                        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).imageContentChanged);
                    }, fps);
                });
            }
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).colorCycleToggled);
        } else (0, $8FLxR.default).softAlert("There are no color ranges defined.", "Can't Start Color Cycle");
    };
    function generateColorLayers() {
        colorLayers = {};
        let image = (0, $jU8Uk.default).getCurrentFile();
        let regeneratePixels = true;
        if (regeneratePixels) (0, $jU8Uk.default).generateIndexedPixels();
        let pixels = image.indexedPixels || [];
        image.colorRange.forEach((range)=>{
            range.index = 0;
            range.max = range.high - range.low + 1;
        });
        function isInRange(pixel) {
            let inRange = false;
            image.colorRange.forEach((range)=>{
                if (range.active && pixel >= range.low && pixel <= range.high) inRange = true;
            });
            return inRange;
        }
        // put every active pixel in a color layer
        pixels.forEach((line, y)=>{
            line.forEach((pixel, x)=>{
                if (isInRange(pixel)) {
                    colorLayers[pixel] = colorLayers[pixel] || [];
                    colorLayers[pixel].push(y * image.width + x);
                }
            });
        });
    }
    function updateRangeColors(range, data) {
        for(let i = range.low; i <= range.high; i++){
            let colorIndex = i - range.index;
            if (colorIndex < range.low) colorIndex += range.max;
            let color = currentPalette[colorIndex];
            let pixels = colorLayers[i] || [];
            pixels.forEach((index)=>{
                let offset = index * 4;
                data[offset] = color[0];
                data[offset + 1] = color[1];
                data[offset + 2] = color[2];
                data[offset + 3] = 255;
            });
        }
    }
    function scanDuplicates() {
        hasDuplicates = false;
        for(let i = 0; i < currentPalette.length; i++){
            let color = currentPalette[i];
            let match = currentPalette.findIndex((c, index)=>{
                return index !== i && c[0] === color[0] && c[1] === color[1] && c[2] === color[2];
            });
            if (match >= 0) {
                hasDuplicates = true;
                break;
            }
        }
        if (hasDuplicates) console.warn("Palette has duplicates");
    }
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).PALETTEFROMIMAGE, me.fromImage);
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).PALETTEREDUCE, me.reduce);
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).SWAPCOLORS, ()=>{
        let c = drawColor;
        me.setColor(backgroundColor, false, false);
        me.setColor(c, true, false);
        c = drawColorIndex;
        drawColorIndex = backColorIndex;
        backColorIndex = c;
    });
    (0, $9dDG4.default).on((0, $k5ZAj.EVENT).UIresize, ()=>{
        let box = paletteCanvas.getBoundingClientRect();
        let parentBox = paletteCanvas.parentElement.getBoundingClientRect();
        let availableHeight = parentBox.height + parentBox.top - box.top - 2;
        if (availableHeight !== currentHeight) me.set(currentPalette);
    });
    (0, $9dDG4.default).on((0, $k5ZAj.EVENT).colorCycleChanged, (index)=>{
        let image = (0, $jU8Uk.default).getCurrentFile();
        let range = image.colorRange[index];
        for(let i = range.low; i <= range.high; i++){
            let index = i - (range.index || 0);
            if (index < range.low) index += range.max;
            let color = $ad846eee7cfb94e2$var$Palette.get()[index];
            let cols = 4;
            let rows = Math.floor(paletteCanvas.height / size);
            let start = palettePageIndex * cols * rows;
            if (i >= start && i < start + cols * rows) {
                let x = (i - start) % cols * size;
                let y = Math.floor((i - start) / cols) * size;
                paletteCtx.fillStyle = (0, $bfgOg.default).toString(color);
                paletteCtx.fillRect(x, y, size, size);
            }
        }
    });
    (0, $9dDG4.default).on((0, $k5ZAj.EVENT).colorCycleToggled, ()=>{
        if (cycleButton) cycleButton.classList.toggle("active", (0, $bqUff.default).isRunning());
    });
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).LOCKPALETTE, ()=>{
        isLocked = !isLocked;
        lockButton.classList.toggle("active", isLocked);
    });
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).CYCLEPALETTE, me.cycle);
    (0, $9dDG4.default).on((0, $k5ZAj.EVENT).layerContentChanged, (options)=>{
        options = options || {};
        if ((0, $bqUff.default).isRunning() && options.commit) {
            // toggle cycle to regenerate the color cycle layer after draw
            me.cycle();
            me.cycle();
        }
    });
    return me;
}();
var $ad846eee7cfb94e2$export$2e2bcd8739ae039 = $ad846eee7cfb94e2$var$Palette;

});
parcelRegister("bfgOg", function(module, exports) {

$parcel$export(module.exports, "default", () => $82fe22818d9c7c3d$export$2e2bcd8739ae039);
var $82fe22818d9c7c3d$var$Color = function() {
    var me = {};
    me.toString = function(color) {
        // Uint8ClampedArray returns false on isArray;
        if (typeof color === "object" && color.length) return "rgb(" + color[0] + "," + color[1] + "," + color[2] + ")";
        return color;
    };
    me.fromString = function(color) {
        if (typeof color === "object") return color;
        if (color.indexOf("rgb") === 0) {
            let parts = color.split("(")[1].split(")")[0].split(",");
            if (parts.length === 4) return [
                parseInt(parts[0]),
                parseInt(parts[1]),
                parseInt(parts[2]),
                parseInt(parts[3])
            ];
            return [
                parseInt(parts[0]),
                parseInt(parts[1]),
                parseInt(parts[2])
            ];
        }
        if (color.indexOf("#") === 0) {
            let r = parseInt(color.substr(1, 2), 16);
            let g = parseInt(color.substr(3, 2), 16);
            let b = parseInt(color.substr(5, 2), 16);
            if (color.length === 9) return [
                r,
                g,
                b,
                parseInt(color.substr(7, 2), 16)
            ];
            return [
                r,
                g,
                b
            ];
        }
        return color;
    };
    me.toHex = function(color) {
        if (typeof color === "string") color = me.fromString(color);
        if (typeof color === "object" && color.length) {
            let result = "#" + hexByte(color[0]) + hexByte(color[1]) + hexByte(color[2]);
            if (color.length === 4) result += hexByte(color[3]);
            return result;
        }
    };
    me.toHSV = function(color, maxRange) {
        if (typeof color === "string") color = me.fromString(color);
        if (typeof color === "object" && color.length) {
            let r = color[0] / 255;
            let g = color[1] / 255;
            let b = color[2] / 255;
            let max = Math.max(r, g, b);
            let min = Math.min(r, g, b);
            let h, s, v = max;
            let d = max - min;
            s = max === 0 ? 0 : d / max;
            if (max === min) h = 0; // shade of gray
            else {
                switch(max){
                    case r:
                        h = (g - b) / d + (g < b ? 6 : 0);
                        break;
                    case g:
                        h = (b - r) / d + 2;
                        break;
                    case b:
                        h = (r - g) / d + 4;
                        break;
                }
                h /= 6;
            }
            if (maxRange) {
                h = Math.round(h * 360);
                s = Math.round(s * 100);
                v = Math.round(v * 100);
            }
            return [
                h,
                s,
                v
            ];
        }
    };
    me.fromHSV = function(h, s, v) {
        let r, g, b;
        let i = Math.floor(h * 6);
        let f = h * 6 - i;
        let p = v * (1 - s);
        let q = v * (1 - f * s);
        let t = v * (1 - (1 - f) * s);
        switch(i % 6){
            case 0:
                r = v;
                g = t;
                b = p;
                break;
            case 1:
                r = q;
                g = v;
                b = p;
                break;
            case 2:
                r = p;
                g = v;
                b = t;
                break;
            case 3:
                r = p;
                g = q;
                b = v;
                break;
            case 4:
                r = t;
                g = p;
                b = v;
                break;
            case 5:
                r = v;
                g = p;
                b = q;
                break;
        }
        return [
            Math.round(r * 255),
            Math.round(g * 255),
            Math.round(b * 255)
        ];
    };
    me.toLAB = function(color) {
        if (typeof color === "string") color = me.fromString(color);
        if (typeof color === "object" && color.length) {
            let r = color[0] / 255;
            let g = color[1] / 255;
            let b = color[2] / 255;
            let x, y, z;
            r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
            g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
            b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
            x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
            y = r * 0.2126 + g * 0.7152 + b * 0.0722;
            z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
            x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
            y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
            z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
            return [
                116 * y - 16,
                500 * (x - y),
                200 * (y - z)
            ];
        }
    };
    me.distance = function(color1, color2) {
        // note: this is rather simplistic, but it's fast to calculate
        // for better results, use a color space like LAB or HSV
        color1 = me.fromString(color1);
        color2 = me.fromString(color2);
        let r = color1[0] - color2[0];
        let g = color1[1] - color2[1];
        let b = color1[2] - color2[2];
        if (color1.length === 4 && color2.length === 4) {
            let a = color1[3] - color2[3];
            return Math.sqrt(r * r + g * g + b * b + a * a);
        }
        return Math.sqrt(r * r + g * g + b * b);
    };
    me.distanceHSV = function(color1, color2) {
        let c1 = me.toHSV(color1);
        let c2 = me.toHSV(color2);
        let h = c1[0] - c2[0];
        let s = c1[1] - c2[1];
        let v = c1[2] - c2[2];
        return Math.sqrt(h * h + s * s + v * v);
    };
    me.distanceLAB = function(color1, color2) {
        let c1 = me.toLAB(color1);
        let c2 = me.toLAB(color2);
        let l = c1[0] - c2[0];
        let a = c1[1] - c2[1];
        let b = c1[2] - c2[2];
        return Math.sqrt(l * l + a * a + b * b);
    };
    me.hue = function(color) {
        let c = me.toHSV(color);
        return c[0];
    };
    me.lightness = function(color) {
        let c = me.toHSV(color);
        return c[2];
    };
    me.saturation = function(color) {
        let c = me.toHSV(color);
        return c[1];
    };
    me.blend = (color1, color2, amount)=>{
        let remaining = 1 - amount;
        let c1 = me.fromString(color1);
        let c2 = me.fromString(color2);
        let r = Math.round(c1[0] * remaining + c2[0] * amount);
        let g = Math.round(c1[1] * remaining + c2[1] * amount);
        let b = Math.round(c1[2] * remaining + c2[2] * amount);
        return [
            r,
            g,
            b
        ];
    };
    me.equals = (color1, color2)=>{
        color1 = me.fromString(color1);
        color2 = me.fromString(color2);
        return color1[0] === color2[0] && color1[1] === color2[1] && color1[2] === color2[2];
    };
    function hexByte(nr) {
        if (typeof nr === "string") nr = parseInt(nr);
        let result = nr.toString(16);
        if (result.length === 1) result = "0" + result;
        return result;
    }
    return me;
}();
var $82fe22818d9c7c3d$export$2e2bcd8739ae039 = $82fe22818d9c7c3d$var$Color;

});

parcelRegister("8ztM6", function(module, exports) {

$parcel$export(module.exports, "default", () => $63d8b04d6909e951$export$2e2bcd8739ae039);

var $k5ZAj = parcelRequire("k5ZAj");

var $eJ26Q = parcelRequire("eJ26Q");

var $lPw7G = parcelRequire("lPw7G");

var $jU8Uk = parcelRequire("jU8Uk");

var $9dDG4 = parcelRequire("9dDG4");

var $eTCYn = parcelRequire("eTCYn");

var $c5gcp = parcelRequire("c5gcp");

var $cZrAj = parcelRequire("cZrAj");

var $j2Icj = parcelRequire("j2Icj");

var $lTixE = parcelRequire("lTixE");

var $clDPp = parcelRequire("clDPp");
var $63d8b04d6909e951$var$SidePanel = function() {
    let me = {};
    let container;
    let collapsedHeight = 21;
    let panels = {
        info: {
            label: "Info",
            height: 84
        },
        frames: {
            label: "Frames",
            height: 100,
            content: (parent)=>{
                (0, $cZrAj.default).generate(parent);
            }
        },
        layers: {
            label: "Layers",
            height: 180,
            content: (parent)=>{
                (0, $c5gcp.default).generate(parent);
            }
        },
        brush: {
            label: "Brush",
            height: 118,
            content: (parent)=>{
                (0, $j2Icj.default).generate(parent);
            }
        },
        color: {
            label: "Color",
            height: 142,
            content: (parent)=>{
                (0, $lTixE.default).generate(parent);
            }
        },
        grid: {
            label: "Grid",
            height: 120,
            content: (parent)=>{
                (0, $clDPp.default).generate(parent);
            }
        },
        reduce: {
            label: "Reduce Colors",
            collapsed: true,
            height: 230,
            content: (parent)=>{
                (0, $eTCYn.default).generateControlPanel(parent);
            }
        }
    };
    me.init = (parent)=>{
        container = (0, $eJ26Q.$div)("sidepanel");
        parent.appendChild(container);
        generate();
    };
    me.show = (section)=>{
        document.body.classList.add("withsidepanel");
        if (section) {
            Object.keys(panels).forEach((key)=>{
                if (key === section) panels[key].collapsed = false;
            });
            setPanelsState();
        }
    };
    me.hide = ()=>{
        document.body.classList.remove("withsidepanel");
    };
    me.toggle = ()=>{
        document.body.classList.toggle("withsidepanel");
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).UIresize);
    };
    me.isVisible = ()=>{
        return document.body.classList.contains("withsidepanel");
    };
    me.showInfo = (file)=>{
        let contentPanel = panels.info.container.querySelector(".inner");
        if (contentPanel) {
            if (file && file.width) {
                contentPanel.innerHTML = "";
                generateInfoLine("Width", file.width + "px", contentPanel);
                generateInfoLine("Height", file.height + "px", contentPanel);
                generateInfoLine("Colors", (0, $lPw7G.default).getColors((0, $jU8Uk.default).getCanvas()).length, contentPanel);
            } else contentPanel.innerHTML = "<small>No file present</small>";
        }
        (0, $cZrAj.default).list();
        me.show();
    };
    function generate() {
        let y = 0;
        Object.keys(panels).forEach((key)=>{
            let panel = panels[key];
            let height = panel.height || 100;
            panel.container = generatePanel(panel, container);
            panel.container.style.height = height + "px";
            panel.container.style.top = y + "px";
            y += panel.collapsed ? collapsedHeight : height;
        });
    }
    function generatePanel(panelInfo, parent) {
        let panel = (0, $eJ26Q.$div)("panel " + panelInfo.label.toLowerCase() + (panelInfo.collapsed ? " collapsed" : ""), "", parent);
        let caption = (0, $eJ26Q.$div)("caption", "<i></i> " + panelInfo.label, panel, ()=>{
            panelInfo.collapsed = !panelInfo.collapsed;
            setPanelsState();
        });
        let close = (0, $eJ26Q.$div)("close info", "x", caption, ()=>(0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).TOGGLESIDEPANEL));
        close.info = "Close side panels";
        let inner = (0, $eJ26Q.$div)("inner", "", panel);
        if (panelInfo.content) panelInfo.content(inner);
        return panel;
    }
    function setPanelsState() {
        let y = 0;
        Object.keys(panels).forEach((key)=>{
            let panel = panels[key];
            let height = panel.height || 100;
            if (panel.collapsed) height = collapsedHeight;
            panel.container.style.height = height + "px";
            panel.container.style.top = y + "px";
            panel.container.classList.toggle("collapsed", !!panel.collapsed);
            y += height;
        });
    }
    function generateInfoLine(label, value, parent) {
        let line = document.createElement("dl");
        let dt = document.createElement("dt");
        dt.innerHTML = label;
        let dd = document.createElement("dd");
        dd.innerHTML = value;
        line.appendChild(dt);
        line.appendChild(dd);
        parent.appendChild(line);
    }
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).TOGGLESIDEPANEL, me.toggle);
    return me;
}();
var $63d8b04d6909e951$export$2e2bcd8739ae039 = $63d8b04d6909e951$var$SidePanel;

});
parcelRegister("c5gcp", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cc28480d7649b3e$export$2e2bcd8739ae039);

var $jU8Uk = parcelRequire("jU8Uk");

var $eJ26Q = parcelRequire("eJ26Q");

var $9dDG4 = parcelRequire("9dDG4");

var $k5ZAj = parcelRequire("k5ZAj");

var $lkhKc = parcelRequire("lkhKc");

var $b6UY4 = parcelRequire("b6UY4");

var $eZZbx = parcelRequire("eZZbx");
let $8cc28480d7649b3e$var$LayerPanel = function() {
    let me = {};
    let contentPanel;
    let opacityRange;
    let blendSelect;
    let editIndex;
    let blendModes = [
        "normal",
        "lighter",
        "multiply",
        "screen",
        "overlay",
        "darken",
        "lighten",
        "color-dodge",
        "color-burn",
        "hard-light",
        "soft-light",
        "hue",
        "saturation",
        "color",
        "luminosity"
    ];
    me.generate = (parent)=>{
        (0, $eJ26Q.default)(".paneltools.multirow", {
            parent: parent
        }, (0, $eJ26Q.default)(".rangeselect", {
            info: "Set transparency of active layer"
        }, (0, $eJ26Q.default)(".label", "Opacity"), opacityRange = (0, $eJ26Q.default)("input", {
            type: "range",
            max: 100,
            min: 0,
            value: 100,
            oninput: ()=>{
                (0, $jU8Uk.default).setLayerOpacity(opacityRange.value);
            }
        })), (0, $eJ26Q.default)(".blendselect", (0, $eJ26Q.default)(".label", "Blend"), blendSelect = (0, $eJ26Q.default)("select", {
            oninput: ()=>{
                (0, $jU8Uk.default).setLayerBlendMode(blendSelect.value);
            }
        })), (0, $eJ26Q.default)(".button.delete", {
            onclick: ()=>{
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).DELETELAYER);
            },
            info: "Delete active layer"
        }), (0, $eJ26Q.default)(".button.add", {
            onclick: ()=>{
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).NEWLAYER);
            },
            info: "Add new layer"
        }));
        contentPanel = (0, $eJ26Q.default)(".panelcontent", {
            parent: parent
        });
        blendModes.forEach((mode)=>{
            (0, $eJ26Q.$elm)("option", mode, blendSelect);
        });
    };
    me.list = ()=>{
        contentPanel.innerHTML = "";
        let activeIndex = (0, $jU8Uk.default).getActiveLayerIndex() || 0;
        let imageFile = (0, $jU8Uk.default).getCurrentFile();
        let frame = imageFile.frames[(0, $jU8Uk.default).getActiveFrameIndex()];
        let max = frame.layers.length - 1;
        let systemLayers = 0;
        let startY = 46;
        if (window.override) {
            for(let i = 0; i <= max; i++)if (frame.layers[i].name.indexOf("_") === 0) systemLayers++;
            startY = 46 - systemLayers * 23;
        }
        let offset = 0;
        for(let i = 0; i <= max; i++){
            let layer = frame.layers[i];
            let elm = (0, $eJ26Q.$div)("layer info" + (activeIndex === i ? " active" : "") + (layer.visible ? "" : " hidden"), layer.name, contentPanel, ()=>{
                if (elm.classList.contains("hasinput")) {
                    let input = elm.querySelector("input");
                    if (input) input.focus();
                    return;
                }
                if (activeIndex !== i) (0, $jU8Uk.default).activateLayer(i);
            });
            elm.style.top = startY + (max - i) * 23 - offset + "px";
            elm.currentIndex = elm.targetIndex = i;
            elm.id = "layer" + i;
            elm.info = "Drag to reorder, double click to rename, right click for more options";
            if (layer.name.indexOf("_") === 0) {
                elm.classList.add("system");
                if (window.override) offset -= 23;
            }
            elm.onDragStart = (e)=>{
                if (elm.classList.contains("hasinput")) return;
                // TODO probably more performant if we postpone this to when we actually drag
                let dupe = (0, $eJ26Q.$div)("dragelement box", elm.innerText);
                (0, $lkhKc.default).setDragElement(dupe);
            };
            elm.onDrag = (x, y)=>{
                if (elm.classList.contains("hasinput")) return;
                let distance = Math.abs(y);
                if (distance > 5) {
                    // Meh... did we just did a rugpull regenerating the layer list? FIXME!
                    let currentTarget = contentPanel.querySelector("#layer" + elm.currentIndex);
                    currentTarget.classList.add("ghost");
                    let indexChange = Math.round(y / 23);
                    let newIndex = elm.currentIndex - indexChange;
                    elm.targetIndex = newIndex;
                    if (newIndex < 0) newIndex = 0;
                    if (newIndex >= max) newIndex = max;
                    for(let i = 0; i <= max; i++){
                        let el = contentPanel.querySelector("#layer" + i);
                        if (el) {
                            if (elm.currentIndex === i) el.style.top = 46 + (max - newIndex) * 23 + "px";
                            else {
                                let ci = 0;
                                if (newIndex < elm.currentIndex && i >= newIndex && i <= elm.currentIndex) ci = 1;
                                if (newIndex > elm.currentIndex && i <= newIndex && i >= elm.currentIndex) ci = -1;
                                el.style.top = 46 + (max - i - ci) * 23 + "px";
                            }
                        }
                    }
                }
            };
            elm.onDragEnd = (e)=>{
                console.log("drop");
                (0, $lkhKc.default).removeDragElement();
                let currentTarget = contentPanel.querySelector("#layer" + elm.currentIndex);
                currentTarget.classList.remove("ghost");
                if (elm.currentIndex !== elm.targetIndex) (0, $jU8Uk.default).moveLayer(elm.currentIndex, elm.targetIndex);
            };
            elm.onDoubleClick = ()=>{
                renameLayer(i);
            };
            elm.onContextMenu = ()=>{
                let items = [];
                if (max > 1) items.push({
                    label: "Remove Layer",
                    command: (0, $k5ZAj.COMMAND).DELETELAYER
                });
                items.push({
                    label: "Duplicate Layer",
                    command: (0, $k5ZAj.COMMAND).DUPLICATELAYER
                });
                items.push({
                    label: "Rename Layer",
                    action: ()=>{
                        renameLayer(i);
                    }
                });
                if (layer.hasMask) {
                    items.push({
                        label: "Remove Layer Mask",
                        command: (0, $k5ZAj.COMMAND).DELETELAYERMASK
                    });
                    items.push({
                        label: "Apply Layer Mask",
                        command: (0, $k5ZAj.COMMAND).APPLYLAYERMASK
                    });
                } else {
                    items.push({
                        label: "Add Layer Mask: Show",
                        command: (0, $k5ZAj.COMMAND).LAYERMASK
                    });
                    items.push({
                        label: "Add Layer Mask: Hide",
                        command: (0, $k5ZAj.COMMAND).LAYERMASKHIDE
                    });
                }
                if (i < max) items.push({
                    label: "Move Up",
                    command: (0, $k5ZAj.COMMAND).LAYERUP
                });
                if (i > 0) {
                    items.push({
                        label: "Move Down",
                        command: (0, $k5ZAj.COMMAND).LAYERDOWN
                    });
                    items.push({
                        label: "Merge Down",
                        command: (0, $k5ZAj.COMMAND).MERGEDOWN
                    });
                }
                (0, $b6UY4.default).show(items);
            };
            if (elm.currentIndex === editIndex) {
                let input = (0, $eJ26Q.$input)("text", layer.name);
                elm.appendChild(input);
            }
            (0, $eJ26Q.default)(".eye", {
                parent: elm,
                onClick: ()=>{
                    (0, $eZZbx.default).start((0, $k5ZAj.EVENT).layerPropertyHistory, i);
                    (0, $jU8Uk.default).toggleLayer(i);
                    (0, $eZZbx.default).end();
                },
                info: "Toggle layer visibility"
            });
            if (layer.hasMask) (0, $eJ26Q.default)(".mask" + (layer.isMaskActive() ? ".active" : ""), {
                parent: elm,
                onClick: ()=>{
                    (0, $eZZbx.default).start((0, $k5ZAj.EVENT).layerPropertyHistory, i);
                    layer.toggleMask();
                    (0, $eZZbx.default).end();
                    (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).toolChanged);
                    (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layersChanged);
                },
                info: "Toggle layer mask"
            });
            if (layer.locked) {
                elm.classList.add("locked");
                (0, $eJ26Q.default)(".lock", {
                    parent: elm,
                    info: "Layer is locked"
                });
            }
            if (activeIndex === i) {
                opacityRange.value = layer.opacity;
                blendSelect.value = layer.blendMode;
            }
        }
    };
    function renameLayer(index) {
        let elm = contentPanel.querySelector("#layer" + index);
        let layer = (0, $jU8Uk.default).getLayer(index);
        if (elm) {
            let input = (0, $eJ26Q.$input)("text", layer.name);
            input.onkeydown = function(e) {
                e.stopPropagation();
                if (e.code === "Enter") {
                    (0, $eZZbx.default).start((0, $k5ZAj.EVENT).layerPropertyHistory, index);
                    layer.name = input.value;
                    (0, $eZZbx.default).end();
                    me.list();
                }
                if (e.code === "Escape") me.list();
            };
            elm.appendChild(input);
            elm.classList.add("hasinput");
            input.focus();
            // needed for rename from context menu
            setTimeout(()=>{
                input.focus();
            }, 50);
        }
    }
    (0, $9dDG4.default).on((0, $k5ZAj.EVENT).layersChanged, me.list);
    return me;
}();
var $8cc28480d7649b3e$export$2e2bcd8739ae039 = $8cc28480d7649b3e$var$LayerPanel;

});
parcelRegister("lkhKc", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8693adaf5076318$export$2e2bcd8739ae039);

var $9dDG4 = parcelRequire("9dDG4");

var $k5ZAj = parcelRequire("k5ZAj");

var $c1pPV = parcelRequire("c1pPV");

var $2hBLH = parcelRequire("2hBLH");

var $4eKVl = parcelRequire("4eKVl");

var $b6UY4 = parcelRequire("b6UY4");

var $jU8Uk = parcelRequire("jU8Uk");

var $5FeyE = parcelRequire("5FeyE");

var $ebbAH = parcelRequire("ebbAH");

var $4sZF5 = parcelRequire("4sZF5");
var $f8693adaf5076318$var$Input = function() {
    let me = {};
    let keyDown = {};
    let modifiers = [
        "space",
        "shift",
        "control",
        "alt"
    ];
    let touchData = {};
    let activeKeyHandler;
    let holdPointerEvents = false;
    me.init = function() {
        console.log("Input init");
        document.addEventListener("pointerdown", onPointerDown);
        document.addEventListener("pointerup", onPointerUp);
        document.addEventListener("pointercancel", onPointerUp);
        //document.addEventListener("pointerout",onPointerUp)
        document.addEventListener("pointerleave", onPointerUp);
        document.addEventListener("pointermove", onPointerMove);
        document.addEventListener("touchstart", onTouchStart);
        document.addEventListener("touchmove", onTouchMove);
        document.addEventListener("touchend", onTouchEnd);
        document.addEventListener("keydown", onKeyDown);
        document.addEventListener("keyup", onKeyUp);
        document.body.oncontextmenu = function(e) {
            return me.isShiftDown() && !(e.target && e.target.classList.contains("maincanvas"));
        };
        window.addEventListener("paste", handlePaste, false);
        window.addEventListener("copy", handleCopy, false);
        window.addEventListener("cut", handleCut, false);
        window.addEventListener("undo", handleUndo, false);
        window.addEventListener("delete", handleDelete, false);
        window.addEventListener("dragenter", handleDragEnter, false);
        window.addEventListener("dragover", handleDragOver, false);
        window.addEventListener("drop", handleDrop, false);
        (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).COPY, handleCopy);
        (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).PASTE, handlePaste);
    };
    me.isSpaceDown = function() {
        return !!keyDown["space"];
    };
    me.isShiftDown = function() {
        return !!keyDown["shift"];
    };
    me.isControlDown = function() {
        return !!keyDown["control"];
    };
    me.isAltDown = function() {
        return !!keyDown["alt"];
    };
    me.isMetaDown = function() {
        return !!keyDown["meta"] || me.isControlDown() || me.isShiftDown();
    };
    me.isMetaAndShiftDown = function() {
        return (!!keyDown["meta"] || me.isControlDown()) && me.isShiftDown();
    };
    me.isPointerDown = function() {
        return document.body.classList.contains("pointerdown");
    };
    me.setPointerOver = function(id) {
        document.body.classList.add("hover" + id);
    };
    me.removePointerOver = function(id) {
        document.body.classList.remove("hover" + id);
    };
    me.setActiveKeyHandler = function(handler) {
        activeKeyHandler = handler;
    };
    me.setDragElement = function(elm, activate) {
        if (touchData.dragElement) me.removeDragElement();
        touchData.dragElement = document.createElement("div");
        touchData.dragElement.id = "dragelement";
        if (activate) {
            touchData.dragElement.classList.add("active");
            let pos = (0, $ebbAH.default).getPosition();
            touchData.dragElement.style.left = pos.x + "px";
            touchData.dragElement.style.top = pos.y + "px";
        }
        if (elm) touchData.dragElement.appendChild(elm);
        document.body.appendChild(touchData.dragElement);
    };
    me.removeDragElement = function() {
        if (touchData.dragElement) {
            touchData.dragElement.remove();
            touchData.dragElement = undefined;
        }
    };
    me.holdPointerEvents = function() {
        holdPointerEvents = true;
    };
    me.releasePointerEvents = function() {
        holdPointerEvents = false;
    };
    me.hasPointerEvents = function() {
        return !holdPointerEvents;
    };
    me.getTouches = function() {
        return touchData.touches || [];
    };
    me.isMultiTouch = function() {
        return me.getTouches().length > 1;
    };
    function onPointerDown(e) {
        if (holdPointerEvents) return;
        let target = e.target.closest(".handle");
        if (e.pointerType === "touch" && target && target.classList.contains("viewport")) {
            // add a small delay so we still can capture multi touch gestures
            setTimeout(function() {
                handlePointerDown(e, target);
            }, 100);
            return;
        }
        handlePointerDown(e, target);
    }
    function onTouchStart(e) {
        touchData.touches = e.touches;
        if (e.touches.length > 1) {
            console.log("multitouch detected, holding pointer events");
            holdPointerEvents = true;
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).hideCanvasOverlay);
        }
    }
    function onTouchMove(e) {
        touchData.touches = e.touches;
    }
    function onTouchEnd(e) {
        touchData.touches = e.touches;
        if (e.touches.length === 0) holdPointerEvents = false;
    }
    function handlePointerDown(e, target) {
        if (holdPointerEvents) return;
        document.body.classList.add("pointerdown");
        console.log(target);
        if (!target || !target.classList.contains("menuitem")) (0, $c1pPV.default).close();
        if (!target || !target.classList.contains("contextmenuitem")) (0, $b6UY4.default).hide();
        if (target) {
            let resizer = (0, $2hBLH.default).getActivePanel().getResizer();
            if (resizer.isActive()) {
                let sizeTarget = target.closest(".sizebox");
                if (!sizeTarget) (0, $2hBLH.default).commit();
            }
            if (target.onClick) {
                // on touch devices this is not a click, which might interfere with events that require "user input"
                // like the file input dialog to open a file
                if ((e.pointerType === "touch" || e.pointerType === "pen") && target.waitForClick) touchData.waitForClick = {
                    target: target,
                    event: e,
                    time: performance.now()
                };
                else target.onClick(e, target);
            }
            if (target.onDoubleClick) {
                let now = performance.now();
                if (target.prevNow) {
                    if (now - target.prevNow < 400) target.onDoubleClick();
                }
                target.prevNow = now;
            }
            if (target.onDrag) {
                touchData.target = target;
                touchData.onDrag = target.onDrag;
                touchData.isDragging = true;
                touchData.startX = e.clientX;
                touchData.startY = e.clientY;
                touchData.button = e.button;
                e.preventDefault();
                if (target.onDragStart) target.onDragStart(e);
            }
            if ((e.button || e.ctrlKey) && target.onContextMenu) target.onContextMenu(e);
        }
    }
    function onPointerMove(e) {
        if (holdPointerEvents) return;
        if (!e.shiftKey) keyDown["shift"] = false;
        if (!e.altKey) keyDown["alt"] = false;
        if (!e.ctrlKey) keyDown["control"] = false;
        if (!e.metaKey) keyDown["meta"] = false;
        let infoTarget = e.target.closest(".info");
        if (infoTarget) {
            let tooltip = infoTarget.info;
            if (infoTarget.infoOnMove) tooltip = infoTarget.infoOnMove(e) + infoTarget.info;
            if (infoTarget.info) (0, $4eKVl.default).setToolTip(tooltip);
        } else (0, $4eKVl.default).setToolTip("");
        if (touchData.isDragging && touchData.onDrag) {
            let x = e.clientX - touchData.startX;
            let y = e.clientY - touchData.startY;
            touchData.onDrag(x, y, touchData, e);
        }
        if (touchData.dragElement) {
            touchData.dragElement.classList.add("active");
            touchData.dragElement.style.left = e.clientX + "px";
            touchData.dragElement.style.top = e.clientY + "px";
        }
        // Meh ...
        if (!me.isShiftDown() && !me.isAltDown() && !me.isSpaceDown() && !document.body.classList.contains("cursor-pan")) (0, $ebbAH.default).resetOverride();
    }
    function onPointerUp(e) {
        if (e.button === 1 && document.body.classList.contains("cursor-pan")) (0, $ebbAH.default).resetOverride();
        if (touchData.waitForClick) {
            let now = performance.now();
            if (now - touchData.waitForClick.time < 2000) touchData.waitForClick.target.onClick(touchData.waitForClick.event);
            else console.log("waitForClick timeout");
            touchData.waitForClick = undefined;
        }
        if (touchData.isDragging) {
            if (touchData.target && touchData.target.onDragEnd) touchData.target.onDragEnd(e);
        }
        touchData.isDragging = false;
        document.body.classList.remove("pointerdown");
        document.body.classList.contains("colorpicker") && !me.isShiftDown() && me.isAltDown();
    }
    function onKeyDown(e) {
        let code = limitKeyCode(e.code);
        let key = e.key;
        if (key) key = key.toLowerCase();
        if (me.isShiftDown() && !e.shiftKey) modifierKeyUp("shift");
        if (me.isControlDown() && !e.ctrlKey) modifierKeyUp("control");
        if (me.isAltDown() && !e.altKey) modifierKeyUp("alt");
        if (keyDown["meta"] && !e.metaKey) modifierKeyUp("meta");
        if (code === "keyv" && $f8693adaf5076318$var$Input.isMetaDown()) // allow default paste
        return;
        if (code === "keyc" && $f8693adaf5076318$var$Input.isMetaDown()) // allow default copy
        return;
        e.preventDefault();
        e.stopPropagation();
        //                                                      console.log(e);
        keyDown[code] = true;
        if (modifiers.indexOf(code) >= 0) {
            document.body.classList.add(code.toLowerCase());
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).modifierKeyChanged);
        }
        if (activeKeyHandler) {
            let handled = activeKeyHandler(code);
            if (handled) return;
        }
        //console.log(code);
        switch(code){
            case "delete":
            case "backspace":
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).CLEAR);
                break;
            case "escape":
                // TODO should we tie this to the selected tool?
                (0, $c1pPV.default).close();
                (0, $b6UY4.default).hide();
                (0, $2hBLH.default).reset();
                if ((0, $4sZF5.default).inPresentation()) (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).PRESENTATION);
                break;
            case "tab":
                //EventBus.trigger(COMMAND.SPLITSCREEN);
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).CYCLEPALETTE);
                break;
            case "enter":
                (0, $2hBLH.default).commit();
                break;
            case "numpad4":
                (0, $jU8Uk.default).nextFrame(-1);
                break;
            case "intlbackslash":
                if (me.isShiftDown()) (0, $jU8Uk.default).nextFrame();
                else (0, $jU8Uk.default).nextFrame(-1);
                break;
            case "numpad6":
                (0, $jU8Uk.default).nextFrame();
                break;
            case "arrowleft":
            case "arrowup":
            case "arrowright":
            case "arrowdown":
                (0, $2hBLH.default).arrowKey(code.replace("arrow", ""));
                break;
        }
        if (me.isMetaDown()) {
            if (me.isMetaAndShiftDown()) switch(key){
                case "a":
                    (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).LAYERMASK);
                    break;
                case "h":
                    (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).LAYERMASKHIDE);
                    break;
                case "l":
                    (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).TOSELECTION);
                    break;
                case "p":
                    (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).COLORSELECT);
                    break;
                case "arrowdown":
                    (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).MERGEDOWN);
                    break;
            }
            else switch(key){
                case "a":
                    (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).SELECTALL);
                    break;
                case "b":
                    (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).EFFECTS);
                    break;
                case "d":
                    (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).DUPLICATELAYER);
                    break;
                case "e":
                    (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).STAMP);
                    break;
                case "i":
                    (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).IMPORTFRAME);
                    break;
                case "j":
                    (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).TOLAYER);
                    break;
                case "k":
                    (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).CUTTOLAYER);
                    break;
                case "n":
                    (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).NEW);
                    break;
                case "o":
                    (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).OPEN);
                    break;
                case "p":
                    (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).RESIZE);
                    break;
                case "_r":
                    (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).ROTATE);
                    break;
                case "r":
                    (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).RESAMPLE);
                    break;
                case "s":
                    (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).SAVE);
                    break;
                case "y":
                    (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).REDO);
                    break;
                case "z":
                    (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).UNDO);
                    break;
            }
        } else switch(key){
            case "a":
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).TOGGLEMASK);
                break;
            case "b":
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).DRAW);
                break;
            case "c":
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).CIRCLE);
                break;
            case "d":
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).TOGGLEGRID);
                break;
            case "e":
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).ERASE);
                break;
            case "f":
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).FLOOD);
                break;
            case "g":
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).GRADIENT);
                break;
            case "h":
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).PAN);
                break;
            case "i":
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).TOGGLEINVERT);
                break;
            case "k":
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).COLORPICKER);
                break;
            case "l":
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).LINE);
                break;
            case "m":
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).SMUDGE);
                break;
            case "p":
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).POLYGONSELECT);
                break;
            case "q":
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).TOGGLEOVERRIDE);
                break;
            case "r":
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).SQUARE);
                break;
            case "s":
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).SELECT);
                break;
            case "t":
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).TRANSFORMLAYER);
                break;
            case "v":
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).TRANSFORMLAYER);
                break;
            case "w":
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).FLOODSELECT);
                break;
            case "x":
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).SWAPCOLORS);
                break;
            case "z":
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).SPLITSCREEN);
                break;
            case "-":
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).ZOOMOUT);
                break;
            case "+":
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).ZOOMIN);
                break;
        }
    }
    function onKeyUp(e) {
        let code = limitKeyCode(e.code);
        keyDown[code] = false;
        if (modifiers.indexOf(code) >= 0) modifierKeyUp(code);
    }
    function modifierKeyUp(code) {
        keyDown[code] = false;
        document.body.classList.remove(code);
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).modifierKeyChanged);
    }
    function limitKeyCode(code) {
        if (code === "ShiftLeft" || code === "ShiftRight") code = "shift";
        if (code === "AltLeft" || code === "AltRight") code = "alt";
        if (code === "ControlLeft" || code === "ControlRight") code = "control";
        if (code === "MetaLeft" || code === "MetaRight") code = "meta";
        return code.toLowerCase();
    }
    function handlePaste(e) {
        function pasteImage(blob) {
            let img = new Image();
            img.onerror = ()=>{
                console.error("error pasting image");
            };
            img.onload = ()=>{
                console.log("pasted image", img.width, img.height);
                (0, $jU8Uk.default).paste(img);
            };
            img.src = URL.createObjectURL(blob);
        }
        if (!e) {
            // "paste" selected from menu;
            let blob;
            const queryOpts = {
                name: "clipboard-read",
                allowWithoutGesture: true
            };
            navigator.permissions.query(queryOpts).then((permissionStatus)=>{
                // Will be 'granted', 'denied' or 'prompt':
                console.log(permissionStatus.state);
                getClipboardContents();
                // Listen for changes to the permission state
                permissionStatus.onchange = ()=>{
                    console.log(permissionStatus.state);
                    getClipboardContents();
                };
                async function getClipboardContents() {
                    if (permissionStatus.state === "granted") try {
                        const clipboardItems = await navigator.clipboard.read();
                        for (const clipboardItem of clipboardItems){
                            for (const type of clipboardItem.types)if (!blob && type.indexOf("image") !== -1) {
                                blob = await clipboardItem.getType(type);
                                pasteImage(blob);
                            }
                        }
                    } catch (err) {
                        console.error(err.name, err.message);
                    }
                }
            });
        }
        console.log("paste", e);
        if (e && e.clipboardData) {
            const clipboardItems = e.clipboardData.items;
            console.log("paste " + clipboardItems.length + " items");
            let list = [].slice.call(clipboardItems);
            list.forEach((item)=>{
                console.log(item.type);
            });
            const items = list.filter(function(item) {
                // Filter the image items only
                return item.type.indexOf("image") !== -1;
            });
            if (items.length === 0) return;
            const item = items[0];
            // Get the blob of image
            console.log("paste " + item.type);
            const blob = item.getAsFile();
            pasteImage(blob);
        }
    }
    function handleCopy(e) {
        if (e) {
            // Check what we need to copy
            console.log("copy from ", e.target, e);
            // allow default copy for input fields
            if (e.target.tagName.toLowerCase() === "input") return;
            if (e.target.closest("code")) return;
        }
        let canvas = (0, $5FeyE.default).toCanvas() || (0, $jU8Uk.default).getActiveContext().canvas;
        if (canvas && ClipboardItem) canvas.toBlob((blob)=>{
            // note: As to date, FireFox doesn't support ClipboardItem.
            let data = [
                new ClipboardItem({
                    [blob.type]: blob
                })
            ];
            navigator.clipboard.write(data).then(()=>{
                console.log("copied");
            }, (err)=>{
                console.error("error");
                console.error(err);
            //onError(err);
            });
        });
    }
    function handleCut() {
        console.log("cut");
    }
    function handleUndo() {
        console.log("undo");
    }
    function handleDelete() {
        console.log("delete");
    }
    function handleDragEnter(e) {
        e.stopPropagation();
        e.preventDefault();
    }
    function handleDragOver(e) {
        e.stopPropagation();
        e.preventDefault();
    }
    function handleDrop(e) {
        e.preventDefault();
        //console.error("Drop");
        //console.error(e);
        var dt = e.dataTransfer;
        var files = dt.files;
        (0, $jU8Uk.default).handleUpload(files, "file");
    }
    return me;
}();
var $f8693adaf5076318$export$2e2bcd8739ae039 = $f8693adaf5076318$var$Input;

});
parcelRegister("c1pPV", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c099ea1fa3fefc2$export$2e2bcd8739ae039);

var $eJ26Q = parcelRequire("eJ26Q");

var $k5ZAj = parcelRequire("k5ZAj");

var $9dDG4 = parcelRequire("9dDG4");
let $8c099ea1fa3fefc2$var$Menu = function() {
    let me = {};
    let container;
    let activeMenu;
    let isMenuActive;
    let isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
    let items = [
        {
            label: "File",
            items: [
                {
                    label: "New",
                    command: (0, $k5ZAj.COMMAND).NEW,
                    shortKey: "meta+N"
                },
                {
                    label: "Open",
                    command: (0, $k5ZAj.COMMAND).OPEN,
                    shortKey: "meta+O",
                    needsRealClick: true
                },
                {
                    label: "Save",
                    command: (0, $k5ZAj.COMMAND).SAVE,
                    shortKey: "meta+S"
                },
                {
                    label: "Import",
                    command: (0, $k5ZAj.COMMAND).IMPORTFRAME,
                    shortKey: "meta+I",
                    needsRealClick: true
                },
                {
                    label: "Info",
                    command: (0, $k5ZAj.COMMAND).INFO
                }
            ]
        },
        {
            label: "Edit",
            items: [
                {
                    label: "Copy",
                    command: (0, $k5ZAj.COMMAND).COPY,
                    shortKey: "meta+C"
                },
                {
                    label: "Paste",
                    command: (0, $k5ZAj.COMMAND).PASTE,
                    shortKey: "meta+V"
                },
                {
                    label: "Undo",
                    command: (0, $k5ZAj.COMMAND).UNDO,
                    shortKey: "meta+Z"
                },
                {
                    label: "Redo",
                    command: (0, $k5ZAj.COMMAND).REDO,
                    shortKey: "meta+Y"
                }
            ]
        },
        {
            label: "Image",
            items: [
                {
                    label: "Rotate",
                    command: (0, $k5ZAj.COMMAND).ROTATE
                },
                {
                    label: "Clear",
                    command: (0, $k5ZAj.COMMAND).CLEAR
                },
                {
                    label: "Crop",
                    command: (0, $k5ZAj.COMMAND).CROP
                },
                {
                    label: "Trim",
                    command: (0, $k5ZAj.COMMAND).TRIM
                },
                {
                    label: "Flatten",
                    command: (0, $k5ZAj.COMMAND).FLATTEN
                },
                {
                    label: "Image size",
                    command: (0, $k5ZAj.COMMAND).RESAMPLE,
                    shortKey: "meta+R"
                },
                {
                    label: "Canvas Size",
                    command: (0, $k5ZAj.COMMAND).RESIZE,
                    shortKey: "meta+P"
                }
            ]
        },
        {
            label: "Tools",
            items: [
                {
                    label: "Draw",
                    command: (0, $k5ZAj.COMMAND).DRAW,
                    shortKey: "B"
                },
                {
                    label: "Select",
                    command: (0, $k5ZAj.COMMAND).SELECT,
                    shortKey: "S"
                },
                {
                    label: "Line",
                    command: (0, $k5ZAj.COMMAND).LINE,
                    shortKey: "L"
                },
                {
                    label: "Rectangle",
                    command: (0, $k5ZAj.COMMAND).SQUARE,
                    shortKey: "R"
                },
                {
                    label: "Circle",
                    command: (0, $k5ZAj.COMMAND).CIRCLE,
                    shortKey: "C"
                },
                {
                    label: "Gradient",
                    command: (0, $k5ZAj.COMMAND).GRADIENT,
                    shortKey: "G"
                },
                {
                    label: "Erase",
                    command: (0, $k5ZAj.COMMAND).ERASE,
                    shortKey: "E"
                },
                {
                    label: "Smudge",
                    command: (0, $k5ZAj.COMMAND).SMUDGE,
                    shortKey: "M"
                },
                {
                    label: "Hand",
                    command: (0, $k5ZAj.COMMAND).PAN,
                    shortKey: "H"
                },
                {
                    label: "Color Picker",
                    command: (0, $k5ZAj.COMMAND).COLORPICKER,
                    shortKey: "K"
                }
            ]
        },
        {
            label: "Layer",
            items: [
                {
                    label: "New",
                    command: (0, $k5ZAj.COMMAND).NEWLAYER
                },
                {
                    label: "Transform",
                    items: [
                        {
                            label: "Free Transform",
                            command: (0, $k5ZAj.COMMAND).TRANSFORMLAYER,
                            shortKey: "T / V"
                        },
                        {
                            label: "Flip Horizontal",
                            command: (0, $k5ZAj.COMMAND).FLIPHORIZONTAL
                        },
                        {
                            label: "Flip Vertical",
                            command: (0, $k5ZAj.COMMAND).FLIPVERTICAL
                        }
                    ]
                },
                {
                    label: "Duplicate",
                    command: (0, $k5ZAj.COMMAND).DUPLICATELAYER,
                    shortKey: "meta+D"
                },
                {
                    label: "Effects",
                    command: (0, $k5ZAj.COMMAND).EFFECTS,
                    shortKey: "meta+B"
                },
                {
                    label: "Move Up",
                    command: (0, $k5ZAj.COMMAND).LAYERUP
                },
                {
                    label: "Move Down",
                    command: (0, $k5ZAj.COMMAND).LAYERDOWN
                },
                {
                    label: "Merge Down",
                    command: (0, $k5ZAj.COMMAND).MERGEDOWN,
                    shortKey: "meta+Shift+\u2193"
                },
                {
                    label: "Add Mask",
                    items: [
                        {
                            label: "Show All",
                            command: (0, $k5ZAj.COMMAND).LAYERMASK,
                            shortKey: "meta+Shift+A"
                        },
                        {
                            label: "Hide All",
                            command: (0, $k5ZAj.COMMAND).LAYERMASKHIDE,
                            shortKey: "meta+Shift+H"
                        }
                    ]
                }
            ]
        },
        {
            label: "Selection",
            items: [
                {
                    label: "Select",
                    items: [
                        {
                            label: "All",
                            command: (0, $k5ZAj.COMMAND).SELECTALL,
                            shortKey: "meta+A"
                        },
                        {
                            label: "Pixels in Current Layer",
                            command: (0, $k5ZAj.COMMAND).TOSELECTION,
                            shortKey: "meta+Shift+L"
                        },
                        {
                            label: "Pixels in Current Color",
                            command: (0, $k5ZAj.COMMAND).COLORSELECT,
                            shortKey: "meta+Shift+P"
                        }
                    ]
                },
                {
                    label: "Deselect",
                    command: (0, $k5ZAj.COMMAND).CLEARSELECTION,
                    shortKey: "Esc"
                },
                {
                    label: "Copy To Layer",
                    command: (0, $k5ZAj.COMMAND).TOLAYER,
                    shortKey: "meta+J"
                },
                {
                    label: "Cut To Layer",
                    command: (0, $k5ZAj.COMMAND).CUTTOLAYER,
                    shortKey: "meta+K"
                },
                {
                    label: "Copy To Brush",
                    command: (0, $k5ZAj.COMMAND).STAMP,
                    shortKey: "meta+E"
                }
            ]
        },
        {
            label: "Palette",
            items: [
                {
                    label: "Edit",
                    command: (0, $k5ZAj.COMMAND).EDITPALETTE
                },
                {
                    label: "From Image",
                    command: (0, $k5ZAj.COMMAND).PALETTEFROMIMAGE
                },
                {
                    label: "Reduce",
                    command: (0, $k5ZAj.COMMAND).PALETTEREDUCE
                },
                {
                    label: "Show Presets",
                    command: (0, $k5ZAj.COMMAND).TOGGLEPALETTES
                },
                {
                    label: "Save Palette",
                    command: (0, $k5ZAj.COMMAND).SAVEPALETTE
                },
                {
                    label: "Load Palette",
                    command: (0, $k5ZAj.COMMAND).LOADPALETTE
                },
                {
                    label: "Toggle Color Cycle",
                    command: (0, $k5ZAj.COMMAND).CYCLEPALETTE,
                    shortKey: "tab"
                }
            ]
        },
        {
            label: "View",
            items: [
                {
                    label: "Grid",
                    command: (0, $k5ZAj.COMMAND).TOGGLEGRID,
                    shortKey: "D",
                    checked: false
                },
                {
                    label: "Split Screen",
                    command: (0, $k5ZAj.COMMAND).SPLITSCREEN,
                    shortKey: "Z",
                    checked: false
                },
                {
                    label: "Tool Options",
                    command: (0, $k5ZAj.COMMAND).TOGGLESIDEPANEL,
                    checked: false
                },
                {
                    label: "Presentation mode",
                    command: (0, $k5ZAj.COMMAND).PRESENTATION,
                    checked: false
                },
                {
                    label: "Full Screen",
                    command: (0, $k5ZAj.COMMAND).FULLSCREEN,
                    needsRealClick: true,
                    checked: false
                }
            ]
        },
        {
            label: "Amiga",
            items: [
                {
                    label: "Open ADF image",
                    command: (0, $k5ZAj.COMMAND).ADF,
                    needsRealClick: true
                },
                {
                    label: "Preview in Deluxe Paint",
                    command: (0, $k5ZAj.COMMAND).DELUXE
                }
            ]
        },
        {
            label: "Help",
            items: [
                {
                    label: "About DPaint.js",
                    command: (0, $k5ZAj.COMMAND).ABOUT
                },
                {
                    label: "Documentation",
                    action: ()=>{
                        window.open("https://www.stef.be/dpaint/docs/");
                    },
                    needsRealClick: true
                },
                {
                    label: "SourceCode on GitHub",
                    action: ()=>{
                        window.open("https://github.com/steffest/dpaint-js");
                    },
                    needsRealClick: true
                }
            ]
        }
    ];
    me.init = function(parent) {
        container = (0, $eJ26Q.$div)("menu", "", parent);
        generate();
    };
    me.activateMenu = function(index) {
        if (typeof activeMenu === "number" && activeMenu !== index) me.deActivateMenu(activeMenu);
        let item = items[index];
        if (item && item.element) {
            item.element.classList.toggle("active");
            if (item.element.classList.contains("active")) {
                activeMenu = index;
                isMenuActive = true;
            } else isMenuActive = false;
        }
    };
    me.deActivateMenu = function(index) {
        if (typeof index === "undefined") index = activeMenu;
        let item = items[index];
        if (item && item.element) {
            item.element.classList.remove("active");
            activeMenu = undefined;
            isMenuActive = false;
        }
    };
    me.close = function() {
        if (container) container.classList.remove("active");
        me.deActivateMenu();
    };
    function buildMenuItem(item, parent) {
        let menuItem = (0, $eJ26Q.$link)("handle", item.label, parent, (e)=>{
            if (item.command) {
                (0, $9dDG4.default).trigger(item.command);
                me.deActivateMenu();
            }
            if (item.action) {
                me.deActivateMenu();
                item.action();
            }
        });
        if (item.items) {
            menuItem.classList.add("caret");
            let sub = (0, $eJ26Q.$div)("menuitem subsub", "", menuItem);
            item.items.forEach((subitem)=>{
                buildMenuItem(subitem, sub);
            });
        }
        if (item.needsRealClick) menuItem.waitForClick = true;
        if (item.shortKey) {
            let k = item.shortKey;
            if (k.length > 2) {
                menuItem.classList.add("wide");
                let meta = isMac ? "Cmd" : "Ctrl";
                if (k.indexOf("+N") > 1) meta = isMac ? "Ctrl" : "Alt";
                k = k.replace("meta", meta);
                if (k.length > 8) menuItem.classList.add("ultra");
            }
            (0, $eJ26Q.$div)("shortkey", k, menuItem);
        }
        if (typeof item.checked !== "undefined") {
            parent.classList.add("checkable");
            (0, $9dDG4.default).on(item.command, (e)=>{
                item.checked = !item.checked;
                menuItem.classList.toggle("checked");
            });
        }
        if (item.checked) menuItem.classList.add("checked");
    }
    function generate() {
        (0, $eJ26Q.$div)("hamburger menuitem", "DPaint.js", container, ()=>{
            container.classList.toggle("active");
        });
        items.forEach((item, index)=>{
            item.element = (0, $eJ26Q.$link)("menuitem main handle", item.label, container, (e)=>{
                me.activateMenu(index);
            });
            item.element.addEventListener("pointerenter", (e)=>{
                if (isMenuActive && activeMenu !== index) me.activateMenu(index);
            });
            if (item.items) {
                let sub = (0, $eJ26Q.$div)("menuitem sub", "", item.element);
                item.items.forEach((subitem)=>{
                    buildMenuItem(subitem, sub);
                });
            }
        });
    }
    return me;
}();
var $8c099ea1fa3fefc2$export$2e2bcd8739ae039 = $8c099ea1fa3fefc2$var$Menu;

});

parcelRegister("2hBLH", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a9a7749b90023a5$export$2e2bcd8739ae039);
parcelRequire("fEhXZ");

var $eJ26Q = parcelRequire("eJ26Q");

var $9dDG4 = parcelRequire("9dDG4");

var $k5ZAj = parcelRequire("k5ZAj");

var $gECXt = parcelRequire("gECXt");

var $lPw7G = parcelRequire("lPw7G");

var $jU8Uk = parcelRequire("jU8Uk");

var $5FeyE = parcelRequire("5FeyE");

var $eTCYn = parcelRequire("eTCYn");

var $bfgOg = parcelRequire("bfgOg");

var $8FLxR = parcelRequire("8FLxR");

var $9xub8 = parcelRequire("9xub8");

var $lkhKc = parcelRequire("lkhKc");

var $eZZbx = parcelRequire("eZZbx");

var $ebbAH = parcelRequire("ebbAH");
var $1a9a7749b90023a5$var$Editor = function() {
    var me = {};
    let panels = [];
    let divider;
    var container;
    var zoomFactor = 1.1;
    var activePanel;
    let resizer;
    var currentTool = (0, $k5ZAj.COMMAND).DRAW;
    let previousTool;
    var touchData = {};
    var state = {
        splitPanel: false
    };
    me.init = function(parent) {
        container = (0, $eJ26Q.$div)("editor splitpanel", "", parent);
        panels.push((0, $gECXt.default)(container, "left"));
        divider = (0, $eJ26Q.$div)("splitter", "", container, (e)=>{
            touchData.totalWidth = container.getBoundingClientRect().width;
            touchData.startWith = panels[0].getWidth();
            touchData.startWith2 = panels[1].getWidth();
            touchData.startX = parseInt(divider.style.marginLeft) || -3;
        });
        panels.push((0, $gECXt.default)(container, "right"));
        activePanel = panels[0];
        resizer = activePanel.getResizer();
        divider.onDrag = function(x, y) {
            let w = touchData.startWith + x;
            let w2 = touchData.startWith2 - x;
            let min = 120;
            if (w < min) x = min - touchData.startWith;
            if (w2 < min) x = touchData.startWith2 - min;
            w = (touchData.startWith + x) * 100 / touchData.totalWidth;
            divider.style.left = w + "%";
            panels[0].setWidth(w, true);
            w = (touchData.startWith2 - x) * 100 / touchData.totalWidth;
            panels[1].setWidth(w, true);
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).panelResized);
        };
        (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).ZOOMIN, function(center) {
            activePanel.zoom(zoomFactor, center);
        });
        (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).ZOOMOUT, function(center) {
            activePanel.zoom(1 / zoomFactor, center);
        });
        //TODO: move these to ToolOptions
        (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).DRAW, function() {
            currentTool = (0, $k5ZAj.COMMAND).DRAW;
            (0, $ebbAH.default).set("draw");
        });
        (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).ERASE, function() {
            currentTool = (0, $k5ZAj.COMMAND).ERASE;
            (0, $ebbAH.default).set("draw");
        });
        (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).SMUDGE, function() {
            currentTool = (0, $k5ZAj.COMMAND).SMUDGE;
        });
        (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).FLOOD, function() {
            currentTool = (0, $k5ZAj.COMMAND).FLOOD;
        });
        (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).SQUARE, function() {
            currentTool = (0, $k5ZAj.COMMAND).SQUARE;
            (0, $ebbAH.default).set("select");
        });
        (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).CIRCLE, function() {
            currentTool = (0, $k5ZAj.COMMAND).CIRCLE;
            (0, $ebbAH.default).set("select");
        });
        (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).LINE, function() {
            currentTool = (0, $k5ZAj.COMMAND).LINE;
        });
        (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).GRADIENT, function() {
            currentTool = (0, $k5ZAj.COMMAND).GRADIENT;
        });
        (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).PAN, function() {
            currentTool = (0, $k5ZAj.COMMAND).PAN;
            (0, $ebbAH.default).set("pan");
        });
        (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).COLORPICKER, function() {
            currentTool = (0, $k5ZAj.COMMAND).COLORPICKER;
            (0, $ebbAH.default).set("colorpicker");
        });
        (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).SPLITSCREEN, function() {
            me.splitPanel();
        });
        (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).ROTATE, function() {
            (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).CLEARSELECTION);
            let currentFrame = (0, $jU8Uk.default).getActiveFrame();
            currentFrame.layers.forEach((layer)=>{
                (0, $lPw7G.default).rotate(layer.getCanvas());
            });
            let w = (0, $jU8Uk.default).getCurrentFile().width;
            (0, $jU8Uk.default).getCurrentFile().width = (0, $jU8Uk.default).getCurrentFile().height;
            (0, $jU8Uk.default).getCurrentFile().height = w;
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).imageSizeChanged);
        });
        (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).CLEAR, function() {
            var s = (0, $5FeyE.default).get();
            let layer = (0, $jU8Uk.default).getActiveLayer();
            if (!layer) return;
            (0, $eZZbx.default).start((0, $k5ZAj.EVENT).layerContentHistory);
            if (s) {
                if (s.canvas || s.points) {
                    let canvas = (0, $5FeyE.default).getCanvas();
                    let layerCtx = layer.getContext();
                    layerCtx.globalCompositeOperation = "destination-out";
                    layerCtx.drawImage(canvas, 0, 0);
                    layerCtx.globalCompositeOperation = "source-over";
                    (0, $9xub8.releaseCanvas)(canvas);
                } else // rectangular selection
                layer.getContext().clearRect(s.left, s.top, s.width, s.height);
            } else layer.clear();
            (0, $eZZbx.default).end();
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layerContentChanged);
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).imageContentChanged);
        });
        (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).CROP, function() {
            var s = (0, $5FeyE.default).get();
            if (s) {
                (0, $eZZbx.default).start((0, $k5ZAj.EVENT).imageHistory);
                (0, $jU8Uk.default).getCurrentFile().frames.forEach((frame)=>{
                    frame.layers.forEach((layer)=>{
                        let c = layer.getCanvas();
                        let ctx = c.getContext("2d");
                        let canvas = document.createElement("canvas");
                        canvas.width = s.width;
                        canvas.height = s.height;
                        canvas.getContext("2d").clearRect(0, 0, s.width, s.height);
                        canvas.getContext("2d").drawImage(c, s.left, s.top, s.width, s.height, 0, 0, s.width, s.height);
                        c.width = s.width;
                        c.height = s.height;
                        ctx.clearRect(0, 0, s.width, s.height);
                        ctx.drawImage(canvas, 0, 0);
                        (0, $9xub8.releaseCanvas)(canvas);
                    });
                });
                (0, $jU8Uk.default).getCurrentFile().width = s.width;
                (0, $jU8Uk.default).getCurrentFile().height = s.height;
                (0, $5FeyE.default).move(0, 0, s.width, s.height);
                (0, $eZZbx.default).end();
                (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).imageSizeChanged);
            }
        });
        (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).TRIM, ()=>{
            let ctx = (0, $jU8Uk.default).getActiveContext();
            let canvas = ctx.canvas;
            let box = (0, $jU8Uk.default).getLayerBoundingRect();
            if (!box.w || !box.h) return;
            let cut = ctx.getImageData(box.x, box.y, box.w, box.h);
            if (box.w === canvas.width && box.h === canvas.height && box.x === 0) return;
            (0, $eZZbx.default).start((0, $k5ZAj.EVENT).imageHistory);
            canvas.width = box.w;
            canvas.height = box.h;
            ctx.putImageData(cut, 0, 0);
            (0, $jU8Uk.default).getCurrentFile().width = canvas.width;
            (0, $jU8Uk.default).getCurrentFile().height = canvas.height;
            (0, $eZZbx.default).end();
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).imageSizeChanged);
        });
        (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).TRANSFORMLAYER, ()=>{
            let box = (0, $jU8Uk.default).getLayerBoundingRect();
            if (!box.w || !box.h) return;
            previousTool = currentTool;
            currentTool = (0, $k5ZAj.COMMAND).TRANSFORMLAYER;
            resizer.init({
                x: box.x,
                y: box.y,
                width: box.w,
                height: box.h,
                rotation: 0,
                aspect: box.w / box.h,
                canRotate: true
            });
            touchData.transformBox = box;
            touchData.transformCanvas = document.createElement("canvas");
            touchData.transformCanvas.width = box.w;
            touchData.transformCanvas.height = box.h;
            let ctx = touchData.transformCanvas.getContext("2d");
            ctx.imageSmoothingEnabled = false;
            ctx.drawImage((0, $jU8Uk.default).getActiveContext().canvas, box.x, box.y, box.w, box.h, 0, 0, box.w, box.h);
            touchData.transformLayer = (0, $jU8Uk.default).getActiveLayer();
            resizer.setOnUpdate(updateTransform);
        });
        (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).COLORMASK, ()=>{
            let ctx = (0, $jU8Uk.default).getActiveContext();
            let color = (0, $eTCYn.default).getDrawColor();
            let w = (0, $jU8Uk.default).getCurrentFile().width;
            let h = (0, $jU8Uk.default).getCurrentFile().height;
            let data = ctx.getImageData(0, 0, w, h).data;
            let layerIndex = (0, $jU8Uk.default).addLayer();
            let layer = (0, $jU8Uk.default).getLayer(layerIndex);
            layer.type = "pixelSelection";
            let ctx2 = (0, $jU8Uk.default).getLayer(layerIndex).getContext();
            ctx2.fillStyle = "red";
            let count = 0;
            for(let y = 0; y < h; y++)for(let x = 0; x < w; x++){
                let index = (y * w + x) * 4;
                let r = data[index];
                let g = data[index + 1];
                let b = data[index + 2];
                let c = (0, $bfgOg.default).toString([
                    r,
                    g,
                    b
                ]);
                if (c === color) {
                    count++;
                    ctx2.fillRect(x, y, 1, 1);
                }
            }
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).imageContentChanged);
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).colorCount, count);
            return layerIndex;
        });
        (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).LAYERMASK, (hide)=>{
            (0, $eZZbx.default).start((0, $k5ZAj.EVENT).layerHistory);
            let layer = (0, $jU8Uk.default).getActiveLayer();
            layer.addMask(!!hide);
            (0, $eZZbx.default).end();
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layerContentChanged);
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layersChanged);
        });
        (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).LAYERMASKHIDE, ()=>{
            (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).LAYERMASK, true);
            setTimeout(()=>{
                (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layerContentChanged);
                (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layersChanged);
            }, 1000);
        });
        (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).DELETELAYERMASK, ()=>{
            let layer = (0, $jU8Uk.default).getActiveLayer();
            layer.removeMask();
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layerContentChanged);
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layersChanged);
        });
        (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).APPLYLAYERMASK, ()=>{
            let layer = (0, $jU8Uk.default).getActiveLayer();
            layer.removeMask(true);
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layerContentChanged);
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layersChanged);
        });
        (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).EDITPALETTE, ()=>{
            (0, $8FLxR.default).show((0, $8FLxR.DIALOG).PALETTE);
        });
        (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).EFFECTS, ()=>{
            (0, $8FLxR.default).show((0, $8FLxR.DIALOG).EFFECTS);
        });
        (0, $9dDG4.default).on((0, $k5ZAj.EVENT).toolChanged, (tool)=>{
            me.commit();
            (0, $ebbAH.default).reset();
            if (tool === (0, $k5ZAj.COMMAND).SELECT || tool === (0, $k5ZAj.COMMAND).FLOODSELECT || tool === (0, $k5ZAj.COMMAND).POLYGONSELECT) {
                currentTool = tool;
                (0, $ebbAH.default).set("select");
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).INITSELECTION, tool);
            }
        });
    };
    me.setActivePanel = function(panel) {
        activePanel = panels[panel];
        resizer = activePanel.getResizer();
    };
    me.getActivePanel = function() {
        return activePanel;
    };
    me.getCurrentTool = function() {
        return currentTool;
    };
    me.splitPanel = function() {
        state.splitPanel = !state.splitPanel;
        if (divider.style.display === "block") {
            panels[0].setWidth(100, true);
            panels[1].hide();
            divider.style.display = "none";
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).UIresize);
        } else {
            panels[0].setWidth("calc(50% - 4px)");
            panels[1].setWidth("calc(50% - 4px)");
            panels[1].show();
            divider.style.display = "block";
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).imageSizeChanged);
        }
    };
    me.isStateActive = function(name) {
        return !!state[name];
    };
    me.commit = function() {
        if (currentTool === (0, $k5ZAj.COMMAND).TRANSFORMLAYER) {
            console.log("commit layer");
            resizer.commit();
            updateTransform();
            clearTransform();
            (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).CLEARSELECTION);
            currentTool = undefined;
            if (previousTool) (0, $9dDG4.default).trigger(previousTool);
        }
        if (currentTool === (0, $k5ZAj.COMMAND).POLYGONSELECT) (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).ENDPOLYGONSELECT);
    };
    me.reset = function() {
        if (currentTool === (0, $k5ZAj.COMMAND).TRANSFORMLAYER) {
            resizer.commit();
            resetTransform();
            clearTransform();
            currentTool = undefined;
        }
        (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).CLEARSELECTION);
    };
    me.arrowKey = function(direction) {
        let x = 0;
        let y = 0;
        switch(direction){
            case "left":
                x = -1;
                break;
            case "right":
                x = 1;
                break;
            case "up":
                y = -1;
                break;
            case "down":
                y = 1;
                break;
        }
        if ((0, $lkhKc.default).isMetaDown()) {
            x *= 10;
            y *= 10;
        }
        if (currentTool === (0, $k5ZAj.COMMAND).DRAW) {
            if (x > 0) (0, $eTCYn.default).next();
            if (x < 0) (0, $eTCYn.default).prev();
            return;
        }
        resizer.move(x, y);
    };
    me.setZoom = function(factor, center) {
        activePanel.setZoom(factor, center);
    };
    me.canPickColor = ()=>{
        let ct = $1a9a7749b90023a5$var$Editor.getCurrentTool();
        return !(ct === (0, $k5ZAj.COMMAND).SELECT || ct === (0, $k5ZAj.COMMAND).SQUARE || ct === (0, $k5ZAj.COMMAND).GRADIENT || ct === (0, $k5ZAj.COMMAND).LINE || ct === (0, $k5ZAj.COMMAND).CIRCLE || ct === (0, $k5ZAj.COMMAND).TRANSFORMLAYER);
    };
    function updateTransform() {
        if (!touchData.transformLayer) return;
        console.log("update transform layer");
        let d = resizer.get();
        touchData.transformLayer.clear();
        if (d.width === 0 || d.height === 0) return;
        let ctx = touchData.transformLayer.getContext();
        ctx.imageSmoothingEnabled = false;
        if (d.rotation) {
            console.log("rotate " + d.rotation);
            let dw = d.left + d.width / 2;
            let dh = d.top + d.height / 2;
            ctx.translate(dw, dh);
            ctx.rotate(d.rotation * Math.PI / 180);
            ctx.translate(-dw, -dh);
        }
        ctx.drawImage(touchData.transformCanvas, d.left, d.top, d.width, d.height);
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layerContentChanged);
    }
    function resetTransform() {
        touchData.transformLayer.clear();
        let ctx = touchData.transformLayer.getContext();
        let box = touchData.transformBox;
        ctx.imageSmoothingEnabled = false;
        ctx.drawImage(touchData.transformCanvas, box.x, box.y, box.w, box.h);
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layerContentChanged);
    }
    function clearTransform() {
        touchData.transformBox = undefined;
        if (touchData.transformCanvas) (0, $9xub8.releaseCanvas)(touchData.transformCanvas);
        touchData.transformLayer = undefined;
    }
    return me;
}();
var $1a9a7749b90023a5$export$2e2bcd8739ae039 = $1a9a7749b90023a5$var$Editor;

});
parcelRegister("fEhXZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b648873c4b7cfb64$export$2e2bcd8739ae039);

var $lkhKc = parcelRequire("lkhKc");

var $9dDG4 = parcelRequire("9dDG4");

var $k5ZAj = parcelRequire("k5ZAj");

var $eJ26Q = parcelRequire("eJ26Q");

var $eTCYn = parcelRequire("eTCYn");

var $aEF6k = parcelRequire("aEF6k");

var $2hBLH = parcelRequire("2hBLH");
parcelRequire("5FeyE");

var $jU8Uk = parcelRequire("jU8Uk");

var $bo1l3 = parcelRequire("bo1l3");

var $gDIFj = parcelRequire("gDIFj");

var $4eKVl = parcelRequire("4eKVl");

var $81IXX = parcelRequire("81IXX");

var $lPw7G = parcelRequire("lPw7G");

var $eZded = parcelRequire("eZded");

var $bfgOg = parcelRequire("bfgOg");

var $9xub8 = parcelRequire("9xub8");

var $eZZbx = parcelRequire("eZZbx");

var $ebbAH = parcelRequire("ebbAH");

var $4UCrC = parcelRequire("4UCrC");

var $h67gn = parcelRequire("h67gn");
let $b648873c4b7cfb64$var$Canvas = function(parent) {
    let me = {};
    let canvas;
    let ctx;
    let overlayCanvas;
    let overlayCtx;
    let touchData = {};
    let zoom = 1;
    let prevZoom;
    var panelParent;
    let selectBox;
    let resizer;
    let gridOverlay;
    let drawFunction;
    let containerTransform = {
        x: 0,
        y: 0,
        startX: 0,
        startY: 0
    };
    let currentCursorPoint;
    canvas = document.createElement("canvas");
    overlayCanvas = document.createElement("canvas");
    resizer = (0, $bo1l3.default)(parent);
    selectBox = (0, $81IXX.default)(parent, resizer);
    canvas.width = 200;
    canvas.height = 200;
    overlayCanvas.width = 200;
    overlayCanvas.height = 200;
    ctx = canvas.getContext("2d", {
        willReadFrequently: true,
        antialias: false,
        desynchronized: false
    });
    overlayCtx = overlayCanvas.getContext("2d", {
        willReadFrequently: true
    });
    let wrapper = (0, $eJ26Q.$div)("canvaswrapper");
    let container = (0, $eJ26Q.$div)("canvascontainer");
    let visualAids = (0, $eJ26Q.$div)("visualaids");
    gridOverlay = (0, $h67gn.default)(visualAids);
    overlayCanvas.className = "overlaycanvas";
    canvas.className = "maincanvas info";
    container.appendChild(canvas);
    container.appendChild(overlayCanvas);
    container.appendChild(selectBox.getBox());
    container.appendChild(visualAids);
    wrapper.appendChild(container);
    panelParent = parent.getViewPort();
    panelParent.appendChild(wrapper);
    panelParent.addEventListener("scroll", (e)=>{
        handle("scroll", e);
    }, false);
    panelParent.classList.add("handle");
    panelParent.onDragStart = function(e) {
        handle("down", e);
    };
    panelParent.onDrag = function(x, y, touchData, e) {
        handle("move", e);
    };
    panelParent.onDragEnd = function(e) {
        handle("up", e);
    };
    panelParent.onDoubleClick = function(e) {
        if ((0, $2hBLH.default).getCurrentTool() === (0, $k5ZAj.COMMAND).POLYGONSELECT) selectBox.endPolySelect(true);
    };
    canvas.addEventListener("pointermove", function(e) {
        handle("over", e);
    }, false);
    canvas.addEventListener("pointerenter", function(e) {
        (0, $lkhKc.default).setPointerOver("canvas");
    }, false);
    canvas.addEventListener("pointerleave", function(e) {
        (0, $lkhKc.default).removePointerOver("canvas");
        hideOverlay();
    }, false);
    //canvas.addEventListener("touchmove",(e)=>{
    //    console.error("m3",e.targetTouches[0].force);
    //});
    canvas.addEventListener("touchend", (e)=>{
        // This is needed to avoid the "selection lens" on mobile safari on double tap/hold
        e.preventDefault();
        touchData.touchUpTime = performance.now();
    });
    (0, $9dDG4.default).on((0, $k5ZAj.EVENT).hideCanvasOverlay, ()=>{
        overlayCanvas.style.opacity = 0;
    });
    (0, $9dDG4.default).on((0, $k5ZAj.EVENT).drawCanvasOverlay, (point)=>{
        if (!(0, $lkhKc.default).hasPointerEvents()) return;
        overlayCanvas.style.opacity = 1;
        overlayCtx.clearRect(0, 0, canvas.width, canvas.height);
        overlayCtx.globalAlpha = (0, $aEF6k.default).getOpacity();
        (0, $aEF6k.default).draw(overlayCtx, point.x, point.y, (0, $eTCYn.default).getDrawColor(), (0, $lkhKc.default).isControlDown() || (0, $lkhKc.default).isMetaDown());
        overlayCtx.globalAlpha = 1;
        currentCursorPoint = point;
    });
    (0, $9dDG4.default).on((0, $k5ZAj.EVENT).drawColorChanged, ()=>{
        if (overlayCanvas.style.opacity > 0 && currentCursorPoint) {
            overlayCtx.globalAlpha = (0, $aEF6k.default).getOpacity();
            (0, $aEF6k.default).draw(overlayCtx, currentCursorPoint.x, currentCursorPoint.y, (0, $eTCYn.default).getDrawColor(), (0, $lkhKc.default).isControlDown() || (0, $lkhKc.default).isMetaDown());
            overlayCtx.globalAlpha = 1;
        }
    });
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).INITSELECTION, (tool)=>{
        if (!parent.isVisible()) return;
        selectBox.activate(tool);
    });
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).ENDPOLYGONSELECT, (fromClick)=>{
        selectBox.endPolySelect(fromClick);
    });
    (0, $9dDG4.default).on((0, $k5ZAj.EVENT).endPolygonSelect, ()=>{
        touchData.isPolySelect = false;
    });
    (0, $9dDG4.default).on((0, $k5ZAj.EVENT).imageSizeChanged, ()=>{
        if (!parent.isVisible()) return;
        let c = (0, $jU8Uk.default).getCanvas();
        canvas.width = overlayCanvas.width = c.width;
        canvas.height = overlayCanvas.height = c.height;
        me.update();
        me.zoom(1);
        gridOverlay.update();
    });
    (0, $9dDG4.default).on((0, $k5ZAj.EVENT).UIresize, ()=>{
        if (!parent.isVisible()) return;
        me.zoom(1);
    });
    (0, $9dDG4.default).on((0, $k5ZAj.EVENT).panelResized, ()=>{
        if (!parent.isVisible()) return;
        me.zoom(1);
    });
    (0, $9dDG4.default).on((0, $k5ZAj.EVENT).imageContentChanged, ()=>{
        me.clear();
        let c = (0, $jU8Uk.default).getCanvas();
        if (c) ctx.drawImage(c, 0, 0);
    });
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).TOGGLEGRID, ()=>{
        if (!parent.isVisible()) return;
        gridOverlay.toggle();
    });
    (0, $9dDG4.default).on((0, $k5ZAj.EVENT).gridOptionsChanged, ()=>{
        gridOverlay.update();
    });
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).COLORSELECT, ()=>{
        if (!parent.isVisible()) return;
        selectBox.activate((0, $k5ZAj.COMMAND).COLORSELECT);
        selectBox.colorSelect((0, $eTCYn.default).getDrawColor());
    });
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).TOSELECTION, ()=>{
        if (!parent.isVisible()) return;
        //This is different from COMMAND.SELECTALL as this selects the actual pixels?
        let layer = (0, $jU8Uk.default).getActiveLayer();
        selectBox.activate((0, $k5ZAj.COMMAND).TOSELECTION);
        selectBox.applyCanvas(layer.getCanvas());
    });
    me.clear = function() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
    };
    me.set = function(image, reset) {
        if (reset) {
            canvas.width = overlayCanvas.width = image.width;
            canvas.height = overlayCanvas.height = image.height;
            zoom = 1;
            me.zoom(1);
        }
        me.clear();
    };
    me.update = function() {
        me.clear();
        ctx.drawImage((0, $jU8Uk.default).getCanvas(), 0, 0);
    };
    me.zoom = function(amount, event) {
        hideOverlay();
        var z = prevZoom || zoom;
        prevZoom = undefined;
        const rect = panelParent.getBoundingClientRect();
        if (!event) event = {
            clientX: rect.width / 2,
            clientY: rect.height / 2
        };
        // zoom around point
        var x = Math.floor(event.clientX - rect.left) + panelParent.scrollLeft;
        var y = Math.floor(event.clientY - rect.top) + panelParent.scrollTop;
        zoom = zoom * amount;
        canvas.style.width = Math.floor(canvas.width * zoom) + "px";
        canvas.style.height = Math.floor(canvas.height * zoom) + "px";
        overlayCanvas.style.width = Math.floor(canvas.width * zoom) + "px";
        overlayCanvas.style.height = Math.floor(canvas.height * zoom) + "px";
        var _z = zoom / z - 1;
        panelParent.scrollLeft += _z * x;
        panelParent.scrollTop += _z * y;
        if (selectBox.isActive()) selectBox.zoom(zoom);
        if (resizer.isActive()) resizer.zoom(zoom);
        gridOverlay.zoom(zoom);
    };
    me.getZoom = function() {
        return zoom;
    };
    me.setZoom = function(amount, center) {
        prevZoom = zoom;
        zoom = amount;
        me.zoom(1, center);
    };
    me.getCanvas = function() {
        return canvas;
    };
    // TODO: resize and selectbox should be part of the editPanel?
    me.getResizer = function() {
        return resizer;
    };
    me.startSelect = function() {
        touchData.isSelecting = true;
    };
    function draw() {
        // button=0 -> left, button=2: right
        let color = touchData.button ? (0, $eTCYn.default).getBackgroundColor() : (0, $eTCYn.default).getDrawColor();
        if ((0, $2hBLH.default).getCurrentTool() === (0, $k5ZAj.COMMAND).ERASE) color = "transparent";
        let { x: x, y: y } = touchData;
        //TODO: should we cancel the draw if the coordinates are the same as the previous draw?
        if (touchData.previousDrawPoint && x === touchData.previousDrawPoint.x && y === touchData.previousDrawPoint.y) return;
        touchData.drawLayer = (0, $jU8Uk.default).getActiveLayer();
        touchData.drawLayer.draw(x, y, color, touchData);
        if (touchData.previousDrawPoint) {
            // fill in gaps
            let p1 = touchData.previousDrawPoint;
            let delta = {
                x: x - p1.x,
                y: y - p1.y
            };
            if (Math.abs(delta.x) > 1 || Math.abs(delta.y) > 1) {
                let steps = Math.max(Math.abs(delta.x), Math.abs(delta.y));
                delta.x /= steps;
                delta.y /= steps;
                for(let i = 0; i < steps; i++){
                    let _x = p1.x + Math.round(delta.x * i);
                    let _y = p1.y + Math.round(delta.y * i);
                    touchData.drawLayer.draw(_x, _y, color, touchData);
                // TODO: avoid duplicate _x,_y draws
                // check how this affect transparency, especially in locked palette mode
                }
            }
        }
        touchData.previousDrawPoint = {
            x: x,
            y: y
        };
        touchData.isDrawing = true;
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layerContentChanged);
    }
    let defaultDrawFunction = function() {
        let box = resizer.get();
        let w = box.width;
        let h = box.height;
        let x = box.left;
        let y = box.top;
        drawFunction(canvas.getContext("2d"), x, y, w, h);
    };
    function handle(action, e) {
        e.preventDefault();
        var point;
        switch(action){
            case "down":
                if ((0, $lkhKc.default).isMultiTouch()) return;
                // let the editPanel parent handle this for pan/zoom
                if (touchData.touchUpTime) {
                    let delta = performance.now() - touchData.touchUpTime;
                    if (delta < 90) {
                        // this is a tap on touchscreen on the canvas without dragging
                        // pointer event handling seems a bit mixed up here
                        // (Touchup on the canvas happens before the touchdown on its parent element?)
                        touchData.touchUpTime = undefined;
                        setTimeout(()=>{
                            handle("up", e);
                            console.error("synth up");
                        }, 10);
                    }
                }
                point = getCursorPosition(canvas, e, true);
                let isOnCanvas = e.target && e.target.classList.contains("maincanvas");
                console.error(e.target);
                touchData.isdown = true;
                touchData.button = e.button;
                (0, $aEF6k.default).setPressure(e.pressure);
                //navigator.clipboard.writeText(point.x + "," + point.y);
                if (e.metaKey || e.ctrlKey) touchData.button = 3;
                if ((0, $lkhKc.default).isSpaceDown() || e.button === 1 || (0, $2hBLH.default).getCurrentTool() === (0, $k5ZAj.COMMAND).PAN) {
                    (0, $ebbAH.default).override("pan");
                    touchData.startDragX = e.clientX;
                    touchData.startDragY = e.clientY;
                    touchData.startScrollX = panelParent.scrollLeft;
                    touchData.startScrollY = panelParent.scrollTop;
                    containerTransform.startX = containerTransform.x;
                    containerTransform.startY = containerTransform.y;
                    return;
                } else if (((0, $lkhKc.default).isShiftDown() || (0, $lkhKc.default).isAltDown()) && (0, $2hBLH.default).canPickColor() || (0, $2hBLH.default).getCurrentTool() === (0, $k5ZAj.COMMAND).COLORPICKER) {
                    (0, $ebbAH.default).override("colorpicker");
                    (0, $ebbAH.default).attach("colorpicker");
                    var pixel = ctx.getImageData(point.x, point.y, 1, 1).data;
                    (0, $eTCYn.default).setColor(pixel, !!e.button, true);
                    return;
                }
                let currentTool = (0, $2hBLH.default).getCurrentTool();
                switch(currentTool){
                    case (0, $k5ZAj.COMMAND).DRAW:
                    case (0, $k5ZAj.COMMAND).ERASE:
                        if (!isOnCanvas) return;
                        (0, $eZZbx.default).start((0, $k5ZAj.EVENT).layerContentHistory);
                        draw();
                        break;
                    case (0, $k5ZAj.COMMAND).SMUDGE:
                        (0, $eZZbx.default).start((0, $k5ZAj.EVENT).layerContentHistory);
                        (0, $4UCrC.default).start(touchData);
                        if (!isOnCanvas) return;
                        break;
                    case (0, $k5ZAj.COMMAND).SELECT:
                        touchData.isSelecting = true;
                        selectBox.boundingBoxSelect(point);
                        break;
                    case (0, $k5ZAj.COMMAND).POLYGONSELECT:
                        touchData.isPolySelect = true;
                        selectBox.polySelect(point);
                        break;
                    case (0, $k5ZAj.COMMAND).FLOODSELECT:
                        let c = selectBox.floodSelect((0, $jU8Uk.default).getActiveLayer().getCanvas(), point);
                        selectBox.activate((0, $k5ZAj.COMMAND).FLOODSELECT);
                        selectBox.applyCanvas(c);
                        break;
                    case (0, $k5ZAj.COMMAND).FLOOD:
                        (0, $eZZbx.default).start((0, $k5ZAj.EVENT).layerContentHistory);
                        let cf = selectBox.floodSelect((0, $jU8Uk.default).getActiveLayer().getCanvas(), point, (0, $bfgOg.default).fromString(e.button ? (0, $eTCYn.default).getBackgroundColor() : (0, $eTCYn.default).getDrawColor()));
                        (0, $jU8Uk.default).getActiveLayer().drawImage(cf);
                        (0, $eZZbx.default).end();
                        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layerContentChanged);
                        break;
                    case (0, $k5ZAj.COMMAND).CIRCLE:
                    case (0, $k5ZAj.COMMAND).SQUARE:
                        touchData.isSelecting = true;
                        resizer.init({
                            x: point.x,
                            y: point.y,
                            width: 0,
                            height: 0,
                            rotation: 0,
                            hot: true,
                            aspect: 1,
                            canRotate: false
                        });
                        (0, $eZZbx.default).start((0, $k5ZAj.EVENT).layerContentHistory);
                        if (currentTool === (0, $k5ZAj.COMMAND).CIRCLE) drawFunction = function(ctx, x, y, w, h, button) {
                            ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
                            let color = button ? (0, $eTCYn.default).getBackgroundColor() : (0, $eTCYn.default).getDrawColor();
                            let cx = x + w / 2;
                            let cy = y + h / 2;
                            let wx = w / 2;
                            let wh = h / 2;
                            let isOdd = false;
                            ctx.fillStyle = color;
                            if ((0, $gDIFj.default).isSmooth()) {
                                ctx.imageSmoothingEnabled = (0, $gDIFj.default).isSmooth();
                                if (!(0, $gDIFj.default).isFill()) {
                                    ctx.strokeStyle = color;
                                    ctx.lineWidth = (0, $gDIFj.default).getLineSize();
                                    isOdd = ctx.lineWidth % 2 === 1;
                                }
                                ctx.beginPath();
                                if (isOdd) ctx.translate(0.5, 0.5);
                                ctx.ellipse(cx, cy, wx, wh, 0, 0, 2 * Math.PI);
                                if (isOdd) ctx.translate(-0.5, -0.5);
                                if ((0, $gDIFj.default).isFill()) ctx.fill();
                                else ctx.stroke();
                            } else {
                                cx = Math.floor(cx);
                                cy = Math.floor(cy);
                                wx = Math.floor(wx);
                                wh = Math.floor(wh);
                                let isFill = (0, $gDIFj.default).isFill();
                                let size = (0, $gDIFj.default).getLineSize();
                                // calculate the size of the circle for 1 quadrant
                                // then scale it to fit the ellipse box
                                // then draw the other 3 quadrants
                                // ... does this make sense?
                                let r = Math.max(wx, wh);
                                let xScale = wx / r;
                                let yScale = wh / r;
                                // shift the quadrants if the width or height is even
                                let offsetX = 1 - w % 2;
                                let offsetY = 1 - h % 2;
                                for(let x = -r; x <= 0; x += 1)for(let y = -r; y <= 0; y += 1){
                                    let distance = Math.round(Math.sqrt(x * x + y * y));
                                    let _x = Math.floor(x * xScale);
                                    let _y = Math.floor(y * yScale);
                                    let draw = isFill ? distance <= r : distance === r;
                                    if (draw) {
                                        ctx.fillRect(cx + _x, cy + _y, size, size);
                                        ctx.fillRect(cx - _x - offsetX, cy + _y, size, size);
                                        ctx.fillRect(cx + _x, cy - _y - offsetY, size, size);
                                        ctx.fillRect(cx - _x - offsetX, cy - _y - offsetY, size, size);
                                    }
                                }
                            }
                        };
                        if (currentTool === (0, $k5ZAj.COMMAND).SQUARE) drawFunction = function(ctx, x, y, w, h, button) {
                            ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
                            let color = button ? (0, $eTCYn.default).getBackgroundColor() : (0, $eTCYn.default).getDrawColor();
                            if ((0, $gDIFj.default).isFill()) {
                                ctx.fillStyle = color;
                                ctx.fillRect(x, y, w, h);
                            } else {
                                ctx.strokeStyle = color;
                                ctx.lineWidth = (0, $gDIFj.default).getLineSize();
                                let isOdd = ctx.lineWidth % 2 === 1;
                                ctx.beginPath();
                                if (isOdd) ctx.translate(0.5, 0.5);
                                ctx.rect(x, y, w, h);
                                if (isOdd) ctx.translate(-0.5, -0.5);
                                ctx.closePath();
                                ctx.stroke();
                            }
                        };
                        resizer.setOnUpdate(()=>{
                            let box = resizer.get();
                            let w = box.width;
                            let h = box.height;
                            let x = box.left;
                            let y = box.top;
                            (0, $jU8Uk.default).getActiveLayer().drawShape(drawFunction, x, y, w, h);
                            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layerContentChanged);
                        });
                        break;
                    case (0, $k5ZAj.COMMAND).LINE:
                    case (0, $k5ZAj.COMMAND).GRADIENT:
                        // TODO move this as well to the drawLayer of the active layer ?
                        if (currentTool === (0, $k5ZAj.COMMAND).LINE && !isOnCanvas) return;
                        (0, $eZZbx.default).start((0, $k5ZAj.EVENT).layerContentHistory);
                        let layerIndex = (0, $jU8Uk.default).addLayer((0, $jU8Uk.default).getActiveLayerIndex() + 1);
                        let drawLayer = (0, $jU8Uk.default).getLayer(layerIndex);
                        touchData.hotDrawFunction = function(x, y) {
                            drawLayer.clear();
                            let ctx = drawLayer.getContext();
                            //let lineWidth = ToolOptions.getLineSize() / (window.devicePixelRatio || 1)
                            let lineWidth = (0, $gDIFj.default).getLineSize();
                            ctx.lineWidth = lineWidth;
                            ctx.lineCap = "square";
                            ctx.strokeStyle = (0, $eTCYn.default).getDrawColor();
                            ctx.imageSmoothingEnabled = false;
                            if ((0, $lkhKc.default).isShiftDown()) {
                                // snap to x or y axis
                                let w = Math.abs(x - point.x);
                                let h = Math.abs(y - point.y);
                                let ratio = Math.min(w / h, h / w);
                                if (ratio <= 1 && ratio > 0.5) {
                                    let d = Math.min(w, h);
                                    x = point.x + d * (x < point.x ? -1 : 1);
                                    y = point.y + d * (y < point.y ? -1 : 1);
                                } else if (w < h) x = point.x;
                                else y = point.y;
                            }
                            if (currentTool === (0, $k5ZAj.COMMAND).GRADIENT) {
                                ctx.strokeStyle = "black";
                                ctx.lineWidth = 2;
                                touchData.points = [
                                    point,
                                    {
                                        x: x,
                                        y: y
                                    }
                                ];
                            }
                            if ((0, $gDIFj.default).isSmooth()) {
                                let isOdd = ctx.lineWidth % 2 === 1;
                                if (isOdd) ctx.translate(.5, .5);
                                ctx.beginPath();
                                ctx.moveTo(point.x, point.y);
                                ctx.lineTo(x, y);
                                ctx.closePath();
                                ctx.stroke();
                                if (isOdd) ctx.translate(-0.5, -0.5);
                            } else bLine_(point.x, point.y, x, y, ctx, (0, $bfgOg.default).fromString((0, $eTCYn.default).getDrawColor()), lineWidth);
                            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layerContentChanged);
                        };
                        touchData.hotDrawDone = function() {
                            if (currentTool === (0, $k5ZAj.COMMAND).GRADIENT) {
                                //drawLayer.clear();
                                let drawLayer = (0, $jU8Uk.default).getLayer(layerIndex);
                                let ctx = drawLayer.getContext();
                                let p1 = touchData.points[0];
                                let p2 = touchData.points[1];
                                let w = ctx.canvas.width;
                                let h = ctx.canvas.height;
                                ctx.clearRect(0, 0, w, h);
                                let grd;
                                if ((0, $eZded.default).getDitherState()) {
                                    let gradientCanvas = (0, $9xub8.duplicateCanvas)(ctx.canvas);
                                    let gCtx = gradientCanvas.getContext("2d");
                                    grd = gCtx.createLinearGradient(p1.x, p1.y, p2.x, p2.y);
                                    grd.addColorStop(0, "white");
                                    grd.addColorStop(1, "black");
                                    gCtx.fillStyle = grd;
                                    gCtx.fillRect(0, 0, w, h);
                                    (0, $lPw7G.default).bayer(gCtx, 128, true);
                                    let fColor = (0, $eTCYn.default).getDrawColor();
                                    let bColor = (0, $eTCYn.default).getBackgroundColor();
                                    let patterCanvas = (0, $9xub8.duplicateCanvas)(ctx.canvas);
                                    let pCtx = patterCanvas.getContext("2d");
                                    if (fColor === "transparent") {
                                        pCtx.fillStyle = bColor;
                                        pCtx.fillRect(0, 0, w, h);
                                        pCtx.globalCompositeOperation = "destination-in";
                                        pCtx.drawImage(gradientCanvas, 0, 0);
                                        pCtx.globalCompositeOperation = "source-over";
                                        ctx.drawImage(patterCanvas, 0, 0);
                                    } else {
                                        pCtx.fillStyle = fColor;
                                        pCtx.fillRect(0, 0, w, h);
                                        pCtx.globalCompositeOperation = "destination-out";
                                        pCtx.drawImage(gradientCanvas, 0, 0);
                                        pCtx.globalCompositeOperation = "source-over";
                                        ctx.fillStyle = bColor;
                                        ctx.fillRect(0, 0, w, h);
                                        ctx.drawImage(patterCanvas, 0, 0);
                                    }
                                } else {
                                    grd = ctx.createLinearGradient(p1.x, p1.y, p2.x, p2.y);
                                    grd.addColorStop(0, (0, $eTCYn.default).getDrawColor());
                                    grd.addColorStop(1, (0, $eTCYn.default).getBackgroundColor());
                                    ctx.fillStyle = grd;
                                    ctx.fillRect(0, 0, w, h);
                                }
                                (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layerContentChanged);
                            }
                            // TODO: move this to the drawLayer of the active layer instead of a new layer
                            (0, $jU8Uk.default).mergeDown(layerIndex, true);
                            (0, $eZZbx.default).end((0, $k5ZAj.EVENT).layerContentHistory);
                        };
                        break;
                }
                break;
            case "up":
                if (touchData.isDrawing) {
                    let layer = touchData.drawLayer || (0, $jU8Uk.default).getActiveLayer();
                    layer.commitDraw();
                    (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layerContentChanged, {
                        commit: true
                    });
                }
                if (touchData.isSmudging) {
                    (0, $eZZbx.default).end();
                    (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layerContentChanged, {
                        commit: true
                    });
                }
                if (touchData.isSelecting) {
                    if (touchData.selection) {
                        //Selection.set(touchData.selection);
                        resizer.commit();
                        if (drawFunction) {
                            // we're not selectin but dragging/drawing a shape
                            (0, $jU8Uk.default).getActiveLayer().commitDraw();
                            drawFunction = undefined;
                            resizer.remove();
                            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layerContentChanged, {
                                commit: true
                            });
                            (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).CLEARSELECTION);
                        }
                    } else (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).CLEARSELECTION);
                }
                if (touchData.hotDrawFunction) {
                    touchData.hotDrawFunction = undefined;
                    if (touchData.hotDrawDone) touchData.hotDrawDone();
                }
                if (!(0, $lkhKc.default).isSpaceDown()) document.body.classList.remove("space");
                touchData.isdown = false;
                touchData.isDrawing = false;
                touchData.isSmudging = false;
                touchData.isSelecting = false;
                touchData.selection = undefined;
                touchData.previousDrawPoint = undefined;
                break;
            case "over":
                // mousemove with no click
                if (!touchData.isdown) {
                    if (e.pointerType === "touch") return;
                    point = getCursorPosition(canvas, e, false);
                    var pixel = ctx.getImageData(point.x, point.y, 1, 1).data;
                    let tooltip = "x:" + point.x + " y:" + point.y;
                    if (pixel[3]) tooltip += " r:" + pixel[0] + " g:" + pixel[1] + " b:" + pixel[2];
                    (0, $4eKVl.default).setToolTip(tooltip);
                    if (touchData.isPolySelect) selectBox.updatePoint(point);
                    else drawOverlay(point);
                }
                break;
            case "move":
                if ((0, $lkhKc.default).isMultiTouch()) return;
                // let the editPanel parent handle this for pan/zoom
                point = getCursorPosition(canvas, e, false);
                if (touchData.isdown) {
                    if ((0, $lkhKc.default).isSpaceDown() || touchData.button === 1 || (0, $2hBLH.default).getCurrentTool() === (0, $k5ZAj.COMMAND).PAN) {
                        var dx = touchData.startDragX - e.clientX;
                        var dy = touchData.startDragY - e.clientY;
                        let tx = touchData.startScrollX + dx;
                        let ty = touchData.startScrollY + dy;
                        panelParent.scrollLeft = tx;
                        panelParent.scrollTop = ty;
                        let fx = parseInt(panelParent.scrollLeft);
                        let fy = parseInt(panelParent.scrollTop);
                        if (fx !== tx) {
                            containerTransform.x = containerTransform.startX + fx - tx;
                            setContainer();
                        }
                        if (fy !== ty) {
                            containerTransform.y = containerTransform.startY + fy - ty;
                            setContainer();
                        }
                        return;
                    }
                    if (touchData.isPolySelect) {
                        selectBox.updatePoint(point);
                        return;
                    }
                    if (((0, $lkhKc.default).isShiftDown() || (0, $lkhKc.default).isAltDown()) && (0, $2hBLH.default).canPickColor()) {
                        var pixel = ctx.getImageData(point.x, point.y, 1, 1).data;
                        (0, $eTCYn.default).setColor(pixel, false, true);
                        return;
                    }
                    if (touchData.isDrawing) {
                        (0, $aEF6k.default).setPressure(e.pressure);
                        hideOverlay();
                        getCursorPosition(canvas, e, true);
                        draw();
                    }
                    if (touchData.isSmudging) {
                        hideOverlay();
                        getCursorPosition(canvas, e, true);
                        (0, $4UCrC.default).draw(touchData);
                    }
                    if (touchData.isSelecting) {
                        let w = point.x - touchData.x;
                        let h = point.y - touchData.y;
                        let x = touchData.x;
                        let y = touchData.y;
                        if (w < 0) {
                            x += w;
                            w = -w;
                        }
                        if (h < 0) {
                            y += h;
                            h = -h;
                        }
                        touchData.selection = {
                            left: x,
                            top: y,
                            width: w,
                            height: h
                        };
                        resizer.init({
                            x: x,
                            y: y,
                            width: w,
                            height: h
                        });
                    }
                    if (touchData.hotDrawFunction) touchData.hotDrawFunction(point.x, point.y);
                }
                break;
            case "scroll":
                break;
        }
    }
    function getCursorPosition(elm, event, persist) {
        const rect = elm.getBoundingClientRect();
        const x = Math.floor((event.clientX - rect.left) / zoom);
        const y = Math.floor((event.clientY - rect.top) / zoom);
        if (persist) {
            touchData.prevX = touchData.x;
            touchData.prevY = touchData.y;
            touchData.x = x;
            touchData.y = y;
        }
        return {
            x: x,
            y: y
        };
    }
    me.getCursorPosition = function(event) {
        return getCursorPosition(canvas, event);
    };
    function getElementPosition(el) {
        var rect = el.getBoundingClientRect(), scrollLeft = window.pageXOffset || document.documentElement.scrollLeft, scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return {
            top: rect.top + scrollTop,
            left: rect.left + scrollLeft
        };
    }
    function hideOverlay() {
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).hideCanvasOverlay);
    }
    function drawOverlay(point) {
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).drawCanvasOverlay, point);
    }
    function setContainer() {
        container.style.transform = "translate(" + containerTransform.x + "px," + containerTransform.y + "px)";
    }
    function resetContainer() {
        containerTransform.x = 0;
        containerTransform.y = 0;
        setContainer();
    }
    me.resetPan = function() {
        resetContainer();
        panelParent.scrollLeft = 0;
        panelParent.scrollTop = 0;
    };
    //Bresenham's_line_algorithm
    //http://rosettacode.org/wiki/Bitmap/Bresenham's_line_algorithm
    function bLine_(x0, y0, x1, y1, ctx, color, lineWidth) {
        let imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        let data1 = imgData.data;
        lineWidth = lineWidth || 1;
        if (lineWidth < 1) lineWidth = 1;
        var dx = Math.abs(x1 - x0), sx = x0 < x1 ? 1 : -1;
        var dy = Math.abs(y1 - y0), sy = y0 < y1 ? 1 : -1;
        var err = (dx > dy ? dx : -dy) / 2;
        let lineStart = 0 - Math.floor(lineWidth / 2);
        let lineEnd = parseInt(lineWidth) + lineStart;
        while(true){
            for(let i = lineStart; i < lineEnd; i++)for(let j = lineStart; j < lineEnd; j++)drawPixel(x0 + i, y0 + j);
            if (x0 === x1 && y0 === y1) break;
            var e2 = err;
            if (e2 > -dx) {
                err -= dy;
                x0 += sx;
            }
            if (e2 < dy) {
                err += dx;
                y0 += sy;
            }
        }
        ctx.putImageData(imgData, 0, 0);
        function drawPixel(x, y) {
            let n = (y * canvas.width + x) * 4;
            data1[n] = color[0];
            data1[n + 1] = color[1];
            data1[n + 2] = color[2];
            data1[n + 3] = 255;
        }
    }
    function bLine(x0, y0, x1, y1, ctx, color, thickness) {
        let dx = Math.abs(x1 - x0);
        let dy = Math.abs(y1 - y0);
        let sx = x0 < x1 ? 1 : -1;
        let sy = y0 < y1 ? 1 : -1;
        let err = dx - dy;
        let e2;
        let x = x0;
        let y = y0;
        let angle = Math.atan2(dy, dx);
        let thicknessX = thickness * Math.cos(angle);
        let thicknessY = thickness * Math.sin(angle);
        //color = "black";
        while(true){
            for(let i = Math.floor(-thicknessX / 2); i <= Math.ceil(thicknessX / 2); i++)for(let j = Math.floor(-thicknessY / 2); j <= Math.ceil(thicknessY / 2); j++){
                let xi = Math.round(x + i * Math.cos(angle) - j * Math.sin(angle));
                let yi = Math.round(y + i * Math.sin(angle) + j * Math.cos(angle));
                ctx.fillStyle = color;
                ctx.fillRect(xi, yi, 1, 1);
            }
            if (x == x1 && y == y1) break;
            e2 = err * 2;
            if (e2 > -dy) {
                err -= dy;
                x += sx;
            }
            if (e2 < dx) {
                err += dx;
                y += sy;
            }
        }
        function drawPixel(x, y) {
            let n = (y * canvas.width + x) * 4;
            data[n] = color[0];
            data[n + 1] = color[1];
            data[n + 2] = color[2];
            data[n + 3] = 255;
        }
    }
    return me;
};
var $b648873c4b7cfb64$export$2e2bcd8739ae039 = $b648873c4b7cfb64$var$Canvas;

});
parcelRegister("aEF6k", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c1d85a23ec30cc8$export$2e2bcd8739ae039);

var $eJ26Q = parcelRequire("eJ26Q");

var $9dDG4 = parcelRequire("9dDG4");

var $k5ZAj = parcelRequire("k5ZAj");

var $eTCYn = parcelRequire("eTCYn");

var $bfgOg = parcelRequire("bfgOg");

var $2hBLH = parcelRequire("2hBLH");

var $jU8Uk = parcelRequire("jU8Uk");

var $gDIFj = parcelRequire("gDIFj");
var $7c1d85a23ec30cc8$var$Brush = function() {
    var me = {};
    var container;
    var width = 1;
    var height = 1;
    var brushType = "square";
    var presets = [];
    var brushIndex = 0;
    let dynamicSettings;
    let opacity = 100;
    let pressure = 1;
    var brushCanvas = document.createElement("canvas");
    var brushBackCanvas = document.createElement("canvas");
    let brushCtx = brushCanvas.getContext("2d");
    let brushBackCtx = brushBackCanvas.getContext("2d");
    me.init = function(parent) {
        container = (0, $eJ26Q.$div)("brushes info", "", parent);
        container.info = "Select the brush for drawing";
        for(var i = 0; i < 10; i++){
            let b = (0, $eJ26Q.$div)("brush", "", container, (e)=>{
                let index = e.target.index || 0;
                me.set("preset", index);
                let currentTool = (0, $2hBLH.default).getCurrentTool();
                if (!(currentTool === (0, $k5ZAj.COMMAND).DRAW || currentTool === (0, $k5ZAj.COMMAND).ERASE)) (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).DRAW);
            });
            let x = -(i % 5) * 11 + "px";
            let y = Math.floor(i / 5) * -11 + "px";
            b.style.backgroundPosition = x + " " + y;
            b.index = i;
            if (!i) b.classList.add("active");
            presets.push(b);
        }
        (0, $9dDG4.default).on((0, $k5ZAj.EVENT).drawColorChanged, ()=>{
            if (brushType === "canvas" && brushIndex >= 0) generateBrush();
        });
        (0, $9dDG4.default).on((0, $k5ZAj.EVENT).backgroundColorChanged, ()=>{
            if (brushType === "canvas" && brushIndex >= 0) generateBrush();
        });
    };
    me.get = function() {};
    me.getOpacity = ()=>{
        return opacity / 100;
    };
    me.getSettings = ()=>{
        let settings = {
            width: width,
            height: height,
            opacity: opacity
        };
        if (dynamicSettings) settings.softness = dynamicSettings.softness;
        return settings;
    };
    me.set = function(type, index) {
        if (type === "preset") {
            presets.forEach((b, i)=>{
                b.classList.toggle("active", i === index);
            });
            brushIndex = index;
            switch(index){
                case 0:
                    brushType = "square";
                    width = height = 1;
                    break;
                case 1:
                case 2:
                case 3:
                case 4:
                    brushType = "canvas";
                    let size = index * 2 + 1;
                    if (brushIndex === 3) size = 5;
                    if (brushIndex === 4) size = 7;
                    width = height = size;
                    generateBrush();
                    break;
                case 5:
                case 6:
                case 7:
                case 8:
                    brushType = "square";
                    width = height = (9 - index) * 2 + 1;
                    break;
                case 9:
                    brushType = "canvas";
                    width = height = 7;
                    generateBrush();
                    break;
            }
        }
        if (type === "canvas") {
            brushType = type;
            brushIndex = -1;
            brushCanvas.width = brushBackCanvas.width = index.width;
            brushCanvas.height = brushBackCanvas.height = index.height;
            brushCtx.clearRect(0, 0, brushCanvas.width, brushCanvas.height);
            brushCtx.drawImage(index, 0, 0);
            brushBackCtx.clearRect(0, 0, brushCanvas.width, brushCanvas.height);
            brushBackCtx.drawImage(index, 0, 0);
        // TODO: What do we draw when grabbing a stencil with right-click draw ?
        }
        if (type === "dynamic") {
            width = index.width;
            height = index.height;
            opacity = index.opacity || 100;
            if (!index.softness) brushType = "square";
            else {
                brushIndex = 100;
                brushType = "canvas";
                dynamicSettings = index;
                generateBrush();
            }
        }
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).brushOptionsChanged);
    };
    me.setPressure = (p)=>{
        pressure = p;
    };
    me.getPressure = ()=>{
        return pressure;
    };
    me.draw = function(ctx, x, y, color, onBackground, blendColor) {
        let w, h, p;
        let useCustomBlend = blendColor && (0, $eTCYn.default).isLocked();
        let useOpacity = (0, $gDIFj.default).usePressure() && !useCustomBlend;
        let finalColor = color;
        if (brushType === "canvas") {
            w = brushCanvas.width;
            h = brushCanvas.height;
        } else {
            w = width;
            h = height;
        }
        if (w > 1) x -= Math.floor((w - 1) / 2);
        if (h > 1) y -= Math.floor((h - 1) / 2);
        if (useOpacity) {
            p = ctx.globalAlpha;
            ctx.globalAlpha = pressure;
        }
        if (brushType === "canvas") {
            if (onBackground) ctx.drawImage(brushBackCanvas, x, y);
            else ctx.drawImage(brushCanvas, x, y);
        } else if (blendColor && (0, $eTCYn.default).isLocked()) {
            let c = (0, $bfgOg.default).fromString(color);
            let imageCtx = (0, $jU8Uk.default).getContext();
            let data = imageCtx.getImageData(x, y, w, h);
            let opacity2 = opacity / 100;
            if ((0, $gDIFj.default).usePressure()) opacity2 *= pressure;
            for(let i = 0; i < data.data.length; i += 4){
                let sourceColor = [
                    data.data[i],
                    data.data[i + 1],
                    data.data[i + 2]
                ];
                let targetColor = (0, $bfgOg.default).blend(sourceColor, c, opacity2);
                finalColor = (0, $eTCYn.default).matchColor(targetColor);
                console.log(sourceColor, finalColor);
                if ((0, $bfgOg.default).equals(sourceColor, finalColor) && !(0, $bfgOg.default).equals(sourceColor, c)) {
                    opacity2 *= 1.5;
                    if (opacity2 > 1) opacity2 = 1;
                    targetColor = (0, $bfgOg.default).blend(sourceColor, c, opacity2);
                    finalColor = (0, $eTCYn.default).matchColor(targetColor);
                }
                data.data[i] = finalColor[0];
                data.data[i + 1] = finalColor[1];
                data.data[i + 2] = finalColor[2];
                data.data[i + 3] = 255;
            }
            ctx.putImageData(data, x, y);
        } else {
            ctx.fillStyle = color;
            ctx.fillRect(x, y, w, h);
        }
        if (useOpacity) ctx.globalAlpha = p;
        return {
            x: x,
            y: y,
            width: w,
            height: h,
            color: finalColor
        };
    };
    function generateBrush() {
        brushCanvas.width = brushBackCanvas.width = width;
        brushCanvas.height = brushBackCanvas.height = height;
        brushCtx.clearRect(0, 0, width, height);
        brushCtx.fillStyle = (0, $eTCYn.default).getDrawColor();
        switch(brushIndex){
            case 1:
                brushCtx.fillRect(0, 1, 3, 1);
                brushCtx.fillRect(1, 0, 1, 3);
                break;
            case 2:
                brushCtx.fillRect(0, 2, 5, 1);
                brushCtx.fillRect(2, 0, 1, 5);
                brushCtx.fillRect(1, 1, 3, 3);
                break;
            case 3:
                brushCtx.fillRect(0, 1, 5, 3);
                brushCtx.fillRect(1, 0, 3, 5);
                break;
            case 4:
                brushCtx.fillRect(0, 2, 7, 3);
                brushCtx.fillRect(2, 0, 3, 7);
                brushCtx.fillRect(1, 1, 5, 5);
                break;
            case 9:
                brushCtx.fillRect(2, 0, 1, 1);
                for(var y = 1; y < 6; y++){
                    var c = 0;
                    if (y % 2 === 1) c = 1;
                    if (y === 4) c = 2;
                    for(var x = 0; x < 5; x += 2)brushCtx.fillRect(x + c, y, 1, 1);
                }
                brushCtx.fillRect(4, 6, 1, 1);
                break;
            case 100:
                // dynamic Brush
                let cx = dynamicSettings.width / 2;
                let cy = dynamicSettings.height / 2;
                let wx = dynamicSettings.width / 2;
                let wh = dynamicSettings.height / 2;
                let color = (0, $eTCYn.default).getDrawColor();
                if (color === "transparent") color = "black";
                brushCtx.fillStyle = color;
                if (dynamicSettings.softness) {
                    let opacityStep = 1 / wx / dynamicSettings.softness;
                    let opacity = opacityStep;
                    let c = (0, $bfgOg.default).fromString((0, $eTCYn.default).getDrawColor());
                    for(let radius1 = wx; radius1 > 0; radius1--){
                        brushCtx.globalAlpha = Math.min(opacity, 1);
                        brushCtx.beginPath();
                        brushCtx.ellipse(cx, cy, radius1, radius1, 0, 0, 2 * Math.PI);
                        brushCtx.fill();
                        opacity += opacityStep;
                    }
                    // hmm... this doesn't preserve the color 100%
                    // reset color
                    // TODO: better way of generating transparent brushes;
                    let data = brushCtx.getImageData(0, 0, width, height);
                    let d = data.data;
                    for(let i = 0, max = d.length; i < max; i += 4){
                        d[i] = c[0];
                        d[i + 1] = c[1];
                        d[i + 2] = c[2];
                    }
                    brushCtx.putImageData(data, 0, 0);
                } else {
                    brushCtx.beginPath();
                    brushCtx.ellipse(cx, cy, radius, radius, 0, 0, 2 * Math.PI);
                    brushCtx.fill();
                }
                brushCtx.globalAlpha = 1;
            default:
                break;
        }
        brushBackCtx.fillStyle = (0, $eTCYn.default).getBackgroundColor();
        brushBackCtx.fillRect(0, 0, width, height);
        brushBackCtx.globalCompositeOperation = "destination-in";
        brushBackCtx.drawImage(brushCanvas, 0, 0);
        brushBackCtx.globalCompositeOperation = "source-over";
    }
    return me;
}();
var $7c1d85a23ec30cc8$export$2e2bcd8739ae039 = $7c1d85a23ec30cc8$var$Brush;

});
parcelRegister("gDIFj", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1d2ef7bbd24dfc6$export$2e2bcd8739ae039);

var $eJ26Q = parcelRequire("eJ26Q");

var $k5ZAj = parcelRequire("k5ZAj");

var $9dDG4 = parcelRequire("9dDG4");

var $jU8Uk = parcelRequire("jU8Uk");

var $j2Icj = parcelRequire("j2Icj");

var $aEF6k = parcelRequire("aEF6k");

var $eZded = parcelRequire("eZded");
let $c1d2ef7bbd24dfc6$var$ToolOptions = function() {
    let me = {};
    let smooth = false;
    let fill = false;
    let lineSize = 1;
    let tolerance = 0;
    let mask = false;
    let selectionOutline = true;
    let selectionMask = false;
    let pressure = false;
    let smoothCheckbox;
    let maskCheckbox;
    let selectSection;
    let selectionOutlineCheckbox;
    let selectionMaskCheckbox;
    let ditherSection;
    let ditherCheckbox;
    let invertCheckbox;
    let pressureCheckbox;
    let fillCheckbox;
    let lineSizeRange;
    let toleranceRange;
    let brushOptionGroup;
    let brushSettings = {};
    me.isSmooth = ()=>{
        return smooth;
    };
    me.isFill = ()=>{
        return fill;
    };
    me.showMask = ()=>{
        return mask;
    };
    me.showSelectionOutline = ()=>{
        return selectionOutline;
    };
    me.showSelectionMask = ()=>{
        return selectionMask;
    };
    me.usePressure = ()=>{
        return pressure;
    };
    me.setFill = (state)=>{
        fill = !!state;
        if (fillCheckbox) {
            let cb = fillCheckbox.querySelector("input");
            if (cb) cb.checked = fill;
        }
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).toolOptionsChanged);
    };
    me.getLineSize = ()=>{
        return lineSize;
    };
    me.getTolerance = ()=>{
        return tolerance;
    };
    me.getOptions = (command)=>{
        let options = (0, $eJ26Q.$div)("options");
        switch(command){
            case (0, $k5ZAj.COMMAND).DRAW:
                options.appendChild(label("Brush:"));
                options.appendChild(brushSetting());
                options.appendChild(ditherSetting());
                options.appendChild(pressureSetting());
                break;
            case (0, $k5ZAj.COMMAND).SMUDGE:
                options.appendChild(label("Brush:"));
                options.appendChild(brushSetting());
                break;
            case (0, $k5ZAj.COMMAND).LINE:
                options.appendChild(label("Line:"));
                options.appendChild(smoothSetting());
                options.appendChild(lineSetting());
                break;
            case (0, $k5ZAj.COMMAND).SQUARE:
                options.appendChild(label("Rectangle:"));
                options.appendChild(fillSetting());
                options.appendChild(lineSetting());
                break;
            case (0, $k5ZAj.COMMAND).CIRCLE:
                options.appendChild(label("Circle:"));
                options.appendChild(fillSetting());
                options.appendChild(smoothSetting());
                options.appendChild(lineSetting());
                break;
            case (0, $k5ZAj.COMMAND).GRADIENT:
                options.appendChild(label("Gradient:"));
                options.appendChild(ditherSetting());
                break;
            case (0, $k5ZAj.COMMAND).SELECT:
            case (0, $k5ZAj.COMMAND).POLYGONSELECT:
            case (0, $k5ZAj.COMMAND).FLOODSELECT:
                options.appendChild(selectSetting());
                if (command === (0, $k5ZAj.COMMAND).FLOODSELECT) options.appendChild(toleranceSetting());
                break;
            case (0, $k5ZAj.COMMAND).FLOOD:
                options.appendChild(toleranceSetting());
                break;
        }
        let activeLayer = (0, $jU8Uk.default).getActiveLayer();
        if (activeLayer.isMaskActive()) options.appendChild(maskSetting());
        return options;
    };
    function smoothSetting() {
        if (!smoothCheckbox) smoothCheckbox = (0, $eJ26Q.$checkbox)("Smooth", "", "", (checked)=>{
            smooth = checked;
        });
        return smoothCheckbox;
    }
    function fillSetting() {
        if (!fillCheckbox) fillCheckbox = (0, $eJ26Q.$checkbox)("Fill", "", "", (checked)=>{
            fill = checked;
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).toolOptionsChanged);
        });
        return fillCheckbox;
    }
    function lineSetting() {
        if (!lineSizeRange) {
            lineSizeRange = (0, $eJ26Q.$div)("range");
            (0, $eJ26Q.$elm)("label", "Size:", lineSizeRange);
            let range = document.createElement("input");
            range.type = "range";
            range.min = 1;
            range.max = 10;
            range.value = 1;
            lineSizeRange.appendChild(range);
            let value = (0, $eJ26Q.$elm)("span", "1px", lineSizeRange);
            range.oninput = function() {
                value.innerText = range.value + "px";
                lineSize = range.value;
            };
        }
        return lineSizeRange;
    }
    function brushSetting() {
        if (!brushOptionGroup) {
            let settings = (0, $aEF6k.default).getSettings();
            brushOptionGroup = (0, $eJ26Q.$div)("optionsgroup");
            let brushSizeRange = (0, $eJ26Q.$div)("range", "", brushOptionGroup);
            (0, $eJ26Q.$elm)("label", "Size:", brushSizeRange);
            brushSettings.sizeRange = (0, $eJ26Q.$input)("range", settings.width, brushSizeRange);
            brushSettings.sizeRange.min = 1;
            brushSettings.sizeRange.max = 100;
            brushSettings.sizeInput = (0, $eJ26Q.$elm)("span", settings.width + "px", brushSizeRange);
            brushSettings.sizeRange.oninput = function() {
                (0, $j2Icj.default).set({
                    size: brushSettings.sizeRange.value
                });
            };
            let brushOpacityRange = (0, $eJ26Q.$div)("range", "", brushOptionGroup);
            (0, $eJ26Q.$elm)("label", "Opacity:", brushOpacityRange, "inline");
            brushSettings.opacityRange = (0, $eJ26Q.$input)("range", settings.opacity, brushOpacityRange);
            brushSettings.opacityRange.min = 1;
            brushSettings.opacityRange.max = 100;
            brushSettings.opacityInput = (0, $eJ26Q.$elm)("span", settings.opacity + "%", brushOpacityRange);
            brushSettings.opacityRange.oninput = function() {
                (0, $j2Icj.default).set({
                    opacity: brushSettings.opacityRange.value
                });
            };
            (0, $9dDG4.default).on((0, $k5ZAj.EVENT).brushOptionsChanged, ()=>{
                let settings = (0, $aEF6k.default).getSettings();
                brushSettings.sizeRange.value = settings.width;
                brushSettings.sizeInput.innerText = settings.width + "px";
                brushSettings.opacityRange.value = settings.opacity;
                brushSettings.opacityInput.innerText = settings.opacity + "%";
                if (ditherCheckbox) ditherCheckbox.setState((0, $eZded.default).getDitherState());
                if (invertCheckbox) invertCheckbox.setState((0, $eZded.default).getDitherInvertState());
            });
        }
        return brushOptionGroup;
    }
    function maskSetting() {
        if (!maskCheckbox) maskCheckbox = (0, $eJ26Q.$checkbox)("Show Mask", "", "mask", (checked)=>{
            mask = checked;
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layerContentChanged);
        });
        return maskCheckbox;
    }
    function selectSetting() {
        if (!selectSection) {
            selectSection = (0, $eJ26Q.$div)("optionsgroup");
            selectionMaskCheckbox = (0, $eJ26Q.$checkbox)("Show Mask", selectSection, "mask", (checked)=>{
                selectionMask = checked;
                (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).selectionChanged);
            });
            selectionOutlineCheckbox = (0, $eJ26Q.$checkbox)("Show Outline", selectSection, "", (checked)=>{
                selectionOutline = checked;
                (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).selectionChanged);
            });
        }
        selectionOutlineCheckbox.setState(selectionOutline);
        selectionMaskCheckbox.setState(selectionMask);
        return selectSection;
    }
    function ditherSetting() {
        if (!ditherSection) {
            ditherSection = (0, $eJ26Q.$div)("inline flex");
            ditherCheckbox = (0, $eJ26Q.$checkbox)("Dither", ditherSection, "inline info", (checked)=>{
                (0, $eZded.default).setDitherState(checked);
            });
            ditherCheckbox.info = "Toggle Brush Dither Pattern";
            invertCheckbox = (0, $eJ26Q.$checkbox)("Invert", ditherSection, "info", (checked)=>{
                (0, $eZded.default).setDitherInvertState(checked);
            });
            invertCheckbox.info = "<b>I</b> Invert Brush Dither Pattern";
        }
        ditherCheckbox.setState((0, $eZded.default).getDitherState());
        invertCheckbox.setState((0, $eZded.default).getDitherInvertState());
        return ditherSection;
    }
    function pressureSetting() {
        if (!pressureCheckbox) pressureCheckbox = (0, $eJ26Q.$checkbox)("Pressure", "", "pressure info", (checked)=>{
            pressure = checked;
        });
        pressureCheckbox.info = "Toggle brush pressure sensitivity";
        pressureCheckbox.setState(pressure);
        return pressureCheckbox;
    }
    function toleranceSetting() {
        if (!toleranceRange) {
            toleranceRange = (0, $eJ26Q.$div)("range");
            (0, $eJ26Q.$elm)("label", "Tolerance:", toleranceRange);
            let range = document.createElement("input");
            range.type = "range";
            range.min = 0;
            range.max = 100;
            range.value = 0;
            toleranceRange.appendChild(range);
            let value = (0, $eJ26Q.$elm)("span", "0", toleranceRange);
            range.oninput = function() {
                value.innerText = range.value;
                tolerance = range.value;
            };
        }
        return toleranceRange;
    }
    function label(text) {
        let label = document.createElement("span");
        label.className = "tool";
        label.innerText = text;
        return label;
    }
    function lineWidthSetting() {}
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).TOGGLEMASK, ()=>{
        mask = !mask;
        if (window.override) mask = false;
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layerContentChanged);
    });
    return me;
}();
var $c1d2ef7bbd24dfc6$export$2e2bcd8739ae039 = $c1d2ef7bbd24dfc6$var$ToolOptions;

});
parcelRegister("j2Icj", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddd07cf64f9d0c8e$export$2e2bcd8739ae039);

var $eJ26Q = parcelRequire("eJ26Q");

var $aEF6k = parcelRequire("aEF6k");

var $9dDG4 = parcelRequire("9dDG4");

var $k5ZAj = parcelRequire("k5ZAj");

var $eZded = parcelRequire("eZded");

var $8FLxR = parcelRequire("8FLxR");
let $ddd07cf64f9d0c8e$var$BrushPanel = function() {
    let me = {};
    let sizeRange;
    let sizeInput;
    let softRange;
    let opacityRange;
    let opacityInput;
    let ditherPatterns = [];
    me.generate = (parent)=>{
        let sizeSelect = (0, $eJ26Q.$div)("rangeselect", "", parent);
        (0, $eJ26Q.$elm)("label", "Size", sizeSelect);
        sizeRange = (0, $eJ26Q.$input)("range", 0, sizeSelect, ()=>{
            update();
        });
        sizeInput = (0, $eJ26Q.$input)("text", 1, sizeSelect);
        sizeRange.min = 1;
        sanitize(sizeInput, sizeRange);
        let softSelect = (0, $eJ26Q.$div)("rangeselect", "", parent);
        (0, $eJ26Q.$elm)("label", "Softness", softSelect);
        softRange = (0, $eJ26Q.$input)("range", 0, softSelect, ()=>{
            update();
            softInput.value = softRange.value;
        });
        let softInput = (0, $eJ26Q.$input)("text", 0, softSelect);
        softRange.max = 10;
        sanitize(softInput, softRange);
        let opacitySelect = (0, $eJ26Q.$div)("rangeselect", "", parent);
        (0, $eJ26Q.$elm)("label", "Opacity", opacitySelect);
        opacityRange = (0, $eJ26Q.$input)("range", 100, opacitySelect, ()=>{
            update();
        });
        opacityInput = (0, $eJ26Q.$input)("text", 100, opacitySelect);
        opacityRange.min = 1;
        sanitize(opacityInput, opacityRange);
        let ditherPanel = (0, $eJ26Q.$div)("dither", "", parent);
        (0, $eJ26Q.$elm)("label", "Dither", ditherPanel);
        let patterns = (0, $eJ26Q.$div)("patterns", "", ditherPanel);
        ditherPatterns = [];
        for(let i = 0; i < 5; i++){
            let hasPattern = i < 4 && i > 0 ? " hasPattern" : "";
            ditherPatterns.push((0, $eJ26Q.$div)("pattern p" + i + hasPattern, "", patterns, ()=>{
                if (i === 4) (0, $8FLxR.default).show((0, $8FLxR.DIALOG).DITHER);
                else (0, $eZded.default).setDitherPattern(i);
            }));
        }
        ditherPatterns[0].classList.add("active");
    };
    function update() {
        let size = parseInt(sizeRange.value);
        let soft = parseInt(softRange.value);
        let opacity = parseInt(opacityRange.value);
        (0, $aEF6k.default).set("dynamic", {
            width: size,
            height: size,
            softness: soft,
            opacity: opacity
        });
    }
    me.set = function(settings) {
        let doUpdate = false;
        if (settings.size) {
            sizeRange.value = settings.size;
            doUpdate = true;
        }
        if (settings.opacity) {
            opacityRange.value = settings.opacity;
            doUpdate = true;
        }
        if (doUpdate) update();
    };
    function sanitize(input, range) {
        range.min = range.min || 0;
        range.max = range.max || 100;
        input.onkeydown = (e)=>{
            e.stopPropagation();
        };
        input.oninput = (e)=>{
            let val = parseInt(input.value);
            if (isNaN(val)) val = range.min;
            if (val < range.min) val = range.min;
            if (val > range.max) val = range.max;
            range.value = val;
            update();
        };
    }
    (0, $9dDG4.default).on((0, $k5ZAj.EVENT).brushOptionsChanged, ()=>{
        let settings = (0, $aEF6k.default).getSettings();
        sizeRange.value = settings.width;
        sizeInput.value = settings.width;
        opacityRange.value = settings.opacity;
        opacityInput.value = settings.opacity;
        let invert = (0, $eZded.default).getDitherInvertState();
        ditherPatterns.forEach((elm)=>{
            elm.classList.remove("active");
            elm.classList.toggle("invert", invert);
        });
        let ditherIndex = (0, $eZded.default).getDitherIndex();
        let elm = ditherPatterns[ditherIndex];
        if (elm) elm.classList.add("active");
    });
    return me;
}();
var $ddd07cf64f9d0c8e$export$2e2bcd8739ae039 = $ddd07cf64f9d0c8e$var$BrushPanel;

});
parcelRegister("eZded", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae9106079ee11a8e$export$2e2bcd8739ae039);

var $jU8Uk = parcelRequire("jU8Uk");

var $9dDG4 = parcelRequire("9dDG4");

var $k5ZAj = parcelRequire("k5ZAj");
let $ae9106079ee11a8e$var$DitherPanel = function() {
    let me = {};
    let ditherPattern;
    let ditherCtx;
    let dither;
    let invert = false;
    let ditherIndex = 3;
    let patternCanvas = document.createElement("canvas");
    patternCanvas.width = 4;
    patternCanvas.height = 4;
    let patterns = [
        [
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            0
        ],
        [
            0,
            1,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            1,
            0
        ],
        [
            0,
            1,
            0,
            1,
            1,
            0,
            1,
            0,
            0,
            1,
            0,
            1,
            1,
            0,
            1,
            0
        ],
        [
            0,
            1,
            0,
            1,
            1,
            1,
            1,
            0,
            0,
            1,
            0,
            1,
            1,
            0,
            1,
            1
        ],
        [
            1,
            1,
            1,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            1,
            1,
            0,
            0,
            0,
            0
        ],
        [
            1,
            0,
            1,
            0,
            1,
            0,
            1,
            0,
            1,
            0,
            1,
            0,
            1,
            0,
            1,
            0
        ],
        [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ],
        [
            1,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            1,
            1,
            0,
            0,
            0,
            0,
            1,
            1
        ]
    ];
    me.getDitherPattern = ()=>{
        if (!ditherPattern) generateDitherPattern();
        return ditherPattern;
    };
    me.setDitherPattern = (pattern)=>{
        dither = !!pattern;
        if (dither) {
            if (typeof pattern === "number") {
                ditherIndex = pattern;
                generateDitherPattern();
            }
            if (typeof pattern === "object") generateDitherPattern(pattern);
        }
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).brushOptionsChanged);
    };
    me.setDitherState = (state)=>{
        dither = !!state;
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).brushOptionsChanged);
    };
    me.getDitherState = ()=>{
        return dither;
    };
    me.setDitherInvertState = (state)=>{
        invert = !!state;
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).brushOptionsChanged);
        ditherPattern = undefined;
    };
    me.getDitherInvertState = ()=>{
        return invert;
    };
    me.getDitherIndex = ()=>{
        return dither ? ditherIndex : 0;
    };
    function generateDitherPattern(fromCanvas) {
        if (!ditherPattern) {
            ditherPattern = document.createElement("canvas");
            ditherPattern.width = (0, $jU8Uk.default).getCurrentFile().width;
            ditherPattern.height = (0, $jU8Uk.default).getCurrentFile().height;
            ditherCtx = ditherPattern.getContext("2d");
        }
        ditherCtx.clearRect(0, 0, ditherPattern.width, ditherPattern.height);
        let pCtx = patternCanvas.getContext("2d");
        if (fromCanvas) {
            let s = fromCanvas.width;
            patternCanvas.width = s;
            patternCanvas.height = s;
            pCtx.clearRect(0, 0, s, s);
            pCtx.drawImage(fromCanvas, 0, 0);
        } else {
            let grid = patterns[ditherIndex - 1];
            let s = grid.length === 9 ? 3 : 4;
            patternCanvas.width = s;
            patternCanvas.height = s;
            pCtx.clearRect(0, 0, s, s);
            pCtx.fillStyle = "black";
            for(let y = 0; y < s; y++)for(let x = 0; x < s; x++){
                let i = y * s + x;
                let isBlack = !!grid[i];
                if (invert) isBlack = !isBlack;
                if (isBlack) pCtx.fillRect(x, y, 1, 1);
            }
        }
        ditherCtx.fillStyle = ditherCtx.createPattern(patternCanvas, "repeat");
        ditherCtx.fillRect(0, 0, ditherPattern.width, ditherPattern.height);
    }
    me.getPreset = function(index) {
        return patterns[index];
    };
    (0, $9dDG4.default).on((0, $k5ZAj.EVENT).imageSizeChanged, ()=>{
        ditherPattern = undefined;
    });
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).TOGGLEINVERT, ()=>{
        invert = !invert;
        ditherPattern = undefined;
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).brushOptionsChanged);
    });
    return me;
}();
var $ae9106079ee11a8e$export$2e2bcd8739ae039 = $ae9106079ee11a8e$var$DitherPanel;

});

parcelRegister("8FLxR", function(module, exports) {

$parcel$export(module.exports, "DIALOG", () => $6507088e91962c14$export$f99739dbfcd2e015);
$parcel$export(module.exports, "default", () => $6507088e91962c14$export$2e2bcd8739ae039);

var $eJ26Q = parcelRequire("eJ26Q");

var $4sZF5 = parcelRequire("4sZF5");

var $lkhKc = parcelRequire("lkhKc");

var $e0HvT = parcelRequire("e0HvT");

var $4QD11 = parcelRequire("4QD11");

var $7OdK5 = parcelRequire("7OdK5");

var $7nqci = parcelRequire("7nqci");

var $jR9CC = parcelRequire("jR9CC");

var $9ARHe = parcelRequire("9ARHe");

var $9nXmJ = parcelRequire("9nXmJ");
parcelRequire("2hBLH");
let $6507088e91962c14$export$f99739dbfcd2e015 = {
    SAVE: 1,
    RESIZE: 2,
    RESAMPLE: 3,
    PALETTE: 4,
    EFFECTS: 5,
    ABOUT: 6,
    DITHER: 7,
    OPTION: 8
};
var $6507088e91962c14$var$Modal = function() {
    let me = {};
    let blanket;
    let modalWindow;
    let caption;
    let inner;
    let currentTranslate = [
        0,
        0
    ];
    let currentDialog;
    let notification;
    let dialogs = {
        1: {
            title: "Save File",
            fuzzy: true,
            width: 400,
            height: "auto",
            handler: (0, $e0HvT.default),
            position: [
                0,
                0
            ]
        },
        2: {
            title: "Canvas Size",
            fuzzy: true,
            handler: (0, $4QD11.default),
            position: [
                0,
                0
            ],
            width: 406,
            height: 220
        },
        3: {
            title: "Image Size",
            fuzzy: true,
            handler: (0, $7OdK5.default),
            position: [
                0,
                0
            ],
            width: 326,
            height: 220
        },
        4: {
            title: "Palette Editor",
            handler: (0, $7nqci.default),
            width: 450,
            height: 304,
            position: [
                0,
                0
            ]
        },
        5: {
            title: "Effects",
            handler: (0, $jR9CC.default),
            position: [
                0,
                0
            ],
            width: 500,
            height: 530
        },
        6: {
            title: "About",
            action: showAbout,
            position: [
                0,
                0
            ],
            width: 750,
            height: 470
        },
        7: {
            title: "DitherPattern",
            handler: (0, $9ARHe.default),
            position: [
                0,
                0
            ],
            width: 662,
            height: 326
        },
        8: {
            title: "Request",
            fuzzy: true,
            handler: (0, $9nXmJ.default),
            position: [
                0,
                0
            ],
            width: 300,
            height: "auto"
        }
    };
    me.show = function(type, data) {
        data = data || {};
        let dialog = dialogs[type];
        if (dialog && dialog.fuzzy) {
            (0, $4sZF5.default).fuzzy(true);
            me.showBlanket();
        }
        if (!modalWindow) {
            modalWindow = (0, $eJ26Q.$div)("modalwindow", "", document.body);
            let titleBar = (0, $eJ26Q.$div)("caption", "", modalWindow);
            caption = (0, $eJ26Q.$div)("handle", "Title", titleBar);
            (0, $eJ26Q.$div)("button", "x", titleBar, ()=>{
                me.hide();
            });
            inner = (0, $eJ26Q.$div)("inner", "", modalWindow);
            caption.onDrag = function(x, y) {
                x += currentDialog.position[0];
                y += currentDialog.position[1];
                currentTranslate = [
                    x,
                    y
                ];
                modalWindow.style.transform = "translate(" + x + "px," + y + "px)";
            };
            caption.onDragEnd = function() {
                currentDialog.position = [
                    currentTranslate[0],
                    currentTranslate[1]
                ];
            };
        }
        modalWindow.classList.add("active");
        (0, $lkhKc.default).setActiveKeyHandler(keyHandler);
        if (dialog) {
            let width = data.width || dialog.width || 440;
            let height = data.height || dialog.height || 260;
            let maxWidth = window.innerWidth - 20;
            let maxHeight = window.innerHeight - 20;
            if (width > maxWidth) width = maxWidth;
            if (height > maxHeight) height = maxHeight;
            modalWindow.style.width = width + "px";
            modalWindow.style.height = height + "px";
            let top = "calc(50vh - " + (height >> 1) + "px)";
            if (height === "auto") {
                modalWindow.style.height = "auto";
                top = "calc(50vh - 150px)";
                inner.classList.remove("full");
            } else inner.classList.add("full");
            modalWindow.style.top = top;
            modalWindow.style.marginLeft = -(width >> 1) + "px";
            currentDialog = dialog;
            let x = currentDialog.position[0];
            let y = currentDialog.position[1];
            modalWindow.style.transform = "translate(" + x + "px," + y + "px)";
            caption.innerHTML = data.title || dialog.title;
            if (dialog.handler) dialog.handler.render(inner, me, data);
            if (dialog.action) dialog.action(data);
        } else console.error("no handler");
    };
    me.hide = function() {
        (0, $4sZF5.default).fuzzy(false);
        me.hideBlanket();
        if (modalWindow) modalWindow.classList.remove("active");
        (0, $lkhKc.default).setActiveKeyHandler(null);
        if (currentDialog && currentDialog.handler && currentDialog.handler.onClose) currentDialog.handler.onClose();
        currentDialog = undefined;
    };
    me.isVisible = function() {};
    me.inputKeyDown = function(e) {
        e.stopPropagation();
    };
    me.showBlanket = function() {
        if (!blanket) blanket = (0, $eJ26Q.$div)("blanket", "", document.body);
        blanket.classList.add("active");
    };
    me.hideBlanket = function() {
        if (blanket) blanket.classList.remove("active");
    };
    me.showNotification = function(data) {
        let delay = 0;
        if (!notification) {
            notification = (0, $eJ26Q.$div)("notificationbox", "", document.body);
            delay = 10;
        }
        notification.innerHTML = "";
        notification.appendChild((0, $eJ26Q.$div)("title", data.title));
        notification.appendChild((0, $eJ26Q.$div)("text", data.text));
        setTimeout(()=>{
            notification.classList.add("active");
        }, delay);
        setTimeout(()=>{
            notification.classList.remove("active");
        }, 3000);
    };
    me.hideNotification = function() {
        if (notification) notification.classList.remove("active");
    };
    me.alert = (message, title)=>{
        $6507088e91962c14$var$Modal.show($6507088e91962c14$export$f99739dbfcd2e015.OPTION, {
            title: title || "Alert",
            text: message,
            buttons: [
                {
                    label: "OK"
                }
            ]
        });
    };
    me.softAlert = (message, title)=>{
        $6507088e91962c14$var$Modal.showNotification({
            title: title || "Alert",
            text: message
        });
    };
    function keyHandler(code) {
        switch(code){
            case "escape":
                me.hide();
                return true;
            case "enter":
                let button = inner.querySelector(".button.primary");
                if (button && button.onClick) button.onClick();
                else {
                    button = inner.querySelector(".button");
                    if (button) {
                        if (button.onClick) button.onClick();
                        else me.hide();
                    }
                }
                return true;
        }
    }
    function showAbout(version) {
        inner.innerHTML = "";
        inner.appendChild((0, $eJ26Q.default)(".about", (0, $eJ26Q.default)("img", {
            src: "./_img/dpaint-about.png",
            onclick: ()=>me.hide()
        }), (0, $eJ26Q.default)(".text.version", "version " + version), (0, $eJ26Q.default)(".text.info", "Webbased image editor modeled after the legendary", (0, $eJ26Q.default)("br"), "Deluxe Paint with a focus on retro Amiga file formats."), (0, $eJ26Q.default)(".text.copyright.link", {
            onClick: ()=>window.open("https://www.stef.be/")
        }, "\xa9 2023-2024 - Steffest"), (0, $eJ26Q.default)(".text.github.link", {
            onClick: ()=>window.open("https://github.com/steffest/dpaint-js")
        }, "Open Source - Plain JavaScript - Fork me on GitHub")));
    }
    return me;
}();
var $6507088e91962c14$export$2e2bcd8739ae039 = $6507088e91962c14$var$Modal;

});
parcelRegister("4sZF5", function(module, exports) {

$parcel$export(module.exports, "default", () => $34099bab13f4cf51$export$2e2bcd8739ae039);

var $lkhKc = parcelRequire("lkhKc");

var $eJ26Q = parcelRequire("eJ26Q");

var $c1pPV = parcelRequire("c1pPV");

var $jYv0o = parcelRequire("jYv0o");

var $2hBLH = parcelRequire("2hBLH");

var $ebbAH = parcelRequire("ebbAH");

var $8ztM6 = parcelRequire("8ztM6");

var $4eKVl = parcelRequire("4eKVl");

var $jkJiE = parcelRequire("jkJiE");

var $9dDG4 = parcelRequire("9dDG4");

var $k5ZAj = parcelRequire("k5ZAj");
let $34099bab13f4cf51$var$UI = function() {
    let me = {};
    let container;
    me.init = function() {
        container = (0, $eJ26Q.$div)("container");
        document.body.appendChild(container);
        (0, $ebbAH.default).init();
        (0, $lkhKc.default).init();
        (0, $c1pPV.default).init(container);
        (0, $jYv0o.default).init(container);
        (0, $4eKVl.default).init(container);
        (0, $8ztM6.default).init(container);
        (0, $jkJiE.default).init(container);
        (0, $2hBLH.default).init(container);
        window.addEventListener("resize", ()=>{
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).UIresize);
        }, {
            passive: true
        });
    };
    me.fuzzy = function(value) {
        if (container) container.classList.toggle("fuzzy", value);
    };
    me.getContainer = function() {
        return container;
    };
    me.inPresentation = function() {
        return document.body.classList.contains("presentation");
    };
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).PRESENTATION, ()=>{
        document.body.classList.toggle("presentation");
    });
    return me;
}();
var $34099bab13f4cf51$export$2e2bcd8739ae039 = $34099bab13f4cf51$var$UI;

});
parcelRegister("jYv0o", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8ababebaa980911$export$2e2bcd8739ae039);

var $eJ26Q = parcelRequire("eJ26Q");

var $k5ZAj = parcelRequire("k5ZAj");

var $9dDG4 = parcelRequire("9dDG4");

var $eTCYn = parcelRequire("eTCYn");

var $aEF6k = parcelRequire("aEF6k");

var $2hBLH = parcelRequire("2hBLH");

var $gDIFj = parcelRequire("gDIFj");
parcelRequire("8ztM6");
let $e8ababebaa980911$var$Toolbar = function() {
    let me = {};
    let container;
    let undo, redo;
    let isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
    let meta = isMac ? "Cmd" : "Ctrl";
    let items = [
        {
            name: "pencil",
            command: (0, $k5ZAj.COMMAND).DRAW,
            isTool: true,
            info: "<b>B</b> Left click: draw with foreground color, Right click: draw with background color."
        },
        {
            name: "select",
            command: (0, $k5ZAj.COMMAND).SELECT,
            isTool: true,
            handleDeActivate: true,
            info: "<b>S</b> Make rectangular selection."
        },
        {
            name: "polygonselect",
            command: (0, $k5ZAj.COMMAND).POLYGONSELECT,
            isTool: true,
            handleDeActivate: true,
            info: "<b>P</b> Make polygon selection."
        },
        {
            name: "floodselect",
            isTool: true,
            command: (0, $k5ZAj.COMMAND).FLOODSELECT,
            info: "<b>W</b> Make selection of on area of the same color."
        },
        {
            name: "circle",
            label: "",
            isTool: true,
            canFill: true,
            command: (0, $k5ZAj.COMMAND).CIRCLE,
            info: "<b>C</b> Draw ellipsis. Shift to lock to circle, select again to toggle fill."
        },
        {
            name: "square",
            label: "",
            isTool: true,
            canFill: true,
            command: (0, $k5ZAj.COMMAND).SQUARE,
            info: "<b>R</b> Draw rectangle. Shift to lock to square, select again to toggle fill."
        },
        {
            name: "line",
            label: "",
            isTool: true,
            command: (0, $k5ZAj.COMMAND).LINE,
            info: "<b>L</b> Draw straight line."
        },
        {
            name: "gradient",
            isTool: true,
            command: (0, $k5ZAj.COMMAND).GRADIENT,
            info: "<b>G</b> Gradient fill, draw line to set start- and endpoint."
        },
        {
            name: "flood",
            isTool: true,
            command: (0, $k5ZAj.COMMAND).FLOOD,
            info: "<b>F</b> Fill an area."
        },
        //{name: "stamp", command: COMMAND.STAMP, info: "Make brush from selection."},
        {
            name: "smudge",
            isTool: true,
            command: (0, $k5ZAj.COMMAND).SMUDGE,
            info: "<b>M</b>  Smudge/Smear colors."
        },
        {
            name: "erase",
            isTool: true,
            command: (0, $k5ZAj.COMMAND).ERASE,
            info: "<b>E</b> Erase."
        },
        {
            name: "split",
            command: (0, $k5ZAj.COMMAND).SPLITSCREEN,
            toggleProperty: "<b>Tab</b> splitPanel",
            info: "Toggle split view."
        },
        {
            name: "pan",
            isTool: true,
            command: (0, $k5ZAj.COMMAND).PAN,
            info: "<b>H</b> or <b>Space</b> Hand: Pan the image."
        },
        {
            name: "picker",
            isTool: true,
            command: (0, $k5ZAj.COMMAND).COLORPICKER,
            info: "<b>K</b> or <b>Shift+Draw</b> Pick color from image."
        },
        {
            name: "zoom",
            label: "",
            command: (0, $k5ZAj.COMMAND).ZOOMIN,
            info: "<b>+</b> Zoom in."
        },
        {
            name: "zoomout",
            label: "",
            command: (0, $k5ZAj.COMMAND).ZOOMOUT,
            info: "<b>-</b> Zoom out."
        },
        {
            name: "undo",
            command: (0, $k5ZAj.COMMAND).UNDO,
            info: "<b>" + meta + "-Z</b> Undo."
        },
        {
            name: "redo",
            command: (0, $k5ZAj.COMMAND).REDO,
            info: "<b>" + meta + "-Y</b> Redo."
        }
    ];
    me.init = function(parent) {
        container = (0, $eJ26Q.$div)("toolbar", "", parent);
        generate();
        (0, $9dDG4.default).on((0, $k5ZAj.EVENT).toolOptionsChanged, ()=>{
            if (container) container.classList.toggle("fill", (0, $gDIFj.default).isFill());
        });
    };
    me.activateButton = function(index) {
        let item = items[index];
        if (item) {
            if (item.element) {
                if (item.canFill && item.element.classList.contains("active")) (0, $gDIFj.default).setFill(!(0, $gDIFj.default).isFill());
            }
            if (item.command) (0, $9dDG4.default).trigger(item.command);
        }
    };
    function generate() {
        let tools = (0, $eJ26Q.default)(".tools", {
            parent: container
        }, (0, $eJ26Q.default)(".togglepanel.sidebar", {
            onClick: ()=>(0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).TOGGLESIDEPANEL),
            info: "Toggle side panels"
        }));
        (0, $aEF6k.default).init(tools);
        items.forEach((item, index)=>{
            item.element = (0, $eJ26Q.$div)("button handle info icon " + item.name, item.label, tools, (e)=>{
                me.activateButton(index);
            });
            item.element.info = item.info;
            if (item.isTool && item.command) (0, $9dDG4.default).on(item.command, ()=>{
                items.forEach((itm, i)=>{
                    if (itm.isTool) {
                        if (itm.handleDeActivate && itm.command && itm.element.classList.contains("active") && index !== i) (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).toolDeActivated, itm.command);
                        itm.element.classList.toggle("active", index === i);
                    }
                });
                (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).toolChanged, item.command);
            });
            if (item.toggleProperty && item.command) (0, $9dDG4.default).on(item.command, ()=>{
                setTimeout(()=>{
                    items.forEach((itm, i)=>{
                        if (index === i) itm.element.classList.toggle("active", (0, $2hBLH.default).isStateActive(item.toggleProperty));
                    });
                }, 50);
            });
            if (item.command === (0, $k5ZAj.COMMAND).UNDO) {
                undo = item.element;
                undo.classList.toggle("disabled", true);
            }
            if (item.command === (0, $k5ZAj.COMMAND).REDO) {
                redo = item.element;
                redo.classList.toggle("disabled", true);
            }
        });
        (0, $eTCYn.default).init(tools, container);
    }
    (0, $9dDG4.default).on((0, $k5ZAj.EVENT).historyChanged, ([undoCount, redoCount])=>{
        if (undo) undo.classList.toggle("disabled", undoCount === 0);
        if (redo) redo.classList.toggle("disabled", redoCount === 0);
    });
    return me;
}();
var $e8ababebaa980911$export$2e2bcd8739ae039 = $e8ababebaa980911$var$Toolbar;

});

parcelRegister("ebbAH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a52b157e0fe8b879$export$2e2bcd8739ae039);

var $eJ26Q = parcelRequire("eJ26Q");

var $9dDG4 = parcelRequire("9dDG4");

var $lkhKc = parcelRequire("lkhKc");

var $k5ZAj = parcelRequire("k5ZAj");

var $2hBLH = parcelRequire("2hBLH");
var $a52b157e0fe8b879$var$Cursor = function() {
    var me = {};
    var cursor;
    var cursorMark;
    var toolTip;
    let position = {
        x: 0,
        y: 0
    };
    let defaultCursor = "default";
    let currentCursor = undefined;
    let overrideCursor = undefined;
    me.init = function() {
        cursor = (0, $eJ26Q.$div)("cursor");
        cursorMark = (0, $eJ26Q.$div)("mark", "", cursor);
        toolTip = (0, $eJ26Q.$div)("tooltip", "", cursor);
        document.body.appendChild(cursor);
        document.body.addEventListener("pointermove", function(e) {
            position = {
                x: e.clientX,
                y: e.clientY
            };
            cursor.style.left = e.clientX + "px";
            cursor.style.top = e.clientY + "px";
        }, false);
        (0, $9dDG4.default).on((0, $k5ZAj.EVENT).drawColorChanged, (color)=>{
            cursorMark.style.borderColor = "rgb(" + color[0] + "," + color[1] + "," + color[2] + ")";
        });
    };
    me.set = function(name) {
        currentCursor = name;
        setCursor();
    };
    me.reset = function() {
        currentCursor = undefined;
        setCursor();
    };
    me.override = function(name) {
        overrideCursor = name;
        setCursor();
    };
    me.resetOverride = function(name) {
        overrideCursor = undefined;
        setCursor();
    };
    me.attach = function(name) {
        cursor.style.display = "block";
        cursorMark.style.display = "block";
    };
    me.getPosition = ()=>{
        return position;
    };
    function setCursor() {
        document.body.classList.forEach((c)=>{
            if (c.startsWith("cursor-")) document.body.classList.remove(c);
        });
        let cursorName = overrideCursor || currentCursor || defaultCursor;
        document.body.classList.add("cursor-" + cursorName);
    }
    (0, $9dDG4.default).on((0, $k5ZAj.EVENT).modifierKeyChanged, ()=>{
        if (((0, $lkhKc.default).isShiftDown() || (0, $lkhKc.default).isAltDown()) && (0, $2hBLH.default).canPickColor()) me.override("colorpicker");
        else me.resetOverride();
        if ((0, $lkhKc.default).isSpaceDown()) me.override("pan");
    });
    return me;
}();
var $a52b157e0fe8b879$export$2e2bcd8739ae039 = $a52b157e0fe8b879$var$Cursor;

});

parcelRegister("4eKVl", function(module, exports) {

$parcel$export(module.exports, "default", () => $315cde56f1f3c31d$export$2e2bcd8739ae039);

var $eJ26Q = parcelRequire("eJ26Q");
let $315cde56f1f3c31d$var$StatusBar = (()=>{
    let me = {};
    let container;
    let toolTip;
    let overide = false;
    me.init = (parent)=>{
        container = (0, $eJ26Q.$div)("statusbar", "", parent);
        toolTip = (0, $eJ26Q.$div)("tooltip", "", container);
    };
    me.setToolTip = (text)=>{
        if (overide) return;
        toolTip.innerHTML = text;
    };
    me.overideToolTip = (text)=>{
        overide = true;
        toolTip.innerHTML = text;
    };
    return me;
})();
var $315cde56f1f3c31d$export$2e2bcd8739ae039 = $315cde56f1f3c31d$var$StatusBar;

});

parcelRegister("jkJiE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e133062ea8b69f7f$export$2e2bcd8739ae039);

var $eJ26Q = parcelRequire("eJ26Q");

var $eTCYn = parcelRequire("eTCYn");

var $bfgOg = parcelRequire("bfgOg");

var $9dDG4 = parcelRequire("9dDG4");

var $k5ZAj = parcelRequire("k5ZAj");
let $e133062ea8b69f7f$var$PaletteList = function() {
    let me = {};
    let container;
    let parent;
    let inner;
    let showGeneral = true;
    let showPlatform = false;
    me.init = function(_parent) {
        parent = _parent;
        (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).TOGGLEPALETTES, me.toggle);
    };
    me.toggle = function() {
        if (document.body.classList.contains("withpalettelist")) me.hide();
        else me.show();
    };
    me.show = ()=>{
        if (!container) generate();
        document.body.classList.add("withpalettelist");
        container.classList.add("active");
    };
    me.hide = ()=>{
        document.body.classList.remove("withpalettelist");
        container.classList.remove("active");
    };
    function generate() {
        if (!container) {
            container = (0, $eJ26Q.default)(".palettelist", (0, $eJ26Q.default)(".caption", "Palettes", (0, $eJ26Q.default)(".close", {
                onClick: me.hide
            }, "x")), inner = (0, $eJ26Q.default)(".inner"));
            parent.appendChild(container);
        }
        inner.innerHTML = "";
        let list = (0, $eTCYn.default).getPaletteMap();
        inner.appendChild((0, $eJ26Q.default)(".group" + (showGeneral ? ".active" : ""), {
            onClick: ()=>{
                showGeneral = !showGeneral;
                generate();
            }
        }, "General"));
        if (showGeneral) {
            for(let key in list)if (!list[key].platform) renderPalette(list[key]);
        }
        inner.appendChild((0, $eJ26Q.default)(".group" + (showPlatform ? ".active" : ""), {
            onClick: ()=>{
                showPlatform = !showPlatform;
                generate();
            }
        }, "Retro platforms"));
        if (showPlatform) {
            for(let key in list)if (list[key].platform) renderPalette(list[key]);
        }
        inner.appendChild((0, $eJ26Q.default)(".buttons", (0, $eJ26Q.default)(".button", {
            onClick: ()=>{
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).LOADPALETTE);
            }
        }, "Load Palette"), (0, $eJ26Q.default)(".button", {
            onClick: ()=>{
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).SAVEPALETTE);
            }
        }, "Save Palette")));
    }
    function renderPalette(palette) {
        let preset = palette.palette;
        if (preset) {
            let canvas, ctx, colors;
            (0, $eJ26Q.default)(".palette", {
                parent: inner,
                onClick: ()=>{
                    (0, $eTCYn.default).set(colors);
                    (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).paletteChanged);
                }
            }, (0, $eJ26Q.default)(".caption", palette.label), canvas = (0, $eJ26Q.default)("canvas"));
            (0, $eTCYn.default).loadPreset(palette).then((_colors)=>{
                colors = _colors;
                canvas.width = 80;
                let size = colors.length > 32 ? 5 : 10;
                let colorsPerRow = Math.floor(canvas.width / size);
                canvas.height = Math.ceil(colors.length / colorsPerRow) * size;
                ctx = canvas.getContext("2d");
                colors.forEach((color, index)=>{
                    ctx.fillStyle = (0, $bfgOg.default).toString(color);
                    ctx.fillRect(index % colorsPerRow * size, Math.floor(index / colorsPerRow) * size, size, size);
                });
            });
        }
    }
    return me;
}();
var $e133062ea8b69f7f$export$2e2bcd8739ae039 = $e133062ea8b69f7f$var$PaletteList;

});


parcelRegister("e0HvT", function(module, exports) {

$parcel$export(module.exports, "default", () => $a332d1a1e81f3277$export$2e2bcd8739ae039);

var $eJ26Q = parcelRequire("eJ26Q");

var $jU8Uk = parcelRequire("jU8Uk");

var $ltCSF = parcelRequire("ltCSF");

var $8FLxR = parcelRequire("8FLxR");

var $eTCYn = parcelRequire("eTCYn");

var $9dDG4 = parcelRequire("9dDG4");

var $k5ZAj = parcelRequire("k5ZAj");

var $3xwem = parcelRequire("3xwem");
var $a332d1a1e81f3277$var$SaveDialog = function() {
    let me = {};
    let nameInput;
    let currentFile;
    let filetypes = {
        IFF: {
            description: "IFF ILBM Image",
            accept: {
                "image/x-ilbm": [
                    ".iff"
                ]
            }
        },
        PLANES: {
            description: "Binary Bitplane Data",
            accept: {
                "application/octet-stream": [
                    ".planes"
                ]
            }
        },
        MASK: {
            description: "Binary Bitplane Mask",
            accept: {
                "application/octet-stream": [
                    ".mask"
                ]
            }
        },
        PNG: {
            description: "PNG Image",
            accept: {
                "image/png": [
                    ".png"
                ]
            }
        },
        GIF: {
            description: "GIF Image",
            accept: {
                "image/gif": [
                    ".gif"
                ]
            }
        },
        ICO: {
            description: "Amiga Icon",
            accept: {
                "application/octet-stream": [
                    ".info"
                ]
            }
        },
        PALETTE: {
            description: "DPaint.js Palette",
            accept: {
                "application/json": [
                    ".json"
                ]
            }
        },
        DPAINTJS: {
            description: "DPaint.js File",
            accept: {
                "application/json": [
                    ".json"
                ]
            }
        },
        INDEXED: {
            description: "DPaint.json with indexed color pixels",
            accept: {
                "application/json": [
                    ".json"
                ]
            }
        },
        ADF: {
            description: "Amiga Disk File",
            accept: {
                "application/octet-stream": [
                    ".adf"
                ]
            }
        },
        FILE: {
            description: "File"
        }
    };
    function saveFile(blob, fileName, type) {
        return new Promise(async (resolve, reject)=>{
            if (window.host && window.host.saveFile) {
                window.host.saveFile(blob, fileName);
                resolve();
                return;
            }
            if (window.showSaveFilePicker) window.showSaveFilePicker({
                suggestedName: fileName,
                types: [
                    type
                ]
            }).then(async (handle)=>{
                const writableStream = await handle.createWritable();
                await writableStream.write(blob);
                await writableStream.close();
                resolve();
            }).catch(async (err)=>{
                console.error(err);
                await (0, $ltCSF.default)(blob, fileName);
                resolve();
            });
            else {
                await (0, $ltCSF.default)(blob, fileName);
                resolve();
            }
        });
    }
    me.render = function(container) {
        let submenu;
        container.innerHTML = "";
        let mainPanel;
        container.appendChild(mainPanel = (0, $eJ26Q.default)(".saveform", (0, $eJ26Q.default)(".name", (0, $eJ26Q.default)("h4", "Name"), nameInput = (0, $eJ26Q.default)("input", {
            type: "text",
            value: (0, $jU8Uk.default).getName()
        })), (0, $eJ26Q.default)("h4", "Save as"), (0, $eJ26Q.default)(".moremenu", (0, $eJ26Q.default)(".item.index", {
            onClick: (e, elm)=>{
                waitFor(writeINDEXED, elm);
            }
        }, "Indexed", (0, $eJ26Q.default)(".subtitle", "Dpaint.json with indexed color pixels"), (0, $eJ26Q.default)(".info", "Map each pixel to the current palette. Used e.g. for the Magrathea Living Worlds app.\n")), (0, $eJ26Q.default)(".item.planes", {
            onClick: writePLANES
        }, "Planes", (0, $eJ26Q.default)(".subtitle", "Binary bitplane data"), (0, $eJ26Q.default)(".info", "Converts the current image to binary bitplane data. Useful for creating custom Amiga demos.")), (0, $eJ26Q.default)(".item.mask", {
            onClick: writeMASK
        }, "Mask", (0, $eJ26Q.default)(".subtitle", "Binary bitplane mask"), (0, $eJ26Q.default)(".info", "Converts the current image to a binary bitplane mask. Useful for creating custom Amiga demos."))), (0, $eJ26Q.default)(".platform.general", (0, $eJ26Q.default)("h4.general", "General"), renderButton("png", "PNG Image", "PNG file", "Full color and transparency, no layers, only the current frame gets saved.", writePNG), renderButton("json", "DPaint.JSON", "JSON file", "The internal format of Dpaint.js", writeJSON), renderButton("psd", "PSD", "Coming soon ...", "Working on it!"), (0, $eJ26Q.default)(".button.more", {
            onclick: ()=>{
                //submenu.classList.toggle("active");
                mainPanel.classList.toggle("hasmore");
            }
        }, "More")), (0, $eJ26Q.default)(".platform.amiga", (0, $eJ26Q.default)("h4.amiga", "Amiga"), currentFile ? renderButton("adf", "ADF", "Save to ADF", "Save Back to ADF. (Download the ADF afterwards when you're done editing)", writeADF) : null, renderButton("iff", "IFF Image", "Amiga IFF file", "Maximum 256 colours, only the current frame gets saved.", writeIFF), renderButton("mui", "Amiga Classic Icon", "OS1.3 Style", "For all Amiga's. Use MUI palette for best compatibility", writeAmigaClassicIcon), renderButton("os3", "Amiga Color Icon", "OS3.2 Style", "Also called 'Glowicons'. For modern Amiga systems and/or with PeterK's Icon Library. Max 256 colors.", writeAmigaColorIcon), renderButton("os4", "Amiga Dual PNG Icon", "OS4 Style", "For modern Amiga systems and/or with PeterK's Icon Library. Full colors.", writeAmigaPNGIcon))));
        nameInput.onkeydown = function(e) {
            e.stopPropagation();
        };
        nameInput.onchange = function() {
            (0, $jU8Uk.default).setName(getFileName());
        };
        // check if we have a server to post back to
        let postBack;
        let urlParams = new URLSearchParams(window.location.search);
        let url;
        if (urlParams.has("putback")) {
            url = urlParams.get("putback");
            if (url) postBack = {
                method: "PUT",
                url: url
            };
        }
        if (urlParams.has("postback")) {
            url = urlParams.get("postback");
            if (url) postBack = {
                method: "POST",
                url: url
            };
        }
        if (postBack) try {
            let url = new URL(postBack.url, window.location.href);
            postBack.domain = url.hostname;
            postBack.url = postBack.url = url.href;
        } catch  {
            postBack = undefined;
        }
        if (postBack) addPostBackOverlay(postBack, container);
    };
    me.setFile = function(file) {
        currentFile = file;
    };
    function renderButton(type, title, subtitle, info, onClick) {
        return (0, $eJ26Q.default)(".button", {
            onclick: onClick
        }, (0, $eJ26Q.default)(".icon." + type), (0, $eJ26Q.default)(".title", title), (0, $eJ26Q.default)(".subtitle", subtitle), (0, $eJ26Q.default)(".info", info));
    }
    function addPostBackOverlay(postBack, container) {
        let overridePanel = (0, $eJ26Q.default)(".saveoverlay", (0, $eJ26Q.default)(".info", "This editor is configured to save files back to", (0, $eJ26Q.default)("b", postBack.domain), (0, $eJ26Q.default)(".textlink", {
            onClick: ()=>{
                overridePanel.remove();
            }
        }, "More options")), (0, $eJ26Q.default)(".spinner"), (0, $eJ26Q.default)(".buttons", (0, $eJ26Q.default)(".button.ghost", {
            onclick: ()=>{
                (0, $8FLxR.default).hide();
            }
        }, "Cancel"), (0, $eJ26Q.default)(".button.primary", {
            onclick: async ()=>{
                overridePanel.classList.add("loading");
                let blob = await (0, $3xwem.default).file("PNG");
                if (blob) fetch(postBack.url, {
                    method: postBack.method,
                    body: blob
                }).then((response)=>{
                    if (response.ok) (0, $8FLxR.default).hide();
                    else (0, $8FLxR.default).alert("Error saving file to server");
                }).catch((err)=>{
                    (0, $8FLxR.default).alert("Error saving file to server");
                });
            }
        }, "Save")));
        container.appendChild(overridePanel);
    }
    function waitFor(action, elm) {
        let spinner = (0, $eJ26Q.default)(".spinner");
        elm.appendChild(spinner);
        elm.classList.add("loading");
        action().then((result)=>{
            spinner.remove();
            if (result && result.remarks && result.remarks.length) {
                let messages = [
                    "Some issues were found while saving the file:"
                ];
                result.remarks.forEach((remark)=>{
                    messages.push(remark.message);
                });
                messages.push("You might want to check the file.");
                (0, $8FLxR.default).alert(messages);
            } else (0, $8FLxR.default).hide();
        });
    }
    function getFileName() {
        let name = nameInput ? nameInput.value.replace(/[ &\/\\#,+()$~%.'":*?<>{}]/g, "") : "";
        return name || "Untitled";
    }
    async function writeIFF() {
        let blob = await (0, $3xwem.default).file("IFF");
        if (blob) {
            let fileName = getFileName() + ".iff";
            await saveFile(blob, fileName, filetypes.IFF);
            (0, $8FLxR.default).hide();
        }
    }
    async function writePLANES() {
        let result = await (0, $3xwem.default).file("BitPlanes");
        console.error(result);
        if (result && result.planes) {
            let blob = new Blob([
                result.planes
            ], {
                type: "application/octet-stream"
            });
            let fileName = getFileName() + ".planes";
            await saveFile(blob, fileName, filetypes.PLANES);
            fileName = getFileName() + ".palette.txt";
            let content = "{";
            for(let i = 0; i < result.palette.length; i++){
                let color = result.palette[i];
                content += "0X";
                color.forEach((c)=>{
                    c = Math.round(c / 16);
                    if (c > 15) c = 15;
                    content += c.toString(16);
                });
                content += ",";
            }
            content = content.slice(0, -1) + "}";
            let blob2 = new Blob([
                content
            ], {
                type: "application/octet-stream"
            });
            await saveFile(blob2, fileName, filetypes.FILE);
            (0, $8FLxR.default).hide();
        }
    }
    async function writeMASK() {
        let result = await (0, $3xwem.default).file("BitMask");
        console.error(result);
        if (result && result.planes) {
            let blob = new Blob([
                result.planes
            ], {
                type: "application/octet-stream"
            });
            let fileName = getFileName() + ".mask";
            await saveFile(blob, fileName, filetypes.MASK);
            (0, $8FLxR.default).hide();
        }
        return result;
    }
    async function writeINDEXED() {
        let result = await (0, $3xwem.default).file("DPAINTINDEXED");
        if (result.file) await saveFile(result.file, getFileName() + ".json", filetypes.INDEXED);
        return result;
    }
    function writeADF() {
        (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).SAVEFILETOADF, [
            currentFile,
            getFileName()
        ]);
    }
    async function writePNG() {
        let blob = await (0, $3xwem.default).file("PNG");
        if (blob) {
            await saveFile(blob, getFileName() + ".png", filetypes.PNG);
            (0, $8FLxR.default).hide();
        }
    }
    async function writeJSON() {
        let result = await (0, $3xwem.default).file("DPAINT");
        if (result.file) {
            await saveFile(result.file, getFileName() + ".json", filetypes.DPAINTJS);
            (0, $8FLxR.default).hide();
        }
    }
    async function writeAmigaClassicIcon(config) {
        let blob = await (0, $3xwem.default).file("classicIcon");
        if (blob) {
            await saveFile(blob, getFileName() + ".info", filetypes.ICO);
            (0, $8FLxR.default).hide();
        }
    }
    async function writeAmigaPNGIcon() {
        let blob = await (0, $3xwem.default).file("PNGIcon");
        if (blob) saveFile(blob, getFileName() + ".info", filetypes.ICO).then(()=>{
            (0, $8FLxR.default).hide();
        });
    }
    async function writeAmigaColorIcon() {
        let blob = await (0, $3xwem.default).file("colorIcon");
        if (blob) {
            await saveFile(blob, getFileName() + ".info", filetypes.ICO);
            (0, $8FLxR.default).hide();
        }
    }
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).SAVEPALETTE, ()=>{
        let struct = {
            type: "palette",
            palette: (0, $eTCYn.default).get()
        };
        let blob = new Blob([
            JSON.stringify(struct, null, 2)
        ], {
            type: "application/json"
        });
        saveFile(blob, getFileName() + "_palette.json", filetypes.PALETTE).then(()=>{});
    });
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).SAVEDISK, ([data, fileName])=>{
        let blob = new Blob([
            data
        ], {
            type: "application/octet-stream"
        });
        saveFile(blob, fileName, filetypes.ADF).then(()=>{});
    });
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).SAVEGENERIC, ([data, fileName])=>{
        let blob = new Blob([
            data
        ], {
            type: "application/octet-stream"
        });
        saveFile(blob, fileName, filetypes.FILE).then(()=>{});
    });
    window.png8 = function() {
        (0, $3xwem.default).file("PNG8").then((blob)=>{
            if (blob) saveFile(blob, getFileName() + ".png", filetypes.PNG).then(()=>{});
        });
    };
    window.savegif = function() {
        (0, $3xwem.default).file("GIF").then((blob)=>{
            if (blob) saveFile(blob, getFileName() + ".gif", filetypes.GIF).then(()=>{});
        });
    };
    return me;
}();
var $a332d1a1e81f3277$export$2e2bcd8739ae039 = $a332d1a1e81f3277$var$SaveDialog;

});
parcelRegister("ltCSF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $fa2a7752a5f62865$export$2e2bcd8739ae039);
/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */ var $fa2a7752a5f62865$var$saveAs = $fa2a7752a5f62865$var$saveAs || function(e) {
    "use strict";
    if (typeof e === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) return;
    var t = e.document, n = function() {
        return e.URL || e.webkitURL || e;
    }, r = t.createElementNS("http://www.w3.org/1999/xhtml", "a"), o = "download" in r, a = function(e) {
        var t = new MouseEvent("click");
        e.dispatchEvent(t);
    }, i = /constructor/i.test(e.HTMLElement) || e.safari, f = /CriOS\/[\d]+/.test(navigator.userAgent), u = function(t) {
        (e.setImmediate || e.setTimeout)(function() {
            throw t;
        }, 0);
    }, s = "application/octet-stream", d = 40000, c = function(e) {
        var t = function() {
            if (typeof e === "string") n().revokeObjectURL(e);
            else e.remove();
        };
        setTimeout(t, d);
    }, l = function(e, t, n) {
        t = [].concat(t);
        var r = t.length;
        while(r--){
            var o = e["on" + t[r]];
            if (typeof o === "function") try {
                o.call(e, n || e);
            } catch (a) {
                u(a);
            }
        }
    }, p = function(e) {
        if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e.type)) return new Blob([
            String.fromCharCode(65279),
            e
        ], {
            type: e.type
        });
        return e;
    }, v = function(t, u, d) {
        if (!d) t = p(t);
        var v = this, w = t.type, m = w === s, y, h = function() {
            l(v, "writestart progress write writeend".split(" "));
        }, S = function() {
            if ((f || m && i) && e.FileReader) {
                var r = new FileReader;
                r.onloadend = function() {
                    var t = f ? r.result : r.result.replace(/^data:[^;]*;/, "data:attachment/file;");
                    var n = e.open(t, "_blank");
                    if (!n) e.location.href = t;
                    t = undefined;
                    v.readyState = v.DONE;
                    h();
                };
                r.readAsDataURL(t);
                v.readyState = v.INIT;
                return;
            }
            if (!y) y = n().createObjectURL(t);
            if (m) e.location.href = y;
            else {
                var o = e.open(y, "_blank");
                if (!o) e.location.href = y;
            }
            v.readyState = v.DONE;
            h();
            c(y);
        };
        v.readyState = v.INIT;
        if (o) {
            y = n().createObjectURL(t);
            setTimeout(function() {
                r.href = y;
                r.download = u;
                a(r);
                h();
                c(y);
                v.readyState = v.DONE;
            });
            return;
        }
        S();
    }, w = v.prototype, m = function(e, t, n) {
        return new v(e, t || e.name || "download", n);
    };
    if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) return function(e, t, n) {
        t = t || e.name || "download";
        if (!n) e = p(e);
        return navigator.msSaveOrOpenBlob(e, t);
    };
    w.abort = function() {};
    w.readyState = w.INIT = 0;
    w.WRITING = 1;
    w.DONE = 2;
    w.error = w.onwritestart = w.onprogress = w.onwrite = w.onabort = w.onerror = w.onwriteend = null;
    return m;
}(typeof self !== "undefined" && self || typeof window !== "undefined" && window || undefined.content);
if (0, module.exports) module.exports.saveAs = $fa2a7752a5f62865$var$saveAs;
else if (typeof define !== "undefined" && define !== null && define.amd !== null) define("FileSaver.js", function() {
    return $fa2a7752a5f62865$var$saveAs;
});
var $fa2a7752a5f62865$export$2e2bcd8739ae039 = $fa2a7752a5f62865$var$saveAs;

});

parcelRegister("3xwem", function(module, exports) {

$parcel$export(module.exports, "default", () => $293d747e76d80124$export$2e2bcd8739ae039);

var $8FLxR = parcelRequire("8FLxR");

var $aQoVS = parcelRequire("aQoVS");

var $jU8Uk = parcelRequire("jU8Uk");

var $lPw7G = parcelRequire("lPw7G");

var $fC5qu = parcelRequire("fC5qu");

var $eTCYn = parcelRequire("eTCYn");

var $9r69W = parcelRequire("9r69W");

var $bnYE1 = parcelRequire("bnYE1");
let $293d747e76d80124$var$Generate = function() {
    let me = {};
    me.validate = (config)=>{
        let result = {
            valid: true,
            errors: []
        };
        if (config.maxColors) {
            let colors = (0, $lPw7G.default).getColors((0, $jU8Uk.default).getCanvas(), config.maxColors).length;
            if ((0, $jU8Uk.default).getCurrentFile().frames.length > 1 && config.checkAllFrames) colors = Math.max(colors, (0, $lPw7G.default).getColors((0, $jU8Uk.default).getCanvas(1), config.maxColors).length);
            if (colors > config.maxColors) {
                result.valid = false;
                result.errors.push("Please reduce the number of colors to maximum  " + config.maxColors + ".");
            }
        }
        if (config.maxWidth && config.maxHeight) {
            let width = (0, $jU8Uk.default).getCurrentFile().width;
            let height = (0, $jU8Uk.default).getCurrentFile().height;
            if (width > config.maxWidth || height > config.maxHeight) {
                result.valid = false;
                result.errors.push("Please reduce the image size to maximum " + config.maxWidth + "x" + config.maxHeight + " pixels.");
            }
        }
        return result;
    };
    // returns a blob
    me.file = async (type)=>{
        switch(type){
            case "classicIcon":
                return await me.classicIcon();
            case "colorIcon":
                return me.colorIcon();
            case "PNGIcon":
                return await me.PNGIcon();
            case "IFF":
                return me.iff();
            case "BitPlanes":
                return me.planes();
            case "BitMask":
                return me.mask();
            case "PNG":
                return await new Promise((resolve)=>(0, $jU8Uk.default).getCanvas().toBlob(resolve));
            case "PNG8":
                return me.png8();
            case "GIF":
                return me.gif();
            case "DPAINT":
                return me.dPaint();
            case "DPAINTINDEXED":
                return me.dPaint(true);
            default:
                console.error("Unknown file type", type);
        }
    };
    me.iff = (maxColors, tooManyColorMessage)=>{
        maxColors = maxColors || 256;
        let check = me.validate({
            maxColors: maxColors
        });
        if (!check.valid) {
            (0, $8FLxR.default).show((0, $8FLxR.DIALOG).OPTION, {
                title: "Save as IFF",
                text: [
                    tooManyColorMessage || "Sorry, this image can't be saved as IFF."
                ].concat(check.errors),
                buttons: [
                    {
                        label: "OK"
                    }
                ]
            });
            return;
        }
        let buffer = (0, $aQoVS.default).write((0, $jU8Uk.default).getCanvas());
        return new Blob([
            buffer
        ], {
            type: "application/octet-stream"
        });
    };
    me.planes = ()=>{
        let maxColors = 32;
        let check = me.validate({
            maxColors: maxColors
        });
        if (!check.valid) {
            (0, $8FLxR.default).show((0, $8FLxR.DIALOG).OPTION, {
                title: "Save as BitPlane data",
                text: [
                    "Sorry, this image can't be saved as Bitplane data."
                ].concat(check.errors),
                buttons: [
                    {
                        label: "OK"
                    }
                ]
            });
            return;
        }
        return (0, $aQoVS.default).toBitPlanes((0, $jU8Uk.default).getCanvas());
    };
    me.mask = ()=>{
        return (0, $aQoVS.default).toBitMask((0, $jU8Uk.default).getCanvas());
    };
    me.png8 = ()=>{
        let maxColors = 256;
        let check = me.validate({
            maxColors: maxColors
        });
        if (!check.valid) {
            (0, $8FLxR.default).show((0, $8FLxR.DIALOG).OPTION, {
                title: "Save as PNG8",
                text: [
                    "Sorry, this image can't be saved as PNG8."
                ].concat(check.errors),
                buttons: [
                    {
                        label: "OK"
                    }
                ]
            });
            return;
        }
        let buffer = (0, $9r69W.default).write((0, $jU8Uk.default).getCanvas());
        console.log(buffer);
        return new Blob([
            buffer
        ], {
            type: "application/octet-stream"
        });
    };
    me.gif = ()=>{
        let maxColors = 256;
        let check = me.validate({
            maxColors: maxColors
        });
        if (!check.valid) {
            (0, $8FLxR.default).show((0, $8FLxR.DIALOG).OPTION, {
                title: "Save as GIF",
                text: [
                    "Sorry, this image can't be saved as GIF."
                ].concat(check.errors),
                buttons: [
                    {
                        label: "OK"
                    }
                ]
            });
            return;
        }
        let buffer = (0, $bnYE1.default).write((0, $jU8Uk.default).getCurrentFile().frames);
        //let buffer = GIF.write(ImageFile.getCanvas());
        console.log(buffer);
        return new Blob([
            buffer
        ], {
            type: "application/octet-stream"
        });
    };
    me.dPaint = (indexed)=>{
        let result = (0, $jU8Uk.default).export(indexed);
        let remarks = [];
        if (indexed && result.errorCount) {
            let pixels = " pixel";
            if (result.errorCount > 1) pixels += "s";
            remarks.push({
                type: "warning",
                message: result.errorCount + pixels + " could not be converted to index colors because there was no matching color found in the palette."
            });
        }
        return {
            file: new Blob([
                JSON.stringify(result)
            ], {
                type: "application/json"
            }),
            remarks: remarks
        };
    };
    me.classicIcon = (config)=>{
        return new Promise((next)=>{
            config = config || {};
            config.title = "Save as Amiga Classic Icon";
            let check = me.validate({
                maxColors: 32,
                checkAllFrames: true
            });
            if (!check.valid) {
                (0, $8FLxR.default).show((0, $8FLxR.DIALOG).OPTION, {
                    title: config.title,
                    text: [
                        "Sorry, this image has too many colors. Please reduce them to 16 or even better: 8 or less using the MUI palette"
                    ],
                    buttons: [
                        {
                            label: "OK"
                        }
                    ]
                });
                next();
            }
            check = me.validate({
                maxWidth: 1024,
                maxHeight: 1024
            });
            if (!check.valid) {
                (0, $8FLxR.default).show((0, $8FLxR.DIALOG).OPTION, {
                    title: config.title,
                    text: [
                        "Sorry, this image is too big. Please reduce it to 1024x1024 pixels or less."
                    ],
                    buttons: [
                        {
                            label: "OK"
                        }
                    ]
                });
                next();
            }
            if (!config.skipColorCheck) {
                check = me.validate({
                    maxColors: 8
                });
                if (!check.valid) {
                    (0, $8FLxR.default).show((0, $8FLxR.DIALOG).OPTION, {
                        title: config.title,
                        text: "Are you sure you want to save this image as Amiga Classic Icon? It has more than 8 colors which means it probably won't display correctly",
                        onOk: ()=>{
                            config.skipColorCheck = true;
                            me.classicIcon(config).then(next);
                        }
                    });
                    return;
                }
            }
            if (!config.skipSizeCheck) {
                check = me.validate({
                    maxWidth: 256,
                    maxHeight: 256
                });
                if (!check.valid) {
                    (0, $8FLxR.default).show((0, $8FLxR.DIALOG).OPTION, {
                        title: config.title,
                        text: "Are you sure you want to save this image as Amiga Classic Icon? It's kind of big... Although technically possible, it's not recommended to use icons bigger than 256x256 pixels",
                        onOk: ()=>{
                            config.skipSizeCheck = true;
                            me.classicIcon(config).then(next);
                        }
                    });
                    return;
                }
            }
            let canvas1 = (0, $jU8Uk.default).getCanvas(0);
            let canvas2 = (0, $jU8Uk.default).getCanvas(1) || canvas1;
            let ctx1 = canvas1.getContext("2d");
            let ctx2 = canvas2.getContext("2d");
            let w = canvas1.width;
            let h = canvas1.height;
            let r, g, b, alpha;
            let icon = (0, $fC5qu.default).create(w, h);
            // discard ColorIcon
            icon.colorIcon = undefined;
            icon.width = w;
            icon.height = h;
            icon.img.width = w;
            icon.img.height = h;
            icon.img.depth = 3; // 8 colors
            icon.img.planePick = 7 // color count - 1 (?)
            ;
            icon.img.pixels = [];
            icon.img2.width = w;
            icon.img2.height = h;
            icon.img2.depth = 3; // 8 colors
            icon.img2.planePick = 7 // color count - 1 (?)
            ;
            icon.img2.pixels = [];
            function fillPixels(_ctx, pixels) {
                // canvas colours to pixel array
                let MUIColors = [
                    "#959595",
                    "#000000",
                    "#ffffff",
                    "#3b67a2",
                    "#7b7b7b",
                    "#afafaf",
                    "#aa907c",
                    "#ffa997"
                ];
                let additionalColors = [
                    "#000000"
                ];
                let data = _ctx.getImageData(0, 0, w, h).data;
                for(let y = 0; y < h; y++)for(let x = 0; x < w; x++){
                    let index = (x + y * w) * 4;
                    r = data[index];
                    g = data[index + 1];
                    b = data[index + 2];
                    alpha = data[index + 3];
                    if (alpha > 100) {
                        let rgb = rgbToHex(r, g, b);
                        let colorIndex = MUIColors.indexOf(rgb);
                        if (colorIndex < 0) {
                            console.warn("No MUI color: " + rgb);
                            // making some assumptions here:
                            // get from palette
                            colorIndex = (0, $eTCYn.default).getColorIndex([
                                r,
                                g,
                                b
                            ], true);
                            // check if already in list
                            if (colorIndex < 0) colorIndex = additionalColors.indexOf(rgb);
                            if (colorIndex < 0) {
                                // add to list
                                additionalColors.push(rgb);
                                colorIndex = additionalColors.length - 1;
                            }
                            if (colorIndex > 15) {
                                console.error("Too many colors: " + rgb);
                                colorIndex = 0;
                            }
                        }
                        pixels.push(colorIndex);
                    } else pixels.push(0);
                }
            }
            fillPixels(ctx1, icon.img.pixels);
            fillPixels(ctx2, icon.img2.pixels);
            let buffer = (0, $fC5qu.default).write(icon);
            next(new Blob([
                buffer
            ], {
                type: "application/octet-stream"
            }));
        });
    };
    me.colorIcon = ()=>{
        let check = me.validate({
            maxColors: 256,
            checkAllFrames: true,
            maxWidth: 256,
            maxHeight: 256
        });
        if (!check.valid) {
            (0, $8FLxR.default).show((0, $8FLxR.DIALOG).OPTION, {
                title: "Save as Amiga Color Icon",
                text: [
                    "Sorry, this image can't be saved as Amiga Color Icon."
                ].concat(check.errors),
                buttons: [
                    {
                        label: "OK"
                    }
                ]
            });
            return;
        }
        // save as ColorIcon
        let canvas1 = (0, $jU8Uk.default).getCanvas(0);
        var palette = [];
        var pixels = [];
        var ctx = canvas1.getContext("2d");
        let canvas2 = (0, $jU8Uk.default).getCanvas(1) || canvas1;
        var palette2 = [];
        var pixels2 = [];
        var ctx2 = canvas2.getContext("2d");
        var w = canvas1.width;
        var h = canvas1.height;
        // for images < 8 colors we use the transparentColor as actual color;
        // for >=8 we add the transparent color as extra color (image processing should have filtered that out already)
        //if (IconEditor.getPalette().length > 7){
        palette.push((0, $eTCYn.default).getBackgroundColor());
        palette2.push((0, $eTCYn.default).getBackgroundColor());
        //}
        var r, g, b, alpha;
        var colorLookup = {};
        var colorLookup2 = {};
        function matchColor(r, g, b, _palette) {
            for(var i = 1, max = _palette.length; i < max; i++){
                var color = _palette[i];
                var div = Math.abs(color[0] - r) + Math.abs(color[1] - g) + Math.abs(color[2] - b);
                if (div === 0) return i;
                else {
                    // TODO: is this still needed? palette should already be exact?
                    if (div < 5) return i;
                }
            }
            return -1;
        }
        // canvas colours to pixel array
        var data = ctx.getImageData(0, 0, w, h).data;
        for(let y = 0; y < h; y++)for(let x = 0; x < w; x++){
            let index = (x + y * w) * 4;
            r = data[index];
            g = data[index + 1];
            b = data[index + 2];
            alpha = data[index + 3];
            if (alpha > 100) {
                let rgb = rgbToHex(r, g, b);
                let colorIndex = colorLookup[rgb];
                if (typeof colorIndex === "undefined") {
                    colorIndex = matchColor(r, g, b, palette);
                    if (colorIndex < 0) {
                        palette.push([
                            r,
                            g,
                            b
                        ]);
                        colorIndex = palette.length - 1;
                        colorLookup[rgb] = colorIndex;
                    }
                }
                pixels.push(colorIndex);
            } else pixels.push(0);
        }
        var data2 = ctx2.getImageData(0, 0, w, h).data;
        colorLookup2 = {};
        for(let y = 0; y < h; y++)for(let x = 0; x < w; x++){
            let index = (x + y * w) * 4;
            r = data2[index];
            g = data2[index + 1];
            b = data2[index + 2];
            alpha = data2[index + 3];
            if (alpha > 100) {
                let rgb = rgbToHex(r, g, b);
                let colorIndex = colorLookup2[rgb];
                if (typeof colorIndex === "undefined") {
                    colorIndex = matchColor(r, g, b, palette2);
                    if (colorIndex < 0) {
                        palette2.push([
                            r,
                            g,
                            b
                        ]);
                        colorIndex = palette2.length - 1;
                        colorLookup2[rgb] = colorIndex;
                    }
                }
                //console.error(colorIndex);
                pixels2.push(colorIndex);
            } else pixels2.push(0);
        }
        var icon = (0, $fC5qu.default).create(w, h);
        icon.colorIcon.MaxPaletteSize = palette.length;
        var state = icon.colorIcon.states[0];
        state.NumColors = palette.length;
        state.paletteSize = state.NumColors * 3;
        state.palette = palette.slice();
        state.pixels = pixels.slice();
        icon.colorIcon.states.push({
            transparentIndex: 0,
            flags: 3,
            imageCompression: 0,
            paletteCompression: 0,
            depth: 8,
            imageSize: pixels2.length
        });
        let state2 = icon.colorIcon.states[1];
        state2.NumColors = palette2.length;
        state2.paletteSize = state2.NumColors * 3;
        state2.palette = palette2.slice();
        state2.pixels = pixels2.slice();
        let buffer = (0, $fC5qu.default).write(icon);
        return new Blob([
            buffer
        ], {
            type: "application/octet-stream"
        });
    };
    me.PNGIcon = (config)=>{
        return new Promise((next)=>{
            let canvas1 = (0, $jU8Uk.default).getCanvas(0);
            let canvas2 = (0, $jU8Uk.default).getCanvas(1);
            if (canvas2) canvas1.toBlob(function(blob1) {
                canvas2.toBlob(function(blob2) {
                    next(new Blob([
                        blob1,
                        blob2
                    ], {
                        type: "application/octet-stream"
                    }));
                });
            });
            else canvas1.toBlob(function(blob1) {
                next(new Blob([
                    blob1
                ], {
                    type: "application/octet-stream"
                }));
            });
        });
    };
    function rgbToHex(r, g, b) {
        return "#" + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
    }
    return me;
}();
var $293d747e76d80124$export$2e2bcd8739ae039 = $293d747e76d80124$var$Generate;

});
parcelRegister("9r69W", function(module, exports) {

$parcel$export(module.exports, "default", () => $6deb69c9547cbd8f$export$2e2bcd8739ae039);
/*

    Simple PNG write support for indexed palette images
    Copyright (c) 2023 Steffest - dev@stef.be

    spec -> https://www.w3.org/TR/png/

 */ 
var $3QDcZ = parcelRequire("3QDcZ");

var $eTCYn = parcelRequire("eTCYn");

var $8nT1Z = parcelRequire("8nT1Z");

var $8XeSI = parcelRequire("8XeSI");
(0, $8XeSI.default).call(window);
const $6deb69c9547cbd8f$var$PLTE = [
    80,
    76,
    84,
    69
];
const $6deb69c9547cbd8f$var$IHDR = [
    73,
    72,
    68,
    82
];
const $6deb69c9547cbd8f$var$IDAT = [
    73,
    68,
    65,
    84
];
const $6deb69c9547cbd8f$var$IEND = [
    73,
    69,
    78,
    68
];
let $6deb69c9547cbd8f$var$IndexedPng = function() {
    let me = {};
    let pngHeader = new Uint8Array([
        137,
        80,
        78,
        71,
        13,
        10,
        26,
        10
    ]);
    me.write = function(canvas) {
        let bitDepth = 8;
        let colorType = 3; // indexed color
        let compressionMethod = 0;
        let filterMethod = 0;
        let interlaceMethod = 0;
        let header = getHeaderChunk(canvas.width, canvas.height, bitDepth, colorType, compressionMethod, filterMethod, interlaceMethod);
        let palette = getPaletteChunk();
        let data = getDataChunk(canvas);
        let pngSize = pngHeader.length + chunkSize(header) + chunkSize(palette) + chunkSize(data) + chunkSize([]);
        let arrayBuffer = new ArrayBuffer(pngSize);
        let file = new (0, $3QDcZ.default)(arrayBuffer, true);
        file.writeByteArray(pngHeader);
        writeChunk(file, $6deb69c9547cbd8f$var$IHDR, header);
        writeChunk(file, $6deb69c9547cbd8f$var$PLTE, palette);
        writeChunk(file, $6deb69c9547cbd8f$var$IDAT, data);
        writeChunk(file, $6deb69c9547cbd8f$var$IEND, []);
        return file.buffer;
    };
    function writeChunk(stream, type, data) {
        let len = data.length;
        stream.writeUint(len);
        stream.writeByteArray(type);
        stream.writeByteArray(data);
        stream.writeUint((0, $8nT1Z.default).get(type.concat(Array.from(data))));
    }
    function chunkSize(data) {
        return data.length + 12;
    }
    function getHeaderChunk(width, height, bitDepth, colorType, compressionMethod, filterMethod, interlaceMethod) {
        let byteArr = new ArrayBuffer(13);
        let data = new (0, $3QDcZ.default)(byteArr, true);
        data.writeUint(width);
        data.writeUint(height);
        data.writeUbyte(bitDepth);
        data.writeUbyte(colorType);
        data.writeUbyte(compressionMethod);
        data.writeUbyte(filterMethod);
        data.writeUbyte(interlaceMethod);
        return new Uint8Array(data.buffer);
    }
    function getPaletteChunk() {
        let palette = (0, $eTCYn.default).get();
        let data = new Uint8Array(palette.length * 3);
        for(let i = 0; i < palette.length; i++)data.set(palette[i], i * 3);
        return data;
    }
    function getDataChunk(canvas) {
        let w = canvas.width;
        let h = canvas.height;
        // convert canvas to indexed color
        // put scanline filter method in first byte of each scanline
        // zlib compress the whole thing
        let imageData = canvas.getContext("2d").getImageData(0, 0, w, h);
        let pixels = imageData.data;
        let data = new Uint8Array(w * h + h);
        for(let y = 0; y < h; y++){
            let scanLineIndex = y * (w + 1);
            data[scanLineIndex] = 0; // no filter
            for(let x = 0; x < w; x++){
                let i = (y * w + x) * 4;
                let r = pixels[i];
                let g = pixels[i + 1];
                let b = pixels[i + 2];
                let color = (0, $eTCYn.default).getColorIndex([
                    r,
                    g,
                    b
                ], true);
                data[scanLineIndex + x + 1] = color;
            }
        }
        let zData = new Zlib.Deflate(data).compress();
        return zData;
    }
    return me;
}();
var $6deb69c9547cbd8f$export$2e2bcd8739ae039 = $6deb69c9547cbd8f$var$IndexedPng;

});
parcelRegister("8nT1Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $61ab28b963de8c15$export$2e2bcd8739ae039);
let $61ab28b963de8c15$var$CRC32 = function() {
    let me = {};
    let crcTable = new Uint32Array(256);
    for(let n = 0; n < 256; n++){
        let c = n;
        for(let k = 0; k < 8; k++)if (c & 1) c = 0xedb88320 ^ c >>> 1;
        else c = c >>> 1;
        crcTable[n] = c;
    }
    me.get = function(data) {
        let crc = 0xffffffff;
        for(let i = 0; i < data.length; i++)crc = crcTable[(crc ^ data[i]) & 0xff] ^ crc >>> 8;
        return crc ^ 0xffffffff;
    };
    return me;
}();
var $61ab28b963de8c15$export$2e2bcd8739ae039 = $61ab28b963de8c15$var$CRC32;

});


parcelRegister("bnYE1", function(module, exports) {

$parcel$export(module.exports, "default", () => $0223a08e15d68546$export$2e2bcd8739ae039);

var $3QDcZ = parcelRequire("3QDcZ");

var $eTCYn = parcelRequire("eTCYn");

var $3izfq = parcelRequire("3izfq");

var $jU8Uk = parcelRequire("jU8Uk");
const $0223a08e15d68546$var$GIF = (()=>{
    const me = {};
    me.detect = function(file) {
        const id = file.readString(3, 0);
        if (id === "GIF") {
            let version = file.readString(3);
            return version === "87a" || version === "89a";
        }
        return false;
    };
    me.parse = function(file) {
        let img = {};
        file.goto(3);
        img.version = file.readString(3);
        //Logical Screen Descriptor
        img.width = file.readShort();
        img.height = file.readShort();
        let packed = file.readUbyte();
        img.gctFlag = (packed & 128) !== 0;
        img.colorResolution = (packed & 112) >> 4;
        img.sortFlag = (packed & 8) !== 0;
        img.gctSize = packed & 7;
        img.colorCount = 1 << img.gctSize + 1;
        img.bgColorIndex = file.readUbyte();
        img.pixelAspectRatio = file.readUbyte();
        if (img.gctFlag) {
            img.palette = [];
            for(let i = 0; i < img.colorCount; i++){
                let r = file.readUbyte();
                let g = file.readUbyte();
                let b = file.readUbyte();
                img.palette.push([
                    r,
                    g,
                    b
                ]);
            }
        }
        function parseBlock() {
            let block = {};
            block.id = file.readUbyte();
            switch(block.id){
                case 0x21:
                    //Extension
                    block.label = file.readUbyte();
                    switch(block.label){
                        case 0xF9:
                            //Graphics Control Extension
                            console.log("Graphics Control Extension Found");
                            block.size = file.readUbyte();
                            let packed = file.readUbyte();
                            img.disposalMethod = (packed & 28) >> 2;
                            //disposalMethod: 0: unspecified, 1: do not dispose, 2: restore to background, 3: restore to previous
                            img.userInputFlag = (packed & 2) !== 0;
                            img.transparentColorFlag = (packed & 1) !== 0;
                            img.delayTime = file.readShort();
                            img.transparentColorIndex = file.readUbyte();
                            file.readUbyte(); //block terminator
                            break;
                        case 0xFF:
                            //Application Extension
                            console.log("Application Extension Found");
                            block.size = file.readUbyte();
                            block.app = file.readString(11);
                            let subBlockSize = file.readUbyte();
                            if (block.app === "NETSCAPE2.0") {
                                file.jump(1);
                                img.loopCount = file.readShort();
                                file.readUbyte(); //block terminator
                            } else {
                                file.jump(subBlockSize);
                                file.readUbyte(); //block terminator
                            }
                            break;
                        case 0xFE:
                        case 0x01:
                            //0xFE: Comment Extension
                            //0x01: Plain Text Extension
                            // ignore for now
                            console.error("Comment Extension");
                            file.jump(1);
                            let size = file.readUbyte();
                            file.jump(size);
                            file.readUbyte(); //block terminator
                            break;
                        default:
                            console.error("Unknown GIF block label: " + block.label);
                    }
                    break;
                case 0x2C:
                    //Image Descriptor
                    console.log("Image Descriptor Found");
                    img.frames = img.frames || [];
                    let frame = {};
                    frame.left = file.readShort();
                    frame.top = file.readShort();
                    frame.width = file.readShort();
                    frame.height = file.readShort();
                    let packed1 = file.readUbyte();
                    block.lctFlag = (packed1 & 128) !== 0;
                    block.interlaceFlag = (packed1 & 64) !== 0;
                    block.sortFlag = (packed1 & 32) !== 0;
                    block.reserved = (packed1 & 24) >> 3;
                    block.lctSize = packed1 & 7;
                    block.colorCount = 1 << block.lctSize + 1;
                    if (block.lctFlag) {
                        frame.palette = [];
                        for(let i = 0; i < block.colorCount; i++){
                            let r = file.readUbyte();
                            let g = file.readUbyte();
                            let b = file.readUbyte();
                            frame.palette.push([
                                r,
                                g,
                                b
                            ]);
                        }
                    }
                    block.lzwMinCodeSize = file.readUbyte();
                    let lzwData = [];
                    let size1;
                    do {
                        size1 = file.readUbyte();
                        for(let i = 0; i < size1; i++)lzwData.push(file.readUbyte());
                    }while (size1 > 0);
                    frame.pixels = (0, $3izfq.default).decode(lzwData, block.lzwMinCodeSize, frame.width * frame.height);
                    if (!frame.palette) frame.palette = img.palette;
                    if (img.transparentColorFlag) frame.transparentColorIndex = img.transparentColorIndex;
                    img.frames.push(frame);
                    break;
                case 0x3B:
                    //Trailer
                    console.log("EOF Found");
                    break;
                default:
                    console.error("Unknown GIF block: ", block);
            }
            return block;
        }
        let block = parseBlock();
        while(block.id !== 0x3B)block = parseBlock();
        return img;
    };
    me.toCanvas = function(img) {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        let imageData = new ImageData(img.width, img.height);
        img.pixels.forEach((pixel, index)=>{
            let color = img.palette[pixel] || [
                0,
                0,
                0
            ];
            imageData.data[index * 4] = color[0];
            imageData.data[index * 4 + 1] = color[1];
            imageData.data[index * 4 + 2] = color[2];
            imageData.data[index * 4 + 3] = img.transparentColorIndex === pixel ? 0 : 255;
        });
        ctx.putImageData(imageData, 0, 0);
        return canvas;
    };
    me.toFrames = function(file) {
        let data = me.parse(file);
        let img;
        // gifs should have at least one frame
        if (data && data.frames && data.frames.length) {
            img = [];
            data.frames.forEach((frame, index)=>{
                let frameCanvas = $0223a08e15d68546$var$GIF.toCanvas(frame);
                let canvas = document.createElement("canvas");
                canvas.width = data.width;
                canvas.height = data.height;
                let ctx = canvas.getContext("2d");
                ctx.fillStyle = frame.palette[data.bgColorIndex || 0];
                if (data.disposalMethod === 0 || data.disposalMethod === 1) {
                    if (index > 0) ctx.drawImage(img[index - 1], 0, 0);
                }
                if (data.disposalMethod === 2) // restore to background color
                ctx.fillRect(0, 0, canvas.width, canvas.height);
                if (data.disposalMethod === 3) {
                    if (index > 0) ctx.drawImage(img[0], 0, 0);
                }
                ctx.drawImage(frameCanvas, frame.left || 0, frame.top || 0);
                img.push(canvas);
            });
        }
        if (img) return {
            image: img,
            type: "GIF",
            data: data
        };
    };
    me.write = function(canvas) {
        // write GIF file
        // https://www.w3.org/Graphics/GIF/spec-gif89a.txt
        let frames = [
            canvas
        ];
        if (Array.isArray(canvas)) {
            frames = [];
            canvas.forEach((c, index)=>{
                frames.push((0, $jU8Uk.default).getCanvas(index));
            });
        }
        console.error(frames);
        let delayTime = 0;
        if (frames.length > 1) delayTime = 10;
        let encodedFrames = [];
        let palette = (0, $eTCYn.default).get();
        let colorDepth = 1;
        while(1 << colorDepth < palette.length)colorDepth++;
        let gctSize = colorDepth - 1;
        let colorCount = 1 << colorDepth;
        frames.forEach((frame, index)=>{
            let pixels = (0, $jU8Uk.default).generateIndexedPixels(index, true);
            encodedFrames.push((0, $3izfq.default).encode(pixels, frame.width, frame.height, colorDepth));
        });
        let headerSize = 13 + colorCount * 3;
        let gceSize = 8;
        let imageDescriptorSize = 10;
        let totalSize = headerSize + 1;
        encodedFrames.forEach((frame)=>{
            totalSize += gceSize + imageDescriptorSize + frame.length;
        });
        console.log("Total GIF size: ", totalSize);
        let file = new (0, $3QDcZ.default)(new ArrayBuffer(totalSize), false);
        //Header
        file.writeString("GIF89a");
        // Logical Screen Descriptor
        file.writeWord(frames[0].width);
        file.writeWord(frames[0].height);
        file.writeUbyte(240 | // 5 : gct sort flag = 0
        gctSize); // 6-8 : gct size
        file.writeUbyte(0); //background color index
        file.writeUbyte(0); //pixel aspect ratio
        //Global Color Table
        for(let i = 0; i < palette.length; i++){
            file.writeUbyte(palette[i][0]);
            file.writeUbyte(palette[i][1]);
            file.writeUbyte(palette[i][2]);
        }
        let remaining = colorCount - palette.length;
        for(var i = 0; i < remaining * 3; i++)file.writeUbyte(0);
        frames.forEach((frame, index)=>{
            ////Graphics Control Extension
            file.writeUbyte(0x21); //extension introducer
            file.writeUbyte(0xF9); //graphic control label
            file.writeUbyte(0x04); //block size
            var transp;
            var disp;
            let transparent = null;
            let dispose = 0;
            if (transparent === null) {
                transp = 0;
                disp = 0; // dispose = no action
            } else {
                transp = 1;
                disp = 2; // force clear if using transparent color
            }
            if (dispose >= 0) disp = dispose & 7; // user override
            disp <<= 2;
            // packed fields
            file.writeUbyte(0 | // 1:3 reserved
            disp | // 4:6 disposal
            0 | // 7 user input - 0 = none
            transp); // 8 transparency flag
            file.writeWord(delayTime); //delay time x 1/100 sec
            file.writeUbyte(0); //transparent color index
            file.writeUbyte(0); //block terminator
            //Image Descriptor
            file.writeUbyte(0x2C); //image separator
            file.writeWord(0); //image left position
            file.writeWord(0); //image top position
            file.writeWord(frame.width); //image width
            file.writeWord(frame.height); //image height
            if (index === 0) // no local color table
            file.writeUbyte(0);
            else // on second frame, if a local color table exists
            /*
                file.writeUbyte(0x80 | // 1 local color table 1=yes
                    0 | // 2 interlace - 0=no
                    0 | // 3 sorted - 0=no
                    0 | // 4-5 reserved
                    gctSize); // 6-8 size of color table

                // and write palette*/ file.writeUbyte(0);
            file.writeByteArray(encodedFrames[index]);
        });
        //Trailer
        file.writeUbyte(0x3B);
        return file.buffer;
    };
    return me;
})();
var $0223a08e15d68546$export$2e2bcd8739ae039 = $0223a08e15d68546$var$GIF;

});
parcelRegister("3izfq", function(module, exports) {

$parcel$export(module.exports, "default", () => $266e6504206d9912$export$2e2bcd8739ae039);
let $266e6504206d9912$var$LZW = function() {
    var me = {};
    me.encode = function(pixels, imgWidth, imgHeight, color_depth) {
        // adapted from https://github.com/antimatter15/jsgif/blob/master/LZWEncoder.js
        // MIT License
        // Copyright (c) 2010-2014 Kevin Kwok <antimatter15@gmail.com>
        var EOF = -1;
        var initCodeSize;
        var remaining;
        var curPixel;
        var BITS = 12;
        var HSIZE = 5003; // 80% occupancy
        var n_bits; // number of bits/code
        var maxbits = BITS; // user settable max # bits/code
        var maxcode; // maximum code, given n_bits
        var maxmaxcode = 1 << BITS; // should NEVER generate this code
        var htab = [];
        var codetab = [];
        var hsize = HSIZE; // for dynamic table sizing
        var free_ent = 0; // first unused entry
        var clear_flg = false;
        var g_init_bits;
        var ClearCode;
        var EOFCode;
        var cur_accum = 0;
        var cur_bits = 0;
        var masks = [
            0x0000,
            0x0001,
            0x0003,
            0x0007,
            0x000F,
            0x001F,
            0x003F,
            0x007F,
            0x00FF,
            0x01FF,
            0x03FF,
            0x07FF,
            0x0FFF,
            0x1FFF,
            0x3FFF,
            0x7FFF,
            0xFFFF
        ];
        var a_count;
        var accum = [];
        initCodeSize = Math.max(2, color_depth);
        let out = [];
        out.push(initCodeSize); // write "initial code size" byte
        remaining = imgWidth * imgHeight; // reset navigation variables
        curPixel = 0;
        compress(initCodeSize + 1, out); // compress and write the pixel data
        //os.writeByte(0); // write block terminator
        out.push(0); // write block terminator
        return out;
        // Add a character to the end of the current packet, and if it is 254
        // characters, flush the packet to disk.
        function char_out(c, outs) {
            accum[a_count++] = c;
            if (a_count >= 254) flush_char(outs);
        }
        // Clear out the hash table
        // table clear for block compress
        function cl_block(outs) {
            cl_hash(hsize);
            free_ent = ClearCode + 2;
            clear_flg = true;
            output(ClearCode, outs);
        }
        // reset code table
        function cl_hash(hsize) {
            for(var i = 0; i < hsize; ++i)htab[i] = -1;
        }
        function compress(init_bits, outs) {
            var fcode;
            var i; /* = 0 */ 
            var c;
            var ent;
            var disp;
            var hsize_reg;
            var hshift;
            // Set up the globals: g_init_bits - initial number of bits
            g_init_bits = init_bits;
            // Set up the necessary values
            clear_flg = false;
            n_bits = g_init_bits;
            maxcode = MAXCODE(n_bits);
            ClearCode = 1 << init_bits - 1;
            EOFCode = ClearCode + 1;
            free_ent = ClearCode + 2;
            a_count = 0; // clear packet
            ent = nextPixel();
            hshift = 0;
            for(fcode = hsize; fcode < 65536; fcode *= 2)++hshift;
            hshift = 8 - hshift; // set hash code range bound
            hsize_reg = hsize;
            cl_hash(hsize_reg); // clear hash table
            output(ClearCode, outs);
            outer_loop: while((c = nextPixel()) != EOF){
                fcode = (c << maxbits) + ent;
                i = c << hshift ^ ent; // xor hashing
                if (htab[i] == fcode) {
                    ent = codetab[i];
                    continue;
                } else if (htab[i] >= 0) {
                    disp = hsize_reg - i; // secondary hash (after G. Knott)
                    if (i === 0) disp = 1;
                    do {
                        if ((i -= disp) < 0) i += hsize_reg;
                        if (htab[i] == fcode) {
                            ent = codetab[i];
                            continue outer_loop;
                        }
                    }while (htab[i] >= 0);
                }
                output(ent, outs);
                ent = c;
                if (free_ent < maxmaxcode) {
                    codetab[i] = free_ent++; // code -> hashtable
                    htab[i] = fcode;
                } else cl_block(outs);
            }
            // Put out the final code.
            output(ent, outs);
            output(EOFCode, outs);
        }
        // ----------------------------------------------------------------------------
        // Flush the packet to disk, and reset the accumulator
        function flush_char(outs) {
            if (a_count > 0) {
                if (outs.writeByte) {
                    outs.writeByte(a_count);
                    for(var i = 0; i < a_count; i++)outs.writeByte(accum[i]);
                } else {
                    outs.push(a_count);
                    for(var i = 0; i < a_count; i++)outs.push(accum[i]);
                }
                a_count = 0;
            }
        }
        function MAXCODE(n_bits) {
            return (1 << n_bits) - 1;
        }
        // ----------------------------------------------------------------------------
        // Return the next pixel from the image
        // ----------------------------------------------------------------------------
        function nextPixel() {
            if (remaining === 0) return EOF;
            --remaining;
            var pix = pixels[curPixel++];
            return pix & 0xff;
        }
        function output(code, outs) {
            cur_accum &= masks[cur_bits];
            if (cur_bits > 0) cur_accum |= code << cur_bits;
            else cur_accum = code;
            cur_bits += n_bits;
            while(cur_bits >= 8){
                char_out(cur_accum & 0xff, outs);
                cur_accum >>= 8;
                cur_bits -= 8;
            }
            // If the next entry is going to be too big for the code size,
            // then increase it, if possible.
            if (free_ent > maxcode || clear_flg) {
                if (clear_flg) {
                    maxcode = MAXCODE(n_bits = g_init_bits);
                    clear_flg = false;
                } else {
                    ++n_bits;
                    if (n_bits == maxbits) maxcode = maxmaxcode;
                    else maxcode = MAXCODE(n_bits);
                }
            }
            if (code == EOFCode) {
                // At EOF, write the rest of the buffer.
                while(cur_bits > 0){
                    char_out(cur_accum & 0xff, outs);
                    cur_accum >>= 8;
                    cur_bits -= 8;
                }
                flush_char(outs);
            }
        }
    };
    me.decode = function(data, minCodeSize, pixelCount) {
        // adapted from https://github.com/matt-way/gifuct-js
        // MIT license
        // Copyright (c) 2015 Matt Way
        const MAX_STACK_SIZE = 4096;
        const nullCode = -1;
        const npix = pixelCount;
        let available, clear, code_mask, code_size, end_of_information, in_code, old_code, code, i, data_size;
        const dstPixels = new Array(pixelCount);
        const prefix = new Array(MAX_STACK_SIZE);
        const suffix = new Array(MAX_STACK_SIZE);
        const pixelStack = new Array(MAX_STACK_SIZE + 1);
        // Initialize GIF data stream decoder.
        data_size = minCodeSize;
        clear = 1 << data_size;
        end_of_information = clear + 1;
        available = clear + 2;
        old_code = nullCode;
        code_size = data_size + 1;
        code_mask = (1 << code_size) - 1;
        for(code = 0; code < clear; code++){
            prefix[code] = 0;
            suffix[code] = code;
        }
        // Decode GIF pixel stream.
        let datum, bits, count, first, top, pi, bi;
        datum = bits = count = first = top = pi = bi = 0;
        for(i = 0; i < npix;){
            if (top === 0) {
                if (bits < code_size) {
                    // get the next byte
                    datum += data[bi] << bits;
                    bits += 8;
                    bi++;
                    continue;
                }
                // Get the next code.
                code = datum & code_mask;
                datum >>= code_size;
                bits -= code_size;
                // Interpret the code
                if (code > available || code == end_of_information) break;
                if (code == clear) {
                    // Reset decoder.
                    code_size = data_size + 1;
                    code_mask = (1 << code_size) - 1;
                    available = clear + 2;
                    old_code = nullCode;
                    continue;
                }
                if (old_code == nullCode) {
                    pixelStack[top++] = suffix[code];
                    old_code = code;
                    first = code;
                    continue;
                }
                in_code = code;
                if (code == available) {
                    pixelStack[top++] = first;
                    code = old_code;
                }
                while(code > clear){
                    pixelStack[top++] = suffix[code];
                    code = prefix[code];
                }
                first = suffix[code] & 0xff;
                pixelStack[top++] = first;
                // add a new string to the table, but only if space is available
                // if not, just continue with current table until a clear code is found
                // (deferred clear code implementation as per GIF spec)
                if (available < MAX_STACK_SIZE) {
                    prefix[available] = old_code;
                    suffix[available] = first;
                    available++;
                    if ((available & code_mask) === 0 && available < MAX_STACK_SIZE) {
                        code_size++;
                        code_mask += available;
                    }
                }
                old_code = in_code;
            }
            // Pop a pixel off the pixel stack.
            top--;
            dstPixels[pi++] = pixelStack[top];
            i++;
        }
        for(i = pi; i < npix; i++)dstPixels[i] = 0; // clear missing pixels
        return dstPixels;
    };
    return me;
};
var $266e6504206d9912$export$2e2bcd8739ae039 = $266e6504206d9912$var$LZW();

});




parcelRegister("4QD11", function(module, exports) {

$parcel$export(module.exports, "default", () => $387a486e9f1711c0$export$2e2bcd8739ae039);

var $eJ26Q = parcelRequire("eJ26Q");

var $jU8Uk = parcelRequire("jU8Uk");
var $387a486e9f1711c0$var$ResizeDialog = function() {
    let me = {};
    let lockAspectRatio = true;
    let aspectRatio = 1;
    let anchorPoint = "center";
    me.render = function(container, modal) {
        let image = (0, $jU8Uk.default).getCurrentFile();
        aspectRatio = image.width / image.height;
        container.innerHTML = "";
        (0, $eJ26Q.$title)(3, "Resize Canvas to:", container);
        let panel = (0, $eJ26Q.$div)("panel form", "", container);
        let inputW = document.createElement("input");
        inputW.value = image.width;
        inputW.type = "number";
        let inputH = document.createElement("input");
        inputH.type = "number";
        inputH.value = image.height;
        inputW.onkeydown = modal.inputKeyDown;
        inputH.onkeydown = modal.inputKeyDown;
        inputW.oninput = ()=>{
            if (lockAspectRatio) {
                let w1 = parseInt(inputW.value);
                if (isNaN(w1)) w1 = image.width;
                inputH.value = Math.round(w1 / aspectRatio);
            }
        };
        inputH.oninput = ()=>{
            if (lockAspectRatio) {
                let h = parseInt(inputH.value);
                if (isNaN(h)) w = image.height;
                inputW.value = Math.round(h * aspectRatio);
            }
        };
        (0, $eJ26Q.$elm)("span", "width", panel, "label");
        panel.appendChild(inputW);
        (0, $eJ26Q.$elm)("span", "pixels", panel);
        (0, $eJ26Q.$elm)("br", "", panel);
        (0, $eJ26Q.$elm)("span", "height", panel, "label");
        panel.appendChild(inputH);
        (0, $eJ26Q.$elm)("span", "pixels", panel);
        let lock = (0, $eJ26Q.$div)("lock active", "", panel);
        (0, $eJ26Q.$div)("link", "", lock, ()=>{
            lockAspectRatio = !lockAspectRatio;
            lock.classList.toggle("active", lockAspectRatio);
        });
        let qbuttons = (0, $eJ26Q.$div)("quick", "", panel);
        let labels = [
            "x2",
            "/2",
            "x3",
            "/3"
        ];
        for(let i = 0; i < 4; i++)(0, $eJ26Q.$div)("button calc", labels[i], qbuttons, ()=>{
            let w1 = parseInt(inputW.value);
            let h = parseInt(inputH.value);
            if (isNaN(w1)) w1 = image.width;
            if (isNaN(h)) w1 = image.height;
            if (i === 0) {
                w1 *= 2;
                h *= 2;
            }
            if (i === 1) {
                w1 /= 2;
                h /= 2;
            }
            if (i === 2) {
                w1 *= 3;
                h *= 3;
            }
            if (i === 3) {
                w1 /= 3;
                h /= 3;
            }
            inputW.value = Math.round(w1);
            inputH.value = Math.round(h);
        });
        let anchor = (0, $eJ26Q.$div)("anchor center", "", panel);
        let zones = [
            "top left",
            "top",
            "top right",
            "left",
            "center",
            "right",
            "bottom left",
            "bottom",
            "bottom right"
        ];
        for(let i = 0; i < 9; i++)(0, $eJ26Q.$div)("hotspot", "", anchor, ()=>{
            anchorPoint = zones[i];
            anchor.className = "anchor " + anchorPoint;
        });
        (0, $eJ26Q.$div)("page", "", anchor);
        (0, $eJ26Q.$title)(3, "Anchor:", anchor);
        let directions = [
            "top",
            "right",
            "bottom",
            "left"
        ];
        for(let i = 0; i < 4; i++)(0, $eJ26Q.$div)("arrow " + directions[i], "", anchor);
        let buttons = (0, $eJ26Q.$div)("buttons", "", container);
        (0, $eJ26Q.$div)("button ghost", "Cancel", buttons, modal.hide);
        (0, $eJ26Q.$div)("button primary", "Update", buttons, ()=>{
            let w1 = parseInt(inputW.value);
            if (isNaN(w1)) w1 = image.width;
            let h = parseInt(inputH.value);
            if (isNaN(h)) w1 = image.height;
            if (w1 < 1) w1 = 1;
            if (h < 1) h = 1;
            modal.hide();
            (0, $jU8Uk.default).resize({
                width: w1,
                height: h,
                anchor: anchorPoint
            });
        });
    };
    return me;
}();
var $387a486e9f1711c0$export$2e2bcd8739ae039 = $387a486e9f1711c0$var$ResizeDialog;

});

parcelRegister("7OdK5", function(module, exports) {

$parcel$export(module.exports, "default", () => $5af7dcdb8668399b$export$2e2bcd8739ae039);

var $eJ26Q = parcelRequire("eJ26Q");

var $jU8Uk = parcelRequire("jU8Uk");
var $5af7dcdb8668399b$var$ResampleDialog = function() {
    let me = {};
    let lockAspectRatio = true;
    let aspectRatio = 1;
    me.render = function(container, modal) {
        let image = (0, $jU8Uk.default).getCurrentFile();
        aspectRatio = image.width / image.height;
        container.innerHTML = "";
        let inputW;
        let inputH;
        let lock;
        let qbuttons;
        let qualitySelect;
        (0, $eJ26Q.default)("h3", {
            parent: container
        }, "Resize Image to:");
        (0, $eJ26Q.default)(".panel.form", {
            parent: container
        }, (0, $eJ26Q.default)("span.label", "width"), inputW = (0, $eJ26Q.default)("input", {
            type: "number",
            value: image.width,
            onkeydown: modal.inputKeyDown,
            oninput: ()=>{
                if (lockAspectRatio) {
                    let w1 = parseInt(inputW.value);
                    if (isNaN(w1)) w1 = image.width;
                    inputH.value = Math.round(w1 / aspectRatio);
                }
            }
        }), (0, $eJ26Q.default)("span", "pixels"), (0, $eJ26Q.default)("br"), (0, $eJ26Q.default)("span.label", "height"), inputH = (0, $eJ26Q.default)("input", {
            type: "number",
            value: image.height,
            onkeydown: modal.inputKeyDown,
            oninput: ()=>{
                if (lockAspectRatio) {
                    let h = parseInt(inputH.value);
                    if (isNaN(h)) w = image.height;
                    inputW.value = Math.round(h * aspectRatio);
                }
            }
        }), (0, $eJ26Q.default)("span", "pixels"), lock = (0, $eJ26Q.default)(".lock.active", (0, $eJ26Q.default)(".link", {
            onClick: ()=>{
                lockAspectRatio = !lockAspectRatio;
                lock.classList.toggle("active", lockAspectRatio);
            }
        })), qbuttons = (0, $eJ26Q.default)(".quick"), qualitySelect = (0, $eJ26Q.default)("select.resize", (0, $eJ26Q.default)("option", "Pixelated"), (0, $eJ26Q.default)("option", "Smooth")));
        (0, $eJ26Q.default)(".buttons", {
            parent: container
        }, (0, $eJ26Q.default)(".button.ghost", {
            onClick: modal.hide
        }, "Cancel"), (0, $eJ26Q.default)(".button.primary", {
            onClick: ()=>{
                let w1 = parseInt(inputW.value);
                if (isNaN(w1)) w1 = image.width;
                let h = parseInt(inputH.value);
                if (isNaN(h)) w1 = image.height;
                if (w1 < 1) w1 = 1;
                if (h < 1) h = 1;
                let quality = qualitySelect.value === "Pixelated" ? "pixelated" : "smooth";
                modal.hide();
                (0, $jU8Uk.default).resample({
                    width: w1,
                    height: h,
                    quality: quality
                });
            }
        }, "Update"));
        let labels = [
            "x2",
            "/2",
            "x3",
            "/3"
        ];
        for(let i = 0; i < 4; i++)(0, $eJ26Q.$div)("button calc", labels[i], qbuttons, ()=>{
            let w1 = parseInt(inputW.value);
            let h = parseInt(inputH.value);
            if (isNaN(w1)) w1 = image.width;
            if (isNaN(h)) w1 = image.height;
            if (i === 0) {
                w1 *= 2;
                h *= 2;
            }
            if (i === 1) {
                w1 /= 2;
                h /= 2;
            }
            if (i === 2) {
                w1 *= 3;
                h *= 3;
            }
            if (i === 3) {
                w1 /= 3;
                h /= 3;
            }
            inputW.value = Math.round(w1);
            inputH.value = Math.round(h);
        });
    };
    return me;
}();
var $5af7dcdb8668399b$export$2e2bcd8739ae039 = $5af7dcdb8668399b$var$ResampleDialog;

});

parcelRegister("7nqci", function(module, exports) {

$parcel$export(module.exports, "default", () => $55ef00a4501599c5$export$2e2bcd8739ae039);

var $eJ26Q = parcelRequire("eJ26Q");

var $jU8Uk = parcelRequire("jU8Uk");

var $eTCYn = parcelRequire("eTCYn");

var $bfgOg = parcelRequire("bfgOg");
parcelRequire("fEhXZ");

var $k5ZAj = parcelRequire("k5ZAj");

var $9dDG4 = parcelRequire("9dDG4");

var $lkhKc = parcelRequire("lkhKc");

var $ex1EM = parcelRequire("ex1EM");
var $55ef00a4501599c5$var$PaletteDialog = function() {
    let me = {};
    let colorCanvas;
    let colorCanvasCtx;
    let paletteCanvas;
    let paletteCanvasCtx;
    let sliders = [];
    let tabs = {};
    let panels = {};
    let buttons;
    let inputHex;
    let colorHighlight;
    let colorPicker;
    let lockToImage = true;
    let highlight = false;
    let pixelCount;
    let currentIndex;
    let colorSize = 30;
    let palettePage = 0;
    let swapButton;
    let spreadButton;
    let paletteClickAction = "";
    let withActions = false;
    let panelContainer;
    let hsv = false;
    me.render = function(container, modal) {
        container.innerHTML = "";
        sliders = [];
        paletteClickAction = "";
        let currentColor = (0, $eTCYn.default).getDrawColor();
        let palettePanel;
        let subPanel;
        let optionsPanel;
        let contextMenu;
        (0, $eJ26Q.$setTarget)(container);
        panelContainer = (0, $eJ26Q.default)(".palette.panel.form" + (withActions ? ".withactions" : ""), palettePanel = (0, $eJ26Q.default)(".palettepanel"), (0, $eJ26Q.default)(".actions", (0, $eJ26Q.default)(".caption.sub", {
            onClick: ()=>{
                withActions = false;
                panelContainer.classList.toggle("withactions", withActions);
            }
        }, "Actions"), (0, $eJ26Q.default)(".nav", (0, $eJ26Q.default)(".zoomin", {
            onClick: ()=>{
                colorSize = Math.min(colorSize * 2, 60);
                renderPalette(palettePanel);
            },
            info: "Draw bigger color squares"
        }), (0, $eJ26Q.default)(".zoomout", {
            onClick: ()=>{
                colorSize = Math.max(colorSize / 2, 15);
                renderPalette(palettePanel);
            },
            info: "Draw smaller color squares"
        })), swapButton = (0, $eJ26Q.default)(".button.small", {
            onClick: ()=>{
                let active = paletteClickAction === "swap";
                active = !active;
                paletteClickAction = active ? "swap" : "";
                swapButton.classList.toggle("highlight", active);
                if (active) {
                    let dupe = (0, $eJ26Q.$div)("dragelement tooltip", "Swap with");
                    (0, $lkhKc.default).setDragElement(dupe, true);
                } else (0, $lkhKc.default).removeDragElement();
            },
            info: "Swap a color in the palette"
        }, "Swap"), spreadButton = (0, $eJ26Q.default)(".button.small", {
            onClick: ()=>{
                let active = paletteClickAction === "spread";
                active = !active;
                paletteClickAction = active ? "spread" : "";
                spreadButton.classList.toggle("highlight", active);
                if (active) {
                    let dupe = (0, $eJ26Q.$div)("dragelement tooltip", "Spread to");
                    (0, $lkhKc.default).setDragElement(dupe, true);
                } else (0, $lkhKc.default).removeDragElement();
            },
            info: "Create a color gradient between 2 colors in the palette."
        }, "Spread"), (0, $eJ26Q.default)(".button.small", {
            onClick: ()=>{
                (0, $eTCYn.default).addColor((0, $bfgOg.default).fromString(inputHex.value));
            },
            "info": "Add a new color"
        }, "Add"), (0, $eJ26Q.default)(".button.small", {
            onClick: ()=>{
                (0, $eTCYn.default).removeColor(currentIndex);
            },
            "info": "Remove the selected color"
        }, "Remove"), (0, $eJ26Q.default)(".spacer"), (0, $eJ26Q.default)(".button.small", {
            onClick: ()=>{
                contextMenu.classList.toggle("active");
            }
        }, "Sort", contextMenu = (0, $eJ26Q.default)(".contextmenu", (0, $eJ26Q.default)(".item", {
            onClick: ()=>{
                (0, $eTCYn.default).reverse();
                contextMenu.classList.remove("active");
            },
            "info": "Reverse the colors in the palette"
        }, "Reverse"), (0, $eJ26Q.default)(".item", {
            onClick: ()=>{
                (0, $eTCYn.default).sortByHue();
                contextMenu.classList.remove("active");
            },
            "info": "Sort by hue"
        }, "Hue"), (0, $eJ26Q.default)(".item", {
            onClick: ()=>{
                (0, $eTCYn.default).sortBySaturation();
                contextMenu.classList.remove("active");
            },
            "info": "Sort by saturation"
        }, "Saturation"), (0, $eJ26Q.default)(".item", {
            onClick: ()=>{
                (0, $eTCYn.default).sortByLightness();
                contextMenu.classList.remove("active");
            },
            "info": "Sort by lightness"
        }, "Lightness"), (0, $eJ26Q.default)(".item", {
            onClick: ()=>{
                (0, $eTCYn.default).sortByUseCount();
                contextMenu.classList.remove("active");
            },
            "info": "Sort by how much a color is used in the image (optimized for compression)"
        }, "Use Count"), (0, $eJ26Q.default)(".item", {
            onClick: ()=>{
                (0, $eTCYn.default).sortByUseCount(true);
                contextMenu.classList.remove("active");
            },
            "info": "optimize and test compression results"
        }, "File Size"))), (0, $eJ26Q.default)(".button.small", {
            onClick: ()=>{
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).LOADPALETTE);
            },
            "info": "Open palette from disk"
        }, "Load"), (0, $eJ26Q.default)(".button.small", {
            onClick: ()=>{
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).SAVEPALETTE);
            },
            "info": "Save palette to disk"
        }, "Save")), (0, $eJ26Q.default)(".mainpanel", (0, $eJ26Q.default)(".tabs", panels.colortab = (0, $eJ26Q.default)(".caption.sub", {
            onClick: toggleRangePanel
        }, "Color"), panels.rangestab = (0, $eJ26Q.default)(".caption.sub.inactive", {
            onClick: toggleRangePanel
        }, "Ranges")), panels.color = (0, $eJ26Q.default)(".colorpanel", (0, $eJ26Q.default)(".sliders", colorCanvas = (0, $eJ26Q.default)("canvas", {
            width: 60,
            height: 30,
            onclick: ()=>{
                colorPicker.click();
            }
        }), colorPicker = (0, $eJ26Q.default)("input.masked", {
            type: "color",
            value: (0, $bfgOg.default).toHex(currentColor),
            oninput: ()=>{
                inputHex.value = colorPicker.value;
                updateColor(inputHex.value);
            }
        }), pixelCount = (0, $eJ26Q.default)(".pixelcount"), inputHex = (0, $eJ26Q.default)("input.hex", {
            type: "text",
            value: (0, $bfgOg.default).toHex(currentColor),
            oninput: ()=>{
                updateColor(inputHex.value);
            },
            onkeydown: modal.inputKeyDown
        }), (0, $eJ26Q.default)(".tabs", tabs.rgb = (0, $eJ26Q.default)(".tab", {
            onClick: toggleHSV
        }, (0, $eJ26Q.default)("span", "R G B")), tabs.hsv = (0, $eJ26Q.default)(".tab.inactive", {
            onClick: toggleHSV
        }, (0, $eJ26Q.default)("span", "H S V")), subPanel = (0, $eJ26Q.default)(".panel"))), buttons = (0, $eJ26Q.default)(".buttons"), optionsPanel = (0, $eJ26Q.default)(".options")), panels.ranges = (0, $eJ26Q.default)(".rangepanel")));
        renderPalette(palettePanel);
        colorCanvasCtx = colorCanvas.getContext("2d");
        colorCanvasCtx.fillStyle = currentColor;
        colorCanvasCtx.fillRect(0, 0, 60, 30);
        let RGBValues = (0, $bfgOg.default).fromString(currentColor);
        [
            "red",
            "green",
            "blue"
        ].forEach((color, index)=>{
            let slider = (0, $eJ26Q.$div)("slider", "", subPanel);
            let range = document.createElement("input");
            range.type = "range";
            range.className = "slider " + color;
            range.max = 255;
            range.value = RGBValues[index];
            range.addEventListener("wheel", function(e) {
                range.value = parseInt(range.value) + Math.sign(e.deltaY);
                range.oninput();
            });
            slider.appendChild(range);
            let label = (0, $eJ26Q.$elm)("span", color, slider, "label");
            let input = document.createElement("input");
            input.type = "text";
            input.className = "rangevalue";
            input.value = RGBValues[index];
            input.onkeydown = modal.inputKeyDown;
            slider.appendChild(input);
            sliders.push({
                range: range,
                input: input,
                label: label
            });
            range.oninput = ()=>{
                input.value = range.value;
                let newColor = [
                    sliders[0].input.value,
                    sliders[1].input.value,
                    sliders[2].input.value
                ];
                if (hsv) newColor = (0, $bfgOg.default).fromHSV(sliders[0].range.value / 360, sliders[1].range.value / 100, sliders[2].range.value / 100);
                updateColor(newColor);
            };
            input.oninput = ()=>{
                let value = parseInt(input.value);
                if (isNaN(value)) value = 0;
                if (value < 0) value = 0;
                if (value > 255) value = 255;
                range.value = input.value;
                let newColor = [
                    sliders[0].range.value,
                    sliders[1].range.value,
                    sliders[2].range.value
                ];
                updateColor(newColor);
            };
        //currentIndex = 0;
        });
        (0, $eJ26Q.$div)("button small revert", "Revert", buttons, ()=>{
            setColor((0, $eTCYn.default).get()[currentIndex], currentIndex);
        });
        (0, $eJ26Q.$div)("button small apply", "Apply", buttons, ()=>{
            let color = (0, $bfgOg.default).fromString(inputHex.value);
            (0, $eTCYn.default).updateColor(currentIndex, color);
            let colorsPerPage = paletteCanvas.width / colorSize * paletteCanvas.height / colorSize;
            let start = palettePage * colorsPerPage;
            drawColor(color, currentIndex - start);
            colorCanvasCtx.fillStyle = (0, $bfgOg.default).toString(color);
            colorCanvasCtx.fillRect(0, 0, 60, 30);
            if (lockToImage) {
                let currentHighLight = (0, $jU8Uk.default).getLayerIndexesOfType("pixelSelection");
                if (currentHighLight.length) {
                    let newIndex = (0, $jU8Uk.default).getActiveLayerIndex() + 1;
                    (0, $jU8Uk.default).moveLayer(currentHighLight[0], newIndex);
                    (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).MERGEDOWN, newIndex);
                }
            }
        });
        (0, $eJ26Q.$checkbox)("Update image with color changes", optionsPanel, "", (checked)=>{
            lockToImage = checked;
        }, lockToImage);
        (0, $eJ26Q.$checkbox)("HighLight pixels that use selected color", optionsPanel, "", (checked)=>{
            highlight = checked;
            setPixelHighLights();
        }, highlight);
        if (hsv) {
            hsv = false;
            toggleHSV();
        }
    };
    me.onClose = function() {
        removePixelHighLigts();
        me.clearPaletteClickAction();
        paletteCanvas = null;
        (0, $ex1EM.default).cleanUp();
    };
    me.setPaletteClickAction = (action)=>{
        paletteClickAction = action;
    };
    me.clearPaletteClickAction = function() {
        paletteClickAction = "";
        (0, $lkhKc.default).removeDragElement();
    };
    function toggleHSV() {
        hsv = !hsv;
        tabs.rgb.classList.toggle("inactive", hsv);
        tabs.hsv.classList.toggle("inactive", !hsv);
        let color = (0, $bfgOg.default).fromString(inputHex.value);
        let labels = [
            "Red",
            "Green",
            "Blue"
        ];
        let max = [
            255,
            255,
            255
        ];
        if (hsv) {
            color = (0, $bfgOg.default).toHSV(color, true);
            labels = [
                "Hue",
                "Sat.",
                "Value"
            ];
            max = [
                360,
                100,
                100
            ];
        }
        sliders.forEach((slider, index)=>{
            slider.range.max = max[index];
            slider.range.value = slider.input.value = color[index];
            slider.label.innerText = labels[index];
            slider.range.classList.toggle("hsv", hsv);
        });
    }
    function toggleRangePanel() {
        if (panels.colortab.classList.contains("inactive")) {
            panels.colortab.classList.remove("inactive");
            panels.rangestab.classList.add("inactive");
            panels.color.style.display = "block";
            panels.ranges.style.display = "none";
            (0, $ex1EM.default).cleanUp();
        } else {
            panels.colortab.classList.add("inactive");
            panels.rangestab.classList.remove("inactive");
            panels.color.style.display = "none";
            panels.ranges.style.display = "block";
            (0, $ex1EM.default).render(panels.ranges);
        }
    }
    function renderPalette(parent) {
        parent.innerHTML = "";
        paletteCanvas = (0, $eJ26Q.default)("canvas", {
            width: 120,
            height: 240
        });
        paletteCanvasCtx = paletteCanvas.getContext("2d");
        let colors = (0, $eTCYn.default).get();
        colorHighlight = (0, $eJ26Q.$div)("highlight", "", parent);
        let colorsPerPage = paletteCanvas.width / colorSize * paletteCanvas.height / colorSize;
        let pageCount = Math.ceil(colors.length / colorsPerPage);
        if (palettePage >= pageCount) palettePage = pageCount - 1;
        let isInRange = ()=>{
            return false;
        };
        if ((0, $ex1EM.default).getActiveRange() !== undefined) {
            let range = (0, $jU8Uk.default).getCurrentFile().colorRange[(0, $ex1EM.default).getActiveRange()];
            isInRange = (index)=>{
                return index >= range.low && index <= range.high;
            };
        }
        let start = palettePage * colorsPerPage;
        let end = start + colorsPerPage;
        for(let i = start; i < end; i++){
            if (!colors[i]) break;
            drawColor(colors[i], i - start, isInRange(i));
        }
        paletteCanvas.onpointerdown = function(e) {
            const rect = paletteCanvas.getBoundingClientRect();
            const x = Math.floor((e.clientX - rect.left) / colorSize);
            const y = Math.floor((e.clientY - rect.top) / colorSize);
            let colorsPerRow = paletteCanvas.width / colorSize;
            let index = y * colorsPerRow + x + start;
            if (paletteClickAction === "swap") {
                (0, $eTCYn.default).swapColors(currentIndex, index);
                me.clearPaletteClickAction();
                swapButton.classList.remove("highlight");
            }
            if (paletteClickAction === "spread") {
                (0, $eTCYn.default).spreadColors(currentIndex, index);
                me.clearPaletteClickAction();
                spreadButton.classList.remove("highlight");
            }
            if (paletteClickAction === "rangeto") {
                (0, $ex1EM.default).setTo(index);
                me.clearPaletteClickAction();
            }
            if (paletteClickAction === "rangefrom") {
                (0, $ex1EM.default).setFrom(index);
                (0, $lkhKc.default).removeDragElement();
                let dupe = (0, $eJ26Q.$div)("dragelement tooltip", "Select range: To color");
                (0, $lkhKc.default).setDragElement(dupe, true);
                paletteClickAction = "rangeto";
            }
            setColor(colors[index], index);
        };
        parent.appendChild((0, $eJ26Q.default)(".caption.sub", {
            onClick: ()=>{
                withActions = !withActions;
                panelContainer.classList.toggle("withactions", withActions);
            },
            info: "Show palette and color actions"
        }, "Palette"));
        parent.appendChild(paletteCanvas);
        if (colors.length > colorsPerPage) (0, $eJ26Q.default)(".nav", {
            parent: parent
        }, (0, $eJ26Q.default)(".prev" + (palettePage ? ".active" : ""), {
            onClick: ()=>{
                palettePage--;
                renderPalette(parent);
            }
        }), (0, $eJ26Q.default)(".page", "" + (palettePage + 1)), (0, $eJ26Q.default)(".next" + (palettePage < pageCount - 1 ? ".active" : ""), {
            onClick: ()=>{
                palettePage++;
                renderPalette(parent);
            }
        }));
        else palettePage = 0;
        setColorSelection();
    }
    function drawColor(color, index, highlight) {
        let colorsPerRow = paletteCanvas.width / colorSize;
        let x = index % colorsPerRow * colorSize;
        let y = Math.floor(index / colorsPerRow) * colorSize;
        let c = (0, $bfgOg.default).toString(color);
        paletteCanvasCtx.fillStyle = c;
        paletteCanvasCtx.fillRect(x, y, colorSize, colorSize);
        if (highlight) {
            paletteCanvasCtx.beginPath();
            paletteCanvasCtx.strokeStyle = "rgba(255,255,255,0.8)";
            paletteCanvasCtx.lineWidth = 1;
            paletteCanvasCtx.rect(x + 1.5, y + 1.5, colorSize - 3, colorSize - 3);
            paletteCanvasCtx.closePath();
            paletteCanvasCtx.stroke();
        }
        if (c === (0, $eTCYn.default).getDrawColor()) {
            currentIndex = index;
            colorHighlight.style.left = x + "px";
            colorHighlight.style.top = y + "px";
        }
    }
    function setColor(color, index) {
        if (index >= (0, $eTCYn.default).get().length) return;
        currentIndex = index;
        (0, $eTCYn.default).setColorIndex(index);
    }
    function setColorSelection() {
        let colorsPerRow = paletteCanvas.width / colorSize;
        let colorsPerPage = colorsPerRow * paletteCanvas.height / colorSize;
        let visualIndex = currentIndex - palettePage * colorsPerPage;
        if (visualIndex < 0 || visualIndex >= colorsPerPage) colorHighlight.style.display = "none";
        else {
            colorHighlight.style.display = "block";
            colorHighlight.style.left = visualIndex % colorsPerRow * colorSize + "px";
            colorHighlight.style.top = Math.floor(visualIndex / colorsPerRow) * colorSize + "px";
            colorHighlight.style.width = colorHighlight.style.height = colorSize + "px";
        }
    }
    function setPixelHighLights() {
        removePixelHighLigts();
        if (highlight) (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).COLORMASK);
    }
    function removePixelHighLigts() {
        let currentHighLight = (0, $jU8Uk.default).getLayerIndexesOfType("pixelSelection");
        currentHighLight.forEach((layerIndex)=>{
            (0, $jU8Uk.default).removeLayer(layerIndex);
        });
    }
    function updateColor(color) {
        if (typeof color === "string" && color.substr(0, 1) === "#") {
            color = color + "000000";
            color = color.substr(0, 7);
            color = (0, $bfgOg.default).fromString(color);
            if (hsv) color = (0, $bfgOg.default).toHSV(color, true);
            sliders.forEach((slider, index)=>{
                slider.range.value = slider.input.value = color[index];
            });
        } else inputHex.value = (0, $bfgOg.default).toHex(color);
        colorCanvasCtx.fillStyle = (0, $bfgOg.default).toString(color);
        colorCanvasCtx.fillRect(30, 0, 30, 30);
        if (lockToImage) {
            let currentHighLight = (0, $jU8Uk.default).getLayerIndexesOfType("pixelSelection");
            if (!currentHighLight.length) {
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).COLORMASK, true);
                currentHighLight = (0, $jU8Uk.default).getLayerIndexesOfType("pixelSelection");
            }
            let colorLayer = (0, $jU8Uk.default).getLayer(currentHighLight[0]);
            if (colorLayer) {
                colorLayer.fill(color);
                (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).imageContentChanged);
            } else console.error("colorLayer not found");
        }
        buttons.classList.add("active");
    //buttons.forEach(button=>{button.classList.add("active")})
    }
    (0, $9dDG4.default).on((0, $k5ZAj.EVENT).colorCount, (count)=>{
        if (highlight) pixelCount.innerHTML = "Used on<br>" + count + " pixels";
    });
    (0, $9dDG4.default).on((0, $k5ZAj.EVENT).paletteChanged, ()=>{
        if (paletteCanvas) {
            console.log("render palette");
            renderPalette(paletteCanvas.parentNode);
        }
    });
    (0, $9dDG4.default).on((0, $k5ZAj.EVENT).colorCycleChanged, (index)=>{
        if (!paletteCanvas) return;
        let image = (0, $jU8Uk.default).getCurrentFile();
        let range = image.colorRange[index];
        for(let i = range.low; i <= range.high; i++){
            let index = i - (range.index || 0);
            if (index < range.low) index += range.max;
            let color = (0, $eTCYn.default).get()[index];
            let colorsPerRow = paletteCanvas.width / colorSize;
            let rows = Math.floor(paletteCanvas.height / colorSize);
            let start = palettePage * colorsPerRow * rows;
            if (i >= start && i < start + colorsPerRow * rows) {
                let x = (i - start) % colorsPerRow * colorSize;
                let y = Math.floor((i - start) / colorsPerRow) * colorSize;
                paletteCanvasCtx.fillStyle = (0, $bfgOg.default).toString(color);
                paletteCanvasCtx.fillRect(x, y, colorSize, colorSize);
            }
        }
    });
    (0, $9dDG4.default).on((0, $k5ZAj.EVENT).colorRangeChanged, ()=>{
        if (paletteCanvas) renderPalette(paletteCanvas.parentNode);
    });
    (0, $9dDG4.default).on((0, $k5ZAj.EVENT).drawColorChanged, ()=>{
        if (paletteCanvas) {
            let color = (0, $eTCYn.default).getDrawColor();
            currentIndex = (0, $eTCYn.default).getDrawColorIndex();
            colorCanvasCtx.fillStyle = (0, $bfgOg.default).toString(color);
            colorCanvasCtx.fillRect(0, 0, 60, 30);
            inputHex.value = colorPicker.value = (0, $bfgOg.default).toHex(color);
            color = hsv ? (0, $bfgOg.default).toHSV(color, true) : (0, $bfgOg.default).fromString(color);
            sliders.forEach((slider, _index)=>{
                slider.range.value = color[_index];
                slider.input.value = color[_index];
            });
            setPixelHighLights();
            setColorSelection();
            buttons.classList.remove("active");
        }
    });
    return me;
}();
var $55ef00a4501599c5$export$2e2bcd8739ae039 = $55ef00a4501599c5$var$PaletteDialog;

});
parcelRegister("ex1EM", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9456ebdca79943b$export$2e2bcd8739ae039);

var $jU8Uk = parcelRequire("jU8Uk");

var $eJ26Q = parcelRequire("eJ26Q");

var $lkhKc = parcelRequire("lkhKc");

var $bqUff = parcelRequire("bqUff");

var $eTCYn = parcelRequire("eTCYn");

var $9dDG4 = parcelRequire("9dDG4");

var $k5ZAj = parcelRequire("k5ZAj");

var $bfgOg = parcelRequire("bfgOg");

var $7nqci = parcelRequire("7nqci");
let $a9456ebdca79943b$var$ColorRange = function() {
    let me = {};
    let colorRangeContext = [];
    let playButton;
    let container;
    let currentRange = undefined;
    let rangesPanel;
    me.render = (parent)=>{
        container = parent || container;
        container.innerHTML = "";
        colorRangeContext = [];
        let image = (0, $jU8Uk.default).getCurrentFile();
        let buttons = (0, $eJ26Q.default)(".bottom", {
            parent: container
        }, (0, $eJ26Q.default)(".button.small.add", {
            onclick: ()=>{
                (0, $jU8Uk.default).addRange();
            }
        }, "Add Range"));
        if (image.colorRange && image.colorRange.length) {
            (0, $eJ26Q.default)(".captions", {
                parent: container
            }, (0, $eJ26Q.default)(".a", "Active"), (0, $eJ26Q.default)(".b", "Speed (fps)"), (0, $eJ26Q.default)(".c", "Colors"));
            rangesPanel = (0, $eJ26Q.default)(".ranges", {
                parent: container,
                onClick: deActivateRange
            });
            image.colorRange.forEach((range, index)=>{
                let rangeContainer = (0, $eJ26Q.$div)("range" + (currentRange === index ? " active" : ""), "", rangesPanel, ()=>{
                    deActivateRange();
                    currentRange = index;
                    rangeContainer.classList.add("active");
                    (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).colorRangeChanged);
                });
                (0, $eJ26Q.$checkbox)("", rangeContainer, "", (checked)=>{
                    range.active = checked;
                    colorRangeContext[index].canvas.classList.toggle("inactive", !checked);
                }, range.active);
                let slider = (0, $eJ26Q.default)("input.slider", {
                    type: "range",
                    parent: rangeContainer,
                    min: -60,
                    max: 60,
                    value: range.fps * (range.reverse ? -1 : 1),
                    oninput: ()=>{
                        range.fps = Math.abs(slider.value);
                        speed.value = slider.value;
                        range.reverse = slider.value < 0;
                    }
                });
                let speed = (0, $eJ26Q.default)("input.speed", {
                    type: "text",
                    parent: rangeContainer,
                    value: range.fps * (range.reverse ? -1 : 1),
                    oninput: ()=>{
                        range.fps = Math.abs(speed.value);
                        slider.value = speed.value;
                        range.reverse = speed.value < 0;
                    },
                    onkeydown: (e)=>{
                        e.stopPropagation();
                    }
                });
                if (range.high) {
                    range.low = range.low || 0;
                    let length = range.high - range.low + 1;
                    let canvas = (0, $eJ26Q.default)("canvas", {
                        width: length * 10,
                        height: 20,
                        parent: rangeContainer,
                        onClick: ()=>{
                            canvas.classList.toggle("active");
                            if (canvas.classList.contains("active")) {
                                deActivateRange();
                                (0, $7nqci.default).setPaletteClickAction("rangefrom");
                                currentRange = index;
                                canvas.classList.add("active");
                                rangeContainer.classList.add("active");
                                let dupe = (0, $eJ26Q.$div)("dragelement tooltip", "Select range: From color");
                                (0, $lkhKc.default).setDragElement(dupe, true);
                                (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).colorRangeChanged);
                            } else (0, $7nqci.default).clearPaletteClickAction();
                        }
                    });
                    drawRange(canvas.getContext("2d"), range);
                    colorRangeContext[index] = canvas.getContext("2d");
                }
            });
            playButton = (0, $eJ26Q.$div)("button small" + ((0, $bqUff.default).isRunning() ? " active" : ""), (0, $bqUff.default).isRunning() ? "Stop" : "Play", buttons, (0, $eTCYn.default).cycle);
        } else (0, $eJ26Q.$div)("norange", "No ranges specified", container);
    };
    me.cleanUp = ()=>{
        colorRangeContext = [];
        currentRange = undefined;
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).colorRangeChanged);
    };
    me.getActiveRange = ()=>{
        return currentRange;
    };
    me.setFrom = (index)=>{
        let range = (0, $jU8Uk.default).getCurrentFile().colorRange[currentRange];
        range.low = index;
        updateRange(range);
    };
    me.setTo = (index)=>{
        let range = (0, $jU8Uk.default).getCurrentFile().colorRange[currentRange];
        range.high = index;
        updateRange(range, true);
    };
    function deActivateRange() {
        currentRange = undefined;
        if (rangesPanel) {
            let r = rangesPanel.querySelector(".range.active");
            if (r) {
                r.classList.remove("active");
                r.querySelector("canvas").classList.remove("active");
            }
            (0, $7nqci.default).clearPaletteClickAction();
        }
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).colorRangeChanged);
    }
    function updateRange(range, done) {
        if (range.low > range.high) {
            if (done) {
                let temp = range.low;
                range.low = range.high;
                range.high = temp;
            } else range.high = range.low;
        }
        let ctx = colorRangeContext[currentRange];
        if (ctx) {
            let length = range.high - range.low + 1;
            ctx.canvas.width = length * 10;
            if (done) ctx.canvas.classList.remove("active");
            drawRange(ctx, range);
        }
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).colorRangeChanged);
    }
    function drawRange(ctx, range) {
        for(let i = range.low; i <= range.high; i++){
            let index = i - (range.index || 0);
            if (index < range.low) index += range.max;
            let color = (0, $eTCYn.default).get()[index];
            ctx.fillStyle = (0, $bfgOg.default).toString(color);
            ctx.fillRect((i - range.low) * 10, 0, 10, 20);
        }
    }
    (0, $9dDG4.default).on((0, $k5ZAj.EVENT).colorCycleToggled, ()=>{
        if (playButton) {
            let isActive = (0, $bqUff.default).isRunning();
            playButton.classList.toggle("active", isActive);
            playButton.innerHTML = isActive ? "Stop" : "Play";
        }
    });
    (0, $9dDG4.default).on((0, $k5ZAj.EVENT).colorRangesChanged, ()=>{
        me.render();
    });
    (0, $9dDG4.default).on((0, $k5ZAj.EVENT).colorCycleChanged, (index)=>{
        if (colorRangeContext[index]) {
            let range = (0, $jU8Uk.default).getCurrentFile().colorRange[index];
            drawRange(colorRangeContext[index], range);
        }
    });
    return me;
}();
var $a9456ebdca79943b$export$2e2bcd8739ae039 = $a9456ebdca79943b$var$ColorRange;

});
parcelRegister("bqUff", function(module, exports) {

$parcel$export(module.exports, "default", () => $852dc07973175586$export$2e2bcd8739ae039);
let $852dc07973175586$var$Animator = function() {
    let me = {};
    let running = false;
    let tickFunctions = [];
    me.start = function(tickFunction, fps) {
        let tick = {
            tickFunction: tickFunction,
            fps: fps,
            fpsInterval: 1000 / fps,
            then: window.performance.now(),
            startTime: window.performance.now()
        };
        tickFunctions.push(tick);
        if (!running) {
            running = true;
            requestAnimationFrame(animate);
        }
    };
    me.stop = function() {
        running = false;
        tickFunctions = [];
    };
    me.isRunning = function() {
        return running;
    };
    function animate(newtime) {
        if (!running) return;
        requestAnimationFrame(animate);
        tickFunctions.forEach((tick)=>{
            tick.now = newtime;
            tick.elapsed = tick.now - tick.then;
            if (tick.elapsed > tick.fpsInterval) {
                tick.then = tick.now - tick.elapsed % tick.fpsInterval;
                tick.tickFunction();
            }
        });
    }
    return me;
}();
var $852dc07973175586$export$2e2bcd8739ae039 = $852dc07973175586$var$Animator;

});



parcelRegister("jR9CC", function(module, exports) {

$parcel$export(module.exports, "default", () => $e74a6e47269cc2d7$export$2e2bcd8739ae039);

var $eJ26Q = parcelRequire("eJ26Q");

var $fldBw = parcelRequire("fldBw");

var $8FLxR = parcelRequire("8FLxR");

var $jU8Uk = parcelRequire("jU8Uk");
parcelRequire("fEhXZ");

var $9xub8 = parcelRequire("9xub8");

var $9dDG4 = parcelRequire("9dDG4");

var $k5ZAj = parcelRequire("k5ZAj");

var $8SKzz = parcelRequire("8SKzz");

var $eTCYn = parcelRequire("eTCYn");
parcelRequire("lPw7G");

var $eZZbx = parcelRequire("eZZbx");
var EffectDialog = function() {
    let me = {};
    let effects = [];
    let previewCanvas;
    let livePreview = true;
    let codePanel;
    let currentSource;
    let currentRecipeSource;
    let mainPanel;
    me.render = function(container, modal) {
        if (!previewCanvas) {
            previewCanvas = document.createElement("canvas");
            previewCanvas.width = 200;
            previewCanvas.height = 200;
        }
        container.innerHTML = "";
        mainPanel = (0, $eJ26Q.$div)("effects panel form", "", container);
        let tabs = (0, $eJ26Q.$div)("tabs", "", mainPanel);
        let generalTab = (0, $eJ26Q.$div)("tab active", "General", tabs, ()=>{
            generalTab.classList.add("active");
            alchemyTab.classList.remove("active");
            sliders.classList.add("active");
            alchemy.classList.remove("active");
            if (codePanel) {
                codePanel.innerHTML = "";
                codePanel = undefined;
            }
        });
        let alchemyTab = (0, $eJ26Q.$div)("tab", "Alchemy", tabs, ()=>{
            generalTab.classList.remove("active");
            alchemyTab.classList.add("active");
            sliders.classList.remove("active");
            alchemy.classList.add("active");
        });
        let sliders = (0, $eJ26Q.$div)("sliders active", "", mainPanel);
        currentSource = (0, $9xub8.duplicateCanvas)((0, $jU8Uk.default).getActiveLayer().getCanvas(), true);
        (0, $eZZbx.default).start((0, $k5ZAj.EVENT).layerContentHistory);
        (0, $fldBw.default).setSrcTarget(currentSource, previewCanvas.getContext("2d"));
        createSlider(sliders, "Brightness", 0, -50, 50, (value)=>{
            (0, $fldBw.default).setBrightness(value);
            update();
        });
        createSlider(sliders, "Contrast", 0, -50, 50, (value)=>{
            (0, $fldBw.default).setContrast(value);
            update();
        });
        createSlider(sliders, "Saturation", 0, -50, 50, (value)=>{
            (0, $fldBw.default).setSaturation(value);
            update();
        });
        createSlider(sliders, "Hue", 0, -180, 180, (value)=>{
            (0, $fldBw.default).setHue(value);
            update();
        });
        createSlider(sliders, "Blur", 0, 0, 100, (value)=>{
            (0, $fldBw.default).setBlur(value);
            update();
        });
        createSlider(sliders, "Sharpen", 0, 0, 100, (value)=>{
            (0, $fldBw.default).setSharpen(value);
            update();
        });
        createSlider(sliders, "Sepia", 0, 0, 100, (value)=>{
            (0, $fldBw.default).setSepia(value);
            update();
        });
        createSlider(sliders, "Invert", 0, 0, 100, (value)=>{
            (0, $fldBw.default).setInvert(value);
            update();
        });
        createSlider(sliders, "Cyan/Red", 0, -100, 100, (value)=>{
            (0, $fldBw.default).setColorBalance("red", value);
            update();
        });
        createSlider(sliders, "Magenta/Green", 0, -100, 100, (value)=>{
            (0, $fldBw.default).setColorBalance("green", value);
            update();
        });
        createSlider(sliders, "Yellow/Blue", 0, -100, 100, (value)=>{
            (0, $fldBw.default).setColorBalance("blue", value);
            update();
        });
        /* alchemy */ codePanel = undefined;
        let alchemy = (0, $eJ26Q.$div)("alchemy", "", mainPanel);
        let recipes = [
            {
                name: "Dabble",
                file: "dots"
            },
            {
                name: "Speckles",
                file: "speckles"
            },
            {
                name: "Lines",
                file: "lines"
            },
            {
                name: "Glow",
                file: "glow"
            },
            {
                name: "Frost",
                file: "web"
            }
        ];
        recipes.forEach((recipe)=>{
            (0, $eJ26Q.$div)("recipe", recipe.name, alchemy, ()=>{
                loadRecipe(recipe.file, recipe.name);
            });
        });
        /* previewPanel */ let previewPanel = (0, $eJ26Q.$div)("previewpanel", "", mainPanel);
        let p = (0, $eJ26Q.$div)("preview", "", previewPanel);
        p.appendChild(previewCanvas);
        (0, $eJ26Q.$checkbox)("Preview", previewPanel, "", (checked)=>{
            livePreview = checked;
            update();
        }, livePreview);
        let buttons = (0, $eJ26Q.$div)("buttons", "", mainPanel);
        (0, $eJ26Q.$div)("button ghost left", "Reset", buttons, ()=>{
            (0, $fldBw.default).hold();
            effects.forEach((slider)=>{
                slider.value = 0;
                slider.oninput();
            });
            (0, $fldBw.default).apply();
        });
        (0, $eJ26Q.$div)("button ghost", "Cancel", buttons, ()=>{
            let t = (0, $jU8Uk.default).getActiveLayer().getContext();
            t.clearRect(0, 0, t.canvas.width, t.canvas.height);
            t.drawImage(currentSource, 0, 0);
            (0, $fldBw.default).clear();
            modal.hide();
            (0, $9xub8.releaseCanvas)(currentSource);
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layerContentChanged);
            (0, $eZZbx.default).neverMind();
        });
        (0, $eJ26Q.$div)("button primary", "Apply", buttons, ()=>{
            if (codePanel) ;
            else {
                let t = (0, $jU8Uk.default).getActiveLayer().getContext();
                (0, $fldBw.default).setSrcTarget(currentSource, t);
                (0, $fldBw.default).apply();
            }
            (0, $fldBw.default).clear();
            (0, $9xub8.releaseCanvas)(currentSource);
            modal.hide();
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layerContentChanged);
            if ((0, $eTCYn.default).isLocked()) (0, $eTCYn.default).apply();
            (0, $eZZbx.default).end();
        });
        (0, $fldBw.default).clear();
    };
    function createSlider(parent, label, value, min, max, onInput, isCustom, onChange) {
        let result = (0, $eJ26Q.$div)("slider");
        let labelElm = (0, $eJ26Q.$elm)("label", label, result);
        let range = (0, $eJ26Q.$input)("range", value, result);
        let valueElm = (0, $eJ26Q.$input)("text", value, result);
        range.min = min || 0;
        range.max = max || 100;
        range.className = label.toLowerCase().split("/")[0];
        range.ondblclick = ()=>{
            range.value = value;
            range.oninput();
        };
        range.oninput = ()=>{
            valueElm.value = range.value;
            if (onInput) onInput(range.value);
        };
        valueElm.onkeydown = (0, $8FLxR.default).inputKeyDown;
        valueElm.oninput = ()=>{
            let p = parseInt(valueElm.value);
            if (isNaN(p)) p = 0;
            if (p < min) p = min;
            if (p > max) p = max;
            range.value = p;
            if (onInput) onInput(range.value);
        };
        valueElm.onchange = ()=>{
            if (onChange) onChange();
        };
        if (onChange) range.onchange = onChange;
        if (parent) parent.appendChild(result);
        if (!isCustom) effects.push(range);
        return result;
    }
    function update() {
        if (livePreview) {
            (0, $fldBw.default).setSrcTarget(currentSource, (0, $jU8Uk.default).getActiveLayer().getContext());
            (0, $fldBw.default).apply();
            (0, $fldBw.default).setSrcTarget(currentSource, previewCanvas.getContext("2d"));
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layerContentChanged);
        }
    }
    async function loadRecipe(recipe, name) {
        let textarea;
        let button;
        let process;
        if (codePanel) {
            codePanel.remove();
            codePanel = undefined;
        }
        codePanel = (0, $eJ26Q.$div)("code", "", mainPanel);
        textarea = (0, $8SKzz.default)(codePanel, (value)=>{
            console.log("updating function");
            let f = new Function("source", "target", "return " + value);
            process = f();
        });
        let run = (0, $eJ26Q.$div)("button primary", "Run", codePanel, ()=>{
            if (typeof process === "function") {
                let source = currentSource;
                //let target = ImageFile.getActiveLayer().getContext();
                let target = previewCanvas.getContext("2d");
                process(source, target);
                if (livePreview) {
                    target = (0, $jU8Uk.default).getActiveLayer().getContext();
                    process(source, target);
                }
                (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layerContentChanged);
            }
        });
        process = (await import("../../alchemy/" + recipe + ".js")).default;
        if (typeof process === "function") {
            let value = process.toString();
            let exposeIndex = value.indexOf("expose=");
            let exposeIndexEnd = 0;
            if (exposeIndex < 0) exposeIndex = value.indexOf("expose =");
            if (exposeIndex >= 0) {
                let expose = value.substring(exposeIndex);
                let bracketCount = 0;
                let bracketFound = false;
                for(let i = 1; i < expose.length; i++){
                    if (expose[i] === "{") bracketCount++;
                    if (expose[i] === "}") {
                        bracketCount--;
                        bracketFound = true;
                    }
                    if (bracketFound && bracketCount === 0) {
                        exposeIndexEnd = i;
                        let endOfLine = expose.indexOf("\n", exposeIndexEnd);
                        if (endOfLine >= 0) exposeIndexEnd = endOfLine;
                        expose = expose.substring(0, i + 1);
                        break;
                    }
                }
                try {
                    let exposed = eval(expose);
                    if (exposed && typeof exposed === "object" && Object.keys(exposed).length > 0) renderRecipeParams(exposed);
                } catch (e) {
                    console.error(e);
                }
            }
            textarea.setValue(value);
            currentRecipeSource = value;
            if (exposeIndex > 0 && exposeIndexEnd > 0) currentRecipeSource = value.substring(0, exposeIndex) + "###exposed###" + value.substring(exposeIndex + exposeIndexEnd);
        }
        function renderRecipeParams(params) {
            let paramPanel = (0, $eJ26Q.$div)("params", "<h3>Parameters for '" + name + "'</h3>", codePanel);
            let keys = Object.keys(params);
            if (keys.length > 5) paramPanel.classList.add("columns");
            keys.forEach((key)=>{
                let param = params[key];
                // parent,label,value,min,max,onInput,isCustom
                let slider = createSlider(paramPanel, camelCaseToSpace(key), param.value, param.min, param.max, (value)=>{
                    params[key].value = parseFloat(value);
                    let expose = "expose = {\n";
                    Object.keys(params).forEach((key)=>{
                        expose += "        " + key + ": " + JSON.stringify(params[key]) + ",\n";
                    });
                    expose += "    };";
                    textarea.setValue(currentRecipeSource.replace("###exposed###", expose));
                }, true, ()=>{
                    textarea.onChange();
                    run.onClick();
                });
                if (param.main) slider.classList.add("main");
            });
        }
    }
    function camelCaseToSpace(str) {
        let result = "";
        for(let i = 0; i < str.length; i++){
            let c = str[i];
            if (c === c.toUpperCase()) result += " " + c;
            else result += c;
        }
        return result;
    }
    return me;
}();
var $e74a6e47269cc2d7$export$2e2bcd8739ae039 = EffectDialog;

});
parcelRegister("fldBw", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2b35eb6bd3fbb60$export$2e2bcd8739ae039);

var $3q6B6 = parcelRequire("3q6B6");
let $b2b35eb6bd3fbb60$var$Effects = function() {
    let me = {};
    let filters = {};
    let _src, _target;
    let maskCanvas;
    let doApply = true;
    let customFilters = {
        sharpen: function(value) {
            sharpen(_target, _target.canvas.width, _target.canvas.height, value);
        },
        blur: function(value) {
            $3q6B6.canvasRGBA(_target.canvas, 0, 0, _target.canvas.width, _target.canvas.height, value);
        },
        red: function(value) {
            if (value) overlayColor(value > 0 ? "#F50A0A" : "#0AF5F5", Math.abs(value / 3));
        },
        green: function(value) {
            if (value) overlayColor(value > 0 ? "#0AF50A" : "#F50AF5", Math.abs(value / 3));
        },
        blue: function(value) {
            if (value) overlayColor(value > 0 ? "#0A0AF5" : "#F5F50A", Math.abs(value / 3));
        }
    };
    me.clear = ()=>{
        filters = {};
        maskCanvas = null;
    };
    me.setBrightness = (value, src, target)=>{
        me.setSrcTarget(src, target);
        value = parseInt(value);
        if (isNaN(value)) value = 50;
        filters.brightness = (value + 50) / 50;
        if (filters.brightness === 1) delete filters.brightness;
        applyFilters();
    };
    me.setContrast = (value, src, target)=>{
        me.setSrcTarget(src, target);
        value = parseInt(value);
        if (isNaN(value)) value = 50;
        filters.contrast = (value + 50) / 50;
        applyFilters();
    };
    me.setSaturation = (value, src, target)=>{
        me.setSrcTarget(src, target);
        value = parseInt(value);
        if (isNaN(value)) value = 50;
        filters.saturate = (value + 50) / 50;
        applyFilters();
    };
    me.setHue = (value, src, target)=>{
        me.setSrcTarget(src, target);
        filters["hue-rotate"] = value + "deg";
        applyFilters();
    };
    me.setBlur = (value, src, target)=>{
        me.setSrcTarget(src, target);
        //filters.blur = (value/5) + "px";
        filters.blur = value / 2;
        applyFilters();
    };
    me.setSharpen = (value, src, target)=>{
        me.setSrcTarget(src, target);
        filters.sharpen = value / 100;
        applyFilters();
    };
    me.setSepia = (value, src, target)=>{
        me.setSrcTarget(src, target);
        filters.sepia = value / 100;
        applyFilters();
    };
    me.setInvert = (value, src, target)=>{
        me.setSrcTarget(src, target);
        filters.invert = value / 100;
        applyFilters();
    };
    me.setColorBalance = (channel, value, src, target)=>{
        me.setSrcTarget(src, target);
        createMask();
        value = parseInt(value);
        filters[channel] = value / 100;
        applyFilters();
    };
    me.setSrcTarget = (src, target)=>{
        if (src) _src = src;
        if (target) _target = target;
    };
    me.hold = ()=>{
        doApply = false;
    };
    me.apply = ()=>{
        doApply = true;
        applyFilters();
    };
    me.feather = function(ctx, amount) {
        let w = ctx.canvas.width;
        let h = ctx.canvas.height;
        let data = ctx.getImageData(0, 0, w, h);
        let d = data.data;
        let target = [];
        if (amount > 0) {
            function onEdge(index) {
                return d[index + 3] === 0;
            }
            for(let y = 0; y < h; y++)for(let x = 0; x < w; x++){
                let index = (y * w + x) * 4;
                let alpha = d[index + 3];
                if (alpha) {
                    let isOnEdge = onEdge(index - 4) || onEdge(index + 4) || onEdge(index - w * 4) || onEdge(index + w * 4);
                    if (isOnEdge) target.push(index);
                }
            }
            target.forEach((index)=>{
                d[index + 3] = d[index + 3] >> 1;
            });
            ctx.putImageData(data, 0, 0);
        } else {
            let alphaIncrease = -amount * 100;
            for(let y = 0; y < h; y++)for(let x = 0; x < w; x++){
                let index = (y * w + x) * 4;
                let alpha = d[index + 3];
                if (alpha < 255 && alpha > 0) {
                    alpha = Math.min(255, alpha += alphaIncrease);
                    d[index + 3] = alpha;
                }
            }
            ctx.putImageData(data, 0, 0);
        }
    };
    me.outline = function(ctx, color) {
        let w = ctx.canvas.width;
        let h = ctx.canvas.height;
        let data = ctx.getImageData(0, 0, w, h);
        let d = data.data;
        let target = [];
        function checkPixel(index) {
            if (d[index + 3] === 0) target.push(index);
        }
        for(let y = 1; y < h - 1; y++)for(let x = 1; x < w - 1; x++){
            let index = (y * w + x) * 4;
            let alpha = d[index + 3];
            if (alpha) {
                checkPixel(index - 4);
                checkPixel(index + 4);
                checkPixel(index - w * 4);
                checkPixel(index + w * 4);
            }
        }
        if (color) {
            target.forEach((index)=>{
                d[index] = color[0];
                d[index + 1] = color[1];
                d[index + 2] = color[2];
                d[index + 3] = 255;
            });
            target = [];
            ctx.putImageData(data, 0, 0);
        } else return target;
    };
    function applyFilters() {
        if (!doApply) return;
        let filter = "";
        if (_src && _target) {
            _target.filter = "none";
            _target.clearRect(0, 0, _target.canvas.width, _target.canvas.height);
            _target.drawImage(_src, 0, 0);
            for(let key in filters)if (typeof filters[key] !== "undefined") {
                if (customFilters[key]) customFilters[key](filters[key]);
                else filter += key + "(" + filters[key] + ") ";
            }
            _target.filter = filter;
            _target.drawImage(_target.canvas, 0, 0);
            _target.filter = "none";
        }
    }
    function sharpen(ctx, w, h, mix) {
        var x, sx, sy, r, g, b, a, dstOff, srcOff, wt, cx, cy, scy, scx, weights = [
            0,
            -1,
            0,
            -1,
            5,
            -1,
            0,
            -1,
            0
        ], katet = Math.round(Math.sqrt(weights.length)), half = katet * 0.5 | 0, dstData = ctx.createImageData(w, h), dstBuff = dstData.data, srcBuff = ctx.getImageData(0, 0, w, h).data, y = h;
        while(y--){
            x = w;
            while(x--){
                sy = y;
                sx = x;
                dstOff = (y * w + x) * 4;
                r = 0;
                g = 0;
                b = 0;
                a = 0;
                if (x > 0 && y > 0 && x < w - 1 && y < h - 1) {
                    for(cy = 0; cy < katet; cy++)for(cx = 0; cx < katet; cx++){
                        scy = sy + cy - half;
                        scx = sx + cx - half;
                        if (scy >= 0 && scy < h && scx >= 0 && scx < w) {
                            srcOff = (scy * w + scx) * 4;
                            wt = weights[cy * katet + cx];
                            r += srcBuff[srcOff] * wt;
                            g += srcBuff[srcOff + 1] * wt;
                            b += srcBuff[srcOff + 2] * wt;
                            a += srcBuff[srcOff + 3] * wt;
                        }
                    }
                    dstBuff[dstOff] = r * mix + srcBuff[dstOff] * (1 - mix);
                    dstBuff[dstOff + 1] = g * mix + srcBuff[dstOff + 1] * (1 - mix);
                    dstBuff[dstOff + 2] = b * mix + srcBuff[dstOff + 2] * (1 - mix);
                    dstBuff[dstOff + 3] = srcBuff[dstOff + 3];
                } else {
                    dstBuff[dstOff] = srcBuff[dstOff];
                    dstBuff[dstOff + 1] = srcBuff[dstOff + 1];
                    dstBuff[dstOff + 2] = srcBuff[dstOff + 2];
                    dstBuff[dstOff + 3] = srcBuff[dstOff + 3];
                }
            }
        }
        ctx.putImageData(dstData, 0, 0);
    }
    function overlayColor(color, amount) {
        if (_target && amount) {
            _target.globalCompositeOperation = "overlay";
            _target.globalAlpha = amount;
            _target.fillStyle = color;
            _target.fillRect(0, 0, _target.canvas.width, _target.canvas.height);
            _target.globalCompositeOperation = "source-over";
            _target.globalAlpha = 1;
            if (maskCanvas) {
                _target.globalCompositeOperation = "destination-in";
                _target.drawImage(maskCanvas, 0, 0);
                _target.globalCompositeOperation = "source-over";
            }
        }
    }
    function createMask() {
        if (!_src) {
            console.error("no source for mask");
            return;
        }
        if (!maskCanvas) {
            maskCanvas = document.createElement("canvas");
            maskCanvas.width = _src.width;
            maskCanvas.height = _src.height;
            let maskCtx = maskCanvas.getContext("2d");
            let maskData = _src.getContext("2d").getImageData(0, 0, maskCanvas.width, maskCanvas.height);
            maskCtx.fillStyle = "black";
            maskCtx.fillRect(0, 0, maskCanvas.width, maskCanvas.height);
            let mask = maskData.data;
            for(let i = 0; i < mask.length; i += 4)if (mask[i + 3] === 0) {
                mask[i] = 255;
                mask[i + 1] = 255;
                mask[i + 2] = 255;
            }
            maskCtx.putImageData(maskData, 0, 0);
            console.log("mask created");
        }
    }
    return me;
}();
var $b2b35eb6bd3fbb60$export$2e2bcd8739ae039 = $b2b35eb6bd3fbb60$var$Effects;

});
parcelRegister("3q6B6", function(module, exports) {

$parcel$export(module.exports, "canvasRGBA", () => $27d8eae4e1baac14$export$2dd10362761f44f5);
function $27d8eae4e1baac14$var$t(r) {
    return ($27d8eae4e1baac14$var$t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
        return typeof t;
    } : function(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(r);
}
var $27d8eae4e1baac14$var$r = [
    512,
    512,
    456,
    512,
    328,
    456,
    335,
    512,
    405,
    328,
    271,
    456,
    388,
    335,
    292,
    512,
    454,
    405,
    364,
    328,
    298,
    271,
    496,
    456,
    420,
    388,
    360,
    335,
    312,
    292,
    273,
    512,
    482,
    454,
    428,
    405,
    383,
    364,
    345,
    328,
    312,
    298,
    284,
    271,
    259,
    496,
    475,
    456,
    437,
    420,
    404,
    388,
    374,
    360,
    347,
    335,
    323,
    312,
    302,
    292,
    282,
    273,
    265,
    512,
    497,
    482,
    468,
    454,
    441,
    428,
    417,
    405,
    394,
    383,
    373,
    364,
    354,
    345,
    337,
    328,
    320,
    312,
    305,
    298,
    291,
    284,
    278,
    271,
    265,
    259,
    507,
    496,
    485,
    475,
    465,
    456,
    446,
    437,
    428,
    420,
    412,
    404,
    396,
    388,
    381,
    374,
    367,
    360,
    354,
    347,
    341,
    335,
    329,
    323,
    318,
    312,
    307,
    302,
    297,
    292,
    287,
    282,
    278,
    273,
    269,
    265,
    261,
    512,
    505,
    497,
    489,
    482,
    475,
    468,
    461,
    454,
    447,
    441,
    435,
    428,
    422,
    417,
    411,
    405,
    399,
    394,
    389,
    383,
    378,
    373,
    368,
    364,
    359,
    354,
    350,
    345,
    341,
    337,
    332,
    328,
    324,
    320,
    316,
    312,
    309,
    305,
    301,
    298,
    294,
    291,
    287,
    284,
    281,
    278,
    274,
    271,
    268,
    265,
    262,
    259,
    257,
    507,
    501,
    496,
    491,
    485,
    480,
    475,
    470,
    465,
    460,
    456,
    451,
    446,
    442,
    437,
    433,
    428,
    424,
    420,
    416,
    412,
    408,
    404,
    400,
    396,
    392,
    388,
    385,
    381,
    377,
    374,
    370,
    367,
    363,
    360,
    357,
    354,
    350,
    347,
    344,
    341,
    338,
    335,
    332,
    329,
    326,
    323,
    320,
    318,
    315,
    312,
    310,
    307,
    304,
    302,
    299,
    297,
    294,
    292,
    289,
    287,
    285,
    282,
    280,
    278,
    275,
    273,
    271,
    269,
    267,
    265,
    263,
    261,
    259
], $27d8eae4e1baac14$var$a = [
    9,
    11,
    12,
    13,
    13,
    14,
    14,
    15,
    15,
    15,
    15,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24
];
function $27d8eae4e1baac14$export$5c452ff88e35e47d(t, r, a, n, e, i) {
    if ("string" == typeof t && (t = document.getElementById(t)), t && "naturalWidth" in t) {
        var g = e ? "offset" : "natural", v = t[g + "Width"], s = t[g + "Height"];
        if ("string" == typeof r && (r = document.getElementById(r)), r && "getContext" in r) {
            i || (r.style.width = v + "px", r.style.height = s + "px"), r.width = v, r.height = s;
            var u = r.getContext("2d");
            u.clearRect(0, 0, v, s), u.drawImage(t, 0, 0, t.naturalWidth, t.naturalHeight, 0, 0, v, s), isNaN(a) || a < 1 || (n ? $27d8eae4e1baac14$export$2dd10362761f44f5(r, 0, 0, v, s, a) : $27d8eae4e1baac14$export$b5ffa7e20566d485(r, 0, 0, v, s, a));
        }
    }
}
function $27d8eae4e1baac14$var$e(r, a, n, e, o) {
    if ("string" == typeof r && (r = document.getElementById(r)), !r || "object" !== $27d8eae4e1baac14$var$t(r) || !("getContext" in r)) throw new TypeError("Expecting canvas with `getContext` method in processCanvasRGB(A) calls!");
    var i = r.getContext("2d");
    try {
        return i.getImageData(a, n, e, o);
    } catch (t) {
        throw new Error("unable to access image data: " + t);
    }
}
function $27d8eae4e1baac14$export$2dd10362761f44f5(t, r, a, n, o, f) {
    if (!(isNaN(f) || f < 1)) {
        f |= 0;
        var g = $27d8eae4e1baac14$var$e(t, r, a, n, o);
        g = $27d8eae4e1baac14$export$95ea1a5e72bf4fa5(g, r, a, n, o, f), t.getContext("2d").putImageData(g, r, a);
    }
}
function $27d8eae4e1baac14$export$95ea1a5e72bf4fa5(t, n, e, o, i, f) {
    for(var g, s = t.data, u = 2 * f + 1, c = o - 1, l = i - 1, x = f + 1, b = x * (x + 1) / 2, y = new $27d8eae4e1baac14$export$c7ee5523f3ead121, h = y, m = 1; m < u; m++)h = h.next = new $27d8eae4e1baac14$export$c7ee5523f3ead121, m === x && (g = h);
    h.next = y;
    for(var d = null, p = null, w = 0, C = 0, B = $27d8eae4e1baac14$var$r[f], E = $27d8eae4e1baac14$var$a[f], I = 0; I < i; I++){
        h = y;
        for(var N = s[C], R = s[C + 1], D = s[C + 2], G = s[C + 3], S = 0; S < x; S++)h.r = N, h.g = R, h.b = D, h.a = G, h = h.next;
        for(var A = 0, W = 0, H = 0, T = 0, j = x * N, k = x * R, q = x * D, z = x * G, F = b * N, J = b * R, K = b * D, L = b * G, M = 1; M < x; M++){
            var O = C + ((c < M ? c : M) << 2), P = s[O], Q = s[O + 1], U = s[O + 2], V = s[O + 3], X = x - M;
            F += (h.r = P) * X, J += (h.g = Q) * X, K += (h.b = U) * X, L += (h.a = V) * X, A += P, W += Q, H += U, T += V, h = h.next;
        }
        d = y, p = g;
        for(var Y = 0; Y < o; Y++){
            var Z = L * B >> E;
            if (s[C + 3] = Z, 0 !== Z) {
                var $ = 255 / Z;
                s[C] = (F * B >> E) * $, s[C + 1] = (J * B >> E) * $, s[C + 2] = (K * B >> E) * $;
            } else s[C] = s[C + 1] = s[C + 2] = 0;
            F -= j, J -= k, K -= q, L -= z, j -= d.r, k -= d.g, q -= d.b, z -= d.a;
            var _ = Y + f + 1;
            _ = w + (_ < c ? _ : c) << 2, F += A += d.r = s[_], J += W += d.g = s[_ + 1], K += H += d.b = s[_ + 2], L += T += d.a = s[_ + 3], d = d.next;
            var tt = p, rt = tt.r, at = tt.g, nt = tt.b, et = tt.a;
            j += rt, k += at, q += nt, z += et, A -= rt, W -= at, H -= nt, T -= et, p = p.next, C += 4;
        }
        w += o;
    }
    for(var ot = 0; ot < o; ot++){
        var it = s[C = ot << 2], ft = s[C + 1], gt = s[C + 2], vt = s[C + 3], st = x * it, ut = x * ft, ct = x * gt, lt = x * vt, xt = b * it, bt = b * ft, yt = b * gt, ht = b * vt;
        h = y;
        for(var mt = 0; mt < x; mt++)h.r = it, h.g = ft, h.b = gt, h.a = vt, h = h.next;
        for(var dt = o, pt = 0, wt = 0, Ct = 0, Bt = 0, Et = 1; Et <= f; Et++){
            C = dt + ot << 2;
            var It = x - Et;
            xt += (h.r = it = s[C]) * It, bt += (h.g = ft = s[C + 1]) * It, yt += (h.b = gt = s[C + 2]) * It, ht += (h.a = vt = s[C + 3]) * It, Bt += it, pt += ft, wt += gt, Ct += vt, h = h.next, Et < l && (dt += o);
        }
        C = ot, d = y, p = g;
        for(var Nt = 0; Nt < i; Nt++){
            var Rt = C << 2;
            s[Rt + 3] = vt = ht * B >> E, vt > 0 ? (vt = 255 / vt, s[Rt] = (xt * B >> E) * vt, s[Rt + 1] = (bt * B >> E) * vt, s[Rt + 2] = (yt * B >> E) * vt) : s[Rt] = s[Rt + 1] = s[Rt + 2] = 0, xt -= st, bt -= ut, yt -= ct, ht -= lt, st -= d.r, ut -= d.g, ct -= d.b, lt -= d.a, Rt = ot + ((Rt = Nt + x) < l ? Rt : l) * o << 2, xt += Bt += d.r = s[Rt], bt += pt += d.g = s[Rt + 1], yt += wt += d.b = s[Rt + 2], ht += Ct += d.a = s[Rt + 3], d = d.next, st += it = p.r, ut += ft = p.g, ct += gt = p.b, lt += vt = p.a, Bt -= it, pt -= ft, wt -= gt, Ct -= vt, p = p.next, C += o;
        }
    }
    return t;
}
function $27d8eae4e1baac14$export$b5ffa7e20566d485(t, r, a, n, o, i) {
    if (!(isNaN(i) || i < 1)) {
        i |= 0;
        var f = $27d8eae4e1baac14$var$e(t, r, a, n, o);
        f = $27d8eae4e1baac14$export$78187a1b7e472a09(f, r, a, n, o, i), t.getContext("2d").putImageData(f, r, a);
    }
}
function $27d8eae4e1baac14$export$78187a1b7e472a09(t, n, e, o, i, f) {
    for(var g, s = t.data, u = 2 * f + 1, c = o - 1, l = i - 1, x = f + 1, b = x * (x + 1) / 2, y = new $27d8eae4e1baac14$export$c7ee5523f3ead121, h = y, m = 1; m < u; m++)h = h.next = new $27d8eae4e1baac14$export$c7ee5523f3ead121, m === x && (g = h);
    h.next = y;
    for(var d, p, w = null, C = null, B = $27d8eae4e1baac14$var$r[f], E = $27d8eae4e1baac14$var$a[f], I = 0, N = 0, R = 0; R < i; R++){
        var D = s[N], G = s[N + 1], S = s[N + 2], A = x * D, W = x * G, H = x * S, T = b * D, j = b * G, k = b * S;
        h = y;
        for(var q = 0; q < x; q++)h.r = D, h.g = G, h.b = S, h = h.next;
        for(var z = 0, F = 0, J = 0, K = 1; K < x; K++)d = N + ((c < K ? c : K) << 2), T += (h.r = D = s[d]) * (p = x - K), j += (h.g = G = s[d + 1]) * p, k += (h.b = S = s[d + 2]) * p, z += D, F += G, J += S, h = h.next;
        w = y, C = g;
        for(var L = 0; L < o; L++)s[N] = T * B >> E, s[N + 1] = j * B >> E, s[N + 2] = k * B >> E, T -= A, j -= W, k -= H, A -= w.r, W -= w.g, H -= w.b, d = I + ((d = L + f + 1) < c ? d : c) << 2, T += z += w.r = s[d], j += F += w.g = s[d + 1], k += J += w.b = s[d + 2], w = w.next, A += D = C.r, W += G = C.g, H += S = C.b, z -= D, F -= G, J -= S, C = C.next, N += 4;
        I += o;
    }
    for(var M = 0; M < o; M++){
        var O = s[N = M << 2], P = s[N + 1], Q = s[N + 2], U = x * O, V = x * P, X = x * Q, Y = b * O, Z = b * P, $ = b * Q;
        h = y;
        for(var _ = 0; _ < x; _++)h.r = O, h.g = P, h.b = Q, h = h.next;
        for(var tt = 0, rt = 0, at = 0, nt = 1, et = o; nt <= f; nt++)N = et + M << 2, Y += (h.r = O = s[N]) * (p = x - nt), Z += (h.g = P = s[N + 1]) * p, $ += (h.b = Q = s[N + 2]) * p, tt += O, rt += P, at += Q, h = h.next, nt < l && (et += o);
        N = M, w = y, C = g;
        for(var ot = 0; ot < i; ot++)s[d = N << 2] = Y * B >> E, s[d + 1] = Z * B >> E, s[d + 2] = $ * B >> E, Y -= U, Z -= V, $ -= X, U -= w.r, V -= w.g, X -= w.b, d = M + ((d = ot + x) < l ? d : l) * o << 2, Y += tt += w.r = s[d], Z += rt += w.g = s[d + 1], $ += at += w.b = s[d + 2], w = w.next, U += O = C.r, V += P = C.g, X += Q = C.b, tt -= O, rt -= P, at -= Q, C = C.next, N += o;
    }
    return t;
}
var $27d8eae4e1baac14$export$c7ee5523f3ead121 = function t() {
    !function(t, r) {
        if (!(t instanceof r)) throw new TypeError("Cannot call a class as a function");
    }(this, t), this.r = 0, this.g = 0, this.b = 0, this.a = 0, this.next = null;
};
 //https://github.com/flozz/StackBlur

});


parcelRegister("9xub8", function(module, exports) {

$parcel$export(module.exports, "duplicateCanvas", () => $6f1e9af35f76d342$export$a28f33e67446e40d);
$parcel$export(module.exports, "releaseCanvas", () => $6f1e9af35f76d342$export$e918ac6a1026a12a);
$parcel$export(module.exports, "outLineCanvas", () => $6f1e9af35f76d342$export$26d9ccbfe3b890b2);
$parcel$export(module.exports, "indexPixelsToPalette", () => $6f1e9af35f76d342$export$d28cb5544a8eac47);
parcelRequire("eTCYn");
function $6f1e9af35f76d342$export$a28f33e67446e40d(canvas, includingContent) {
    let result = document.createElement("canvas");
    result.width = canvas.width;
    result.height = canvas.height;
    if (includingContent) result.getContext("2d").drawImage(canvas, 0, 0);
    return result;
}
function $6f1e9af35f76d342$export$e918ac6a1026a12a(canvas) {
    // mostly needed for safari as it tends to hold on the canvas elements;
    canvas.width = 1;
    canvas.height = 1;
    canvas.getContext("2d").clearRect(0, 0, 1, 1);
    canvas = undefined;
}
function $6f1e9af35f76d342$export$26d9ccbfe3b890b2(ctx, generateSVG) {
    let lines = [];
    let img = ctx.getImageData(0, 0, ctx.canvas.width, ctx.canvas.height);
    let topLine = {
        x: 0,
        y: 0,
        w: 0
    };
    let bottomLine = {
        x: 0,
        y: 0,
        w: 0
    };
    let leftLine = {
        x: 0,
        y: 0,
        h: 0
    };
    let rightLine = {
        x: 0,
        y: 0,
        h: 0
    };
    let w = img.width;
    let h = img.height;
    let boundingCoords = {
        x1: w,
        y1: h,
        x2: 0,
        y2: 0
    };
    function isPixel(x, y) {
        if (x < 0 || x >= w || y < 0 || y >= h) return false;
        let index = (y * w + x) * 4;
        let alpha = img.data[index + 3];
        return alpha > 1;
    }
    function addLine(line, horizontal) {
        if (line.w) {
            if (horizontal) lines.push([
                line.x,
                line.y,
                line.x + line.w,
                line.y
            ]);
            else lines.push([
                line.x,
                line.y,
                line.x,
                line.y + line.w
            ]);
            line.w = 0;
        }
    }
    // find horizontal lines;
    for(let y = 0; y < h; y++){
        for(let x = 0; x < w; x++)if (isPixel(x, y)) {
            // update bounding box
            if (x < boundingCoords.x1) boundingCoords.x1 = x;
            if (x > boundingCoords.x2) boundingCoords.x2 = x;
            if (y < boundingCoords.y1) boundingCoords.y1 = y;
            if (y > boundingCoords.y2) boundingCoords.y2 = y;
            if (!isPixel(x, y - 1)) {
                // top edge found
                if (topLine.w) topLine.w++;
                else topLine = {
                    x: x,
                    y: y,
                    w: 1
                };
            } else addLine(topLine, true);
            if (!isPixel(x, y + 1)) {
                // bottom edge found
                if (bottomLine.w) bottomLine.w++;
                else bottomLine = {
                    x: x,
                    y: y + 1,
                    w: 1
                };
            } else addLine(bottomLine, true);
        } else {
            addLine(topLine, true);
            addLine(bottomLine, true);
        }
        addLine(topLine, true);
        addLine(bottomLine, true);
    }
    let boundingBox = {
        x: boundingCoords.x1,
        y: boundingCoords.y1,
        w: boundingCoords.x2 - boundingCoords.x1,
        h: boundingCoords.y2 - boundingCoords.y1
    };
    // find vertical lines;
    for(let x = 0; x < w; x++){
        for(let y = 0; y < h; y++)if (isPixel(x, y)) {
            if (!isPixel(x - 1, y)) {
                // left edge found
                if (leftLine.w) leftLine.w++;
                else leftLine = {
                    x: x,
                    y: y,
                    w: 1
                };
            } else addLine(leftLine);
            if (!isPixel(x + 1, y)) {
                // right edge found
                if (rightLine.w) rightLine.w++;
                else rightLine = {
                    x: x + 1,
                    y: y,
                    w: 1
                };
            } else addLine(rightLine);
        } else {
            addLine(leftLine);
            addLine(rightLine);
        }
        addLine(leftLine);
        addLine(rightLine);
    }
    // TODO: should we do the extra pass to construct polylines?
    let totalLines = lines.length;
    let svg;
    if (generateSVG) {
        svg = "<svg xmlns='http://www.w3.org/2000/svg' viewbox='0 0 " + ctx.canvas.width + " " + ctx.canvas.height + "' preserveAspectRatio='none'>";
        if (totalLines > 6000) {
            console.warn("too many lines, displaying bounding box instead");
            svg += '<rect x="' + boundingBox.x + '" y="' + boundingBox.y + '" width="' + boundingBox.w + '" height="' + boundingBox.h + '" class="white" />';
            svg += '<rect x="' + boundingBox.x + '" y="' + boundingBox.y + '" width="' + boundingBox.w + '" height="' + boundingBox.h + '" class="ants" />';
        } else // draw lines
        lines.forEach((h)=>{
            let x = h[0];
            let y = h[1];
            let x2 = h[2];
            let y2 = h[3];
            svg += '<line x1="' + x + '" y1="' + y + '" x2="' + x2 + '" y2="' + y2 + '" class="white" />';
            svg += '<line x1="' + x + '" y1="' + y + '" x2="' + x2 + '" y2="' + y2 + '" class="ants" />';
        });
        svg += "</svg>";
    }
    return {
        svg: svg,
        box: boundingBox,
        lines: lines,
        lineCount: totalLines
    };
}
function $6f1e9af35f76d342$export$d28cb5544a8eac47(ctx, palette, oneDimensional) {
    let width = ctx.canvas.width;
    let height = ctx.canvas.height;
    let pixels = [];
    let data = ctx.getImageData(0, 0, width, height).data;
    let notFoundCount = 0;
    function getIndex(color, x, y) {
        let index = palette.findIndex((c)=>{
            return c[0] === color[0] && c[1] === color[1] && c[2] === color[2];
        });
        if (index < 0) {
            index = 0;
            notFoundCount++;
        }
        return index;
    }
    for(let i = 0; i < data.length; i += 4){
        let x = i / 4 % width;
        let y = Math.floor(i / 4 / width);
        let r = data[i];
        let g = data[i + 1];
        let b = data[i + 2];
        let a = data[i + 3];
        let index = a ? getIndex([
            r,
            g,
            b,
            a
        ], x, y) : -1;
        if (oneDimensional) pixels.push(index);
        else {
            pixels[y] = pixels[y] || [];
            pixels[y][x] = index;
        }
    }
    return {
        pixels: pixels,
        notFoundCount: notFoundCount
    };
}

});

parcelRegister("8SKzz", function(module, exports) {

$parcel$export(module.exports, "default", () => $67777e439cf83066$export$2e2bcd8739ae039);
let $67777e439cf83066$var$SyntaxEdit = function(parent, onChange) {
    let me = {};
    let regexes = {
        string1: {
            reg: /"(.*?)"/g,
            style: "string",
            wrap: '"'
        },
        string2: {
            reg: /'(.*?)'/g,
            style: "string",
            wrap: "'"
        },
        numbers: {
            reg: /(\b\d+\b)/g,
            style: "number"
        },
        hex: {
            reg: /(\B#\w+)/g,
            style: "number"
        },
        reserved: {
            reg: /\b(new|var|let|if|do|function|while|switch|for|foreach|in|continue|break)(?=[^\w])/g,
            style: "reserved"
        },
        globals: {
            reg: /\b(document|window|Array|String|Object|Number|Math|\$)(?=[^\w])/g,
            style: "globals"
        },
        js: {
            reg: /\b(getElementsBy(TagName|ClassName|Name)|getElementById|typeof|instanceof)(?=[^\w])/g,
            style: "js"
        },
        //methods: {reg:/((?<=\.)\w+)/g, style:"method"},
        // Note: Safari doesn't support lookbehind in regexes ...
        htmlTags: {
            reg: /(&lt;[^\&]*&gt;)/g,
            style: "html"
        },
        blockComments: {
            reg: /(\/\*.*\*\/)/g,
            style: "comment"
        },
        inlineComments: {
            reg: /(\/\/.*)/g,
            style: "comment"
        },
        source: {
            reg: /\b(source|\$)(?=[^\w])/g,
            style: "source"
        },
        target: {
            reg: /\b(target|\$)(?=[^\w])/g,
            style: "target"
        }
    };
    let editor = document.createElement("code");
    let textarea = document.createElement("textarea");
    editor.contentEditable = "true";
    editor.spellcheck = false;
    editor.onkeydown = (e)=>{
        e.stopPropagation();
    };
    editor.onblur = function() {
        onChange(editor.innerText);
        highlight();
    };
    parent.appendChild(editor);
    me.setValue = (value)=>{
        editor.innerText = value;
        highlight();
    };
    me.onChange = ()=>{
        onChange(editor.innerText);
    };
    function highlight() {
        textarea.innerText = editor.innerText;
        let text = textarea.innerHTML;
        for(let key in regexes){
            let reg = regexes[key];
            let wrap = reg.wrap || "";
            text = text.replace(reg.reg, '<span class="' + reg.style + '">' + wrap + "$1" + wrap + "</span>");
        }
        editor.innerHTML = text;
    }
    return me;
};
var $67777e439cf83066$export$2e2bcd8739ae039 = $67777e439cf83066$var$SyntaxEdit;

});

parcelRegister("eZZbx", function(module, exports) {

$parcel$export(module.exports, "default", () => $aeb6394397c8b47d$export$2e2bcd8739ae039);

var $9dDG4 = parcelRequire("9dDG4");

var $k5ZAj = parcelRequire("k5ZAj");

var $jU8Uk = parcelRequire("jU8Uk");

var $9xub8 = parcelRequire("9xub8");
let $aeb6394397c8b47d$var$HistoryService = function() {
    let me = {};
    let maxHistory = 20;
    let history = [];
    let future = [];
    let currentHistory;
    // TODO: maybe add a "framehistory" type to store the current frame instead of the whole image?
    me.start = function(type, data) {
        console.log("start his");
        currentHistory = {
            type: type,
            data: {}
        };
        let index = (0, $jU8Uk.default).getActiveLayerIndex();
        if (typeof data === "number") index = data;
        switch(type){
            case (0, $k5ZAj.EVENT).layerContentHistory:
                currentHistory.data.layerIndex = index;
                currentHistory.data.from = (0, $9xub8.duplicateCanvas)((0, $jU8Uk.default).getActiveContext().canvas, true);
                break;
            case (0, $k5ZAj.EVENT).layerPropertyHistory:
                currentHistory.data.layerIndex = index;
                currentHistory.data.from = getLayerProperties(index);
                break;
            case (0, $k5ZAj.EVENT).layerHistory:
                currentHistory.data.layerIndex = index;
                currentHistory.data.from = (0, $jU8Uk.default).getActiveLayer().clone();
                break;
            case (0, $k5ZAj.EVENT).imageHistory:
                currentHistory.data.from = (0, $jU8Uk.default).clone();
                break;
            default:
                console.error("History type " + type + " not handled");
        }
    };
    me.end = function() {
        if (currentHistory) {
            console.log("end his");
            switch(currentHistory.type){
                case (0, $k5ZAj.EVENT).layerContentHistory:
                    currentHistory.data.to = (0, $9xub8.duplicateCanvas)((0, $jU8Uk.default).getActiveContext().canvas, true);
                    break;
                case (0, $k5ZAj.EVENT).layerPropertyHistory:
                    currentHistory.data.to = getLayerProperties(currentHistory.data.layerIndex);
                    break;
                case (0, $k5ZAj.EVENT).layerHistory:
                    currentHistory.data.to = (0, $jU8Uk.default).getLayer(currentHistory.data.layerIndex).clone();
                    break;
                case (0, $k5ZAj.EVENT).imageHistory:
                    currentHistory.data.to = (0, $jU8Uk.default).clone();
                    break;
            }
            history.unshift(currentHistory);
            if (history.length > maxHistory) history.pop();
            future = [];
            currentHistory = undefined;
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).historyChanged, [
                history.length,
                future.length
            ]);
        }
    };
    me.neverMind = function() {
        currentHistory = undefined;
    };
    me.add = function(type, from, to) {
        history.unshift({
            type: type,
            data: {
                from: from,
                to: to
            }
        });
        if (history.length > maxHistory) history.pop();
        future = [];
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).historyChanged, [
            history.length,
            future.length
        ]);
    };
    me.clear = function() {
        history = [];
        future = [];
    };
    function getLayerProperties(index) {
        let layer = (0, $jU8Uk.default).getLayer(index);
        return {
            name: layer.name,
            visible: layer.visible,
            hasMask: layer.hasMask,
            maskActive: layer.isMaskActive(),
            index: index
        };
    }
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).UNDO, ()=>{
        if (history.length) {
            let historyStep = history.shift();
            let layer;
            let target;
            switch(historyStep.type){
                case (0, $k5ZAj.EVENT).layerContentHistory:
                    layer = (0, $jU8Uk.default).getLayer(historyStep.data.layerIndex);
                    layer.clear();
                    layer.drawImage(historyStep.data.from);
                    (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layerContentChanged);
                    break;
                case (0, $k5ZAj.EVENT).imageHistory:
                    (0, $jU8Uk.default).restore(historyStep.data.from);
                    (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).CLEARSELECTION);
                    break;
                case (0, $k5ZAj.EVENT).layerPropertyHistory:
                    target = historyStep.data.from;
                    let source = historyStep.data.to;
                    if (target.index < 0) {
                        // add new layer
                        (0, $jU8Uk.default).removeLayer(target.index);
                        (0, $jU8Uk.default).activateLayer(target.currentIndex);
                    } else {
                        layer = (0, $jU8Uk.default).getLayer(target.index);
                        if (typeof target.name === "string") layer.name = target.name;
                        if (typeof target.visible === "boolean") layer.visible = target.visible;
                        if (source.hasMask && source.maskActive !== target.maskActive) layer.toggleMask();
                        console.error(layer);
                    }
                    (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layersChanged);
                    break;
                case (0, $k5ZAj.EVENT).layerHistory:
                    layer = (0, $jU8Uk.default).getLayer(historyStep.data.layerIndex);
                    layer.restore(historyStep.data.from);
                    (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layerContentChanged);
                    (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layersChanged);
                    break;
                default:
                    console.error("History type " + historyStep.type + " not handled");
            }
            future.unshift(historyStep);
            if (future.length > maxHistory) future.pop();
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).historyChanged, [
                history.length,
                future.length
            ]);
        }
    });
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).REDO, ()=>{
        if (future.length) {
            let historyStep = future.shift();
            let layer;
            let target;
            let source;
            //console.log(historyStep);
            switch(historyStep.type){
                case (0, $k5ZAj.EVENT).layerContentHistory:
                    layer = (0, $jU8Uk.default).getActiveLayer();
                    layer.clear();
                    layer.drawImage(historyStep.data.to);
                    (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layerContentChanged);
                    break;
                case (0, $k5ZAj.EVENT).imageHistory:
                    (0, $jU8Uk.default).restore(historyStep.data.to);
                    (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).CLEARSELECTION);
                    break;
                case (0, $k5ZAj.EVENT).layerPropertyHistory:
                    target = historyStep.data.to;
                    source = historyStep.data.from;
                    if (source.index < 0) {
                        (0, $jU8Uk.default).activateLayer(source.currentIndex);
                        (0, $jU8Uk.default).addLayer(source.currentIndex);
                    } else {
                        layer = (0, $jU8Uk.default).getLayer(target.index);
                        if (typeof target.name === "string") layer.name = target.name;
                        if (typeof target.visible === "boolean") layer.visible = target.visible;
                        if (source.hasMask && source.maskActive !== target.maskActive) layer.toggleMask();
                    }
                    (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layersChanged);
                    break;
                case (0, $k5ZAj.EVENT).layerHistory:
                    layer = (0, $jU8Uk.default).getLayer(historyStep.data.layerIndex);
                    layer.restore(historyStep.data.to);
                    (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layerContentChanged);
                    (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layersChanged);
                    break;
                default:
                    console.error("History type " + historyStep.type + " not handled");
            }
            history.unshift(historyStep);
            if (history.length > maxHistory) history.pop();
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).historyChanged, [
                history.length,
                future.length
            ]);
        }
    });
    return me;
}();
var $aeb6394397c8b47d$export$2e2bcd8739ae039 = $aeb6394397c8b47d$var$HistoryService;

});


parcelRegister("9ARHe", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fc120d06db5f1ce$export$2e2bcd8739ae039);

var $eJ26Q = parcelRequire("eJ26Q");

var $eZded = parcelRequire("eZded");
parcelRequire("8FLxR");

var $c4sle = parcelRequire("c4sle");
let $6fc120d06db5f1ce$var$DitherDialog = (()=>{
    let me = {};
    let patternCanvas;
    let patternCtx;
    let canvas;
    let ctx;
    let preview;
    let previewCtx;
    let gridSize = 4;
    let gridButtons = [];
    let presetPanel;
    let deleteButton;
    let saveButton;
    let touchData = {};
    let userPresetIndex;
    me.render = function(container, modal) {
        container.innerHTML = "";
        gridButtons = [];
        let ditherPanel = (0, $eJ26Q.$div)("ditheredit", "", container);
        presetPanel = (0, $eJ26Q.$div)("presets", "", ditherPanel);
        listPresets();
        let editPanel = (0, $eJ26Q.$div)("editpreset", "", ditherPanel);
        (0, $eJ26Q.$title)("2", "Draw pattern", editPanel);
        canvas = (0, $eJ26Q.$elm)("canvas", "", editPanel, "handle info");
        canvas.width = 240;
        canvas.height = 240;
        ctx = canvas.getContext("2d");
        canvas.info = "Left click to draw black - Right click to draw white";
        let toolBar = (0, $eJ26Q.$div)("subtoolbar", "", editPanel);
        (0, $eJ26Q.$elm)("label", "Grid size", toolBar);
        gridButtons.push((0, $eJ26Q.$div)("button small", 9, toolBar, ()=>{
            setGridSize(3, true);
        }));
        gridButtons.push((0, $eJ26Q.$div)("button small active", 16, toolBar, ()=>{
            setGridSize(4, true);
        }));
        gridButtons.push((0, $eJ26Q.$div)("button small", 25, toolBar, ()=>{
            setGridSize(5, true);
        }));
        (0, $eJ26Q.$div)("button left", "Clear", toolBar, ()=>{
            ctx.fillStyle = "white";
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            drawGridLines();
            patternCtx.clearRect(0, 0, patternCanvas.width, patternCanvas.height);
            updatePattern();
        });
        patternCanvas = document.createElement("canvas");
        patternCanvas.width = 8;
        patternCanvas.height = 8;
        patternCtx = patternCanvas.getContext("2d");
        patternCtx.fillStyle = "white";
        patternCtx.fillRect(0, 0, patternCanvas.width, patternCanvas.height);
        canvas.onClick = (e)=>{
            touchData.box = canvas.getBoundingClientRect();
            let s = 240 / gridSize / 2;
            let x = Math.floor((e.clientX - touchData.box.left) / s);
            let y = Math.floor((e.clientY - touchData.box.top) / s);
            touchData.rightButton = e.button;
            putPixeltoPattern(x, y);
        };
        canvas.onDrag = (dx, dy, _touchData, e)=>{
            let s = 240 / gridSize / 2;
            let x = Math.floor((e.clientX - touchData.box.left) / s);
            let y = Math.floor((e.clientY - touchData.box.top) / s);
            if (x !== touchData.x || y !== touchData.y) putPixeltoPattern(x, y);
        };
        let previewPanel = (0, $eJ26Q.$div)("previewpreset", "", ditherPanel);
        (0, $eJ26Q.$title)("2", "Preview", previewPanel);
        preview = document.createElement("canvas");
        previewCtx = preview.getContext("2d");
        preview.width = 200;
        preview.height = 240;
        previewPanel.appendChild(preview);
        let buttons = (0, $eJ26Q.$div)("subtoolbar", "", previewPanel);
        deleteButton = (0, $eJ26Q.$div)("button left hidden", "Remove preset", buttons, ()=>{
            (0, $c4sle.default).remove("dither", userPresetIndex);
            listPresets();
            loadPreset(0);
        });
        saveButton = (0, $eJ26Q.$div)("button", "Save as new preset", buttons, ()=>{
            let pattern = [];
            let data = patternCtx.getImageData(0, 0, patternCanvas.width, patternCanvas.height).data;
            for(let i = 0; i < data.length; i += 4)pattern.push(data[i + 3] ? 1 : 0);
            (0, $c4sle.default).put("dither", pattern, userPresetIndex);
            listPresets();
        });
        loadPreset(2);
    };
    function loadPreset(preset) {
        let pattern = preset;
        let isUserPreset = typeof preset !== "number";
        if (!isUserPreset) {
            pattern = (0, $eZded.default).getPreset(preset);
            userPresetIndex = undefined;
        }
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.fillStyle = "black";
        if (isUserPreset) setGridSize(pattern.length === 36 ? 3 : 4);
        else setGridSize(pattern.length === 9 ? 3 : 4);
        patternCanvas.width = gridSize * 2;
        patternCanvas.height = gridSize * 2;
        patternCtx.clearRect(0, 0, patternCanvas.width, patternCanvas.height);
        if (isUserPreset) {
            for(let y = 0; y < gridSize * 2; y++)for(let x = 0; x < gridSize * 2; x++){
                let index = y * gridSize * 2 + x;
                if (pattern[index]) drawPixel(x, y);
            }
            deleteButton.classList.remove("hidden");
            saveButton.innerHTML = "Update preset";
        } else {
            // repeat preset 4 times
            for(let y = 0; y < gridSize; y++)for(let x = 0; x < gridSize; x++){
                let index = y * gridSize + x;
                if (pattern[index]) {
                    drawPixel(x, y);
                    drawPixel(x + gridSize, y);
                    drawPixel(x, y + gridSize);
                    drawPixel(x + gridSize, y + gridSize);
                }
            }
            deleteButton.classList.add("hidden");
            saveButton.innerHTML = "Save as new preset";
        }
        drawGridLines();
        updatePattern();
        if (isUserPreset) (0, $eZded.default).setDitherPattern(patternCanvas);
    }
    function userPresetToCanvas(preset) {
        let size = preset.length === 36 ? 6 : 8;
        if (size > 64) size = 10;
        let canvas = document.createElement("canvas");
        canvas.width = size;
        canvas.height = size;
        let ctx = canvas.getContext("2d");
        ctx.fillStyle = "black";
        for(let y = 0; y < size; y++)for(let x = 0; x < size; x++){
            let index = y * size + x;
            if (preset[index]) ctx.fillRect(x, y, 1, 1);
        }
        return canvas;
    }
    function putPixeltoPattern(x, y) {
        touchData.x = x;
        touchData.y = y;
        ctx.fillStyle = patternCtx.fillStyle = touchData.rightButton ? "white" : "black";
        drawPixel(x, y, touchData.rightButton);
        drawGridLines();
        updatePattern();
        (0, $eZded.default).setDitherPattern(patternCanvas);
    }
    function drawPixel(x, y, erase) {
        let s = 240 / gridSize / 2;
        ctx.fillRect(x * s, y * s, s, s);
        if (erase) patternCtx.clearRect(x, y, 1, 1);
        else patternCtx.fillRect(x, y, 1, 1);
    }
    function horizontalLine(y) {
        let s = 240 / gridSize / 2;
        ctx.moveTo(0, y * s - 0.5);
        ctx.lineTo(240, y * s - 0.5);
    }
    function verticalLine(x) {
        let s = 240 / gridSize / 2;
        ctx.moveTo(x * s - 0.5, 0);
        ctx.lineTo(x * s - 0.5, 240);
    }
    function updatePattern() {
        let pattern = previewCtx.createPattern(patternCanvas, "repeat");
        previewCtx.clearRect(0, 0, preview.width, preview.height);
        previewCtx.fillStyle = pattern;
        previewCtx.fillRect(0, 0, preview.width, preview.height);
    }
    function drawGridLines() {
        ctx.strokeStyle = "#666666";
        ctx.lineWidth = 1;
        ctx.beginPath();
        for(let x = 0; x < gridSize; x++){
            verticalLine(x);
            verticalLine(x + gridSize);
            horizontalLine(x);
            horizontalLine(x + gridSize);
        }
        ctx.stroke();
    }
    function setGridSize(size, force) {
        gridSize = size;
        gridButtons.forEach((button)=>button.classList.remove("active"));
        let button = gridButtons[size - 3];
        if (button) button.classList.add("active");
        if (force) {
            ctx.fillStyle = "white";
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.fillStyle = "black";
            gridSize = size;
            patternCanvas.width = gridSize * 2;
            patternCanvas.height = gridSize * 2;
            drawGridLines();
            updatePattern();
        }
    }
    function listPresets() {
        presetPanel.innerHTML = "";
        (0, $eJ26Q.$title)("2", "Presets", presetPanel);
        for(let i = 0; i < 8; i++)(0, $eJ26Q.$div)("preset p" + i, "", presetPanel, ()=>{
            loadPreset(i);
            (0, $eZded.default).setDitherPattern(i + 1);
        });
        let userPresets = (0, $c4sle.default).get("dither");
        if (userPresets && userPresets.forEach) userPresets.forEach((preset, index)=>{
            let tile = (0, $eJ26Q.$div)("preset user", "", presetPanel, ()=>{
                loadPreset(preset);
                userPresetIndex = index;
            });
            tile.appendChild(userPresetToCanvas(preset));
        });
    }
    return me;
})();
var $6fc120d06db5f1ce$export$2e2bcd8739ae039 = $6fc120d06db5f1ce$var$DitherDialog;

});
parcelRegister("c4sle", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c9bd7c77a260124$export$2e2bcd8739ae039);
let $8c9bd7c77a260124$var$Storage = function() {
    let me = {};
    let typeData = {};
    me.put = (type, content, index)=>{
        typeData[type] = typeData[type] || [];
        if (typeof index === "number") typeData[type][index] = content;
        else typeData[type].push(content);
        localStorage.setItem("dp_" + type, JSON.stringify(typeData[type]));
    };
    me.get = (type, index)=>{
        if (typeData[type]) return typeData[type];
        let s = localStorage.getItem("dp_" + type);
        if (s) try {
            s = JSON.parse(s);
        } catch (e) {
            s = [];
        }
        typeData[type] = s;
        return s;
    };
    me.remove = (type, index)=>{
        typeData[type] = typeData[type] || [];
        typeData[type].splice(index, 1);
        localStorage.setItem("dp_" + type, JSON.stringify(typeData[type]));
    };
    return me;
}();
var $8c9bd7c77a260124$export$2e2bcd8739ae039 = $8c9bd7c77a260124$var$Storage;

});


parcelRegister("9nXmJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d544fd39d2230f0$export$2e2bcd8739ae039);

var $eJ26Q = parcelRequire("eJ26Q");
parcelRequire("jU8Uk");
let $6d544fd39d2230f0$var$OptionDialog = function() {
    let me = {};
    me.render = function(container, modal, data) {
        container.innerHTML = "";
        let panel = (0, $eJ26Q.default)(".optiondialog", {
            parent: container
        });
        (0, $eJ26Q.$setTarget)(panel);
        //if (data.title) $("h3",data.title);
        if (data.text) {
            if (typeof data.text === "string") data.text = [
                data.text
            ];
            data.text.forEach((text)=>{
                (0, $eJ26Q.default)("p", text);
            });
        }
        if (data.buttons) data.buttons.forEach((button)=>{
            (0, $eJ26Q.default)(".button.large", {
                onclick: ()=>{
                    if (button.onclick) button.onclick();
                    modal.hide();
                }
            }, button.label);
        });
        else (0, $eJ26Q.default)(".buttons.relative", (0, $eJ26Q.default)(".button.ghost", {
            onclick: modal.hide
        }, "Cancel"), (0, $eJ26Q.default)(".button.primary", {
            onclick: ()=>{
                modal.hide();
                if (data.onOk) data.onOk();
            }
        }, "OK"));
    };
    return me;
}();
var $6d544fd39d2230f0$export$2e2bcd8739ae039 = $6d544fd39d2230f0$var$OptionDialog;

});





parcelRegister("5FeyE", function(module, exports) {

$parcel$export(module.exports, "default", () => $41fc13009f5d2b17$export$2e2bcd8739ae039);

var $aEF6k = parcelRequire("aEF6k");

var $9dDG4 = parcelRequire("9dDG4");

var $k5ZAj = parcelRequire("k5ZAj");

var $jU8Uk = parcelRequire("jU8Uk");

var $9xub8 = parcelRequire("9xub8");
/*
Selection holds the data of the current selected pixels.
it always has a left,top,width, height of the bounding box.

if it has nothing more, selection is a rectangle
if it has a "points" array it's a polygon
if it has a canvas object, it is based on (the alpha layer of) the canvas.
 */ let $41fc13009f5d2b17$var$Selection = function() {
    let me = {};
    let currentSelection;
    me.set = function(selection) {
        currentSelection = selection || {};
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).selectionChanged);
    };
    me.move = function(x, y, w, h) {
        currentSelection = {
            left: x,
            top: y,
            width: w,
            height: h
        };
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).selectionChanged);
    };
    me.get = function() {
        return currentSelection;
    };
    me.clear = function() {
        let hasSelection = !!currentSelection;
        currentSelection = undefined;
        if (hasSelection) (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).selectionChanged);
    };
    me.selectAll = function() {
        let w = (0, $jU8Uk.default).getCurrentFile().width;
        let h = (0, $jU8Uk.default).getCurrentFile().height;
        (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).CLEARSELECTION);
        (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).SELECT);
        me.set({
            left: 0,
            top: 0,
            width: w,
            height: h
        });
    };
    me.getCanvas = function() {
        // renders the current selection to canvas
        if (currentSelection) {
            if (currentSelection.canvas) return (0, $9xub8.duplicateCanvas)(currentSelection.canvas, true);
            else if (currentSelection.points && currentSelection.points.length) {
                let result = document.createElement("canvas");
                result.width = (0, $jU8Uk.default).getCurrentFile().width;
                result.height = (0, $jU8Uk.default).getCurrentFile().height;
                let ctx = result.getContext("2d");
                ctx.fillStyle = "black";
                ctx.beginPath();
                currentSelection.points.forEach((point, index)=>{
                    if (index) ctx.lineTo(point.x, point.y);
                    else ctx.moveTo(point.x, point.y);
                });
                ctx.closePath();
                ctx.fill();
                return result;
            }
        }
        console.error("No selection to convert to canvas");
    };
    me.toCanvas = function() {
        // TODO: non rectangular selections
        if (currentSelection) {
            let canvas = document.createElement("canvas");
            canvas.width = currentSelection.width;
            canvas.height = currentSelection.height;
            let ctx = canvas.getContext("2d");
            ctx.imageSmoothingEnabled = false;
            ctx.drawImage((0, $jU8Uk.default).getActiveLayer().getCanvas(), currentSelection.left, currentSelection.top, canvas.width, canvas.height, 0, 0, canvas.width, canvas.height);
            return canvas;
        }
    };
    me.toStamp = function() {
        let canvas = me.toCanvas();
        if (canvas) {
            (0, $aEF6k.default).set("canvas", canvas);
            (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).DRAW);
            (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).CLEARSELECTION);
        }
    };
    me.toLayer = function(andCut) {
        if (currentSelection) {
            let canvas = (0, $jU8Uk.default).getActiveLayer().getCanvas();
            let sourceLayerIndex = (0, $jU8Uk.default).getActiveLayerIndex();
            (0, $jU8Uk.default).duplicateLayer();
            let layer = (0, $jU8Uk.default).getActiveLayer();
            if (currentSelection.points || currentSelection.canvas) {
                // draw on Mask
                layer.addMask();
                layer.toggleMask();
                let ctx = layer.getContext();
                ctx.fillStyle = "black";
                ctx.fillRect(0, 0, canvas.width, canvas.height);
                if (currentSelection.points) {
                    // draw Polygon on Mask
                    ctx.fillStyle = "white";
                    ctx.beginPath();
                    currentSelection.points.forEach((point, index)=>{
                        if (index) ctx.lineTo(point.x, point.y);
                        else ctx.moveTo(point.x, point.y);
                    });
                    ctx.closePath();
                    ctx.fill();
                }
                if (currentSelection.canvas) ctx.drawImage(currentSelection.canvas, 0, 0);
                layer.update();
                layer.removeMask(true);
            } else {
                // rectangle
                layer.clear();
                layer.getContext().drawImage(canvas, currentSelection.left, currentSelection.top, currentSelection.width, currentSelection.height, currentSelection.left, currentSelection.top, currentSelection.width, currentSelection.height);
            }
            if (andCut) {
                (0, $jU8Uk.default).activateLayer(sourceLayerIndex);
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).CLEAR);
                (0, $jU8Uk.default).activateLayer(sourceLayerIndex + 1);
            }
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layerContentChanged);
            (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).CLEARSELECTION);
        }
    };
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).SELECTALL, me.selectAll);
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).CLEARSELECTION, me.clear);
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).STAMP, me.toStamp);
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).TOLAYER, me.toLayer);
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).CUTTOLAYER, ()=>{
        me.toLayer(true);
    });
    return me;
}();
var $41fc13009f5d2b17$export$2e2bcd8739ae039 = $41fc13009f5d2b17$var$Selection;

});

parcelRegister("bo1l3", function(module, exports) {

$parcel$export(module.exports, "default", () => $84a2f96f113d7422$export$2e2bcd8739ae039);

var $9dDG4 = parcelRequire("9dDG4");

var $k5ZAj = parcelRequire("k5ZAj");

var $eJ26Q = parcelRequire("eJ26Q");

var $2hBLH = parcelRequire("2hBLH");

var $lkhKc = parcelRequire("lkhKc");

var $ebbAH = parcelRequire("ebbAH");
var $84a2f96f113d7422$var$Resizer = function(editor) {
    let me = {};
    let currentSize;
    let previousSize;
    let sizeBox;
    let updateHandler;
    let dots = [];
    let rotateDots = [];
    let touchData = {};
    let aspectRatio = 1;
    let canRotate = false;
    me.init = function(options) {
        options = options || {};
        if (!sizeBox) createSizeBox(editor.getViewPort());
        sizeBox.classList.add("active");
        sizeBox.classList.toggle("hot", !!options.hot);
        if (options.aspect) {
            aspectRatio = options.aspect;
            console.log("setting AR to " + aspectRatio);
        }
        canRotate = !!options.canRotate;
        sizeBox.classList.toggle("canrotate", canRotate);
        previousSize = undefined;
        currentSize = undefined;
        setSize(options.x, options.y, options.width, options.height, options.rotation);
    };
    function setSize(x, y, w, h, rotation) {
        previousSize = Object.assign({}, currentSize);
        currentSize = {
            left: Math.round(x),
            top: Math.round(y),
            width: Math.round(w),
            height: Math.round(h),
            rotation: rotation
        };
        if (!rotation) sizeBox.style.transform = "none";
        updateSizeBox();
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).sizerChanged, {
            from: previousSize,
            to: currentSize
        });
    }
    me.setOnUpdate = function(handler) {
        updateHandler = handler;
    };
    me.commit = function() {
        if (sizeBox) sizeBox.classList.remove("hot");
        updateHandler = undefined;
    };
    me.get = function() {
        return currentSize;
    };
    me.move = function(x, y) {
        if (me.isActive() && currentSize) {
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).sizerStartChange);
            //TODO: this still crops the canvas if we move outside the canvas
            previousSize = Object.assign({}, currentSize);
            currentSize.left += x;
            currentSize.top += y;
            updateSizeBox();
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).sizerChanged, {
                from: previousSize,
                to: currentSize
            });
        }
    };
    me.zoom = function(zoom) {
        updateSizeBox();
    };
    me.isActive = function() {
        return sizeBox && sizeBox.classList.contains("active");
    };
    me.remove = function() {
        previousSize = undefined;
        if (sizeBox) sizeBox.classList.remove("active");
    };
    (0, $9dDG4.default).on((0, $k5ZAj.EVENT).modifierKeyChanged, function() {
        if (sizeBox && sizeBox.classList.contains("active") && currentSize) updateSizeBox();
    });
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).CLEARSELECTION, ()=>{
        me.remove();
    });
    (0, $9dDG4.default).on((0, $k5ZAj.EVENT).imageSizeChanged, ()=>{
        me.remove();
    });
    function createSizeBox(parent) {
        sizeBox = (0, $eJ26Q.$div)("sizebox", "", parent, (e)=>{
            resizeBox(e);
        });
        sizeBox.classList.toggle("canrotate", canRotate);
        for(let i = 0; i < 8; i++){
            let dot = (0, $eJ26Q.$div)("sizedot", "", sizeBox, function(e) {
                resizeBox(e);
            });
            dot.onDragStart = function() {
                (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).sizerStartChange);
            };
            dot.onDrag = function(x, y) {
                handleDrag(x, y, dot);
            };
            dot.onDragEnd = function(x, y) {
                sizeBox.classList.remove("hot");
            };
            dot.index = i;
            dots.push(dot);
        }
        for(let i = 0; i < 4; i++){
            let rotateDot = (0, $eJ26Q.$div)("rotatedot d" + (i + 1), "", sizeBox, function(e) {});
            rotateDot.onDragStart = function() {
                let x = currentSize.left + currentSize.width / 2;
                let y = currentSize.top + currentSize.height / 2;
                touchData.rotateCenter = [
                    x,
                    y
                ];
                touchData.startAngle = currentSize.rotation;
                if (i === 0) touchData.rotateStart = [
                    currentSize.left,
                    currentSize.top
                ];
                if (i === 1) touchData.rotateStart = [
                    currentSize.left + currentSize.width,
                    currentSize.top
                ];
                if (i === 2) touchData.rotateStart = [
                    currentSize.left + currentSize.width,
                    currentSize.top + currentSize.height
                ];
                if (i === 3) touchData.rotateStart = [
                    currentSize.left,
                    currentSize.top + currentSize.height
                ];
                touchData.isRotating = true;
            };
            rotateDot.onDrag = function(x, y, _touchData) {
                touchData.rotateEnd = [
                    touchData.rotateStart[0] + x,
                    touchData.rotateStart[1] + y
                ];
                let a = {
                    x: touchData.rotateStart[0],
                    y: touchData.rotateStart[1]
                };
                let b = {
                    x: touchData.rotateCenter[0],
                    y: touchData.rotateCenter[1]
                };
                let c = {
                    x: touchData.rotateEnd[0],
                    y: touchData.rotateEnd[1]
                };
                let angle = angle_between_points(c, b, a);
                angle += touchData.startAngle || 0;
                if ((0, $lkhKc.default).isShiftDown() && (0, $lkhKc.default).isPointerDown()) angle = Math.round(angle / 15) * 15;
                currentSize.angle = angle;
                currentSize.rotation = angle;
                sizeBox.style.transform = "rotate(" + angle + "deg)";
                updateSizeBox();
            };
            rotateDot.onDragEnd = function(x, y) {
                currentSize.rotation = currentSize.angle;
                delete currentSize.angle;
                touchData.isRotating = false;
            };
            rotateDot.onpointerenter = function() {
                (0, $ebbAH.default).set("rotate");
            };
            rotateDot.onpointerleave = function() {
                (0, $ebbAH.default).reset();
            };
            rotateDot.index = i;
            rotateDots.push(rotateDot);
        }
        sizeBox.onDragStart = function(x, y) {
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).sizerStartChange);
        };
        sizeBox.onDrag = function(x, y) {
            handleDrag(x, y, {
                index: 8
            });
        };
        sizeBox.onDragEnd = function(x, y) {
            sizeBox.classList.remove("hot");
        };
    }
    function updateSizeBox() {
        if (!currentSize) return;
        var parent = editor.getCanvas();
        let viewport = editor.getViewPort();
        var rect = parent.getBoundingClientRect();
        var rect2 = viewport.getBoundingClientRect();
        let zoom = editor.getZoom();
        if ((0, $lkhKc.default).isShiftDown() && (0, $lkhKc.default).isPointerDown() && !touchData.isRotating) {
            // aspect ratio lock
            currentSize._width = currentSize._width || currentSize.width;
            currentSize._height = currentSize._height || currentSize.height;
            //let size = Math.min(currentSize._width,currentSize._height);
            let w = currentSize._width;
            let h = w / aspectRatio;
            if (w > currentSize.width || h > currentSize.height) {
                h = currentSize.height;
                w = h * aspectRatio;
            }
            currentSize.width = w;
            currentSize.height = h;
        }
        let wz = currentSize.width * zoom;
        let hz = currentSize.height * zoom;
        sizeBox.style.left = rect.left - rect2.left + viewport.scrollLeft + currentSize.left * zoom + "px";
        sizeBox.style.top = rect.top - rect2.top + viewport.scrollTop + currentSize.top * zoom + "px";
        sizeBox.style.width = wz + "px";
        sizeBox.style.height = hz + "px";
        dots[1].style.left = Math.round(wz / 2) + "px";
        dots[2].style.left = wz + "px";
        dots[3].style.left = wz + "px";
        dots[3].style.top = Math.round(hz / 2) + "px";
        dots[4].style.left = wz + "px";
        dots[4].style.top = hz + "px";
        dots[5].style.left = dots[1].style.left;
        dots[5].style.top = hz + "px";
        dots[6].style.top = hz + "px";
        dots[7].style.top = dots[3].style.top;
        rotateDots[1].style.left = dots[2].style.left;
        rotateDots[2].style.top = dots[4].style.top;
        rotateDots[2].style.left = dots[4].style.left;
        rotateDots[3].style.top = dots[6].style.top;
        if (updateHandler) updateHandler();
    }
    function resizeBox() {
        touchData.isResizing = true;
        touchData.isdown = true;
        touchData.startSelectWidth = currentSize.width;
        touchData.startSelectHeight = currentSize.height;
        touchData.startSelectLeft = currentSize.left;
        touchData.startSelectTop = currentSize.top;
        sizeBox.classList.add("hot");
    }
    function handleDrag(x, y, dot) {
        let zoom = (0, $2hBLH.default).getActivePanel().getZoom();
        let l = touchData.startSelectLeft;
        let t = touchData.startSelectTop;
        let w = touchData.startSelectWidth;
        let h = touchData.startSelectHeight;
        let xz = x / zoom;
        let yz = y / zoom;
        switch(dot.index){
            case 0:
                l += xz;
                t += yz;
                h -= yz;
                w -= xz;
                break;
            case 1:
                t += yz;
                h -= yz;
                break;
            case 2:
                t += yz;
                w += xz;
                h -= yz;
                break;
            case 3:
                w += xz;
                break;
            case 4:
                w += xz;
                h += yz;
                break;
            case 5:
                h += yz;
                break;
            case 6:
                l += xz;
                w -= xz;
                h += yz;
                break;
            case 7:
                l += xz;
                w -= xz;
                break;
            case 8:
                l += xz;
                t += yz;
                break;
        }
        setSize(l, t, w, h, currentSize ? currentSize.rotation : 0);
    }
    function angle_between_points(p1, p2, p3) {
        // p2 is the center point;
        const ab = {
            x: p2.x - p1.x,
            y: p2.y - p1.y
        };
        const bc = {
            x: p3.x - p2.x,
            y: p3.y - p2.y
        };
        const radians = Math.atan2(bc.y, bc.x) - Math.atan2(ab.y, ab.x);
        const degrees = -(radians * 180 / Math.PI - 180) % 360;
        return degrees;
    }
    return me;
};
var $84a2f96f113d7422$export$2e2bcd8739ae039 = $84a2f96f113d7422$var$Resizer;

});

parcelRegister("81IXX", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d814c0a4a6d3ed6$export$2e2bcd8739ae039);

var $eJ26Q = parcelRequire("eJ26Q");

var $5FeyE = parcelRequire("5FeyE");

var $9dDG4 = parcelRequire("9dDG4");

var $k5ZAj = parcelRequire("k5ZAj");

var $2hBLH = parcelRequire("2hBLH");

var $jU8Uk = parcelRequire("jU8Uk");

var $lkhKc = parcelRequire("lkhKc");

var $9xub8 = parcelRequire("9xub8");

var $bfgOg = parcelRequire("bfgOg");

var $gDIFj = parcelRequire("gDIFj");
/*
    SelectBox follows changes in the selection.
    If the resize is active, the resize triggers a change in the selection, this triggers a change in the selectbox.

    There are 3 different types of selection:
    - rectangle selection, this is also calculated as a bounding box for the other types
    - polygon selection, this is a series of points
    - canvas selection, this is a selection of pixels
 */ let $5d814c0a4a6d3ed6$var$SelectBox = (editor, resizer)=>{
    let me = {};
    let box = (0, $eJ26Q.$div)("selectbox");
    let canvas;
    let ctx;
    let selectionPoints = [];
    let selectionTransform;
    let selecting;
    let dots;
    let shape;
    let selectionTool;
    let timeout;
    let border = (0, $eJ26Q.$div)("border", "<svg xmlns='http://www.w3.org/2000/svg' viewbox='0 0 40 40' preserveAspectRatio='none'><rect class='white' width='40' height='40'/><rect class='ants'  width='40' height='40'/>/svg>");
    box.appendChild(border);
    let content = (0, $eJ26Q.$div)("content");
    box.appendChild(content);
    me.getBox = ()=>{
        return box;
    };
    me.activate = (tool)=>{
        if (tool) selectionTool = tool;
        let currentSelection = (0, $5FeyE.default).get();
        box.classList.add("active");
        if (currentSelection) switch(tool){
            case (0, $k5ZAj.COMMAND).SELECT:
                if (editor.isActive()) resizer.init({
                    x: currentSelection.left,
                    y: currentSelection.top,
                    width: currentSelection.width,
                    height: currentSelection.height,
                    rotation: 0,
                    aspectRatio: 1,
                    canRotate: false
                });
                break;
            case (0, $k5ZAj.COMMAND).POLYGONSELECT:
                if (currentSelection.points) {
                    clearTimeout(timeout);
                    resizer.remove();
                    me.polySelect();
                }
                break;
            case (0, $k5ZAj.COMMAND).FLOODSELECT:
                resizer.remove();
                break;
            case (0, $k5ZAj.COMMAND).COLORSELECT:
                resizer.remove();
                break;
            case (0, $k5ZAj.COMMAND).TOSELECTION:
                resizer.remove();
                break;
        }
    };
    me.deActivate = ()=>{
        box.classList.remove("active", "capture");
        cleanUp();
    };
    me.isActive = ()=>{
        return box.classList.contains("active");
    };
    me.boundingBoxSelect = (point)=>{
        (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).CLEARSELECTION);
        me.activate((0, $k5ZAj.COMMAND).SELECT);
        resizer.init({
            x: point.x,
            y: point.y,
            width: 0,
            height: 0,
            rotation: 0,
            hot: true,
            aspect: 1,
            canRotate: false
        });
    };
    me.polySelect = (point)=>{
        if (!dots) dots = (0, $eJ26Q.$div)("dots", "", content);
        if (!selecting) {
            let currentSelection = (0, $5FeyE.default).get();
            if (currentSelection && currentSelection.points && currentSelection.points.length) selectionPoints = currentSelection.points;
            else selectionPoints = [];
            (0, $lkhKc.default).setActiveKeyHandler(keyHandler);
        }
        selecting = true;
        border.classList.remove("active");
        border.classList.remove("filled");
        box.classList.add("capture");
        if (point) {
            selectionPoints.push(point);
            if (selectionPoints.length === 1) selectionPoints.push({
                x: point.x,
                y: point.y
            });
        }
        updateBoundingBox();
        drawPolyShape();
    };
    me.endPolySelect = (fromClick)=>{
        selecting = false;
        timeout = setTimeout(()=>{
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).endPolygonSelect);
            (0, $lkhKc.default).setActiveKeyHandler();
            selectionPoints = [];
            if (dots) {
                dots.innerHTML = "";
                dots = undefined;
            }
            box.classList.remove("capture");
        }, fromClick ? 100 : 0);
    };
    // Don't overuse this function, it's expensive
    me.applyCanvas = (_canvas)=>{
        let selectedCanvas = (0, $9xub8.duplicateCanvas)(_canvas, true);
        let selectedCtx = selectedCanvas.getContext("2d");
        selectedCtx.globalCompositeOperation = "source-in";
        selectedCtx.fillStyle = "white";
        selectedCtx.fillRect(0, 0, _canvas.width, _canvas.height);
        selectedCtx.globalCompositeOperation = "source-over";
        // generate SVG outline..; Expensive! move to webworker?
        let outline = (0, $9xub8.outLineCanvas)(selectedCtx, false);
        (0, $5FeyE.default).set({
            left: outline.box.x,
            top: outline.box.y,
            width: outline.box.w,
            height: outline.box.h,
            canvas: selectedCanvas,
            outline: outline.lines
        });
    };
    me.floodSelect = function(canvas, point, fillColor) {
        fillColor = fillColor || [
            0,
            0,
            0
        ];
        let w = canvas.width;
        let h = canvas.height;
        let imageData = canvas.getContext("2d").getImageData(0, 0, w, h);
        let tolerance = (0, $gDIFj.default).getTolerance();
        fillColor[3] = 255;
        let c = (0, $9xub8.duplicateCanvas)(canvas).getContext("2d");
        let target = c.getImageData(0, 0, w, h);
        let done = {};
        let check = [];
        let ind = getIndex(point);
        put(ind);
        let color = getColor(ind);
        while(check.length){
            let i = check.shift();
            let x = i % w;
            let y = (i - x) / w;
            if (x > 0) checkIndex(i - 1);
            if (x < w - 1) checkIndex(i + 1);
            if (y > 0) checkIndex(i - w);
            if (y < h - 1) checkIndex(i + w);
        }
        c.putImageData(target, 0, 0);
        return c.canvas;
        function getColor(index) {
            index *= 4;
            let r = imageData.data[index];
            let g = imageData.data[index + 1];
            let b = imageData.data[index + 2];
            let a = imageData.data[index + 3];
            if (index >= imageData.data.length) console.error("invalid index " + index);
            else return (0, $bfgOg.default).toHex([
                r,
                g,
                b,
                a
            ]);
        }
        function getIndex(p) {
            return p.y * w + p.x;
        }
        function checkIndex(ind) {
            if (!done[ind]) {
                let c = getColor(ind);
                let passed = c === color;
                if (!passed && tolerance) {
                    let distance = (0, $bfgOg.default).distance(c, color);
                    passed = distance <= tolerance * 2;
                }
                if (passed) put(ind);
            }
        }
        function put(ind) {
            target.data[ind * 4] = fillColor[0];
            target.data[ind * 4 + 1] = fillColor[1];
            target.data[ind * 4 + 2] = fillColor[2];
            target.data[ind * 4 + 3] = 255;
            done[ind] = true;
            check.push(ind);
        }
    };
    me.colorSelect = function(color) {
        let canvas = (0, $jU8Uk.default).getActiveLayer().getCanvas();
        let w = canvas.width;
        let h = canvas.height;
        let imageData = canvas.getContext("2d").getImageData(0, 0, w, h);
        let c = (0, $9xub8.duplicateCanvas)(canvas).getContext("2d");
        let target = c.getImageData(0, 0, w, h);
        color = (0, $bfgOg.default).fromString(color);
        for(let x = 0; x < w; x++)for(let y = 0; y < h; y++){
            let index = (y * w + x) * 4;
            let r = imageData.data[index];
            let g = imageData.data[index + 1];
            let b = imageData.data[index + 2];
            let a = imageData.data[index + 3];
            if (a && r === color[0] && g === color[1] && b === color[2]) {
                target.data[index] = 255;
                target.data[index + 1] = 255;
                target.data[index + 2] = 255;
                target.data[index + 3] = 255;
            }
        }
        c.putImageData(target, 0, 0);
        me.applyCanvas(c.canvas);
    };
    function renderSelection() {
        let selection = (0, $5FeyE.default).get();
        let zoom = editor.getZoom();
        let showOutline = (0, $gDIFj.default).showSelectionOutline();
        let showFill = (0, $gDIFj.default).showSelectionMask();
        border.classList.remove("active");
        border.classList.remove("filled");
        if (shape) shape.innerHTML = "";
        if (canvas && ctx) ctx.clearRect(0, 0, canvas.width, canvas.height);
        if (selection) {
            if (selection.points && selection.points.length) {
                selectionPoints = selection.points;
                drawPolyShape();
            } else if (selection.canvas) {
                if (showFill) {
                    if (!canvas) {
                        canvas = (0, $9xub8.duplicateCanvas)((0, $jU8Uk.default).getCanvas());
                        content.appendChild(canvas);
                        ctx = canvas.getContext("2d");
                    }
                    ctx.globalAlpha = 0.5;
                    ctx.drawImage(selection.canvas, 0, 0);
                    ctx.globalCompositeOperation = "source-in";
                    ctx.fillStyle = "red";
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                    ctx.globalCompositeOperation = "source-over";
                }
                if (showOutline) {
                    if (selection.outline) drawOutline(selection);
                }
            } else {
                border.style.left = selection.left * zoom + "px";
                border.style.top = selection.top * zoom + "px";
                border.style.width = selection.width * zoom + "px";
                border.style.height = selection.height * zoom + "px";
                if (showOutline) border.classList.add("active");
                if (showFill) border.classList.add("filled");
            }
        } else me.deActivate();
    }
    me.zoom = (zoom)=>{
        resizer.zoom();
        renderSelection();
    };
    me.updatePoint = (point, index)=>{
        if (typeof index === "undefined") index = selectionPoints.length - 1;
        let p = selectionPoints[index];
        if (p) {
            p.x = point.x;
            p.y = point.y;
        }
        updateBoundingBox();
        drawPolyShape();
    };
    function drawPolyShape() {
        let zoom = (0, $2hBLH.default).getActivePanel().getZoom();
        let drawOutline = (0, $gDIFj.default).showSelectionOutline();
        let drawFill = (0, $gDIFj.default).showSelectionMask();
        let generateSVG = drawOutline || drawFill;
        if (dots) dots.innerHTML = "";
        let w = (0, $jU8Uk.default).getCurrentFile().width;
        let h = (0, $jU8Uk.default).getCurrentFile().height;
        let path = "";
        selectionPoints.forEach((point, index)=>{
            if (dots) {
                let dot = (0, $eJ26Q.$div)("sizedot", "", dots, ()=>{});
                dot.onDragStart = (x, y)=>{
                    point.startX = point.x;
                    point.startY = point.y;
                };
                dot.onDrag = (x, y)=>{
                    point.x = Math.round(point.startX + x / zoom);
                    point.y = Math.round(point.startY + y / zoom);
                    drawPolyShape();
                };
                dot.onDragEnd = ()=>{
                    updateBoundingBox();
                };
                dot.style.left = point.x * zoom + "px";
                dot.style.top = point.y * zoom + "px";
            }
            if (generateSVG) path += point.x + " " + point.y + " ";
        });
        if (generateSVG) {
            if (!shape) shape = (0, $eJ26Q.$div)("shape", "", content);
            // close the path
            if (selectionPoints.length > 1) path += selectionPoints[0].x + " " + selectionPoints[0].y + " ";
            let svg = "<svg xmlns='http://www.w3.org/2000/svg' viewbox='0 0 " + w + " " + h + "' preserveAspectRatio='none'>";
            let className = "";
            if (drawOutline) className = "white";
            if (drawFill) className += " filled";
            svg += "<path class='" + className + "' d='M" + path + "'/>";
            if (drawOutline) svg += "<path class='ants' d='M" + path + "'/>";
            svg += "</svg>";
            shape.innerHTML = svg;
        } else if (shape) {
            shape.innerHTML = "";
            shape = undefined;
        }
    }
    function drawOutline(selection) {
        if (!selection) return;
        let lines = selection.outline;
        if (!lines) return;
        if (!shape) shape = (0, $eJ26Q.$div)("shape", "", content);
        let w = (0, $jU8Uk.default).getCurrentFile().width;
        let h = (0, $jU8Uk.default).getCurrentFile().height;
        let svg = "<svg xmlns='http://www.w3.org/2000/svg' viewbox='0 0 " + w + " " + h + "' preserveAspectRatio='none'>";
        if (lines.length > 6000) {
            console.warn("too many lines, displaying bounding box instead");
            svg += '<rect x="' + selection.left + '" y="' + selection.top + '" width="' + selection.width + '" height="' + selection.height + '" class="white" />';
            svg += '<rect x="' + selection.left + '" y="' + selection.top + '" width="' + selection.width + '" height="' + selection.height + '" class="ants" />';
        } else // draw lines
        lines.forEach((h)=>{
            let x = h[0];
            let y = h[1];
            let x2 = h[2];
            let y2 = h[3];
            svg += '<line x1="' + x + '" y1="' + y + '" x2="' + x2 + '" y2="' + y2 + '" class="white" />';
            svg += '<line x1="' + x + '" y1="' + y + '" x2="' + x2 + '" y2="' + y2 + '" class="ants" />';
        });
        svg += "</svg>";
        shape.innerHTML = svg;
    }
    function keyHandler(code) {
        //console.error(code);
        if (selecting) switch(code){
            case "keyj":
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).TOLAYER);
                return true;
            case "keyk":
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).CUTTOLAYER);
                return true;
            case "escape":
                me.endPolySelect();
                return true;
            case "enter":
                me.endPolySelect();
                return true;
        }
    }
    function cleanUp() {
        selectionPoints = [];
        selectionTransform = undefined;
        if (dots) {
            dots.innerHTML = "";
            dots = undefined;
        }
        if (shape) {
            shape.innerHTML = "";
            shape = undefined;
        }
        if (canvas) {
            canvas.remove();
            (0, $9xub8.releaseCanvas)(canvas);
            canvas = undefined;
        }
        content.innerHTML = "";
        border.classList.remove("active");
        border.classList.remove("filled");
        if (selecting) {
            selecting = false;
            me.endPolySelect();
        }
    }
    function updateBoundingBox() {
        let x = (0, $jU8Uk.default).getCurrentFile().width;
        let y = (0, $jU8Uk.default).getCurrentFile().height;
        let x2 = 0;
        let y2 = 0;
        if (selectionPoints && selectionPoints.length) {
            selectionPoints.forEach((point)=>{
                if (point.x < x) x = point.x;
                if (point.y < y) y = point.y;
                if (point.x > x2) x2 = point.x;
                if (point.y > y2) y2 = point.y;
            });
            // warning; this updates the selection, which triggers a change in the selectbox
            (0, $5FeyE.default).set({
                left: x,
                top: y,
                width: x2 - x,
                height: y2 - y,
                points: selectionPoints
            });
        }
    }
    (0, $9dDG4.default).on((0, $k5ZAj.EVENT).sizerStartChange, ()=>{
        if (me.isActive() && editor.isActive()) {
            let selection = (0, $5FeyE.default).get();
            if (selection.canvas) {
                selectionTransform = {
                    left: selection.left,
                    top: selection.top,
                    width: selection.width,
                    height: selection.height,
                    canvas: (0, $9xub8.duplicateCanvas)(selection.canvas, true)
                };
                if (selection.outline) selectionTransform.outline = selection.outline.map((a)=>a.slice());
            }
        }
    });
    (0, $9dDG4.default).on((0, $k5ZAj.EVENT).sizerChanged, (change)=>{
        if (me.isActive() && editor.isActive()) {
            let fromSize = change.from;
            let currentSize = change.to;
            if (currentSize) {
                let selection = (0, $5FeyE.default).get();
                let handled = false;
                if (fromSize && selection) {
                    let translate = {
                        x: 0,
                        y: 0,
                        scale: 1
                    };
                    translate.x = currentSize.left - fromSize.left;
                    translate.y = currentSize.top - fromSize.top;
                    translate.scaleX = currentSize.width / fromSize.width;
                    translate.scaleY = currentSize.height / fromSize.height;
                    if (isNaN(translate.scaleX)) translate.scaleX = 1;
                    if (isNaN(translate.scaleY)) translate.scaleY = 1;
                    if (selection.points && selection.points.length) {
                        selectionPoints = selection.points;
                        if (translate.x || translate.y) selectionPoints.forEach((point)=>{
                            point.x += translate.x;
                            point.y += translate.y;
                        });
                        if (translate.scaleX !== 1 || translate.scaleY !== 1) {
                            let startX = currentSize.left;
                            let startY = currentSize.top;
                            selectionPoints.forEach((point)=>{
                                point.x = startX + Math.round((point.x - startX) * translate.scaleX);
                                point.y = startY + Math.round((point.y - startY) * translate.scaleY);
                            });
                        }
                        currentSize.points = selectionPoints;
                        (0, $5FeyE.default).set(currentSize);
                        handled = true;
                    } else if (selection.canvas) {
                        if (translate.scaleX !== 1 || translate.scaleY !== 1 || translate.x || translate.y) {
                            // scale the original selection canvas and outline
                            let deltaScaleX = currentSize.width / selectionTransform.width;
                            let deltaScaleY = currentSize.height / selectionTransform.height;
                            if (selection.outline && selectionTransform.outline) {
                                for(let i = 0; i < selection.outline.length; i++){
                                    selection.outline[i][0] = currentSize.left + Math.round((selectionTransform.outline[i][0] - selectionTransform.left) * deltaScaleX);
                                    selection.outline[i][1] = currentSize.top + Math.round((selectionTransform.outline[i][1] - selectionTransform.top) * deltaScaleY);
                                    selection.outline[i][2] = currentSize.left + Math.round((selectionTransform.outline[i][2] - selectionTransform.left) * deltaScaleX);
                                    selection.outline[i][3] = currentSize.top + Math.round((selectionTransform.outline[i][3] - selectionTransform.top) * deltaScaleY);
                                }
                                currentSize.outline = selection.outline;
                            }
                            if (selectionTransform.canvas) {
                                let offsetX = selectionTransform.left * deltaScaleX - currentSize.left;
                                let offsetY = selectionTransform.top * deltaScaleY - currentSize.top;
                                let c = (0, $9xub8.duplicateCanvas)(selectionTransform.canvas);
                                let ctx = c.getContext("2d");
                                ctx.clearRect(0, 0, c.width, c.height);
                                ctx.drawImage(selectionTransform.canvas, -offsetX, -offsetY, c.width * deltaScaleX, c.height * deltaScaleY);
                                currentSize.canvas = c;
                            }
                            (0, $5FeyE.default).set(currentSize);
                            handled = true;
                        }
                    }
                }
                if (!handled) {
                    // set the bounding box
                    if (selection) {
                        selection.left = currentSize.left;
                        selection.top = currentSize.top;
                        selection.width = currentSize.width;
                        selection.height = currentSize.height;
                        (0, $5FeyE.default).set(selection);
                    } else (0, $5FeyE.default).set(currentSize);
                }
            }
        }
    });
    (0, $9dDG4.default).on((0, $k5ZAj.EVENT).selectionChanged, ()=>{
        if (!editor.isVisible()) return;
        if (!me.isActive()) return;
        renderSelection();
    });
    (0, $9dDG4.default).on((0, $k5ZAj.EVENT).toolChanged, (tool)=>{
        if (me.isActive()) {
            selectionTransform = undefined;
            box.classList.remove("capture");
            resizer.remove();
        }
    });
    return me;
};
var $5d814c0a4a6d3ed6$export$2e2bcd8739ae039 = $5d814c0a4a6d3ed6$var$SelectBox;

});

parcelRegister("4UCrC", function(module, exports) {

$parcel$export(module.exports, "default", () => $393a36a3bf3e0a24$export$2e2bcd8739ae039);

var $jU8Uk = parcelRequire("jU8Uk");

var $9dDG4 = parcelRequire("9dDG4");

var $k5ZAj = parcelRequire("k5ZAj");

var $aEF6k = parcelRequire("aEF6k");

var $eTCYn = parcelRequire("eTCYn");
parcelRequire("bfgOg");

var $9xub8 = parcelRequire("9xub8");
// somewhat based on https://stackoverflow.com/questions/28197378/html5-canvas-javascript-smudge-brush-tool
let $393a36a3bf3e0a24$var$Smudge = function() {
    let me = {};
    let lastForce = 1;
    let alpha = 0.5;
    let hardness = 0.01;
    let radius = 10;
    const brushCtx = document.createElement("canvas").getContext("2d");
    let featherGradient;
    let ctx;
    let lastX;
    let lastY;
    me.start = function(touchData) {
        touchData.isSmudging = true;
        touchData.drawLayer = (0, $jU8Uk.default).getActiveLayer();
        ctx = touchData.drawLayer.getContext();
        let { x: x, y: y } = touchData;
        lastX = x;
        lastY = y;
        lastForce = touchData.force || 1;
        let settings = (0, $aEF6k.default).getSettings();
        alpha = settings.opacity / 100;
        hardness = 1 - settings.softness / 10;
        radius = settings.width;
        if (isNaN(hardness)) hardness = 0.01;
        if (radius < 2) radius = 2;
        updateBrushSettings();
    };
    me.draw = function(touchData) {
        if (!touchData.isSmudging) return;
        let { x: x, y: y, force: force } = touchData;
        force = force || 1;
        let tempCtx;
        if ((0, $eTCYn.default).isLocked()) {
            let tempCanvas = (0, $9xub8.duplicateCanvas)(brushCtx.canvas);
            tempCtx = tempCanvas.getContext("2d");
        }
        const line = setupLine(lastX, lastY, x, y);
        for(let more = true; more;){
            more = advanceLine(line);
            let x = line.position[0] - brushCtx.canvas.width / 2;
            let y = line.position[1] - brushCtx.canvas.height / 2;
            let w = brushCtx.canvas.width;
            let h = brushCtx.canvas.height;
            if ((0, $eTCYn.default).isLocked()) {
                tempCtx.clearRect(0, 0, w, h);
                tempCtx.drawImage(ctx.canvas, x, y, w, h, 0, 0, w, h);
                tempCtx.globalAlpha = alpha * lerp(lastForce, force, line.u);
                tempCtx.drawImage(brushCtx.canvas, 0, 0);
                let data = tempCtx.getImageData(0, 0, w, h);
                for(let i = 0; i < data.data.length; i += 4){
                    let r = data.data[i];
                    let g = data.data[i + 1];
                    let b = data.data[i + 2];
                    let finalColor = (0, $eTCYn.default).matchColor([
                        r,
                        g,
                        b
                    ]);
                    //console.error(finalColor,r,g,b);
                    data.data[i] = finalColor[0];
                    data.data[i + 1] = finalColor[1];
                    data.data[i + 2] = finalColor[2];
                }
                tempCtx.putImageData(data, 0, 0);
                ctx.clearRect(x, y, w, h);
                ctx.drawImage(tempCtx.canvas, x, y);
            } else {
                ctx.globalAlpha = alpha * lerp(lastForce, force, line.u);
                ctx.drawImage(brushCtx.canvas, x, y);
            }
            updateBrush(line.position[0], line.position[1]);
            ctx.globalAlpha = 1;
        }
        lastX = x;
        lastY = y;
        lastForce = force;
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layerContentChanged);
    };
    function createFeatherGradient(radius, hardness) {
        const innerRadius = Math.min(radius * hardness, radius - 1);
        const gradient = brushCtx.createRadialGradient(0, 0, innerRadius, 0, 0, radius);
        gradient.addColorStop(0, "rgba(0, 0, 0, 0)");
        gradient.addColorStop(1, "rgba(0, 0, 0, 1)");
        return gradient;
    }
    function updateBrushSettings() {
        featherGradient = createFeatherGradient(radius / 2, hardness);
        brushCtx.canvas.width = radius;
        brushCtx.canvas.height = radius;
    }
    function feather(ctx) {
        // feather the brush
        ctx.save();
        ctx.fillStyle = featherGradient;
        ctx.globalCompositeOperation = "destination-out";
        const { width: width, height: height } = ctx.canvas;
        ctx.translate(width / 2, height / 2);
        ctx.fillRect(-width / 2, -height / 2, width, height);
        ctx.restore();
    }
    function updateBrush(x, y) {
        let width = brushCtx.canvas.width;
        let height = brushCtx.canvas.height;
        let srcX = x - width / 2;
        let srcY = y - height / 2;
        // draw it in the middle of the brush
        let dstX = (brushCtx.canvas.width - width) / 2;
        let dstY = (brushCtx.canvas.height - height) / 2;
        // clear the brush canvas
        brushCtx.clearRect(0, 0, brushCtx.canvas.width, brushCtx.canvas.height);
        // clip the rectangle to be
        // inside
        if (srcX < 0) {
            width += srcX;
            dstX -= srcX;
            srcX = 0;
        }
        const overX = srcX + width - ctx.canvas.width;
        if (overX > 0) width -= overX;
        if (srcY < 0) {
            dstY -= srcY;
            height += srcY;
            srcY = 0;
        }
        const overY = srcY + height - ctx.canvas.height;
        if (overY > 0) height -= overY;
        if (width <= 0 || height <= 0) return;
        brushCtx.drawImage(ctx.canvas, srcX, srcY, width, height, dstX, dstY, width, height);
        feather(brushCtx);
    }
    function lerp(a, b, t) {
        return a + (b - a) * t;
    }
    function setupLine(x, y, targetX, targetY) {
        const deltaX = targetX - x;
        const deltaY = targetY - y;
        const deltaRow = Math.abs(deltaX);
        const deltaCol = Math.abs(deltaY);
        const counter = Math.max(deltaCol, deltaRow);
        const axis = counter == deltaCol ? 1 : 0;
        // setup a line draw.
        return {
            position: [
                x,
                y
            ],
            delta: [
                deltaX,
                deltaY
            ],
            deltaPerp: [
                deltaRow,
                deltaCol
            ],
            inc: [
                Math.sign(deltaX),
                Math.sign(deltaY)
            ],
            accum: Math.floor(counter / 2),
            counter: counter,
            endPnt: counter,
            axis: axis,
            u: 0
        };
    }
    function advanceLine(line) {
        --line.counter;
        line.u = 1 - line.counter / line.endPnt;
        if (line.counter <= 0) return false;
        const axis = line.axis;
        const perp = 1 - axis;
        line.accum += line.deltaPerp[perp];
        if (line.accum >= line.endPnt) {
            line.accum -= line.endPnt;
            line.position[perp] += line.inc[perp];
        }
        line.position[axis] += line.inc[axis];
        return true;
    }
    return me;
}();
var $393a36a3bf3e0a24$export$2e2bcd8739ae039 = $393a36a3bf3e0a24$var$Smudge;

});

parcelRegister("h67gn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c728a186441789c0$export$2e2bcd8739ae039);

var $eJ26Q = parcelRequire("eJ26Q");

var $jU8Uk = parcelRequire("jU8Uk");

var $clDPp = parcelRequire("clDPp");
let $c728a186441789c0$var$GridOverlay = (parent)=>{
    let container = parent;
    let me = {};
    let visible = false;
    let grid;
    let zoom = 1;
    let linesVertical = [];
    let linesHorizontal = [];
    me.toggle = ()=>{
        visible = !visible;
        if (visible && !grid) grid = (0, $eJ26Q.$div)("grid", "", container);
        grid.style.display = visible ? "block" : "none";
        me.update();
    };
    me.update = (rebuild)=>{
        let options = (0, $clDPp.default).getOptions();
        visible = options.visible;
        if (!visible) return;
        if (!grid) grid = (0, $eJ26Q.$div)("grid", "", container);
        let w = (0, $jU8Uk.default).getCurrentFile().width;
        let h = (0, $jU8Uk.default).getCurrentFile().height;
        let size = options.size || 16;
        grid.innerHTML = "";
        grid.style.opacity = options.opacity / 100;
        grid.style.filter = "brightness(" + options.brightness + "%)";
        linesVertical = [];
        linesHorizontal = [];
        for(let x = size; x < w; x += size){
            let line = (0, $eJ26Q.$div)("line vertical", "", grid);
            line.style.left = x * zoom + "px";
            linesVertical.push(line);
        }
        for(let y = size; y < h; y += size){
            let line = (0, $eJ26Q.$div)("line horizontal", "", grid);
            line.style.top = y * zoom + "px";
            linesHorizontal.push(line);
        }
    };
    me.zoom = (factor)=>{
        zoom = factor;
        let options = (0, $clDPp.default).getOptions();
        visible = options.visible;
        if (!visible) return;
        let size = options.size || 16;
        console.log("zooming grid", size, zoom);
        linesVertical.forEach((line, index)=>{
            line.style.left = size * zoom * (index + 1) + "px";
            console.log("line", line.style.left);
        });
        linesHorizontal.forEach((line, index)=>{
            line.style.top = size * zoom * (index + 1) + "px";
        });
    };
    return me;
};
var $c728a186441789c0$export$2e2bcd8739ae039 = $c728a186441789c0$var$GridOverlay;

});
parcelRegister("clDPp", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fd6574572a1d978$export$2e2bcd8739ae039);
parcelRequire("jU8Uk");

var $9dDG4 = parcelRequire("9dDG4");

var $k5ZAj = parcelRequire("k5ZAj");

var $eJ26Q = parcelRequire("eJ26Q");
parcelRequire("aEF6k");
let $8fd6574572a1d978$var$GridPanel = function() {
    let me = {};
    let sizeRange;
    let sizeInput;
    let opacityRange;
    let opacityInput;
    let brightnessRange;
    let brightnessInput;
    let visibleToggle;
    let contentPanel;
    let options = {
        size: 32,
        brightness: 0,
        opacity: 100,
        visible: false
    };
    me.generate = (parent)=>{
        let visibleSelect = (0, $eJ26Q.$div)("rangeselect", "", parent);
        (0, $eJ26Q.$elm)("label", "Visible", visibleSelect);
        visibleToggle = (0, $eJ26Q.default)(".yesno", {
            parent: visibleSelect,
            onClick: (e)=>{
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).TOGGLEGRID);
            },
            info: "Show or hide the grid"
        }, (0, $eJ26Q.default)(".option", "Yes"), (0, $eJ26Q.default)(".option", "No"));
        let sizeSelect = (0, $eJ26Q.$div)("rangeselect", "", parent);
        (0, $eJ26Q.$elm)("label", "Size", sizeSelect);
        sizeRange = (0, $eJ26Q.$input)("range", options.size, sizeSelect, ()=>{
            update();
        });
        sizeInput = (0, $eJ26Q.$input)("text", options.size, sizeSelect);
        sizeRange.min = 16;
        sizeRange.max = 100;
        sanitize(sizeInput, sizeRange);
        let opacitySelect = (0, $eJ26Q.$div)("rangeselect", "", parent);
        (0, $eJ26Q.$elm)("label", "Opacity", opacitySelect);
        opacityRange = (0, $eJ26Q.$input)("range", options.opacity, opacitySelect, ()=>{
            update();
        });
        opacityInput = (0, $eJ26Q.$input)("text", options.opacity, opacitySelect);
        opacityRange.min = 1;
        opacityRange.max = 100;
        sanitize(opacityInput, opacityRange);
        let brightnessSelect = (0, $eJ26Q.$div)("rangeselect", "", parent);
        (0, $eJ26Q.$elm)("label", "Brightness", brightnessSelect);
        brightnessRange = (0, $eJ26Q.$input)("range", options.brightness, brightnessSelect, ()=>{
            update();
        });
        brightnessInput = (0, $eJ26Q.$input)("text", options.brightness, brightnessSelect);
        brightnessRange.min = 0;
        brightnessRange.max = 100;
        sanitize(brightnessInput, brightnessRange);
        contentPanel = (0, $eJ26Q.$div)("panelcontent", "", parent);
    };
    me.getOptions = ()=>{
        return options;
    };
    function update() {
        options.size = parseInt(sizeRange.value);
        options.opacity = parseInt(opacityRange.value);
        options.brightness = parseInt(brightnessRange.value);
        (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).gridOptionsChanged, options);
    }
    function sanitize(input, range) {
        range.min = range.min || 0;
        range.max = range.max || 100;
        let min = parseInt(range.min);
        let max = parseInt(range.max);
        input.onkeydown = (e)=>{
            e.stopPropagation();
        };
        input.onchange = (e)=>{
            let val = parseInt(input.value, 10);
            if (isNaN(val)) val = min;
            if (val < min) val = min;
            if (val > max) val = max;
            range.value = val;
            update();
        };
    }
    (0, $9dDG4.default).on((0, $k5ZAj.EVENT).gridOptionsChanged, (_options)=>{
        options = _options;
        sizeRange.value = options.size;
        sizeInput.value = options.size;
        opacityRange.value = options.opacity;
        opacityInput.value = options.opacity;
        brightnessRange.value = options.brightness;
        brightnessInput.value = options.brightness;
    });
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).TOGGLEGRID, ()=>{
        options.visible = !options.visible;
        visibleToggle.classList.toggle("selected", options.visible);
    });
    return me;
}();
var $8fd6574572a1d978$export$2e2bcd8739ae039 = $8fd6574572a1d978$var$GridPanel;

});



parcelRegister("gECXt", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1fe9a0fe6796bfa$export$2e2bcd8739ae039);

var $eJ26Q = parcelRequire("eJ26Q");

var $9dDG4 = parcelRequire("9dDG4");

var $k5ZAj = parcelRequire("k5ZAj");

var $fEhXZ = parcelRequire("fEhXZ");

var $2hBLH = parcelRequire("2hBLH");

var $jU8Uk = parcelRequire("jU8Uk");

var $gDIFj = parcelRequire("gDIFj");

var $lkhKc = parcelRequire("lkhKc");

var $aEF6k = parcelRequire("aEF6k");

var $j2Icj = parcelRequire("j2Icj");
parcelRequire("4sZF5");
parcelRequire("4eKVl");
var $c1fe9a0fe6796bfa$var$EditPanel = function(parent, type) {
    var me = {};
    var zoomLevels = [
        0.1,
        0.25,
        0.5,
        1,
        2,
        3,
        4,
        6,
        8,
        10,
        15,
        20,
        30,
        50,
        100
    ];
    let startZoom = 1;
    let startScale = 1;
    let isZooming = false;
    let touchData = {};
    var panel = (0, $eJ26Q.$div)("panel " + type, "", parent);
    var toolbar = (0, $eJ26Q.$div)("toolbar", "", panel);
    var viewport = (0, $eJ26Q.$div)("viewport", "", panel);
    let windowContainer;
    let windowCanvasList = [];
    let tileContainer;
    let toolPanel;
    let currentView = "editor";
    var thisPanel = type === "left" ? 0 : 1;
    if (thisPanel === 1) panel.style.display = "none";
    me.getViewPort = function() {
        return viewport;
    };
    var canvas = (0, $fEhXZ.default)(me);
    me.getCanvas = function() {
        return canvas.getCanvas();
    };
    me.getZoom = function() {
        return canvas.getZoom();
    };
    me.getResizer = function() {
        return canvas.getResizer();
    };
    me.getIndex = function() {
        return thisPanel;
    };
    viewport.addEventListener("wheel", function(e) {
        e.preventDefault();
        if ((0, $lkhKc.default).isShiftDown()) {
            let point = canvas.getCursorPosition(e);
            let settings = (0, $aEF6k.default).getSettings();
            let offset = e.deltaY > 0 ? -1 : 1;
            (0, $j2Icj.default).set({
                size: settings.width + offset
            });
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).drawCanvasOverlay, point);
        //console.error(settings);
        } else if ((0, $lkhKc.default).isControlDown()) {
            let point = canvas.getCursorPosition(e);
            let settings = (0, $aEF6k.default).getSettings();
            let offset = e.deltaY > 0 ? -5 : 5;
            (0, $j2Icj.default).set({
                opacity: settings.opacity + offset
            });
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).drawCanvasOverlay, point);
        } else {
            if (e.deltaY > 0) (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).ZOOMOUT, e);
            else if (e.deltaY < 0) (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).ZOOMIN, e);
        }
    });
    if ("gesturestart" in window) {
        // TODO: I probably shouldn't bother with gestures, as it's not supported on Android.
        // better to implement a generic solution with touch events
        // besides ... we still need to track touches to get the center of the gesture
        viewport.addEventListener("gesturestart", function(e) {
            e.preventDefault();
            e.stopPropagation();
            (0, $lkhKc.default).holdPointerEvents();
            startScale = e.scale || 1;
            startZoom = canvas.getZoom();
            touchData.startScrollX = viewport.scrollLeft;
            touchData.startScrollY = viewport.scrollTop;
            touchData.startDragX = e.clientX;
            touchData.startDragY = e.clientY;
        //console.log("gesturestart");
        });
        viewport.addEventListener("gesturechange", function(e) {
            e.preventDefault();
            e.stopPropagation();
            let scale = startScale * (e.scale || 1);
            let touches = (0, $lkhKc.default).getTouches();
            if (touches.length > 1) {
                if (scale > 1.2 || scale < 0.8 || isZooming) {
                    let zoom = scale * startZoom;
                    canvas.setZoom(zoom, e);
                    syncZoomLevel();
                    isZooming = true;
                // TODO also apply panning ?
                } else {
                    // pan
                    let dx = touchData.startDragX - e.clientX;
                    let dy = touchData.startDragY - e.clientY;
                    viewport.scrollLeft = touchData.startScrollX + dx;
                    viewport.scrollTop = touchData.startScrollY + dy;
                }
            }
        //console.log("gesturechange");
        });
        viewport.addEventListener("gestureend", function(e) {
            e.preventDefault();
            e.stopPropagation();
            (0, $lkhKc.default).releasePointerEvents();
            isZooming = false;
        });
    } else {
        viewport.addEventListener("touchstart", function(e) {
            if (e.touches.length > 1) {
                e.preventDefault();
                e.stopPropagation();
                (0, $lkhKc.default).holdPointerEvents();
                touchData.startScrollX = viewport.scrollLeft;
                touchData.startScrollY = viewport.scrollTop;
                touchData.startDragX = e.touches[0].clientX;
                touchData.startDragY = e.touches[0].clientY;
                touchData.startZoom = canvas.getZoom();
                touchData.startScale = 1;
                let dx = e.touches[0].clientX - e.touches[1].clientX;
                let dy = e.touches[0].clientY - e.touches[1].clientY;
                touchData.startDistance = Math.sqrt(dx * dx + dy * dy);
            }
        });
        viewport.addEventListener("touchmove", function(e) {
            if (e.touches.length > 1) {
                e.preventDefault();
                e.stopPropagation();
                let dx = e.touches[0].clientX - e.touches[1].clientX;
                let dy = e.touches[0].clientY - e.touches[1].clientY;
                let distance = Math.sqrt(dx * dx + dy * dy);
                let scale = distance / touchData.startDistance;
                if (scale > 1.1 || scale < 0.9 || isZooming) {
                    let zoom = touchData.startZoom * scale;
                    syncZoomLevel();
                    isZooming = true;
                    canvas.setZoom(zoom);
                } else {
                    // pan
                    dx = touchData.startDragX - e.touches[0].clientX;
                    dy = touchData.startDragY - e.touches[0].clientY;
                    viewport.scrollLeft = touchData.startScrollX + dx;
                    viewport.scrollTop = touchData.startScrollY + dy;
                }
            }
        });
        viewport.addEventListener("touchend", function(e) {
            e.preventDefault();
            e.stopPropagation();
            (0, $lkhKc.default).releasePointerEvents();
            isZooming = false;
        });
    }
    viewport.addEventListener("pointerenter", function(e) {
        (0, $lkhKc.default).setPointerOver("viewport");
    }, false);
    viewport.addEventListener("pointerleave", function(e) {
        (0, $lkhKc.default).removePointerOver("viewport");
    }, false);
    panel.addEventListener("pointermove", ()=>{
        (0, $2hBLH.default).setActivePanel(thisPanel);
    //activeCanvas = type==="left"?canvas:canvas2;
    });
    function syncZoomLevel() {
        let z = Math.floor(canvas.getZoom() * 100);
        zoombutton.innerHTML = z + "%";
    }
    me.clear = function() {
        canvas.clear();
    };
    me.zoom = function(zoomFactor, center) {
        canvas.zoom(zoomFactor, center);
        syncZoomLevel();
    };
    me.zoomToFit = function() {
        const rect = viewport.getBoundingClientRect();
        let sx = rect.width / canvas.getCanvas().width;
        let sy = rect.height / canvas.getCanvas().height;
        canvas.setZoom(Math.min(sx, sy));
        canvas.resetPan();
        syncZoomLevel();
    };
    me.setZoom = function(factor) {
        canvas.setZoom(factor);
        syncZoomLevel();
    };
    me.getWidth = function() {
        return panel.getBoundingClientRect().width;
    };
    me.setWidth = function(w, percentage) {
        let p = percentage ? "%" : "px";
        if (typeof w === "string") p = "";
        panel.style.width = w + p;
    };
    me.setView = function(type) {
        console.log("setting view to " + type);
        currentView = type;
        viewport.classList.toggle("hidden", type !== "editor");
        if (windowContainer) windowContainer.classList.toggle("hidden", type !== "icons");
        if (tileContainer) tileContainer.classList.toggle("hidden", type !== "tiles");
        if (type === "icons") {
            if (!windowContainer) generateWindows();
            windowContainer.classList.remove("hidden");
            updateWindows();
        }
        if (type === "tiles") {
            if (!tileContainer) generateTiles();
            tileContainer.classList.remove("hidden");
            updateTiles();
        }
    };
    me.show = function() {
        panel.style.display = "block";
    };
    me.hide = function() {
        panel.style.display = "none";
    };
    me.isVisible = function() {
        return panel.style.display !== "none";
    };
    me.isActive = function() {
        return me.isVisible() && (0, $2hBLH.default).getActivePanel().getIndex() === thisPanel;
    };
    // setup toolbar
    let zoomoutButton = (0, $eJ26Q.$div)("button info", "-", toolbar, ()=>{
        var z = canvas.getZoom();
        for(var i = zoomLevels.length - 1; i >= 0; i--){
            var zoom = zoomLevels[i];
            if (zoom < z) break;
        }
        canvas.setZoom(zoom);
        syncZoomLevel();
    });
    var zoombutton = (0, $eJ26Q.$div)("button auto info", "100%", toolbar, ()=>{
        canvas.setZoom(1);
        syncZoomLevel();
    });
    let zoominButton = (0, $eJ26Q.$div)("button info", "+", toolbar, ()=>{
        var z = canvas.getZoom();
        for(var i = 0; i < zoomLevels.length - 1; i++){
            var zoom = zoomLevels[i];
            if (zoom > z) break;
        }
        canvas.setZoom(zoom);
        syncZoomLevel();
    });
    let zoomFitButton = (0, $eJ26Q.$div)("button expand info", "", toolbar, me.zoomToFit);
    zoomoutButton.info = "Zoom out";
    zoominButton.info = "Zoom in";
    zoombutton.info = "Reset zoom to 100%";
    zoomFitButton.info = "Zoom to fit screen";
    if (thisPanel === 0) {
        (0, $eJ26Q.$div)("button closepresentation", "x", toolbar, ()=>{
            (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).PRESENTATION);
        });
        toolPanel = (0, $eJ26Q.$div)("toolpanel", "", toolbar);
        (0, $9dDG4.default).on((0, $k5ZAj.EVENT).toolChanged, (tool)=>{
            tool = tool || (0, $2hBLH.default).getCurrentTool();
            toolPanel.innerHTML = "";
            toolPanel.appendChild((0, $gDIFj.default).getOptions(tool));
        });
    }
    if (thisPanel === 1) {
        let viewPanel = (0, $eJ26Q.$div)("viewstyle", "", toolbar);
        let b1 = (0, $eJ26Q.$div)("button info editor active", "E", viewPanel, ()=>{
            me.setView("editor");
        });
        let b2 = (0, $eJ26Q.$div)("button info icons", "I", viewPanel, ()=>{
            me.setView("icons");
        });
        let b3 = (0, $eJ26Q.$div)("button info tiles", "T", viewPanel, ()=>{
            me.setView("tiles");
        });
        b1.info = "View in editor";
        b2.info = "Preview as icon";
        b3.info = "Preview as tile";
    }
    function generateWindows() {
        windowContainer = (0, $eJ26Q.$div)("windowContainer", "", panel);
        for(let i = 1; i < 4; i++){
            let window1 = (0, $eJ26Q.$div)("window", "", windowContainer);
            let colorbar = (0, $eJ26Q.$div)("colorbar", "", window1);
            let windowCanvas = document.createElement("canvas");
            windowCanvas.width = 280;
            windowCanvas.height = 142;
            window1.appendChild(windowCanvas);
            windowCanvasList.push(windowCanvas.getContext("2d"));
        }
    }
    function updateWindows() {
        let icon = (0, $jU8Uk.default).getCanvas();
        let colors = [
            "#959595",
            "#3A67A3",
            "#000000"
        ];
        windowCanvasList.forEach((ctx, index)=>{
            ctx.fillStyle = colors[index];
            ctx.fillRect(0, 0, 280, 142);
            let x = 10;
            let y = 10;
            while(y < 140){
                while(x < 280){
                    ctx.drawImage(icon, x, y);
                    x = x + icon.width + 10;
                }
                x = 10;
                y = y + icon.height + 10;
            }
        });
    }
    function generateTiles() {
        tileContainer = (0, $eJ26Q.$div)("tileContainer", "", panel);
    }
    function updateTiles() {
        let tile = (0, $jU8Uk.default).getCanvas();
        let imageDataURL = tile.toDataURL();
        tileContainer.style.backgroundImage = "url('" + imageDataURL + "')";
    }
    (0, $9dDG4.default).on((0, $k5ZAj.EVENT).imageSizeChanged, ()=>{
        setTimeout(syncZoomLevel, 20);
    });
    (0, $9dDG4.default).on((0, $k5ZAj.EVENT).imageContentChanged, ()=>{
        if (currentView === "icons") updateWindows();
        if (currentView === "tiles") updateTiles();
    });
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).PRESENTATION, ()=>{
        if (me.isVisible()) me.zoomToFit();
    });
    (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).ZOOMFIT, ()=>{
        if (me.isVisible()) me.zoomToFit();
    });
    return me;
};
var $c1fe9a0fe6796bfa$export$2e2bcd8739ae039 = $c1fe9a0fe6796bfa$var$EditPanel;

});


parcelRegister("b6UY4", function(module, exports) {

$parcel$export(module.exports, "default", () => $816c71e38998eba6$export$2e2bcd8739ae039);

var $eJ26Q = parcelRequire("eJ26Q");

var $ebbAH = parcelRequire("ebbAH");

var $9dDG4 = parcelRequire("9dDG4");
let $816c71e38998eba6$var$ContextMenu = (()=>{
    let menu;
    let me = {};
    me.show = (items)=>{
        if (!menu) {
            menu = (0, $eJ26Q.$div)("contextmenu");
            document.body.appendChild(menu);
        }
        menu.innerHTML = "";
        items.forEach((item)=>{
            (0, $eJ26Q.$div)("contextmenuitem", item.label, menu, ()=>{
                if (item.command) (0, $9dDG4.default).trigger(item.command);
                if (item.action) item.action();
                me.hide();
            });
        });
        let position = (0, $ebbAH.default).getPosition();
        menu.style.left = position.x + "px";
        menu.style.top = position.y + "px";
        menu.classList.add("active");
    };
    me.hide = ()=>{
        if (menu) menu.classList.remove("active");
    };
    return me;
})();
var $816c71e38998eba6$export$2e2bcd8739ae039 = $816c71e38998eba6$var$ContextMenu;

});



parcelRegister("cZrAj", function(module, exports) {

$parcel$export(module.exports, "default", () => $9750944670b7b7e7$export$2e2bcd8739ae039);

var $jU8Uk = parcelRequire("jU8Uk");

var $eJ26Q = parcelRequire("eJ26Q");

var $9dDG4 = parcelRequire("9dDG4");

var $k5ZAj = parcelRequire("k5ZAj");

var $b6UY4 = parcelRequire("b6UY4");

var $lkhKc = parcelRequire("lkhKc");

var $ebbAH = parcelRequire("ebbAH");
let $9750944670b7b7e7$var$FramesPanel = function() {
    let me = {};
    let contentPanel;
    let frames = [];
    me.generate = (parent)=>{
        (0, $eJ26Q.default)(".paneltools", {
            parent: parent
        }, (0, $eJ26Q.default)(".button.delete", {
            onClick: ()=>{
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).DELETEFRAME);
            },
            info: "Delete active frame"
        }), (0, $eJ26Q.default)(".button.add", {
            onClick: ()=>{
                (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).ADDFRAME);
            },
            info: "Add new frame"
        }));
        contentPanel = (0, $eJ26Q.$div)("panelcontent", "", parent);
    };
    me.list = ()=>{
        contentPanel.innerHTML = "";
        frames = [];
        let activeIndex = (0, $jU8Uk.default).getActiveFrameIndex() || 0;
        let imageFile = (0, $jU8Uk.default).getCurrentFile();
        if (imageFile && imageFile.frames) {
            let hasMultipleItems = imageFile.frames.length > 1;
            let max = imageFile.frames.length - 1;
            imageFile.frames.forEach((frame, index)=>{
                let elm = (0, $eJ26Q.$div)("frame info" + (activeIndex === index && hasMultipleItems ? " active" : ""), "", contentPanel, ()=>{
                    (0, $jU8Uk.default).activateFrame(index);
                });
                elm.currentIndex = elm.targetIndex = index;
                elm.id = "frame" + index;
                elm.style.left = index * 52 + "px";
                elm.info = "Click to activate, drag to reorder, right click for more options";
                let canvas = document.createElement("canvas");
                canvas.width = 48;
                canvas.height = 48;
                canvas.getContext("2d").drawImage((0, $jU8Uk.default).getCanvas(index), 0, 0, 48, 48);
                elm.appendChild(canvas);
                elm.onDragStart = (e)=>{
                    let dupe = (0, $eJ26Q.$div)("dragelement box frame", "Frame " + index);
                    (0, $lkhKc.default).setDragElement(dupe);
                    let currentTarget = contentPanel.querySelector("#frame" + elm.currentIndex);
                    if (currentTarget) currentTarget.startDragX = currentTarget.currentIndex * 52 + e.clientX - currentTarget.getBoundingClientRect().left;
                };
                elm.onDrag = (x, y)=>{
                    let distance = Math.abs(x);
                    // TODO: avoid comple list refresh on pointer down ?
                    if (distance > 5) {
                        (0, $ebbAH.default).set("drag");
                        contentPanel.classList.add("inactive");
                        let currentTarget = contentPanel.querySelector("#frame" + elm.currentIndex);
                        if (currentTarget) {
                            currentTarget.classList.add("ghost");
                            let newIndex = Math.floor((currentTarget.startDragX + x) / 52);
                            elm.targetIndex = newIndex;
                            if (newIndex < 0) newIndex = 0;
                            if (newIndex >= max) newIndex = max;
                            for(let i = 0; i <= max; i++){
                                let el = contentPanel.querySelector("#frame" + i);
                                if (el) {
                                    if (elm.currentIndex === i) el.style.left = newIndex * 52 + "px";
                                    else {
                                        let ci = 0;
                                        if (newIndex < elm.currentIndex && i >= newIndex && i <= elm.currentIndex) ci = -1;
                                        if (newIndex > elm.currentIndex && i <= newIndex && i >= elm.currentIndex) ci = 1;
                                        el.style.left = (i - ci) * 52 + "px";
                                    }
                                }
                            }
                        }
                    }
                };
                elm.onDragEnd = (e)=>{
                    (0, $lkhKc.default).removeDragElement();
                    if (elm.currentIndex !== elm.targetIndex) (0, $jU8Uk.default).moveFrame(elm.currentIndex, elm.targetIndex);
                    let currentTarget = contentPanel.querySelector("#frame" + elm.currentIndex);
                    if (currentTarget) currentTarget.classList.remove("ghost");
                    (0, $ebbAH.default).reset();
                    contentPanel.classList.remove("inactive");
                };
                elm.onContextMenu = ()=>{
                    let items = [];
                    if (hasMultipleItems) items.push({
                        label: "Remove Frame",
                        command: (0, $k5ZAj.COMMAND).DELETEFRAME
                    });
                    items.push({
                        label: "Duplicate Frame",
                        command: (0, $k5ZAj.COMMAND).DUPLICATEFRAME
                    });
                    (0, $b6UY4.default).show(items);
                };
                (0, $eJ26Q.$div)("label", "" + index, elm);
                frames.push(elm);
            });
        }
    };
    me.update = ()=>{
        let index = (0, $jU8Uk.default).getActiveFrameIndex();
        let frame = frames[index];
        if (frame) {
            let canvas = frame.querySelector("canvas");
            if (canvas) {
                let ctx = canvas.getContext("2d");
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                ctx.drawImage((0, $jU8Uk.default).getCanvas(index), 0, 0, 48, 48);
            }
        }
    };
    (0, $9dDG4.default).on((0, $k5ZAj.EVENT).imageSizeChanged, me.list);
    (0, $9dDG4.default).on((0, $k5ZAj.EVENT).framesChanged, me.list);
    (0, $9dDG4.default).on((0, $k5ZAj.EVENT).layerContentChanged, me.update);
    return me;
}();
var $9750944670b7b7e7$export$2e2bcd8739ae039 = $9750944670b7b7e7$var$FramesPanel;

});

parcelRegister("lTixE", function(module, exports) {

$parcel$export(module.exports, "default", () => $fefd1e0f8aaf93b5$export$2e2bcd8739ae039);

var $eJ26Q = parcelRequire("eJ26Q");
parcelRequire("8ztM6");

var $eTCYn = parcelRequire("eTCYn");
let $fefd1e0f8aaf93b5$var$ColorPicker = function() {
    let me = {};
    let ctx;
    let ctx2;
    let rgbaColor = "rgba(255,0,0,1)";
    let w = 120;
    let cx = w - 1;
    let cy = 0;
    let dot;
    let line;
    me.generate = (parent)=>{
        let container = (0, $eJ26Q.default)(".colorpicker", {
            parent: parent
        });
        let canvas = (0, $eJ26Q.default)("canvas.handle", {
            width: w,
            height: w,
            parent: container,
            onDrag: (x, y, d)=>{
                let box = canvas.getBoundingClientRect();
                cx = d.startX + x - box.left;
                cy = d.startY + y - box.top;
                setColor(d.button);
            },
            onDragStart: (e)=>{
                let box = canvas.getBoundingClientRect();
                cx = e.clientX - box.left;
                cy = e.clientY - box.top;
                setColor(e.button);
            }
        });
        ctx = canvas.getContext("2d");
        fillGradient();
        let colorStrip = (0, $eJ26Q.default)("canvas.handle", {
            width: 20,
            height: w,
            parent: container,
            onDrag: (x, y, d)=>{
                let box = colorStrip.getBoundingClientRect();
                let cy = d.startY + y - box.top;
                setStrip(cy, d.button);
            },
            onDragStart: (e)=>{
                let box = colorStrip.getBoundingClientRect();
                let cy = e.clientY - box.top;
                setStrip(cy, e.button);
            }
        });
        ctx2 = colorStrip.getContext("2d");
        fillStrip();
        dot = (0, $eJ26Q.default)(".dot", {
            parent: container
        });
        line = (0, $eJ26Q.default)(".line", {
            parent: container
        });
    };
    function fillStrip() {
        let grd1 = ctx2.createLinearGradient(0, 0, 0, w);
        grd1.addColorStop(0, "rgba(255, 0, 0, 1)");
        grd1.addColorStop(0.17, "rgba(255, 255, 0, 1)");
        grd1.addColorStop(0.34, "rgba(0, 255, 0, 1)");
        grd1.addColorStop(0.51, "rgba(0, 255, 255, 1)");
        grd1.addColorStop(0.68, "rgba(0, 0, 255, 1)");
        grd1.addColorStop(0.85, "rgba(255, 0, 255, 1)");
        grd1.addColorStop(1, "rgba(255, 0, 0, 1)");
        ctx2.fillStyle = grd1;
        ctx2.fillRect(0, 0, 20, w);
    }
    function fillGradient() {
        ctx.fillStyle = rgbaColor;
        ctx.fillRect(0, 0, w, w);
        let grdWhite = ctx.createLinearGradient(0, 0, w, 0);
        grdWhite.addColorStop(0, "rgba(255,255,255,1)");
        grdWhite.addColorStop(1, "rgba(255,255,255,0)");
        ctx.fillStyle = grdWhite;
        ctx.fillRect(0, 0, w, w);
        let grdBlack = ctx.createLinearGradient(0, 0, 0, w);
        grdBlack.addColorStop(0, "rgba(0,0,0,0)");
        grdBlack.addColorStop(1, "rgba(0,0,0,1)");
        ctx.fillStyle = grdBlack;
        ctx.fillRect(0, 0, w, w);
    }
    function setColor(button) {
        if (cx < 0) cx = 0;
        if (cx > w) cx = w - 1;
        if (cy < 0) cy = 0;
        if (cy > w) cy = w - 1;
        dot.style.left = cx + "px";
        dot.style.top = cy + "px";
        let imageData = ctx.getImageData(cx, cy, 1, 1).data;
        (0, $eTCYn.default).setColor(imageData, button, true);
    }
    function setStrip(sy, button) {
        if (sy > w) sy = w - 1;
        if (sy < 0) sy = 0;
        line.style.top = sy + "px";
        let imageData = ctx2.getImageData(0, sy, 1, 1).data;
        rgbaColor = "rgba(" + imageData[0] + "," + imageData[1] + "," + imageData[2] + ",1)";
        fillGradient();
        setColor(button);
    }
    return me;
}();
var $fefd1e0f8aaf93b5$export$2e2bcd8739ae039 = $fefd1e0f8aaf93b5$var$ColorPicker;

});



parcelRegister("a8IsR", function(module, exports) {

var $94bSz = parcelRequire("94bSz");
let $761d247291208e40$var$url = new URL("quantize.1de3ea60.js", import.meta.url);
module.exports = $94bSz($761d247291208e40$var$url.toString(), $761d247291208e40$var$url.origin, true);

});
parcelRegister("94bSz", function(module, exports) {
"use strict";
module.exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? "import " + JSON.stringify(workerUrl) + ";" : "importScripts(" + JSON.stringify(workerUrl) + ");";
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: "application/javascript"
        }));
    }
};

});





parcelRegister("22JNL", function(module, exports) {

$parcel$export(module.exports, "default", () => $17cf4be8b2d94008$export$2e2bcd8739ae039);

var $bfgOg = parcelRequire("bfgOg");

var $gDIFj = parcelRequire("gDIFj");

var $9xub8 = parcelRequire("9xub8");

var $aEF6k = parcelRequire("aEF6k");

var $eZZbx = parcelRequire("eZZbx");

var $eZded = parcelRequire("eZded");

var $eTCYn = parcelRequire("eTCYn");
parcelRequire("jU8Uk");
let $17cf4be8b2d94008$var$Layer = function(width, height, name) {
    let me = {
        visible: true,
        opacity: 100,
        name: name,
        blendMode: "normal",
        hasMask: false,
        locked: false
    };
    let canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    let ctx = canvas.getContext("2d", {
        willReadFrequently: true
    });
    //note: willReadFrequently forces the canvas to remain on the CPU instead of the GPU
    // this also "fixes" a bug in Chrome where multiple calls to getImageData() on the same canvas clears the canvas incorrectly
    let mask;
    let maskCtx;
    let maskActive;
    let alphaLayer;
    let alphaCtx;
    let combined;
    let drawLayer;
    let drawCtx;
    let drawMask;
    let drawMaskCtx;
    let isDrawing;
    let drawOpacity;
    let currentColor;
    me.getCanvas = function() {
        if (maskActive) return mask;
        else return canvas;
    };
    me.getCanvasType = function(maskType) {
        return maskType ? mask : canvas;
    };
    me.getContext = function() {
        if (maskActive) return maskCtx;
        else return ctx;
    };
    me.render = function() {
        if (mask || isDrawing) {
            if (!combined) combined = (0, $9xub8.duplicateCanvas)(canvas);
            let combinedCtx = combined.getContext("2d", {
                willReadFrequently: true
            });
            combinedCtx.clearRect(0, 0, combined.width, combined.height);
            combinedCtx.globalCompositeOperation = "source-over";
            combinedCtx.drawImage(canvas, 0, 0);
            if (isDrawing && drawLayer) {
                if (mask && maskActive) {
                    // temporary composite alphaLayer
                    if (!drawMask) {
                        drawMask = (0, $9xub8.duplicateCanvas)(mask);
                        drawMaskCtx = drawMask.getContext("2d");
                    }
                    drawMaskCtx.clearRect(0, 0, drawMask.width, drawMask.height);
                    drawMaskCtx.drawImage(mask, 0, 0);
                    drawMaskCtx.globalAlpha = drawOpacity;
                    drawMaskCtx.drawImage(drawLayer, 0, 0);
                    drawMaskCtx.globalAlpha = 1;
                    me.update(drawMaskCtx);
                } else {
                    combinedCtx.globalAlpha = drawOpacity;
                    if (currentColor === "transparent") combinedCtx.globalCompositeOperation = "destination-out";
                    combinedCtx.drawImage(drawLayer, 0, 0);
                    combinedCtx.globalCompositeOperation = "source-over";
                    combinedCtx.globalAlpha = 1;
                }
            }
            if (mask) {
                if (maskActive && (0, $gDIFj.default).showMask()) {
                    combinedCtx.fillStyle = "red";
                    combinedCtx.globalAlpha = 0.7;
                    combinedCtx.fillRect(0, 0, combined.width, combined.height);
                    combinedCtx.globalAlpha = 1;
                }
                combinedCtx.globalCompositeOperation = "destination-in";
                combinedCtx.drawImage(alphaLayer, 0, 0);
                combinedCtx.globalCompositeOperation = "source-over";
            }
            return combined;
        } else return canvas;
    };
    me.clear = function() {
        if (maskActive) maskCtx.clearRect(0, 0, canvas.width, canvas.height);
        else ctx.clearRect(0, 0, canvas.width, canvas.height);
    };
    me.drawImage = function(image, x, y) {
        x = x || 0;
        y = y || 0;
        let _ctx = me.getContext();
        _ctx.imageSmoothingEnabled = false;
        _ctx.drawImage(image, x, y);
        me.update();
    };
    me.draw = function(x, y, color, touchData) {
        if (!drawLayer) {
            drawLayer = (0, $9xub8.duplicateCanvas)(canvas);
            drawCtx = drawLayer.getContext("2d");
        }
        if (!touchData.isDrawing) drawOpacity = (0, $eTCYn.default).isLocked() ? 1 : (0, $aEF6k.default).getOpacity();
        isDrawing = true;
        currentColor = color;
        let drawColor = color;
        if (color === "transparent") drawColor = "black";
        //Brush.draw(me.getContext(),x,y,color,true);
        let b = (0, $aEF6k.default).draw(drawCtx, x, y, drawColor, touchData.button, true); // TODO: color should not be part of the brush?
        if ((0, $eZded.default).getDitherState()) {
            let pattern = (0, $eZded.default).getDitherPattern();
            drawCtx.globalCompositeOperation = touchData.button ? "destination-out" : "destination-in";
            drawCtx.drawImage(pattern, 0, 0);
            drawCtx.globalCompositeOperation = "source-over";
        }
    };
    me.drawShape = function(drawFunction, x, y, w, h) {
        if (!drawLayer) {
            drawLayer = (0, $9xub8.duplicateCanvas)(canvas);
            drawCtx = drawLayer.getContext("2d");
        }
        isDrawing = true;
        drawFunction(drawCtx, x, y, w, h);
    };
    me.commitDraw = function() {
        let _ctx = me.getContext();
        _ctx.globalAlpha = drawOpacity;
        if (currentColor === "transparent") _ctx.globalCompositeOperation = "destination-out";
        _ctx.drawImage(drawLayer, 0, 0);
        _ctx.globalCompositeOperation = "source-over";
        _ctx.globalAlpha = 1;
        drawCtx.clearRect(0, 0, drawLayer.width, drawLayer.height);
        isDrawing = false;
        currentColor = "";
        (0, $eZZbx.default).end();
    };
    me.fill = function(color) {
        color = (0, $bfgOg.default).fromString(color);
        let imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        let data = imageData.data;
        let max = data.length >> 2;
        for(let i = 0; i < max; i++){
            let index = i * 4;
            if (data[index + 3] > 100) {
                imageData.data[index] = color[0];
                imageData.data[index + 1] = color[1];
                imageData.data[index + 2] = color[2];
            }
        }
        ctx.putImageData(imageData, 0, 0);
    };
    me.addMask = function(hide) {
        if (!mask) {
            mask = (0, $9xub8.duplicateCanvas)(canvas);
            alphaLayer = (0, $9xub8.duplicateCanvas)(canvas);
            if (!combined) combined = (0, $9xub8.duplicateCanvas)(canvas);
            maskCtx = mask.getContext("2d");
            alphaCtx = alphaLayer.getContext("2d");
            maskCtx.fillStyle = alphaLayer.fillStyle = hide ? "black" : "white";
            maskCtx.fillRect(0, 0, mask.width, mask.height);
            alphaCtx.fillRect(0, 0, mask.width, mask.height);
            me.hasMask = true;
            if (!me.isMaskActive()) {
                me.toggleMask();
                me.update(maskCtx);
                me.toggleMask();
            }
        }
    };
    me.removeMask = function(andApply) {
        if (mask) {
            if (andApply) {
                ctx.globalCompositeOperation = "destination-in";
                ctx.drawImage(alphaLayer, 0, 0);
                ctx.globalCompositeOperation = "source-over";
            }
            (0, $9xub8.releaseCanvas)(mask);
            if (drawMask) (0, $9xub8.releaseCanvas)(drawMask);
            //releaseCanvas(alphaLayer);
            maskCtx = undefined;
            mask = undefined;
            me.hasMask = false;
            maskActive = false;
        }
    };
    me.toggleMask = function() {
        maskActive = !maskActive;
    };
    me.isMaskActive = ()=>{
        return maskActive;
    };
    me.update = (_maskCtx)=>{
        _maskCtx = _maskCtx || maskCtx;
        if (maskActive) {
            // move mask mayer to alpha layer
            let img = _maskCtx.getImageData(0, 0, canvas.width, canvas.height);
            for(let i = 0, max = img.data.length; i < max; i += 4)img.data[i + 3] = img.data[i]; // move red channel to alpha
            alphaCtx.putImageData(img, 0, 0);
        }
    };
    me.clone = (forSerialization, indexed)=>{
        let struct = {
            name: me.name,
            blendMode: me.blendMode,
            opacity: me.opacity,
            visible: me.visible,
            hasMask: me.hasMask
        };
        if (!forSerialization) indexed = false;
        if (indexed) {
            let indexed = me.generateIndexedPixels();
            struct.indexedPixels = indexed.pixels;
            struct.conversionErrors = indexed.notFoundCount;
        } else struct.canvas = forSerialization ? canvas.toDataURL() : (0, $9xub8.duplicateCanvas)(canvas);
        if (me.hasMask) struct.mask = forSerialization ? mask.toDataURL() : (0, $9xub8.duplicateCanvas)(mask);
        return struct;
    };
    me.restore = (struct)=>{
        return new Promise((next)=>{
            me.name = struct.name;
            me.blendMode = struct.blendMode;
            me.opacity = struct.opacity;
            me.visible = !!struct.visible;
            me.hasMask = !!struct.hasMask;
            let canvasRestored = true;
            let maskRestored = true;
            if (mask) (0, $9xub8.releaseCanvas)(mask);
            if (alphaLayer) (0, $9xub8.releaseCanvas)(alphaLayer);
            if (combined) (0, $9xub8.releaseCanvas)(combined);
            mask = undefined;
            alphaLayer = undefined;
            maskActive = false;
            let isDone = ()=>{
                if (canvasRestored && maskRestored) {
                    if (struct.mask) {
                        let a = maskActive;
                        maskActive = true;
                        me.update();
                        maskActive = a;
                    }
                    next();
                }
            };
            if (struct.canvas) {
                canvasRestored = false;
                if (typeof struct.canvas === "string") {
                    let img = new Image();
                    img.onload = ()=>{
                        ctx.drawImage(img, 0, 0);
                        canvasRestored = true;
                        isDone();
                    };
                    img.src = struct.canvas;
                } else ctx.drawImage(struct.canvas, 0, 0);
            } else if (struct.indexedPixels) {
                console.log("restoring indexed pixels");
                canvasRestored = false;
                let imgData = ctx.createImageData(canvas.width, canvas.height);
                let colors = (0, $eTCYn.default).get();
                let w = canvas.width;
                let h = canvas.height;
                let indexed = struct.indexedPixels;
                for(let y = 0; y < h; y++)for(let x = 0; x < w; x++){
                    let line = indexed[y] || [];
                    let offset = (y * w + x) * 4;
                    let index = line[x];
                    if (typeof index !== "number") index = -1;
                    if (index >= 0) {
                        let color = colors[index] || [
                            0,
                            0,
                            0
                        ];
                        imgData.data[offset] = color[0];
                        imgData.data[offset + 1] = color[1];
                        imgData.data[offset + 2] = color[2];
                        imgData.data[offset + 3] = 255;
                    } else {
                        imgData.data[offset] = 0;
                        imgData.data[offset + 1] = 0;
                        imgData.data[offset + 2] = 0;
                        imgData.data[offset + 3] = 0;
                    }
                }
                ctx.putImageData(imgData, 0, 0);
                canvasRestored = true;
            }
            if (struct.mask) {
                maskRestored = false;
                me.addMask();
                if (typeof struct.mask === "string") {
                    let img = new Image();
                    img.onload = ()=>{
                        maskCtx.drawImage(img, 0, 0);
                        maskRestored = true;
                        isDone();
                    };
                    img.src = struct.mask;
                } else maskCtx.drawImage(struct.mask, 0, 0);
            }
            isDone();
        });
    };
    me.generateIndexedPixels = function() {
        return (0, $9xub8.indexPixelsToPalette)(ctx, (0, $eTCYn.default).get());
    };
    return me;
};
var $17cf4be8b2d94008$export$2e2bcd8739ae039 = $17cf4be8b2d94008$var$Layer;

});


parcelRegister("7Gerp", function(module, exports) {

var $6yzBw = parcelRequire("6yzBw");
module.exports = $6yzBw("ktCvd").then(()=>parcelRequire("7vstl"));

});
parcelRegister("6yzBw", function(module, exports) {
"use strict";

function $4c61894dc5722920$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("3C43N")).resolve(id));
}
module.exports = $4c61894dc5722920$var$load;

});


parcelRegister("c05FU", function(module, exports) {

var $6yzBw = parcelRequire("6yzBw");
module.exports = Promise.all([
    $6yzBw("c4nAm"),
    $6yzBw("7qhal")
]).then(()=>parcelRequire("ensTt"));

});

parcelRegister("6sKqH", function(module, exports) {

var $6yzBw = parcelRequire("6yzBw");
module.exports = Promise.all([
    $6yzBw("c4nAm"),
    $6yzBw("iAojx")
]).then(()=>parcelRequire("cqprK"));

});


var $4sZF5 = parcelRequire("4sZF5");

var $9dDG4 = parcelRequire("9dDG4");

var $k5ZAj = parcelRequire("k5ZAj");

var $jU8Uk = parcelRequire("jU8Uk");

var $eTCYn = parcelRequire("eTCYn");

var $8FLxR = parcelRequire("8FLxR");



let $69ffc7ab9943f3a8$var$App = function() {
    let me = {
        version: "0.1.4.1 alpha"
    };
    me.init = function() {
        (0, $4sZF5.default).init();
        (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).NEW);
        let urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has("file")) {
            let file = urlParams.get("file");
            if (file) {
                if (urlParams.has("presentation")) (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).PRESENTATION);
                (0, $jU8Uk.default).openUrl(file).then(()=>{
                    setTimeout(()=>{
                        if (urlParams.has("play")) (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).CYCLEPALETTE);
                        if (urlParams.has("zoom")) (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).ZOOMFIT);
                    }, 200);
                }).catch((err)=>{});
            }
        } else // show about dialog on first run
        if (window.localStorage.getItem("dp_about") !== "true") setTimeout(()=>{
            (0, $9dDG4.default).trigger((0, $k5ZAj.COMMAND).ABOUT);
            window.localStorage.setItem("dp_about", "true");
        }, 200);
        if (window.self !== window.top && window.parent) {
            // we are running in an iframe, let's see if we can contact the host
            console.log("contacting host");
            (parcelRequire("7Gerp")).then((host)=>{
                window.host = host.default;
                window.host.init();
            });
        }
        (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).OPEN, function() {
            (0, $jU8Uk.default).openLocal();
        });
        (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).LOADPALETTE, ()=>{
            (0, $eTCYn.default).openLocal();
        });
        (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).ADF, ()=>{
            var input = document.createElement("input");
            input.type = "file";
            input.onchange = function(e) {
                let files = e.target.files;
                (parcelRequire("c05FU")).then((FileBrowser)=>{
                    FileBrowser.default.openAdf(files);
                });
            };
            input.click();
        });
        (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).DELUXE, ()=>{
            (parcelRequire("6sKqH")).then((UAE)=>{
                UAE.default.preview();
            });
        });
        (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).ABOUT, ()=>{
            (0, $8FLxR.default).show((0, $8FLxR.DIALOG).ABOUT, me.version);
        });
        (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).FULLSCREEN, ()=>{
            let elm = document.body;
            if (!elm) return;
            if (elm.requestFullscreen) elm.requestFullscreen().catch((err)=>{
                console.error("fullscreen failed");
                console.error(err);
            });
            else if (elm.webkitRequestFullscreen) elm.webkitRequestFullscreen();
        });
        (0, $9dDG4.default).on((0, $k5ZAj.COMMAND).TOGGLEOVERRIDE, ()=>{
            window.override = !window.override;
            document.body.classList.toggle("override", window.override);
            (0, $9dDG4.default).trigger((0, $k5ZAj.EVENT).layersChanged);
        });
    };
    window.addEventListener("DOMContentLoaded", (event)=>{
        if (window.location.protocol === "http:" && window.location.hostname.indexOf("stef.be") >= 0) window.location.href = window.location.href.replace("http:", "https:");
        else me.init();
    });
    // prevent pinch-zoom for iOS Safari
    if (window.GestureEvent) document.documentElement.addEventListener("gesturestart", (e)=>{
        e.preventDefault();
    }, {
        passive: false,
        capture: true
    });
    /*
	window.test = function(){
		let canvas = ImageFile.getCanvas();
		let ctx = canvas.getContext("2d");

		let imagaDate = canvas.getContext("2d").getImageData(0,0,canvas.width,canvas.height);

		let transformed = bayer(imagaDate,128);
		//let transformed = atkinson(imagaDate);
		ctx.putImageData(transformed,0,0);


		//effects.outline(ctx,[0,0,0]);
		//effects.feather(ctx,-1);

		//StackBlur.canvasRGBA(canvas,0 ,0,canvas.width,canvas.height,10);
		EventBus.trigger(EVENT.layerContentChanged);


	}


	function bayer(image, threshold) {
		const thresholdMap = [
			[15, 135, 45, 165],
			[195, 75, 225, 105],
			[60, 180, 30, 150],
			[240, 120, 210, 90],
		];

		for (let i = 0; i < image.data.length; i += 4) {
			const luminance = (image.data[i] * 0.299) + (image.data[i + 1] * 0.587) + (image.data[i + 2] * 0.114);

			const x = i / 4 % image.width;
			const y = Math.floor(i / 4 / image.width);
			const map = Math.floor((luminance + thresholdMap[x % 4][y % 4]) / 2);
			//console.error(map);
			let value = map < threshold ? 0 : 255;
			image.data.fill(value, i, i + 3);
		}

		return image;
	}

	function floydsteinberg(image) {
		const width = image.width;
		const luminance = new Uint8ClampedArray(image.width * image.height);

		for (let l = 0, i = 0; i < image.data.length; l++, i += 4) {
			luminance[l] = (image.data[i] * 0.299) + (image.data[i + 1] * 0.587) + (image.data[i + 2] * 0.114);
		}

		for (let l = 0, i = 0; i < image.data.length; l++, i += 4) {
			const value = luminance[l] < 129 ? 0 : 255;
			const error = Math.floor((luminance[l] - value) / 16);
			image.data.fill(value, i, i + 3);

			luminance[l + 1] += error * 7;
			luminance[l + width - 1] += error * 3;
			luminance[l + width] += error * 5;
			luminance[l + width + 1] += error * 1;
		}

		return image;
	}

	function atkinson(image) {
		const width = image.width;
		const luminance = new Uint8ClampedArray(image.width * image.height);

		for (let l = 0, i = 0; i < image.data.length; l++, i += 4) {
			luminance[l] = (image.data[i] * 0.299) + (image.data[i + 1] * 0.587) + (image.data[i + 2] * 0.114);
		}

		for (let l = 0, i = 0; i < image.data.length; l++, i += 4) {
			const value = luminance[l] < 129 ? 0 : 255;
			const error = Math.floor((luminance[l] - value) / 8);
			image.data.fill(value, i, i + 3);

			luminance[l + 1] += error;
			luminance[l + 2] += error;
			luminance[l + width - 1] += error;
			luminance[l + width] += error;
			luminance[l + width + 1] += error;
			luminance[l + 2 * width] += error;
		}

		return image;
	}

*/ return me;
}();


//# sourceMappingURL=index.7531bd6c.js.map
